import React, { useState, useEffect, useRef, useMemo } from 'react';
import api from './api';
import { House, FileSpreadsheet, ChartBar, ScanLine, Package, Users, ClipboardList, RefreshCw, Folder, Library, UserCog, LogOut, CreditCard, BookOpen, BookX, PackageX, ChevronLeft, ChevronRight, ChevronUp, ChevronDown, Plus, Pencil, X, Check, RotateCw, RotateCcw, TrendingUp, TrendingDown, AlertTriangle, ShoppingCart, Printer, Pause, Search, Upload, Download, CheckCircle, User, Building2, Truck, Receipt, FileMinus, PackageCheck, ArrowLeft, Wallet, ArrowDownLeft, ArrowUpRight, Lock, PencilLine, Zap, GraduationCap, Coffee, PiggyBank, CirclePlus, Megaphone, Handshake, FilePlus, FileText, Clock, Trash2, Banknote, ArrowRightLeft, Gift, CircleAlert, WalletCards, Ellipsis, Tag, Percent, CalendarDays, Send, Eye, FileSignature, Minus, Sparkles, Mail } from 'lucide-react';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import { generarPdfCotizacion } from './lib/cotizacion-pdf';
import { generarExcelCotizacion } from './lib/cotizacion-excel';

// ---------------------------------------------------------------------------
// DEBUG: captura errores de JS antes de que React se monte.
// Muestra un div fijo en pantalla con el mensaje + stack.
// REMOVER una vez identificado el problema.
// ---------------------------------------------------------------------------
(function installErrorOverlay() {
  function showOverlay(msg, src, line, col, err) {
    var existing = document.getElementById('__relea_err__');
    if (existing) {
      existing.innerHTML += '<hr style="border-color:#f88">' + msg;
      return;
    }
    var d = document.createElement('div');
    d.id = '__relea_err__';
    d.style.cssText = [
      'position:fixed', 'top:0', 'left:0', 'right:0', 'z-index:99999',
      'background:#1a0000', 'color:#ff8a80', 'padding:16px 20px',
      'font-family:monospace', 'font-size:13px', 'white-space:pre-wrap',
      'max-height:60vh', 'overflow-y:auto', 'border-bottom:3px solid #f44336',
    ].join(';');
    var stack = err && err.stack ? '\n\nStack:\n' + err.stack : '';
    var loc = src ? '\n\n' + src + ':' + line + ':' + col : '';
    d.textContent = '⛔ JS ERROR (pre-React)\n\n' + msg + loc + stack;
    document.body ? document.body.prepend(d) : document.addEventListener('DOMContentLoaded', function() { document.body.prepend(d); });
  }
  window.onerror = function(msg, src, line, col, err) {
    showOverlay(String(msg), src, line, col, err);
    return false;
  };
  window.addEventListener('unhandledrejection', function(ev) {
    var err = ev.reason;
    showOverlay('Unhandled Promise rejection: ' + (err && err.message ? err.message : String(err)), '', 0, 0, err);
  });
})();

function Login({ onLogin }) {
  const initVista = new URLSearchParams(window.location.search).get('registro') === '1' ? 'registro' : 'login';
  const [vista,    setVista]    = useState(initVista);
  const [form,     setForm]     = useState({ email: '', password: '' });
  const [formReg,  setFormReg]  = useState({ nombre_libreria: '', nombre: '', email: '', password: '', password2: '' });
  const [error,    setError]    = useState('');
  const [cargando, setCargando] = useState(false);

  const inpSt = { padding: '0.75rem', border: '1px solid #ddd', borderRadius: '4px', fontSize: '1rem', width: '100%', boxSizing: 'border-box' };
  const boxSt = { background: 'white', padding: '2rem', borderRadius: '8px', width: '100%', maxWidth: '380px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' };
  const wrapSt = { display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', background: '#f5f5f5', padding: '1rem' };

  function cambiarVista(v) { setVista(v); setError(''); }

  async function handleLogin(e) {
    e.preventDefault();
    setCargando(true); setError('');
    try {
      const res = await api.post('/login', form);
      localStorage.setItem('relea_token', res.data.token);
      localStorage.setItem('relea_nombre', res.data.nombre);
      localStorage.setItem('relea_rol',    res.data.rol || 'librero');
      onLogin(res.data.nombre, res.data.rol);
    } catch { setError('Usuario/email o contraseña incorrectos'); }
    setCargando(false);
  }

  async function handleRegistro(e) {
    e.preventDefault();
    if (formReg.password !== formReg.password2) { setError('Las contraseñas no coinciden'); return; }
    setCargando(true); setError('');
    try {
      const res = await api.post('/registro', {
        nombre_libreria: formReg.nombre_libreria,
        nombre:          formReg.nombre,
        email:           formReg.email,
        password:        formReg.password,
      });
      localStorage.setItem('relea_token', res.data.token);
      localStorage.setItem('relea_nombre', res.data.nombre);
      localStorage.setItem('relea_rol',    res.data.rol || 'admin');
      if (res.data.username) {
        alert(`Cuenta creada. Tu nombre de usuario es "${res.data.username}" — también puedes usarlo para entrar, además de tu email.`);
      }
      onLogin(res.data.nombre, res.data.rol);
    } catch (err) { setError(err.response?.data?.error || 'Error al crear la cuenta'); }
    setCargando(false);
  }

  if (vista === 'registro') return (
    <div style={wrapSt}>
      <div style={boxSt}>
        <h1 style={{ marginBottom: '0.25rem' }}>RELEA</h1>
        <p style={{ color: '#666', marginBottom: '1.5rem', fontSize: '0.9rem' }}>Registrá tu librería — es gratis para empezar.</p>
        <form onSubmit={handleRegistro}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
            <input type="text"     placeholder="Nombre de la librería *" value={formReg.nombre_libreria} onChange={e => setFormReg(p => ({ ...p, nombre_libreria: e.target.value }))} required style={inpSt} />
            <input type="text"     placeholder="Tu nombre *"             value={formReg.nombre}          onChange={e => setFormReg(p => ({ ...p, nombre: e.target.value }))}          required style={inpSt} />
            <input type="email"    placeholder="Email *"                 value={formReg.email}           onChange={e => setFormReg(p => ({ ...p, email: e.target.value }))}           required style={inpSt} />
            <input type="password" placeholder="Contraseña (mín. 6 caracteres) *" value={formReg.password}  onChange={e => setFormReg(p => ({ ...p, password: e.target.value }))}  required minLength={6} style={inpSt} />
            <input type="password" placeholder="Confirmar contraseña *"  value={formReg.password2}       onChange={e => setFormReg(p => ({ ...p, password2: e.target.value }))}      required style={inpSt} />
            {error && <p style={{ color: 'red', fontSize: '0.85rem', margin: 0 }}>{error}</p>}
            <button type="submit" disabled={cargando} style={{ padding: '0.75rem', background: '#2c2c2a', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '1rem', fontWeight: 600 }}>
              {cargando ? 'Creando cuenta…' : 'Crear cuenta'}
            </button>
            <button type="button" onClick={() => cambiarVista('login')} style={{ background: 'none', border: 'none', color: '#666', cursor: 'pointer', fontSize: '0.85rem', padding: '0.25rem 0', textAlign: 'center' }}>
              ¿Ya tenés cuenta? Iniciá sesión
            </button>
          </div>
        </form>
      </div>
    </div>
  );

  return (
    <div style={wrapSt}>
      <div style={boxSt}>
        <h1 style={{ marginBottom: '0.25rem' }}>RELEA</h1>
        <p style={{ color: '#666', marginBottom: '2rem', fontSize: '0.9rem' }}>Tu librería, bien leída.</p>
        <form onSubmit={handleLogin}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
            <input type="text"     placeholder="Email o nombre de usuario" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} required autoComplete="username" style={inpSt} />
            <input type="password" placeholder="Contraseña" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} required style={inpSt} />
            {error && <p style={{ color: 'red', fontSize: '0.85rem', margin: 0 }}>{error}</p>}
            <button type="submit" disabled={cargando} style={{ padding: '0.75rem', background: '#2c2c2a', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '1rem' }}>
              {cargando ? 'Entrando…' : 'Entrar'}
            </button>
            <button type="button" onClick={() => cambiarVista('registro')} style={{ background: 'none', border: 'none', color: '#666', cursor: 'pointer', fontSize: '0.85rem', padding: '0.25rem 0', textAlign: 'center', textDecoration: 'underline' }}>
              ¿No tenés cuenta? Registrá tu librería →
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

// =============================================================================
// HOOK: useMobile
// =============================================================================
function useMobile() {
  const [m, setM] = useState(window.innerWidth < 768);
  useEffect(() => {
    const h = () => setM(window.innerWidth < 768);
    window.addEventListener('resize', h);
    return () => window.removeEventListener('resize', h);
  }, []);
  return m;
}

// =============================================================================
// SIDEBAR — navegación vertical fija
// =============================================================================
const SIDEBAR_W = 184; // 16px left offset + 168px width

const NAV_ITEMS = [
  { id: 'dashboard',      label: 'Inicio',             icono: House         },
  { id: 'reportes',       label: 'Ventas',             icono: Receipt       },
  { id: 'finanzas',       label: 'Finanzas',           icono: Wallet        },
  { id: 'lotes',          label: 'Inventario',         icono: Package       },
  { id: 'clientes',       label: 'Clientes',           icono: Users         },
  { id: 'pedidos-dist',   label: 'Pedidos',            icono: ClipboardList },
  { id: 'reposicion',     label: 'Reposición',         icono: RefreshCw     },
  { id: 'documentos',     label: 'Documentos',         icono: Folder        },
  { id: 'cotizaciones',   label: 'Cotizaciones',       icono: FileText      },
  { id: 'consignacion',   label: 'Consignación',       icono: Handshake     },
  { id: 'ofertas',        label: 'Ofertas',            icono: Tag           },
  { id: 'devoluciones',  label: 'Devoluciones',       icono: PackageCheck   },
  { id: 'catalogos',      label: 'Catálogos',          icono: Library,       superadminOnly: true },
  { id: 'migracion',      label: 'Migración',          icono: Upload,        adminOnly: true },
  { id: 'usuarios',       label: 'Usuarios',           icono: UserCog,       adminOnly: true },
  { id: 'dte',            label: 'Boletas SII',         icono: FileSignature, adminOnly: true },
  { id: 'superadmin',     label: 'Librerías',          icono: Building2,     superadminOnly: true },
  { id: 'libros-relea',  label: 'Libros',             icono: BookOpen,      superadminOnly: true },
  { id: 'boletines',      label: 'Boletines',          icono: Megaphone,     superadminOnly: true },
];

// Visual groupings for the sidebar — purely presentational, no effect on routing
const NAV_SECTIONS = [
  { label: 'General',    ids: ['dashboard', 'reportes', 'finanzas', 'lotes', 'clientes'], posTop: true },
  { label: 'Operación',  ids: ['pedidos-dist', 'reposicion', 'documentos', 'cotizaciones', 'consignacion', 'ofertas', 'devoluciones'] },
  { label: 'Admin',      ids: ['migracion', 'usuarios', 'dte'], adminOnly: true },
  { label: 'RELEA',      ids: ['superadmin', 'libros-relea', 'catalogos', 'boletines'], superadminOnly: true },
];

function SbPosBlock({ activo, onClick }) {
  const [pressed, setPressed] = React.useState(false);
  return (
    <button
      onClick={onClick}
      onMouseDown={() => setPressed(true)}
      onMouseUp={() => setPressed(false)}
      onMouseLeave={() => setPressed(false)}
      style={{
        width: '100%', display: 'flex', alignItems: 'center', gap: 11,
        padding: '12px 14px', borderRadius: 16, border: 'none', cursor: 'pointer',
        background: pressed ? 'var(--brand)' : 'rgba(255,255,255,0.06)',
        outline: pressed ? 'none' : '1.5px solid rgba(255,255,255,0.10)',
        marginBottom: 8, transition: 'background 80ms ease',
      }}
    >
      <span style={{
        width: 34, height: 34, borderRadius: 10,
        background: pressed ? 'rgba(0,0,0,0.12)' : 'var(--brand)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
        transition: 'background 80ms ease',
      }}>
        <ScanLine size={19} color="var(--ink-900)" strokeWidth={2} />
      </span>
      <div style={{ textAlign: 'left', minWidth: 0 }}>
        <div style={{ fontSize: 15, fontWeight: 700, color: '#fff', lineHeight: 1.1, fontFamily: 'var(--font-ui)' }}>POS</div>
        <div style={{ fontSize: 10.5, color: 'var(--ink-400)', marginTop: 2, fontFamily: 'var(--font-ui)' }}>Cobrar ahora</div>
      </div>
    </button>
  );
}

function BottomNavBar({ pagina, setPagina, esAdmin, esSuperAdmin, migracionRealizada, usuario, onLogout }) {
  const [masAbierto, setMasAbierto] = useState(false);

  const masItems = NAV_ITEMS.filter(item => {
    if (['dashboard', 'lotes', 'reposicion'].includes(item.id)) return false;
    if (item.adminOnly && !esAdmin) return false;
    if (item.superadminOnly && !esSuperAdmin) return false;
    if (esSuperAdmin && !item.superadminOnly) return false;
    if (item.id === 'migracion' && migracionRealizada) return false;
    return true;
  });

  const enMas = masItems.some(item => item.id === pagina);

  function navTo(id) { setPagina(id); setMasAbierto(false); }

  const tabSt = (activo) => ({
    flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
    gap: 4, background: 'none', border: 'none', cursor: 'pointer',
    color: activo ? '#fff' : 'var(--ink-500)', padding: '6px 4px',
    transition: 'color 120ms ease',
  });

  const tabLbl = (activo) => ({
    fontSize: 10, fontWeight: activo ? 600 : 400,
    fontFamily: 'var(--font-ui)', lineHeight: 1, whiteSpace: 'nowrap',
  });

  return (
    <>
      {masAbierto && (
        <div
          onClick={() => setMasAbierto(false)}
          style={{ position: 'fixed', inset: 0, background: 'var(--scrim)', zIndex: 150 }}
        />
      )}

      {/* Sheet "Más" */}
      <div style={{
        position: 'fixed', left: 0, right: 0, bottom: 62,
        background: 'var(--paper)', borderRadius: '20px 20px 0 0',
        zIndex: 151, padding: '10px 16px 20px',
        boxShadow: '0 -2px 16px rgba(0,0,0,0.1)',
        transform: masAbierto ? 'translateY(0)' : 'translateY(110%)',
        transition: 'transform 260ms cubic-bezier(.4,0,.2,1)',
      }}>
        <div style={{ width: 36, height: 4, background: 'var(--line)', borderRadius: 2, margin: '0 auto 14px' }} />
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 6 }}>
          {masItems.map(item => {
            const IconComp = item.icono;
            const activo = pagina === item.id;
            return (
              <button
                key={item.id}
                onClick={() => navTo(item.id)}
                style={{
                  display: 'flex', flexDirection: 'column', alignItems: 'center',
                  gap: 7, padding: '12px 8px',
                  borderRadius: 14, border: 'none',
                  background: activo ? 'var(--paper-stripe)' : 'transparent',
                  color: activo ? 'var(--ink-900)' : 'var(--ink-500)',
                  cursor: 'pointer',
                }}
              >
                <IconComp size={22} strokeWidth={1.75} />
                <span style={{ fontSize: 11.5, fontWeight: activo ? 600 : 400, fontFamily: 'var(--font-ui)', lineHeight: 1.2, textAlign: 'center' }}>
                  {item.label}
                </span>
                {(item.id === 'pedidos-dist' || item.id === 'clientes' || item.id === 'devoluciones' || item.id === 'cotizaciones') && (
                  <span style={{ fontSize: 8, fontWeight: 700, background: 'var(--warn-bg)', color: 'var(--warn-ink)', borderRadius: 3, padding: '1px 4px', lineHeight: 1.4, marginTop: -4 }}>BETA</span>
                )}
              </button>
            );
          })}
        </div>
        {/* Footer: usuario + logout */}
        <div style={{ borderTop: '1px solid var(--line)', marginTop: 12, paddingTop: 12, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <span style={{ width: 32, height: 32, borderRadius: '50%', background: 'var(--brand)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 13, color: '#fff', flexShrink: 0 }}>
              {(usuario || 'L')[0].toUpperCase()}
            </span>
            <span style={{ fontSize: 13, fontWeight: 500, color: 'var(--ink-700)', fontFamily: 'var(--font-ui)' }}>{usuario || 'Librero'}</span>
          </div>
          <button
            onClick={onLogout}
            style={{ display: 'flex', alignItems: 'center', gap: 6, background: 'none', border: 'none', cursor: 'pointer', color: 'var(--ink-500)', fontSize: 13, fontFamily: 'var(--font-ui)', padding: '6px 8px', borderRadius: 8 }}
          >
            <LogOut size={16} strokeWidth={1.75} />
            Salir
          </button>
        </div>
      </div>

      {/* Tab bar */}
      <nav aria-label="Navegación principal" style={{
        position: 'fixed', bottom: 0, left: 0, right: 0, height: 62,
        background: 'var(--ink-900)', display: 'flex', alignItems: 'stretch',
        zIndex: 200, paddingBottom: 'env(safe-area-inset-bottom)',
      }}>
        <button onClick={() => navTo('dashboard')} style={tabSt(pagina === 'dashboard')} aria-label="Inicio">
          <House size={21} strokeWidth={1.75} />
          <span style={tabLbl(pagina === 'dashboard')}>Inicio</span>
        </button>
        <button onClick={() => navTo('lotes')} style={tabSt(pagina === 'lotes')} aria-label="Inventario">
          <Package size={21} strokeWidth={1.75} />
          <span style={tabLbl(pagina === 'lotes')}>Inventario</span>
        </button>
        <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <button
            onClick={() => navTo('pos')}
            aria-label="POS — Cobrar ahora"
            style={{
              width: 50, height: 50, background: 'var(--brand)',
              borderRadius: '50%', border: 'none', cursor: 'pointer',
              display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
              gap: 2, flexShrink: 0, marginTop: -22,
              boxShadow: '0 4px 14px rgba(196,82,42,0.5)',
            }}
          >
            <ScanLine size={20} strokeWidth={2} color="#fff" />
            <span style={{ fontSize: 8, fontWeight: 700, color: '#fff', letterSpacing: '0.05em', fontFamily: 'var(--font-ui)' }}>POS</span>
          </button>
        </div>
        <button onClick={() => navTo('reposicion')} style={tabSt(pagina === 'reposicion')} aria-label="Reposición">
          <RefreshCw size={21} strokeWidth={1.75} />
          <span style={tabLbl(pagina === 'reposicion')}>Reposición</span>
        </button>
        <button onClick={() => setMasAbierto(p => !p)} style={tabSt(enMas || masAbierto)} aria-label="Más módulos">
          <Ellipsis size={21} strokeWidth={1.75} />
          <span style={tabLbl(enMas || masAbierto)}>Más</span>
        </button>
      </nav>
    </>
  );
}

function Sidebar({ pagina, setPagina, esAdmin, esSuperAdmin, usuario, onLogout, abierto, onCerrar, esMobile, migracionRealizada }) {
  const translateX = esMobile && !abierto ? -SIDEBAR_W : 0;

  return (
    <>
      {/* Overlay móvil — cierra el sidebar al tocar fuera */}
      {esMobile && abierto && (
        <div
          onClick={onCerrar}
          style={{ position: 'fixed', inset: 0, background: 'var(--scrim)', zIndex: 9 }}
        />
      )}

      <nav style={{
        position:      'fixed',
        top:           '16px',
        left:          '16px',
        width:         '168px',
        height:        'calc(100vh - 32px)',
        background:    'var(--ink-900)',
        borderRadius:  'var(--r-3xl)',
        display:       'flex',
        flexDirection: 'column',
        padding:       '22px 14px 18px',
        gap:           2,
        zIndex:        'var(--z-rail)',
        transform:     `translateX(${translateX}px)`,
        transition:    `transform var(--t-normal)`,
        overflowY:     'auto',
        boxShadow:     esMobile ? 'var(--shadow-pop)' : 'none',
      }}>

        {/* Brand wordmark */}
        <div style={{ display: 'flex', alignItems: 'center', padding: '4px 10px 22px' }}>
          <img src="/logo-relea-dark.png" alt="RELEA" style={{ height: 32 }} />
        </div>

        {/* Nav sections */}
        <div style={{ flex: 1 }}>
          {NAV_SECTIONS.map(sec => {
            if (sec.adminOnly && !esAdmin) return null;
            if (sec.superadminOnly && !esSuperAdmin) return null;
            if (!sec.superadminOnly && esSuperAdmin) return null;
            const items = NAV_ITEMS.filter(item =>
              sec.ids.includes(item.id) &&
              (!item.adminOnly || esAdmin) &&
              (!item.superadminOnly || esSuperAdmin) &&
              !(item.id === 'migracion' && migracionRealizada)
            );
            if (items.length === 0) return null;
            return (
              <div key={sec.label}>
                <div style={{
                  fontSize:      'var(--fs-xs)',
                  color:         'var(--ink-400)',
                  textTransform: 'uppercase',
                  letterSpacing: '0.08em',
                  fontWeight:    500,
                  padding:       '14px 10px 6px',
                  fontFamily:    'var(--font-ui)',
                }}>
                  {sec.label}
                </div>
                {sec.posTop && (
                  <SbPosBlock
                    activo={pagina === 'pos'}
                    onClick={() => { setPagina('pos'); if (esMobile) onCerrar(); }}
                  />
                )}
                {items.map(item => {
                  const activo = pagina === item.id;
                  const IconComp = item.icono;
                  return (
                    <button
                      key={item.id}
                      onClick={() => { setPagina(item.id); if (esMobile) onCerrar(); }}
                      style={{
                        width:       '100%',
                        display:     'flex',
                        alignItems:  'center',
                        gap:         10,
                        padding:     '8px 10px',
                        borderRadius: 14,
                        border:      'none',
                        background:  activo ? 'rgba(255,255,255,0.08)' : 'transparent',
                        color:       activo ? '#fff' : 'var(--ink-300)',
                        fontSize:    13,
                        fontFamily:  'var(--font-ui)',
                        textAlign:   'left',
                        cursor:      'pointer',
                        transition:  `background var(--t-fast)`,
                      }}
                      onMouseEnter={e => { if (!activo) e.currentTarget.style.background = 'rgba(255,255,255,0.04)'; }}
                      onMouseLeave={e => { if (!activo) e.currentTarget.style.background = 'transparent'; }}
                    >
                      <IconComp size={16} strokeWidth={1.75} style={{ flexShrink: 0 }} />
                      <span style={{ fontWeight: activo ? 600 : 400 }}>{item.label}</span>
                      {(item.id === 'pedidos-dist' || item.id === 'clientes' || item.id === 'devoluciones' || item.id === 'cotizaciones') && (
                        <span style={{ fontSize: 9, fontWeight: 700, letterSpacing: '0.04em', background: 'var(--warn-bg)', color: 'var(--warn-ink)', borderRadius: 4, padding: '1px 5px', marginLeft: 'auto', flexShrink: 0 }}>BETA</span>
                      )}
                    </button>
                  );
                })}
              </div>
            );
          })}
        </div>

        {/* Footer: avatar + usuario + cerrar sesión */}
        <div style={{ borderTop: '1px solid rgba(255,255,255,0.07)', paddingTop: 14, marginTop: 10 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '0 6px 10px' }}>
            <span style={{
              width:          32,
              height:         32,
              borderRadius:   '50%',
              background:     'var(--brand)',
              display:        'flex',
              alignItems:     'center',
              justifyContent: 'center',
              fontWeight:     700,
              fontSize:       13,
              color:          '#fff',
              flexShrink:     0,
            }}>
              {(usuario || 'L')[0].toUpperCase()}
            </span>
            <div style={{ minWidth: 0 }}>
              <div style={{ fontSize: 12, fontWeight: 600, color: '#fff', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontFamily: 'var(--font-ui)' }}>
                {usuario || 'Librero'}
              </div>
              <div style={{ fontSize: 10, color: 'var(--ink-400)', textTransform: 'capitalize', fontFamily: 'var(--font-ui)' }}>
                {esSuperAdmin ? 'superadmin' : esAdmin ? 'admin' : 'librero'}
              </div>
            </div>
          </div>
          <button
            onClick={onLogout}
            style={{
              width:          '100%',
              background:     'transparent',
              border:         '1px solid rgba(255,255,255,0.12)',
              color:          'var(--ink-300)',
              borderRadius:   'var(--r-pill)',
              padding:        '7px 12px',
              cursor:         'pointer',
              fontSize:       12,
              fontFamily:     'var(--font-ui)',
              display:        'inline-flex',
              alignItems:     'center',
              justifyContent: 'center',
              gap:            6,
              transition:     `border-color var(--t-fast), color var(--t-fast)`,
            }}
            onMouseEnter={e => { e.currentTarget.style.borderColor = 'rgba(255,255,255,0.25)'; e.currentTarget.style.color = '#fff'; }}
            onMouseLeave={e => { e.currentTarget.style.borderColor = 'rgba(255,255,255,0.12)'; e.currentTarget.style.color = 'var(--ink-300)'; }}
          >
            <LogOut size={12} strokeWidth={1.75} />
            Cerrar sesión
          </button>
        </div>
      </nav>
    </>
  );
}

// =============================================================================
// APP
// =============================================================================
function App() {
  const [usuario, setUsuario] = useState(localStorage.getItem('relea_nombre'));
  const [rol,     setRol]     = useState(localStorage.getItem('relea_rol') || 'librero');
  const [pagina,  setPaginaRaw]  = useState(() => {
    const storedRol = localStorage.getItem('relea_rol');
    if (storedRol === 'superadmin') return 'superadmin';
    return localStorage.getItem('relea_pagina') || 'dashboard';
  });
  function setPagina(p) { localStorage.setItem('relea_pagina', p); setPaginaRaw(p); }
  const [esMobile,   setEsMobile]   = useState(window.innerWidth < 768);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [migracionRealizada, setMigracionRealizada] = useState(false);
  const [tieneLibros,        setTieneLibros]        = useState(true);  // optimista: evita flash
  const [migracionCargada,   setMigracionCargada]   = useState(false);  // la librería ya tiene su inventario (oculta "Migración")
  const [posLibroInicial,    setPosLibroInicial]    = useState(null);  // lote pre-seleccionado desde Inicio
  const [posGrupoInicial,    setPosGrupoInicial]    = useState(null);  // grupo autor/editorial pre-expandido desde Inicio
  // Documentos se queda montado (oculto) después de la primera visita: así el lote de documentos que se está
  // revisando —y las lecturas de archivos en curso— no se pierden al pasar a otro módulo y volver.
  const [documentosVisitado, setDocumentosVisitado] = useState(false);
  useEffect(() => { if (pagina === 'documentos') setDocumentosVisitado(true); }, [pagina]);

  useEffect(() => {
    const onResize = () => setEsMobile(window.innerWidth < 768);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  // Fetch estado de migración cada vez que hay un admin logueado
  // (cubre tanto login fresco como restauración desde localStorage al recargar)
  // y cada vez que se abre Inventario, donde se decide si se pregunta por la carga inicial
  const enInventario = pagina === 'lotes';
  useEffect(() => {
    if (!usuario) return;
    api.get('/migracion/estado').then(r => {
      setMigracionRealizada(r.data.realizada);
      setMigracionCargada(r.data.cargada ?? r.data.realizada);
      setTieneLibros(r.data.tiene_libros);
    }).catch(err => console.error('[migracion/estado] error', err));
  }, [usuario, rol, enInventario]);

  function handleLogin(nombre, rolRecibido) {
    setUsuario(nombre);
    setRol(rolRecibido || 'librero');
    if (rolRecibido === 'superadmin') setPagina('superadmin');
    // El useEffect de arriba detecta el cambio y hace el fetch automáticamente
  }
  function handleLogout() {
    localStorage.removeItem('relea_token');
    localStorage.removeItem('relea_nombre');
    localStorage.removeItem('relea_rol');
    setUsuario(null);
    setRol('librero');
  }

  const esAdmin      = rol === 'admin';
  const esSuperAdmin = rol === 'superadmin';
  if (!usuario) return <Login onLogin={handleLogin} />;

  const contentMargin = esMobile ? 0 : 200; /* rail-inset(16) + rail-w(168) + content-inset(16) */

  return (
    <div style={{ fontFamily: 'sans-serif', minHeight: '100vh', background: 'var(--canvas)' }}>
      {/* Sidebar — solo desktop */}
      {!esMobile && (
        <Sidebar
          pagina={pagina}
          setPagina={setPagina}
          esAdmin={esAdmin}
          esSuperAdmin={esSuperAdmin}
          usuario={usuario}
          onLogout={handleLogout}
          abierto={sidebarOpen}
          onCerrar={() => setSidebarOpen(false)}
          esMobile={false}
          migracionRealizada={migracionCargada}
        />
      )}

      {/* Barra de navegación inferior — solo móvil */}
      {esMobile && (
        <BottomNavBar
          pagina={pagina}
          setPagina={setPagina}
          esAdmin={esAdmin}
          esSuperAdmin={esSuperAdmin}
          migracionRealizada={migracionCargada}
          usuario={usuario}
          onLogout={handleLogout}
        />
      )}

      {/* Contenido principal */}
      <div style={{
        marginLeft:  contentMargin,
        padding:     esMobile ? '1rem 1rem 80px' : '16px 16px 2rem 16px',
        maxWidth:    esMobile ? '100%' : `calc(1100px + 200px)`,
        minHeight:   '100vh',
        boxSizing:   'border-box',
      }}>
        {pagina === 'dashboard'      && <SaludNegocio setPagina={setPagina} usuario={usuario} onLibroSeleccionado={lote => { setPosLibroInicial(lote); setPagina('pos'); }} onGrupoSeleccionado={grupo => { setPosGrupoInicial(grupo); setPagina('pos'); }} />}
        {pagina === 'usuarios'       && esAdmin && <Usuarios />}
        {pagina === 'dte'            && esAdmin && <ModuloDte />}
        {pagina === 'clientes'       && <PedidosClientes />}
        {pagina === 'reportes'       && <ModuloReportes />}
        {pagina === 'finanzas'       && <Finanzas setPagina={setPagina} />}
        {pagina === 'pos'            && <POS libroInicial={posLibroInicial} onLibroInicialUsado={() => setPosLibroInicial(null)} grupoInicial={posGrupoInicial} onGrupoInicialUsado={() => setPosGrupoInicial(null)} />}
        {pagina === 'reposicion'     && <Reposicion />}
        {pagina === 'pedidos-dist'   && <Pedidos setPagina={setPagina} />}
        {pagina === 'catalogos'      && esSuperAdmin && <Catalogos />}
        {pagina === 'migracion'      && <AdminMigracion migracionRealizada={migracionCargada} onMigracionCompletada={() => { setMigracionRealizada(true); setMigracionCargada(true); setTieneLibros(true); setPagina('lotes'); }} setPagina={setPagina} />}
        {pagina === 'lotes'          && <ModuloInventario preguntaCarga={esAdmin && !migracionRealizada && !tieneLibros ? {
          cargar: () => setPagina('migracion'),
          desdeCero: async () => { await api.post('/migracion/estado', { libros_creados: 0, lotes_creados: 0 }); setMigracionRealizada(true); },
        } : null} />}
        {(documentosVisitado || pagina === 'documentos') && (
          <div style={{ display: pagina === 'documentos' ? 'block' : 'none' }}><Documentos activo={pagina === 'documentos'} /></div>
        )}
        {pagina === 'cotizaciones'  && <ModuloCotizacion />}
        {pagina === 'consignacion'   && <ModuloConsignacion />}
        {pagina === 'ofertas'        && <ModuloOfertas />}
        {pagina === 'devoluciones'  && <ModuloDevoluciones />}
        {pagina === 'superadmin'    && esSuperAdmin && <SuperAdminTenants />}
        {pagina === 'libros-relea'  && esSuperAdmin && <SuperAdminLibros />}
        {pagina === 'boletines'     && esSuperAdmin && <SuperAdminBoletines />}
      </div>
    </div>
  );
}

function Usuarios() {
  const [usuarios, setUsuarios] = useState([]);
  const [form,    setForm]    = useState({ email: '', nombre: '', password: '', rol: 'librero' });
  const [cargando, setCargando] = useState(false);
  const [error,   setError]   = useState('');
  const [mensaje, setMensaje] = useState('');

  useEffect(() => { cargarUsuarios(); }, []);

  async function cargarUsuarios() {
    const res = await api.get('/usuarios');
    setUsuarios(res.data);
  }

  async function agregarUsuario(e) {
    e.preventDefault();
    setCargando(true);
    setError('');
    try {
      const res = await api.post('/usuarios', form);
      setForm({ email: '', nombre: '', password: '', rol: 'librero' });
      setMensaje(res.data.username
        ? `Usuario creado ✓ — su nombre de usuario es "${res.data.username}"`
        : 'Usuario creado ✓');
      await cargarUsuarios();
      setTimeout(() => setMensaje(''), 6000);
    } catch (err) {
      setError(err.response?.data?.error || 'Error al crear usuario');
    }
    setCargando(false);
  }

  async function cambiarRol(u) {
    const nuevoRol = u.rol === 'admin' ? 'librero' : 'admin';
    if (!window.confirm(`¿Cambiar rol de ${u.nombre} a "${nuevoRol}"?`)) return;
    await api.patch(`/usuarios/${u.id}/rol`, { rol: nuevoRol });
    await cargarUsuarios();
  }

  async function eliminarUsuario(id, nombre) {
    if (!window.confirm(`¿Eliminar a ${nombre}? Esta acción no se puede deshacer.`)) return;
    await api.delete(`/usuarios/${id}`);
    await cargarUsuarios();
  }

  return (
    <div>
      <h2>Gestión de usuarios</h2>
      <form onSubmit={agregarUsuario} style={{ marginBottom: '2rem', background: '#f9f9f9', padding: '1rem', borderRadius: '8px', maxWidth: '420px' }}>
        <h3 style={{ marginTop: 0 }}>Nuevo usuario</h3>
        {mensaje && <p style={{ background: '#e8f5e9', padding: '0.5rem', borderRadius: '4px' }}>{mensaje}</p>}
        {error   && <p style={{ color: 'red', fontSize: '0.9rem' }}>{error}</p>}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
          <input placeholder="Nombre *" value={form.nombre} onChange={e => setForm({ ...form, nombre: e.target.value })} required style={{ padding: '0.5rem' }} />
          <input type="email" placeholder="Email *" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} required style={{ padding: '0.5rem' }} />
          <input type="password" placeholder="Contraseña *" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} required style={{ padding: '0.5rem' }} />
          <select value={form.rol} onChange={e => setForm({ ...form, rol: e.target.value })} style={{ padding: '0.5rem' }}>
            <option value="librero">Librero</option>
            <option value="admin">Administrador</option>
          </select>
          <button type="submit" disabled={cargando} style={{ padding: '0.5rem', background: '#2c2c2a', color: 'white', border: 'none', cursor: 'pointer' }}>
            {cargando ? 'Creando...' : 'Crear usuario'}
          </button>
        </div>
      </form>
      <h3>Usuarios registrados ({usuarios.length})</h3>
      <table style={{ width: '100%', borderCollapse: 'collapse', maxWidth: '680px' }}>
        <thead>
          <tr style={{ textAlign: 'left', borderBottom: '2px solid #ccc' }}>
            <th style={{ padding: '0.5rem' }}>Nombre</th>
            <th style={{ padding: '0.5rem' }}>Email</th>
            <th style={{ padding: '0.5rem' }}>Usuario</th>
            <th style={{ padding: '0.5rem' }}>Rol</th>
            <th style={{ padding: '0.5rem' }}>Desde</th>
            <th style={{ padding: '0.5rem' }}></th>
          </tr>
        </thead>
        <tbody>
          {usuarios.map(u => (
            <tr key={u.id} style={{ borderBottom: '1px solid #eee' }}>
              <td style={{ padding: '0.5rem' }}>{u.nombre}</td>
              <td style={{ padding: '0.5rem', color: '#666' }}>{u.email}</td>
              <td style={{ padding: '0.5rem', color: '#666', fontFamily: 'monospace', fontSize: '0.85rem' }}>{u.username || '—'}</td>
              <td style={{ padding: '0.5rem' }}>
                <span style={{ fontSize: '0.8rem', padding: '0.15rem 0.5rem', borderRadius: '10px', background: u.rol === 'admin' ? '#f0c040' : '#e9ecef', color: u.rol === 'admin' ? '#2c2c2a' : '#555', fontWeight: 600 }}>
                  {u.rol === 'admin' ? 'Admin' : 'Librero'}
                </span>
              </td>
              <td style={{ padding: '0.5rem', fontSize: '0.85rem', color: '#666' }}>{new Date(u.creado_en).toLocaleDateString('es-CL')}</td>
              <td style={{ padding: '0.5rem', display: 'flex', gap: '0.4rem' }}>
                <button onClick={() => cambiarRol(u)} style={{ background: 'none', border: '1px solid #aaa', color: '#555', padding: '0.2rem 0.5rem', cursor: 'pointer', borderRadius: '4px', fontSize: '0.8rem' }}>
                  {u.rol === 'admin' ? '→ Librero' : '→ Admin'}
                </button>
                <button onClick={() => eliminarUsuario(u.id, u.nombre)} style={{ background: 'none', border: '1px solid #d9534f', color: '#d9534f', padding: '0.2rem 0.5rem', cursor: 'pointer', borderRadius: '4px', fontSize: '0.8rem' }}>
                  Eliminar
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

// =============================================================================
// DTE — boletas electrónicas SII (Fase 0: motor local, todavía sin envío real)
// =============================================================================

const DTE_TIPO_LABEL = { '39': 'Boleta afecta', '41': 'Boleta exenta', '33': 'Factura', '52': 'Guía de despacho', '56': 'Nota de débito', '61': 'Nota de crédito' };
const DTE_ESTADO_STYLE = {
  generado:           { bg: 'var(--info-bg)', ink: 'var(--info-ink)', label: 'Generado (prueba)' },
  enviado:            { bg: 'var(--warn-bg)', ink: 'var(--warn-ink)', label: 'Enviado' },
  aceptado:           { bg: 'var(--ok-bg)',   ink: 'var(--ok-ink)',   label: 'Aceptado' },
  aceptado_reparos:   { bg: 'var(--warn-bg)', ink: 'var(--warn-ink)', label: 'Aceptado con reparos' },
  rechazado:          { bg: 'var(--bad-bg)',  ink: 'var(--bad-ink)',  label: 'Rechazado' },
  anulado:            { bg: 'var(--ink-200)', ink: 'var(--ink-700)',  label: 'Anulado' },
};

function DtePill({ bg, ink, label }) {
  return (
    <span style={{ fontSize: 'var(--fs-xs)', fontWeight: 700, background: bg, color: ink, borderRadius: 'var(--r-pill)', padding: '3px 10px', fontFamily: 'var(--font-ui)', whiteSpace: 'nowrap' }}>
      {label}
    </span>
  );
}

function ModuloDte() {
  const esMobile = useMobile();
  const [tab, setTab] = useState('config'); // 'config' | 'certificado' | 'boletas'

  // Config tributaria
  const [config, setConfig] = useState(null);
  const [formConfig, setFormConfig] = useState({ rut_emisor: '', razon_social: '', giro: '', direccion: '', comuna: '' });
  const [guardandoConfig, setGuardandoConfig] = useState(false);
  const [msgConfig, setMsgConfig] = useState({ tipo: '', texto: '' });

  // Certificado
  const [certificado, setCertificado] = useState(null);
  const [archivoPfx, setArchivoPfx] = useState(null);
  const [passwordPfx, setPasswordPfx] = useState('');
  const [subiendoCert, setSubiendoCert] = useState(false);
  const [msgCert, setMsgCert] = useState({ tipo: '', texto: '' });

  // CAF / folios
  const [folios, setFolios] = useState([]);
  const [cafXml, setCafXml] = useState('');
  const [subiendoCaf, setSubiendoCaf] = useState(false);
  const [msgCaf, setMsgCaf] = useState({ tipo: '', texto: '' });

  // Boletas de prueba
  const [ventas, setVentas] = useState([]);
  const [ventaId, setVentaId] = useState('');
  const [generando, setGenerando] = useState(false);
  const [resultado, setResultado] = useState(null);
  const [msgBoleta, setMsgBoleta] = useState({ tipo: '', texto: '' });
  const [emitidos, setEmitidos] = useState([]);
  const [detalleAbierto, setDetalleAbierto] = useState(null); // { id, xml_documento } | null

  const errMsg = e => e?.response?.data?.error || e?.message || 'Error inesperado';

  useEffect(() => { cargarTodo(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  async function cargarTodo() {
    try { const { data } = await api.get('/dte/config'); setConfig(data); if (data) setFormConfig(data); } catch (e) { /* sin config todavía */ }
    try { const { data } = await api.get('/dte/certificado'); setCertificado(data); } catch (e) { /* sin certificado */ }
    await Promise.all([cargarFolios(), cargarEmitidos(), cargarVentas()]);
  }
  async function cargarFolios()   { try { const { data } = await api.get('/dte/folios');   setFolios(data);   } catch (e) { console.error(e); } }
  async function cargarEmitidos() { try { const { data } = await api.get('/dte/emitidos'); setEmitidos(data); } catch (e) { console.error(e); } }
  async function cargarVentas()   { try { const { data } = await api.get('/ventas');       setVentas(data);   } catch (e) { console.error(e); } }

  async function guardarConfig(e) {
    e.preventDefault();
    setGuardandoConfig(true); setMsgConfig({ tipo: '', texto: '' });
    try {
      const { data } = await api.post('/dte/config', formConfig);
      setConfig(data);
      setMsgConfig({ tipo: 'ok', texto: 'Datos guardados ✓' });
    } catch (e) { setMsgConfig({ tipo: 'error', texto: errMsg(e) }); }
    setGuardandoConfig(false);
  }

  async function subirCertificado(e) {
    e.preventDefault();
    if (!archivoPfx || !passwordPfx) { setMsgCert({ tipo: 'error', texto: 'Elegí el archivo .pfx y escribí su contraseña' }); return; }
    setSubiendoCert(true); setMsgCert({ tipo: '', texto: '' });
    try {
      const fd = new FormData();
      fd.append('archivo', archivoPfx);
      fd.append('password', passwordPfx);
      const res = await fetch(`${api.defaults.baseURL}/dte/certificado`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${localStorage.getItem('relea_token')}` },
        body: fd,
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'No se pudo subir el certificado');
      setCertificado(data);
      setArchivoPfx(null); setPasswordPfx('');
      setMsgCert({ tipo: 'ok', texto: 'Certificado cargado ✓' });
    } catch (e) { setMsgCert({ tipo: 'error', texto: e.message }); }
    setSubiendoCert(false);
  }

  async function subirCaf(e) {
    e.preventDefault();
    if (!cafXml.trim()) { setMsgCaf({ tipo: 'error', texto: 'Pegá el XML del CAF' }); return; }
    setSubiendoCaf(true); setMsgCaf({ tipo: '', texto: '' });
    try {
      const { data } = await api.post('/dte/caf', { xml: cafXml });
      setCafXml('');
      await cargarFolios();
      setMsgCaf({ tipo: 'ok', texto: `CAF cargado ✓ — folios ${data.folio_desde} a ${data.folio_hasta} (tipo ${data.tipo_dte})` });
    } catch (e) { setMsgCaf({ tipo: 'error', texto: errMsg(e) }); }
    setSubiendoCaf(false);
  }

  async function generarBoleta() {
    if (!ventaId) { setMsgBoleta({ tipo: 'error', texto: 'Elegí una venta primero' }); return; }
    setGenerando(true); setMsgBoleta({ tipo: '', texto: '' }); setResultado(null);
    try {
      const { data } = await api.post('/dte/boleta/generar-prueba', { venta_id: ventaId });
      setResultado(data);
      await cargarEmitidos();
      await cargarFolios();
    } catch (e) {
      const data = e?.response?.data;
      setMsgBoleta({ tipo: 'error', texto: data?.sin_folios ? `${data.error} — cargá un CAF de tipo 39 en la pestaña "Certificado y CAF"` : errMsg(e) });
    }
    setGenerando(false);
  }

  async function verDetalle(id) {
    if (detalleAbierto?.id === id) { setDetalleAbierto(null); return; }
    try {
      const { data } = await api.get(`/dte/emitidos/${id}`);
      setDetalleAbierto({ id, xml_documento: data.xml_documento, pdf417: data.pdf417 });
    } catch (e) { console.error(e); }
  }

  // ── estilos ────────────────────────────────────────────────────────────
  const card    = { background: 'var(--paper)', border: '1px solid var(--line)', borderRadius: 'var(--r-xl)', padding: esMobile ? 16 : 20, marginBottom: 16 };
  const label   = { fontSize: 'var(--fs-sm)', fontWeight: 600, color: 'var(--ink-700)', marginBottom: 4, display: 'block', fontFamily: 'var(--font-ui)' };
  const input   = { padding: '10px 12px', border: '1px solid var(--line)', borderRadius: 'var(--r-md)', fontSize: 'var(--fs-base)', fontFamily: 'var(--font-ui)', width: '100%', boxSizing: 'border-box', background: 'var(--paper)', color: 'var(--ink-900)' };
  const row2    = { display: 'grid', gridTemplateColumns: esMobile ? '1fr' : '1fr 1fr', gap: 12 };
  const btnPri  = (disabled) => ({ background: disabled ? 'var(--ink-300)' : 'var(--brand)', color: '#fff', border: 'none', borderRadius: 'var(--r-pill)', padding: '10px 22px', fontSize: 'var(--fs-base)', fontWeight: 600, cursor: disabled ? 'default' : 'pointer', fontFamily: 'var(--font-ui)' });
  const banner  = (tipo) => ({ marginTop: 10, padding: '9px 14px', borderRadius: 'var(--r-md)', fontSize: 'var(--fs-sm)', fontFamily: 'var(--font-ui)', background: tipo === 'ok' ? 'var(--ok-bg)' : 'var(--bad-bg)', color: tipo === 'ok' ? 'var(--ok-ink)' : 'var(--bad-ink)' });
  const tabBtn  = (activo) => ({ padding: '9px 18px', borderRadius: 'var(--r-pill)', border: 'none', cursor: 'pointer', fontSize: 'var(--fs-base)', fontWeight: 600, fontFamily: 'var(--font-ui)', background: activo ? 'var(--ink-900)' : 'var(--paper-stripe)', color: activo ? '#fff' : 'var(--ink-700)' });

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 4 }}>
        <FileSignature size={22} color="var(--brand)" strokeWidth={1.75} />
        <h2 style={{ margin: 0, fontFamily: 'var(--font-display)', fontSize: 'var(--fs-2xl)', color: 'var(--ink-900)' }}>Boletas electrónicas SII</h2>
      </div>
      <p style={{ color: 'var(--ink-600)', fontFamily: 'var(--font-ui)', fontSize: 'var(--fs-base)', marginTop: 4, marginBottom: 18, maxWidth: 640 }}>
        Fase 0 — el motor que arma, timbra y firma boletas. <strong>Nada de esto se envía al SII todavía.</strong> Sirve para cargar tus datos y probar que todo funciona antes de emitir algo real.
      </p>

      <div style={{ display: 'flex', gap: 8, marginBottom: 18, flexWrap: 'wrap' }}>
        <button style={tabBtn(tab === 'config')} onClick={() => setTab('config')}>1. Datos tributarios</button>
        <button style={tabBtn(tab === 'certificado')} onClick={() => setTab('certificado')}>2. Certificado y CAF</button>
        <button style={tabBtn(tab === 'boletas')} onClick={() => setTab('boletas')}>3. Boletas de prueba</button>
      </div>

      {tab === 'config' && (
        <div style={card}>
          <h3 style={{ marginTop: 0, fontFamily: 'var(--font-ui)', color: 'var(--ink-900)' }}>Datos tributarios de la librería</h3>
          <form onSubmit={guardarConfig}>
            <div style={row2}>
              <div>
                <label style={label}>RUT *</label>
                <input style={input} placeholder="76123456-7" value={formConfig.rut_emisor} onChange={e => setFormConfig({ ...formConfig, rut_emisor: e.target.value })} required />
              </div>
              <div>
                <label style={label}>Razón social *</label>
                <input style={input} value={formConfig.razon_social} onChange={e => setFormConfig({ ...formConfig, razon_social: e.target.value })} required />
              </div>
            </div>
            <div style={{ marginTop: 12 }}>
              <label style={label}>Giro *</label>
              <input style={input} placeholder="Venta de libros" value={formConfig.giro} onChange={e => setFormConfig({ ...formConfig, giro: e.target.value })} required />
            </div>
            <div style={{ ...row2, marginTop: 12 }}>
              <div>
                <label style={label}>Dirección</label>
                <input style={input} value={formConfig.direccion || ''} onChange={e => setFormConfig({ ...formConfig, direccion: e.target.value })} />
              </div>
              <div>
                <label style={label}>Comuna</label>
                <input style={input} value={formConfig.comuna || ''} onChange={e => setFormConfig({ ...formConfig, comuna: e.target.value })} />
              </div>
            </div>
            <button type="submit" disabled={guardandoConfig} style={{ ...btnPri(guardandoConfig), marginTop: 16 }}>
              {guardandoConfig ? 'Guardando…' : 'Guardar'}
            </button>
            {msgConfig.texto && <div style={banner(msgConfig.tipo)}>{msgConfig.texto}</div>}
          </form>
        </div>
      )}

      {tab === 'certificado' && (
        <>
          <div style={card}>
            <h3 style={{ marginTop: 0, fontFamily: 'var(--font-ui)', color: 'var(--ink-900)' }}>Certificado digital (.pfx)</h3>
            {certificado ? (
              <p style={{ fontFamily: 'var(--font-ui)', fontSize: 'var(--fs-base)', color: 'var(--ink-700)' }}>
                Cargado — titular <strong>{certificado.rut_titular || '—'}</strong>, vence el {new Date(certificado.vence_en).toLocaleDateString('es-CL')}.
              </p>
            ) : (
              <p style={{ fontFamily: 'var(--font-ui)', fontSize: 'var(--fs-base)', color: 'var(--ink-500)' }}>Todavía no hay un certificado cargado.</p>
            )}
            <form onSubmit={subirCertificado} style={{ marginTop: 8 }}>
              <div style={row2}>
                <div>
                  <label style={label}>Archivo .pfx</label>
                  <input style={input} type="file" accept=".pfx,.p12" onChange={e => setArchivoPfx(e.target.files[0] || null)} />
                </div>
                <div>
                  <label style={label}>Contraseña del certificado</label>
                  <input style={input} type="password" value={passwordPfx} onChange={e => setPasswordPfx(e.target.value)} />
                </div>
              </div>
              <button type="submit" disabled={subiendoCert} style={{ ...btnPri(subiendoCert), marginTop: 14 }}>
                {subiendoCert ? 'Subiendo…' : (certificado ? 'Reemplazar certificado' : 'Subir certificado')}
              </button>
              {msgCert.texto && <div style={banner(msgCert.tipo)}>{msgCert.texto}</div>}
            </form>
          </div>

          <div style={card}>
            <h3 style={{ marginTop: 0, fontFamily: 'var(--font-ui)', color: 'var(--ink-900)' }}>CAF — folios autorizados por el SII</h3>
            <form onSubmit={subirCaf}>
              <label style={label}>Pegá acá el XML del CAF</label>
              <textarea
                style={{ ...input, minHeight: 110, fontFamily: 'var(--font-mono)', fontSize: 'var(--fs-sm)' }}
                placeholder="<AUTORIZACION>...</AUTORIZACION>"
                value={cafXml}
                onChange={e => setCafXml(e.target.value)}
              />
              <button type="submit" disabled={subiendoCaf} style={{ ...btnPri(subiendoCaf), marginTop: 12 }}>
                {subiendoCaf ? 'Cargando…' : 'Cargar CAF'}
              </button>
              {msgCaf.texto && <div style={banner(msgCaf.tipo)}>{msgCaf.texto}</div>}
            </form>

            {folios.length > 0 && (
              <div style={{ marginTop: 18, overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontFamily: 'var(--font-ui)', fontSize: 'var(--fs-sm)' }}>
                  <thead>
                    <tr style={{ textAlign: 'left', borderBottom: `1px solid var(--line)`, color: 'var(--ink-500)' }}>
                      <th style={{ padding: '6px 8px' }}>Tipo</th>
                      <th style={{ padding: '6px 8px' }}>Rango</th>
                      <th style={{ padding: '6px 8px' }}>Restantes</th>
                      <th style={{ padding: '6px 8px' }}>Estado</th>
                    </tr>
                  </thead>
                  <tbody>
                    {folios.map(f => (
                      <tr key={f.tipo_dte + f.folio_desde} style={{ borderBottom: '1px solid var(--line-soft)' }}>
                        <td style={{ padding: '6px 8px' }}>{DTE_TIPO_LABEL[f.tipo_dte] || f.tipo_dte}</td>
                        <td style={{ padding: '6px 8px', fontFamily: 'var(--font-tabular)', fontVariantNumeric: 'tabular-nums' }}>{f.folio_desde}–{f.folio_hasta}</td>
                        <td style={{ padding: '6px 8px', fontFamily: 'var(--font-tabular)', fontVariantNumeric: 'tabular-nums' }}>{f.restantes}</td>
                        <td style={{ padding: '6px 8px' }}>
                          {f.agotado
                            ? <DtePill bg="var(--bad-bg)" ink="var(--bad-ink)" label="Agotado" />
                            : <DtePill bg="var(--ok-bg)" ink="var(--ok-ink)" label="Disponible" />}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </>
      )}

      {tab === 'boletas' && (
        <>
          <div style={card}>
            <h3 style={{ marginTop: 0, fontFamily: 'var(--font-ui)', color: 'var(--ink-900)' }}>Generar una boleta de prueba</h3>
            <p style={{ fontFamily: 'var(--font-ui)', fontSize: 'var(--fs-sm)', color: 'var(--ink-500)', marginTop: -6 }}>
              Elegí una venta ya cobrada en el POS. Se arma la boleta completa, pero no se manda a ningún lado.
            </p>
            <label style={label}>Venta</label>
            <select style={input} value={ventaId} onChange={e => setVentaId(e.target.value)}>
              <option value="">— elegir una venta —</option>
              {ventas.map(v => (
                <option key={v.id} value={v.id}>
                  {new Date(v.fecha).toLocaleString('es-CL')} · ${Number(v.total).toLocaleString('es-CL')} · {v.items?.[0]?.titulo}{v.items?.length > 1 ? ` +${v.items.length - 1}` : ''}
                </option>
              ))}
            </select>
            <button onClick={generarBoleta} disabled={generando || !ventaId} style={{ ...btnPri(generando || !ventaId), marginTop: 14 }}>
              {generando ? 'Generando…' : 'Generar boleta de prueba'}
            </button>
            {msgBoleta.texto && <div style={banner(msgBoleta.tipo)}>{msgBoleta.texto}</div>}

            {resultado && (
              <div style={{ marginTop: 16, padding: 14, background: 'var(--paper-soft)', borderRadius: 'var(--r-lg)', border: '1px solid var(--line)' }}>
                <p style={{ margin: 0, fontFamily: 'var(--font-ui)', fontSize: 'var(--fs-base)', color: 'var(--ink-900)' }}>
                  Folio <strong>{resultado.folio}</strong> generado ✓
                </p>
                <p style={{ margin: '4px 0 10px', fontFamily: 'var(--font-ui)', fontSize: 'var(--fs-sm)', color: 'var(--warn-ink)' }}>{resultado.aviso}</p>
                {resultado.pdf417 && (
                  <div style={{ background: '#fff', padding: 12, borderRadius: 'var(--r-md)', display: 'inline-block', marginBottom: 10 }}>
                    <img src={resultado.pdf417} alt="Timbre electrónico (PDF417)" style={{ maxWidth: '100%', display: 'block' }} />
                  </div>
                )}
                <details>
                  <summary style={{ cursor: 'pointer', fontFamily: 'var(--font-ui)', fontSize: 'var(--fs-sm)', fontWeight: 600, color: 'var(--ink-700)' }}>Ver XML generado</summary>
                  <pre style={{ marginTop: 8, padding: 12, background: 'var(--ink-900)', color: 'var(--ok-bg)', borderRadius: 'var(--r-md)', fontSize: 11, fontFamily: 'var(--font-mono)', overflowX: 'auto', whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
                    {resultado.xml}
                  </pre>
                </details>
              </div>
            )}
          </div>

          <div style={card}>
            <h3 style={{ marginTop: 0, fontFamily: 'var(--font-ui)', color: 'var(--ink-900)' }}>Historial de boletas generadas</h3>
            {emitidos.length === 0 ? (
              <p style={{ fontFamily: 'var(--font-ui)', color: 'var(--ink-500)', fontSize: 'var(--fs-base)' }}>Todavía no generaste ninguna.</p>
            ) : (
              <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontFamily: 'var(--font-ui)', fontSize: 'var(--fs-sm)' }}>
                  <thead>
                    <tr style={{ textAlign: 'left', borderBottom: '1px solid var(--line)', color: 'var(--ink-500)' }}>
                      <th style={{ padding: '6px 8px' }}>Folio</th>
                      <th style={{ padding: '6px 8px' }}>Tipo</th>
                      <th style={{ padding: '6px 8px' }}>Estado</th>
                      <th style={{ padding: '6px 8px' }}>Fecha</th>
                      <th style={{ padding: '6px 8px' }}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {emitidos.map(d => {
                      const est = DTE_ESTADO_STYLE[d.estado] || { bg: 'var(--ink-200)', ink: 'var(--ink-700)', label: d.estado };
                      return (
                        <React.Fragment key={d.id}>
                          <tr style={{ borderBottom: '1px solid var(--line-soft)' }}>
                            <td style={{ padding: '6px 8px', fontFamily: 'var(--font-tabular)', fontVariantNumeric: 'tabular-nums' }}>{d.folio}</td>
                            <td style={{ padding: '6px 8px' }}>{DTE_TIPO_LABEL[d.tipo_dte] || d.tipo_dte}</td>
                            <td style={{ padding: '6px 8px' }}><DtePill bg={est.bg} ink={est.ink} label={est.label} /></td>
                            <td style={{ padding: '6px 8px', color: 'var(--ink-500)' }}>{new Date(d.creado_en).toLocaleString('es-CL')}</td>
                            <td style={{ padding: '6px 8px' }}>
                              <button onClick={() => verDetalle(d.id)} style={{ background: 'none', border: '1px solid var(--line)', color: 'var(--ink-700)', padding: '3px 10px', borderRadius: 'var(--r-pill)', cursor: 'pointer', fontSize: 'var(--fs-xs)', fontFamily: 'var(--font-ui)' }}>
                                {detalleAbierto?.id === d.id ? 'Ocultar' : 'Ver XML'}
                              </button>
                            </td>
                          </tr>
                          {detalleAbierto?.id === d.id && (
                            <tr>
                              <td colSpan={5} style={{ padding: '0 8px 12px' }}>
                                {detalleAbierto.pdf417 && (
                                  <div style={{ background: '#fff', padding: 12, borderRadius: 'var(--r-md)', display: 'inline-block', marginBottom: 8 }}>
                                    <img src={detalleAbierto.pdf417} alt="Timbre electrónico (PDF417)" style={{ maxWidth: '100%', display: 'block' }} />
                                  </div>
                                )}
                                <pre style={{ padding: 12, background: 'var(--ink-900)', color: 'var(--ok-bg)', borderRadius: 'var(--r-md)', fontSize: 11, fontFamily: 'var(--font-mono)', overflowX: 'auto', whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
                                  {detalleAbierto.xml_documento}
                                </pre>
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
}

// =============================================================================
// SUPERADMIN — gestión de librerías (tenants)
// =============================================================================

const BOL_MESES = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
const bolFecha = iso => {
  const [, m, d] = String(iso ?? '').slice(0, 10).split('-');
  return m ? `${+d} ${BOL_MESES[+m - 1]}` : '—';
};
const BOL_TIPO = {
  nuevo:      { etiqueta: 'Nuevo',      color: '#B35A00', fondo: '#FFF1DF' },
  mejora:     { etiqueta: 'Mejora',     color: '#1F6B4A', fondo: '#E6F4EC' },
  correccion: { etiqueta: 'Corrección', color: '#5A5348', fondo: '#F0EDE6' },
};

function SuperAdminBoletines() {
  const esMobile = useMobile();
  const [lista,    setLista]    = useState([]);
  const [meta,     setMeta]     = useState({ destinatarios: 0, envio_configurado: false, remitente: '' });
  const [detalle,  setDetalle]  = useState(null);
  const [cargando, setCargando] = useState(false);
  const [ocupado,  setOcupado]  = useState('');
  const [error,    setError]    = useState('');
  const [mensaje,  setMensaje]  = useState('');
  const [confirmar, setConfirmar] = useState(false);

  const err = (e, alt) => e?.response?.data?.error || alt;

  useEffect(() => { cargarLista(); }, []);

  async function cargarLista() {
    setCargando(true);
    try {
      const { data } = await api.get('/superadmin/boletines');
      setLista(data.boletines);
      setMeta({ destinatarios: data.destinatarios, envio_configurado: data.envio_configurado, remitente: data.remitente });
    } catch (e) { setError(err(e, 'No se pudo cargar el listado de boletines')); }
    finally { setCargando(false); }
  }

  async function abrir(id) {
    setError(''); setMensaje(''); setConfirmar('');
    try {
      const { data } = await api.get(`/superadmin/boletines/${id}`);
      setDetalle(data);
    } catch (e) { setError(err(e, 'No se pudo abrir el boletín')); }
  }

  async function generar() {
    setError(''); setMensaje(''); setOcupado('generar');
    try {
      const { data } = await api.post('/superadmin/boletines/generar', {});
      await cargarLista();
      await abrir(data.id);
      setMensaje(`Borrador armado con ${data.items.filter(i => i.incluido).length} de ${data.items.length} cambios marcados.`);
    } catch (e) {
      if (e?.response?.status === 409 && e.response.data?.id) {
        setError('Ya existe un boletín para esta semana. Lo abrí para que lo edites.');
        await abrir(e.response.data.id);
      } else setError(err(e, 'No se pudo generar el borrador'));
    } finally { setOcupado(''); }
  }

  async function guardar() {
    setError(''); setMensaje(''); setOcupado('guardar');
    try {
      const { data } = await api.patch(`/superadmin/boletines/${detalle.id}`, {
        asunto: detalle.asunto, intro: detalle.intro, items: detalle.items,
      });
      setDetalle(d => ({ ...d, ...data }));
      setMensaje('Cambios guardados. La vista previa está actualizada.');
      cargarLista();
    } catch (e) { setError(err(e, 'No se pudieron guardar los cambios')); }
    finally { setOcupado(''); }
  }

  async function enviarPrueba() {
    setError(''); setMensaje(''); setOcupado('prueba');
    try {
      const { data } = await api.post(`/superadmin/boletines/${detalle.id}/prueba`, {});
      setMensaje(`Correo de prueba enviado a ${data.enviado_a}.`);
    } catch (e) { setError(err(e, 'No se pudo enviar la prueba')); }
    finally { setOcupado(''); }
  }

  async function enviar() {
    setError(''); setMensaje(''); setOcupado('enviar'); setConfirmar(false);
    try {
      const { data } = await api.post(`/superadmin/boletines/${detalle.id}/enviar`, {});
      setMensaje(data.fallidos
        ? `Enviado a ${data.enviados_ahora}, con ${data.fallidos} fallo(s). Puedes reintentar: quien ya recibió no se repite.`
        : `Boletín enviado a ${data.enviados_ahora} destinatarios.`);
      await abrir(detalle.id);
      cargarLista();
    } catch (e) { setError(err(e, 'No se pudo enviar el boletín')); }
    finally { setOcupado(''); }
  }

  async function borrar(id) {
    setError(''); setMensaje('');
    try { await api.delete(`/superadmin/boletines/${id}`); cargarLista(); }
    catch (e) { setError(err(e, 'No se pudo borrar')); }
  }

  const editarItem = (idx, campo, valor) => setDetalle(d => ({
    ...d, items: d.items.map((it, i) => (i === idx ? { ...it, [campo]: valor } : it)),
  }));

  const card = { background: 'var(--paper)', borderRadius: 16, padding: '20px 24px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)', border: '1px solid var(--line)' };
  const inp  = { width: '100%', padding: '9px 12px', borderRadius: 10, border: '1.5px solid var(--line)', background: 'var(--paper)', fontSize: 14, fontFamily: 'var(--font-ui)', boxSizing: 'border-box', color: 'var(--ink-900)' };
  const btn  = (variant, off) => ({
    padding: '9px 18px', borderRadius: 10, border: 'none', cursor: off ? 'default' : 'pointer',
    fontSize: 14, fontFamily: 'var(--font-ui)', fontWeight: 600, opacity: off ? 0.5 : 1,
    display: 'inline-flex', alignItems: 'center', gap: 7,
    ...(variant === 'primary' ? { background: 'var(--brand)', color: 'var(--ink-900)' }
      : variant === 'ghost'   ? { background: 'transparent', color: 'var(--ink-500)', border: '1.5px solid var(--line)' }
      : variant === 'peligro' ? { background: '#E52E01', color: '#fff' }
      : { background: 'var(--paper-stripe)', color: 'var(--ink-700)' }),
  });
  const avisos = (
    <>
      {error   && <div style={{ color: 'var(--danger)',  marginBottom: 12, fontSize: 14 }}>{error}</div>}
      {mensaje && <div style={{ color: 'var(--success)', marginBottom: 12, fontSize: 14 }}>{mensaje}</div>}
    </>
  );

  // ── Detalle / edición ───────────────────────────────────────────────────
  if (detalle) {
    const incluidos = (detalle.items || []).filter(i => i.incluido).length;
    const enviado   = detalle.estado === 'enviado';
    const fallidos  = (detalle.envios || []).filter(e => e.estado === 'error');

    return (
      <div>
        <button onClick={() => { setDetalle(null); setError(''); setMensaje(''); }}
          style={{ ...btn('ghost'), marginBottom: 20 }}>
          <ArrowLeft size={15} /> Volver
        </button>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 16, marginBottom: 20, flexWrap: 'wrap' }}>
          <div>
            <h2 style={{ margin: 0, fontSize: 22, fontFamily: 'var(--font-ui)' }}>
              Boletín {bolFecha(detalle.desde)} – {bolFecha(detalle.hasta)}
            </h2>
            <span style={{ fontSize: 13, color: 'var(--ink-500)', fontFamily: 'var(--font-ui)' }}>
              {enviado
                ? `Enviado a ${detalle.enviados} destinatarios`
                : `${incluidos} de ${(detalle.items || []).length} cambios marcados · llegará a ${detalle.destinatarios} personas`}
            </span>
          </div>
          {!enviado && (
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
              <button onClick={guardar} disabled={!!ocupado} style={btn('', !!ocupado)}>
                {ocupado === 'guardar' ? 'Guardando…' : 'Guardar cambios'}
              </button>
              <button onClick={enviarPrueba} disabled={!!ocupado || !detalle.envio_configurado} style={btn('ghost', !!ocupado || !detalle.envio_configurado)}>
                <Eye size={15} /> {ocupado === 'prueba' ? 'Enviando…' : 'Enviarme una prueba'}
              </button>
              {!confirmar ? (
                <button onClick={() => setConfirmar(true)} disabled={!!ocupado || !incluidos || !detalle.envio_configurado}
                  style={btn('primary', !!ocupado || !incluidos || !detalle.envio_configurado)}>
                  <Send size={15} /> Enviar a {detalle.destinatarios}
                </button>
              ) : (
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8, background: '#FFF1DF', border: '1.5px solid #FE8505', borderRadius: 10, padding: '4px 6px 4px 14px' }}>
                  <span style={{ fontSize: 13, fontFamily: 'var(--font-ui)', color: 'var(--ink-700)' }}>
                    ¿Enviar a {detalle.destinatarios} personas?
                  </span>
                  <button onClick={enviar} style={btn('primary')}>Sí, enviar</button>
                  <button onClick={() => setConfirmar(false)} style={btn('ghost')}>Cancelar</button>
                </span>
              )}
            </div>
          )}
        </div>

        {avisos}

        {!detalle.envio_configurado && (
          <div style={{ ...card, marginBottom: 16, borderColor: '#FE8505', background: '#FFF9F0' }}>
            <div style={{ display: 'flex', gap: 10, alignItems: 'flex-start' }}>
              <AlertTriangle size={18} style={{ color: '#B35A00', flexShrink: 0, marginTop: 2 }} />
              <div style={{ fontSize: 14, fontFamily: 'var(--font-ui)', color: 'var(--ink-700)', lineHeight: 1.6 }}>
                <b>El envío todavía no está habilitado.</b> Falta configurar <code>RESEND_API_KEY</code> en
                el servidor y verificar el dominio relea.cl. Mientras tanto puedes armar y guardar borradores,
                pero no enviarlos.
              </div>
            </div>
          </div>
        )}

        <div style={{ display: 'grid', gridTemplateColumns: esMobile ? '1fr' : 'minmax(0,1fr) minmax(0,1fr)', gap: 16, alignItems: 'start' }}>
          <div style={{ ...card, display: 'flex', flexDirection: 'column', gap: 16 }}>
            <div>
              <label style={{ fontSize: 12, fontWeight: 600, color: 'var(--ink-500)', fontFamily: 'var(--font-ui)' }}>Asunto</label>
              <input value={detalle.asunto || ''} disabled={enviado}
                onChange={e => setDetalle(d => ({ ...d, asunto: e.target.value }))}
                style={{ ...inp, marginTop: 5 }} />
            </div>
            <div>
              <label style={{ fontSize: 12, fontWeight: 600, color: 'var(--ink-500)', fontFamily: 'var(--font-ui)' }}>
                Titular del correo
              </label>
              <input value={detalle.intro || ''} disabled={enviado}
                onChange={e => setDetalle(d => ({ ...d, intro: e.target.value }))}
                style={{ ...inp, marginTop: 5, fontWeight: 600 }} />
              <div style={{ fontSize: 12, color: 'var(--ink-500)', fontFamily: 'var(--font-ui)', paddingTop: 5 }}>
                Sale grande, bajo el saludo. Córtalo: una línea, sin punto final.
              </div>
            </div>

            <div>
              <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--ink-500)', fontFamily: 'var(--font-ui)', marginBottom: 4 }}>
                Cambios de la semana
              </div>
              <div style={{ fontSize: 13, color: 'var(--ink-500)', fontFamily: 'var(--font-ui)', marginBottom: 12, lineHeight: 1.5 }}>
                Desmarcados vienen los cambios internos, que no significan nada para un librero.
                Reescribe los títulos con sus palabras antes de enviar.
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                {(detalle.items || []).map((it, idx) => {
                  const t = BOL_TIPO[it.tipo] || BOL_TIPO.correccion;
                  return (
                    <div key={it.id + idx} style={{
                      display: 'flex', gap: 10, alignItems: 'flex-start', padding: '10px 12px',
                      borderRadius: 10, border: '1px solid var(--line)',
                      background: it.incluido ? 'var(--paper)' : 'var(--paper-stripe)',
                      opacity: it.incluido ? 1 : 0.65,
                    }}>
                      <input type="checkbox" checked={!!it.incluido} disabled={enviado}
                        onChange={e => editarItem(idx, 'incluido', e.target.checked)}
                        style={{ marginTop: 9, width: 16, height: 16, flexShrink: 0, accentColor: '#FE8505' }} />
                      <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: 6 }}>
                        <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                          <span style={{ fontSize: 11, fontWeight: 700, padding: '2px 7px', borderRadius: 6, background: t.fondo, color: t.color, fontFamily: 'var(--font-ui)', whiteSpace: 'nowrap' }}>
                            {t.etiqueta}
                          </span>
                          <input value={it.ambito || ''} disabled={enviado}
                            onChange={e => editarItem(idx, 'ambito', e.target.value)}
                            placeholder="Módulo"
                            style={{ ...inp, padding: '4px 8px', fontSize: 12, width: 150, maxWidth: '45%', flexShrink: 1 }} />
                        </div>
                        <input value={it.titulo || ''} disabled={enviado}
                          onChange={e => editarItem(idx, 'titulo', e.target.value)}
                          style={{ ...inp, padding: '6px 10px', fontWeight: 600 }} />
                        <input value={it.detalle || ''} disabled={enviado}
                          onChange={e => editarItem(idx, 'detalle', e.target.value)}
                          placeholder="Explica en una línea qué gana el librero (opcional)"
                          style={{ ...inp, padding: '6px 10px', fontSize: 13, color: 'var(--ink-600)' }} />
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          <div style={{ ...card, padding: 16 }}>
            <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--ink-500)', fontFamily: 'var(--font-ui)', marginBottom: 10 }}>
              Vista previa {!enviado && '— se actualiza al guardar'}
            </div>
            <iframe title="Vista previa del boletín" srcDoc={detalle.html || ''}
              style={{ width: '100%', height: 640, border: '1px solid var(--line)', borderRadius: 12, background: '#fff' }} />
          </div>
        </div>

        {!!fallidos.length && (
          <div style={{ ...card, marginTop: 16 }}>
            <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--danger)', fontFamily: 'var(--font-ui)', marginBottom: 8 }}>
              {fallidos.length} envío(s) con error
            </div>
            {fallidos.map(f => (
              <div key={f.email} style={{ fontSize: 13, color: 'var(--ink-600)', fontFamily: 'var(--font-ui)', padding: '4px 0' }}>
                {f.email} — {f.error}
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }

  // ── Listado ─────────────────────────────────────────────────────────────
  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 16, marginBottom: 20, flexWrap: 'wrap' }}>
        <div>
          <h2 style={{ margin: 0, fontSize: 22, fontFamily: 'var(--font-ui)' }}>Boletines</h2>
          <span style={{ fontSize: 13, color: 'var(--ink-500)', fontFamily: 'var(--font-ui)' }}>
            Cada viernes se arma solo un borrador con los cambios de la semana. Nada sale sin que lo revises.
            {meta.destinatarios > 0 && ` Hoy llegaría a ${meta.destinatarios} personas.`}
          </span>
        </div>
        <button onClick={generar} disabled={ocupado === 'generar'} style={btn('primary', ocupado === 'generar')}>
          <Megaphone size={15} /> {ocupado === 'generar' ? 'Armando…' : 'Armar borrador de esta semana'}
        </button>
      </div>

      {avisos}

      {!meta.envio_configurado && (
        <div style={{ ...card, marginBottom: 16, borderColor: '#FE8505', background: '#FFF9F0' }}>
          <div style={{ display: 'flex', gap: 10, alignItems: 'flex-start' }}>
            <AlertTriangle size={18} style={{ color: '#B35A00', flexShrink: 0, marginTop: 2 }} />
            <div style={{ fontSize: 14, fontFamily: 'var(--font-ui)', color: 'var(--ink-700)', lineHeight: 1.6 }}>
              <b>Falta habilitar el envío.</b> Hay que crear la cuenta en Resend, verificar relea.cl con
              SPF y DKIM, y cargar <code>RESEND_API_KEY</code> en Railway. Los borradores ya funcionan.
            </div>
          </div>
        </div>
      )}

      <div style={{ ...card, overflowX: 'auto' }}>
        {cargando ? (
          <div style={{ padding: 20, color: 'var(--ink-500)', fontSize: 14, fontFamily: 'var(--font-ui)' }}>Cargando…</div>
        ) : !lista.length ? (
          <div style={{ padding: '28px 8px', color: 'var(--ink-500)', fontSize: 14, fontFamily: 'var(--font-ui)', lineHeight: 1.6 }}>
            Todavía no hay boletines. Arma el primero con el botón de arriba —
            junta los cambios de los últimos siete días y te deja el borrador listo para editar.
          </div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse', fontFamily: 'var(--font-ui)', fontSize: 14 }}>
            <thead>
              <tr style={{ borderBottom: '1.5px solid var(--line)' }}>
                {['Semana', 'Asunto', 'Estado', 'Ítems', ''].map(h => (
                  <th key={h} style={{ textAlign: 'left', padding: '6px 12px', color: 'var(--ink-500)', fontWeight: 600, fontSize: 12 }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {lista.map(b => (
                <tr key={b.id} style={{ borderBottom: '1px solid var(--line)' }}>
                  <td style={{ padding: '10px 12px', whiteSpace: 'nowrap', color: 'var(--ink-600)' }}>
                    {bolFecha(b.desde)} – {bolFecha(b.hasta)}
                  </td>
                  <td style={{ padding: '10px 12px' }}>{b.asunto}</td>
                  <td style={{ padding: '10px 12px' }}>
                    <span style={{
                      fontSize: 12, fontWeight: 600, padding: '2px 9px', borderRadius: 8,
                      background: b.estado === 'enviado' ? '#E6F4EC' : 'var(--paper-stripe)',
                      color: b.estado === 'enviado' ? '#1F6B4A' : 'var(--ink-600)',
                    }}>
                      {b.estado === 'enviado' ? `enviado a ${b.enviados}` : 'borrador'}
                    </span>
                  </td>
                  <td style={{ padding: '10px 12px', color: 'var(--ink-600)' }}>{b.incluidos}</td>
                  <td style={{ padding: '10px 12px', textAlign: 'right', whiteSpace: 'nowrap' }}>
                    <button onClick={() => abrir(b.id)} style={{ ...btn('ghost'), padding: '5px 12px', fontSize: 13 }}>
                      {b.estado === 'enviado' ? 'Ver' : 'Revisar'}
                    </button>
                    {b.estado === 'borrador' && (
                      <button onClick={() => borrar(b.id)} title="Borrar borrador"
                        style={{ ...btn('ghost'), padding: '5px 10px', marginLeft: 6, color: 'var(--danger)' }}>
                        <Trash2 size={14} />
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

function SuperAdminTenants() {
  const [tenants,   setTenants]   = useState([]);
  const [cargando,  setCargando]  = useState(false);
  const [error,     setError]     = useState('');
  const [mensaje,   setMensaje]   = useState('');
  const [modalOpen, setModalOpen] = useState(false);
  const [detalle,   setDetalle]   = useState(null); // tenant seleccionado para ver usuarios
  const [usuarios,  setUsuarios]  = useState([]);
  const [modalUsuario, setModalUsuario] = useState(false);

  const formVacio = { nombre: '', subdominio: '', admin_nombre: '', admin_email: '', admin_password: '' };
  const [form, setForm] = useState(formVacio);

  const formUserVacio = { nombre: '', email: '', password: '', rol: 'librero' };
  const [formUser, setFormUser] = useState(formUserVacio);

  useEffect(() => { cargar(); }, []);

  async function cargar() {
    setCargando(true);
    try {
      const res = await api.get('/superadmin/tenants');
      setTenants(res.data);
    } catch { setError('Error cargando librerías'); }
    finally { setCargando(false); }
  }

  async function crearTenant(e) {
    e.preventDefault();
    setError(''); setMensaje('');
    try {
      await api.post('/superadmin/tenants', form);
      setMensaje('Librería creada con éxito');
      setModalOpen(false);
      setForm(formVacio);
      cargar();
    } catch (err) {
      setError(err.response?.data?.error || 'Error creando librería');
    }
  }

  async function verDetalle(tenant) {
    setDetalle(tenant);
    try {
      const res = await api.get(`/superadmin/tenants/${tenant.id}/usuarios`);
      setUsuarios(res.data);
    } catch { setUsuarios([]); }
  }

  async function crearUsuario(e) {
    e.preventDefault();
    setError(''); setMensaje('');
    try {
      await api.post(`/superadmin/tenants/${detalle.id}/usuarios`, formUser);
      setMensaje('Usuario creado');
      setModalUsuario(false);
      setFormUser(formUserVacio);
      const res = await api.get(`/superadmin/tenants/${detalle.id}/usuarios`);
      setUsuarios(res.data);
    } catch (err) {
      setError(err.response?.data?.error || 'Error creando usuario');
    }
  }

  const card = { background: 'var(--paper)', borderRadius: 16, padding: '20px 24px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)', border: '1px solid var(--line)' };
  const inp  = { width: '100%', padding: '9px 12px', borderRadius: 10, border: '1.5px solid var(--line)', background: 'var(--paper)', fontSize: 14, fontFamily: 'var(--font-ui)', boxSizing: 'border-box', color: 'var(--ink-900)' };
  const btn  = (variant) => ({
    padding: '9px 18px', borderRadius: 10, border: 'none', cursor: 'pointer', fontSize: 14,
    fontFamily: 'var(--font-ui)', fontWeight: 600,
    ...(variant === 'primary' ? { background: 'var(--brand)', color: 'var(--ink-900)' }
      : variant === 'ghost'   ? { background: 'transparent', color: 'var(--ink-500)', border: '1.5px solid var(--line)' }
      : { background: 'var(--paper-stripe)', color: 'var(--ink-700)' }),
  });

  // Panel de detalle de un tenant
  if (detalle) return (
    <div>
      <button onClick={() => { setDetalle(null); setUsuarios([]); setError(''); setMensaje(''); }}
        style={{ ...btn('ghost'), marginBottom: 20, display: 'flex', alignItems: 'center', gap: 6 }}>
        <ArrowLeft size={15} /> Volver
      </button>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 20 }}>
        <div>
          <h2 style={{ margin: 0, fontSize: 22, fontFamily: 'var(--font-ui)' }}>{detalle.nombre}</h2>
          <span style={{ fontSize: 13, color: 'var(--ink-500)', fontFamily: 'var(--font-ui)' }}>subdominio: <b>{detalle.subdominio}</b></span>
        </div>
        <button onClick={() => { setModalUsuario(true); setFormUser(formUserVacio); setError(''); }} style={btn('primary')}>
          + Agregar usuario
        </button>
      </div>
      {error   && <div style={{ color: 'var(--danger)', marginBottom: 12, fontSize: 14 }}>{error}</div>}
      {mensaje && <div style={{ color: 'var(--success)', marginBottom: 12, fontSize: 14 }}>{mensaje}</div>}
      <div style={card}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontFamily: 'var(--font-ui)', fontSize: 14 }}>
          <thead>
            <tr style={{ borderBottom: '1.5px solid var(--line)' }}>
              {['Nombre', 'Email', 'Rol'].map(h => (
                <th key={h} style={{ textAlign: 'left', padding: '6px 12px', color: 'var(--ink-500)', fontWeight: 600, fontSize: 12 }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {usuarios.map(u => (
              <tr key={u.id} style={{ borderBottom: '1px solid var(--line)' }}>
                <td style={{ padding: '10px 12px' }}>{u.nombre}</td>
                <td style={{ padding: '10px 12px', color: 'var(--ink-600)' }}>{u.email}</td>
                <td style={{ padding: '10px 12px' }}>
                  <span style={{ fontSize: 12, fontWeight: 600, padding: '2px 8px', borderRadius: 8, background: u.rol === 'admin' ? '#f0c040' : 'var(--paper-stripe)', color: u.rol === 'admin' ? '#2c2c2a' : 'var(--ink-600)' }}>
                    {u.rol}
                  </span>
                </td>
              </tr>
            ))}
            {usuarios.length === 0 && (
              <tr><td colSpan={3} style={{ padding: '16px 12px', color: 'var(--ink-400)', textAlign: 'center' }}>Sin usuarios</td></tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Modal nuevo usuario */}
      {modalUsuario && (
        <div style={{ position: 'fixed', inset: 0, background: 'var(--scrim)', zIndex: 200, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ ...card, width: '100%', maxWidth: 420, margin: 16 }}>
            <h3 style={{ margin: '0 0 18px', fontFamily: 'var(--font-ui)' }}>Nuevo usuario en {detalle.nombre}</h3>
            <form onSubmit={crearUsuario} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              <input style={inp} placeholder="Nombre" value={formUser.nombre} onChange={e => setFormUser({ ...formUser, nombre: e.target.value })} required />
              <input style={inp} placeholder="Email" type="email" value={formUser.email} onChange={e => setFormUser({ ...formUser, email: e.target.value })} required />
              <input style={inp} placeholder="Contraseña (mín. 6 caracteres)" type="password" value={formUser.password} onChange={e => setFormUser({ ...formUser, password: e.target.value })} required />
              <select style={inp} value={formUser.rol} onChange={e => setFormUser({ ...formUser, rol: e.target.value })}>
                <option value="librero">Librero</option>
                <option value="admin">Admin</option>
              </select>
              {error && <div style={{ color: 'var(--danger)', fontSize: 13 }}>{error}</div>}
              <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
                <button type="button" onClick={() => { setModalUsuario(false); setError(''); }} style={btn('ghost')}>Cancelar</button>
                <button type="submit" style={btn('primary')}>Crear</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );

  // Lista de tenants
  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <h1 style={{ margin: 0, fontSize: 24, fontFamily: 'var(--font-ui)' }}>Librerías</h1>
        <button onClick={() => { setModalOpen(true); setForm(formVacio); setError(''); }} style={btn('primary')}>
          + Nueva librería
        </button>
      </div>

      {error   && <div style={{ color: 'var(--danger)', marginBottom: 12, fontSize: 14 }}>{error}</div>}
      {mensaje && <div style={{ color: 'var(--success)', marginBottom: 12, fontSize: 14 }}>{mensaje}</div>}

      {cargando ? (
        <div style={{ color: 'var(--ink-500)', fontFamily: 'var(--font-ui)' }}>Cargando…</div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {tenants.map(t => (
            <div key={t.id} style={{ ...card, display: 'flex', alignItems: 'center', gap: 16, cursor: 'pointer' }}
              onClick={() => verDetalle(t)}>
              <div style={{ width: 42, height: 42, borderRadius: 12, background: 'var(--brand)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <Building2 size={20} color="var(--ink-900)" />
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontFamily: 'var(--font-ui)', fontWeight: 600, fontSize: 15 }}>{t.nombre}</div>
                <div style={{ fontSize: 13, color: 'var(--ink-500)', fontFamily: 'var(--font-ui)' }}>
                  {t.subdominio} · {t.admins} admin{t.admins !== 1 ? 's' : ''} · {t.libreros} librero{t.libreros !== 1 ? 's' : ''}
                </div>
              </div>
              <ChevronRight size={18} color="var(--ink-400)" />
            </div>
          ))}
          {tenants.length === 0 && (
            <div style={{ ...card, color: 'var(--ink-400)', textAlign: 'center', fontFamily: 'var(--font-ui)' }}>
              No hay librerías registradas
            </div>
          )}
        </div>
      )}

      {/* Modal nueva librería */}
      {modalOpen && (
        <div style={{ position: 'fixed', inset: 0, background: 'var(--scrim)', zIndex: 200, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ ...card, width: '100%', maxWidth: 460, margin: 16 }}>
            <h3 style={{ margin: '0 0 6px', fontFamily: 'var(--font-ui)' }}>Nueva librería</h3>
            <p style={{ margin: '0 0 18px', fontSize: 13, color: 'var(--ink-500)', fontFamily: 'var(--font-ui)' }}>
              Se creará la librería y su usuario administrador.
            </p>
            <form onSubmit={crearTenant} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              <div>
                <label style={{ fontSize: 12, fontWeight: 600, color: 'var(--ink-500)', fontFamily: 'var(--font-ui)', display: 'block', marginBottom: 4 }}>LIBRERÍA</label>
                <input style={inp} placeholder="Nombre (ej: Librería del Mar)" value={form.nombre} onChange={e => setForm({ ...form, nombre: e.target.value })} required />
              </div>
              <input style={inp} placeholder="Subdominio (ej: delmar)" value={form.subdominio} onChange={e => setForm({ ...form, subdominio: e.target.value.toLowerCase().replace(/\s+/g, '-') })} required />
              <div style={{ borderTop: '1px solid var(--line)', paddingTop: 12 }}>
                <label style={{ fontSize: 12, fontWeight: 600, color: 'var(--ink-500)', fontFamily: 'var(--font-ui)', display: 'block', marginBottom: 8 }}>ADMIN DE LA LIBRERÍA</label>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                  <input style={inp} placeholder="Nombre del admin" value={form.admin_nombre} onChange={e => setForm({ ...form, admin_nombre: e.target.value })} required />
                  <input style={inp} placeholder="Email" type="email" value={form.admin_email} onChange={e => setForm({ ...form, admin_email: e.target.value })} required />
                  <input style={inp} placeholder="Contraseña (mín. 6 caracteres)" type="password" value={form.admin_password} onChange={e => setForm({ ...form, admin_password: e.target.value })} required />
                </div>
              </div>
              {error && <div style={{ color: 'var(--danger)', fontSize: 13 }}>{error}</div>}
              <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 4 }}>
                <button type="button" onClick={() => { setModalOpen(false); setError(''); }} style={btn('ghost')}>Cancelar</button>
                <button type="submit" style={btn('primary')}>Crear librería</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

// =============================================================================
// SUPERADMIN — Libros RELEA
// =============================================================================
function SuperAdminLibros() {
  const [libros,    setLibros]    = useState([]);
  const [total,     setTotal]     = useState(0);
  const [cargando,  setCargando]  = useState(false);
  const [busqueda,  setBusqueda]  = useState('');
  const [pagina,    setPagina]    = useState(1);
  const [modal,     setModal]     = useState(null);
  const [form,      setForm]      = useState({ isbn: '', titulo: '', autor: '', editorial: '', categoria: '' });
  const [guardando, setGuardando] = useState(false);
  const [error,     setError]     = useState('');
  const [mensaje,   setMensaje]   = useState('');
  // Import persistente — idle | lista | subiendo | trabajando
  const [importVista,       setImportVista]       = useState('idle');
  const [importArchivos,    setImportArchivos]     = useState([]);
  const [importArchivo,     setImportArchivo]      = useState(null);  // archivo activo { id, nombre, total_items }
  const [importItem,        setImportItem]         = useState(null);  // item actual { key, tipo, data }
  const [importPending,     setImportPending]      = useState(0);
  const [importTotal,       setImportTotal]        = useState(0);
  const [importItemDec,     setImportItemDec]      = useState({});    // decisión local del item actual
  const [importGuardando,   setImportGuardando]    = useState(false);
  const fileRef = useRef(null);
  const POR_PAGINA = 50;
  const [propuestas,    setPropuestas]    = useState([]);
  const [propModal,     setPropModal]     = useState(null);
  const [propForm,      setPropForm]      = useState({});
  const [propGuardando, setPropGuardando] = useState(false);
  const [propMsg,       setPropMsg]       = useState(null);
  const [historial,     setHistorial]     = useState([]);
  const [histTab,       setHistTab]       = useState('datos');

  const cargar = React.useCallback(async (pag, q) => {
    setCargando(true);
    try {
      const res = await api.get('/superadmin/libros', { params: { q: q ?? busqueda, page: pag ?? pagina, limit: POR_PAGINA } });
      setLibros(res.data.libros);
      setTotal(res.data.total);
    } catch { /* silencioso */ }
    finally { setCargando(false); }
  }, [busqueda, pagina]);

  const cargarPropuestas = async () => {
    try {
      const res = await api.get('/superadmin/libros/propuestas');
      setPropuestas(res.data);
    } catch { /* silencioso */ }
  };

  useEffect(() => { cargar(); cargarPropuestas(); }, []);

  const buscar = (q) => { setBusqueda(q); setPagina(1); cargar(1, q); };
  const irPagina = (p) => { setPagina(p); cargar(p, busqueda); };

  const abrirPropuesta = (p) => {
    setPropModal(p);
    const base = p.tipo === 'nuevo'
      ? { isbn: '', titulo: '', autor: '', editorial: '', categoria: '' }
      : {};
    setPropForm({ ...base, ...(p.campos || {}) });
    setPropMsg(null);
  };

  const revisarPropuesta = async (decision) => {
    if (!propModal) return;
    setPropGuardando(true);
    setPropMsg(null);
    try {
      await api.post(`/superadmin/libros/propuestas/${propModal.id}/revisar`, { decision, campos: propForm });
      setPropModal(null);
      cargarPropuestas();
      if (decision === 'aprobado') cargar();
    } catch (err) {
      setPropMsg({ tipo: 'error', texto: err.response?.data?.error || 'Error al procesar.' });
    }
    setPropGuardando(false);
  };

  const abrirNuevo = () => {
    setForm({ isbn: '', titulo: '', autor: '', editorial: '', categoria: '' });
    setError(''); setMensaje('');
    setModal({ nuevo: true });
  };
  const abrirEditar = (libro) => {
    setForm({ isbn: libro.isbn || '', titulo: libro.titulo, autor: libro.autor || '', editorial: libro.editorial || '', categoria: libro.categoria || '' });
    setError(''); setMensaje('');
    setModal({ libro });
    setHistTab('datos');
    setHistorial([]);
    api.get(`/superadmin/libros/${libro.id}/historial`).then(r => setHistorial(r.data)).catch(() => {});
  };
  const cerrarModal = () => { setModal(null); setError(''); };

  const guardar = async (e) => {
    e.preventDefault();
    setGuardando(true); setError('');
    try {
      if (modal.nuevo) {
        await api.post('/superadmin/libros', form);
        setMensaje('Libro creado');
      } else {
        await api.patch(`/superadmin/libros/${modal.libro.id}`, form);
        setMensaje('Libro actualizado');
      }
      cerrarModal();
      cargar();
    } catch (err) {
      setError(err.response?.data?.error || 'Error al guardar');
    } finally { setGuardando(false); }
  };

  const cargarArchivos = async () => {
    try {
      const res = await api.get('/superadmin/libros/importar/archivos');
      setImportArchivos(res.data);
    } catch { /* silencioso */ }
  };

  const abrirLista = () => { cargarArchivos(); setImportVista('lista'); };

  const subirArchivo = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    e.target.value = '';
    const fd = new FormData();
    fd.append('archivo', file);
    setImportVista('subiendo');
    setError('');
    try {
      const res = await fetch(`${api.defaults.baseURL}/superadmin/libros/importar/subir`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${localStorage.getItem('relea_token')}` },
        body: fd,
      });
      if (!res.ok) { const d = await res.json(); throw new Error(d.error || 'Error al procesar el archivo'); }
      const data = await res.json();
      setImportArchivo({ id: data.id, nombre: data.nombre, total_items: data.total_items });
      setImportPending(data.pendiente);
      setImportTotal(data.pendiente);
      setImportVista('trabajando');
      _autoAplicarLote(data.id);
    } catch (err) {
      setImportVista('lista');
      setError(err.message);
    }
  };

  const abrirArchivo = async (archivo) => {
    try {
      const res = await api.get(`/superadmin/libros/importar/archivos/${archivo.id}/abrir`);
      setImportArchivo({ id: res.data.id, nombre: res.data.nombre, total_items: res.data.total_items });
      setImportPending(res.data.pendiente);
      setImportTotal(res.data.total);
      setImportVista('trabajando');
      _autoAplicarLote(res.data.id);
      setImportVista('trabajando');
    } catch (err) { setError(err.response?.data?.error || 'Error al abrir archivo'); }
  };

  const _iniciarItem = (item) => {
    if (!item) { setImportItem(null); setImportItemDec({}); return; }
    setImportItem(item);
    if (item.tipo === 'dif') {
      const init = {};
      for (const [c, vals] of Object.entries(item.data.diff || {}))
        init[c] = { modo: 'sistema', valorCustom: vals.excel || '' };
      setImportItemDec(init);
    } else if (item.tipo === 'titulo') {
      const best = item.data.candidatos?.[0];
      setImportItemDec({ libro_id: best?.score >= 70 ? best.libro_id : null, actualizar_datos: false });
    } else {
      setImportItemDec({});
    }
  };

  // Aplica en lote todos los nuevo/auto pendientes, luego muestra el primer item manual
  const _autoAplicarLote = async (archivoId) => {
    try {
      const res = await api.post(`/superadmin/libros/importar/archivos/${archivoId}/auto-aplicar`);
      setImportPending(res.data.pendiente);
      setImportTotal(res.data.total);
      if (res.data.done || !res.data.siguiente) {
        setImportVista('lista');
        cargarArchivos();
        cargar(1, busqueda);
      } else {
        _iniciarItem(res.data.siguiente);
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Error en auto-aplicación');
    }
  };

  const decidirItem = async (decision) => {
    if (!importItem || importGuardando) return;
    setImportGuardando(true);
    let campos = null;
    if (decision === 'aplicado') {
      if (importItem.tipo === 'dif') {
        campos = {};
        for (const [c, dec] of Object.entries(importItemDec)) {
          const vals = importItem.data.diff[c];
          if (dec.modo === 'excel')  campos[c] = vals?.excel || '';
          else if (dec.modo === 'custom') campos[c] = dec.valorCustom;
          // modo 'sistema' → no se envía, se mantiene el valor del sistema
        }
        if (!Object.keys(campos).length) campos = null;
      } else if (importItem.tipo === 'titulo') {
        campos = importItemDec;
      }
    }
    try {
      const res = await api.post(`/superadmin/libros/importar/archivos/${importArchivo.id}/decidir`, {
        item_key: importItem.key, decision, campos,
      });
      setImportPending(res.data.pendiente);
      if (res.data.done || !res.data.siguiente) {
        setImportVista('lista');
        cargarArchivos();
        cargar(1, busqueda);
      } else {
        _autoAplicarLote(importArchivo.id);
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Error al guardar decisión');
    } finally { setImportGuardando(false); }
  };

  const eliminarArchivo = async (id) => {
    if (!window.confirm('¿Eliminar este archivo y su progreso?')) return;
    try {
      await api.delete(`/superadmin/libros/importar/archivos/${id}`);
      cargarArchivos();
    } catch (err) { setError(err.response?.data?.error || 'Error al eliminar'); }
  };

  const volverLista = () => {
    setImportVista('lista');
    setImportItem(null);
    setImportArchivo(null);
    cargarArchivos();
  };

  const totalPags = Math.ceil(total / POR_PAGINA);

  const card = { background: 'var(--paper)', borderRadius: 16, padding: '20px 24px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)', border: '1px solid var(--line)' };
  const inp  = { width: '100%', padding: '9px 12px', borderRadius: 10, border: '1.5px solid var(--line)', background: 'var(--paper)', fontSize: 14, fontFamily: 'var(--font-ui)', boxSizing: 'border-box', color: 'var(--ink-900)' };
  const btn  = (v) => ({
    padding: '9px 18px', borderRadius: 10, border: 'none', cursor: 'pointer', fontSize: 14,
    fontFamily: 'var(--font-ui)', fontWeight: 600,
    ...(v === 'primary' ? { background: 'var(--brand)', color: 'var(--ink-900)' }
      : v === 'ghost'   ? { background: 'transparent', color: 'var(--ink-500)', border: '1.5px solid var(--line)' }
      : { background: 'var(--paper-stripe)', color: 'var(--ink-700)' }),
  });
  const scoreColor = (s) => s >= 80 ? 'var(--success)' : s >= 60 ? '#b07000' : 'var(--danger)';

  const CAMPO = { titulo: 'Título', autor: 'Autor', editorial: 'Editorial' };

  // ── RENDER: subiendo ──────────────────────────────────────────────────────
  if (importVista === 'subiendo') {
    return (
      <div style={{ fontFamily: 'var(--font-ui)', maxWidth: 520, paddingTop: 48, textAlign: 'center' }}>
        <div style={{ fontSize: 32, marginBottom: 16 }}>⏳</div>
        <h3 style={{ margin: '0 0 8px' }}>Analizando archivo...</h3>
        <p style={{ color: 'var(--ink-500)', fontSize: 14 }}>Esto puede tomar unos segundos</p>
      </div>
    );
  }

  // ── RENDER: lista de archivos ─────────────────────────────────────────────
  if (importVista === 'lista') {
    return (
      <div style={{ fontFamily: 'var(--font-ui)', maxWidth: 720 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 24 }}>
          <button onClick={() => setImportVista('idle')} style={{ ...btn('ghost'), padding: '6px 14px', display: 'flex', alignItems: 'center', gap: 6 }}>
            <ArrowLeft size={14} /> Catálogo
          </button>
          <div style={{ flex: 1 }}>
            <h2 style={{ margin: 0, fontSize: 20 }}>Importaciones</h2>
            <span style={{ fontSize: 13, color: 'var(--ink-500)' }}>Trabajá un archivo a tu ritmo</span>
          </div>
          <button onClick={() => fileRef.current?.click()} style={{ ...btn('primary'), display: 'flex', alignItems: 'center', gap: 6 }}>
            <Upload size={14} /> Subir nuevo archivo
          </button>
          <input type="file" ref={fileRef} style={{ display: 'none' }} accept=".xlsx,.xls" onChange={subirArchivo} />
        </div>

        {error && <div style={{ color: 'var(--danger)', marginBottom: 12, fontSize: 14 }}>{error}</div>}

        {importArchivos.length === 0 && (
          <div style={{ ...card, textAlign: 'center', padding: 48 }}>
            <div style={{ fontSize: 40, marginBottom: 12 }}>📂</div>
            <p style={{ color: 'var(--ink-500)', fontSize: 15 }}>No hay archivos subidos todavía</p>
            <button onClick={() => fileRef.current?.click()} style={{ ...btn('primary'), marginTop: 8 }}>
              Subir primer archivo Excel
            </button>
          </div>
        )}

        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {importArchivos.map(a => {
            const pct = a.total_items > 0 ? Math.round((a.procesados / a.total_items) * 100) : 0;
            const completo = a.pendiente === 0;
            return (
              <div key={a.id} style={{ ...card, display: 'flex', gap: 16, alignItems: 'center' }}>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontWeight: 600, fontSize: 15, marginBottom: 4, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{a.nombre}</div>
                  <div style={{ fontSize: 12, color: 'var(--ink-400)', marginBottom: 8 }}>
                    {new Date(a.creado_en).toLocaleDateString('es-CL', { day:'2-digit', month:'short', year:'numeric' })}
                    {' · '}
                    <span style={{ color: 'var(--success)' }}>{a.aplicados} aplicados</span>
                    {' · '}
                    <span style={{ color: 'var(--ink-400)' }}>{a.saltados} saltados</span>
                    {' · '}
                    <span style={{ color: a.pendiente > 0 ? '#b07000' : 'var(--ink-400)' }}>{a.pendiente} pendientes</span>
                  </div>
                  <div style={{ height: 6, background: 'var(--paper-stripe)', borderRadius: 3, overflow: 'hidden' }}>
                    <div style={{ height: '100%', width: `${pct}%`, background: completo ? 'var(--success)' : 'var(--brand)', borderRadius: 3, transition: 'width 0.3s' }} />
                  </div>
                  <div style={{ fontSize: 11, color: 'var(--ink-400)', marginTop: 3 }}>{pct}% completado</div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 6, flexShrink: 0 }}>
                  {!completo && (
                    <button onClick={() => abrirArchivo(a)} style={{ ...btn('primary'), padding: '7px 16px', fontSize: 13 }}>
                      {a.procesados === 0 ? 'Comenzar' : 'Continuar'}
                    </button>
                  )}
                  {completo && (
                    <span style={{ fontSize: 13, color: 'var(--success)', fontWeight: 600, padding: '7px 0' }}>✓ Completo</span>
                  )}
                  <button onClick={() => eliminarArchivo(a.id)} style={{ ...btn('ghost'), padding: '5px 12px', fontSize: 12, color: 'var(--danger)', borderColor: 'var(--danger)' }}>
                    Eliminar
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  // ── RENDER: trabajando (libro por libro) ──────────────────────────────────
  if (importVista === 'trabajando' && importArchivo) {
    const procesados = importTotal - importPending;
    const pct = importTotal > 0 ? Math.round((procesados / importTotal) * 100) : 0;

    const updField = (campo, modo, valorCustom) => setImportItemDec(prev => ({
      ...prev, [campo]: { modo, valorCustom: valorCustom ?? (prev[campo]?.valorCustom || '') }
    }));

    const pill = (label, val, accent) => val ? (
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 3, fontSize: 11, padding: '2px 7px', borderRadius: 4, fontWeight: 500,
        background: accent ? 'var(--bg-accent, #e8f0fe)' : 'var(--paper-stripe)',
        color: accent ? '#185fa5' : 'var(--ink-500)',
        border: accent ? '0.5px solid #b5d4f4' : '0.5px solid var(--line)', whiteSpace: 'nowrap' }}>
        <span style={{ color: 'var(--ink-400)', fontWeight: 400 }}>{label}</span> {val}
      </span>
    ) : null;

    const renderItem = () => {
      if (!importItem) return (
        <div style={{ textAlign: 'center', paddingTop: 40 }}>
          {importGuardando
            ? <><div style={{ fontSize: 14, color: 'var(--ink-500)' }}>Procesando libros nuevos…</div></>
            : <><div style={{ fontSize: 40, marginBottom: 12 }}>✓</div>
               <h3 style={{ margin: '0 0 8px' }}>¡Archivo completado!</h3>
               <p style={{ color: 'var(--ink-500)', fontSize: 14 }}>Todos los libros fueron revisados</p></>
          }
        </div>
      );

      const { tipo, data } = importItem;

      if (tipo === 'dif') {
        return (
          <div>
            <div style={{ marginBottom: 12, padding: '10px 14px', background: 'var(--paper-stripe)', borderRadius: 10, border: '1px solid var(--line)' }}>
              <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--ink-400)', textTransform: 'uppercase', marginBottom: 5 }}>Excel</div>
              <div style={{ fontSize: 15, fontWeight: 600, marginBottom: 6 }}>{data.excel?.titulo}</div>
              <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                {pill('ISBN', data.isbn, true)}
                {pill('Autor', data.excel?.autor, false)}
                {pill('Ed.', data.excel?.editorial, false)}
              </div>
            </div>
            <div style={{ fontSize: 12, color: 'var(--ink-400)', marginBottom: 10 }}>
              ISBN coincide — {data.codigo_relea} — elegí qué valor conservar por campo:
            </div>
            {Object.entries(data.diff || {}).map(([campo, { sistema, excel }]) => {
              const dec = importItemDec[campo] || { modo: 'sistema', valorCustom: excel || '' };
              return (
                <div key={campo} style={{ marginBottom: 10 }}>
                  <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--ink-400)', textTransform: 'uppercase', marginBottom: 5 }}>{CAMPO[campo]}</div>
                  <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', alignItems: 'stretch' }}>
                    {[
                      { modo: 'sistema', label: 'Sistema', value: sistema, selBg: 'var(--paper-stripe)', selBorder: 'var(--ink-500)', selColor: 'var(--ink-700)' },
                      { modo: 'excel',   label: 'Excel',   value: excel,   selBg: '#e8f0fe',            selBorder: '#185fa5',         selColor: '#185fa5'       },
                    ].map(({ modo, label, value, selBg, selBorder, selColor }) => {
                      const sel = dec.modo === modo;
                      return (
                        <div key={modo} onClick={() => updField(campo, modo)} style={{
                          flex: 1, minWidth: 120, cursor: 'pointer', borderRadius: 8, padding: '7px 10px',
                          border: sel ? `2px solid ${selBorder}` : '1.5px solid var(--line)',
                          background: sel ? selBg : 'var(--paper)',
                        }}>
                          <div style={{ fontSize: 10, fontWeight: 700, color: sel ? selColor : 'var(--ink-400)', marginBottom: 3 }}>{label.toUpperCase()}</div>
                          <div style={{ fontSize: 13, color: sel ? selColor : 'var(--ink-600)' }}>
                            {value || <em style={{ color: 'var(--ink-300)', fontStyle: 'italic' }}>vacío</em>}
                          </div>
                        </div>
                      );
                    })}
                    {dec.modo === 'custom' ? (
                      <div style={{ flex: 2, minWidth: 160, borderRadius: 8, padding: '7px 10px', border: '2px solid var(--brand)', background: 'var(--paper)' }}>
                        <div style={{ fontSize: 10, fontWeight: 700, color: 'var(--brand)', marginBottom: 3 }}>EDITAR</div>
                        <input autoFocus value={dec.valorCustom} onChange={e => updField(campo, 'custom', e.target.value)}
                          style={{ border: 'none', background: 'transparent', width: '100%', fontSize: 13, outline: 'none', color: 'var(--ink-900)' }} />
                      </div>
                    ) : (
                      <button onClick={e => { e.stopPropagation(); updField(campo, 'custom', excel || sistema || ''); }}
                        style={{ ...btn('ghost'), fontSize: 12, padding: '4px 10px', whiteSpace: 'nowrap', display: 'flex', alignItems: 'center', gap: 4, alignSelf: 'center' }}>
                        <PencilLine size={12} /> Editar
                      </button>
                    )}
                  </div>
                </div>
              );
            })}
            {Object.keys(data.auto || {}).length > 0 && (
              <div style={{ marginTop: 8, padding: '7px 10px', borderRadius: 8, background: '#e6f9ed', fontSize: 12, color: '#1a6e3a', display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
                <span style={{ fontWeight: 600 }}>✓ Auto-relleno:</span>
                {Object.entries(data.auto).map(([c, v]) => <span key={c}>{CAMPO[c]}: <strong>"{v}"</strong></span>)}
              </div>
            )}
          </div>
        );
      }

      if (tipo === 'auto') {
        return (
          <div>
            <div style={{ marginBottom: 12, padding: '10px 14px', background: 'var(--paper-stripe)', borderRadius: 10, border: '1px solid var(--line)' }}>
              <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--ink-400)', textTransform: 'uppercase', marginBottom: 5 }}>Excel</div>
              <div style={{ fontSize: 15, fontWeight: 600, marginBottom: 6 }}>{data.excel?.titulo || data.titulo}</div>
              <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                {pill('ISBN', data.isbn, true)}
                {pill('Autor', data.excel?.autor || data.autor, false)}
                {pill('Ed.', data.excel?.editorial || data.editorial, false)}
              </div>
            </div>
            <div style={{ fontSize: 12, color: 'var(--ink-400)', marginBottom: 10 }}>
              ISBN coincide — {data.codigo_relea} — los siguientes campos estaban vacíos en el sistema:
            </div>
            <div style={{ padding: '10px 14px', background: '#e6f9ed', borderRadius: 10, border: '1px solid #b3e6c5' }}>
              {Object.entries(data.auto || {}).map(([c, v]) => (
                <div key={c} style={{ fontSize: 14, marginBottom: 4 }}>
                  <span style={{ fontWeight: 600, color: '#1a6e3a' }}>{CAMPO[c]}:</span> {v}
                </div>
              ))}
            </div>
          </div>
        );
      }

      if (tipo === 'titulo') {
        const selId = importItemDec.libro_id;
        return (
          <div>
            <div style={{ marginBottom: 12, padding: '10px 14px', background: 'var(--paper-stripe)', borderRadius: 10, border: '1px solid var(--line)' }}>
              <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--ink-400)', textTransform: 'uppercase', marginBottom: 5 }}>Excel</div>
              <div style={{ fontSize: 15, fontWeight: 600, marginBottom: 6 }}>{data.excel?.titulo}</div>
              <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                {pill('ISBN', data.excel?.isbn, true)}
                {pill('Autor', data.excel?.autor, false)}
                {pill('Ed.', data.excel?.editorial, false)}
              </div>
            </div>
            <div style={{ fontSize: 12, color: 'var(--ink-400)', marginBottom: 10 }}>Sin ISBN — coincidencia por título. ¿A qué libro corresponde?</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
              {(data.candidatos || []).map(c => {
                const sel = selId === c.libro_id;
                return (
                  <div key={c.libro_id} onClick={() => setImportItemDec({ libro_id: c.libro_id, actualizar_datos: false })}
                    style={{ display: 'grid', gridTemplateColumns: 'auto 1fr auto', gap: '8px 12px', padding: '10px 12px', borderRadius: 10, cursor: 'pointer',
                      border: sel ? '2px solid #185fa5' : '1.5px solid var(--line)', background: sel ? '#e8f0fe' : 'var(--paper)', alignItems: 'start' }}>
                    <input type="radio" checked={sel} readOnly style={{ marginTop: 3 }} />
                    <div>
                      <div style={{ fontSize: 13, fontWeight: 600, color: sel ? '#185fa5' : 'var(--ink-800)', marginBottom: 5 }}>{c.titulo_sistema}</div>
                      <div style={{ display: 'flex', gap: 5, flexWrap: 'wrap' }}>
                        {c.codigo_relea && <span style={{ fontFamily: 'monospace', fontSize: 11, padding: '1px 7px', borderRadius: 4, background: 'var(--paper-stripe)', border: '0.5px solid var(--line)', color: 'var(--ink-500)' }}>{c.codigo_relea}</span>}
                        {pill('ISBN', c.isbn_sistema, true)}
                        {pill('Autor', c.autor_sistema, false)}
                        {pill('Ed.', c.editorial_sistema, false)}
                      </div>
                    </div>
                    <span style={{ fontSize: 12, fontWeight: 700, color: scoreColor(c.score), whiteSpace: 'nowrap', paddingTop: 2 }}>{c.score}%</span>
                  </div>
                );
              })}
              <div onClick={() => setImportItemDec({ libro_id: null, actualizar_datos: false })}
                style={{ display: 'grid', gridTemplateColumns: 'auto 1fr', gap: '8px 12px', padding: '8px 12px', borderRadius: 10, cursor: 'pointer',
                  border: selId === null ? '2px solid var(--line)' : '1.5px solid var(--line)', background: selId === null ? 'var(--paper-stripe)' : 'var(--paper)', alignItems: 'center' }}>
                <input type="radio" checked={selId === null} readOnly />
                <span style={{ fontSize: 13, color: 'var(--ink-500)' }}>Crear como libro nuevo (código RELEA automático)</span>
              </div>
            </div>
          </div>
        );
      }

      if (tipo === 'nuevo') {
        return (
          <div style={{ padding: '16px 20px', background: 'var(--paper-stripe)', borderRadius: 12, border: '1px solid var(--line)' }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--ink-400)', textTransform: 'uppercase', marginBottom: 8 }}>Libro nuevo</div>
            <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 8 }}>{data.titulo}</div>
            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
              {pill('ISBN', data.isbn, true)}
              {pill('Autor', data.autor, false)}
              {pill('Ed.', data.editorial, false)}
            </div>
            <div style={{ marginTop: 10, fontSize: 13, color: 'var(--ink-500)' }}>Se creará con código RELEA automático</div>
          </div>
        );
      }
      return null;
    };

    const tipoLabel = {
      dif:    'Datos distintos (ISBN coincide)',
      auto:   'Campos vacíos a rellenar',
      titulo: 'Coincidencia por título',
      nuevo:  'Libro nuevo',
    }[importItem?.tipo] || '';

    return (
      <div style={{ fontFamily: 'var(--font-ui)', maxWidth: 680 }}>
        {/* Header */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 20 }}>
          <button onClick={volverLista} style={{ ...btn('ghost'), padding: '6px 14px', display: 'flex', alignItems: 'center', gap: 6 }}>
            <ArrowLeft size={14} /> Pausar y salir
          </button>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontWeight: 600, fontSize: 15, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{importArchivo.nombre}</div>
            <div style={{ fontSize: 12, color: 'var(--ink-400)' }}>{importTotal - importPending} de {importTotal} revisados</div>
          </div>
        </div>

        {/* Barra de progreso */}
        <div style={{ marginBottom: 20 }}>
          <div style={{ height: 6, background: 'var(--paper-stripe)', borderRadius: 3, overflow: 'hidden' }}>
            <div style={{ height: '100%', width: `${pct}%`, background: 'var(--brand)', borderRadius: 3, transition: 'width 0.3s' }} />
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 4, fontSize: 12, color: 'var(--ink-400)' }}>
            <span>{tipoLabel}</span>
            <span>{pct}%</span>
          </div>
        </div>

        {error && <div style={{ color: 'var(--danger)', marginBottom: 12, fontSize: 14 }}>{error}</div>}

        {/* Tarjeta del item */}
        <div style={{ ...card, marginBottom: 16 }}>{renderItem()}</div>

        {/* Botones de acción */}
        {importItem && (
          <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
            <button onClick={() => decidirItem('saltado')} disabled={importGuardando} style={{ ...btn('ghost'), padding: '9px 20px' }}>
              Saltar →
            </button>
            <button onClick={() => decidirItem('aplicado')} disabled={importGuardando} style={{ ...btn('primary'), padding: '9px 24px' }}>
              {importGuardando ? 'Guardando...' : importItem?.tipo === 'nuevo' ? 'Crear libro' : importItem?.tipo === 'auto' ? 'Aplicar auto-relleno' : 'Aplicar'}
            </button>
          </div>
        )}
        {!importItem && (
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <button onClick={volverLista} style={btn('primary')}>Ver archivos</button>
          </div>
        )}
      </div>
    );
  }
  // ── RENDER: tabla principal ───────────────────────────────────────────────
  return (
    <div style={{ fontFamily: 'var(--font-ui)' }}>
      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20, flexWrap: 'wrap', gap: 12 }}>
        <div>
          <h2 style={{ margin: 0, fontSize: 22 }}>Libros RELEA</h2>
          <span style={{ fontSize: 13, color: 'var(--ink-500)' }}>{total.toLocaleString()} libros en el catálogo central</span>
        </div>
        <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
          <div style={{ position: 'relative' }}>
            <Search size={14} style={{ position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)', color: 'var(--ink-400)' }} />
            <input
              value={busqueda}
              onChange={ev => buscar(ev.target.value)}
              placeholder="Buscar por título, ISBN, autor..."
              style={{ ...inp, width: 260, paddingLeft: 32 }}
            />
          </div>
          <button onClick={abrirLista} style={btn('default')}>
            <Upload size={14} style={{ marginRight: 6, verticalAlign: 'middle' }} />
            Importaciones
          </button>
          <button onClick={abrirNuevo} style={btn('primary')}>+ Nuevo libro</button>
        </div>
      </div>

      {/* Feedback global */}
      {mensaje && <div style={{ color: 'var(--success)', marginBottom: 12, fontSize: 14 }}>{mensaje}</div>}
      {error   && <div style={{ color: 'var(--danger)',  marginBottom: 12, fontSize: 14 }}>{error}</div>}

      {/* Tabla */}
      <div style={{ ...card, padding: 0, overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
          <thead>
            <tr style={{ borderBottom: '1.5px solid var(--line)' }}>
              {['Código RELEA', 'ISBN', 'Título', 'Autor', 'Editorial', ''].map(h => (
                <th key={h} style={{ textAlign: 'left', padding: '10px 16px', color: 'var(--ink-500)', fontWeight: 600, fontSize: 12, whiteSpace: 'nowrap' }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {cargando && (
              <tr><td colSpan={6} style={{ padding: '24px', textAlign: 'center', color: 'var(--ink-400)' }}>Cargando...</td></tr>
            )}
            {!cargando && libros.length === 0 && (
              <tr><td colSpan={6} style={{ padding: '24px', textAlign: 'center', color: 'var(--ink-400)' }}>
                {busqueda ? 'Sin resultados para esa búsqueda' : 'No hay libros aún. Importa un Excel o crea uno.'}
              </td></tr>
            )}
            {libros.map(l => (
              <tr key={l.id} style={{ borderBottom: '1px solid var(--line)' }}>
                <td style={{ padding: '10px 16px', whiteSpace: 'nowrap' }}>
                  <span style={{ fontFamily: 'monospace', fontSize: 12, background: 'var(--paper-stripe)', padding: '2px 8px', borderRadius: 6, color: 'var(--ink-600)' }}>
                    {l.codigo_relea || '—'}
                  </span>
                </td>
                <td style={{ padding: '10px 16px', color: 'var(--ink-500)', fontSize: 13 }}>{l.isbn || '—'}</td>
                <td style={{ padding: '10px 16px', fontWeight: 500, maxWidth: 300 }}>{l.titulo}</td>
                <td style={{ padding: '10px 16px', color: 'var(--ink-600)' }}>{l.autor || '—'}</td>
                <td style={{ padding: '10px 16px', color: 'var(--ink-600)' }}>{l.editorial || '—'}</td>
                <td style={{ padding: '10px 16px' }}>
                  <button onClick={() => abrirEditar(l)} style={{ ...btn('ghost'), padding: '5px 12px', fontSize: 13 }}>
                    <Pencil size={13} style={{ verticalAlign: 'middle', marginRight: 4 }} />Editar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Paginación */}
      {totalPags > 1 && (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 8, marginTop: 16 }}>
          <button onClick={() => irPagina(pagina - 1)} disabled={pagina === 1} style={{ ...btn('ghost'), padding: '6px 12px' }}>
            <ChevronLeft size={16} />
          </button>
          <span style={{ fontSize: 14, color: 'var(--ink-600)' }}>Página {pagina} de {totalPags}</span>
          <button onClick={() => irPagina(pagina + 1)} disabled={pagina === totalPags} style={{ ...btn('ghost'), padding: '6px 12px' }}>
            <ChevronRight size={16} />
          </button>
        </div>
      )}

      {/* Correcciones de libros */}
      {propuestas.filter(p => p.tipo === 'edicion').length > 0 && (
        <div style={{ marginTop: 32 }}>
          <h3 style={{ margin: '0 0 12px', fontSize: 16, display: 'flex', alignItems: 'center', gap: 8 }}>
            Correcciones de libros
            <span style={{ padding: '2px 9px', borderRadius: 10, fontSize: 12, fontWeight: 600, background: '#fcd34d', color: '#78350f' }}>
              {propuestas.filter(p => p.tipo === 'edicion').length}
            </span>
          </h3>
          <div style={{ ...card, padding: 0, overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
              <thead>
                <tr style={{ borderBottom: '1.5px solid var(--line)' }}>
                  {['Libro', 'Librería', 'Campos', ''].map(h => (
                    <th key={h} style={{ textAlign: 'left', padding: '10px 16px', color: 'var(--ink-500)', fontWeight: 600, fontSize: 12 }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {propuestas.filter(p => p.tipo === 'edicion').map(p => (
                  <tr key={p.id} style={{ borderBottom: '1px solid var(--line)' }}>
                    <td style={{ padding: '10px 16px', fontWeight: 500 }}>{p.titulo_sistema || '—'}</td>
                    <td style={{ padding: '10px 16px', color: 'var(--ink-500)', fontSize: 13 }}>{p.tenant_nombre}</td>
                    <td style={{ padding: '10px 16px', color: 'var(--ink-400)', fontSize: 12 }}>{Object.keys(p.campos || {}).join(', ')}</td>
                    <td style={{ padding: '10px 16px' }}>
                      <button onClick={() => abrirPropuesta(p)} style={{ ...btn('ghost'), padding: '5px 12px', fontSize: 13 }}>Revisar</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Libros nuevos propuestos */}
      {propuestas.filter(p => p.tipo === 'nuevo').length > 0 && (
        <div style={{ marginTop: 28 }}>
          <h3 style={{ margin: '0 0 12px', fontSize: 16, display: 'flex', alignItems: 'center', gap: 8 }}>
            Libros nuevos propuestos
            <span style={{ padding: '2px 9px', borderRadius: 10, fontSize: 12, fontWeight: 600, background: '#fcd34d', color: '#78350f' }}>
              {propuestas.filter(p => p.tipo === 'nuevo').length}
            </span>
          </h3>
          <div style={{ ...card, padding: 0, overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
              <thead>
                <tr style={{ borderBottom: '1.5px solid var(--line)' }}>
                  {['Título propuesto', 'ISBN', 'Librería', ''].map(h => (
                    <th key={h} style={{ textAlign: 'left', padding: '10px 16px', color: 'var(--ink-500)', fontWeight: 600, fontSize: 12 }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {propuestas.filter(p => p.tipo === 'nuevo').map(p => (
                  <tr key={p.id} style={{ borderBottom: '1px solid var(--line)' }}>
                    <td style={{ padding: '10px 16px', fontWeight: 500 }}>{p.campos?.titulo || '—'}</td>
                    <td style={{ padding: '10px 16px', color: 'var(--ink-500)', fontSize: 13 }}>{p.campos?.isbn || '—'}</td>
                    <td style={{ padding: '10px 16px', color: 'var(--ink-500)', fontSize: 13 }}>{p.tenant_nombre}</td>
                    <td style={{ padding: '10px 16px' }}>
                      <button onClick={() => abrirPropuesta(p)} style={{ ...btn('ghost'), padding: '5px 12px', fontSize: 13 }}>Revisar</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Modal revisar propuesta */}
      {propModal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: 200, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ background: 'var(--paper)', borderRadius: 18, padding: '28px 32px', width: 500, maxWidth: '90vw', boxShadow: '0 8px 32px rgba(0,0,0,0.2)', maxHeight: '90vh', overflowY: 'auto' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 18 }}>
              <h3 style={{ margin: 0, fontSize: 17 }}>
                {propModal.tipo === 'edicion' ? 'Corrección propuesta' : 'Libro nuevo propuesto'}
              </h3>
              <button onClick={() => setPropModal(null)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--ink-400)', fontSize: 22, lineHeight: 1 }}>×</button>
            </div>

            <div style={{ marginBottom: 16, fontSize: 13, color: 'var(--ink-500)' }}>
              Propuesto por <strong>{propModal.tenant_nombre}</strong>
              {propModal.tipo === 'edicion' && propModal.titulo_sistema && (
                <span> — libro: <em>{propModal.titulo_sistema}</em></span>
              )}
            </div>

            {propModal.tipo === 'edicion' && (
              <div style={{ marginBottom: 16, padding: '10px 14px', background: 'var(--paper-stripe)', borderRadius: 8 }}>
                <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em', color: 'var(--ink-400)', marginBottom: 6 }}>Datos actuales en RELEA</div>
                {Object.keys(propModal.campos || {}).map(campo => (
                  <div key={campo} style={{ fontSize: 13, marginBottom: 3 }}>
                    <span style={{ color: 'var(--ink-400)', textTransform: 'capitalize' }}>{campo}:</span>
                    <span style={{ marginLeft: 6, color: 'var(--ink-700)' }}>
                      {propModal[`${campo}_sistema`] || '—'}
                    </span>
                  </div>
                ))}
              </div>
            )}

            <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em', color: 'var(--ink-400)', marginBottom: 10 }}>
              {propModal.tipo === 'edicion' ? 'Valores propuestos (editables antes de aprobar)' : 'Datos del libro (editables antes de aprobar)'}
            </div>
            {Object.entries(propForm).map(([campo, valor]) => (
              <div key={campo} style={{ marginBottom: 12 }}>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 600, marginBottom: 4, color: 'var(--ink-700)', textTransform: 'capitalize' }}>{campo}</label>
                <input value={valor || ''} onChange={e => setPropForm(f => ({ ...f, [campo]: e.target.value }))} style={inp} />
              </div>
            ))}

            {propMsg && (
              <div style={{ marginBottom: 12, padding: '8px 12px', borderRadius: 6, fontSize: 13,
                background: 'var(--bad-bg)', border: '1px solid var(--bad-line)', color: 'var(--bad-ink)'
              }}>
                {propMsg.texto}
              </div>
            )}

            <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 18 }}>
              <button onClick={() => revisarPropuesta('rechazado')} disabled={propGuardando}
                style={{ ...btn('ghost'), padding: '9px 18px', color: 'var(--danger)', borderColor: 'var(--danger)' }}>
                Rechazar
              </button>
              <button onClick={() => revisarPropuesta('aprobado')} disabled={propGuardando} style={{ ...btn('primary'), padding: '9px 22px' }}>
                {propGuardando ? 'Guardando...' : 'Aprobar'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal nuevo/editar */}
      {modal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: 200, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ background: 'var(--paper)', borderRadius: 18, padding: '28px 32px', width: 520, maxWidth: '94vw', maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 8px 32px rgba(0,0,0,0.2)' }}>
            <h3 style={{ margin: '0 0 4px', fontSize: 18 }}>{modal.nuevo ? 'Nuevo libro' : 'Editar libro'}</h3>
            {!modal.nuevo && modal.libro.codigo_relea && (
              <div style={{ marginBottom: 14, fontSize: 13, color: 'var(--ink-500)' }}>
                Código RELEA: <span style={{ fontFamily: 'monospace', fontWeight: 600, color: 'var(--ink-700)' }}>{modal.libro.codigo_relea}</span>
              </div>
            )}

            {/* Tabs — solo al editar */}
            {!modal.nuevo && (
              <div style={{ display: 'flex', gap: 0, marginBottom: 20, borderBottom: '2px solid var(--line)' }}>
                {['datos', 'historial'].map(t => (
                  <button key={t} onClick={() => setHistTab(t)} style={{
                    padding: '7px 18px', border: 'none', background: 'transparent', cursor: 'pointer',
                    fontSize: 13, fontWeight: 600, fontFamily: 'var(--font-ui)',
                    color: histTab === t ? 'var(--brand)' : 'var(--ink-500)',
                    borderBottom: histTab === t ? '2px solid var(--brand)' : '2px solid transparent',
                    marginBottom: -2,
                  }}>
                    {t === 'datos' ? 'Datos' : 'Historial'}
                  </button>
                ))}
              </div>
            )}

            {/* Tab datos */}
            {(modal.nuevo || histTab === 'datos') && (
              <form onSubmit={guardar}>
                {[
                  { key: 'isbn',      label: 'ISBN (opcional)' },
                  { key: 'titulo',    label: 'Título *' },
                  { key: 'autor',     label: 'Autor' },
                  { key: 'editorial', label: 'Editorial' },
                  { key: 'categoria', label: 'Categoría' },
                ].map(({ key, label }) => (
                  <div key={key} style={{ marginBottom: 14 }}>
                    <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 4, color: 'var(--ink-700)' }}>{label}</label>
                    <input
                      value={form[key]}
                      onChange={ev => setForm(f => ({ ...f, [key]: ev.target.value }))}
                      required={key === 'titulo'}
                      style={inp}
                    />
                  </div>
                ))}
                {error && <div style={{ color: 'var(--danger)', fontSize: 13, marginBottom: 12 }}>{error}</div>}
                <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 8 }}>
                  <button type="button" onClick={cerrarModal} style={btn('ghost')}>Cancelar</button>
                  <button type="submit" disabled={guardando} style={btn('primary')}>{guardando ? 'Guardando...' : 'Guardar'}</button>
                </div>
              </form>
            )}

            {/* Tab historial */}
            {!modal.nuevo && histTab === 'historial' && (
              <div>
                {historial.length === 0 ? (
                  <p style={{ color: 'var(--ink-400)', fontSize: 13, fontStyle: 'italic' }}>Sin cambios registrados todavía.</p>
                ) : (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
                    {historial.map((h, i) => {
                      const CAMPOS_ES = { titulo: 'Título', autor: 'Autor', editorial: 'Editorial', isbn: 'ISBN', categoria: 'Categoría', codigo_relea: 'Código RELEA', libro_creado: 'Libro creado' };
                      const campoLabel = CAMPOS_ES[h.campo] || h.campo;
                      const fecha = new Date(h.creado_en);
                      const fechaStr = fecha.toLocaleDateString('es-CL', { day: '2-digit', month: 'short', year: 'numeric' }) + ' · ' + fecha.toLocaleTimeString('es-CL', { hour: '2-digit', minute: '2-digit' });
                      const fuenteLabel = h.fuente === 'importacion' ? '📥 Catálogo' : h.fuente === 'edicion_manual' ? '✏️ RELEA' : h.fuente === 'propuesta' ? '📨 Propuesta' : h.fuente;
                      return (
                        <div key={i} style={{ display: 'flex', gap: 12, padding: '12px 0', borderBottom: i < historial.length - 1 ? '1px solid var(--line-soft)' : 'none' }}>
                          <div style={{ width: 6, minWidth: 6, borderRadius: 3, background: h.fuente === 'edicion_manual' ? 'var(--brand)' : h.fuente === 'propuesta' ? '#7c3aed' : '#0ea5e9', marginTop: 3, alignSelf: 'stretch' }} />
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 3, flexWrap: 'wrap' }}>
                              <span style={{ fontWeight: 600, fontSize: 13, color: 'var(--ink-900)' }}>{campoLabel}</span>
                              <span style={{ fontSize: 11, color: 'var(--ink-400)', background: 'var(--paper-stripe)', borderRadius: 5, padding: '1px 7px' }}>{fuenteLabel}</span>
                              {h.fuente_desc && h.fuente_desc !== 'RELEA' && <span style={{ fontSize: 11, color: 'var(--ink-400)' }}>{h.fuente_desc}</span>}
                            </div>
                            {h.campo === 'libro_creado' ? (
                              <span style={{ fontSize: 13, color: 'var(--ink-600)' }}>Libro creado: <em>{h.valor_nuevo}</em></span>
                            ) : (
                              <div style={{ fontSize: 13, color: 'var(--ink-600)', display: 'flex', gap: 6, alignItems: 'center', flexWrap: 'wrap' }}>
                                {h.valor_antes ? <span style={{ textDecoration: 'line-through', color: 'var(--ink-400)', maxWidth: 180, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{h.valor_antes}</span> : <span style={{ color: 'var(--ink-300)', fontSize: 12 }}>vacío</span>}
                                <span style={{ color: 'var(--ink-300)' }}>→</span>
                                {h.valor_nuevo ? <span style={{ maxWidth: 180, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{h.valor_nuevo}</span> : <span style={{ color: 'var(--ink-300)', fontSize: 12 }}>vacío</span>}
                              </div>
                            )}
                            <div style={{ fontSize: 11, color: 'var(--ink-300)', marginTop: 4 }}>{fechaStr}</div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 20 }}>
                  <button onClick={cerrarModal} style={btn('ghost')}>Cerrar</button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

// =============================================================================
// SALUD DEL NEGOCIO — componentes de módulo
// =============================================================================

// -----------------------------------------------------------------------------
// BloqueContenedor — wrapper de drag (PC) o botones ▲▼ (móvil) para cada bloque
// -----------------------------------------------------------------------------
function BloqueContenedor({ titulo, children, headerExtra }) {
  return (
    <div style={{
      border:       '1px solid var(--line)',
      borderRadius: 20,
      marginBottom: '1.5rem',
      background:   'var(--paper)',
      boxShadow:    'var(--shadow-card)',
      overflow:     'hidden',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', padding: '14px 20px', borderBottom: '1px solid var(--line-soft)', gap: 10 }}>
        <h3 style={{ margin: 0, fontFamily: 'var(--font-display)', fontSize: 15, fontWeight: 700, color: 'var(--ink-900)', flex: 1, letterSpacing: '-0.01em' }}>{titulo}</h3>
        {headerExtra}
      </div>
      <div style={{ padding: '16px 20px' }}>{children}</div>
    </div>
  );
}

// -----------------------------------------------------------------------------
// BloqueAlertas — Sección 1: lo que el sistema detectó
// -----------------------------------------------------------------------------
// Pastel tones for alert icon circles — keyed by alert category
const ALERT_TONE = {
  rose:  { bg: 'var(--past-rose)',  ink: 'var(--past-rose-ink)' },
  olive: { bg: 'var(--past-olive)', ink: 'var(--past-olive-ink)' },
  peach: { bg: 'var(--past-peach)', ink: 'var(--past-peach-ink)' },
  blue:  { bg: 'var(--past-blue)',  ink: 'var(--past-blue-ink)' },
};

function BloqueAlertas({ alertas, setPagina }) {
  const [librosExpand, setLibrosExpand] = useState(false);

  if (!alertas) return <p style={{ color: 'var(--ink-400)', fontSize: 13 }}>Cargando…</p>;

  const { facturas_vencidas, libros_sin_venta, pedidos_borrador, consignaciones_sin_reportar } = alertas;

  const items = [
    ...facturas_vencidas.map(a => ({ key: `fv-${a.distribuidor_id}`,   Icon: CreditCard,   tone: 'rose',  mensaje: a.mensaje, modulo: a.modulo })),
    ...(libros_sin_venta ? [{
      key: 'lsv', Icon: BookOpen, tone: 'olive',
      mensaje: libros_sin_venta.mensaje, modulo: libros_sin_venta.modulo, extra: libros_sin_venta,
    }] : []),
    ...pedidos_borrador.map(a =>           ({ key: `pb-${a.pedido_id}`,        Icon: Package,      tone: 'peach', mensaje: a.mensaje, modulo: a.modulo })),
    ...consignaciones_sin_reportar.map(a => ({ key: `csr-${a.distribuidor_id}`, Icon: ClipboardList, tone: 'blue',  mensaje: a.mensaje, modulo: a.modulo })),
  ];

  if (items.length === 0) {
    return (
      <p style={{ color: 'var(--ink-400)', fontSize: 13, margin: '4px 0', fontStyle: 'italic' }}>
        Todo en orden por ahora. ✓
      </p>
    );
  }

  return (
    <div style={{ background: 'var(--paper)', border: '1px solid var(--line)', borderRadius: 16, overflow: 'hidden' }}>
      {items.map((item, i) => {
        const tone = ALERT_TONE[item.tone] || ALERT_TONE.blue;
        return (
          <div key={item.key}>
            <button
              onClick={() => setPagina(item.modulo)}
              style={{
                width: '100%', textAlign: 'left', background: 'transparent', border: 'none',
                borderBottom: i < items.length - 1 ? '1px solid var(--line-soft)' : 'none',
                padding: '14px 18px', cursor: 'pointer',
                display: 'flex', alignItems: 'center', gap: 14,
                transition: `background var(--t-fast)`,
                fontFamily: 'inherit',
              }}
              onMouseEnter={e => e.currentTarget.style.background = 'var(--brand-softer)'}
              onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
            >
              <span style={{
                width: 40, height: 40, borderRadius: '50%',
                background: tone.bg, color: tone.ink,
                display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                flexShrink: 0,
              }}>
                <item.Icon size={18} strokeWidth={1.75} />
              </span>
              <span style={{ flex: 1, minWidth: 0, fontSize: 14, color: 'var(--ink-700)', lineHeight: 'var(--lh-normal)' }}>{item.mensaje}</span>
              <ChevronRight size={16} strokeWidth={1.75} color="var(--ink-400)" style={{ flexShrink: 0 }} />
            </button>
            {/* Expansión de top libros sin movimiento */}
            {item.extra && (
              <div style={{ paddingLeft: 72, paddingRight: 18, paddingBottom: 10 }}>
                <button onClick={() => setLibrosExpand(p => !p)} style={{ background: 'none', border: 'none', color: 'var(--ink-500)', cursor: 'pointer', fontSize: 12, padding: '4px 0', fontFamily: 'inherit' }}>
                  {librosExpand ? '▲ Ocultar detalle' : `▼ Ver top ${item.extra.top_libros.length} títulos`}
                </button>
                {librosExpand && (
                  <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12, marginTop: 6 }}>
                    <thead>
                      <tr style={{ textAlign: 'left', borderBottom: '1px solid var(--line)', color: 'var(--ink-500)' }}>
                        <th style={{ padding: '4px 6px', fontWeight: 500 }}>Título</th>
                        <th style={{ padding: '4px 6px', textAlign: 'right', fontWeight: 500 }}>Stock</th>
                        <th style={{ padding: '4px 6px', textAlign: 'right', fontWeight: 500 }}>Inmovilizado</th>
                      </tr>
                    </thead>
                    <tbody>
                      {item.extra.top_libros.map(l => (
                        <tr key={l.libro_id} style={{ borderBottom: '1px solid var(--line-soft)' }}>
                          <td style={{ padding: '4px 6px', color: 'var(--ink-700)' }}>{l.titulo}{l.autor ? <span style={{ color: 'var(--ink-400)' }}> — {l.autor}</span> : ''}</td>
                          <td style={{ padding: '4px 6px', textAlign: 'right', fontFamily: 'var(--font-mono)', color: 'var(--ink-600)' }}>{l.stock_total}</td>
                          <td style={{ padding: '4px 6px', textAlign: 'right', fontFamily: 'var(--font-mono)', color: 'var(--ink-600)' }}>${Number(l.dinero_inmovilizado).toLocaleString('es-CL', { maximumFractionDigits: 0 })}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

// -----------------------------------------------------------------------------
// FormTarea — formulario de creación/edición de tarea (inline)
// -----------------------------------------------------------------------------
const PRIORIDADES = ['Alta', 'Media', 'Baja'];
const ESTADOS     = ['Pendiente', 'En proceso', 'Completada'];
const PRIO_STYLE  = {
  Alta:  { bg: 'var(--bad-bg)',  ink: 'var(--bad-ink)' },
  Media: { bg: 'var(--warn-bg)', ink: 'var(--warn-ink)' },
  Baja:  { bg: 'var(--ok-bg)',   ink: 'var(--ok-ink)' },
};

function FormTarea({ tarea, categorias, onGuardar, onCancelar, onCrearCategoria }) {
  const esNueva = !tarea.id;
  const [form, setForm] = useState({
    titulo:      tarea.titulo      || '',
    descripcion: tarea.descripcion || '',
    categoria:   tarea.categoria   || (categorias[0]?.nombre || ''),
    prioridad:   tarea.prioridad   || 'Media',
    fecha_limite: tarea.fecha_limite ? tarea.fecha_limite.split('T')[0] : '',
    estado:      tarea.estado      || 'Pendiente',
  });
  const [nuevaCat,   setNuevaCat]   = useState('');
  const [agregandoCat, setAgregandoCat] = useState(false);
  const [guardando,  setGuardando]  = useState(false);

  async function handleGuardar(e) {
    e.preventDefault();
    if (!form.titulo.trim()) return;
    setGuardando(true);
    await onGuardar({ ...tarea, ...form });
    setGuardando(false);
  }

  async function handleCrearCat() {
    if (!nuevaCat.trim()) return;
    const cat = await onCrearCategoria(nuevaCat.trim());
    if (cat) {
      setForm(f => ({ ...f, categoria: cat.nombre }));
      setNuevaCat('');
      setAgregandoCat(false);
    }
  }

  const inp = { padding: '0.4rem 0.6rem', border: '1px solid #ccc', borderRadius: '5px', fontSize: '0.88rem', width: '100%', boxSizing: 'border-box' };

  return (
    <form onSubmit={handleGuardar} style={{ background: '#f9f9f9', border: '1px solid #e0e0e0', borderRadius: '8px', padding: '1rem', marginBottom: '0.75rem' }}>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.6rem', marginBottom: '0.6rem' }}>
        <div style={{ gridColumn: '1 / -1' }}>
          <input required value={form.titulo} onChange={e => setForm(f => ({ ...f, titulo: e.target.value }))} placeholder="Título de la tarea *" style={inp} />
        </div>
        <div style={{ gridColumn: '1 / -1' }}>
          <textarea value={form.descripcion} onChange={e => setForm(f => ({ ...f, descripcion: e.target.value }))} placeholder="Descripción opcional" rows={2} style={{ ...inp, resize: 'vertical' }} />
        </div>
        {/* Categoría */}
        <div>
          {!agregandoCat ? (
            <div style={{ display: 'flex', gap: '0.35rem' }}>
              <select value={form.categoria} onChange={e => setForm(f => ({ ...f, categoria: e.target.value }))} style={{ ...inp, flex: 1 }}>
                {categorias.map(c => <option key={c.id} value={c.nombre}>{c.nombre}</option>)}
              </select>
              <button type="button" onClick={() => setAgregandoCat(true)} title="Nueva categoría" style={{ padding: '0.4rem 0.6rem', border: '1px solid #ccc', borderRadius: '5px', background: 'none', cursor: 'pointer', color: '#666', fontSize: '0.85rem', flexShrink: 0 }}>+</button>
            </div>
          ) : (
            <div style={{ display: 'flex', gap: '0.35rem' }}>
              <input value={nuevaCat} onChange={e => setNuevaCat(e.target.value)} placeholder="Nueva categoría" style={{ ...inp, flex: 1 }} onKeyDown={e => e.key === 'Enter' && (e.preventDefault(), handleCrearCat())} />
              <button type="button" onClick={handleCrearCat} style={{ padding: '0.4rem 0.6rem', border: '1px solid #90caf9', borderRadius: '5px', background: '#e3f2fd', cursor: 'pointer', color: '#1565c0', fontSize: '0.85rem', flexShrink: 0 }}>✓</button>
              <button type="button" onClick={() => setAgregandoCat(false)} style={{ padding: '0.4rem 0.5rem', border: '1px solid #ccc', borderRadius: '5px', background: 'none', cursor: 'pointer', color: '#888', flexShrink: 0 }}>✕</button>
            </div>
          )}
        </div>
        {/* Prioridad */}
        <select value={form.prioridad} onChange={e => setForm(f => ({ ...f, prioridad: e.target.value }))} style={inp}>
          {PRIORIDADES.map(p => <option key={p} value={p}>{p}</option>)}
        </select>
        {/* Fecha límite */}
        <div>
          <input type="date" value={form.fecha_limite} onChange={e => setForm(f => ({ ...f, fecha_limite: e.target.value }))} style={inp} />
        </div>
        {/* Estado (solo al editar) */}
        {!esNueva && (
          <select value={form.estado} onChange={e => setForm(f => ({ ...f, estado: e.target.value }))} style={inp}>
            {ESTADOS.map(s => <option key={s} value={s}>{s}</option>)}
          </select>
        )}
      </div>
      <div style={{ display: 'flex', gap: '0.5rem' }}>
        <button type="submit" disabled={guardando || !form.titulo.trim()} style={{ padding: '0.45rem 1.1rem', background: '#2c2c2a', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer', fontWeight: 600, fontSize: '0.87rem' }}>
          {guardando ? 'Guardando…' : esNueva ? 'Crear tarea' : 'Guardar cambios'}
        </button>
        <button type="button" onClick={onCancelar} style={{ padding: '0.45rem 0.9rem', background: 'none', border: '1px solid #ccc', borderRadius: '5px', cursor: 'pointer', fontSize: '0.87rem' }}>Cancelar</button>
      </div>
    </form>
  );
}

// -----------------------------------------------------------------------------
// FilaTarea — una tarea en la lista (con edición inline)
// -----------------------------------------------------------------------------
function FilaTarea({ tarea, categorias, onGuardar, onEliminar, onCrearCategoria }) {
  const [editando, setEditando] = useState(false);

  const ahora       = new Date();
  const limite      = tarea.fecha_limite ? new Date(tarea.fecha_limite + 'T23:59:59') : null;
  const horas48     = 48 * 60 * 60 * 1000;
  const proximas48  = limite && limite > ahora && (limite - ahora) <= horas48;
  const vencida     = limite && limite < ahora && tarea.estado !== 'Completada';

  const siguienteEstado = { 'Pendiente': 'En proceso', 'En proceso': 'Completada', 'Completada': 'Pendiente' };

  if (editando) {
    return <FormTarea tarea={tarea} categorias={categorias} onCrearCategoria={onCrearCategoria} onGuardar={async t => { await onGuardar(t); setEditando(false); }} onCancelar={() => setEditando(false)} />;
  }

  const ps = PRIO_STYLE[tarea.prioridad] || PRIO_STYLE.Media;
  return (
    <div style={{
      border:       `1px solid ${vencida ? 'var(--bad-line)' : proximas48 ? 'var(--warn-line)' : 'var(--line)'}`,
      background:   vencida ? 'var(--bad-bg)' : proximas48 ? 'var(--warn-bg)' : 'var(--paper)',
      borderRadius: 12, padding: '12px 14px',
      display: 'flex', gap: '0.75rem', alignItems: 'flex-start',
      marginBottom: '0.5rem',
      transition: `border-color var(--t-fast)`,
    }}>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ display: 'flex', gap: '0.4rem', flexWrap: 'wrap', alignItems: 'center', marginBottom: '0.3rem' }}>
          <span style={{ fontSize: 11, fontWeight: 600, background: ps.bg, color: ps.ink, padding: '2px 7px', borderRadius: 'var(--r-pill)' }}>{tarea.prioridad}</span>
          <span style={{ fontSize: 11, color: 'var(--ink-500)', background: 'var(--paper-soft)', padding: '2px 7px', borderRadius: 'var(--r-pill)' }}>{tarea.categoria}</span>
          {tarea.fecha_limite && (
            <span style={{ fontSize: 11, color: vencida ? 'var(--bad-ink)' : proximas48 ? 'var(--warn-ink)' : 'var(--ink-500)' }}>
              {vencida ? '⚠ ' : proximas48 ? '⏰ ' : ''}{new Date(tarea.fecha_limite + 'T12:00:00').toLocaleDateString('es-CL', { day: 'numeric', month: 'short' })}
            </span>
          )}
        </div>
        <div style={{ fontWeight: 600, fontSize: 14, color: 'var(--ink-900)', marginBottom: tarea.descripcion ? '0.2rem' : 0 }}>{tarea.titulo}</div>
        {tarea.descripcion && <div style={{ fontSize: 12, color: 'var(--ink-500)', marginTop: '0.15rem' }}>{tarea.descripcion}</div>}
      </div>
      <div style={{ display: 'flex', gap: '0.3rem', flexShrink: 0, alignItems: 'center' }}>
        <button onClick={() => onGuardar({ ...tarea, estado: siguienteEstado[tarea.estado] })} title={`Avanzar a "${siguienteEstado[tarea.estado]}"`}
          style={{ fontSize: 12, padding: '4px 10px', border: '1px solid var(--line)', borderRadius: 'var(--r-pill)', background: 'var(--paper-soft)', cursor: 'pointer', whiteSpace: 'nowrap', color: 'var(--ink-700)', fontFamily: 'inherit', display: 'inline-flex', alignItems: 'center', gap: 4 }}>
          {tarea.estado === 'En proceso' ? <><Check size={11} strokeWidth={2} /> Completar</> : tarea.estado === 'Completada' ? 'Reabrir' : 'Iniciar'}
        </button>
        <button onClick={() => setEditando(true)} title="Editar"
          style={{ padding: '5px', border: '1px solid var(--line)', borderRadius: 8, background: 'none', cursor: 'pointer', color: 'var(--ink-500)', display: 'inline-flex', alignItems: 'center' }}>
          <Pencil size={13} strokeWidth={1.75} />
        </button>
        <button onClick={() => onEliminar(tarea.id)} title="Eliminar"
          style={{ padding: '5px', border: '1px solid var(--bad-line)', borderRadius: 8, background: 'none', cursor: 'pointer', color: 'var(--bad-ink)', display: 'inline-flex', alignItems: 'center' }}>
          <X size={13} strokeWidth={1.75} />
        </button>
      </div>
    </div>
  );
}

// -----------------------------------------------------------------------------
// BloqueTareas — Sección 2: tareas manuales del librero
// -----------------------------------------------------------------------------
function BloqueTareas({ tareas, categorias, onGuardar, onEliminar, onCrearCategoria, setTareas, formAbierto, setFormAbierto }) {
  const [verCompletadas, setVerCompletadas] = useState(false);

  const pendientes  = tareas.filter(t => t.estado !== 'Completada');
  const completadas = tareas.filter(t => t.estado === 'Completada');

  async function handleGuardar(tarea) {
    try {
      if (tarea.id) {
        const res = await api.patch(`/tareas/${tarea.id}`, tarea);
        setTareas(prev => prev.map(t => t.id === tarea.id ? res.data : t));
      } else {
        const res = await api.post('/tareas', tarea);
        setTareas(prev => [...prev, res.data].sort(ordenTareas));
        setFormAbierto(false);
      }
    } catch (e) { alert(e.response?.data?.error || e.message); }
  }

  async function handleEliminar(id) {
    if (!window.confirm('¿Eliminar esta tarea?')) return;
    try {
      await api.delete(`/tareas/${id}`);
      setTareas(prev => prev.filter(t => t.id !== id));
    } catch (e) { alert(e.response?.data?.error || e.message); }
  }

  return (
    <div>
      {formAbierto && (
        <FormTarea tarea={{}} categorias={categorias} onCrearCategoria={onCrearCategoria} onGuardar={handleGuardar} onCancelar={() => setFormAbierto(false)} />
      )}

      {pendientes.length === 0 && !formAbierto && (
        <p style={{ color: 'var(--ink-400)', fontSize: 13, margin: '4px 0 12px', fontStyle: 'italic' }}>Sin tareas pendientes. ¡Buen momento para agregar una!</p>
      )}

      {pendientes.map(t => (
        <FilaTarea key={t.id} tarea={t} categorias={categorias} onGuardar={handleGuardar} onEliminar={handleEliminar} onCrearCategoria={onCrearCategoria} />
      ))}

      {completadas.length > 0 && (
        <div style={{ marginTop: '0.5rem' }}>
          <button onClick={() => setVerCompletadas(p => !p)} style={{ background: 'none', border: 'none', color: 'var(--ink-400)', cursor: 'pointer', fontSize: 12, padding: '4px 0', fontFamily: 'inherit' }}>
            {verCompletadas ? '▲ Ocultar completadas' : `▼ Ver completadas (${completadas.length})`}
          </button>
          {verCompletadas && completadas.map(t => (
            <FilaTarea key={t.id} tarea={t} categorias={categorias} onGuardar={handleGuardar} onEliminar={handleEliminar} onCrearCategoria={onCrearCategoria} />
          ))}
        </div>
      )}
    </div>
  );
}

// -----------------------------------------------------------------------------
// BloqueFinanciero — Sección 3: estado financiero con distribuidores
// (solo se renderiza cuando hay facturas impagas)
// -----------------------------------------------------------------------------
function BloqueFinanciero({ datos, alertas }) {
  const fmtCLP = n => `$${Number(n).toLocaleString('es-CL', { maximumFractionDigits: 0 })}`;

  if (!datos || datos.length === 0) {
    return (
      <p style={{ color: 'var(--ink-400)', fontSize: 13, margin: '4px 0', fontStyle: 'italic' }}>
        Sin facturas impagas con distribuidores. ✓
      </p>
    );
  }

  // Totales derivados de datos existentes — sin nuevas llamadas al backend
  const totalPorPagar = datos.reduce((s, d) => s + Number(d.total_adeudado), 0);
  const totalVencido  = (alertas?.facturas_vencidas || []).reduce((s, a) => s + Number(a.total_pendiente), 0);
  const totalConsigna = (alertas?.consignaciones_sin_reportar || []).reduce((s, a) => s + Number(a.total_pendiente), 0);

  const resumen = [
    { label: 'Por pagar',       value: fmtCLP(totalPorPagar), desc: `${datos.length} distribuidor${datos.length !== 1 ? 'es' : ''}`,       bg: 'var(--past-peach)', ink: 'var(--past-peach-ink)' },
    { label: 'Vencido (>15d)',  value: fmtCLP(totalVencido),  desc: `${alertas?.facturas_vencidas?.length || 0} factura${(alertas?.facturas_vencidas?.length || 0) !== 1 ? 's' : ''}`, bg: 'var(--bad-bg)', ink: 'var(--bad-ink)' },
    { label: 'Consigna pdte.',  value: fmtCLP(totalConsigna), desc: `${alertas?.consignaciones_sin_reportar?.length || 0} distribuidor${(alertas?.consignaciones_sin_reportar?.length || 0) !== 1 ? 'es' : ''}`, bg: 'var(--past-olive)', ink: 'var(--past-olive-ink)' },
  ];

  return (
    <div>
      {/* Totales resumen */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 10, marginBottom: 18 }}>
        {resumen.map(r => (
          <div key={r.label} style={{ background: r.bg, borderRadius: 14, padding: '14px 16px' }}>
            <div style={{ fontSize: 11, fontWeight: 600, color: r.ink, textTransform: 'uppercase', letterSpacing: '0.07em', fontFamily: 'var(--font-ui)', marginBottom: 6 }}>{r.label}</div>
            <div style={{ fontFamily: 'var(--font-display)', fontSize: 22, fontWeight: 700, color: r.ink, lineHeight: 1, letterSpacing: '-0.02em' }}>{r.value}</div>
            <div style={{ fontSize: 11, color: r.ink, opacity: 0.7, marginTop: 4, fontFamily: 'var(--font-ui)' }}>{r.desc}</div>
          </div>
        ))}
      </div>

      {/* Tabla de distribuidores */}
      <div style={{ border: '1px solid var(--line)', borderRadius: 12, overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead>
            <tr style={{ textAlign: 'left', borderBottom: '1px solid var(--line)', background: 'var(--paper-stripe)', color: 'var(--ink-500)' }}>
              <th style={{ padding: '8px 14px', fontWeight: 500, fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.06em' }}>Distribuidor</th>
              <th style={{ padding: '8px 14px', textAlign: 'right', fontWeight: 500, fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.06em' }}>Facturas</th>
              <th style={{ padding: '8px 14px', textAlign: 'right', fontWeight: 500, fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.06em' }}>Total adeudado</th>
              <th style={{ padding: '8px 14px', textAlign: 'right', fontWeight: 500, fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.06em' }}>Pendiente desde</th>
            </tr>
          </thead>
          <tbody>
            {datos.map(d => (
              <tr key={d.distribuidor_id} style={{ borderBottom: '1px solid var(--line-soft)' }}>
                <td style={{ padding: '10px 14px', fontWeight: 600, color: 'var(--ink-900)' }}>{d.distribuidor_nombre}</td>
                <td style={{ padding: '10px 14px', textAlign: 'right', fontFamily: 'var(--font-mono)', color: 'var(--ink-600)', fontSize: 12 }}>{d.cantidad_facturas}</td>
                <td style={{ padding: '10px 14px', textAlign: 'right', fontFamily: 'var(--font-mono)', fontWeight: 600, color: 'var(--ink-800)', fontSize: 12 }}>{fmtCLP(d.total_adeudado)}</td>
                <td style={{ padding: '10px 14px', textAlign: 'right', fontFamily: 'var(--font-mono)', fontSize: 12, color: d.dias_mas_antigua > 30 ? 'var(--bad-ink)' : 'var(--ink-500)' }}>
                  hace {d.dias_mas_antigua === 1 ? 'un día' : `${d.dias_mas_antigua} días`}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

// -----------------------------------------------------------------------------
// Helpers de ordenación para tareas
// -----------------------------------------------------------------------------
function ordenTareas(a, b) {
  const pri = { Alta: 1, Media: 2, Baja: 3 };
  if (pri[a.prioridad] !== pri[b.prioridad]) return pri[a.prioridad] - pri[b.prioridad];
  if (a.fecha_limite && b.fecha_limite) return a.fecha_limite.localeCompare(b.fecha_limite);
  if (a.fecha_limite) return -1;
  if (b.fecha_limite) return 1;
  return new Date(a.creado_en) - new Date(b.creado_en);
}

// =============================================================================
// MiniCalendario — calendario mensual con dots de facturas impagas
// =============================================================================
function MiniCalendario({ dots }) {
  const hoy   = new Date();
  const year  = hoy.getFullYear();
  const month = hoy.getMonth();
  const DIAS  = ['Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá', 'Do'];
  const MESES = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];

  const primerDow = new Date(year, month, 1).getDay();
  const offsetLun = (primerDow + 6) % 7;
  const diasEnMes = new Date(year, month + 1, 0).getDate();

  const celdas = [];
  for (let i = 0; i < offsetLun; i++) celdas.push(null);
  for (let d = 1; d <= diasEnMes; d++) celdas.push(d);
  while (celdas.length % 7 !== 0) celdas.push(null);

  const pad    = n => String(n).padStart(2, '0');
  const hoyStr = `${year}-${pad(month + 1)}-${pad(hoy.getDate())}`;

  return (
    <div style={{ border: '1px solid var(--line)', borderRadius: 16, overflow: 'hidden' }}>
      <div style={{ padding: '14px 18px', borderBottom: '1px solid var(--line)', background: 'var(--paper-stripe)' }}>
        <span style={{ fontSize: 13, fontWeight: 700, color: 'var(--ink-700)', fontFamily: 'var(--font-ui)' }}>
          {MESES[month]} {year}
        </span>
      </div>
      <div style={{ padding: '10px 12px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', marginBottom: 2 }}>
          {DIAS.map(d => (
            <div key={d} style={{ textAlign: 'center', fontSize: 10, fontWeight: 600, color: 'var(--ink-400)', fontFamily: 'var(--font-ui)', padding: '2px 0' }}>{d}</div>
          ))}
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: '1px' }}>
          {celdas.map((day, idx) => {
            if (!day) return <div key={idx} />;
            const dateStr = `${year}-${pad(month + 1)}-${pad(day)}`;
            const dot     = dots?.[dateStr];
            const esHoy   = dateStr === hoyStr;
            return (
              <div key={idx} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '2px 0' }}>
                <div style={{ width: 24, height: 24, borderRadius: '50%', background: esHoy ? 'var(--brand)' : 'transparent', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <span style={{ fontSize: 11, fontFamily: 'var(--font-ui)', color: esHoy ? '#fff' : 'var(--ink-700)', fontWeight: esHoy ? 700 : 400 }}>{day}</span>
                </div>
                {dot && <div style={{ width: 4, height: 4, borderRadius: '50%', background: dot === 'red' ? 'var(--brand)' : dot === 'orange' ? '#B06000' : '#c9a800', marginTop: 1 }} />}
              </div>
            );
          })}
        </div>
        <div style={{ display: 'flex', gap: 10, marginTop: 8, justifyContent: 'flex-end' }}>
          {[['var(--brand)', 'Vencida'], ['#B06000', 'Próxima'], ['#c9a800', 'Por vencer']].map(([c, l]) => (
            <div key={l} style={{ display: 'flex', alignItems: 'center', gap: 3, fontSize: 10, color: 'var(--ink-400)', fontFamily: 'var(--font-ui)' }}>
              <div style={{ width: 5, height: 5, borderRadius: '50%', background: c }} /> {l}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

// =============================================================================
// SaludNegocio — pantalla principal (reemplaza Dashboard)
// =============================================================================
function SaludNegocio({ setPagina, usuario, onLibroSeleccionado, onGrupoSeleccionado }) {
  const [datos,             setDatos]             = useState(null);
  const [datosKpi,          setDatosKpi]          = useState(null);
  const [tareas,            setTareas]            = useState([]);
  const [categorias,        setCategorias]        = useState([]);
  const [tareasFormAbierto, setTareasFormAbierto] = useState(false);
  const [impagas,           setImpagas]           = useState(null);
  const [consignPend,       setConsignPend]       = useState([]);
  const [reposicion,        setReposicion]        = useState([]);
  const [cargando,          setCargando]          = useState(true);
  const esMobile = useMobile();

  useEffect(() => { cargarTodo(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  async function cargarTodo() {
    setCargando(true);
    try {
      const [saludRes, tareasRes, catRes, kpiRes, impagasRes, consignRes, repoRes] = await Promise.all([
        api.get('/salud-negocio'),
        api.get('/tareas'),
        api.get('/categorias-tarea'),
        api.get('/dashboard'),
        api.get('/documentos/impagas').catch(() => ({ data: { total_general: 0, distribuidores: [] } })),
        api.get('/consignacion/pendientes').catch(() => ({ data: [] })),
        api.get('/reposicion').catch(() => ({ data: [] })),
      ]);
      setDatos(saludRes.data);
      setTareas(tareasRes.data);
      setCategorias(catRes.data);
      setDatosKpi(kpiRes.data);
      setImpagas(impagasRes.data);
      setConsignPend(consignRes.data);
      setReposicion(repoRes.data);
    } catch (e) { console.error('Error cargando Inicio:', e.message); }
    setCargando(false);
  }

  async function crearCategoria(nombre) {
    try {
      const res = await api.post('/categorias-tarea', { nombre });
      setCategorias(prev => [...prev, res.data]);
      return res.data;
    } catch (e) { alert(e.response?.data?.error || e.message); return null; }
  }

  if (cargando) return <p style={{ color: 'var(--ink-400)', padding: '1rem 0', fontFamily: 'var(--font-ui)' }}>Cargando…</p>;

  // ── KPIs ─────────────────────────────────────────────────────────────────
  const kpiVentasHoy = Number(datosKpi?.ventasHoy?.total   || 0);
  const kpiTickets   = Number(datosKpi?.ventasHoy?.cantidad || 0);
  const kpiPorPagar  = (datos?.estado_financiero || []).reduce((s, d) => s + Number(d.total_adeudado), 0);
  const kpiStockCrit = datos?.alertas?.libros_sin_venta?.total_libros || 0;

  // ── Consignación → top 3 por distribuidor ────────────────────────────────
  const consigPorDist = {};
  (consignPend || []).forEach(r => {
    if (!consigPorDist[r.distribuidor_id]) {
      consigPorDist[r.distribuidor_id] = { nombre: r.distribuidor, libros: 0, monto: 0 };
    }
    consigPorDist[r.distribuidor_id].libros += 1;
    consigPorDist[r.distribuidor_id].monto  += Number(r.total);
  });
  const consigTop3 = Object.values(consigPorDist).sort((a, b) => b.monto - a.monto).slice(0, 3);

  // ── Dots para calendario: due = fecha factura + 30 días ──────────────────
  const hoyD = new Date(); hoyD.setHours(0, 0, 0, 0);
  const facturasDots = {};
  (impagas?.distribuidores || []).forEach(dist => {
    (dist.facturas || []).forEach(fac => {
      if (!fac.fecha) return;
      const dueDate  = new Date(new Date(String(fac.fecha).slice(0, 10) + 'T12:00:00').getTime() + 30 * 864e5);
      const dueStr   = dueDate.toISOString().slice(0, 10);
      const diasRest = Math.floor((dueDate - hoyD) / 864e5);
      const col      = diasRest < 0 ? 'red' : diasRest < 7 ? 'orange' : 'yellow';
      const rank     = { red: 3, orange: 2, yellow: 1 };
      if (!facturasDots[dueStr] || rank[col] > rank[facturasDots[dueStr]]) facturasDots[dueStr] = col;
    });
  });

  // ── Reposición ───────────────────────────────────────────────────────────
  const repoTotal = reposicion.length;
  const repoTop4  = reposicion.slice(0, 4);

  // ── Alertas feed (ordenado por urgencia) ─────────────────────────────────
  const ALERTA_META = {
    factura: { label: 'Factura pendiente',    bg: '#fff5f2', color: '#C4522A' },
    consig:  { label: 'Consig. sin reportar', bg: '#fff8e1', color: '#8B5E00' },
    pedido:  { label: 'Pedido en borrador',   bg: '#eef1fa', color: '#3a52a8' },
    stock:   { label: 'Stock sin movimiento', bg: '#f0f7f0', color: '#3a6e4a' },
  };
  const alertasFeed = [
    ...(datos?.alertas?.facturas_vencidas           || []).map(a => ({ ...a, _tipo: 'factura', _urgencia: 3 })),
    ...(datos?.alertas?.consignaciones_sin_reportar || []).map(a => ({ ...a, _tipo: 'consig',  _urgencia: 2 })),
    ...(datos?.alertas?.pedidos_borrador            || []).map(a => ({ ...a, _tipo: 'pedido',  _urgencia: 1 })),
    ...(datos?.alertas?.libros_sin_venta ? [{ ...datos.alertas.libros_sin_venta, _tipo: 'stock', _urgencia: 0 }] : []),
  ].sort((a, b) => b._urgencia - a._urgencia);

  return (
    <div style={{ background: 'var(--canvas)', minHeight: '100%', padding: 'var(--content-inset)' }}>
      <div style={{ background: 'var(--paper)', borderRadius: 20, padding: 24, boxShadow: 'var(--shadow-card)' }}>

        {/* Cabecera */}
        <div style={{ marginBottom: '1.5rem' }}>
          <h2 style={{ margin: 0, fontFamily: 'var(--font-display)', fontSize: 32, fontWeight: 700, letterSpacing: 'var(--tracking-tight)', color: 'var(--ink-900)', lineHeight: 'var(--lh-tight)' }}>
            Hola, <span style={{ color: 'var(--brand)' }}>{usuario || 'Librero'}</span>.
          </h2>
          <span style={{ fontFamily: 'var(--font-ui)', fontSize: 14, color: 'var(--ink-500)', marginTop: 4, display: 'block' }}>
            {new Date().toLocaleDateString('es-CL', { weekday: 'long', day: 'numeric', month: 'long' })}
          </span>
        </div>

        {/* KPIs */}
        <div style={{ display: 'grid', gridTemplateColumns: esMobile ? 'repeat(2,1fr)' : 'repeat(4,1fr)', gap: 12, marginBottom: '1.75rem' }}>
          {[
            { label: 'Ventas hoy',        value: `$${kpiVentasHoy.toLocaleString('es-CL', { maximumFractionDigits: 0 })}`, sub: kpiTickets === 1 ? '1 venta registrada' : `${kpiTickets} ventas registradas`, Icon: TrendingUp, accented: true },
            { label: 'Tickets hoy',       value: String(kpiTickets), sub: 'transacciones realizadas', Icon: ScanLine,     bg: 'var(--past-blue)',  ink: 'var(--past-blue-ink)' },
            { label: 'Por pagar distrib.',value: `$${kpiPorPagar.toLocaleString('es-CL', { maximumFractionDigits: 0 })}`,  sub: `${(datos?.estado_financiero || []).length} distribuidor${(datos?.estado_financiero || []).length !== 1 ? 'es' : ''}`, Icon: CreditCard, bg: kpiPorPagar > 0 ? 'var(--bad-bg)' : 'var(--past-peach)', ink: kpiPorPagar > 0 ? 'var(--bad-ink)' : 'var(--past-peach-ink)' },
            { label: 'Sin movimiento',    value: String(kpiStockCrit), sub: kpiStockCrit > 0 ? 'títulos en firme sin venta' : 'todo en movimiento', Icon: AlertTriangle, bg: kpiStockCrit > 0 ? 'var(--warn-bg)' : 'var(--past-olive)', ink: kpiStockCrit > 0 ? 'var(--warn-ink)' : 'var(--past-olive-ink)' },
          ].map(kpi => (
            <div key={kpi.label} style={{ background: kpi.accented ? 'var(--brand)' : 'var(--paper)', border: kpi.accented ? 'none' : '1px solid var(--line)', borderRadius: 16, padding: '16px 18px', display: 'flex', flexDirection: 'column', gap: 6 }}>
              <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 8 }}>
                <span style={{ fontSize: 11, color: kpi.accented ? 'rgba(255,255,255,0.8)' : 'var(--ink-500)', fontFamily: 'var(--font-ui)', fontWeight: 500, lineHeight: 1.3 }}>{kpi.label}</span>
                <span style={{ width: 32, height: 32, borderRadius: '50%', background: kpi.accented ? 'rgba(255,255,255,0.25)' : kpi.bg, color: kpi.accented ? '#fff' : kpi.ink, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  <kpi.Icon size={14} strokeWidth={1.75} />
                </span>
              </div>
              <div style={{ fontFamily: 'var(--font-display)', fontSize: 26, fontWeight: 700, color: kpi.accented ? '#fff' : 'var(--ink-900)', lineHeight: 1, letterSpacing: '-0.02em' }}>{kpi.value}</div>
              <div style={{ fontSize: 11, color: kpi.accented ? 'rgba(255,255,255,0.7)' : 'var(--ink-400)', fontFamily: 'var(--font-ui)' }}>{kpi.sub}</div>
            </div>
          ))}
        </div>

        {/* 3 columnas */}
        <div style={{ display: 'grid', gridTemplateColumns: esMobile ? '1fr' : '1fr 1fr 1fr', gap: '1.25rem', alignItems: 'start' }}>

          {/* Col 1 — Lo que ha pasado */}
          <div style={{ border: '1px solid var(--line)', borderRadius: 16, overflow: 'hidden' }}>
            <div style={{ padding: '14px 18px', borderBottom: '1px solid var(--line)', background: 'var(--paper-stripe)', display: 'flex', alignItems: 'center', gap: 8 }}>
              <span style={{ fontSize: 13, fontWeight: 700, color: 'var(--ink-700)', fontFamily: 'var(--font-ui)' }}>Lo que ha pasado</span>
              {alertasFeed.length > 0 && (
                <span style={{ background: 'var(--brand)', color: '#fff', borderRadius: 20, padding: '1px 8px', fontSize: 11, fontWeight: 700 }}>{alertasFeed.length}</span>
              )}
            </div>
            <div style={{ padding: 12, display: 'flex', flexDirection: 'column', gap: 8, maxHeight: 500, overflowY: 'auto' }}>
              {alertasFeed.length === 0 ? (
                <p style={{ margin: 0, fontSize: 13, color: 'var(--ink-400)', fontFamily: 'var(--font-ui)', textAlign: 'center', padding: '28px 0' }}>
                  Todo en orden. Sin alertas activas.
                </p>
              ) : alertasFeed.map((a, i) => {
                const meta = ALERTA_META[a._tipo] || ALERTA_META.stock;
                return (
                  <div key={i} style={{ background: meta.bg, border: `1px solid ${meta.color}28`, borderRadius: 10, padding: '9px 12px' }}>
                    <div style={{ fontSize: 10, fontWeight: 700, color: meta.color, fontFamily: 'var(--font-ui)', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 3 }}>{meta.label}</div>
                    <div style={{ fontSize: 12, color: 'var(--ink-700)', fontFamily: 'var(--font-ui)', lineHeight: 1.5 }}>{a.mensaje}</div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Col 2 — Consignación + Facturas impagas */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>

            {/* Consignación top 3 */}
            <div style={{ border: '1px solid var(--line)', borderRadius: 16, overflow: 'hidden' }}>
              <div style={{ padding: '14px 18px', borderBottom: '1px solid var(--line)', background: 'var(--paper-stripe)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <span style={{ fontSize: 13, fontWeight: 700, color: 'var(--ink-700)', fontFamily: 'var(--font-ui)' }}>Consignación pendiente</span>
                <button onClick={() => setPagina('consignacion')} style={{ fontSize: 11, color: 'var(--brand)', background: 'none', border: 'none', cursor: 'pointer', fontFamily: 'var(--font-ui)', fontWeight: 600 }}>Ver todo →</button>
              </div>
              {consigTop3.length === 0 ? (
                <p style={{ margin: 0, padding: '20px 18px', fontSize: 12, color: 'var(--ink-400)', fontFamily: 'var(--font-ui)' }}>Sin ventas en consignación pendientes.</p>
              ) : (
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr>
                      {['Distribuidor', 'Libros', 'Monto'].map((h, hi) => (
                        <th key={h} style={{ padding: '7px 14px', fontSize: 10, fontWeight: 600, color: 'var(--ink-400)', fontFamily: 'var(--font-ui)', textAlign: hi === 2 ? 'right' : 'left', textTransform: 'uppercase', letterSpacing: '0.05em', borderBottom: '1px solid var(--line)', background: 'var(--paper-stripe)' }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {consigTop3.map((row, ri) => (
                      <tr key={ri} style={{ borderBottom: ri < consigTop3.length - 1 ? '1px solid var(--line-soft)' : 'none' }}>
                        <td style={{ padding: '9px 14px', fontSize: 12, color: 'var(--ink-800)', fontFamily: 'var(--font-ui)', fontWeight: 500 }}>{row.nombre}</td>
                        <td style={{ padding: '9px 14px', fontSize: 12, color: 'var(--ink-500)', fontFamily: 'var(--font-ui)', textAlign: 'center' }}>{row.libros}</td>
                        <td style={{ padding: '9px 14px', fontSize: 12, color: 'var(--ink-800)', fontFamily: 'var(--font-ui)', textAlign: 'right', fontWeight: 600 }}>${row.monto.toLocaleString('es-CL', { maximumFractionDigits: 0 })}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>

            {/* Facturas impagas */}
            <div style={{ border: '1px solid var(--line)', borderRadius: 16, overflow: 'hidden' }}>
              <div style={{ padding: '14px 18px', borderBottom: '1px solid var(--line)', background: 'var(--paper-stripe)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <span style={{ fontSize: 13, fontWeight: 700, color: 'var(--ink-700)', fontFamily: 'var(--font-ui)' }}>Facturas impagas</span>
                {(impagas?.total_general || 0) > 0 && (
                  <span style={{ fontSize: 11, color: 'var(--ink-500)', fontFamily: 'var(--font-ui)', fontWeight: 600 }}>
                    ${Number(impagas.total_general).toLocaleString('es-CL', { maximumFractionDigits: 0 })}
                  </span>
                )}
              </div>
              <div style={{ maxHeight: 200, overflowY: 'auto' }}>
                {(impagas?.distribuidores || []).length === 0 ? (
                  <p style={{ margin: 0, padding: '20px 18px', fontSize: 12, color: 'var(--ink-400)', fontFamily: 'var(--font-ui)' }}>Sin facturas pendientes.</p>
                ) : (impagas?.distribuidores || []).map((dist, di) => {
                  const efDist    = (datos?.estado_financiero || []).find(e => e.distribuidor_id === dist.distribuidor_id);
                  const diasViejo = Number(efDist?.dias_mas_antigua || 0);
                  const dotBg     = diasViejo > 30 ? 'var(--brand)' : diasViejo > 15 ? '#B06000' : 'var(--ink-300)';
                  return (
                    <div key={di} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '9px 14px', borderBottom: di < (impagas?.distribuidores || []).length - 1 ? '1px solid var(--line-soft)' : 'none' }}>
                      <span style={{ width: 7, height: 7, borderRadius: '50%', background: dotBg, flexShrink: 0 }} />
                      <span style={{ flex: 1, fontSize: 12, color: 'var(--ink-700)', fontFamily: 'var(--font-ui)' }}>{dist.distribuidor_nombre}</span>
                      <span style={{ fontSize: 12, color: 'var(--ink-800)', fontFamily: 'var(--font-ui)', fontWeight: 600 }}>${Number(dist.total).toLocaleString('es-CL', { maximumFractionDigits: 0 })}</span>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          {/* Col 3 — Calendario + Tareas + Reposición */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>

            <MiniCalendario dots={facturasDots} />

            {/* Tareas */}
            <div style={{ border: '1px solid var(--line)', borderRadius: 16, overflow: 'hidden' }}>
              <div style={{ padding: '14px 18px', borderBottom: '1px solid var(--line)', background: 'var(--paper-stripe)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <span style={{ fontSize: 13, fontWeight: 700, color: 'var(--ink-700)', fontFamily: 'var(--font-ui)' }}>Mis tareas</span>
                {!tareasFormAbierto && (
                  <button onClick={() => setTareasFormAbierto(true)} style={{ display: 'inline-flex', alignItems: 'center', gap: 5, padding: '4px 10px', background: 'var(--ink-900)', color: '#fff', border: 'none', borderRadius: 'var(--r-pill)', cursor: 'pointer', fontSize: 11, fontWeight: 600, fontFamily: 'var(--font-ui)' }}>
                    <Plus size={11} strokeWidth={2.5} /> Nueva
                  </button>
                )}
              </div>
              <div style={{ padding: '12px 16px', maxHeight: 260, overflowY: 'auto' }}>
                <BloqueTareas
                  tareas={tareas}
                  categorias={categorias}
                  onGuardar={() => {}}
                  onEliminar={() => {}}
                  onCrearCategoria={crearCategoria}
                  setTareas={setTareas}
                  formAbierto={tareasFormAbierto}
                  setFormAbierto={setTareasFormAbierto}
                />
              </div>
            </div>

            {/* Reposición */}
            {repoTotal > 0 && (
              <div style={{ border: '1px solid var(--line)', borderRadius: 16, overflow: 'hidden' }}>
                <div style={{ padding: '14px 18px', borderBottom: '1px solid var(--line)', background: 'var(--paper-stripe)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <span style={{ fontSize: 13, fontWeight: 700, color: 'var(--ink-700)', fontFamily: 'var(--font-ui)' }}>Reposición pendiente</span>
                  <button onClick={() => setPagina('reposicion')} style={{ fontSize: 11, color: 'var(--brand)', background: 'none', border: 'none', cursor: 'pointer', fontFamily: 'var(--font-ui)', fontWeight: 600 }}>Ver todo →</button>
                </div>
                <div style={{ padding: '12px 14px' }}>
                  <div style={{ display: 'flex', alignItems: 'baseline', gap: 8, marginBottom: 10 }}>
                    <span style={{ fontFamily: 'var(--font-display)', fontSize: 36, fontWeight: 700, color: 'var(--brand)', lineHeight: 1 }}>{repoTotal}</span>
                    <span style={{ fontSize: 12, color: 'var(--ink-500)', fontFamily: 'var(--font-ui)' }}>título{repoTotal !== 1 ? 's' : ''} por reponer</span>
                  </div>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 5 }}>
                    {repoTop4.map(r => (
                      <div key={r.id} style={{ background: 'var(--canvas)', borderRadius: 8, padding: '6px 9px' }}>
                        <div style={{ fontSize: 11, fontWeight: 600, color: 'var(--ink-800)', fontFamily: 'var(--font-ui)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', lineHeight: 1.3 }}>{r.titulo}</div>
                        <div style={{ fontSize: 10, color: 'var(--ink-400)', fontFamily: 'var(--font-ui)', marginTop: 2 }}>Stock: {r.stock_actual}</div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}

          </div>
        </div>
      </div>
    </div>
  );
}

function Libros() {
  const [libros, setLibros] = useState([]);
  const [librosDesactivados, setLibrosDesactivados] = useState([]);
  const [form, setForm] = useState({ isbn: '', titulo: '', autor: '', editorial: '' });
  const [cargando, setCargando] = useState(false);
  const [editando, setEditando] = useState(null);
  const [importPreview, setImportPreview] = useState(null);
  const [importando, setImportando] = useState(false);
  const [importResult, setImportResult] = useState(null);
  const [importProgress, setImportProgress] = useState(null);
  const [busqueda, setBusqueda] = useState('');

  useEffect(() => { cargarLibros(); }, []);

  async function cargarLibros() {
    try {
      const [activos, desactivados] = await Promise.all([
        api.get('/libros'),
        api.get('/libros/desactivados')
      ]);
      setLibros(activos.data);
      setLibrosDesactivados(desactivados.data);
    } catch (e) { console.error('cargarLibros:', e.message); }
  }

  async function agregarLibro(e) {
    e.preventDefault();
    setCargando(true);
    await api.post('/libros', form);
    setForm({ isbn: '', titulo: '', autor: '', editorial: '' });
    await cargarLibros();
    setCargando(false);
  }

  function iniciarEdicion(libro) {
    setEditando({ id: libro.id, isbn: libro.isbn || '', titulo: libro.titulo, autor: libro.autor || '', editorial: libro.editorial || '' });
  }

  async function guardarEdicion() {
    await api.patch(`/libros/${editando.id}`, editando);
    setEditando(null);
    await cargarLibros();
  }

  async function desactivarLibro(libro) {
    if (!window.confirm(`¿Desactivar "${libro.titulo}"? Dejará de aparecer en el sistema.`)) return;
    await api.patch(`/libros/${libro.id}/desactivar`);
    await cargarLibros();
  }

  async function reactivarLibro(libro) {
    await api.patch(`/libros/${libro.id}/reactivar`);
    await cargarLibros();
  }

  async function subirPreviewImport(e) {
    const file = e.target.files[0];
    if (!file) return;
    e.target.value = '';
    setImportResult(null);
    setImportPreview(null);
    setImportando(true);
    try {
      const formData = new FormData();
      formData.append('archivo', file);
      const token = localStorage.getItem('relea_token');
      const res = await fetch(`${api.defaults.baseURL}/libros/importar/preview`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Error al procesar el archivo');
      setImportPreview(data);
    } catch (err) {
      alert(err.message);
    }
    setImportando(false);
  }

  async function confirmarImport() {
    if (!importPreview?.archivo) return;
    setImportando(true);
    setImportProgress({ fase: 'Iniciando...', progreso: 0 });
    try {
      const token = localStorage.getItem('relea_token');
      const response = await fetch(`${api.defaults.baseURL}/libros/importar/confirmar`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ archivo: importPreview.archivo }),
      });
      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let buf = '';
      while (true) {
        const { value, done } = await reader.read();
        if (done) break;
        buf += decoder.decode(value, { stream: true });
        const lines = buf.split('\n');
        buf = lines.pop();
        for (const line of lines) {
          if (!line.startsWith('data: ')) continue;
          const data = JSON.parse(line.slice(6));
          if (data.error) { alert('Error: ' + data.error); break; }
          if (data.done) {
            setImportResult(data);
            setImportPreview(null);
            setImportProgress(null);
            // No recargamos todos los libros para no congelar el browser con catálogos grandes.
            // El usuario puede buscar cualquier libro importado usando el buscador.
          } else {
            setImportProgress(data);
          }
        }
      }
    } catch (err) {
      alert(err.message);
    }
    setImportando(false);
  }

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1.5rem' }}>
        <h2 style={{ margin: 0 }}>Libros</h2>
        <label style={{ padding: '0.4rem 0.9rem', background: '#1a6b3c', color: 'white', borderRadius: '4px', cursor: importando ? 'not-allowed' : 'pointer', fontSize: '0.9rem', opacity: importando ? 0.7 : 1 }}>
          {importando ? 'Procesando...' : 'Importar Excel'}
          <input type="file" accept=".xlsx,.xls" onChange={subirPreviewImport} disabled={importando} style={{ display: 'none' }} />
        </label>
      </div>

      {importResult && (
        <div style={{ background: '#eafaf1', border: '1px solid #27ae60', borderRadius: '8px', padding: '1rem', marginBottom: '1.5rem' }}>
          <strong style={{ color: '#1a6b3c' }}>Importación completada</strong>
          <span style={{ marginLeft: '1rem', color: '#444' }}>
            {importResult.creados} libro{importResult.creados !== 1 ? 's' : ''} creado{importResult.creados !== 1 ? 's' : ''} · {importResult.actualizados} actualizado{importResult.actualizados !== 1 ? 's' : ''} · {importResult.total} total
          </span>
          <button onClick={() => setImportResult(null)} style={{ marginLeft: '1rem', background: 'none', border: 'none', cursor: 'pointer', color: '#888', fontSize: '1rem' }}>×</button>
        </div>
      )}

      {importProgress && (
        <div style={{ background: '#f0f4ff', border: '1px solid #4a90d9', borderRadius: '8px', padding: '1rem', marginBottom: '1.5rem' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.4rem', fontSize: '0.9rem' }}>
            <span>{importProgress.fase}</span>
            <span style={{ color: '#4a90d9', fontWeight: 'bold' }}>{importProgress.progreso}%</span>
          </div>
          <div style={{ background: '#dce8f8', borderRadius: '4px', height: '8px', overflow: 'hidden' }}>
            <div style={{ background: '#4a90d9', height: '100%', width: `${importProgress.progreso}%`, transition: 'width 0.3s ease' }} />
          </div>
        </div>
      )}

      {importPreview && (
        <div style={{ background: '#f9f9f9', border: '1px solid #ddd', borderRadius: '8px', padding: '1rem', marginBottom: '1.5rem' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.75rem' }}>
            <strong>Preview de importación — {importPreview.total} libros detectados</strong>
            <button onClick={() => setImportPreview(null)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#888', fontSize: '1rem' }}>×</button>
          </div>
          <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '1rem', fontSize: '0.88rem' }}>
            <thead>
              <tr style={{ textAlign: 'left', borderBottom: '2px solid #ccc' }}>
                <th style={{ padding: '0.35rem' }}>ISBN</th>
                <th style={{ padding: '0.35rem' }}>Título</th>
                <th style={{ padding: '0.35rem' }}>Costo</th>
                <th style={{ padding: '0.35rem' }}>PVP</th>
                <th style={{ padding: '0.35rem' }}>Stock</th>
              </tr>
            </thead>
            <tbody>
              {importPreview.preview.map((r, i) => (
                <tr key={i} style={{ borderBottom: '1px solid #eee' }}>
                  <td style={{ padding: '0.35rem', color: '#666' }}>{r.isbn || '—'}</td>
                  <td style={{ padding: '0.35rem' }}>{r.titulo}</td>
                  <td style={{ padding: '0.35rem', color: '#666' }}>{r.costo != null ? `$${r.costo.toLocaleString('es-CL')}` : '—'}</td>
                  <td style={{ padding: '0.35rem', color: '#666' }}>{r.pvp != null ? `$${r.pvp.toLocaleString('es-CL')}` : '—'}</td>
                  <td style={{ padding: '0.35rem', color: '#666' }}>{r.stock || 0}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {importPreview.total > 10 && <p style={{ fontSize: '0.85rem', color: '#888', margin: '0 0 0.75rem' }}>...y {importPreview.total - 10} más</p>}
          <div style={{ display: 'flex', gap: '0.75rem' }}>
            <button onClick={confirmarImport} disabled={importando} style={{ padding: '0.5rem 1.2rem', background: '#2c2c2a', color: 'white', border: 'none', cursor: 'pointer', borderRadius: '4px' }}>
              {importando ? 'Importando...' : `Confirmar importación (${importPreview.total} libros)`}
            </button>
            <button onClick={() => setImportPreview(null)} style={{ padding: '0.5rem 1rem', background: 'none', border: '1px solid #ccc', cursor: 'pointer', borderRadius: '4px' }}>Cancelar</button>
          </div>
        </div>
      )}

      <form onSubmit={agregarLibro} style={{ marginBottom: '2rem' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', maxWidth: '400px' }}>
          <input placeholder="ISBN" value={form.isbn} onChange={e => setForm({ ...form, isbn: e.target.value })} style={{ padding: '0.5rem' }} />
          <input placeholder="Título *" value={form.titulo} onChange={e => setForm({ ...form, titulo: e.target.value })} required style={{ padding: '0.5rem' }} />
          <input placeholder="Autor" value={form.autor} onChange={e => setForm({ ...form, autor: e.target.value })} style={{ padding: '0.5rem' }} />
          <input placeholder="Editorial" value={form.editorial} onChange={e => setForm({ ...form, editorial: e.target.value })} style={{ padding: '0.5rem' }} />
          <button type="submit" disabled={cargando} style={{ padding: '0.5rem', background: '#2c2c2a', color: 'white', border: 'none', cursor: 'pointer' }}>
            {cargando ? 'Guardando...' : 'Agregar libro'}
          </button>
        </div>
      </form>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '1rem' }}>
        <h3 style={{ margin: 0 }}>Registrados ({libros.length})</h3>
        <input
          placeholder="Buscar por título, ISBN o autor..."
          value={busqueda}
          onChange={e => setBusqueda(e.target.value)}
          style={{ padding: '0.4rem 0.75rem', border: '1px solid #ccc', borderRadius: '4px', fontSize: '0.9rem', width: '280px' }}
        />
      </div>
      {(() => {
        const MAX = 100;
        const q = busqueda.trim().toLowerCase();
        const filtrados = q
          ? libros.filter(l => l.titulo?.toLowerCase().includes(q) || l.isbn?.includes(q) || l.autor?.toLowerCase().includes(q))
          : libros.slice(0, MAX);
        const hayMas = !q && libros.length > MAX;
        return (<>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr style={{ textAlign: 'left', borderBottom: '2px solid #ccc' }}>
            <th style={{ padding: '0.5rem' }}>ISBN</th>
            <th style={{ padding: '0.5rem' }}>Título</th>
            <th style={{ padding: '0.5rem' }}>Autor</th>
            <th style={{ padding: '0.5rem' }}>Editorial</th>
            <th style={{ padding: '0.5rem' }}></th>
          </tr>
        </thead>
        <tbody>
          {filtrados.map(libro => {
            const enEdicion = editando?.id === libro.id;
            return (
              <tr key={libro.id} style={{ borderBottom: '1px solid #eee' }}>
                <td style={{ padding: '0.5rem' }}>
                  {enEdicion ? <input value={editando.isbn} onChange={e => setEditando({ ...editando, isbn: e.target.value })} style={{ padding: '0.25rem', width: '90px' }} /> : (libro.isbn || '—')}
                </td>
                <td style={{ padding: '0.5rem' }}>
                  {enEdicion ? <input value={editando.titulo} onChange={e => setEditando({ ...editando, titulo: e.target.value })} required style={{ padding: '0.25rem', width: '180px' }} /> : libro.titulo}
                </td>
                <td style={{ padding: '0.5rem' }}>
                  {enEdicion ? <input value={editando.autor} onChange={e => setEditando({ ...editando, autor: e.target.value })} style={{ padding: '0.25rem', width: '140px' }} /> : (libro.autor || '—')}
                </td>
                <td style={{ padding: '0.5rem' }}>
                  {enEdicion ? <input value={editando.editorial} onChange={e => setEditando({ ...editando, editorial: e.target.value })} style={{ padding: '0.25rem', width: '120px' }} /> : (libro.editorial || '—')}
                </td>
                <td style={{ padding: '0.5rem', whiteSpace: 'nowrap', display: 'flex', gap: '0.4rem' }}>
                  {enEdicion ? (
                    <>
                      <button onClick={guardarEdicion} style={{ background: '#2c2c2a', color: 'white', border: 'none', padding: '0.2rem 0.6rem', cursor: 'pointer', borderRadius: '4px', fontSize: '0.85rem' }}>Guardar</button>
                      <button onClick={() => setEditando(null)} style={{ background: 'none', border: '1px solid #aaa', padding: '0.2rem 0.6rem', cursor: 'pointer', borderRadius: '4px', fontSize: '0.85rem' }}>Cancelar</button>
                    </>
                  ) : (
                    <>
                      <button onClick={() => iniciarEdicion(libro)} style={{ background: 'none', border: '1px solid #aaa', padding: '0.2rem 0.5rem', cursor: 'pointer', borderRadius: '4px', fontSize: '0.85rem' }}>Editar</button>
                      <button onClick={() => desactivarLibro(libro)} style={{ background: 'none', border: '1px solid #d9534f', color: '#d9534f', padding: '0.2rem 0.5rem', cursor: 'pointer', borderRadius: '4px', fontSize: '0.85rem' }}>Desactivar</button>
                    </>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      {hayMas && <p style={{ color: '#888', fontSize: '0.85rem', marginTop: '0.5rem' }}>Mostrando los primeros {MAX} de {libros.length} libros. Usá el buscador para encontrar cualquier título.</p>}
        </>);
      })()}

      {librosDesactivados.length > 0 && (
        <div style={{ marginTop: '3rem' }}>
          <h3 style={{ color: '#999' }}>Libros desactivados ({librosDesactivados.length})</h3>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ textAlign: 'left', borderBottom: '2px solid #eee' }}>
                <th style={{ padding: '0.5rem', color: '#999' }}>ISBN</th>
                <th style={{ padding: '0.5rem', color: '#999' }}>Título</th>
                <th style={{ padding: '0.5rem', color: '#999' }}>Autor</th>
                <th style={{ padding: '0.5rem', color: '#999' }}>Editorial</th>
                <th style={{ padding: '0.5rem' }}></th>
              </tr>
            </thead>
            <tbody>
              {librosDesactivados.map(libro => (
                <tr key={libro.id} style={{ borderBottom: '1px solid #f5f5f5', opacity: 0.6 }}>
                  <td style={{ padding: '0.5rem', fontSize: '0.9rem' }}>{libro.isbn || '—'}</td>
                  <td style={{ padding: '0.5rem', fontSize: '0.9rem' }}>{libro.titulo}</td>
                  <td style={{ padding: '0.5rem', fontSize: '0.9rem' }}>{libro.autor || '—'}</td>
                  <td style={{ padding: '0.5rem', fontSize: '0.9rem' }}>{libro.editorial || '—'}</td>
                  <td style={{ padding: '0.5rem' }}>
                    <button onClick={() => reactivarLibro(libro)} style={{ background: 'none', border: '1px solid #5cb85c', color: '#5cb85c', padding: '0.2rem 0.5rem', cursor: 'pointer', borderRadius: '4px', fontSize: '0.85rem' }}>Reactivar</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

function Distribuidores() {
  const [distribuidores, setDistribuidores] = useState([]);
  const [form, setForm] = useState({ nombre: '', factor_pago: '' });
  const [cargando, setCargando] = useState(false);

  useEffect(() => { cargarDistribuidores(); }, []);

  async function cargarDistribuidores() {
    const res = await api.get('/distribuidores');
    setDistribuidores(res.data);
  }

  async function agregarDistribuidor(e) {
    e.preventDefault();
    setCargando(true);
    await api.post('/distribuidores', form);
    setForm({ nombre: '', factor_pago: '' });
    await cargarDistribuidores();
    setCargando(false);
  }

  return (
    <div>
      <h2>Distribuidores</h2>
      <p style={{ color: '#666', fontSize: '0.9rem' }}>El factor de pago determina el costo real. Ejemplo: 0.6 significa que pagas el 60% del PVP.</p>
      <form onSubmit={agregarDistribuidor} style={{ marginBottom: '2rem' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', maxWidth: '400px' }}>
          <input placeholder="Nombre del distribuidor *" value={form.nombre} onChange={e => setForm({ ...form, nombre: e.target.value })} required style={{ padding: '0.5rem' }} />
          <input placeholder="Factor de pago (ej: 0.6) *" type="number" step="0.01" min="0" max="1" value={form.factor_pago} onChange={e => setForm({ ...form, factor_pago: e.target.value })} required style={{ padding: '0.5rem' }} />
          <button type="submit" disabled={cargando} style={{ padding: '0.5rem', background: '#2c2c2a', color: 'white', border: 'none', cursor: 'pointer' }}>
            {cargando ? 'Guardando...' : 'Agregar distribuidor'}
          </button>
        </div>
      </form>
      <h3>Registrados ({distribuidores.length})</h3>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead><tr style={{ textAlign: 'left', borderBottom: '2px solid #ccc' }}><th style={{ padding: '0.5rem' }}>Nombre</th><th style={{ padding: '0.5rem' }}>Factor de pago</th></tr></thead>
        <tbody>
          {distribuidores.map(d => (
            <tr key={d.id} style={{ borderBottom: '1px solid #eee' }}>
              <td style={{ padding: '0.5rem' }}>{d.nombre}</td>
              <td style={{ padding: '0.5rem' }}>{d.factor_pago}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

function PedidosClientes() {
  const [pedidos, setPedidos] = useState([]);
  const [libros, setLibros] = useState([]);
  const [form, setForm] = useState({ nombre: '', contacto: '', canal: 'whatsapp', libro_id: '', notas: '' });
  const [cargando, setCargando] = useState(false);
  const [filtro, setFiltro] = useState('todos');

  useEffect(() => { cargarTodo(); }, []);

  async function cargarTodo() {
    try {
      const [p, l] = await Promise.all([
        api.get('/pedidos-clientes'),
        api.get('/libros')
      ]);
      setPedidos(p.data);
      setLibros(l.data);
    } catch (e) { console.error('cargarTodo pedidos:', e.message); }
  }

  async function agregarPedido(e) {
    e.preventDefault();
    setCargando(true);
    await api.post('/pedidos-clientes', form);
    setForm({ nombre: '', contacto: '', canal: 'whatsapp', libro_id: '', notas: '' });
    await cargarTodo();
    setCargando(false);
  }

  async function cambiarEstado(id, estado) {
    await api.patch(`/pedidos-clientes/${id}`, { estado });
    await cargarTodo();
  }

  const colores = { pendiente: '#f0c040', pedido: '#4a90d9', recibido: '#7b68ee', entregado: '#5cb85c', 'no retirado': '#d9534f' };
  const pedidosFiltrados = filtro === 'todos' ? pedidos : pedidos.filter(p => p.estado === filtro);

  return (
    <div>
      <h2>Pedidos de clientes</h2>
      <form onSubmit={agregarPedido} style={{ marginBottom: '2rem', background: '#f9f9f9', padding: '1rem', borderRadius: '8px' }}>
        <h3 style={{ marginTop: 0 }}>Nuevo pedido</h3>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem' }}>
          <input placeholder="Nombre del cliente *" value={form.nombre} onChange={e => setForm({ ...form, nombre: e.target.value })} required style={{ padding: '0.5rem' }} />
          <input placeholder="Contacto (teléfono o usuario)" value={form.contacto} onChange={e => setForm({ ...form, contacto: e.target.value })} style={{ padding: '0.5rem' }} />
          <select value={form.canal} onChange={e => setForm({ ...form, canal: e.target.value })} style={{ padding: '0.5rem' }}>
            <option value="whatsapp">WhatsApp</option>
            <option value="instagram">Instagram</option>
            <option value="presencial">Presencial</option>
            <option value="telefono">Teléfono</option>
          </select>
          <select value={form.libro_id} onChange={e => setForm({ ...form, libro_id: e.target.value })} required style={{ padding: '0.5rem' }}>
            <option value="">Seleccionar libro *</option>
            {libros.map(l => <option key={l.id} value={l.id}>{l.titulo}</option>)}
          </select>
          <input placeholder="Notas (opcional)" value={form.notas} onChange={e => setForm({ ...form, notas: e.target.value })} style={{ padding: '0.5rem', gridColumn: '1 / -1' }} />
          <button type="submit" disabled={cargando} style={{ padding: '0.5rem', background: '#2c2c2a', color: 'white', border: 'none', cursor: 'pointer', gridColumn: '1 / -1' }}>
            {cargando ? 'Guardando...' : 'Registrar pedido'}
          </button>
        </div>
      </form>
      <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1rem', flexWrap: 'wrap' }}>
        {['todos', 'pendiente', 'pedido', 'recibido', 'entregado', 'no retirado'].map(f => (
          <button key={f} onClick={() => setFiltro(f)} style={{ padding: '0.25rem 0.75rem', border: '1px solid #ccc', borderRadius: '20px', cursor: 'pointer', background: filtro === f ? '#2c2c2a' : 'white', color: filtro === f ? 'white' : '#333', fontSize: '0.85rem' }}>{f}</button>
        ))}
      </div>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead><tr style={{ textAlign: 'left', borderBottom: '2px solid #ccc' }}><th style={{ padding: '0.5rem' }}>Cliente</th><th style={{ padding: '0.5rem' }}>Contacto</th><th style={{ padding: '0.5rem' }}>Libro</th><th style={{ padding: '0.5rem' }}>Notas</th><th style={{ padding: '0.5rem' }}>Estado</th><th style={{ padding: '0.5rem' }}>Acción</th></tr></thead>
        <tbody>
          {pedidosFiltrados.map(p => (
            <tr key={p.id} style={{ borderBottom: '1px solid #eee' }}>
              <td style={{ padding: '0.5rem' }}>{p.cliente_nombre}</td>
              <td style={{ padding: '0.5rem', fontSize: '0.85rem', color: '#666' }}>{p.canal}: {p.contacto || '—'}</td>
              <td style={{ padding: '0.5rem' }}>{p.titulo}<br /><span style={{ fontSize: '0.85rem', color: '#666' }}>{p.autor}</span></td>
              <td style={{ padding: '0.5rem', fontSize: '0.85rem', color: '#666' }}>{p.notas || '—'}</td>
              <td style={{ padding: '0.5rem' }}><span style={{ background: colores[p.estado], color: 'white', padding: '0.2rem 0.6rem', borderRadius: '20px', fontSize: '0.8rem' }}>{p.estado}</span></td>
              <td style={{ padding: '0.5rem' }}>
                <select value={p.estado} onChange={e => cambiarEstado(p.id, e.target.value)} style={{ padding: '0.25rem', fontSize: '0.85rem' }}>
                  <option value="pendiente">Pendiente</option>
                  <option value="pedido">Pedido</option>
                  <option value="recibido">Recibido</option>
                  <option value="entregado">Entregado</option>
                  <option value="no retirado">No retirado</option>
                </select>
              </td>
            </tr>
          ))}
          {pedidosFiltrados.length === 0 && <tr><td colSpan="6" style={{ padding: '1rem', color: '#666', textAlign: 'center' }}>No hay pedidos</td></tr>}
        </tbody>
      </table>
    </div>
  );
}

// =============================================================================
// MÓDULO REPORTES
// Reemplaza los tres módulos anteriores: Ventas, Reportes y Consignación.
// Pestaña Ventas: vista mensual con comparación, desglose y lista completa.
// Pestaña Consignación: pendientes, crear reporte, historial, facturas.
// =============================================================================

function repFmtClp(n) {
  return `$${Number(n || 0).toLocaleString('es-CL', { maximumFractionDigits: 0 })}`;
}
function repFmtFecha(iso) {
  return new Date(iso).toLocaleDateString('es-CL', { timeZone: 'America/Santiago' });
}
function repFmtMesAno(iso) {
  return new Date(iso).toLocaleDateString('es-CL', { month: 'long', year: 'numeric', timeZone: 'America/Santiago' });
}
function repFmtRango(inicio, fin) {
  if (!inicio || !fin) return null;
  return `${repFmtFecha(inicio)} → ${repFmtFecha(fin)}`;
}
function repFmtHora(iso) {
  return new Date(iso).toLocaleTimeString('es-CL', { hour: '2-digit', minute: '2-digit', timeZone: 'America/Santiago' });
}
// "21 de septiembre" — encabezado de día del Detalle agrupado (textTransform:capitalize en el uso)
function repFmtDiaLargo(iso) {
  return new Date(iso).toLocaleDateString('es-CL', { day: 'numeric', month: 'long', timeZone: 'America/Santiago' });
}
// Agrupa una lista de ventas (ya ordenada por fecha DESC) en bloques por día — asume
// contiguas, como vienen del backend. Usa repFmtFecha (hora de Chile) como clave.
function repAgruparPorDia(ventas) {
  const grupos = [];
  let actual = null;
  for (const v of ventas) {
    const clave = repFmtFecha(v.fecha);
    if (!actual || actual.clave !== clave) {
      actual = { clave, fecha: v.fecha, ventas: [] };
      grupos.push(actual);
    }
    actual.ventas.push(v);
  }
  return grupos;
}
const REP_MESES = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];

// --- Fila de venta con flujo de anulación en dos pasos ---
// Valores sin tilde — son los que valida y guarda el backend (ver METODOS en backend/routes/ventas.js);
// mandar 'débito' acá hacía que el backend rechazara el cambio de método de pago con un error silencioso.
const METODOS_PAGO = [['efectivo','Efectivo'], ['debito','Débito'], ['credito','Crédito'], ['transferencia','Transferencia']];

function RepFilaVenta({ venta, onAnulada, onLibroClick, soloHora }) {
  const [advertencia,   setAdvertencia]   = useState(null);
  const [anulando,      setAnulando]      = useState(false);
  const [editandoPago,  setEditandoPago]  = useState(false);
  const [metodo,        setMetodo]        = useState(venta.metodo_pago || 'efectivo');
  const [metodo2,       setMetodo2]       = useState(venta.metodo_pago_2 || '');
  const [guardandoPago, setGuardandoPago] = useState(false);
  const [tcTickets,     setTcTickets]     = useState(null); // null=cerrado · 'cargando' · []/array = resultado
  const anulada = venta.estado === 'anulada';
  const esHistorica = String(venta.id).startsWith('h-');

  // Busca los tickets de cambio de ESTA venta, sin importar qué tan vieja sea —
  // a diferencia del panel del POS, que solo recuerda las ventas del día.
  async function toggleTicketsCambio() {
    if (tcTickets !== null) { setTcTickets(null); return; }
    setTcTickets('cargando');
    try {
      const r = await api.get(`/tickets-cambio?venta_id=${venta.id}`);
      setTcTickets(r.data);
    } catch { setTcTickets([]); }
  }

  async function guardarMetodoPago() {
    setGuardandoPago(true);
    try {
      await api.patch(`/ventas/${venta.id}/metodo-pago`, {
        metodo_pago: metodo,
        metodo_pago_2: metodo2 || null,
      });
      setEditandoPago(false);
      onAnulada(); // recarga la lista
    } catch (err) {
      alert(err.response?.data?.error || 'Error al actualizar');
    }
    setGuardandoPago(false);
  }

  async function intentarAnular() {
    if (!window.confirm('¿Anular esta venta? El stock volverá al inventario.')) return;
    setAnulando(true);
    try {
      const res = await api.patch(`/ventas/${venta.id}/anular`);
      if (res.data.requiere_confirmacion) {
        setAdvertencia(res.data);
      } else {
        if (res.data.tickets_revertidos > 0) {
          alert(`Venta anulada. Se devolvió el crédito de ${res.data.tickets_revertidos} ticket${res.data.tickets_revertidos !== 1 ? 's' : ''} de cambio — vuelven a estar disponibles.`);
        }
        onAnulada();
      }
    } catch (err) {
      alert(err.response?.data?.error || 'Error al anular la venta');
    }
    setAnulando(false);
  }

  async function forzarAnulacion() {
    setAnulando(true);
    try {
      const res = await api.patch(`/ventas/${venta.id}/anular`, { forzar: true });
      setAdvertencia(null);
      if (res.data.tickets_revertidos > 0) {
        alert(`Venta anulada. Se devolvió el crédito de ${res.data.tickets_revertidos} ticket${res.data.tickets_revertidos !== 1 ? 's' : ''} de cambio — vuelven a estar disponibles.`);
      }
      onAnulada();
    } catch (err) {
      alert(err.response?.data?.error || 'Error al anular la venta');
    }
    setAnulando(false);
  }

  return (
    <>
      <tr style={{ borderBottom: advertencia ? 'none' : '1px solid #eee', opacity: anulada ? 0.55 : 1 }}>
        <td style={{ padding: '0.5rem 0.75rem', color: '#555', fontSize: '0.88rem', whiteSpace: 'nowrap' }}>
          {soloHora
            ? repFmtHora(venta.fecha)
            : <>{repFmtFecha(venta.fecha)}<br /><span style={{ color: '#aaa', fontSize: '0.8rem' }}>{repFmtHora(venta.fecha)}</span></>}
        </td>
        <td style={{ padding: '0.5rem 0.75rem' }}>
          {venta.items.map((item, i) => (
            <div key={i} style={{ fontSize: '0.88rem', textDecoration: anulada ? 'line-through' : 'none', color: anulada ? '#999' : '#333', display: 'flex', alignItems: 'center', gap: '0.3rem', flexWrap: 'wrap' }}>
              {onLibroClick
                ? <span onClick={async () => {
                    if (item.libro_id) {
                      onLibroClick({ id: item.libro_id, titulo: item.titulo, autor: item.autor, isbn: item.isbn });
                    } else if (item.isbn || item.titulo) {
                      try {
                        const q = item.isbn ? `isbn=${encodeURIComponent(item.isbn)}` : `titulo=${encodeURIComponent(item.titulo)}`;
                        const r = await api.get(`/libros/buscar-uno?${q}`);
                        if (r.data?.id) onLibroClick(r.data);
                      } catch {}
                    }
                  }}
                    style={{ cursor: 'pointer', textDecoration: 'underline', textDecorationStyle: 'dotted', textDecorationColor: '#aaa' }}>
                    {item.titulo}
                  </span>
                : item.titulo}
              <span style={{ color: '#aaa' }}>× {item.cantidad}</span>
              {item.modalidad === 'consignacion' && (
                <span style={{ fontSize: '0.74rem', background: '#e8f0fe', color: '#1a56db', padding: '0.1rem 0.35rem', borderRadius: '4px' }}>consig.</span>
              )}
            </div>
          ))}
        </td>
        <td style={{ padding: '0.5rem 0.75rem', fontSize: '0.88rem' }}>
          {editandoPago ? (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                <select value={metodo} onChange={e => setMetodo(e.target.value)}
                  style={{ fontSize: 12, padding: '3px 6px', borderRadius: 6, border: '1px solid var(--line)', fontFamily: 'var(--font-ui)', background: 'var(--paper)' }}>
                  {METODOS_PAGO.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
                </select>
                <select value={metodo2} onChange={e => setMetodo2(e.target.value)}
                  style={{ fontSize: 12, padding: '3px 6px', borderRadius: 6, border: '1px solid var(--line)', fontFamily: 'var(--font-ui)', background: 'var(--paper)' }}>
                  <option value="">sin 2do</option>
                  {METODOS_PAGO.filter(([v]) => v !== metodo).map(([v, l]) => <option key={v} value={v}>{l}</option>)}
                </select>
              </div>
              <div style={{ display: 'flex', gap: 4 }}>
                <button onClick={guardarMetodoPago} disabled={guardandoPago}
                  style={{ fontSize: 11, padding: '3px 8px', background: 'var(--brand)', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontFamily: 'var(--font-ui)' }}>
                  {guardandoPago ? '...' : 'Guardar'}
                </button>
                <button onClick={() => { setEditandoPago(false); setMetodo(venta.metodo_pago); setMetodo2(venta.metodo_pago_2 || ''); }}
                  style={{ fontSize: 11, padding: '3px 8px', background: 'transparent', color: 'var(--ink-500)', border: '1px solid var(--line)', borderRadius: 6, cursor: 'pointer', fontFamily: 'var(--font-ui)' }}>
                  Cancelar
                </button>
              </div>
            </div>
          ) : (
            <span
              onClick={() => { if (!anulada && !esHistorica) setEditandoPago(true); }}
              title={anulada || esHistorica ? '' : 'Click para editar medio de pago'}
              style={{ color: '#666', cursor: anulada || esHistorica ? 'default' : 'pointer', borderBottom: anulada || esHistorica ? 'none' : '1px dashed #ccc' }}>
              {repPagoLabel(venta.metodo_pago)}{venta.metodo_pago_2 ? ` + ${repPagoLabel(venta.metodo_pago_2)}` : ''}
            </span>
          )}
        </td>
        <td style={{ padding: '0.5rem 0.75rem', fontWeight: 700, textAlign: 'right', whiteSpace: 'nowrap' }}>
          {repFmtClp(venta.total)}
        </td>
        <td style={{ padding: '0.5rem 0.75rem', textAlign: 'right' }}>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
            {!esHistorica && (
              <button onClick={toggleTicketsCambio}
                title="Ver o reimprimir los tickets de cambio de esta venta"
                style={{ display: 'inline-flex', alignItems: 'center', gap: 4, padding: '0.2rem 0.6rem', background: tcTickets !== null ? '#F5F3FF' : 'transparent', border: `1px solid ${tcTickets !== null ? 'rgba(109,40,217,0.4)' : 'rgba(109,40,217,0.3)'}`, borderRadius: '4px', cursor: 'pointer', fontSize: '0.78rem', color: '#7C3AED', fontFamily: 'var(--font-ui)' }}>
                <Tag size={11} strokeWidth={1.75} /> TC
              </button>
            )}
            {anulada
              ? <span style={{ fontSize: '0.78rem', background: '#d9534f', color: 'white', padding: '0.2rem 0.5rem', borderRadius: '20px' }}>anulada</span>
              : esHistorica
                ? <span style={{ fontSize: '0.78rem', color: '#aaa' }}>histórica</span>
                : <button onClick={intentarAnular} disabled={anulando} style={{ background: 'none', border: '1px solid #d9534f', color: '#d9534f', padding: '0.2rem 0.6rem', cursor: 'pointer', borderRadius: '4px', fontSize: '0.8rem' }}>
                    {anulando ? '...' : 'Anular'}
                  </button>
            }
          </div>
        </td>
      </tr>
      {tcTickets !== null && (
        <tr>
          <td colSpan={5} style={{ padding: '0.6rem 1rem', background: '#FAFAFA', borderBottom: '1px solid #eee', borderLeft: '3px solid #7C3AED' }}>
            {tcTickets === 'cargando' ? (
              <div style={{ fontSize: 12, color: '#A78BFA', fontFamily: 'var(--font-ui)' }}>Buscando tickets…</div>
            ) : tcTickets.length === 0 ? (
              <div style={{ fontSize: 12, color: 'var(--ink-400)', fontFamily: 'var(--font-ui)' }}>Esta venta no tiene tickets de cambio generados.</div>
            ) : (
              <div>
                <div style={{ fontSize: 10, fontWeight: 600, color: '#A78BFA', textTransform: 'uppercase', letterSpacing: '0.07em', marginBottom: 8, fontFamily: 'var(--font-ui)' }}>Tickets de cambio</div>
                {tcTickets.map(tc => {
                  const esTotal = tc.tipo === 'total';
                  const titulo  = esTotal ? null : tc.items?.[0]?.titulo_snapshot;
                  const nLibros = tc.items?.length || 0;
                  return (
                    <div key={tc.id} style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6 }}>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ fontFamily: 'var(--font-mono)', fontSize: 13, fontWeight: 700, color: '#7C3AED', letterSpacing: '0.08em' }}>{tc.codigo}</div>
                        <div style={{ fontSize: 11, color: 'var(--ink-500)', fontFamily: 'var(--font-ui)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                          {esTotal ? `Compra completa · ${nLibros} libro${nLibros !== 1 ? 's' : ''}` : titulo}
                          {tc.items?.every(i => i.canjeado) && <span style={{ marginLeft: 6, color: 'var(--ink-400)' }}>· ya canjeado</span>}
                        </div>
                      </div>
                      <button onClick={() => imprimirTicketCambio(tc.codigo, titulo, nLibros)}
                        style={{ display: 'inline-flex', alignItems: 'center', gap: 4, padding: '5px 11px', background: '#7C3AED', color: '#fff', border: 'none', borderRadius: 'var(--r-pill)', fontSize: 11, fontWeight: 600, cursor: 'pointer', fontFamily: 'var(--font-ui)', whiteSpace: 'nowrap', flexShrink: 0 }}>
                        <Printer size={11} strokeWidth={2} /> Imprimir
                      </button>
                    </div>
                  );
                })}
              </div>
            )}
          </td>
        </tr>
      )}
      {advertencia && (
        <tr>
          <td colSpan={5} style={{ padding: '0.75rem 1rem', background: '#fff8e1', borderBottom: '1px solid #eee', borderLeft: '3px solid #f0c040' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '1rem', flexWrap: 'wrap' }}>
              <div style={{ flex: 1, minWidth: 220 }}>
                <strong style={{ fontSize: '0.9rem' }}>⚠️ Esta venta ya fue reportada al distribuidor</strong>
                <p style={{ margin: '0.3rem 0 0', fontSize: '0.85rem', color: '#555' }}>{advertencia.mensaje}</p>
              </div>
              <div style={{ display: 'flex', gap: '0.5rem', flexShrink: 0, alignSelf: 'center' }}>
                <button onClick={() => setAdvertencia(null)} style={{ padding: '0.35rem 0.75rem', border: '1px solid #ccc', background: 'white', cursor: 'pointer', borderRadius: '4px', fontSize: '0.85rem' }}>Cancelar</button>
                <button onClick={forzarAnulacion} disabled={anulando} style={{ padding: '0.35rem 0.75rem', background: '#d9534f', color: 'white', border: 'none', cursor: 'pointer', borderRadius: '4px', fontSize: '0.85rem' }}>
                  {anulando ? 'Anulando...' : 'Sí, anular de todas formas'}
                </button>
              </div>
            </div>
          </td>
        </tr>
      )}
    </>
  );
}

// ─── Reportes v2 — helpers ────────────────────────────────────────────────────
const repTones2   = ['peach','mint','rose','blue','violet','olive','yellow','sand'];
const repToneAt   = i => repTones2[Math.abs(i) % 8];
const repClp2     = n => `$ ${Number(n || 0).toLocaleString('es-CL', { maximumFractionDigits: 0 })}`;
const repClpK2    = n => { const v = Number(n||0); return v >= 1000000 ? `$${(v/1000000).toFixed(1)}M` : `$${Math.round(v/1000)}k`; };
const rpDiffPct   = (x, y) => (!y ? null : Math.round(((x - y) / y) * 100));
const REP_PAGO_LABELS = [['efectivo','Efectivo'],['debito','Débito'],['credito','Crédito'],['transferencia','Transferencia'],['giftcard','Gift card']];
const REP_PAGO_LABEL_POR_KEY = Object.fromEntries(REP_PAGO_LABELS);
const repPagoLabel = m => REP_PAGO_LABEL_POR_KEY[m] || m;
const REP_PAGO_TONE   = { efectivo: 'var(--past-mint)', debito: 'var(--past-blue)', credito: 'var(--past-violet)', transferencia: 'var(--past-peach)', giftcard: 'var(--past-rose,#fecdd3)' };
const repTh2 = { textAlign: 'left', padding: '11px 14px', fontSize: 11, color: 'var(--ink-500)', textTransform: 'uppercase', letterSpacing: '0.08em', fontWeight: 500, whiteSpace: 'nowrap' };
const repTd2 = { padding: '12px 14px', verticalAlign: 'middle' };

function RpComparePct({ label, pct }) {
  if (pct === null || pct === undefined)
    return <span style={{ fontSize: 12, color: 'var(--ink-400)' }}>{label}: sin datos</span>;
  const up = pct >= 0;
  const Icon2 = up ? TrendingUp : TrendingDown;
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: 12, fontWeight: 500, padding: '3px 10px', borderRadius: 999, background: up ? 'var(--ok-bg)' : 'var(--bad-bg)', color: up ? 'var(--ok-ink)' : 'var(--bad-ink)' }}>
      <Icon2 size={12} strokeWidth={2} />
      {up ? '+' : ''}{pct}% {label}
    </span>
  );
}

// Fila comparativa del resumen: monto del otro período + una frase que dice, desde "hoy", qué tan arriba o abajo vas.
function RpCompRow({ label, valor, actual, completo }) {
  const diff = actual - valor;
  const pct = rpDiffPct(actual, valor);
  const pctTxt = pct === 0 && diff !== 0 ? 'menos de 1%' : `${Math.abs(pct)}%`;
  const up = diff > 0;
  let frase = null, color = 'var(--ink-500)', Icon2 = null;
  if (!valor) {
    frase = 'Sin ventas en ese período';
  } else if (completo) {
    if (up) { frase = `Ya lo superaste por ${repFmtClp(diff)}`; color = 'var(--ok-ink)'; Icon2 = TrendingUp; }
    else if (diff === 0) frase = 'Justo igualaste ese mes';
    else frase = `Vas al ${Math.round((actual / valor) * 100)}% · te faltan ${repFmtClp(-diff)}`;
  } else if (diff === 0) {
    frase = 'Vas igual que ese período';
  } else {
    frase = `Vas ${pctTxt} por ${up ? 'encima' : 'debajo'} (${up ? '+' : '−'}${repFmtClp(Math.abs(diff))})`;
    color = up ? 'var(--ok-ink)' : 'var(--bad-ink)';
    Icon2 = up ? TrendingUp : TrendingDown;
  }
  return (
    <div style={{ padding: '7px 0', borderTop: '1px solid var(--line-soft)', fontSize: 11.5 }}>
      <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', gap: 8 }}>
        <span style={{ color: 'var(--ink-500)' }}>{label}</span>
        <span style={{ whiteSpace: 'nowrap', fontVariantNumeric: 'tabular-nums', color: 'var(--ink-800)', fontWeight: 600 }}>{repFmtClp(valor)}</span>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 4, marginTop: 2, color, fontWeight: 500 }}>
        {Icon2 && <Icon2 size={12} strokeWidth={2} />}{frase}
      </div>
    </div>
  );
}

const MESES_CORTO = ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic'];
const ANYO_COLORES = ['var(--past-blue)','var(--past-peach)','var(--brand)'];
const ANYO_COLORES_GANANCIA = ['var(--past-mint)', '#8FC78B', 'var(--past-mint-ink)'];

// campo/colores parametrizan el mismo gráfico para reusarlo con ganancia en vez
// de ventas (ver RpTabVentas) — el resto de la lógica queda idéntica.
function RpTrendBars({ serie, anyoActual, campo = 'total', colores = ANYO_COLORES }) {
  if (!serie?.length) return null;
  // Agrupar por año
  const anyos = [...new Set(serie.map(s => s.anyo))].sort();
  // Construir matriz [mes 1-12][anyo]
  const byMesAnyo = {};
  serie.forEach(s => {
    if (!byMesAnyo[s.mes_num]) byMesAnyo[s.mes_num] = {};
    byMesAnyo[s.mes_num][s.anyo] = Number(s[campo]);
  });
  const meses = Object.keys(byMesAnyo).map(Number).sort((a,b) => a-b);
  const max = Math.max(...serie.map(s => Number(s[campo])), 1);

  return (
    <div>
      {/* Leyenda años */}
      <div style={{ display: 'flex', gap: 12, marginBottom: 10, marginTop: 4 }}>
        {anyos.map((a, i) => (
          <span key={a} style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: 11, color: 'var(--ink-600)' }}>
            <span style={{ width: 10, height: 10, borderRadius: 3, background: colores[i] }} />
            {a}
          </span>
        ))}
      </div>
      {/* Barras — a tamaño real (no una columna angosta): más alto que antes para que se lea de un vistazo */}
      <div style={{ display: 'flex', alignItems: 'flex-end', gap: 6, height: 130 }}>
        {meses.map(m => (
          <div key={m} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}>
            <div style={{ display: 'flex', alignItems: 'flex-end', gap: 2, height: 112 }}>
              {anyos.map((a, i) => {
                const val = byMesAnyo[m]?.[a] || 0;
                const h = val ? Math.max(4, (val / max) * 108) : 0;
                return (
                  <div key={a} title={`${a} ${MESES_CORTO[m-1]}: ${repClpK2(val)}`}
                    style={{ width: 10, height: `${h}px`, borderRadius: '3px 3px 0 0', background: colores[i], alignSelf: 'flex-end' }} />
                );
              })}
            </div>
            <span style={{ fontSize: 10, color: 'var(--ink-500)' }}>{MESES_CORTO[m-1]}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

// Ganancia mes a mes del año — apilada debajo de RpTrendBars, misma tarjeta.
// Solo tiene sentido en modo "año" (un único año, no hay 3 años que comparar
// acá); por eso usa su propia escala en vez de compartir el max de ventas.
function RpGananciaBars({ serie }) {
  if (!serie?.length) return null;
  const max = Math.max(...serie.map(s => Number(s.ganancia || 0)), 1);
  return (
    <div style={{ marginTop: 14 }}>
      <hr style={{ border: 0, borderTop: '1px solid var(--line-soft)', margin: '0 0 10px' }} />
      <div style={{ fontSize: 12, color: 'var(--ink-500)', textTransform: 'uppercase', letterSpacing: '0.08em', fontWeight: 500, marginBottom: 8 }}>
        Ganancia mensual
      </div>
      <div style={{ display: 'flex', alignItems: 'flex-end', gap: 6, height: 68 }}>
        {serie.map(s => {
          const val = Number(s.ganancia || 0);
          const h = val ? Math.max(4, (val / max) * 46) : 0;
          return (
            <div key={s.mes_num} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}>
              <div style={{ display: 'flex', alignItems: 'flex-end', height: 46 }}>
                <div title={`${MESES_CORTO[s.mes_num - 1]}: ${repClpK2(val)}`}
                  style={{ width: 10, height: `${h}px`, borderRadius: '3px 3px 0 0', background: 'var(--past-mint)' }} />
              </div>
              <span style={{ fontSize: 10, color: 'var(--ink-500)' }}>{MESES_CORTO[s.mes_num - 1]}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

// Métodos de pago — línea de texto discreta (no compite con el recaudado ni la
// tendencia; el detalle en $ de cada método sigue disponible en Finanzas).
function RpPagoLinea({ actual }) {
  const segs = REP_PAGO_LABELS.map(([key, label]) => ({ key, label, val: Number(actual[key] || 0) })).filter(s => s.val > 0);
  const total = segs.reduce((s, x) => s + x.val, 0);
  if (!segs.length || total <= 0) return null;
  return (
    <span style={{ fontSize: 11, color: 'var(--ink-400)', fontFamily: 'var(--font-ui)' }}>
      Pagos: {segs.map((s, i) => (
        <React.Fragment key={s.key}>
          {i > 0 && ' · '}
          <span style={{ color: 'var(--ink-600)', fontWeight: 500 }}>{Math.round((s.val / total) * 100)}%</span> {s.label.toLowerCase()}
        </React.Fragment>
      ))}
    </span>
  );
}

function RpCatBars({ categorias, catExp, setCatExp }) {
  if (!categorias?.length) return <div style={{ color: 'var(--ink-400)', fontSize: 13, padding: 8 }}>Sin datos de categorías.</div>;
  const max = Math.max(...categorias.map(c => Number(c.total)));
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {categorias.map((c, i) => {
        const exp = catExp === c.categoria;
        return (
          <div key={c.categoria}
            onClick={() => setCatExp(exp ? null : c.categoria)}
            style={{ cursor: 'pointer', padding: '8px 8px', borderRadius: 10, transition: 'background 140ms ease' }}
            onMouseEnter={e => e.currentTarget.style.background = 'var(--brand-softer,#f0f8f0)'}
            onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 5 }}>
              <ChevronRight size={12} strokeWidth={2} color="var(--ink-400)" style={{ transform: exp ? 'rotate(90deg)' : 'none', transition: 'transform 140ms' }} />
              <span style={{ flex: 1, fontSize: 13 }}>{c.categoria}</span>
              <span style={{ fontSize: 11.5, color: 'var(--ink-400)', fontVariantNumeric: 'tabular-nums' }}>{c.unidades} uds.</span>
              <span style={{ fontSize: 13, fontWeight: 600, fontVariantNumeric: 'tabular-nums', minWidth: 80, textAlign: 'right' }}>{repClp2(c.total)}</span>
            </div>
            <div style={{ height: 7, borderRadius: 999, background: 'var(--paper-stripe)', marginLeft: 20 }}>
              <div style={{ width: `${(Number(c.total) / max) * 100}%`, height: '100%', borderRadius: 999, background: `var(--past-${repToneAt(i)})` }} />
            </div>
          </div>
        );
      })}
    </div>
  );
}

function RpTopLibros({ libros }) {
  if (!libros?.length) return <div style={{ color: 'var(--ink-400)', fontSize: 13, padding: 8 }}>Sin datos.</div>;
  return (
    <div style={{ background: 'var(--paper)', border: '1px solid var(--line)', borderRadius: 20, overflow: 'hidden' }}>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12.5 }}>
        <thead>
          <tr style={{ background: 'var(--paper-stripe)' }}>
            <th style={{ ...repTh2, paddingLeft: 16 }}>Título</th>
            <th style={{ ...repTh2, textAlign: 'right' }}>Uds.</th>
            <th style={{ ...repTh2, textAlign: 'right', paddingRight: 16 }}>Total</th>
          </tr>
        </thead>
        <tbody>
          {libros.map((l, i) => (
            <tr key={i} style={{ borderTop: i ? '1px solid var(--line-soft)' : 'none' }}>
              <td style={{ ...repTd2, paddingLeft: 16 }}>
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                  <span style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 12, color: 'var(--ink-300)', width: 14 }}>{i + 1}</span>
                  <span style={{ maxWidth: 180, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{l.titulo}</span>
                </span>
              </td>
              <td style={{ ...repTd2, textAlign: 'right', color: 'var(--ink-500)', fontVariantNumeric: 'tabular-nums' }}>{l.unidades}</td>
              <td style={{ ...repTd2, textAlign: 'right', paddingRight: 16, fontWeight: 600, fontVariantNumeric: 'tabular-nums' }}>{repClp2(l.total)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

// --- Chip de comparación (% vs período anterior) --- [legacy, kept for safety]
function RepChipComparacion({ label, pct }) {
  if (pct === null || pct === undefined) return <span style={{ fontSize: '0.78rem', color: '#bbb' }}>{label}: sin datos</span>;
  const color = pct >= 0 ? '#1a6b3c' : '#c0392b';
  const icon  = pct >= 0 ? '▲' : '▼';
  return (
    <span style={{ fontSize: '0.78rem', color, marginRight: '0.75rem' }}>
      {icon} {Math.abs(pct)}% {label}
    </span>
  );
}

// Barritas de un dato del resumen: una por año (el último es el período mostrado). Al tocar una
// barra el resumen pasa a ese año; tocar la última vuelve al período mostrado.
function RpMiniBarras({ valores, anyos, sel, onSel, etiqueta }) {
  const max = Math.max(0, ...valores);
  return (
    <div style={{ marginTop: 8 }}>
      <div style={{ display: 'flex', alignItems: 'flex-end', gap: 4, height: 30 }}>
        {valores.map((v, i) => (
          <button key={anyos[i]} type="button" onClick={() => onSel(i)}
            title={`${anyos[i]}: ${etiqueta(v)}`} aria-label={`${anyos[i]}: ${etiqueta(v)}`} aria-pressed={i === sel}
            style={{ flex: 1, minWidth: 0, padding: 0, border: 'none', cursor: 'pointer', borderRadius: '3px 3px 0 0',
              height: `${max > 0 ? Math.max(14, Math.round(Math.max(v, 0) / max * 100)) : 14}%`,
              background: i === sel ? 'var(--brand)' : 'var(--line-strong)' }} />
        ))}
      </div>
      <div style={{ display: 'flex', gap: 4, marginTop: 3 }}>
        {anyos.map((a, i) => (
          <span key={a} style={{ flex: 1, textAlign: 'center', fontSize: 11, color: i === sel ? 'var(--ink-900)' : 'var(--ink-400)', fontWeight: i === sel ? 600 : 400 }}>{String(a).slice(2)}</span>
        ))}
      </div>
    </div>
  );
}

// --- Pestaña Ventas ---
function RepTabVentas() {
  const mob = useMobile();
  const hoy = new Date();
  const hoyStr = `${hoy.getFullYear()}-${String(hoy.getMonth()+1).padStart(2,'0')}-${String(hoy.getDate()).padStart(2,'0')}`;

  // ── Modo de período ──
  const [modo,        setModo]       = useState('mes'); // 'dia' | 'mes' | 'anyo'
  const [fecha,       setFecha]      = useState(hoyStr);
  const [year,        setYear]       = useState(hoy.getFullYear());
  const [month,       setMonth]      = useState(hoy.getMonth() + 1);
  const [selectorAb,  setSelectorAb] = useState(false);

  const [datos,       setDatos]      = useState(null);
  const [cargando,    setCargando]   = useState(true);
  const [mostrarAnul, setMostrarAnul] = useState(false);
  const [catExp,      setCatExp]     = useState(null);
  const [analisisAb,  setAnalisisAb] = useState(false);
  const [anyoSel,     setAnyoSel]    = useState(null);  // año elegido en las barritas del resumen (null = el período mostrado)
  const [fichaLibro,  setFichaLibro] = useState(null);

  // ── Calendario flotante del selector de período ──
  const [ptab,        setPtab]       = useState('mes');   // pestaña del calendario: 'dia' | 'mes' | 'anyo'
  const [calY,        setCalY]       = useState(hoy.getFullYear());
  const [calM,        setCalM]       = useState(hoy.getMonth() + 1);
  const [diasVentas,  setDiasVentas] = useState([]);      // días del mes mostrado con ventas (punto en el calendario)
  const selectorRef = useRef(null);

  // Cierra con clic afuera o Escape
  useEffect(() => {
    if (!selectorAb) return;
    const fuera = e => { if (selectorRef.current && !selectorRef.current.contains(e.target)) setSelectorAb(false); };
    const esc   = e => { if (e.key === 'Escape') setSelectorAb(false); };
    document.addEventListener('mousedown', fuera);
    document.addEventListener('keydown', esc);
    return () => { document.removeEventListener('mousedown', fuera); document.removeEventListener('keydown', esc); };
  }, [selectorAb]);

  // Días con ventas del mes que muestra el calendario (si falla, simplemente no hay puntos)
  useEffect(() => {
    if (!selectorAb || ptab !== 'dia') return;
    let v = true;
    setDiasVentas([]);
    api.get(`/reportes/dias-con-ventas?year=${calY}&month=${calM}`)
      .then(r => { if (v) setDiasVentas(r.data?.dias || []); })
      .catch(() => {});
    return () => { v = false; };
  }, [selectorAb, ptab, calY, calM]);

  function fetchDatos() {
    setCargando(true); setCatExp(null);
    const url = modo === 'dia'  ? `/reportes/ventas-dia?fecha=${fecha}`
              : modo === 'anyo' ? `/reportes/ventas-anyo?year=${year}`
              : `/reportes/ventas-periodo?year=${year}&month=${month}`;
    api.get(url)
      .then(res => setDatos(res.data))
      .catch(console.error)
      .finally(() => setCargando(false));
  }

  useEffect(() => { let v = true; setCargando(true); setCatExp(null); setAnyoSel(null);
    const url = modo === 'dia'  ? `/reportes/ventas-dia?fecha=${fecha}`
              : modo === 'anyo' ? `/reportes/ventas-anyo?year=${year}`
              : `/reportes/ventas-periodo?year=${year}&month=${month}`;
    api.get(url).then(r => { if (v) setDatos(r.data); }).catch(console.error).finally(() => { if (v) setCargando(false); });
    return () => { v = false; };
  }, [modo, fecha, year, month]);

  // Navegación anterior / siguiente
  function anterior() {
    if (modo === 'dia') {
      const d = new Date(fecha + 'T12:00:00'); d.setDate(d.getDate() - 1);
      setFecha(d.toISOString().slice(0,10));
    } else if (modo === 'mes') {
      if (month === 1) { setYear(y => y - 1); setMonth(12); } else setMonth(m => m - 1);
    } else {
      setYear(y => y - 1);
    }
  }
  function siguiente() {
    if (esFuturo()) return;
    if (modo === 'dia') {
      const d = new Date(fecha + 'T12:00:00'); d.setDate(d.getDate() + 1);
      setFecha(d.toISOString().slice(0,10));
    } else if (modo === 'mes') {
      if (month === 12) { setYear(y => y + 1); setMonth(1); } else setMonth(m => m + 1);
    } else {
      setYear(y => y + 1);
    }
  }
  function esFuturo() {
    if (modo === 'dia')  return fecha >= hoyStr;
    if (modo === 'mes')  return year === hoy.getFullYear() && month === hoy.getMonth() + 1;
    return year >= hoy.getFullYear();
  }

  function labelPeriodo() {
    if (modo === 'dia') {
      const d = new Date(fecha + 'T12:00:00');
      const txt = d.toLocaleDateString('es-CL', { weekday: 'long', day: 'numeric', month: 'long' });
      const t = txt.charAt(0).toUpperCase() + txt.slice(1);
      return d.getFullYear() === hoy.getFullYear() ? t : `${t} ${d.getFullYear()}`;
    }
    if (modo === 'mes')  return `${REP_MESES[month - 1]} ${year}`;
    return String(year);
  }

  // Calendario flotante: al abrir parte en el período seleccionado
  function abrirSelector() {
    if (selectorAb) { setSelectorAb(false); return; }
    if (modo === 'dia') { setCalY(Number(fecha.slice(0, 4))); setCalM(Number(fecha.slice(5, 7))); }
    else { setCalY(year); setCalM(month); }
    setPtab(modo);
    setSelectorAb(true);
  }
  function calMesDelta(d) {
    const n = calM + d;
    if (n < 1) { setCalY(y => y - 1); setCalM(12); }
    else if (n > 12) { setCalY(y => y + 1); setCalM(1); }
    else setCalM(n);
  }
  function elegirDia(iso)  { setModo('dia');  setFecha(iso); setYear(Number(iso.slice(0, 4))); setMonth(Number(iso.slice(5, 7))); setSelectorAb(false); }
  function elegirMes(y, m) { setModo('mes');  setYear(y); setMonth(m); setSelectorAb(false); }
  function elegirAnyo(y)   { setModo('anyo'); setYear(y); setSelectorAb(false); }
  const calNavBtn = off => ({ width: 32, height: 32, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'none', border: 'none', borderRadius: 8, cursor: off ? 'default' : 'pointer', color: 'var(--ink-600)', opacity: off ? 0.3 : 1 });

  function exportarExcel() {
    if (!datos?.ventas?.length) return;
    const lista = mostrarAnul ? datos.ventas : datos.ventas.filter(v => v.estado !== 'anulada');
    if (!lista.length) return;
    const filas = lista.flatMap(v => v.items.map(item => ({
      Fecha: repFmtFecha(v.fecha), Hora: repFmtHora(v.fecha),
      Título: item.titulo, Autor: item.autor || '',
      Categoría: item.categoria || '—', Modalidad: item.modalidad,
      Cantidad: item.cantidad, 'Precio unitario': item.precio_unitario,
      Subtotal: item.subtotal,
      'Método de pago': repPagoLabel(v.metodo_pago) + (v.metodo_pago_2 ? ` + ${repPagoLabel(v.metodo_pago_2)}` : ''),
      'Total venta': v.total, Estado: v.estado,
    })));
    const ws = XLSX.utils.json_to_sheet(filas);
    const wb2 = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb2, ws, 'Ventas');
    const buf = XLSX.write(wb2, { bookType: 'xlsx', type: 'array' });
    const sufijo = modo === 'dia' ? fecha : modo === 'mes' ? `${year}-${String(month).padStart(2,'0')}` : year;
    saveAs(new Blob([buf], { type: 'application/octet-stream' }), `relea-ventas-${sufijo}.xlsx`);
  }

  const actual = datos?.actual;
  const ventasMostradas = datos?.ventas
    ? (mostrarAnul ? datos.ventas : datos.ventas.filter(v => v.estado !== 'anulada'))
    : [];

  const card = { background: 'var(--paper)', border: '1px solid var(--line)', borderRadius: 20 };

  // Etiquetas comparativas según modo
  const labelComp1 = modo === 'dia' ? 'vs ayer' : modo === 'mes' ? 'vs mes ant.' : 'vs año ant.';
  const comp1Val   = modo === 'mes' ? datos?.mes_anterior?.total_recaudado
                   : modo === 'anyo' ? datos?.anyo_anterior?.total_recaudado : null;

  // Barritas por año del resumen: solo con períodos cerrados — el mes o el año en curso no ha
  // terminado y quedaría parcial frente a años completos.
  const resumenAnios = datos?.resumen_anios;
  const conBarras = !!resumenAnios?.length && !datos?.hasta_fecha && !(modo === 'anyo' && year >= hoy.getFullYear());
  const vistaAnyo = conBarras && anyoSel != null ? resumenAnios[anyoSel] : null;

  return (
    <div>
      {/* ── Selector de período: píldora con flechas + calendario flotante ── */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10, marginBottom: 20 }}>
        <div ref={selectorRef} style={{ position: 'relative', minWidth: 0, flex: mob ? 1 : 'unset' }}>
          <div style={{ display: 'flex', alignItems: 'center', background: 'var(--paper)', border: '1px solid ' + (selectorAb ? 'var(--ink-300)' : 'var(--line)'), borderRadius: 12, overflow: 'hidden' }}>
            <button onClick={anterior} aria-label="Período anterior"
              style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: 38, height: 40, background: 'none', border: 'none', cursor: 'pointer', color: 'var(--ink-600)' }}>
              <ChevronLeft size={16} strokeWidth={2} />
            </button>
            <button onClick={abrirSelector} aria-expanded={selectorAb}
              style={{ flex: 1, minWidth: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6, height: 40, padding: '0 10px', background: 'none', border: 'none', borderLeft: '1px solid var(--line-soft)', borderRight: '1px solid var(--line-soft)', cursor: 'pointer', fontFamily: 'inherit', fontSize: 14, fontWeight: 600, color: 'var(--ink-800)' }}>
              <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{labelPeriodo()}</span>
              <ChevronDown size={14} strokeWidth={2} style={{ flexShrink: 0, transition: 'transform .15s', transform: selectorAb ? 'rotate(180deg)' : 'none' }} />
            </button>
            <button onClick={siguiente} disabled={esFuturo()} aria-label="Período siguiente"
              style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: 38, height: 40, background: 'none', border: 'none', cursor: esFuturo() ? 'default' : 'pointer', color: 'var(--ink-600)', opacity: esFuturo() ? 0.3 : 1 }}>
              <ChevronRight size={16} strokeWidth={2} />
            </button>
          </div>

          {selectorAb && (
            <div style={{ position: 'absolute', top: 'calc(100% + 8px)', left: 0, zIndex: 30, boxSizing: 'border-box', width: mob ? 'min(340px, calc(100vw - 32px))' : 320, background: 'var(--paper)', border: '1px solid var(--line)', borderRadius: 16, padding: 14, boxShadow: '0 12px 32px rgba(0,0,0,0.12)' }}>
              {/* Día / Mes / Año */}
              <div style={{ display: 'flex', gap: 4, padding: 3, background: 'var(--line-soft)', borderRadius: 10, marginBottom: 12 }}>
                {[['dia','Día'],['mes','Mes'],['anyo','Año']].map(([id, label]) => (
                  <button key={id} onClick={() => setPtab(id)} style={{
                    flex: 1, padding: '6px 0', borderRadius: 8, border: 'none', cursor: 'pointer', fontFamily: 'inherit', fontSize: 13,
                    fontWeight: ptab === id ? 600 : 500,
                    background: ptab === id ? 'var(--paper)' : 'transparent',
                    color: ptab === id ? 'var(--ink-900)' : 'var(--ink-500)',
                    boxShadow: ptab === id ? '0 1px 2px rgba(0,0,0,0.08)' : 'none',
                  }}>{label}</button>
                ))}
              </div>

              {ptab === 'dia' && (() => {
                const primerDow = (new Date(calY, calM - 1, 1).getDay() + 6) % 7; // semana parte en lunes
                const nDias = new Date(calY, calM, 0).getDate();
                const mesFuturo = calY > hoy.getFullYear() || (calY === hoy.getFullYear() && calM >= hoy.getMonth() + 1);
                const celdas = [...Array(primerDow).fill(null), ...Array.from({ length: nDias }, (_, i) => i + 1)];
                return (
                  <>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
                      <button onClick={() => calMesDelta(-1)} aria-label="Mes anterior" style={calNavBtn(false)}><ChevronLeft size={16} /></button>
                      <span style={{ fontSize: 14, fontWeight: 600, color: 'var(--ink-800)' }}>{REP_MESES[calM - 1]} {calY}</span>
                      <button onClick={() => calMesDelta(1)} disabled={mesFuturo} aria-label="Mes siguiente" style={calNavBtn(mesFuturo)}><ChevronRight size={16} /></button>
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 2 }}>
                      {['L','M','M','J','V','S','D'].map((d, i) => (
                        <div key={i} style={{ textAlign: 'center', fontSize: 11, color: 'var(--ink-400)', fontWeight: 600, padding: '4px 0' }}>{d}</div>
                      ))}
                      {celdas.map((d, i) => {
                        if (d === null) return <div key={'v' + i} />;
                        const iso = `${calY}-${String(calM).padStart(2,'0')}-${String(d).padStart(2,'0')}`;
                        const futuro = iso > hoyStr;
                        const sel = modo === 'dia' && fecha === iso;
                        const esHoy = iso === hoyStr;
                        return (
                          <button key={d} disabled={futuro} onClick={() => elegirDia(iso)}
                            style={{ position: 'relative', height: 38, borderRadius: 10, border: 'none', fontFamily: 'inherit', fontSize: 13, fontWeight: sel ? 700 : 500,
                              cursor: futuro ? 'default' : 'pointer',
                              background: sel ? 'var(--ink-900)' : 'transparent',
                              color: sel ? '#fff' : futuro ? 'var(--ink-300)' : 'var(--ink-800)',
                              boxShadow: esHoy && !sel ? 'inset 0 0 0 1px var(--brand-line)' : 'none' }}>
                            {d}
                            {diasVentas.includes(d) && (
                              <span style={{ position: 'absolute', bottom: 5, left: '50%', marginLeft: -2, width: 4, height: 4, borderRadius: '50%', background: sel ? '#fff' : 'var(--brand)' }} />
                            )}
                          </button>
                        );
                      })}
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 10, fontSize: 11.5, color: 'var(--ink-500)' }}>
                      <span style={{ width: 4, height: 4, borderRadius: '50%', background: 'var(--brand)' }} /> Día con ventas
                    </div>
                  </>
                );
              })()}

              {ptab === 'mes' && (
                <>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
                    <button onClick={() => setCalY(y => y - 1)} aria-label="Año anterior" style={calNavBtn(false)}><ChevronLeft size={16} /></button>
                    <span style={{ fontSize: 14, fontWeight: 600, color: 'var(--ink-800)' }}>{calY}</span>
                    <button onClick={() => setCalY(y => y + 1)} disabled={calY >= hoy.getFullYear()} aria-label="Año siguiente" style={calNavBtn(calY >= hoy.getFullYear())}><ChevronRight size={16} /></button>
                  </div>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 6 }}>
                    {REP_MESES.map((nombre, i) => {
                      const futuro = calY > hoy.getFullYear() || (calY === hoy.getFullYear() && i + 1 > hoy.getMonth() + 1);
                      const sel = modo === 'mes' && year === calY && month === i + 1;
                      return (
                        <button key={i} disabled={futuro} onClick={() => elegirMes(calY, i + 1)}
                          style={{ height: 40, borderRadius: 10, border: 'none', fontFamily: 'inherit', fontSize: 13, fontWeight: sel ? 700 : 500,
                            cursor: futuro ? 'default' : 'pointer',
                            background: sel ? 'var(--ink-900)' : 'var(--line-soft)',
                            color: sel ? '#fff' : futuro ? 'var(--ink-300)' : 'var(--ink-800)' }}>
                          {nombre.slice(0, 3)}
                        </button>
                      );
                    })}
                  </div>
                </>
              )}

              {ptab === 'anyo' && (
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 6 }}>
                  {Array.from({ length: 12 }, (_, i) => hoy.getFullYear() - 11 + i).map(a => {
                    const sel = modo === 'anyo' && year === a;
                    return (
                      <button key={a} onClick={() => elegirAnyo(a)}
                        style={{ height: 40, borderRadius: 10, border: 'none', fontFamily: 'inherit', fontSize: 13, fontWeight: sel ? 700 : 500, cursor: 'pointer',
                          background: sel ? 'var(--ink-900)' : 'var(--line-soft)', color: sel ? '#fff' : 'var(--ink-800)' }}>
                        {a}
                      </button>
                    );
                  })}
                </div>
              )}
            </div>
          )}
        </div>

        <button onClick={exportarExcel} disabled={!datos?.ventas?.length} title="Descargar Excel" aria-label="Descargar Excel"
          style={{ flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', width: 40, height: 40, background: 'var(--paper)', border: '1px solid var(--line)', borderRadius: 12, cursor: datos?.ventas?.length ? 'pointer' : 'default', color: 'var(--ink-700)', opacity: datos?.ventas?.length ? 1 : 0.4 }}>
          <Download size={16} strokeWidth={2} />
        </button>
      </div>

      {cargando && <p style={{ color: 'var(--ink-400)', fontSize: 14 }}>Cargando...</p>}

      {!cargando && actual && (
        <>
          {/* ── Resumen: recaudado a la izquierda, tendencia a la derecha, pagos discretos abajo ── */}
          <div style={{ ...card, padding: mob ? '22px 20px' : '24px 28px', marginBottom: 16 }}>
            <div style={{ display: 'flex', flexDirection: mob ? 'column' : 'row', gap: mob ? 20 : 30, alignItems: mob ? 'stretch' : 'stretch' }}>
              <div style={{ flex: mob ? 'unset' : '0 0 285px', display: 'flex', flexDirection: 'column', gap: 14, minWidth: 0 }}>
                <div>
                  <div style={{ fontSize: 12, color: 'var(--ink-500)', textTransform: 'uppercase', letterSpacing: '0.08em', fontWeight: 500, marginBottom: 6 }}>
                    Total recaudado{vistaAnyo ? ` · ${modo === 'mes' ? REP_MESES[month - 1].slice(0, 3) + ' ' : ''}${vistaAnyo.anyo}` : ''}
                  </div>
                  <div style={{ fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: 30, letterSpacing: '-0.02em', lineHeight: 1 }}>{repFmtClp(vistaAnyo ? vistaAnyo.total_recaudado : actual.total_recaudado)}</div>
                  {vistaAnyo ? null : datos.hasta_fecha ? (
                    // Mes en curso: comparar "hasta hoy" contra el mismo día de otros períodos —
                    // el mes completo anterior ya terminó, comparar contra uno a medio andar sería injusto.
                    <div style={{ marginTop: 4 }}>
                      <RpCompRow
                        label={`Hasta el ${datos.hasta_fecha.dia} de ${REP_MESES[(month - 2 + 12) % 12].toLowerCase()} ${month === 1 ? year - 1 : year}`}
                        valor={datos.hasta_fecha.mes_anterior.total_recaudado} actual={actual.total_recaudado} />
                      <RpCompRow
                        label={`Hasta el ${datos.hasta_fecha.dia} de ${REP_MESES[month - 1].toLowerCase()} ${year - 1}`}
                        valor={datos.hasta_fecha.mismo_mes_anyo.total_recaudado} actual={actual.total_recaudado} />
                      {datos.mismo_mes_anyo?.total_recaudado > 0 && (
                        <RpCompRow completo
                          label={`${REP_MESES[month - 1]} ${year - 1} completo`}
                          valor={datos.mismo_mes_anyo.total_recaudado} actual={actual.total_recaudado} />
                      )}
                    </div>
                  ) : (
                    // Período ya terminado (o modo día/año): el mes/año completo contra el anterior es una comparación justa.
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 8 }}>
                      {comp1Val != null && <RpComparePct label={labelComp1} pct={rpDiffPct(actual.total_recaudado, comp1Val)} />}
                      {modo === 'mes' && <RpComparePct label="vs año ant." pct={rpDiffPct(actual.total_recaudado, datos?.mismo_mes_anyo?.total_recaudado)} />}
                    </div>
                  )}
                </div>
                {(() => {
                  const d = vistaAnyo || actual;
                  const ventas = Number(d.ventas_validas);
                  const base = Number(d.ganancia_base);
                  const libros = vistaAnyo ? vistaAnyo.libros : actual.libros_vendidos;
                  const hayGanancia = Number(actual.ganancia_base) > 0 || (conBarras && resumenAnios.some(r => r.ganancia_base > 0));
                  const lbl = { fontSize: 12, color: 'var(--ink-500)', textTransform: 'uppercase', letterSpacing: '0.08em', fontWeight: 500, marginBottom: 4 };
                  const val = txt => ({ fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: String(txt).length > 11 ? 16 : 19, whiteSpace: 'nowrap' });
                  const anyos = conBarras ? resumenAnios.map(r => r.anyo) : [];
                  const ultimo = anyos.length - 1;
                  const barras = (valores, etiqueta) => conBarras && (
                    <RpMiniBarras valores={valores} anyos={anyos} sel={anyoSel ?? ultimo} etiqueta={etiqueta}
                      onSel={i => setAnyoSel(i === ultimo ? null : i)} />
                  );
                  const ticketTxt = ventas > 0 ? repFmtClp(Math.round(Number(d.total_recaudado) / ventas)) : '—';
                  const gananciaTxt = base > 0 ? repFmtClp(d.ganancia) : '—';
                  return (
                    <div style={{ display: 'grid', gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)', gap: '14px 22px' }}>
                      <div>
                        <div style={lbl}>Ventas válidas</div>
                        <div style={val(ventas)}>{ventas}</div>
                        {!vistaAnyo && actual.ventas_anuladas > 0 && <div style={{ fontSize: 11, color: 'var(--bad-ink,#c0392b)', marginTop: 3 }}>{actual.ventas_anuladas} anulada{actual.ventas_anuladas !== 1 ? 's' : ''}</div>}
                        {barras(conBarras ? resumenAnios.map(r => r.ventas_validas) : [], v => String(v))}
                      </div>
                      <div>
                        <div style={lbl}>Ticket promedio</div>
                        <div style={val(ticketTxt)}>{ticketTxt}</div>
                        {barras(conBarras ? resumenAnios.map(r => (r.ventas_validas > 0 ? r.total_recaudado / r.ventas_validas : 0)) : [], v => repFmtClp(Math.round(v)))}
                      </div>
                      {hayGanancia && (
                        <div>
                          <div style={lbl}>Ganancia</div>
                          <div style={val(gananciaTxt)}>{gananciaTxt}</div>
                          {base > 0 && (
                            <div style={{ fontSize: 11, color: 'var(--ok-ink)', marginTop: 3, fontWeight: 500 }}>
                              {Math.round((Number(d.ganancia) / base) * 100)}% margen
                            </div>
                          )}
                          {barras(conBarras ? resumenAnios.map(r => r.ganancia) : [], v => repFmtClp(v))}
                        </div>
                      )}
                      {libros != null && (
                        <div>
                          <div style={lbl}>Libros vendidos</div>
                          <div style={val(libros)}>{Number(libros).toLocaleString('es-CL')}</div>
                          {barras(conBarras ? resumenAnios.map(r => r.libros) : [], v => Number(v).toLocaleString('es-CL'))}
                        </div>
                      )}
                    </div>
                  );
                })()}
              </div>
              {!mob && <hr style={{ border: 0, borderLeft: '1px solid var(--line-soft)', alignSelf: 'stretch', margin: 0 }} />}
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 12, color: 'var(--ink-500)', textTransform: 'uppercase', letterSpacing: '0.08em', fontWeight: 500, marginBottom: 0 }}>
                  {modo === 'anyo' ? `Meses de ${year}` : '3 años comparados'}
                </div>
                {datos.serie && <RpTrendBars
                  serie={modo === 'anyo'
                    ? datos.serie.map(s => ({ ...s, anyo: year }))
                    : datos.serie}
                  anyoActual={year} />}
                {modo === 'anyo' && Number(actual.ganancia_base) > 0 && <RpGananciaBars serie={datos.serie} />}
                {modo === 'mes' && datos.serie && Number(actual.ganancia_base) > 0 && (
                  <div style={{ marginTop: 14 }}>
                    <hr style={{ border: 0, borderTop: '1px solid var(--line-soft)', margin: '0 0 10px' }} />
                    <div style={{ fontSize: 12, color: 'var(--ink-500)', textTransform: 'uppercase', letterSpacing: '0.08em', fontWeight: 500, marginBottom: 0 }}>
                      Ganancia — 3 años comparados
                    </div>
                    <RpTrendBars serie={datos.serie} anyoActual={year} campo="ganancia" colores={ANYO_COLORES_GANANCIA} />
                  </div>
                )}
              </div>
            </div>
            <hr style={{ border: 0, borderTop: '1px solid var(--line-soft)', margin: '16px 0 0' }} />
            <div style={{ paddingTop: 16 }}>
              <RpPagoLinea actual={actual} />
            </div>
          </div>

          {/* ── Detalle — agrupado por día ── */}
          {datos.ventas && (
            <div style={{ ...card, marginBottom: 16, overflow: 'hidden' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 20px 0' }}>
                <span style={{ fontSize: 12, color: 'var(--ink-500)', textTransform: 'uppercase', letterSpacing: '0.08em', fontWeight: 500 }}>Detalle · {ventasMostradas.length} ventas</span>
                {actual.ventas_anuladas > 0 && (
                  <label style={{ fontSize: 12, color: 'var(--ink-500)', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 6 }}>
                    <input type="checkbox" checked={mostrarAnul} onChange={e => setMostrarAnul(e.target.checked)} />
                    Mostrar anuladas
                  </label>
                )}
              </div>
              {ventasMostradas.length === 0
                ? <p style={{ padding: '16px 20px', color: 'var(--ink-400)', fontSize: 13 }}>Sin ventas en este período.</p>
                : repAgruparPorDia(ventasMostradas).map(grupo => {
                    const totalGrupo = grupo.ventas.filter(v => v.estado !== 'anulada').reduce((s, v) => s + Number(v.total), 0);
                    return (
                      <div key={grupo.clave}>
                        <div style={{ display: 'flex', alignItems: 'baseline', gap: 10, padding: '14px 20px 8px', background: 'var(--paper-stripe)', marginTop: 12 }}>
                          <span style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 13.5, color: 'var(--ink-800)', textTransform: 'capitalize' }}>{repFmtDiaLargo(grupo.fecha)}</span>
                          <span style={{ fontSize: 12, color: 'var(--ink-500)' }}>· {grupo.ventas.length} venta{grupo.ventas.length !== 1 ? 's' : ''}</span>
                          <span style={{ marginLeft: 'auto', fontSize: 13, fontWeight: 600, color: 'var(--ink-700)', fontVariantNumeric: 'tabular-nums' }}>{repFmtClp(totalGrupo)}</span>
                        </div>
                        {/* overflow-x en vez de width:100% a secas — en pantallas angostas la columna Libros
                            se aplastaba tanto que el título se partía letra por letra; ahora la fila mantiene
                            un ancho mínimo legible y el usuario desliza en vez de leer texto roto. */}
                        <div style={{ overflowX: 'auto' }}>
                          <table style={{ width: '100%', minWidth: 480, borderCollapse: 'collapse' }}>
                            <tbody>
                              {grupo.ventas.map(v => <RepFilaVenta key={v.id} venta={v} onAnulada={fetchDatos} onLibroClick={setFichaLibro} soloHora />)}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    );
                  })
              }
            </div>
          )}

          {/* ── Análisis del período (colapsable) — solo mes ── */}
          {(datos.por_categoria || datos.mas_vendidos) && (
            <div style={{ ...card, overflow: 'hidden' }}>
              <button onClick={() => setAnalisisAb(a => !a)}
                style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 20px', background: 'none', border: 'none', cursor: 'pointer', fontFamily: 'inherit', textAlign: 'left' }}>
                <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--ink-800)' }}>Análisis del período</span>
                {analisisAb ? <ChevronUp size={16} color="var(--ink-500)" /> : <ChevronDown size={16} color="var(--ink-500)" />}
              </button>
              {analisisAb && (
                <div style={{ padding: '0 20px 20px', borderTop: '1px solid var(--line-soft)' }}>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 24, marginTop: 16 }}>
                    <div>
                      <div style={{ fontSize: 12, color: 'var(--ink-500)', textTransform: 'uppercase', letterSpacing: '0.08em', fontWeight: 500, marginBottom: 12 }}>Por categoría</div>
                      <RpCatBars categorias={datos.por_categoria} catExp={catExp} setCatExp={setCatExp} />
                    </div>
                    <div>
                      <div style={{ fontSize: 12, color: 'var(--ink-500)', textTransform: 'uppercase', letterSpacing: '0.08em', fontWeight: 500, marginBottom: 12 }}>Top libros</div>
                      <RpTopLibros libros={datos.mas_vendidos} />
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </>
      )}
      {!cargando && !actual && <p style={{ color: 'var(--ink-400)', fontSize: 14 }}>No hay datos para este período.</p>}
      {fichaLibro && <InvFichaLibro libro={fichaLibro} abierto={true} onClose={() => setFichaLibro(null)} onLibroActualizado={() => {}} />}
    </div>
  );
}

// --- Vista Pendientes (sub-tab de Consignación) ---
function RepPendientesView({ pendientes }) {
  const porDistribuidor = pendientes.reduce((acc, item) => {
    if (!acc[item.distribuidor_id]) acc[item.distribuidor_id] = { nombre: item.distribuidor, items: [] };
    acc[item.distribuidor_id].items.push(item);
    return acc;
  }, {});
  const totalGeneral = pendientes.reduce((sum, p) => sum + Number(p.total), 0);

  if (pendientes.length === 0) {
    return <p style={{ color: '#888', marginTop: '1rem' }}>No hay ventas consignadas pendientes de reporte. ✓</p>;
  }

  return (
    <div>
      <div style={{ background: '#f5f5f3', padding: '0.7rem 1.1rem', borderRadius: '8px', marginBottom: '1.5rem', display: 'inline-block' }}>
        <span style={{ fontSize: '0.82rem', color: '#888' }}>Total pendiente de reportar: </span>
        <span style={{ fontWeight: 800, fontSize: '1.1rem' }}>{repFmtClp(totalGeneral)}</span>
      </div>
      {Object.entries(porDistribuidor).map(([distribuidor_id, { nombre, items }]) => {
        const totalDist = items.reduce((sum, i) => sum + Number(i.total), 0);
        const hayAntiguas = items.some(i => i.es_periodo_anterior);
        return (
          <div key={distribuidor_id} style={{ marginBottom: '2rem', border: '1px solid #e0e0e0', borderRadius: '8px', overflow: 'hidden' }}>
            <div style={{ background: '#2c2c2a', color: 'white', padding: '0.7rem 1rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <span style={{ fontWeight: 600 }}>{nombre}</span>
                {hayAntiguas && <span style={{ marginLeft: '0.75rem', fontSize: '0.74rem', background: '#f0c040', color: '#2c2c2a', padding: '0.1rem 0.4rem', borderRadius: '4px', fontWeight: 700 }}>Incluye período anterior</span>}
              </div>
              <span style={{ color: '#f0c040', fontWeight: 700 }}>{repFmtClp(totalDist)}</span>
            </div>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ background: '#f9f9f9', fontSize: '0.8rem', color: '#aaa', textAlign: 'left', fontWeight: 600 }}>
                  <th style={{ padding: '0.45rem 0.75rem' }}>Título</th>
                  <th style={{ padding: '0.45rem 0.75rem' }}>Autor</th>
                  <th style={{ padding: '0.45rem 0.75rem' }}>ISBN</th>
                  <th style={{ padding: '0.45rem 0.75rem', textAlign: 'right' }}>Cant.</th>
                  <th style={{ padding: '0.45rem 0.75rem', textAlign: 'right' }}>Total</th>
                  <th style={{ padding: '0.45rem 0.75rem' }}>Última venta</th>
                </tr>
              </thead>
              <tbody>
                {items.map((item, i) => (
                  <tr key={i} style={{ borderBottom: '1px solid #eee', background: item.es_periodo_anterior ? '#fffdf0' : 'white' }}>
                    <td style={{ padding: '0.5rem 0.75rem', fontWeight: 600 }}>
                      {item.titulo}
                      {item.es_periodo_anterior && <span style={{ marginLeft: '0.4rem', fontSize: '0.72rem', background: '#fff3cd', color: '#856404', padding: '0.1rem 0.35rem', borderRadius: '4px', border: '1px solid #ffc107' }}>período ant.</span>}
                    </td>
                    <td style={{ padding: '0.5rem 0.75rem', color: '#666', fontSize: '0.9rem' }}>{item.autor}</td>
                    <td style={{ padding: '0.5rem 0.75rem', color: '#bbb', fontSize: '0.82rem' }}>{item.isbn || '—'}</td>
                    <td style={{ padding: '0.5rem 0.75rem', textAlign: 'right' }}>{item.cantidad}</td>
                    <td style={{ padding: '0.5rem 0.75rem', textAlign: 'right', fontWeight: 700 }}>{repFmtClp(item.total)}</td>
                    <td style={{ padding: '0.5rem 0.75rem', color: '#888', fontSize: '0.85rem' }}>{repFmtFecha(item.ultima_venta)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        );
      })}
    </div>
  );
}

// Líneas que se pre-seleccionan al crear un reporte: las que aún no están reportadas y caen en el período.
// Se compara solo el día (l.fecha viene con la hora y "2026-10-26 14:00" no es <= "2026-10-26").
function seleccionPendiente(lineas, desde, hasta) {
  return new Set(lineas
    .filter(l => { const f = String(l.fecha).slice(0, 10); return !l.reportado && (!desde || f >= desde) && (!hasta || f <= hasta); })
    .map(l => l.venta_detalle_id));
}

// --- Panel Crear Reporte ---
function RepPanelCrearReporte({ distribuidores, onReporteCreado, defaultDistId }) {
  const hoy = new Date().toISOString().slice(0, 10);
  const [distSelId,       setDistSelId]       = useState(defaultDistId || '');
  const [distSelNombre,   setDistSelNombre]   = useState(() => defaultDistId ? (distribuidores.find(d => String(d.id) === String(defaultDistId))?.nombre || '') : '');
  const [lineas,          setLineas]          = useState(null);
  const [ultimoReporte,   setUltimoReporte]   = useState(null);
  const [seleccionadas,   setSeleccionadas]   = useState(new Set());
  const [cargandoL,       setCargandoL]       = useState(false);
  const [creando,         setCreando]         = useState(false);
  const [gananciaDistrib, setGananciaDistrib] = useState('');
  const [desde,           setDesde]           = useState('');
  const [hasta,           setHasta]           = useState(hoy);

  useEffect(() => {
    if (!distSelId) { setLineas(null); setSeleccionadas(new Set()); return; }
    let activo = true;
    setCargandoL(true);
    api.get(`/consignacion/cargar-lista?distribuidor_id=${distSelId}`)
      .then(res => {
        if (!activo) return;
        const lineasData = res.data.lineas;
        const ult = res.data.ultimo_reporte;
        setLineas(lineasData);
        setUltimoReporte(ult);
        // Desde: día siguiente a la última venta YA reportada.
        // Si existe reporte previo pero ninguna venta tiene reportado=true (reporte roto),
        // usar la fecha más antigua disponible para que todas queden seleccionables.
        const desdeAuto = ult
          ? (() => {
              const fechasRep = lineasData.filter(l => l.reportado).map(l => l.fecha.slice(0, 10));
              if (fechasRep.length > 0) {
                const ultimaVentaRep = fechasRep.reduce((max, f) => f > max ? f : max, fechasRep[0]);
                const d = new Date(ultimaVentaRep + 'T12:00:00');
                d.setDate(d.getDate() + 1);
                return d.toISOString().slice(0, 10);
              }
              // Reporte previo pero sin ventas marcadas → incluir todo
              return lineasData.length > 0
                ? lineasData.reduce((min, l) => l.fecha.slice(0,10) < min ? l.fecha.slice(0,10) : min, lineasData[0].fecha.slice(0,10))
                : hoy;
            })()
          : (lineasData.length > 0 ? lineasData.reduce((min, l) => l.fecha < min ? l.fecha : min, lineasData[0].fecha).slice(0, 10) : hoy);
        // Las ventas del sistema sin reportar entran siempre, aunque sean anteriores a la última venta reportada: son las
        // que el módulo cuenta como "pendiente", y si quedaran fuera el pendiente no llegaría a $0 al crear el reporte.
        const masAntiguaPend = lineasData
          .filter(l => !l.reportado && (l.origen === 'sistema' || l.origen === 'perdida'))
          .map(l => l.fecha.slice(0, 10))
          .reduce((min, f) => (min && min < f ? min : f), '');
        const desdeFinal = masAntiguaPend && masAntiguaPend < desdeAuto ? masAntiguaPend : desdeAuto;
        setDesde(desdeFinal);
        setHasta(hoy);
        setSeleccionadas(seleccionPendiente(lineasData, desdeFinal, hoy));
        const primera = lineasData.find(l => l.pvp > 0 && l.costo_real > 0);
        if (primera) {
          const gPct = Math.round((1 - primera.costo_real / primera.pvp) * 10000) / 100;
          setGananciaDistrib(String(gPct));
        }
      })
      .catch(console.error)
      .finally(() => { if (activo) setCargandoL(false); });
    return () => { activo = false; };
  }, [distSelId]);

  // Cuando cambia el rango de fechas, pre-seleccionar solo las no reportadas del período
  useEffect(() => {
    if (!lineas) return;
    setSeleccionadas(seleccionPendiente(lineas, desde, hasta));
  }, [desde, hasta]); // eslint-disable-line react-hooks/exhaustive-deps

  async function toggleReportado(linea) {
    const nuevoValor = !linea.reportado;
    setLineas(prev => prev.map(l => l.venta_detalle_id === linea.venta_detalle_id ? { ...l, reportado: nuevoValor } : l));
    try {
      await api.patch('/consignacion/venta-reportado', { id: linea.venta_detalle_id, origen: linea.origen, reportado: nuevoValor });
    } catch {
      // revertir si falla
      setLineas(prev => prev.map(l => l.venta_detalle_id === linea.venta_detalle_id ? { ...l, reportado: linea.reportado } : l));
    }
  }

  function toggleLinea(id) {
    setSeleccionadas(prev => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id); else next.add(id);
      return next;
    });
  }
  function toggleTodas() {
    if (!lineas) return;
    const todas = lineas.every(l => seleccionadas.has(l.venta_detalle_id));
    setSeleccionadas(todas ? new Set() : new Set(lineas.map(l => l.venta_detalle_id)));
  }

  const totalSel    = lineas ? lineas.filter(l => seleccionadas.has(l.venta_detalle_id)).reduce((s, l) => s + Number(l.subtotal), 0) : 0;
  // Pérdidas a pagar (bajas de stock de consignación): no son ventas, se le pagan al distribuidor a costo + IVA
  const costoPerdida = l => Math.round(Number(l.costo_ajustado ?? l.costo_real ?? 0) * Number(l.cantidad));
  const perdidaSel   = lineas ? lineas.filter(l => l.origen === 'perdida' && seleccionadas.has(l.venta_detalle_id)).reduce((s, l) => s + costoPerdida(l), 0) : 0;
  const nPerdidaSel  = lineas ? lineas.filter(l => l.origen === 'perdida' && seleccionadas.has(l.venta_detalle_id)).length : 0;
  const todasSel    = lineas ? lineas.length > 0 && lineas.every(l => seleccionadas.has(l.venta_detalle_id)) : false;
  const gPctNum     = parseFloat(gananciaDistrib);
  const gananciaOk  = gananciaDistrib !== '' && !isNaN(gPctNum) && gPctNum > 0 && gPctNum < 100;
  const pagoDistrib = gananciaOk ? Math.round(totalSel * (1 - gPctNum / 100)) + perdidaSel : null;

  async function confirmarReporte() {
    if (seleccionadas.size === 0) { alert('Seleccioná al menos una línea para incluir en el reporte.'); return; }
    // Ventas sin reportar que no van en este reporte: quedan como pendiente del distribuidor, así que se avisa
    const sinIncluir = lineas.filter(l => !l.reportado && l.origen === 'sistema' && !seleccionadas.has(l.venta_detalle_id));
    const avisoPend = sinIncluir.length > 0
      ? `\n\nOjo: ${sinIncluir.length} venta${sinIncluir.length !== 1 ? 's' : ''} sin reportar de ${distSelNombre} (${repFmtClp(sinIncluir.reduce((s, l) => s + Number(l.subtotal), 0))}) no va${sinIncluir.length !== 1 ? 'n' : ''} en este reporte y seguirá${sinIncluir.length !== 1 ? 'n' : ''} como pendiente.`
      : '';
    const perdSinIncluir = lineas.filter(l => l.origen === 'perdida' && !seleccionadas.has(l.venta_detalle_id));
    const avisoPerd = perdSinIncluir.length > 0
      ? `\n\nOjo: ${perdSinIncluir.length} pérdida${perdSinIncluir.length !== 1 ? 's' : ''} a pagar (${repFmtClp(perdSinIncluir.reduce((s, l) => s + costoPerdida(l), 0))}) no va${perdSinIncluir.length !== 1 ? 'n' : ''} en este reporte y seguirá${perdSinIncluir.length !== 1 ? 'n' : ''} pendiente${perdSinIncluir.length !== 1 ? 's' : ''}.`
      : '';
    const detalleMontos = nPerdidaSel > 0 ? `ventas ${repFmtClp(totalSel)} + ${nPerdidaSel} pérdida${nPerdidaSel !== 1 ? 's' : ''} a pagar ${repFmtClp(perdidaSel)}` : repFmtClp(totalSel);
    if (!window.confirm(`¿Crear reporte para ${distSelNombre} con ${seleccionadas.size} línea${seleccionadas.size !== 1 ? 's' : ''} (${detalleMontos})?${avisoPend}${avisoPerd}`)) return;
    setCreando(true);
    try {
      const resp = await api.post('/consignacion/reportes', {
        distribuidor_id: distSelId,
        distribuidor_nombre: distSelNombre,
        lineas: Array.from(seleccionadas).map(id => {
          const l = lineas.find(x => x.venta_detalle_id === id);
          return { id, origen: l?.origen || 'sistema' };
        }),
      });
      if (resp.data?.lineas_omitidas > 0) {
        alert(`Reporte creado, pero ${resp.data.lineas_omitidas} línea${resp.data.lineas_omitidas !== 1 ? 's' : ''} no se pudo incluir (ya reportada, anulada o sin lote de este distribuidor) y sigue pendiente.`);
      }
      onReporteCreado();
    } catch (err) {
      alert(err.response?.data?.error || 'Error al crear reporte');
    }
    setCreando(false);
  }

  if (distribuidores.length === 0) {
    return <p style={{ color: '#888', marginTop: '1rem' }}>No hay ventas consignadas pendientes de reportar.</p>;
  }

  return (
    <div>
      <div style={{ marginBottom: '1.25rem', maxWidth: 380 }}>
        <label style={{ display: 'block', fontSize: '0.85rem', color: '#666', marginBottom: '0.35rem' }}>Distribuidor</label>
        <select
          value={distSelId}
          onChange={e => {
            const d = distribuidores.find(d => d.id === e.target.value);
            setDistSelId(e.target.value);
            setDistSelNombre(d?.nombre || '');
          }}
          style={{ width: '100%', padding: '0.6rem', border: '1px solid #ddd', borderRadius: '6px', fontSize: '0.95rem' }}
        >
          <option value="">Seleccionar distribuidor…</option>
          {distribuidores.map(d => <option key={d.id} value={d.id}>{d.nombre}</option>)}
        </select>
      </div>

      {ultimoReporte && (
        <div style={{ background: '#f5f5f3', borderRadius: '6px', padding: '0.6rem 1rem', marginBottom: '1rem', fontSize: '0.84rem', color: '#666' }}>
          Último reporte: <strong>{ultimoReporte.nombre}</strong> · {repFmtFecha(ultimoReporte.creado_en)}
        </div>
      )}

      {/* Rango de fechas */}
      {lineas && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: '1rem', padding: '0.75rem 1rem', background: '#f5f5f3', borderRadius: 8, flexWrap: 'wrap' }}>
          <span style={{ fontSize: '0.88rem', color: '#555', fontWeight: 600 }}>Período del reporte</span>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <label style={{ fontSize: '0.83rem', color: '#888' }}>Desde</label>
            <input type="date" value={desde} onChange={e => setDesde(e.target.value)}
              style={{ padding: '0.3rem 0.5rem', border: '1px solid #ddd', borderRadius: 6, fontSize: '0.88rem' }} />
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <label style={{ fontSize: '0.83rem', color: '#888' }}>Hasta</label>
            <input type="date" value={hasta} onChange={e => setHasta(e.target.value)}
              style={{ padding: '0.3rem 0.5rem', border: '1px solid #ddd', borderRadius: 6, fontSize: '0.88rem' }} />
          </div>
          <span style={{ fontSize: '0.82rem', color: '#1a56db', marginLeft: 4 }}>
            {lineas.filter(l => { const f = l.fecha.slice(0,10); return l.origen !== 'perdida' && (!desde || f >= desde) && (!hasta || f <= hasta); }).length} venta{lineas.filter(l => { const f = l.fecha.slice(0,10); return l.origen !== 'perdida' && (!desde || f >= desde) && (!hasta || f <= hasta); }).length !== 1 ? 's' : ''} en el período
          </span>
        </div>
      )}

      {cargandoL && <p style={{ color: '#999' }}>Cargando líneas...</p>}

      {lineas && lineas.length === 0 && <p style={{ color: '#888' }}>No hay ventas pendientes para este distribuidor.</p>}

      {lineas && lineas.length > 0 && (
        <>
          {/* Campo ganancia % */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: '1rem', padding: '0.75rem 1rem', background: '#f5f5f3', borderRadius: 8 }}>
            <label style={{ fontSize: '0.88rem', color: '#555', whiteSpace: 'nowrap' }}>Ganancia librería %</label>
            <input
              type="number" min="0" max="99" step="0.01"
              value={gananciaDistrib}
              onChange={e => setGananciaDistrib(e.target.value)}
              placeholder="ej: 40"
              style={{ width: 80, padding: '0.35rem 0.6rem', border: '1px solid #ddd', borderRadius: 6, fontSize: '0.95rem', textAlign: 'right' }}
            />
            <span style={{ fontSize: '0.84rem', color: '#888' }}>%</span>
            {gananciaOk && (
              <span style={{ fontSize: '0.84rem', color: '#1a6b3c', marginLeft: 6 }}>
                → Pago al distribuidor: <strong>{repFmtClp(pagoDistrib)}</strong> de {repFmtClp(totalSel)} en ventas{perdidaSel > 0 && ` + ${repFmtClp(perdidaSel)} en pérdidas`}
              </span>
            )}
            {!gananciaOk && gananciaDistrib !== '' && (
              <span style={{ fontSize: '0.82rem', color: '#c0571a' }}>Debe ser entre 1 y 99</span>
            )}
          </div>

          <div style={{ border: '1px solid #e0e0e0', borderRadius: '8px', overflow: 'hidden', marginBottom: '1rem' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ background: '#f9f9f9', fontSize: '0.8rem', color: '#aaa', textAlign: 'left', fontWeight: 600, borderBottom: '1px solid #e8e8e8' }}>
                  <th style={{ padding: '0.5rem', textAlign: 'center' }}>
                    <input type="checkbox" checked={todasSel} onChange={toggleTodas} title="Seleccionar todas" />
                  </th>
                  <th style={{ padding: '0.5rem' }}>Fecha venta</th>
                  <th style={{ padding: '0.5rem' }}>Título</th>
                  <th style={{ padding: '0.5rem', textAlign: 'right' }}>Cant.</th>
                  <th style={{ padding: '0.5rem', textAlign: 'right' }}>PVP</th>
                  <th style={{ padding: '0.5rem', textAlign: 'right' }}>Neto</th>
                  <th style={{ padding: '0.5rem', textAlign: 'right' }}>Subtotal</th>
                  {gananciaOk && <th style={{ padding: '0.5rem', textAlign: 'right' }}>Pago dist.</th>}
                </tr>
              </thead>
              <tbody>
                {[...lineas.filter(l => l.origen !== 'perdida'), ...lineas.filter(l => l.origen === 'perdida')].map((l, idx, arr) => {
                  const sel = seleccionadas.has(l.venta_detalle_id);
                  if (l.origen === 'perdida') {
                    const costo = costoPerdida(l);
                    return (
                      <React.Fragment key={l.venta_detalle_id}>
                        {(idx === 0 || arr[idx - 1].origen !== 'perdida') && (
                          <tr style={{ background: '#f9f9f9' }}>
                            <td colSpan={gananciaOk ? 8 : 7} style={{ padding: '0.4rem 0.75rem', fontSize: '0.78rem', fontWeight: 600, color: '#856404' }}>
                              Pérdidas por pagar (bajas de stock de consignación)
                            </td>
                          </tr>
                        )}
                        <tr onClick={() => toggleLinea(l.venta_detalle_id)}
                          style={{ borderBottom: '1px solid #eee', background: '#fff8e1', opacity: sel ? 1 : 0.45, cursor: 'pointer' }}>
                          <td style={{ padding: '0.5rem', textAlign: 'center' }}>
                            <input type="checkbox" checked={sel} onChange={() => toggleLinea(l.venta_detalle_id)} onClick={e => e.stopPropagation()} />
                          </td>
                          <td style={{ padding: '0.5rem', fontSize: '0.84rem', color: '#666', whiteSpace: 'nowrap' }}>{repFmtFecha(l.fecha)}</td>
                          <td style={{ padding: '0.5rem' }}>
                            <div style={{ fontWeight: sel ? 600 : 400, display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
                              {l.titulo}
                              <span style={{ fontSize: '0.7rem', padding: '0.1rem 0.45rem', borderRadius: 20, background: '#fff3cd', color: '#856404', border: '1px solid #ffe69c', fontWeight: 600, lineHeight: 1.4 }}>Pérdida a pagar</span>
                            </div>
                            <div style={{ fontSize: '0.8rem', color: '#aaa' }}>{l.autor}</div>
                          </td>
                          <td style={{ padding: '0.5rem', textAlign: 'right' }}>{l.cantidad}</td>
                          <td style={{ padding: '0.5rem', textAlign: 'right', color: '#bbb' }}>—</td>
                          <td style={{ padding: '0.5rem', textAlign: 'right', color: '#bbb' }}>—</td>
                          <td style={{ padding: '0.5rem', textAlign: 'right', fontWeight: 700, color: '#856404' }} title="Costo + IVA que se le paga al distribuidor">{repFmtClp(costo)}</td>
                          {gananciaOk && <td style={{ padding: '0.5rem', textAlign: 'right', color: '#c0571a', fontWeight: 600, fontSize: '0.88rem' }}>{sel ? repFmtClp(costo) : '—'}</td>}
                        </tr>
                      </React.Fragment>
                    );
                  }
                  const pvp  = Number(l.pvp) || Number(l.precio_unitario);
                  const neto = pvp > 0 ? Math.round(pvp / 1.19) : null;
                  const pagoLinea = gananciaOk ? Math.round(Number(l.subtotal) * (1 - gPctNum / 100)) : null;
                  const fSola = l.fecha.slice(0, 10);
                  const fueraPeriodo = (desde && fSola < desde) || (hasta && fSola > hasta);
                  return (
                    <tr
                      key={l.venta_detalle_id}
                      onClick={() => toggleLinea(l.venta_detalle_id)}
                      style={{ borderBottom: '1px solid #eee', background: fueraPeriodo ? '#f8f8f8' : l.es_periodo_anterior ? '#fffdf0' : 'white', opacity: sel ? 1 : 0.45, cursor: 'pointer' }}
                    >
                      <td style={{ padding: '0.5rem', textAlign: 'center' }}>
                        <input type="checkbox" checked={sel} onChange={() => toggleLinea(l.venta_detalle_id)} onClick={e => e.stopPropagation()} />
                      </td>
                      <td style={{ padding: '0.5rem', fontSize: '0.84rem', color: '#666', whiteSpace: 'nowrap' }}>
                        {repFmtFecha(l.fecha)}
                        {fueraPeriodo && <span style={{ marginLeft: '0.35rem', fontSize: '0.72rem', background: '#e8e8e8', color: '#888', padding: '0.1rem 0.3rem', borderRadius: '4px' }}>fuera del período</span>}
                        {!fueraPeriodo && l.es_periodo_anterior && <span style={{ marginLeft: '0.35rem', fontSize: '0.72rem', background: '#fff3cd', color: '#856404', padding: '0.1rem 0.3rem', borderRadius: '4px' }}>período ant.</span>}
                      </td>
                      <td style={{ padding: '0.5rem' }}>
                        <div style={{ fontWeight: sel ? 600 : 400, display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
                          {l.titulo}
                          {l.reportado && (
                            <button
                              onClick={e => { e.stopPropagation(); toggleReportado(l); }}
                              title="Esta venta ya fue reportada. Clic para quitar el tag."
                              style={{ display: 'inline-flex', alignItems: 'center', gap: 3, fontSize: '0.7rem', padding: '0.1rem 0.45rem', borderRadius: 20, background: '#dbeafe', color: '#1a56db', border: '1px solid #bfdbfe', cursor: 'pointer', fontWeight: 600, lineHeight: 1.4 }}
                            >
                              ✓ Reportada ×
                            </button>
                          )}
                          {l.oferta_nombre && (
                            <span title={`Oferta: ${l.oferta_nombre} — distribuidor absorbe ${l.pct_distribuidor}%`}
                              style={{ display: 'inline-flex', alignItems: 'center', gap: 3, fontSize: '0.7rem', padding: '0.1rem 0.45rem', borderRadius: 20, background: '#dcfce7', color: '#166534', border: '1px solid #bbf7d0', fontWeight: 600, lineHeight: 1.4 }}>
                              🏷 {l.oferta_nombre}
                            </span>
                          )}
                        </div>
                        <div style={{ fontSize: '0.8rem', color: '#aaa' }}>{l.autor}</div>
                      </td>
                      <td style={{ padding: '0.5rem', textAlign: 'right' }}>{l.cantidad}</td>
                      <td style={{ padding: '0.5rem', textAlign: 'right', color: '#555', fontSize: '0.88rem' }}>{pvp > 0 ? repFmtClp(pvp) : '—'}</td>
                      <td style={{ padding: '0.5rem', textAlign: 'right', color: '#888', fontSize: '0.85rem' }}>{neto ? repFmtClp(neto) : '—'}</td>
                      <td style={{ padding: '0.5rem', textAlign: 'right', fontWeight: 700 }}>{repFmtClp(l.subtotal)}</td>
                      {gananciaOk && <td style={{ padding: '0.5rem', textAlign: 'right', color: '#c0571a', fontWeight: 600, fontSize: '0.88rem' }}>{sel ? repFmtClp(pagoLinea) : '—'}</td>}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#2c2c2a', color: 'white', padding: '0.75rem 1rem', borderRadius: '8px', flexWrap: 'wrap', gap: '0.5rem' }}>
            <div style={{ fontSize: '0.9rem' }}>
              <strong>{seleccionadas.size}</strong> línea{seleccionadas.size !== 1 ? 's' : ''} · ventas <span style={{ color: '#f0c040', fontWeight: 700 }}>{repFmtClp(totalSel)}</span>
              {nPerdidaSel > 0 && <span style={{ marginLeft: 12, color: '#ffd37a' }}>· {nPerdidaSel} pérdida{nPerdidaSel !== 1 ? 's' : ''} <strong>{repFmtClp(perdidaSel)}</strong></span>}
              {pagoDistrib !== null && (
                <span style={{ marginLeft: 12, color: '#fca5a5' }}>· pago dist. <strong>{repFmtClp(pagoDistrib)}</strong></span>
              )}
            </div>
            <button onClick={confirmarReporte} disabled={creando || seleccionadas.size === 0} style={{ padding: '0.5rem 1.25rem', background: '#f0c040', color: '#2c2c2a', border: 'none', cursor: 'pointer', borderRadius: '6px', fontWeight: 700, fontSize: '0.9rem' }}>
              {creando ? 'Creando...' : 'Confirmar reporte'}
            </button>
          </div>
        </>
      )}
    </div>
  );
}

// --- Detalle de un reporte (reutilizable) ---
function RepDetalleReporte({ reporte, onVolver }) {
  const [lineas,      setLineas]      = useState([]);
  const [cargando,    setCargando]    = useState(true);

  useEffect(() => {
    setCargando(true);
    api.get(`/consignacion/reportes/${reporte.id}/detalle`)
      .then(res => setLineas(res.data))
      .catch(() => alert('Error al cargar detalle del reporte'))
      .finally(() => setCargando(false));
  }, [reporte.id]);

  async function exportar() {
    try {
      const data = lineas.length > 0 ? lineas : (await api.get(`/consignacion/reportes/${reporte.id}/detalle`)).data;
      const filas = data.map(d => d.es_perdida
        ? { ISBN: d.isbn || '—', Título: d.titulo, Autor: d.autor, Editorial: d.editorial || '—', Cantidad: d.cantidad, 'Precio unitario': '', Total: '', Tipo: 'Pérdida a pagar', 'Costo c/IVA': Number(d.costo_real || 0) * Number(d.cantidad) }
        : { ISBN: d.isbn || '—', Título: d.titulo, Autor: d.autor, Editorial: d.editorial || '—', Cantidad: d.cantidad, 'Precio unitario': d.precio_unitario, Total: d.total, Tipo: 'Venta', 'Costo c/IVA': Number(d.costo_real || 0) * Number(d.cantidad) });
      const ws = XLSX.utils.json_to_sheet(filas);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Consignación');
      const buf = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      saveAs(new Blob([buf], { type: 'application/octet-stream' }), `${reporte.nombre}.xlsx`);
    } catch { alert('Error al exportar reporte'); }
  }

  return (
    <div>
      <button onClick={onVolver} style={{ display: 'inline-flex', alignItems: 'center', gap: 6, marginBottom: 18, background: 'none', border: 'none', cursor: 'pointer', color: 'var(--ink-600)', fontSize: 13, fontFamily: 'inherit' }}>
        <ChevronLeft size={16} strokeWidth={2} /> Volver
      </button>
      <div style={{ background: 'var(--paper)', border: '1px solid var(--line)', borderRadius: 14, padding: '16px 20px', marginBottom: 16, display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'wrap' }}>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 3 }}>
            {reporte.distribuidor_nombre || reporte.distribuidor} · {repFmtMesAno(reporte.creado_en)}
          </div>
          <div style={{ fontSize: 12.5, color: 'var(--ink-500)', display: 'flex', gap: 12, flexWrap: 'wrap' }}>
            {repFmtRango(reporte.fecha_inicio, reporte.fecha_fin)
              ? <span>Período: <strong style={{ color: 'var(--ink-700)' }}>{repFmtRango(reporte.fecha_inicio, reporte.fecha_fin)}</strong></span>
              : <span>Cerrado: {repFmtFecha(reporte.creado_en)}</span>
            }
            {reporte.enviado_en && <span>Enviado: {repFmtFecha(reporte.enviado_en)}</span>}
          </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', borderLeft: '1px solid var(--line)', paddingLeft: 20, flexShrink: 0 }}>
          <span style={{ fontSize: 11, fontWeight: 600, color: 'var(--ink-400)', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: 3 }}>Total a pagar</span>
          <span style={{ fontSize: 22, fontWeight: 700, color: 'var(--ink-900)', fontVariantNumeric: 'tabular-nums', lineHeight: 1.2 }}>
            {cargando ? '—' : repFmtClp(lineas.reduce((s, l) => s + Number(l.costo_real || 0) * Number(l.cantidad), 0))}
          </span>
        </div>
        <button onClick={exportar} style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '8px 14px', background: '#1a6b3c', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 13, fontWeight: 600, fontFamily: 'inherit', flexShrink: 0 }}>
          <Download size={14} strokeWidth={2} /> Excel
        </button>
      </div>
      {cargando
        ? <p style={{ color: 'var(--ink-400)', fontSize: 13 }}>Cargando libros...</p>
        : lineas.length === 0
          ? <p style={{ color: '#888' }}>Sin líneas registradas.</p>
          : (
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.87rem' }}>
                <thead>
                  <tr style={{ textAlign: 'left', borderBottom: '2px solid var(--line)', fontSize: '0.79rem', color: 'var(--ink-400)', fontWeight: 600 }}>
                    <th style={{ padding: '0.45rem 0.5rem' }}>ISBN</th>
                    <th style={{ padding: '0.45rem 0.5rem' }}>Título</th>
                    <th style={{ padding: '0.45rem 0.5rem' }}>Autor</th>
                    <th style={{ padding: '0.45rem 0.5rem' }}>Editorial</th>
                    <th style={{ padding: '0.45rem 0.5rem', textAlign: 'right' }}>Cant.</th>
                    <th style={{ padding: '0.45rem 0.5rem', textAlign: 'right' }}>Precio unit.</th>
                    <th style={{ padding: '0.45rem 0.5rem', textAlign: 'right' }}>Total</th>
                  </tr>
                </thead>
                <tbody>
                  {lineas.map((l, i) => (
                    <tr key={i} style={{ borderBottom: '1px solid var(--line-soft)' }}>
                      <td style={{ padding: '0.45rem 0.5rem', fontFamily: 'monospace', fontSize: '0.8rem', color: 'var(--ink-400)' }}>{l.isbn || '—'}</td>
                      <td style={{ padding: '0.45rem 0.5rem', fontWeight: 600 }}>
                        {l.titulo}
                        {l.es_perdida && <span style={{ marginLeft: 6, fontSize: '0.7rem', padding: '0.1rem 0.45rem', borderRadius: 20, background: '#fff3cd', color: '#856404', border: '1px solid #ffe69c', fontWeight: 600 }}>Pérdida a pagar</span>}
                      </td>
                      <td style={{ padding: '0.45rem 0.5rem', color: 'var(--ink-500)', fontSize: '0.84rem' }}>{l.autor}</td>
                      <td style={{ padding: '0.45rem 0.5rem', color: 'var(--ink-400)', fontSize: '0.84rem' }}>{l.editorial || '—'}</td>
                      <td style={{ padding: '0.45rem 0.5rem', textAlign: 'right' }}>{l.cantidad}</td>
                      <td style={{ padding: '0.45rem 0.5rem', textAlign: 'right', color: 'var(--ink-500)' }}>{l.es_perdida ? '—' : repFmtClp(l.precio_unitario)}</td>
                      <td style={{ padding: '0.45rem 0.5rem', textAlign: 'right', fontWeight: 700 }}>{l.es_perdida ? '—' : repFmtClp(l.total)}</td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr style={{ borderTop: '2px solid var(--line)' }}>
                    <td colSpan={4} style={{ padding: '0.5rem', fontWeight: 600, color: 'var(--ink-500)', fontSize: '0.82rem' }}>{lineas.length} título{lineas.length !== 1 ? 's' : ''}</td>
                    <td style={{ padding: '0.5rem', textAlign: 'right', fontWeight: 700 }}>{lineas.reduce((s, l) => s + Number(l.cantidad), 0)}</td>
                    <td></td>
                    <td style={{ padding: '0.5rem', textAlign: 'right', fontWeight: 700, color: 'var(--brand)' }}>{repFmtClp(lineas.reduce((s, l) => s + Number(l.total), 0))}</td>
                  </tr>
                </tfoot>
              </table>
            </div>
          )
      }
    </div>
  );
}

// --- Historial de Reportes ---
function RepHistorialReportes({ reportes, onVerDetalle }) {
  if (reportes.length === 0) return <p style={{ color: '#888', marginTop: '1rem' }}>No hay reportes enviados todavía.</p>;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      {reportes.map(r => (
        <div key={r.id} onClick={() => onVerDetalle(r)}
          style={{ background: 'var(--paper)', border: '1px solid var(--line)', borderRadius: 12, padding: '12px 16px', display: 'flex', alignItems: 'center', gap: 14, cursor: 'pointer' }}
          onMouseEnter={e => e.currentTarget.style.background = 'var(--paper-stripe,#f9f9f7)'}
          onMouseLeave={e => e.currentTarget.style.background = 'var(--paper)'}>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontWeight: 600, fontSize: 13.5, marginBottom: 2 }}>
              {repFmtMesAno(r.creado_en).replace(' de ', ' ').replace(/^./, c => c.toUpperCase())}
            </div>
            <div style={{ fontSize: 12, color: 'var(--ink-500)' }}>
              {repFmtRango(r.fecha_inicio, r.fecha_fin) || repFmtFecha(r.creado_en)}
            </div>
          </div>
          <div style={{ fontWeight: 700, fontSize: 15, fontVariantNumeric: 'tabular-nums', flexShrink: 0 }}>{repFmtClp(r.total_costo || 0)}</div>
          <ChevronRight size={16} strokeWidth={2} color="var(--ink-300)" style={{ flexShrink: 0 }} />
        </div>
      ))}
    </div>
  );
}

// --- Facturas y Pagos ---
function RepFacturasView({ facturas, reportes, onActualizado }) {
  const [mostrarForm, setMostrarForm] = useState(false);
  const [form, setForm] = useState({ reporte_id: '', distribuidor_id: '', numero_factura: '', monto: '', fecha_factura: new Date().toISOString().split('T')[0], notas: '' });

  async function registrar(e) {
    e.preventDefault();
    try {
      await api.post('/consignacion/facturas', form);
      setMostrarForm(false);
      setForm({ reporte_id: '', distribuidor_id: '', numero_factura: '', monto: '', fecha_factura: new Date().toISOString().split('T')[0], notas: '' });
      onActualizado();
    } catch {
      alert('Error al registrar factura');
    }
  }

  async function actualizarPago(id, estado, monto_pagado) {
    await api.patch(`/consignacion/facturas/${id}`, { estado, monto_pagado });
    onActualizado();
  }

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '1rem' }}>
        <button onClick={() => setMostrarForm(v => !v)} style={{ padding: '0.45rem 1rem', background: '#2c2c2a', color: 'white', border: 'none', cursor: 'pointer', borderRadius: '6px', fontSize: '0.88rem' }}>
          {mostrarForm ? '✕ Cancelar' : '+ Registrar factura'}
        </button>
      </div>
      {mostrarForm && (
        <form onSubmit={registrar} style={{ background: '#f9f9f9', padding: '1rem', borderRadius: '8px', marginBottom: '1.5rem', border: '1px solid #e0e0e0' }}>
          <h4 style={{ marginTop: 0, marginBottom: '0.75rem' }}>Nueva factura de consignación</h4>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.65rem' }}>
            <select value={form.reporte_id} onChange={e => {
              const r = reportes.find(r => r.id === e.target.value);
              setForm({ ...form, reporte_id: e.target.value, distribuidor_id: r?.distribuidor_id || '', monto: r?.total || '' });
            }} required style={{ padding: '0.5rem', gridColumn: '1 / -1' }}>
              <option value="">Seleccionar reporte *</option>
              {reportes.map(r => <option key={r.id} value={r.id}>{r.nombre}</option>)}
            </select>
            <input placeholder="N° factura" value={form.numero_factura} onChange={e => setForm({ ...form, numero_factura: e.target.value })} style={{ padding: '0.5rem' }} />
            <input type="number" placeholder="Monto *" value={form.monto} onChange={e => setForm({ ...form, monto: e.target.value })} required style={{ padding: '0.5rem' }} />
            <input type="date" value={form.fecha_factura} onChange={e => setForm({ ...form, fecha_factura: e.target.value })} style={{ padding: '0.5rem' }} />
            <input placeholder="Notas (opcional)" value={form.notas} onChange={e => setForm({ ...form, notas: e.target.value })} style={{ padding: '0.5rem', gridColumn: '1 / -1' }} />
            <button type="submit" style={{ gridColumn: '1 / -1', padding: '0.5rem', background: '#2c2c2a', color: 'white', border: 'none', cursor: 'pointer', borderRadius: '4px' }}>Registrar</button>
          </div>
        </form>
      )}
      {facturas.length === 0
        ? <p style={{ color: '#888' }}>No hay facturas registradas.</p>
        : (
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ textAlign: 'left', borderBottom: '2px solid #e0e0e0', fontSize: '0.8rem', color: '#aaa', fontWeight: 600 }}>
                <th style={{ padding: '0.5rem' }}>Distribuidor</th>
                <th style={{ padding: '0.5rem' }}>N° Factura</th>
                <th style={{ padding: '0.5rem', textAlign: 'right' }}>Monto</th>
                <th style={{ padding: '0.5rem' }}>Estado</th>
                <th style={{ padding: '0.5rem' }}>Acción</th>
              </tr>
            </thead>
            <tbody>
              {facturas.map(f => (
                <tr key={f.id} style={{ borderBottom: '1px solid #eee' }}>
                  <td style={{ padding: '0.5rem' }}>{f.distribuidor_nombre}</td>
                  <td style={{ padding: '0.5rem', color: '#888', fontSize: '0.88rem' }}>{f.numero_factura || '—'}</td>
                  <td style={{ padding: '0.5rem', fontWeight: 700, textAlign: 'right' }}>{repFmtClp(f.monto)}</td>
                  <td style={{ padding: '0.5rem' }}>
                    <span style={{ background: f.estado === 'pagado' ? '#5cb85c' : f.estado === 'parcial' ? '#f0c040' : '#d9534f', color: f.estado === 'parcial' ? '#2c2c2a' : 'white', padding: '0.2rem 0.6rem', borderRadius: '20px', fontSize: '0.78rem', fontWeight: 600 }}>
                      {f.estado}
                    </span>
                  </td>
                  <td style={{ padding: '0.5rem', display: 'flex', gap: '0.35rem' }}>
                    {f.estado !== 'pagado' && (
                      <>
                        <button onClick={() => actualizarPago(f.id, 'pagado', f.monto)} style={{ background: '#5cb85c', color: 'white', border: 'none', padding: '0.25rem 0.5rem', cursor: 'pointer', borderRadius: '4px', fontSize: '0.78rem' }}>Pagado</button>
                        <button onClick={() => actualizarPago(f.id, 'parcial', f.monto_pagado)} style={{ background: '#f0c040', color: '#2c2c2a', border: 'none', padding: '0.25rem 0.5rem', cursor: 'pointer', borderRadius: '4px', fontSize: '0.78rem' }}>Parcial</button>
                      </>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )
      }
    </div>
  );
}

// --- Helper visual: sección colapsable con badge en el preview ---
function SeccionPreview({ titulo, badge, badgeColor, vacia, msgVacio, children, onAplicar, aplicarLabel, aplicando }) {
  return (
    <div style={{ border: '1px solid #e8e8e8', borderRadius: '8px', marginBottom: '1rem', overflow: 'auto', maxHeight: 'calc(100vh - 120px)' }}>
      <div style={{ background: '#f9f9f9', padding: '0.65rem 1rem', display: 'flex', alignItems: 'center', gap: '0.6rem', borderBottom: '1px solid #e8e8e8', position: 'sticky', top: 0, zIndex: 3 }}>
        <span style={{ fontWeight: 700, fontSize: '0.9rem', color: '#2c2c2a' }}>{titulo}</span>
        <span style={{ background: badgeColor, color: 'white', borderRadius: '20px', padding: '0.1rem 0.55rem', fontSize: '0.78rem', fontWeight: 700 }}>{badge}</span>
      </div>
      <div style={{ padding: '0.75rem 1rem' }}>
        {vacia ? <p style={{ margin: 0, color: '#aaa', fontSize: '0.88rem' }}>{msgVacio}</p> : children}
      </div>
      {onAplicar && !vacia && (
        <div style={{ padding: '0.65rem 1rem', borderTop: '1px solid #e8e8e8', background: '#fafafa', display: 'flex', justifyContent: 'flex-end' }}>
          <button onClick={onAplicar} disabled={aplicando}
            style={{ padding: '0.45rem 1.1rem', background: aplicando ? '#856404' : '#f0c040', color: '#2c2c2a', border: 'none', borderRadius: '6px', fontWeight: 700, fontSize: '0.88rem', cursor: aplicando ? 'not-allowed' : 'pointer', minWidth: 140 }}>
            {aplicando ? '⏳ Guardando...' : (aplicarLabel || 'Guardar en inventario')}
          </button>
        </div>
      )}
    </div>
  );
}

// --- Cargador de lista de consignación desde Excel ---
const CONSIG_SS_KEY = 'relea_consig_importar';
function consigSsLoad(field, fallback) {
  try { const s = sessionStorage.getItem(CONSIG_SS_KEY); if (s) { const d = JSON.parse(s); if (field in d) return d[field]; } } catch {}
  return fallback;
}
function consigSsSave(patch) {
  try { const s = sessionStorage.getItem(CONSIG_SS_KEY); const d = s ? JSON.parse(s) : {}; sessionStorage.setItem(CONSIG_SS_KEY, JSON.stringify({ ...d, ...patch })); } catch {}
}

function RepCargarLista() {
  const [fase,           setFase]           = useState(() => consigSsLoad('fase', 'upload'));
  const [distribuidores, setDistribuidores] = useState([]);
  const [distSelId,      setDistSelId]      = useState(() => consigSsLoad('distSelId', ''));
  const [distSelNombre,  setDistSelNombre]  = useState(() => consigSsLoad('distSelNombre', ''));
  const [archivo,        setArchivo]        = useState(null);
  const [filasParsed,    setFilasParsed]    = useState(() => consigSsLoad('filasParsed', []));
  const [preview,        setPreview]        = useState(() => consigSsLoad('preview', null));
  const [selConfirmar,      setSelConfirmar]      = useState(() => new Set(consigSsLoad('selConfirmar', [])));
  const [selDiferencias,    setSelDiferencias]    = useState(() => new Set(consigSsLoad('selDiferencias', [])));
  const [selTitulo,         setSelTitulo]         = useState(() => new Map(consigSsLoad('selTitulo', [])));
  const [selActualizaciones, setSelActualizaciones] = useState(() => new Set(consigSsLoad('selActualizaciones', [])));
  const [selCambiosPrecio,   setSelCambiosPrecio]   = useState(() => new Set(consigSsLoad('selCambiosPrecio', [])));
  const [selIsbnUpdate,      setSelIsbnUpdate]      = useState(() => new Set(consigSsLoad('selIsbnUpdate', [])));
  const [selOtroDist,        setSelOtroDist]        = useState(() => new Set(consigSsLoad('selOtroDist', [])));
  const [gananciaListra, setGananciaListra] = useState(() => consigSsLoad('gananciaListra', ''));
  const [tabPreview,     setTabPreview]     = useState(() => consigSsLoad('tabPreview', null));
  const [paso,           setPaso]           = useState(1);
  const [cargando,       setCargando]       = useState(false);
  const [confirmando,    setConfirmando]    = useState(false);
  const [guardandoPend,  setGuardandoPend]  = useState(false);
  const [pendGuardados,  setPendGuardados]  = useState(false);
  const [guardandoOtro,  setGuardandoOtro]  = useState(false);
  const [otroGuardados,  setOtroGuardados]  = useState(false);
  const [resultado,      setResultado]      = useState(null);
  const [errorMsg,       setErrorMsg]       = useState('');

  // Persistir en sessionStorage cuando cambia el estado relevante
  useEffect(() => { consigSsSave({ fase }); }, [fase]);
  useEffect(() => { consigSsSave({ distSelId, distSelNombre }); }, [distSelId, distSelNombre]);
  useEffect(() => { consigSsSave({ filasParsed }); }, [filasParsed]);
  useEffect(() => { consigSsSave({ preview }); }, [preview]);
  useEffect(() => { consigSsSave({ gananciaListra }); }, [gananciaListra]);
  useEffect(() => { consigSsSave({ tabPreview }); }, [tabPreview]);
  useEffect(() => { consigSsSave({ selConfirmar:      [...selConfirmar]      }); }, [selConfirmar]);
  useEffect(() => { consigSsSave({ selDiferencias:    [...selDiferencias]    }); }, [selDiferencias]);
  useEffect(() => { consigSsSave({ selTitulo:         [...selTitulo]         }); }, [selTitulo]);
  useEffect(() => { consigSsSave({ selActualizaciones:[...selActualizaciones]}); }, [selActualizaciones]);
  useEffect(() => { consigSsSave({ selCambiosPrecio:  [...selCambiosPrecio]  }); }, [selCambiosPrecio]);
  useEffect(() => { consigSsSave({ selIsbnUpdate:     [...selIsbnUpdate]     }); }, [selIsbnUpdate]);
  useEffect(() => { consigSsSave({ selOtroDist:       [...selOtroDist]       }); }, [selOtroDist]);

  useEffect(() => {
    api.get('/distribuidores').then(res => setDistribuidores(res.data)).catch(console.error);
  }, []);

  function handleArchivo(e) {
    const file = e.target.files[0];
    if (!file) return;
    setArchivo(file);
    setErrorMsg('');
    setFilasParsed([]);
    const reader = new FileReader();
    reader.onload = ev => {
      try {
        const wb   = XLSX.read(ev.target.result, { type: 'array' });
        const ws   = wb.Sheets[wb.SheetNames[0]];
        const rows = XLSX.utils.sheet_to_json(ws, { header: 1, defval: '' });
        // Columnas: 0=ISBN 1=Título 2=Autor 3=Editorial 4=Precio Neto 5=Stock consignado
        // Fila 0 = encabezado → se ignora
        const filas = rows.slice(1)
          .filter(r => String(r[0] || '').trim() || String(r[1] || '').trim())
          .map(r => ({
            isbn:              String(r[0] || '').trim(),
            titulo_lista:      String(r[1] || '').trim(),
            autor_lista:       String(r[2] || '').trim(),
            editorial_lista:   String(r[3] || '').trim(),
            precio_neto_lista: Number(r[4]) || 0,
            stock_lista:       Number(r[5]) || 0,
          }));
        setFilasParsed(filas);
      } catch {
        setErrorMsg('No se pudo leer el archivo. Verifique que sea un .xlsx o .xls válido.');
      }
    };
    reader.readAsArrayBuffer(file);
  }

  async function verificarLista() {
    if (!distSelId)           { setErrorMsg('Seleccione un distribuidor.'); return; }
    if (filasParsed.length === 0) { setErrorMsg('El archivo no tiene filas válidas.'); return; }
    setCargando(true);
    setErrorMsg('');
    try {
      const res = await api.post('/consignacion/cargar-lista', { distribuidor_id: distSelId, filas: filasParsed });
      setPreview(res.data);
      setSelConfirmar(new Set((res.data.a_confirmar || []).map(i => i.lote_id)));
      setSelDiferencias(new Set());
      setSelTitulo(new Map(
        (res.data.coincidencia_titulo || [])
          .map((fila, idx) => {
            const best = (fila.candidatos || []).find(c => c.score >= 70 && c.lote_id);
            if (best) return [idx, { lote_id: best.lote_id, libro_id: best.libro_id }];
            // Auto-proponer candidato sin lote si tiene score muy alto (≥ 85)
            const bestSinLote = (fila.candidatos || []).find(c => c.score >= 85 && !c.lote_id);
            if (bestSinLote) return [idx, { libro_id: bestSinLote.libro_id, crear_lote: true, precio_neto: fila.precio_neto_lista || 0 }];
            return null;
          })
          .filter(Boolean)
      ));
      setSelIsbnUpdate(new Set(
        (res.data.coincidencia_titulo || [])
          .flatMap(fila => (fila.candidatos || [])
            .filter(c => c.score === 100 && fila.isbn_lista && c.libro_id)
            .map(c => c.libro_id))
      ));
      setSelActualizaciones(new Set((res.data.actualizaciones_datos || []).flatMap(u => u.campos.map(c => `${u.libro_id}::${c}`))));
      setSelCambiosPrecio(new Set((res.data.cambios_precio || []).map(u => u.lote_id)));
      setSelOtroDist(new Set((res.data.otro_distribuidor || []).map(i => i.libro_id)));
      setFase('preview');
    } catch (err) {
      setErrorMsg(err.response?.data?.error || 'Error al procesar la lista.');
    }
    setCargando(false);
  }

  function toggleSet(setter, id) {
    setter(prev => { const next = new Set(prev); next.has(id) ? next.delete(id) : next.add(id); return next; });
  }

  async function guardarOtroDistPendiente() {
    const noSel = (preview?.otro_distribuidor || []).filter(i => !selOtroDist.has(i.libro_id));
    if (!noSel.length) return;
    setGuardandoOtro(true);
    try {
      await api.post('/consignacion/sin-match-pendientes', {
        distribuidor_id: distSelId,
        distribuidor_nombre: distSelNombre,
        items: noSel.map(it => ({
          isbn:              it.isbn || null,
          titulo_lista:      it.titulo || null,
          autor_lista:       it.autor || null,
          precio_neto_lista: it.pvp ? Math.round(it.pvp / 1.19) : null,
          stock_lista:       it.stock_lista || null,
          nota:              `Tiene lote con distribuidor: ${it.distribuidor_actual}`,
        })),
      });
      setOtroGuardados(true);
    } catch (e) {
      alert('Error al guardar en pendientes: ' + (e.response?.data?.error || e.message));
    } finally {
      setGuardandoOtro(false);
    }
  }

  async function guardarSinMatchPendiente() {
    if (!preview?.sin_match?.length) return;
    setGuardandoPend(true);
    try {
      await api.post('/consignacion/sin-match-pendientes', {
        distribuidor_id: distSelId,
        distribuidor_nombre: distSelNombre,
        items: preview.sin_match.map(it => ({
          isbn:              it.isbn || null,
          titulo_lista:      it.titulo_lista || null,
          autor_lista:       it.autor_lista || null,
          editorial_lista:   it.editorial_lista || null,
          precio_neto_lista: it.precio_neto_lista || null,
          stock_lista:       it.stock_lista || null,
          nota:              it.nota || null,
        })),
      });
      setPendGuardados(true);
    } catch (e) {
      alert('Error al guardar pendientes: ' + (e.response?.data?.error || e.message));
    } finally {
      setGuardandoPend(false);
    }
  }

  async function aplicarTab(tabId) {
    let cambios = [];
    let actualizaciones_libros = [];
    const extraPayload = {};

    if (tabId === 'confirmar') {
      cambios = (preview.a_confirmar || [])
        .filter(i => selConfirmar.has(i.lote_id))
        .map(i => ({
          lote_id:         i.lote_id,
          nueva_modalidad: 'consignacion',
          nuevo_stock:     i.stock_lista,
          ...(i.nuevo_distribuidor_id ? { nuevo_distribuidor_id: i.nuevo_distribuidor_id } : {}),
        }));
    } else if (tabId === 'diferencias') {
      cambios = preview.diferencias
        .filter(i => selDiferencias.has(i.lote_id))
        .map(i => ({ lote_id: i.lote_id, nuevo_stock: i.stock_lista }));
    } else if (tabId === 'titulo') {
      const coincidencias = preview.coincidencia_titulo || [];
      const isbn_updates  = [];
      for (const [filaIdx, cand] of selTitulo) {
        const fila = coincidencias[filaIdx];
        if (cand.crear_lote) {
          // Propuesta de nuevo lote de consignación (candidato sin lote bajo este distribuidor)
          cambios.push({ crear_lote: true, libro_id: cand.libro_id, distribuidor_id: distSelId, pvp: 0, costo_real: cand.precio_neto || 0 });
        } else if (cand.lote_id) {
          cambios.push({ lote_id: cand.lote_id, nueva_modalidad: 'consignacion' });
          if (fila?.isbn_lista && selIsbnUpdate.has(cand.libro_id))
            isbn_updates.push({ libro_id: cand.libro_id, isbn_nuevo: fila.isbn_lista });
        }
      }
      if (isbn_updates.length > 0) Object.assign(extraPayload, { isbn_updates });
    } else if (tabId === 'otro_dist') {
      cambios = (preview.otro_distribuidor || [])
        .filter(i => selOtroDist.has(i.libro_id))
        .map(i => ({
          lote_id:              i.lote_id,
          nuevo_distribuidor_id: distSelId,
          nueva_modalidad:      'consignacion',
        }));
    } else if (tabId === 'datos') {
      actualizaciones_libros = (preview.actualizaciones_datos || [])
        .map(u => {
          const camposSel = u.campos.filter(c => selActualizaciones.has(`${u.libro_id}::${c}`));
          if (camposSel.length === 0) return null;
          return {
            libro_id: u.libro_id,
            campos: Object.fromEntries(
              camposSel.map(c => [c, c === 'titulo' ? u.titulo_lista : c === 'autor' ? u.autor_lista : u.editorial_lista])
            ),
          };
        })
        .filter(Boolean);
    }

    if (cambios.length === 0 && actualizaciones_libros.length === 0) {
      alert('No hay ítems seleccionados en esta sección.');
      return;
    }
    setConfirmando(true);
    try {
      const res = await api.post('/consignacion/confirmar-lista', { cambios, actualizaciones_libros, ...extraPayload });
      // Marcar la pestaña como guardada quitando los ítems aplicados del estado
      if (tabId === 'confirmar')   setSelConfirmar(new Set());
      if (tabId === 'diferencias') setSelDiferencias(new Set());
      if (tabId === 'titulo')      { setSelTitulo(new Map()); setSelIsbnUpdate(new Set()); }
      if (tabId === 'otro_dist')   setSelOtroDist(new Set());
      if (tabId === 'datos')       setSelActualizaciones(new Set());
      alert(`✓ ${res.data.actualizados} cambio${res.data.actualizados !== 1 ? 's' : ''} guardado${res.data.actualizados !== 1 ? 's' : ''} en el inventario.`);
    } catch (err) {
      alert(err.response?.data?.error || 'Error al aplicar los cambios.');
    }
    setConfirmando(false);
  }

  function reiniciar() {
    try { sessionStorage.removeItem(CONSIG_SS_KEY); } catch {}
    setFase('upload'); setPaso(1); setArchivo(null); setFilasParsed([]); setPreview(null);
    setSelConfirmar(new Set()); setSelDiferencias(new Set()); setSelTitulo(new Map()); setSelActualizaciones(new Set()); setSelCambiosPrecio(new Set()); setSelOtroDist(new Set());
    setOtroGuardados(false); setPendGuardados(false);
    setResultado(null); setErrorMsg('');
  }

  // ── FASE RESULTADO ──────────────────────────────────────────────────────────
  if (fase === 'resultado') {
    return (
      <div style={{ maxWidth: 480 }}>
        <div style={{ padding: '1.5rem', background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 10, marginBottom: 20 }}>
          <div style={{ fontSize: '1.1rem', fontWeight: 700, color: '#1a6b3c', marginBottom: 8 }}>✓ Cambios aplicados correctamente</div>
          <div style={{ fontSize: '0.9rem', color: '#555' }}>{resultado?.actualizados} actualización{resultado?.actualizados !== 1 ? 'es' : ''} realizadas en el inventario.</div>
        </div>
        <button onClick={reiniciar} style={{ padding: '0.5rem 1.25rem', background: '#2c2c2a', color: 'white', border: 'none', cursor: 'pointer', borderRadius: 6, fontWeight: 700, fontSize: '0.9rem' }}>
          Cargar otra lista
        </button>
      </div>
    );
  }

  // ── FASE UPLOAD ─────────────────────────────────────────────────────────────
  if (fase === 'upload') {
    const stepDisabled = paso === 1 ? !distSelId : (filasParsed.length === 0 || cargando);
    const onContinuar = paso === 1 ? () => setPaso(2) : verificarLista;

    return (
      <div style={{ maxWidth: 620 }}>
        {/* Stepper — pill buttons */}
        <div style={{ display: 'flex', gap: 6, marginBottom: 20 }}>
          {[{ n: 1, label: 'Distribuidor' }, { n: 2, label: 'Archivo' }, { n: 3, label: 'Verificar' }].map(s => {
            const active = s.n === paso;
            const done = s.n < paso;
            return (
              <div key={s.n} style={{ display: 'inline-flex', alignItems: 'center', gap: 5, padding: '5px 14px', borderRadius: 999, background: active ? 'var(--ink-900)' : 'transparent', color: active ? '#fff' : done ? 'var(--ink-600)' : 'var(--ink-300)', border: `1px solid ${active ? 'var(--ink-900)' : 'var(--line)'}`, fontSize: 13, fontWeight: active ? 700 : 500, userSelect: 'none' }}>
                <span style={{ fontSize: 11.5, fontWeight: 700, opacity: active ? 0.75 : 1 }}>{s.n}</span> {s.label}
              </div>
            );
          })}
        </div>

        {/* Paso 1 — Seleccionar distribuidor */}
        {paso === 1 && (
          <div style={{ background: 'var(--paper-stripe)', borderRadius: 16, padding: '20px 22px', marginBottom: 16 }}>
            <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 5 }}>¿Con qué distribuidor es esta consignación?</div>
            <div style={{ fontSize: 13, color: '#b45309', marginBottom: 18 }}>El sistema cruzará la lista con los lotes de ese distribuidor en tu inventario.</div>
            <label style={{ display: 'block', fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.06em', color: 'var(--ink-400)', marginBottom: 6 }}>Distribuidor</label>
            <select
              value={distSelId}
              onChange={e => { const d = distribuidores.find(d => d.id === e.target.value); setDistSelId(e.target.value); setDistSelNombre(d?.nombre || ''); }}
              style={{ width: '100%', padding: '0.6rem 0.8rem', border: '1px solid var(--line)', borderRadius: 10, fontSize: 14, background: 'var(--paper)', color: 'var(--ink-800)', fontFamily: 'inherit' }}>
              <option value="">Seleccionar distribuidor…</option>
              {distribuidores.map(d => <option key={d.id} value={d.id}>{d.nombre}</option>)}
            </select>
          </div>
        )}

        {/* Paso 2 — Subir archivo */}
        {paso === 2 && (
          <div style={{ background: 'var(--paper-stripe)', borderRadius: 16, padding: '20px 22px', marginBottom: 16 }}>
            <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 5 }}>¿Cuál es el archivo de la lista?</div>
            <div style={{ fontSize: 13, color: 'var(--ink-400)', marginBottom: 18 }}>
              Columnas en orden exacto: <strong style={{ color: 'var(--ink-700)' }}>ISBN · Título · Autor · Editorial · Precio Neto · Stock</strong>. La primera fila se ignora.
            </div>
            <label style={{ display: 'block', fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.06em', color: 'var(--ink-400)', marginBottom: 6 }}>Archivo Excel (.xlsx / .xls)</label>
            <input
              type="file" accept=".xlsx,.xls" onChange={handleArchivo}
              style={{ width: '100%', padding: '0.5rem', border: '1px solid var(--line)', borderRadius: 10, fontSize: 13.5, background: 'var(--paper)', boxSizing: 'border-box', fontFamily: 'inherit' }} />
            {filasParsed.length > 0 && (
              <p style={{ margin: '0.4rem 0 0', fontSize: 13, color: 'var(--ok-ink)' }}>
                ✓ {filasParsed.length} fila{filasParsed.length !== 1 ? 's' : ''} detectada{filasParsed.length !== 1 ? 's' : ''}
              </p>
            )}
            {errorMsg && <p style={{ margin: '0.4rem 0 0', color: 'var(--bad-ink)', fontSize: 13 }}>{errorMsg}</p>}
          </div>
        )}

        {/* Fila inferior */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <a href="/plantilla_consignacion.xlsx" download="plantilla_consignacion.xlsx"
            style={{ display: 'inline-flex', alignItems: 'center', gap: 5, fontSize: 13, color: 'var(--link, #1a56db)', textDecoration: 'none' }}>
            ⬇ Descargar plantilla
          </a>
          <button
            onClick={onContinuar}
            disabled={stepDisabled}
            style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '8px 20px', background: 'var(--ink-900)', color: '#fff', border: 'none', borderRadius: 999, cursor: stepDisabled ? 'default' : 'pointer', fontSize: 13.5, fontWeight: 600, fontFamily: 'inherit', opacity: stepDisabled ? 0.4 : 1 }}>
            {cargando ? 'Procesando…' : <>Continuar <span style={{ fontSize: 15 }}>→</span></>}
          </button>
        </div>
      </div>
    );
  }

  // ── FASE PREVIEW ─────────────────────────────────────────────────────────────
  if (fase === 'preview') {
    const aConf    = preview.a_confirmar || [];
    const aTitle   = (preview.coincidencia_titulo || []);
    const totalCambios = selConfirmar.size + selDiferencias.size + selTitulo.size + selActualizaciones.size;
    const todasConf = aConf.length > 0 && aConf.every(i => selConfirmar.has(i.lote_id));
    const gListraNum  = parseFloat(gananciaListra);
    const gListraOk   = gananciaListra !== '' && !isNaN(gListraNum) && gListraNum > 0 && gListraNum < 100;
    // Auto-completar ganancia desde primer item con pvp/costo_real si aún no fue ingresada
    if (gananciaListra === '') {
      const conPvp = [...aConf, ...(preview.diferencias || [])].find(i => i.pvp > 0 && i.costo_real > 0);
      if (conPvp) {
        const g = Math.round((1 - conPvp.costo_real / conPvp.pvp) * 10000) / 100;
        setTimeout(() => setGananciaListra(String(g)), 0);
      }
    }

    // Definir pestañas disponibles
    const aOtroDist = preview.otro_distribuidor || [];
    const TABS_PREV = [
      { id: 'confirmar',   label: 'Confirmar',             count: aConf.length,                              show: true },
      { id: 'diferencias', label: 'Diferencias stock',     count: (preview.diferencias || []).length,        show: true },
      { id: 'titulo',      label: 'Coincidencia título',   count: aTitle.length,                             show: aTitle.length > 0 },
      { id: 'otro_dist',   label: 'Otro distribuidor',     count: aOtroDist.length,                          show: aOtroDist.length > 0 },
      { id: 'precios',     label: 'Cambios de precio',     count: (preview.cambios_precio || []).length,     show: (preview.cambios_precio || []).length > 0 },
      { id: 'datos',       label: 'Datos bibliográficos',  count: (preview.actualizaciones_datos || []).flatMap(u => u.campos).length, show: (preview.actualizaciones_datos || []).length > 0 },
      { id: 'sin_match',   label: 'Sin coincidencia',      count: preview.sin_match.length,                  show: preview.sin_match.length > 0 },
    ].filter(t => t.show);
    const tabActiva = tabPreview || TABS_PREV[0]?.id;

    return (
      <div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '1.25rem', gap: '1rem', flexWrap: 'wrap' }}>
          <div>
            <h4 style={{ margin: '0 0 0.2rem' }}>Revisión — {distSelNombre}</h4>
            <p style={{ margin: 0, fontSize: '0.84rem', color: '#888' }}>{filasParsed.length} filas procesadas · {archivo?.name}</p>
          </div>
          <button onClick={reiniciar} style={{ background: 'none', border: '1px solid #ddd', padding: '0.35rem 0.85rem', cursor: 'pointer', borderRadius: '6px', fontSize: '0.84rem', color: '#666', whiteSpace: 'nowrap' }}>
            ← Cargar otra lista
          </button>
        </div>

        {/* Pestañas sticky */}
        <div style={{ position: 'sticky', top: 0, zIndex: 10, background: 'var(--paper,#fff)', paddingBottom: 4, marginBottom: 12, borderBottom: '2px solid #eee' }}>
          <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap', paddingTop: 4 }}>
            {TABS_PREV.map(t => (
              <button key={t.id} onClick={() => setTabPreview(t.id)}
                style={{ padding: '0.4rem 0.85rem', borderRadius: '6px 6px 0 0', border: '1px solid #ddd', borderBottom: tabActiva === t.id ? '2px solid var(--paper,#fff)' : '1px solid #ddd', background: tabActiva === t.id ? 'white' : '#f5f5f3', fontWeight: tabActiva === t.id ? 700 : 400, fontSize: '0.83rem', cursor: 'pointer', fontFamily: 'inherit', color: tabActiva === t.id ? '#222' : '#888', marginBottom: -1 }}>
                {t.label}
                {t.count > 0 && <span style={{ marginLeft: 6, padding: '1px 7px', borderRadius: 999, background: tabActiva === t.id ? '#e0e0e0' : '#ddd', fontSize: '0.75rem', fontWeight: 700 }}>{t.count}</span>}
              </button>
            ))}
          </div>
          {/* Campo ganancia % — siempre visible */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '0.5rem 0.25rem 0', flexWrap: 'wrap' }}>
            <label style={{ fontSize: '0.83rem', color: '#555', whiteSpace: 'nowrap' }}>Ganancia librería %</label>
            <input type="number" min="0" max="99" step="0.01" value={gananciaListra} onChange={e => setGananciaListra(e.target.value)} placeholder="ej: 40"
              style={{ width: 70, padding: '0.25rem 0.5rem', border: '1px solid #ddd', borderRadius: 6, fontSize: '0.9rem', textAlign: 'right' }} />
            <span style={{ fontSize: '0.8rem', color: '#aaa' }}>%</span>
            {gListraOk && <span style={{ fontSize: '0.8rem', color: '#1a6b3c' }}>→ pago dist. por unidad = PVP × {(1 - gListraNum/100).toFixed(2)}</span>}
          </div>
        </div>

        {/* Sección 1 — Confirmar como consignados */}
        {tabActiva === 'confirmar' && <SeccionPreview titulo="Confirmar como consignados" badge={aConf.length} badgeColor="#1a56db" vacia={aConf.length === 0} msgVacio="No hay libros pendientes de confirmar como consignados." onAplicar={() => aplicarTab('confirmar')} aplicarLabel={`Guardar ${selConfirmar.size} en inventario`} aplicando={confirmando}>
          <p style={{ margin: '0 0 0.65rem', fontSize: '0.83rem', color: '#888' }}>
            Estos libros están en tu inventario bajo {distSelNombre} pero con otra modalidad. Al confirmar pasarán a consignación.
          </p>
          <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: 0, fontSize: '0.88rem' }}>
            <thead>
              <tr style={{ background: '#f9f9f9', fontSize: '0.8rem', color: '#aaa', fontWeight: 600, textAlign: 'left', position: 'sticky', top: 0, zIndex: 2, boxShadow: 'inset 0 -1px 0 #eee' }}>
                <th style={{ padding: '0.45rem 0.5rem', textAlign: 'center', width: 36 }}>
                  <input type="checkbox" checked={todasConf} onChange={() => setSelConfirmar(todasConf ? new Set() : new Set(aConf.map(i => i.lote_id)))} />
                </th>
                <th style={{ padding: '0.45rem 0.5rem' }}>Título</th>
                <th style={{ padding: '0.45rem 0.5rem' }}>Autor</th>
                <th style={{ padding: '0.45rem 0.5rem' }}>ISBN</th>
                <th style={{ padding: '0.45rem 0.5rem', textAlign: 'right' }}>PVP</th>
                <th style={{ padding: '0.45rem 0.5rem', textAlign: 'right' }}>Neto</th>
                {gListraOk && <th style={{ padding: '0.45rem 0.5rem', textAlign: 'right' }}>Pago dist.</th>}
                <th style={{ padding: '0.45rem 0.5rem' }}>Modalidad / Distribuidor actual</th>
                <th style={{ padding: '0.45rem 0.5rem', textAlign: 'right' }}>Stock actual</th>
                <th style={{ padding: '0.45rem 0.5rem', textAlign: 'right' }}>Stock lista</th>
              </tr>
            </thead>
            <tbody>
              {aConf.map((item, i) => {
                const sel = selConfirmar.has(item.lote_id);
                const modalidadColor = item.modalidad_actual === 'firme' ? '#1a56db' : item.modalidad_actual === 'migracion' ? '#856404' : '#888';
                return (
                  <tr key={i} onClick={() => toggleSet(setSelConfirmar, item.lote_id)}
                    style={{ borderBottom: '1px solid #eee', cursor: 'pointer', opacity: sel ? 1 : 0.45, background: sel ? 'white' : '#fafafa' }}>
                    <td style={{ padding: '0.45rem 0.5rem', textAlign: 'center' }}>
                      <input type="checkbox" checked={sel} onChange={() => toggleSet(setSelConfirmar, item.lote_id)} onClick={e => e.stopPropagation()} />
                    </td>
                    <td style={{ padding: '0.45rem 0.5rem' }}>
                      <div style={{ fontWeight: 600 }}>{item.titulo}</div>
                    </td>
                    <td style={{ padding: '0.45rem 0.5rem', color: '#666', fontSize: '0.84rem' }}>{item.autor || '—'}</td>
                    <td style={{ padding: '0.45rem 0.5rem', color: '#999', fontSize: '0.84rem', fontFamily: 'monospace' }}>{item.isbn || '—'}</td>
                    <td style={{ padding: '0.45rem 0.5rem', textAlign: 'right', fontSize: '0.84rem', color: '#555' }}>{item.pvp ? `$${Number(item.pvp).toLocaleString('es-CL')}` : '—'}</td>
                    <td style={{ padding: '0.45rem 0.5rem', textAlign: 'right', fontSize: '0.84rem', color: '#888' }}>{item.pvp ? `$${Math.round(Number(item.pvp)/1.19).toLocaleString('es-CL')}` : '—'}</td>
                    {gListraOk && <td style={{ padding: '0.45rem 0.5rem', textAlign: 'right', fontSize: '0.84rem', color: '#c0571a', fontWeight: 600 }}>{item.pvp ? `$${Math.round(Number(item.pvp)*(1-gListraNum/100)).toLocaleString('es-CL')}` : '—'}</td>}
                    <td style={{ padding: '0.45rem 0.5rem', fontSize: '0.82rem' }}>
                      <span style={{ color: modalidadColor, fontWeight: 600 }}>{item.modalidad_actual}</span>
                      {item.distribuidor_actual && (
                        <span style={{ color: '#aaa', fontSize: '0.78rem', marginLeft: 4 }}>({item.distribuidor_actual})</span>
                      )}
                      <span style={{ color: '#aaa', margin: '0 0.3rem' }}>→</span>
                      <span style={{ color: '#1a6b3c', fontWeight: 600 }}>consignación</span>
                      {item.nuevo_distribuidor_id && (
                        <span style={{ color: '#aaa', fontSize: '0.78rem', marginLeft: 4 }}>+ reasignar a {distSelNombre}</span>
                      )}
                    </td>
                    <td style={{ padding: '0.45rem 0.5rem', textAlign: 'right', color: '#888' }}>{item.stock_actual}</td>
                    <td style={{ padding: '0.45rem 0.5rem', textAlign: 'right', fontWeight: 700, color: '#1a56db' }}>{item.stock_lista}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </SeccionPreview>}

        {/* Sección 1c — Coincidencia por título */}
        {tabActiva === 'titulo' && aTitle.length > 0 && (() => {
          const nNuevos = [...selTitulo.values()].filter(v => v.crear_lote).length;
          const nLote   = [...selTitulo.values()].filter(v => v.lote_id).length;
          const nTotal  = nNuevos + nLote;
          const aplicarLabel = nTotal === 0
            ? 'Sin selecciones'
            : `Guardar ${nTotal}${nNuevos > 0 ? ` (${nNuevos} lote${nNuevos !== 1 ? 's' : ''} nuevo${nNuevos !== 1 ? 's' : ''})` : ''}`;
          return (
          <SeccionPreview titulo="Coincidencia por título (requiere revisión)" badge={aTitle.length} badgeColor="#c0571a" vacia={false} msgVacio="" onAplicar={() => aplicarTab('titulo')} aplicarLabel={aplicarLabel} aplicando={confirmando}>
            <p style={{ margin: '0 0 0.65rem', fontSize: '0.83rem', color: '#888' }}>
              El ISBN no coincidió, pero el título se parece a estos libros del sistema. Confirma el candidato correcto para cada fila. Si el libro aún no tiene lote bajo {distSelNombre}, puedes registrarlo como nuevo ingreso de consignación.
            </p>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              {aTitle.map((fila, filaIdx) => {
                const selCand = selTitulo.get(filaIdx);
                return (
                  <div key={filaIdx} style={{ borderBottom: '1px solid #eee', padding: '0.6rem 0.5rem' }}>
                    {/* Cabecera de fila Excel */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6 }}>
                      <span style={{ fontWeight: 600, color: '#555', fontSize: '0.88rem' }}>{fila.titulo_lista || '—'}</span>
                      {fila.isbn_lista && <span style={{ fontFamily: 'monospace', color: '#bbb', fontSize: '0.77rem' }}>{fila.isbn_lista}</span>}
                      <span style={{ marginLeft: 'auto', fontWeight: 700, color: '#c0571a', fontSize: '0.84rem', whiteSpace: 'nowrap' }}>Stock: {fila.stock_lista ?? '—'}</span>
                    </div>
                    {/* Candidatos */}
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 3, paddingLeft: 10 }}>
                      {fila.candidatos.map((cand, candIdx) => {
                        const sinLote    = !cand.lote_id;
                        const selected   = !sinLote && selCand?.libro_id === cand.libro_id && !selCand?.crear_lote;
                        const propuesto  = sinLote && selCand?.libro_id === cand.libro_id && selCand?.crear_lote;
                        const scoreColor = cand.score >= 70 ? '#1a6b3c' : cand.score >= 50 ? '#856404' : '#c0571a';
                        const isbnDistinto = fila.isbn_lista && cand.isbn_sistema && fila.isbn_lista !== cand.isbn_sistema;
                        const isbnSel = selIsbnUpdate.has(cand.libro_id);
                        const bgColor = propuesto ? '#eff6ff' : selected ? '#fff8f3' : 'transparent';
                        return (
                          <div key={candIdx}
                            onClick={() => setSelTitulo(prev => {
                              const next = new Map(prev);
                              if (sinLote) {
                                propuesto ? next.delete(filaIdx) : next.set(filaIdx, { libro_id: cand.libro_id, crear_lote: true, precio_neto: fila.precio_neto_lista || 0 });
                              } else {
                                selected ? next.delete(filaIdx) : next.set(filaIdx, { lote_id: cand.lote_id, libro_id: cand.libro_id });
                              }
                              return next;
                            })}
                            style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '4px 8px', borderRadius: 6, cursor: 'pointer', background: bgColor }}>
                            {sinLote
                              ? <input type="checkbox" readOnly checked={propuesto} style={{ flexShrink: 0 }} />
                              : <input type="radio"    readOnly checked={selected}  style={{ flexShrink: 0 }} />
                            }
                            <div style={{ flex: 1, minWidth: 0 }}>
                              <span style={{ fontWeight: 600, fontSize: '0.87rem' }}>{cand.titulo_sistema}</span>
                              {cand.isbn_sistema && <span style={{ fontFamily: 'monospace', color: '#bbb', fontSize: '0.76rem', marginLeft: 6 }}>{cand.isbn_sistema}</span>}
                              {cand.modalidad_actual && <span style={{ fontSize: '0.75rem', color: '#888', marginLeft: 6 }}>{cand.modalidad_actual} · stock {cand.stock_actual}</span>}
                              {sinLote && (
                                <span style={{ fontSize: '0.75rem', marginLeft: 6, color: propuesto ? '#1a56db' : '#856404', fontWeight: propuesto ? 600 : 400 }}>
                                  {propuesto ? '+ nuevo lote de consignación' : 'sin lote bajo este distribuidor'}
                                </span>
                              )}
                            </div>
                            <span style={{ fontWeight: 700, color: scoreColor, fontSize: '0.84rem', flexShrink: 0 }}>{cand.score}%</span>
                            {selected && isbnDistinto && (
                              <label style={{ display: 'flex', alignItems: 'center', gap: 4, cursor: 'pointer', fontSize: '0.75rem', flexShrink: 0 }} onClick={e => e.stopPropagation()}>
                                <input type="checkbox" checked={isbnSel} onChange={() => toggleSet(setSelIsbnUpdate, cand.libro_id)} />
                                <span style={{ color: isbnSel ? '#1a56db' : '#aaa', fontFamily: 'monospace' }}>→ {fila.isbn_lista}</span>
                              </label>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                );
              })}
            </div>
          </SeccionPreview>
          );
        })()}

        {/* Sección — Otro distribuidor */}
        {tabActiva === 'otro_dist' && (
          <SeccionPreview
            titulo="Libro existe con otro distribuidor"
            badge={aOtroDist.length}
            badgeColor="#7c3aed"
            vacia={aOtroDist.length === 0}
            msgVacio=""
            onAplicar={() => aplicarTab('otro_dist')}
            aplicarLabel={`Reasignar ${selOtroDist.size} lote${selOtroDist.size !== 1 ? 's' : ''} a ${distSelNombre}`}
            aplicando={confirmando}
          >
            <p style={{ margin: '0 0 0.65rem', fontSize: '0.83rem', color: '#888' }}>
              Estos libros ya están en el inventario, pero el lote existente pertenece a otro distribuidor.
              Marque los que desea reasignar a <strong>{distSelNombre}</strong> como consignación (se mueve el lote existente preservando el stock).
              Los que deje sin marcar puede guardarlos en <strong>ISBN pendientes</strong> para decidir después.
            </p>
            <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: 0, fontSize: '0.88rem' }}>
              <thead>
                <tr style={{ background: '#f9f9f9', fontSize: '0.8rem', color: '#aaa', fontWeight: 600, textAlign: 'left', position: 'sticky', top: 0, zIndex: 2, boxShadow: 'inset 0 -1px 0 #eee' }}>
                  <th style={{ padding: '0.45rem 0.5rem', textAlign: 'center', width: 36 }}>
                    <input type="checkbox"
                      checked={aOtroDist.length > 0 && aOtroDist.every(i => selOtroDist.has(i.libro_id))}
                      onChange={e => setSelOtroDist(e.target.checked ? new Set(aOtroDist.map(i => i.libro_id)) : new Set())} />
                  </th>
                  <th style={{ padding: '0.45rem 0.5rem' }}>Título</th>
                  <th style={{ padding: '0.45rem 0.5rem' }}>ISBN</th>
                  <th style={{ padding: '0.45rem 0.5rem' }}>Distribuidor actual</th>
                  <th style={{ padding: '0.45rem 0.5rem' }}>Modalidad</th>
                  <th style={{ padding: '0.45rem 0.5rem', textAlign: 'right' }}>Stock actual</th>
                  <th style={{ padding: '0.45rem 0.5rem', textAlign: 'right' }}>Stock lista</th>
                </tr>
              </thead>
              <tbody>
                {aOtroDist.map((item, i) => {
                  const sel = selOtroDist.has(item.libro_id);
                  const modColor = item.modalidad_actual === 'consignacion' ? '#1a6b3c' : item.modalidad_actual === 'firme' ? '#1a56db' : '#888';
                  return (
                    <tr key={i} onClick={() => toggleSet(setSelOtroDist, item.libro_id)}
                      style={{ borderBottom: '1px solid #eee', cursor: 'pointer', opacity: sel ? 1 : 0.5, background: sel ? '#faf5ff' : 'white' }}>
                      <td style={{ padding: '0.45rem 0.5rem', textAlign: 'center' }}>
                        <input type="checkbox" checked={sel} onChange={() => toggleSet(setSelOtroDist, item.libro_id)} onClick={e => e.stopPropagation()} />
                      </td>
                      <td style={{ padding: '0.45rem 0.5rem' }}>
                        <div style={{ fontWeight: 600 }}>{item.titulo}</div>
                        {item.autor && <div style={{ fontSize: '0.8rem', color: '#888' }}>{item.autor}</div>}
                      </td>
                      <td style={{ padding: '0.45rem 0.5rem', color: '#999', fontSize: '0.84rem', fontFamily: 'monospace' }}>{item.isbn || '—'}</td>
                      <td style={{ padding: '0.45rem 0.5rem', fontSize: '0.84rem', color: '#555' }}>{item.distribuidor_actual}</td>
                      <td style={{ padding: '0.45rem 0.5rem' }}>
                        <span style={{ color: modColor, fontWeight: 600, fontSize: '0.82rem' }}>{item.modalidad_actual}</span>
                      </td>
                      <td style={{ padding: '0.45rem 0.5rem', textAlign: 'right', color: '#888' }}>{item.stock_actual}</td>
                      <td style={{ padding: '0.45rem 0.5rem', textAlign: 'right', fontWeight: 700, color: '#7c3aed' }}>{item.stock_lista}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            {/* Guardar no seleccionados en pendientes */}
            {aOtroDist.length > 0 && (
              <div style={{ marginTop: '0.85rem', display: 'flex', alignItems: 'center', gap: 10 }}>
                <button
                  onClick={guardarOtroDistPendiente}
                  disabled={guardandoOtro || otroGuardados || aOtroDist.every(i => selOtroDist.has(i.libro_id))}
                  style={{ padding: '0.35rem 0.9rem', background: 'none', border: '1px solid #d1c4e9', borderRadius: 6, cursor: 'pointer', fontSize: '0.82rem', color: '#7c3aed', opacity: (guardandoOtro || otroGuardados || aOtroDist.every(i => selOtroDist.has(i.libro_id))) ? 0.5 : 1 }}
                >
                  {guardandoOtro ? 'Guardando…' : otroGuardados ? '✓ Guardados en pendientes' : `Guardar ${aOtroDist.filter(i => !selOtroDist.has(i.libro_id)).length} sin seleccionar en ISBN pendientes`}
                </button>
              </div>
            )}
          </SeccionPreview>
        )}

        {/* Sección 2 — Diferencias de stock */}
        {tabActiva === 'diferencias' && <SeccionPreview titulo="Diferencias de stock en consignación" badge={preview.diferencias.length} badgeColor="#856404" vacia={preview.diferencias.length === 0} msgVacio="Sin diferencias de stock. Todo coincide." onAplicar={() => aplicarTab('diferencias')} aplicarLabel={`Guardar ${selDiferencias.size} en inventario`} aplicando={confirmando}>
          {preview.diferencias.length > 0 && (
            <>
              <p style={{ margin: '0 0 0.65rem', fontSize: '0.83rem', color: '#888' }}>
                Marcá los libros cuyo stock querés ajustar al valor de la lista del distribuidor.
              </p>
              <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: 0, fontSize: '0.88rem' }}>
                <thead>
                  <tr style={{ background: '#f9f9f9', fontSize: '0.8rem', color: '#aaa', fontWeight: 600, textAlign: 'left', position: 'sticky', top: 0, zIndex: 2, boxShadow: 'inset 0 -1px 0 #eee' }}>
                    <th style={{ padding: '0.45rem 0.5rem', textAlign: 'center', width: 36 }}></th>
                    <th style={{ padding: '0.45rem 0.5rem' }}>Título</th>
                    <th style={{ padding: '0.45rem 0.5rem' }}>Autor</th>
                    <th style={{ padding: '0.45rem 0.5rem', textAlign: 'right' }}>PVP</th>
                    <th style={{ padding: '0.45rem 0.5rem', textAlign: 'right' }}>Neto</th>
                    {gListraOk && <th style={{ padding: '0.45rem 0.5rem', textAlign: 'right' }}>Pago dist.</th>}
                    <th style={{ padding: '0.45rem 0.5rem', textAlign: 'right' }}>Stock BD</th>
                    <th style={{ padding: '0.45rem 0.5rem', textAlign: 'right' }}>Stock lista</th>
                    <th style={{ padding: '0.45rem 0.5rem', textAlign: 'right' }}>Diferencia</th>
                    <th style={{ padding: '0.45rem 0.5rem' }}>Nota</th>
                  </tr>
                </thead>
                <tbody>
                  {preview.diferencias.map((item, i) => {
                    const sel = selDiferencias.has(item.lote_id);
                    const dif = item.diferencia; // +: BD tiene más; −: lista tiene más
                    const notaColor = item.diferencia_justificada ? '#1a6b3c' : '#856404';
                    const notaTxt = item.diferencia_justificada
                      ? `✓ Justificada por ${item.ventas_no_reportadas} venta${item.ventas_no_reportadas !== 1 ? 's' : ''} sin reportar`
                      : item.ventas_no_reportadas > 0
                        ? `⚠ Parcialmente explicada (${item.ventas_no_reportadas} vta. sin reportar)`
                        : '⚠ Sin ventas que la expliquen';
                    return (
                      <tr key={i} onClick={() => toggleSet(setSelDiferencias, item.lote_id)}
                        style={{ borderBottom: '1px solid #eee', cursor: 'pointer', opacity: sel ? 1 : 0.55, background: sel ? '#fffdf0' : 'white' }}>
                        <td style={{ padding: '0.45rem 0.5rem', textAlign: 'center' }}>
                          <input type="checkbox" checked={sel} onChange={() => toggleSet(setSelDiferencias, item.lote_id)} onClick={e => e.stopPropagation()} />
                        </td>
                        <td style={{ padding: '0.45rem 0.5rem' }}>
                          <div style={{ fontWeight: 600 }}>{item.titulo}</div>
                        </td>
                        <td style={{ padding: '0.45rem 0.5rem', color: '#666', fontSize: '0.84rem' }}>{item.autor || '—'}</td>
                        <td style={{ padding: '0.45rem 0.5rem', textAlign: 'right', fontSize: '0.84rem', color: '#555' }}>{item.pvp ? `$${Number(item.pvp).toLocaleString('es-CL')}` : '—'}</td>
                        <td style={{ padding: '0.45rem 0.5rem', textAlign: 'right', fontSize: '0.84rem', color: '#888' }}>{item.pvp ? `$${Math.round(Number(item.pvp)/1.19).toLocaleString('es-CL')}` : '—'}</td>
                        {gListraOk && <td style={{ padding: '0.45rem 0.5rem', textAlign: 'right', fontSize: '0.84rem', color: '#c0571a', fontWeight: 600 }}>{item.pvp ? `$${Math.round(Number(item.pvp)*(1-gListraNum/100)).toLocaleString('es-CL')}` : '—'}</td>}
                        <td style={{ padding: '0.45rem 0.5rem', textAlign: 'right' }}>{item.stock_actual}</td>
                        <td style={{ padding: '0.45rem 0.5rem', textAlign: 'right', fontWeight: 700 }}>{item.stock_lista}</td>
                        <td style={{ padding: '0.45rem 0.5rem', textAlign: 'right', fontWeight: 700, color: dif > 0 ? '#c0392b' : '#1a6b3c' }}>
                          {dif > 0 ? `−${dif}` : `+${Math.abs(dif)}`}
                        </td>
                        <td style={{ padding: '0.45rem 0.5rem', fontSize: '0.82rem', color: notaColor }}>{notaTxt}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </>
          )}
        </SeccionPreview>}

        {/* Sección 2b — Cambios de precio */}
        {tabActiva === 'precios' && (preview.cambios_precio || []).length > 0 && (
          <SeccionPreview titulo="Cambios de precio" badge={(preview.cambios_precio || []).length} badgeColor="#c0571a" vacia={false} msgVacio="">
            <p style={{ margin: '0 0 0.65rem', fontSize: '0.83rem', color: '#888' }}>
              Solo informativo — el Precio Neto del Excel difiere del PVP registrado en el sistema. Actualizá los precios desde el módulo de Inventario si corresponde.
            </p>
            <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: 0, fontSize: '0.88rem' }}>
              <thead>
                <tr style={{ background: '#f9f9f9', fontSize: '0.8rem', color: '#aaa', fontWeight: 600, textAlign: 'left', position: 'sticky', top: 0, zIndex: 2, boxShadow: 'inset 0 -1px 0 #eee' }}>
                  <th style={{ padding: '0.45rem 0.5rem' }}>Libro</th>
                  <th style={{ padding: '0.45rem 0.5rem', textAlign: 'right' }}>Neto sistema</th>
                  <th style={{ padding: '0.45rem 0.5rem', textAlign: 'right' }}>PVP sistema</th>
                  <th style={{ padding: '0.45rem 0.5rem', textAlign: 'right' }}>Neto Excel</th>
                  <th style={{ padding: '0.45rem 0.5rem', textAlign: 'right' }}>PVP Excel</th>
                  <th style={{ padding: '0.45rem 0.5rem', textAlign: 'right' }}>Diferencia</th>
                </tr>
              </thead>
              <tbody>
                {(preview.cambios_precio || []).map((u, i) => {
                  const diff = u.pvp_lista - u.pvp_sistema;
                  const diffColor = diff > 0 ? '#1a6b3c' : '#c0571a';
                  return (
                    <tr key={i} style={{ borderBottom: '1px solid #eee' }}>
                      <td style={{ padding: '0.45rem 0.5rem' }}>
                        <div style={{ fontWeight: 600, fontSize: '0.86rem' }}>{u.titulo}</div>
                        <div style={{ fontSize: '0.77rem', color: '#bbb', fontFamily: 'monospace' }}>{u.isbn}</div>
                      </td>
                      <td style={{ padding: '0.45rem 0.5rem', textAlign: 'right', color: '#999' }}>${u.neto_sistema.toLocaleString('es-CL')}</td>
                      <td style={{ padding: '0.45rem 0.5rem', textAlign: 'right', color: '#666' }}>${u.pvp_sistema.toLocaleString('es-CL')}</td>
                      <td style={{ padding: '0.45rem 0.5rem', textAlign: 'right', color: '#1a56db', fontWeight: 600 }}>${u.neto_lista.toLocaleString('es-CL')}</td>
                      <td style={{ padding: '0.45rem 0.5rem', textAlign: 'right', color: '#1a56db', fontWeight: 600 }}>${u.pvp_lista.toLocaleString('es-CL')}</td>
                      <td style={{ padding: '0.45rem 0.5rem', textAlign: 'right', fontWeight: 700, color: diffColor }}>{diff > 0 ? '+' : ''}{diff.toLocaleString('es-CL')}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </SeccionPreview>
        )}

        {/* Sección 2b — Actualizaciones de datos bibliográficos */}
        {tabActiva === 'datos' && (preview.actualizaciones_datos || []).length > 0 && (() => {
          const allKeys = (preview.actualizaciones_datos || []).flatMap(u => u.campos.map(c => `${u.libro_id}::${c}`));
          const todosActu = allKeys.every(k => selActualizaciones.has(k));
          const CAMPO_LABEL = { titulo: 'Título', autor: 'Autor', editorial: 'Editorial' };
          return (
            <SeccionPreview titulo="Actualizar datos bibliográficos" badge={allKeys.length} badgeColor="#6b21a8" vacia={false} msgVacio="" onAplicar={() => aplicarTab('datos')} aplicarLabel={`Guardar ${selActualizaciones.size} campo${selActualizaciones.size !== 1 ? 's' : ''} en inventario`} aplicando={confirmando}>
              <p style={{ margin: '0 0 0.65rem', fontSize: '0.83rem', color: '#888' }}>
                El Excel tiene datos distintos a los del sistema. Marcá campo por campo los que querés actualizar.
              </p>
              <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: 0, fontSize: '0.88rem' }}>
                <thead>
                  <tr style={{ background: '#f9f9f9', fontSize: '0.8rem', color: '#aaa', fontWeight: 600, textAlign: 'left', position: 'sticky', top: 0, zIndex: 2, boxShadow: 'inset 0 -1px 0 #eee' }}>
                    <th style={{ padding: '0.45rem 0.5rem', textAlign: 'center', width: 36 }}>
                      <input type="checkbox" checked={todosActu}
                        onChange={() => setSelActualizaciones(todosActu ? new Set() : new Set(allKeys))} />
                    </th>
                    <th style={{ padding: '0.45rem 0.5rem' }}>Libro</th>
                    <th style={{ padding: '0.45rem 0.5rem' }}>Campo</th>
                    <th style={{ padding: '0.45rem 0.5rem' }}>En el sistema</th>
                    <th style={{ padding: '0.45rem 0.5rem' }}>En el Excel</th>
                  </tr>
                </thead>
                <tbody>
                  {(preview.actualizaciones_datos || []).map((u, i) => {
                    return u.campos.map((campo, j) => {
                      const key = `${u.libro_id}::${campo}`;
                      const sel = selActualizaciones.has(key);
                      return (
                        <tr key={`${i}-${j}`} onClick={() => toggleSet(setSelActualizaciones, key)}
                          style={{ borderBottom: '1px solid #eee', cursor: 'pointer', opacity: sel ? 1 : 0.45, background: sel ? 'white' : '#fafafa' }}>
                          <td style={{ padding: '0.45rem 0.5rem', textAlign: 'center' }}>
                            <input type="checkbox" checked={sel} onChange={() => toggleSet(setSelActualizaciones, key)} onClick={e => e.stopPropagation()} />
                          </td>
                          <td style={{ padding: '0.45rem 0.5rem' }}>
                            {j === 0 && <div style={{ fontWeight: 600, fontSize: '0.86rem' }}>{u.titulo_sistema}</div>}
                            {j === 0 && <div style={{ fontSize: '0.77rem', color: '#bbb', fontFamily: 'monospace' }}>{u.isbn}</div>}
                          </td>
                          <td style={{ padding: '0.45rem 0.5rem', fontWeight: 600, color: '#6b21a8', fontSize: '0.83rem' }}>{CAMPO_LABEL[campo]}</td>
                          <td style={{ padding: '0.45rem 0.5rem', color: '#999', fontSize: '0.83rem' }}>
                            {campo === 'titulo' ? u.titulo_sistema : campo === 'autor' ? u.autor_sistema : u.editorial_sistema || '—'}
                          </td>
                          <td style={{ padding: '0.45rem 0.5rem', color: '#1a56db', fontSize: '0.83rem', fontWeight: 600 }}>
                            {campo === 'titulo' ? u.titulo_lista : campo === 'autor' ? u.autor_lista : u.editorial_lista}
                          </td>
                        </tr>
                      );
                    });
                  })}
                </tbody>
              </table>
            </SeccionPreview>
          );
        })()}

        {/* Sección 3 — Sin coincidencia (solo informativa) */}
        {tabActiva === 'sin_match' && preview.sin_match.length > 0 && (
          <SeccionPreview titulo="ISBNs sin coincidencia en la BD" badge={preview.sin_match.length} badgeColor="#aaa" vacia={false} msgVacio="">
            <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '1rem', marginBottom: '0.65rem', flexWrap: 'wrap' }}>
              <p style={{ margin: 0, fontSize: '0.83rem', color: '#888', flex: 1 }}>
                Estos ISBNs no se encontraron en el catálogo. No se aplican cambios. Podés guardarlos como pendientes para revisarlos después desde Inicio o desde esta sección.
              </p>
              {pendGuardados
                ? <span style={{ fontSize: '0.83rem', color: '#1a6b3c', fontWeight: 600, whiteSpace: 'nowrap' }}>✓ Guardados como pendientes</span>
                : <button onClick={guardarSinMatchPendiente} disabled={guardandoPend}
                    style={{ padding: '0.4rem 0.9rem', background: '#f0c040', color: '#2c2c2a', border: 'none', borderRadius: '6px', fontWeight: 700, fontSize: '0.83rem', cursor: 'pointer', whiteSpace: 'nowrap' }}>
                    {guardandoPend ? 'Guardando...' : '📋 Guardar para revisar después'}
                  </button>
              }
            </div>
            <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: 0, fontSize: '0.86rem' }}>
              <thead>
                <tr style={{ background: '#f9f9f9', fontSize: '0.79rem', color: '#aaa', fontWeight: 600, textAlign: 'left', position: 'sticky', top: 0, zIndex: 2, boxShadow: 'inset 0 -1px 0 #eee' }}>
                  <th style={{ padding: '0.4rem 0.5rem' }}>ISBN</th>
                  <th style={{ padding: '0.4rem 0.5rem' }}>Título (lista)</th>
                  <th style={{ padding: '0.4rem 0.5rem' }}>Autor (lista)</th>
                  <th style={{ padding: '0.4rem 0.5rem' }}>Editorial (lista)</th>
                  <th style={{ padding: '0.4rem 0.5rem' }}>Nota</th>
                </tr>
              </thead>
              <tbody>
                {preview.sin_match.map((item, i) => (
                  <tr key={i} style={{ borderBottom: '1px solid #eee' }}>
                    <td style={{ padding: '0.4rem 0.5rem', fontFamily: 'monospace', color: '#999' }}>
                      <div>{item.isbn || '(vacío)'}</div>
                      {item.isbn_buscado && item.isbn_buscado !== item.isbn && (
                        <div style={{ fontSize: '0.75rem', color: '#bbb' }}>→ buscado: {item.isbn_buscado}</div>
                      )}
                    </td>
                    <td style={{ padding: '0.4rem 0.5rem', color: '#555' }}>{item.titulo_lista || '—'}</td>
                    <td style={{ padding: '0.4rem 0.5rem', color: '#888', fontSize: '0.84rem' }}>{item.autor_lista || '—'}</td>
                    <td style={{ padding: '0.4rem 0.5rem', color: '#aaa' }}>{item.editorial_lista || '—'}</td>
                    <td style={{ padding: '0.4rem 0.5rem', fontSize: '0.8rem', color: '#bbb' }}>{item.nota || 'No encontrado'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </SeccionPreview>
        )}

      </div>
    );
  }

  // ── FASE DONE ────────────────────────────────────────────────────────────────
  return (
    <div style={{ textAlign: 'center', padding: '3rem 1rem' }}>
      <div style={{ fontSize: '2.5rem', marginBottom: '0.5rem' }}>✓</div>
      <h3 style={{ margin: '0 0 0.5rem', color: '#1a6b3c' }}>Lista aplicada correctamente</h3>
      <p style={{ color: '#666', fontSize: '0.95rem', margin: '0 0 1.5rem' }}>
        Se actualizaron <strong>{resultado?.actualizados}</strong> lote{resultado?.actualizados !== 1 ? 's' : ''} en el inventario.
      </p>
      <button onClick={reiniciar} style={{ padding: '0.6rem 1.5rem', background: '#2c2c2a', color: 'white', border: 'none', cursor: 'pointer', borderRadius: '6px', fontWeight: 600 }}>
        Cargar otra lista
      </button>
    </div>
  );
}

// --- Pestaña Consignación (orquestadora) ---
function RepTabConsignacion() {
  const [pendientes, setPendientes] = useState([]);
  const [reportes,   setReportes]   = useState([]);
  const [facturas,   setFacturas]   = useState([]);
  const [cargando,   setCargando]   = useState(true);
  const [panelCrear,    setPanelCrear]    = useState(false);
  const [panelDistId,   setPanelDistId]   = useState('');
  const [panelReporte,       setPanelReporte]       = useState(null);
  const [panelDistHistorial, setPanelDistHistorial] = useState(null);

  useEffect(() => { cargarTodo(); }, []);

  async function cargarTodo() {
    setCargando(true);
    try {
      const [p, r, f] = await Promise.all([
        api.get('/consignacion/pendientes'),
        api.get('/consignacion/reportes'),
        api.get('/consignacion/facturas'),
      ]);
      setPendientes(p.data);
      setReportes(r.data);
      setFacturas(f.data);
    } catch (err) { console.error(err); }
    setCargando(false);
  }

  if (cargando) return <p style={{ color: 'var(--ink-400)', fontSize: 14 }}>Cargando...</p>;

  // Construir pipeline por distribuidor desde los datos reales
  const distMap = {};
  pendientes.forEach(p => {
    if (!distMap[p.distribuidor_id])
      distMap[p.distribuidor_id] = { id: p.distribuidor_id, nombre: p.distribuidor, items_pend: [], reporte: null, factura: null };
    distMap[p.distribuidor_id].items_pend.push(p);
  });
  // Incluir distribuidores con reporte pero sin pendientes
  reportes.forEach(r => {
    if (!distMap[r.distribuidor_id])
      distMap[r.distribuidor_id] = { id: r.distribuidor_id, nombre: r.distribuidor_nombre || r.distribuidor, items_pend: [], reporte: null, factura: null };
    // último reporte (más reciente)
    if (!distMap[r.distribuidor_id].reporte || r.creado_en > distMap[r.distribuidor_id].reporte.creado_en)
      distMap[r.distribuidor_id].reporte = r;
  });
  facturas.forEach(f => {
    if (!distMap[f.distribuidor_id])
      distMap[f.distribuidor_id] = { id: f.distribuidor_id, nombre: f.distribuidor_nombre || f.distribuidor, items_pend: [], reporte: null, factura: null };
    if (!distMap[f.distribuidor_id].factura || f.fecha > distMap[f.distribuidor_id].factura.fecha)
      distMap[f.distribuidor_id].factura = f;
  });

  // Construir tareas priorizadas
  const tareas = [];
  Object.values(distMap).forEach((d, i) => {
    const totalPend  = d.items_pend.reduce((s, p) => s + Number(p.total), 0);
    const hayAntiguas = d.items_pend.some(p => p.es_periodo_anterior);
    if (d.items_pend.length > 0) {
      tareas.push({
        key: `rep-${d.id}`, tipo: 'reportar', d, totalPend, hayAntiguas,
        urgencia: hayAntiguas ? 3 : 2,
        pillTone: hayAntiguas ? 'var(--bad-bg)' : 'var(--warn-bg)',
        pillInk:  hayAntiguas ? 'var(--bad-ink)' : 'var(--warn-ink)',
        pillLabel: hayAntiguas ? 'Urgente' : 'Pendiente',
        PillIcon: hayAntiguas ? AlertTriangle : Clock,
        accion: { label: 'Crear reporte', Icon: FilePlus, fn: () => setPanelCrear(true) },
      });
    }
    if (d.reporte && !d.factura) {
      tareas.push({
        key: `fac-${d.id}`, tipo: 'facturar', d, totalPend: 0,
        urgencia: 1, pillTone: 'var(--info-bg)', pillInk: 'var(--info-ink)',
        pillLabel: 'Facturar', PillIcon: FileText,
        accion: null,
      });
    }
    if (d.factura && d.factura.estado !== 'pagado') {
      tareas.push({
        key: `pago-${d.id}`, tipo: 'pagar', d, totalPend: 0,
        urgencia: 1, pillTone: 'var(--warn-bg)', pillInk: 'var(--warn-ink)',
        pillLabel: 'Por pagar', PillIcon: Wallet,
        accion: null,
      });
    }
  });
  tareas.sort((a, b) => b.urgencia - a.urgencia);

  const alDia = Object.values(distMap).filter(d =>
    d.items_pend.length === 0 &&
    !(d.reporte && !d.factura) &&
    !(d.factura && d.factura.estado !== 'pagado')
  );

  const distribuidoresConPendientes = Object.values(distMap)
    .filter(d => d.items_pend.length > 0)
    .map(d => ({ id: d.id, nombre: d.nombre }));

  // Reportes agrupados por distribuidor
  const reportesPorDist = {};
  reportes.forEach(r => {
    if (!reportesPorDist[r.distribuidor_id]) reportesPorDist[r.distribuidor_id] = [];
    reportesPorDist[r.distribuidor_id].push(r);
  });

  if (panelCrear) return (
    <div>
      <button onClick={() => setPanelCrear(false)} style={{ display: 'inline-flex', alignItems: 'center', gap: 6, marginBottom: 20, background: 'none', border: 'none', cursor: 'pointer', color: 'var(--ink-600)', fontSize: 13, fontFamily: 'inherit' }}>
        <ChevronLeft size={16} strokeWidth={2} /> Volver
      </button>
      <RepPanelCrearReporte distribuidores={distribuidoresConPendientes} defaultDistId={panelDistId} onReporteCreado={() => { cargarTodo(); setPanelCrear(false); }} />
    </div>
  );

  // Una fila por distribuidor (distMap ya garantiza unicidad), estado de mayor prioridad
  const filas = Object.values(distMap).map(d => {
    const totalPend = d.items_pend.reduce((s, p) => s + Number(p.total), 0);
    const hayAntiguas = d.items_pend.some(p => p.es_periodo_anterior);
    let tipo;
    if (d.items_pend.length > 0) tipo = 'reportar';
    else if (d.reporte && !d.factura) tipo = 'facturar';
    else if (d.factura && d.factura.estado !== 'pagado') tipo = 'pagar';
    else tipo = 'aldia';
    return { tipo, d, hayAntiguas, totalPend, key: `dist-${d.id}` };
  }).sort((a, b) => {
    const pri = t => t.tipo === 'reportar' && t.hayAntiguas ? 4 : t.tipo === 'reportar' ? 3 : t.tipo === 'facturar' ? 2 : t.tipo === 'pagar' ? 1 : 0;
    return pri(b) - pri(a);
  });

  const thStyle = { padding: '10px 14px', fontFamily: 'var(--font-ui)', fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.06em', color: 'var(--ink-400)', textAlign: 'left', borderBottom: '1px solid var(--line-soft)' };

  return (
    <div>
      {/* Header */}
      <p style={{ margin: '0 0 16px', fontSize: 13, color: 'var(--ink-500)' }}>
        {Object.values(distMap).length} distribuidor{Object.values(distMap).length !== 1 ? 'es' : ''}
        {filas.filter(f => f.tipo === 'reportar').length > 0 && ` · ${filas.filter(f => f.tipo === 'reportar').length} con ventas pendientes`}
      </p>

      {filas.length === 0 && (
        <div style={{ background: 'var(--paper)', border: '1px solid var(--line)', borderRadius: 20, padding: '48px 24px', textAlign: 'center', color: 'var(--ink-400)', fontSize: 14 }}>
          No hay distribuidores con consignación activa.
        </div>
      )}

      {filas.length > 0 && (
        <div style={{ border: '1px solid var(--line)', borderRadius: 16, overflow: 'hidden' }}>
          <div style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 540 }}>
            <thead>
              <tr style={{ background: 'var(--paper-stripe)' }}>
                <th style={thStyle}>Distribuidor</th>
                <th style={thStyle}>Último reporte</th>
                <th style={{ ...thStyle, textAlign: 'right' }}>Venta total</th>
                <th style={{ ...thStyle, textAlign: 'right' }}>Total a pagar</th>
                <th style={{ ...thStyle, width: 120 }}></th>
              </tr>
            </thead>
            <tbody>
              {filas.map((fila, i) => {
                const { d, tipo, hayAntiguas, totalPend } = fila;
                const reps = reportesPorDist[d.id] || [];

                const totalMostrar = tipo === 'reportar' ? totalPend : tipo === 'pagar' ? (d.factura?.total || 0) : 0;
                const totalCostoPend = tipo === 'reportar' ? d.items_pend.reduce((s, p) => s + Number(p.total_costo || 0), 0) : null;

                return (
                  <tr key={fila.key}
                    onClick={() => reps.length > 0 && setPanelDistHistorial(d)}
                    style={{ borderTop: i > 0 ? '1px solid var(--line-soft)' : 'none', cursor: reps.length > 0 ? 'pointer' : 'default', background: 'var(--paper)', opacity: tipo === 'aldia' ? 0.7 : 1 }}
                    onMouseEnter={e => { if (reps.length > 0) e.currentTarget.style.background = 'var(--paper-stripe)'; }}
                    onMouseLeave={e => e.currentTarget.style.background = 'var(--paper)'}>
                    <td style={{ padding: '12px 14px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                        <div style={{ width: 30, height: 30, borderRadius: '50%', background: `var(--past-${repToneAt(i)})`, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, fontSize: 12, fontWeight: 700, color: 'var(--ink-700)' }}>
                          {d.nombre?.[0]?.toUpperCase() || '?'}
                        </div>
                        <span style={{ fontWeight: 500, fontSize: 13.5 }}>{d.nombre}</span>
                      </div>
                    </td>
                    <td style={{ padding: '12px 14px', color: 'var(--ink-400)', fontSize: 12.5 }}>
                      {d.reporte ? repFmtMesAno(d.reporte.creado_en) : '—'}
                    </td>
                    <td style={{ padding: '12px 14px', textAlign: 'right', fontWeight: 700, fontSize: 14, fontVariantNumeric: 'tabular-nums' }}>
                      {totalMostrar > 0 ? repFmtClp(totalMostrar) : '—'}
                    </td>
                    <td style={{ padding: '12px 14px', textAlign: 'right', fontWeight: 700, fontSize: 14, fontVariantNumeric: 'tabular-nums', color: 'var(--ink-700)' }}>
                      {totalCostoPend !== null ? (totalCostoPend > 0 ? repFmtClp(totalCostoPend) : '—') : '—'}
                    </td>
                    <td style={{ padding: '10px 14px', textAlign: 'right' }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 8 }}>
                        {tipo === 'reportar' && (
                          <button
                            onClick={e => { e.stopPropagation(); setPanelDistId(String(d.id)); setPanelCrear(true); }}
                            style={{ display: 'inline-flex', alignItems: 'center', gap: 5, padding: '6px 12px', background: 'var(--ink-900)', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 12, fontWeight: 600, fontFamily: 'inherit', whiteSpace: 'nowrap' }}>
                            <FilePlus size={12} strokeWidth={2} /> Reportar
                          </button>
                        )}
                        <ChevronRight size={15} strokeWidth={2} color="var(--ink-300)" style={{ flexShrink: 0, opacity: reps.length > 0 ? 1 : 0 }} />
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          </div>
        </div>
      )}

      {/* Drawer lateral — historial de distribuidor + detalle de reporte */}
      {panelDistHistorial && (
        <>
          <div onClick={() => { setPanelDistHistorial(null); setPanelReporte(null); }}
            style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.35)', zIndex: 200 }} />
          <div style={{ position: 'fixed', top: 0, right: 0, width: 540, maxWidth: '95vw', height: '100vh', background: 'var(--paper)', boxShadow: '-6px 0 32px rgba(0,0,0,0.18)', zIndex: 201, overflowY: 'auto', padding: '24px 24px 40px' }}>
            <button onClick={() => { setPanelDistHistorial(null); setPanelReporte(null); }}
              style={{ position: 'absolute', top: 16, right: 16, background: 'none', border: 'none', cursor: 'pointer', color: 'var(--ink-500)', display: 'flex', alignItems: 'center', gap: 4, fontSize: 13, fontFamily: 'inherit' }}>
              <X size={18} strokeWidth={2} />
            </button>
            {panelReporte
              ? <RepDetalleReporte reporte={panelReporte} onVolver={() => setPanelReporte(null)} />
              : (
                <>
                  <div style={{ marginBottom: 24 }}>
                    <div style={{ fontWeight: 700, fontSize: 17, marginBottom: 3 }}>{panelDistHistorial.nombre}</div>
                    <div style={{ fontSize: 13, color: 'var(--ink-400)' }}>Historial de reportes</div>
                  </div>
                  <RepHistorialReportes
                    reportes={reportesPorDist[panelDistHistorial.id] || []}
                    onVerDetalle={r => setPanelReporte(r)}
                  />
                </>
              )
            }
          </div>
        </>
      )}
    </div>
  );
}

// --- Módulo Reportes (raíz) ---
// ── Importar ventas históricas ────────────────────────────────────────────────
function RepTabHistorico() {
  const [resumen,     setResumen]     = useState(null);
  const [cargandoRes, setCargandoRes] = useState(true);
  const [preview,     setPreview]     = useState(null);
  const [totales,     setTotales]     = useState(null);
  const [procesando,  setProcesando]  = useState(false);
  const [resultado,   setResultado]   = useState(null);
  const [errorMsg,    setErrorMsg]    = useState('');
  const fileRef = useRef(null);

  const clp = n => '$ ' + Number(n || 0).toLocaleString('es-CL', { maximumFractionDigits: 0 });

  useEffect(() => {
    api.get('/ventas/historico')
      .then(r => setResumen(r.data))
      .catch(() => setResumen([]))
      .finally(() => setCargandoRes(false));
  }, [resultado]);

  async function descargarPlantilla() {
    try {
      const token = localStorage.getItem('relea_token');
      const base = (api.defaults.baseURL || '').replace(/\/$/, '');
      const r = await fetch(`${base}/ventas/historico/plantilla`, { headers: { Authorization: `Bearer ${token}` } });
      if (!r.ok) { const msg = await r.text(); throw new Error(`Error ${r.status}: ${msg}`); }
      const blob = await r.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a'); a.href = url; a.download = 'plantilla-ventas-historicas.xlsx'; a.click();
      URL.revokeObjectURL(url);
    } catch (err) {
      alert('No se pudo descargar la plantilla: ' + err.message);
    }
  }

  async function handleArchivo(e) {
    const file = e.target.files?.[0];
    if (!file) return;
    setPreview(null); setTotales(null); setErrorMsg(''); setResultado(null);
    setProcesando(true);
    try {
      const token = localStorage.getItem('relea_token');
      const fd = new FormData(); fd.append('archivo', file);
      const r = await fetch(`${api.defaults.baseURL}/ventas/historico/preview`, {
        method: 'POST', headers: { Authorization: `Bearer ${token}` }, body: fd,
      });
      const data = await r.json();
      if (!r.ok) throw new Error(data.error || 'Error al procesar el archivo');
      setPreview(data.preview);
      setTotales(data.totales);
    } catch (err) {
      setErrorMsg(err.message);
    } finally {
      setProcesando(false);
      e.target.value = '';
    }
  }

  async function confirmar() {
    if (!preview?.length) return;
    setProcesando(true); setErrorMsg('');
    const CHUNK = 2000;
    let totalInsertadas = 0;
    try {
      for (let i = 0; i < preview.length; i += CHUNK) {
        const lote = preview.slice(i, i + CHUNK);
        const r = await api.post('/ventas/historico/confirmar', { filas: lote });
        totalInsertadas += r.data.insertadas || lote.length;
      }
      setResultado({ insertadas: totalInsertadas });
      setPreview(null); setTotales(null);
    } catch (err) {
      const msg = err.response?.data?.error || err.message || 'Error desconocido';
      setErrorMsg('Error al confirmar: ' + msg);
      console.error('[confirmar historico]', err);
    } finally { setProcesando(false); }
  }

  const TH = { padding: '9px 12px', textAlign: 'left', fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.06em', color: 'var(--ink-500)', fontWeight: 600, whiteSpace: 'nowrap', background: 'var(--paper-stripe)' };
  const TD = { padding: '9px 12px', fontSize: 13, verticalAlign: 'middle' };
  const TDr = { ...TD, textAlign: 'right', fontVariantNumeric: 'tabular-nums' };

  return (
    <div style={{ maxWidth: 880 }}>
      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 24, gap: 16, flexWrap: 'wrap' }}>
        <div>
          <h3 style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 20, letterSpacing: '-0.015em', margin: 0 }}>Ventas históricas</h3>
          <div style={{ fontSize: 13, color: 'var(--ink-500)', marginTop: 4 }}>Importa ventas de años anteriores para completar el historial</div>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button onClick={descargarPlantilla}
            style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '8px 16px', border: '1px solid var(--line-strong)', background: 'var(--paper)', color: 'var(--ink-800)', borderRadius: 999, cursor: 'pointer', fontFamily: 'inherit', fontSize: 13, fontWeight: 500 }}>
            <Download size={14} strokeWidth={1.75} /> Descargar plantilla
          </button>
          <button onClick={() => fileRef.current?.click()} disabled={procesando}
            style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '8px 18px', border: 'none', background: 'var(--brand)', color: '#fff', borderRadius: 999, cursor: procesando ? 'not-allowed' : 'pointer', fontFamily: 'inherit', fontSize: 13, fontWeight: 600, opacity: procesando ? 0.7 : 1 }}>
            <Upload size={14} strokeWidth={1.75} /> {procesando ? 'Procesando…' : 'Subir Excel'}
          </button>
          <input ref={fileRef} type="file" accept=".xlsx,.xls" onChange={handleArchivo} style={{ display: 'none' }} />
        </div>
      </div>

      {/* Instrucciones */}
      <div style={{ background: 'var(--info-bg)', border: '1px solid var(--info-line)', borderRadius: 14, padding: '14px 18px', marginBottom: 24, fontSize: 13, color: 'var(--info-ink)', lineHeight: 1.6 }}>
        <strong>Cómo usar:</strong> Descarga la plantilla, completa las columnas <strong>Fecha, ISBN, Título, Cantidad, Efectivo, Débito, Crédito, Transferencia, Total, Utilidad</strong> y sube el archivo. Cada fila es una venta individual. El sistema cruzará los ISBN con el inventario cuando sea posible.
      </div>

      {/* Error */}
      {errorMsg && (
        <div style={{ background: 'var(--bad-bg)', border: '1px solid var(--bad-line)', borderRadius: 12, padding: '12px 16px', marginBottom: 16, color: 'var(--bad-ink)', fontSize: 13 }}>
          {errorMsg}
        </div>
      )}

      {/* Resultado importación */}
      {resultado && (
        <div style={{ background: 'var(--ok-bg)', border: '1px solid var(--ok-line)', borderRadius: 14, padding: '14px 18px', marginBottom: 24, display: 'flex', alignItems: 'center', gap: 10, color: 'var(--ok-ink)', fontSize: 13 }}>
          <CheckCircle size={16} strokeWidth={2} />
          <span><strong>{resultado.insertadas} filas</strong> importadas correctamente.</span>
        </div>
      )}

      {/* Preview */}
      {preview && totales && (
        <div style={{ marginBottom: 24 }}>
          {/* Resumen del preview */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 12, marginBottom: 16 }}>
            {[
              { label: 'Filas',      val: totales.filas.toLocaleString('es-CL') },
              { label: 'Total',      val: clp(totales.total) },
              { label: 'Utilidad',   val: clp(totales.utilidad) },
              { label: 'Sin ISBN',   val: totales.sin_isbn + ' sin cruzar', warn: totales.sin_isbn > 0 },
            ].map(({ label, val, warn }) => (
              <div key={label} style={{ background: warn ? 'var(--warn-bg)' : 'var(--paper)', border: '1px solid ' + (warn ? 'var(--warn-line)' : 'var(--line)'), borderRadius: 14, padding: '12px 16px' }}>
                <div style={{ fontSize: 10, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.08em', color: warn ? 'var(--warn-ink)' : 'var(--ink-500)', marginBottom: 4 }}>{label}</div>
                <div style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 20, color: warn ? 'var(--warn-ink)' : 'var(--ink-900)' }}>{val}</div>
              </div>
            ))}
          </div>

          <div style={{ border: '1px solid var(--line)', borderRadius: 16, overflow: 'hidden', marginBottom: 14 }}>
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                <thead>
                  <tr>
                    {['Fecha','ISBN','Título','Cant.','Efectivo','Débito','Crédito','Transf.','Total','Utilidad','Estado'].map(h => (
                      <th key={h} style={TH}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {preview.slice(0, 100).map((f, i) => (
                    <tr key={i} style={{ borderTop: '1px solid var(--line-soft)', background: f.isbn_encontrado || !f.isbn ? 'transparent' : 'var(--warn-bg)' }}>
                      <td style={{ ...TD, fontFamily: 'var(--font-mono)', fontSize: 12 }}>{f.fecha}</td>
                      <td style={{ ...TD, fontFamily: 'var(--font-mono)', fontSize: 11, color: 'var(--ink-500)' }}>{f.isbn || '—'}</td>
                      <td style={TD}>{f.titulo_sistema || f.titulo || '—'}</td>
                      <td style={TDr}>{f.cantidad}</td>
                      <td style={TDr}>{f.efectivo ? clp(f.efectivo) : '—'}</td>
                      <td style={TDr}>{f.debito ? clp(f.debito) : '—'}</td>
                      <td style={TDr}>{f.credito ? clp(f.credito) : '—'}</td>
                      <td style={TDr}>{f.transferencia ? clp(f.transferencia) : '—'}</td>
                      <td style={{ ...TDr, fontWeight: 600 }}>{clp(f.total)}</td>
                      <td style={{ ...TDr, color: 'var(--ok-ink)' }}>{clp(f.utilidad)}</td>
                      <td style={TD}>
                        {f.isbn_encontrado
                          ? <span style={{ padding: '2px 8px', borderRadius: 999, background: 'var(--ok-bg)', color: 'var(--ok-ink)', fontSize: 11, fontWeight: 600 }}>✓ Cruzado</span>
                          : f.isbn
                            ? <span style={{ padding: '2px 8px', borderRadius: 999, background: 'var(--warn-bg)', color: 'var(--warn-ink)', fontSize: 11, fontWeight: 500 }}>Sin match</span>
                            : <span style={{ color: 'var(--ink-400)', fontSize: 11 }}>Sin ISBN</span>}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {preview.length > 100 && (
              <div style={{ padding: '10px 14px', fontSize: 12, color: 'var(--ink-500)', background: 'var(--paper-stripe)', textAlign: 'center' }}>
                Mostrando 100 de {preview.length} filas
              </div>
            )}
          </div>

          <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
            <button onClick={() => { setPreview(null); setTotales(null); }}
              style={{ padding: '9px 18px', border: '1px solid var(--line-strong)', background: 'var(--paper)', color: 'var(--ink-800)', borderRadius: 999, cursor: 'pointer', fontFamily: 'inherit', fontSize: 13 }}>
              Cancelar
            </button>
            <button onClick={confirmar} disabled={procesando}
              style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '9px 20px', border: 'none', background: 'var(--brand)', color: '#fff', borderRadius: 999, cursor: procesando ? 'not-allowed' : 'pointer', fontFamily: 'inherit', fontSize: 13, fontWeight: 600, opacity: procesando ? 0.7 : 1 }}>
              <Check size={14} strokeWidth={2.5} /> Confirmar importación ({preview.length} filas)
            </button>
          </div>
        </div>
      )}

      {/* Historial de importaciones */}
      {!preview && (
        <div>
          <div style={{ fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.08em', color: 'var(--ink-500)', marginBottom: 12 }}>Historial importado por mes</div>
          {cargandoRes && <div style={{ color: 'var(--ink-400)', fontSize: 13 }}>Cargando…</div>}
          {!cargandoRes && (!resumen || resumen.length === 0) && (
            <div style={{ background: 'var(--paper)', border: '1px solid var(--line)', borderRadius: 14, padding: '32px 20px', textAlign: 'center', color: 'var(--ink-400)', fontSize: 13 }}>
              Aún no hay ventas históricas importadas. Sube un Excel para comenzar.
            </div>
          )}
          {!cargandoRes && resumen?.length > 0 && (
            <div style={{ border: '1px solid var(--line)', borderRadius: 16, overflow: 'hidden' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                <thead>
                  <tr>
                    {['Mes','Ventas registradas','Unidades','Total ventas','Utilidad'].map(h => (
                      <th key={h} style={TH}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {resumen.map((r, i) => (
                    <tr key={i} style={{ borderTop: i ? '1px solid var(--line-soft)' : 'none' }}>
                      <td style={{ ...TD, fontFamily: 'var(--font-mono)', fontWeight: 600 }}>{r.mes}</td>
                      <td style={TDr}>{Number(r.filas).toLocaleString('es-CL')}</td>
                      <td style={TDr}>{Number(r.cantidad).toLocaleString('es-CL')}</td>
                      <td style={{ ...TDr, fontWeight: 600 }}>{clp(r.total)}</td>
                      <td style={{ ...TDr, color: 'var(--ok-ink)' }}>{clp(r.utilidad)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

// =============================================================================
// MÓDULO CONSIGNACIÓN
// =============================================================================
function PendientesConsignacion() {
  const [items, setItems] = useState([]);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    api.get('/consignacion/sin-match-pendientes')
      .then(r => setItems(r.data))
      .catch(() => {})
      .finally(() => setCargando(false));
  }, []);

  async function marcarRevisado(id) {
    await api.patch(`/consignacion/sin-match-pendientes/${id}/revisado`);
    setItems(prev => prev.filter(x => x.id !== id));
  }

  async function marcarTodosRevisados(ids) {
    await Promise.all(ids.map(id => api.patch(`/consignacion/sin-match-pendientes/${id}/revisado`)));
    setItems(prev => prev.filter(x => !ids.includes(x.id)));
  }

  async function eliminar(id) {
    await api.delete(`/consignacion/sin-match-pendientes/${id}`);
    setItems(prev => prev.filter(x => x.id !== id));
  }

  if (cargando) return <p style={{ color: 'var(--ink-400)', fontSize: 13, fontFamily: 'var(--font-ui)' }}>Cargando...</p>;
  if (items.length === 0) return (
    <div style={{ border: '1px solid var(--line)', borderRadius: 12, padding: '2rem', textAlign: 'center', color: 'var(--ink-400)', fontFamily: 'var(--font-ui)', fontSize: 13 }}>
      No hay ISBNs pendientes de revisión.
    </div>
  );

  // Group by distributor
  const grupos = {};
  items.forEach(it => {
    const key = it.distribuidor_id || 'sin_dist';
    if (!grupos[key]) grupos[key] = { nombre: it.distribuidor_nombre || 'Sin distribuidor', items: [] };
    grupos[key].items.push(it);
  });

  return (
    <div>
      <p style={{ margin: '0 0 1.25rem', fontSize: 13, color: 'var(--ink-500)', fontFamily: 'var(--font-ui)' }}>
        {items.length} ISBN{items.length !== 1 ? 's' : ''} sin coincidencia · revisión pendiente
      </p>
      {Object.entries(grupos).map(([key, grupo], gi) => (
        <div key={key} style={{ marginBottom: 20 }}>
          {/* Group header */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
            <div style={{ width: 28, height: 28, borderRadius: '50%', background: `var(--past-${repToneAt(gi)})`, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, fontSize: 12, fontWeight: 700, color: 'var(--ink-700)' }}>
              {grupo.nombre[0]?.toUpperCase() || '?'}
            </div>
            <span style={{ fontWeight: 600, fontSize: 13.5 }}>{grupo.nombre}</span>
            <span style={{ display: 'inline-flex', alignItems: 'center', padding: '2px 8px', borderRadius: 999, background: 'var(--paper-stripe)', color: 'var(--ink-500)', fontSize: 11.5, fontWeight: 600 }}>
              {grupo.items.length}
            </span>
            <button onClick={() => marcarTodosRevisados(grupo.items.map(i => i.id))}
              style={{ marginLeft: 'auto', padding: '4px 12px', background: 'none', border: '1px solid var(--line)', borderRadius: 8, cursor: 'pointer', fontSize: 12, color: 'var(--ink-600)', fontFamily: 'inherit' }}>
              Marcar todos
            </button>
          </div>
          {/* Item rows */}
          <div style={{ border: '1px solid var(--line)', borderRadius: 12, overflow: 'hidden' }}>
            {grupo.items.map((it, i) => (
              <div key={it.id}
                style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '10px 14px', borderTop: i > 0 ? '1px solid var(--line-soft)' : 'none', background: 'var(--paper)' }}>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontWeight: 500, fontSize: 13.5, marginBottom: 2 }}>{it.titulo_lista || '—'}</div>
                  <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', fontSize: 12, color: 'var(--ink-400)' }}>
                    {it.isbn && <span style={{ fontFamily: 'monospace', fontSize: 11 }}>{it.isbn}</span>}
                    {it.autor_lista && <span>{it.autor_lista}</span>}
                    {it.editorial_lista && <span>{it.editorial_lista}</span>}
                    {it.stock_lista != null && <span>Stock: {it.stock_lista}</span>}
                  </div>
                </div>
                <div style={{ fontSize: 11, color: 'var(--ink-300)', flexShrink: 0 }}>
                  {new Date(it.creado_en).toLocaleDateString('es-CL', { day: '2-digit', month: '2-digit', year: '2-digit' })}
                </div>
                <div style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
                  <button onClick={() => marcarRevisado(it.id)}
                    style={{ padding: '4px 10px', background: 'var(--ink-900)', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 11.5, fontFamily: 'var(--font-ui)', fontWeight: 600 }}>
                    Revisado
                  </button>
                  <button onClick={() => eliminar(it.id)}
                    style={{ padding: '4px 8px', background: 'none', border: '1px solid var(--line)', borderRadius: 8, cursor: 'pointer', fontSize: 11, color: 'var(--ink-400)', fontFamily: 'var(--font-ui)' }}>
                    ✕
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

function ModuloConsignacion() {
  const LS_KEY = 'relea_consig_tab';
  const [tab, setTab] = useState(() => localStorage.getItem(LS_KEY) || 'importar');
  const [pendCount,     setPendCount]     = useState(0);
  const [distribuidores, setDistribuidores] = useState([]);
  useEffect(() => { localStorage.setItem(LS_KEY, tab); }, [tab]);
  useEffect(() => {
    api.get('/consignacion/sin-match-pendientes').then(r => setPendCount(r.data.length)).catch(() => {});
    api.get('/distribuidores').then(r => setDistribuidores(r.data)).catch(() => {});
  }, []);

  const TABS = [
    { id: 'reportar',   label: 'Reportar ventas',  Icon: ClipboardList },
    { id: 'crear',      label: 'Crear reporte',    Icon: FilePlus      },
    { id: 'importar',   label: 'Importar lista',   Icon: Upload        },
    { id: 'pendientes', label: 'ISBNs pendientes', Icon: ClipboardList, count: pendCount },
  ];

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 24 }}>
        <h1 style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 26, letterSpacing: '-0.015em', margin: 0 }}>Consignación</h1>
      </div>
      <div style={{ display: 'flex', gap: 6, marginBottom: 28, flexWrap: 'wrap' }}>
        {TABS.map(({ id, label, Icon, count }) => {
          const on = tab === id;
          return (
            <button key={id} onClick={() => setTab(id)} style={{
              display: 'inline-flex', alignItems: 'center', gap: 7,
              padding: '9px 18px', borderRadius: 999, fontSize: 14, fontFamily: 'inherit',
              border: '1px solid ' + (on ? 'var(--ink-900)' : 'var(--line)'),
              background: on ? 'var(--ink-900)' : 'var(--paper)',
              color: on ? '#fff' : 'var(--ink-700)', cursor: 'pointer', fontWeight: on ? 600 : 500,
              transition: 'background 140ms ease, color 140ms ease',
            }}>
              <Icon size={15} strokeWidth={1.75} /> {label}
              {count > 0 && <span style={{ background: '#856404', color: 'white', borderRadius: 999, padding: '1px 7px', fontSize: 11, fontWeight: 700, marginLeft: 2 }}>{count}</span>}
            </button>
          );
        })}
      </div>
      {tab === 'reportar'   && <RepTabConsignacion />}
      {tab === 'crear'      && <RepPanelCrearReporte distribuidores={distribuidores} onReporteCreado={() => setTab('reportar')} />}
      {tab === 'importar'   && <RepCargarLista />}
      {tab === 'pendientes' && <PendientesConsignacion />}
    </div>
  );
}

function ModuloReportes() {
  const LS_KEY = 'relea_rep_tab';
  const [tab, setTab] = useState(() => localStorage.getItem(LS_KEY) || 'ventas');
  useEffect(() => { localStorage.setItem(LS_KEY, tab); }, [tab]);

  const TABS = [
    { id: 'ventas',    label: 'Ventas',           Icon: Receipt  },
    { id: 'historico', label: 'Ventas históricas', Icon: RotateCw },
  ];

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 24 }}>
        <h1 style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 26, letterSpacing: '-0.015em', margin: 0 }}>Ventas</h1>
      </div>
      <div style={{ display: 'flex', gap: 6, marginBottom: 28, flexWrap: 'wrap' }}>
        {TABS.map(({ id, label, Icon }) => {
          const on = tab === id;
          return (
            <button key={id} onClick={() => setTab(id)} style={{
              display: 'inline-flex', alignItems: 'center', gap: 7,
              padding: '9px 18px', borderRadius: 999, fontSize: 14, fontFamily: 'inherit',
              border: '1px solid ' + (on ? 'var(--ink-900)' : 'var(--line)'),
              background: on ? 'var(--ink-900)' : 'var(--paper)',
              color: on ? '#fff' : 'var(--ink-700)', cursor: 'pointer', fontWeight: on ? 600 : 500,
              transition: 'background 140ms ease, color 140ms ease',
            }}>
              <Icon size={15} strokeWidth={1.75} /> {label}
            </button>
          );
        })}
      </div>
      {tab === 'ventas'    && <RepTabVentas />}
      {tab === 'historico' && <RepTabHistorico />}
    </div>
  );
}

// Paleta pastel compartida — POS, Inventario, y cualquier módulo con íconos de libro
const POS_TONES = ['peach', 'mint', 'rose', 'blue', 'violet', 'olive', 'yellow', 'sand'];
const itemTone  = (id) => POS_TONES[Math.abs(parseInt(id, 10) || 0) % 8];

// ---------------------------------------------------------------------------
// calcGruposBusqueda — shared by Dashboard and POS dropdowns
// Returns { grupos: [{ header?, iconKey, items }], totalItems }
// Groups: 'book' = título/ISBN, 'user' = autor, 'building' = editorial
// ---------------------------------------------------------------------------
function calcGruposBusqueda(lotes, query) {
  const q = query.toLowerCase();
  const sortByStock = arr => {
    const con = arr.filter(l => (l.stock ?? 0) > 0);
    const sin = arr.filter(l => (l.stock ?? 0) <= 0);
    return [...con, ...sin];
  };
  const titleISBNItems = [], autorItems = [], editorialItems = [];
  for (const l of lotes) {
    if (l.titulo?.toLowerCase().includes(q) || l.isbn?.includes(query)) {
      titleISBNItems.push(l);
    } else if (l.autor?.toLowerCase().includes(q)) {
      autorItems.push(l);
    } else if (l.editorial?.toLowerCase().includes(q)) {
      editorialItems.push(l);
    }
  }
  const grupos = [];
  if (titleISBNItems.length > 0)
    grupos.push({ iconKey: 'book', items: sortByStock(titleISBNItems).slice(0, 30) });
  if (autorItems.length > 0) {
    const autores     = [...new Set(autorItems.map(l => l.autor).filter(Boolean))];
    const header      = autores.length === 1 ? `Autor: ${autores[0]}` : `Autor: "${query}"`;
    grupos.push({ header, iconKey: 'user', items: sortByStock(autorItems).slice(0, 20) });
  }
  if (editorialItems.length > 0) {
    const editoriales = [...new Set(editorialItems.map(l => l.editorial).filter(Boolean))];
    const header      = editoriales.length === 1 ? `Editorial: ${editoriales[0]}` : `Editorial: "${query}"`;
    grupos.push({ header, iconKey: 'building', items: sortByStock(editorialItems).slice(0, 20) });
  }
  return { grupos, totalItems: grupos.reduce((s, g) => s + g.items.length, 0) };
}

const TONE_STYLES = {
  peach:  { bg: 'var(--past-peach)',  ink: 'var(--past-peach-ink)'  },
  mint:   { bg: 'var(--past-mint)',   ink: 'var(--past-mint-ink)'   },
  rose:   { bg: 'var(--past-rose)',   ink: 'var(--past-rose-ink)'   },
  blue:   { bg: 'var(--past-blue)',   ink: 'var(--past-blue-ink)'   },
  violet: { bg: 'var(--past-violet)', ink: 'var(--past-violet-ink)' },
  olive:  { bg: 'var(--past-olive)',  ink: 'var(--past-olive-ink)'  },
  yellow: { bg: 'var(--past-yellow)', ink: 'var(--past-yellow-ink)' },
  sand:   { bg: 'var(--past-sand)',   ink: 'var(--past-sand-ink)'   },
};

function PosUltimasVentas({ ventas, onAnulada }) {
  const [fichaLibro, setFichaLibro] = useState(null);
  if (!ventas || ventas.length === 0) return null;
  return (
    <div style={{ background: 'var(--paper)', borderRadius: 20, padding: '18px 0 0', boxShadow: 'var(--shadow-card)', marginTop: 16, overflow: 'hidden' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 20px 14px' }}>
        <span style={{ fontSize: 12, color: 'var(--ink-500)', textTransform: 'uppercase', letterSpacing: '0.08em', fontWeight: 500 }}>
          Últimas ventas del día
        </span>
        <span style={{ fontSize: 12, color: 'var(--ink-400)' }}>{ventas.length} ventas</span>
      </div>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr style={{ background: 'var(--paper-stripe)', borderBottom: '1px solid var(--line-soft)', textAlign: 'left' }}>
            <th style={repTh2}>Hora</th>
            <th style={repTh2}>Libros</th>
            <th style={repTh2}>Pago</th>
            <th style={{ ...repTh2, textAlign: 'right' }}>Total</th>
            <th style={repTh2}></th>
          </tr>
        </thead>
        <tbody>
          {ventas.map(v => <RepFilaVenta key={v.id} venta={v} onAnulada={onAnulada} onLibroClick={setFichaLibro} />)}
        </tbody>
      </table>
      {fichaLibro && <InvFichaLibro libro={fichaLibro} abierto={true} onClose={() => setFichaLibro(null)} onLibroActualizado={() => {}} />}
    </div>
  );
}

function imprimirTicketCambio(codigo, titulo, nLibros) {
  const ahora = new Date();
  const f = d => d.toLocaleDateString('es-CL', { day: '2-digit', month: '2-digit', year: 'numeric' });
  const cuerpo = titulo
    ? `<div class="titulo">${titulo}</div>`
    : `<div class="tipo">Compra completa · ${nLibros} libro${nLibros !== 1 ? 's' : ''}</div>`;
  const win = window.open('', '_blank', 'width=320,height=460,toolbar=0,menubar=0,scrollbars=0');
  if (!win) return;
  win.document.write(`<!DOCTYPE html><html><head><meta charset="UTF-8">
<title>TC ${codigo}</title>
<style>
  *{margin:0;padding:0;box-sizing:border-box}
  body{font-family:'Courier New',monospace;padding:24px 20px;text-align:center;background:#fff;color:#111}
  .lib{font-size:13px;font-weight:700;letter-spacing:.1em;text-transform:uppercase}
  .fecha{font-size:10px;color:#555;margin-top:3px}
  hr{border:none;border-top:1px dashed #aaa;margin:12px 0}
  .label{font-size:9px;text-transform:uppercase;letter-spacing:.1em;color:#888;margin-bottom:6px}
  .codigo{font-size:32px;font-weight:700;letter-spacing:.15em;margin:10px 0;color:#5B21B6}
  .titulo{font-size:11px;margin:6px 8px 2px;line-height:1.4}
  .tipo{font-size:10px;color:#666}
</style></head><body>
  <div class="lib">LIBRERÍA DE FUEGO</div>
  <div class="fecha">${f(ahora)}</div>
  <hr>
  <div class="label">Ticket de cambio</div>
  <div class="codigo">${codigo}</div>
  ${cuerpo}
</body></html>`);
  win.document.close();
  win.focus();
  setTimeout(() => { try { win.print(); } catch {} }, 400);
}

function PosTicketGenerador({ ventaId, ventaItems }) {
  // null = generando, objeto = listo { individual: {id: codigo|{error}}, total: codigo|null }
  const [tcs,    setTcs]    = useState(null);
  const [reintentando, setReintentando] = useState(false);

  function generar() {
    if (!ventaId || !ventaItems?.length) return;
    setTcs(null);
    setReintentando(false);
    let cancelado = false;
    async function generarTodos() {
      const individual = {};
      await Promise.all(ventaItems.map(async item => {
        try {
          const r = await api.post('/tickets-cambio', {
            venta_id: ventaId,
            tipo: 'individual',
            items: [{ venta_detalle_id: item.venta_detalle_id, titulo_snapshot: item.titulo, precio_original: Number(item.precio_unitario) }],
          });
          individual[item.venta_detalle_id] = r.data.codigo;
        } catch (e) {
          const msg = e.response?.data?.error || e.message || 'Error desconocido';
          console.error('[TC individual]', msg, { ventaId, item });
          individual[item.venta_detalle_id] = { error: msg };
        }
      }));
      let total = null;
      if (ventaItems.length > 1) {
        try {
          const r = await api.post('/tickets-cambio', {
            venta_id: ventaId,
            tipo: 'total',
            items: ventaItems.map(i => ({ venta_detalle_id: i.venta_detalle_id, titulo_snapshot: i.titulo, precio_original: Number(i.precio_unitario) })),
          });
          total = r.data.codigo;
        } catch (e) {
          console.error('[TC total]', e.response?.data?.error || e.message);
        }
      }
      if (!cancelado) setTcs({ individual, total });
    }
    generarTodos();
    return () => { cancelado = true; };
  }

  useEffect(() => {
    const cleanup = generar();
    return cleanup;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ventaId]);

  if (!ventaId || !ventaItems?.length) return null;

  const rowStyle = { display: 'flex', alignItems: 'center', gap: 10, padding: '8px 14px' };
  const btnStyle = { padding: '5px 11px', background: '#7C3AED', color: '#fff', border: 'none', borderRadius: 'var(--r-pill)', fontSize: 11, fontWeight: 600, cursor: 'pointer', fontFamily: 'var(--font-ui)', whiteSpace: 'nowrap', display: 'inline-flex', alignItems: 'center', gap: 5, flexShrink: 0 };

  return (
    <div className="no-print" style={{ margin: '0 20px 16px', background: '#F5F3FF', borderRadius: 12, border: '1px solid rgba(109,40,217,0.15)', overflow: 'hidden' }}>
      <div style={{ padding: '10px 14px 8px', borderBottom: '1px solid rgba(109,40,217,0.1)', fontSize: 11, fontWeight: 600, color: '#A78BFA', textTransform: 'uppercase', letterSpacing: '0.07em', fontFamily: 'var(--font-ui)' }}>
        Tickets de cambio
      </div>
      {!tcs ? (
        <div style={{ padding: 14, fontSize: 12, color: '#A78BFA', fontFamily: 'var(--font-ui)', textAlign: 'center' }}>Generando tickets…</div>
      ) : (
        <div style={{ padding: '4px 0' }}>
          {ventaItems.map(item => {
            const val = tcs.individual[item.venta_detalle_id];
            const ok  = typeof val === 'string';
            return (
              <div key={item.venta_detalle_id} style={rowStyle}>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 11, fontWeight: 500, color: '#374151', fontFamily: 'var(--font-ui)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item.titulo}</div>
                  {ok && <div style={{ fontFamily: 'var(--font-mono)', fontSize: 13, fontWeight: 700, color: '#7C3AED', letterSpacing: '0.08em', marginTop: 1 }}>{val}</div>}
                  {!ok && val?.error && <div style={{ fontSize: 10, color: '#EF4444', fontFamily: 'var(--font-mono)', marginTop: 2, whiteSpace: 'normal', wordBreak: 'break-word' }}>{val.error}</div>}
                </div>
                {ok
                  ? <button onClick={() => imprimirTicketCambio(val, item.titulo, null)} style={btnStyle}><Printer size={11} strokeWidth={2} /> Imprimir</button>
                  : <button onClick={() => { setReintentando(true); generar(); }} style={{ ...btnStyle, background: '#EF4444' }}>Reintentar</button>
                }
              </div>
            );
          })}
          {ventaItems.length > 1 && (
            <>
              <div style={{ borderTop: '1px solid rgba(109,40,217,0.1)', margin: '4px 0' }} />
              <div style={rowStyle}>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 11, fontWeight: 600, color: '#7C3AED', fontFamily: 'var(--font-ui)' }}>TC total · {ventaItems.length} libros</div>
                  {tcs.total && <div style={{ fontFamily: 'var(--font-mono)', fontSize: 13, fontWeight: 700, color: '#7C3AED', letterSpacing: '0.08em', marginTop: 1 }}>{tcs.total}</div>}
                </div>
                {tcs.total
                  ? <button onClick={() => imprimirTicketCambio(tcs.total, null, ventaItems.length)} style={btnStyle}><Printer size={11} strokeWidth={2} /> Imprimir</button>
                  : <button onClick={() => { setReintentando(true); generar(); }} style={{ ...btnStyle, background: '#EF4444' }}>Reintentar</button>
                }
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
}

const POS_METODOS_A = [
  { key: 'efectivo',      label: 'Efectivo',      Icon: Banknote,       tone: 'mint',   atajo: '1' },
  { key: 'debito',        label: 'Débito',        Icon: CreditCard,     tone: 'blue',   atajo: '2' },
  { key: 'credito',       label: 'Crédito',       Icon: WalletCards,    tone: 'violet', atajo: '3' },
  { key: 'transferencia', label: 'Transferencia', Icon: ArrowRightLeft, tone: 'peach',  atajo: '4' },
  { key: 'giftcard',      label: 'Gift card',     Icon: Gift,           tone: 'rose',   atajo: '5' },
];

function POS({ libroInicial, onLibroInicialUsado, grupoInicial, onGrupoInicialUsado }) {
  const mob = useMobile();
  const [lotes, setLotes] = useState([]);
  const [carrito, setCarrito] = useState([]);
  const [editandoPrecioId, setEditandoPrecioId] = useState(null); // lote_id del ítem cuyo precio se está tocando
  const [metodoPago, setMetodoPago] = useState(null);
  const [metodoPago2, setMetodoPago2] = useState('');
  const [montoPago1, setMontoPago1] = useState('');
  const [montoPago2, setMontoPago2] = useState('');
  const [valorGift, setValorGift] = useState('');
  const [pagoMixto, setPagoMixto] = useState(false);
  const [busqueda, setBusqueda] = useState('');
  const [cargando, setCargando] = useState(false);
  const [mensaje, setMensaje] = useState('');
  const [descuentoTotal, setDescuentoTotal] = useState('');
  const [tipoDescuentoTotal, setTipoDescuentoTotal] = useState('pesos');
  const [ventasEspera, setVentasEspera] = useState(() => {
    try { return JSON.parse(localStorage.getItem('relea_ventas_espera') || '[]'); }
    catch { return []; }
  });
  const [alertaPedido,    setAlertaPedido]    = useState(null);
  const [ventaConfirmada, setVentaConfirmada] = useState(null);
  const [tcInput,         setTcInput]         = useState('');
  const [tcPanel,         setTcPanel]         = useState(null);
  const [tcCargando,      setTcCargando]      = useState(false);
  const [tcAplicados,     setTcAplicados]     = useState([]);
  const [tcHistorial,     setTcHistorial]     = useState(null); // { ventaId, tickets: null|[] }
  const [scannedFlash,    setScannedFlash]    = useState(false);
  const [grupoExpandido,  setGrupoExpandido]  = useState(null); // { iconKey, header, items }
  const [ultimasVentas,   setUltimasVentas]   = useState([]);
  const [ventaDetalle,    setVentaDetalle]    = useState(null); // id de la venta con detalle abierto
  const [editandoMetodo,  setEditandoMetodo]  = useState(false);
  const [nuevoMetodo1,    setNuevoMetodo1]    = useState('');
  const [nuevoMetodo2,    setNuevoMetodo2]    = useState('');
  const [confirmAnulacion, setConfirmAnulacion] = useState(null); // { id, mensaje } cuando backend pide confirmación
  const [accionando,      setAccionando]      = useState(false);
  const searchRef       = useRef(null);
  const lotesRef        = useRef([]);          // siempre apunta al array más reciente
  const ofertasRef      = useRef({});          // mapa libro_id → oferta vigente
  const grupoInicialRef = useRef(grupoInicial); // captura el valor antes del primer render

  async function cargarUltimasVentas() {
    try {
      const hoy = new Date().toLocaleString('sv', { timeZone: 'America/Santiago' }).slice(0, 10);
      const r = await api.get(`/reportes/ventas-dia?fecha=${hoy}`);
      const ventas = (r.data.ventas || [])
        .filter(v => !v.id.toString().startsWith('h-'))
        .reverse();
      setUltimasVentas(ventas);
    } catch {}
  }

  useEffect(() => { cargarLotes(); cargarUltimasVentas(); cargarOfertasActivas(); }, []);  // eslint-disable-line react-hooks/exhaustive-deps
  // Ofertas al día: un libro que llegó después de abrir el POS (p. ej. al recepcionar una GDD) toma su descuento
  // sin recargar la página. Es un refresco aparte y no dentro de agregarAlCarrito, para no demorar el escaneo.
  useEffect(() => {
    const t = setInterval(cargarOfertasActivas, 60000);
    return () => clearInterval(t);
  }, []);  // eslint-disable-line react-hooks/exhaustive-deps

  // Pre-cargar libro seleccionado desde Inicio
  useEffect(() => {
    if (libroInicial) {
      agregarAlCarrito(libroInicial);
      onLibroInicialUsado?.();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  async function cargarLotes() {
    try {
      const res = await api.get('/lotes');
      lotesRef.current = res.data;
      setLotes(res.data);
      // Auto-expandir grupo si viene desde Dashboard
      if (grupoInicialRef.current) {
        const { iconKey, header, tipo, valor } = grupoInicialRef.current;
        const q = valor.toLowerCase();
        const matched = res.data.filter(l => l[tipo]?.toLowerCase().includes(q));
        const con = matched.filter(l => (l.stock ?? 0) > 0);
        const sin = matched.filter(l => (l.stock ?? 0) <= 0);
        setGrupoExpandido({ iconKey, header, items: [...con, ...sin] });
        onGrupoInicialUsado?.();
        grupoInicialRef.current = null;
      }
    } catch (err) {
      setMensaje('No se pudo cargar el inventario — ' + (err.response?.status === 401 ? 'sesión expirada' : 'error de conexión'));
    }
  }

  async function cargarOfertasActivas() {
    try {
      const res = await api.get('/ofertas/activas');
      ofertasRef.current = res.data || {};
    } catch {}
  }

  // Expandir grupo desde el dropdown del POS (todos los lotes sin límite)
  function expandirGrupo(grupo, query) {
    const tipo = grupo.iconKey === 'user' ? 'autor' : 'editorial';
    const q = query.toLowerCase();
    const matched = lotes.filter(l => l[tipo]?.toLowerCase().includes(q));
    const con = matched.filter(l => (l.stock ?? 0) > 0);
    const sin = matched.filter(l => (l.stock ?? 0) <= 0);
    setGrupoExpandido({ iconKey: grupo.iconKey, header: grupo.header, items: [...con, ...sin] });
    setBusqueda('');
  }

  useEffect(() => {
    if (!/^\d{10,}$/.test(busqueda.trim())) return;
    const isbn = busqueda.trim();
    const t = setTimeout(() => {
      const lote = lotesRef.current.find(l => l.isbn === isbn); // ref siempre fresco
      if (lote) {
        agregarAlCarrito(lote);
        setBusqueda('');
      }
    }, 250);
    return () => clearTimeout(t);
  }, [busqueda]); // eslint-disable-line react-hooks/exhaustive-deps

  const busquedaTrim    = busqueda.trim();
  const isLikelyBarcode = /^\d{10,}$/.test(busquedaTrim);
  const busquedaGrupos  = !busquedaTrim || isLikelyBarcode
    ? { grupos: [], totalItems: 0 }
    : calcGruposBusqueda(lotes, busquedaTrim);

  async function agregarAlCarrito(lote) {
    // Si la pantalla todavía muestra la boleta de la venta anterior, escanear
    // o buscar un libro nuevo significa "empezar otra venta": vuelve al
    // carrito en vez de dejar la boleta vieja tapando lo que se está cobrando.
    if (ventaConfirmada) setVentaConfirmada(null);
    const existe = carrito.find(i => i.lote_id === lote.id);
    if (existe) {
      setCarrito(carrito.map(i => i.lote_id === lote.id ? { ...i, cantidad: i.cantidad + 1 } : i));
    } else {
      const oferta = ofertasRef.current[lote.libro_id];
      const descuento = oferta ? Math.round(Number(lote.pvp) * oferta.descuento_cliente_pct / 100) : 0;
      setCarrito([...carrito, {
        lote_id: lote.id,
        titulo: lote.titulo,
        precio_unitario: Number(lote.pvp),
        cantidad: 1,
        descuento,
        tipoDescuento: 'pesos',
        ...(oferta ? { oferta_id: oferta.oferta_id, oferta_nombre: oferta.nombre } : {}),
      }]);
    }
    setBusqueda('');
    try {
      const res = await api.get(`/pedidos-clientes/por-libro/${lote.libro_id}`);
      if (res.data.length > 0) setAlertaPedido({ pedido: res.data[0], lote });
    } catch {}
  }

  async function confirmarPedidoCliente() {
    try {
      await api.patch(`/pedidos-clientes/${alertaPedido.pedido.id}`, { estado: 'entregado' });
    } catch {}
    setAlertaPedido(null);
  }

  function guardarEnEspera() {
    if (carrito.length === 0) return;
    const nuevas = [...ventasEspera, {
      id: Date.now().toString(),
      guardada_en: new Date().toISOString(),
      carrito,
      descuentoTotal,
      tipoDescuentoTotal
    }];
    localStorage.setItem('relea_ventas_espera', JSON.stringify(nuevas));
    setVentasEspera(nuevas);
    setCarrito([]);
    setDescuentoTotal('');
    setTipoDescuentoTotal('pesos');
    setMensaje('Venta guardada en espera');
    setTimeout(() => setMensaje(''), 3000);
  }

  function recuperarEspera(venta) {
    if (carrito.length > 0 && !window.confirm('¿Reemplazar el carrito actual con esta venta en espera?')) return;
    setCarrito(venta.carrito);
    setDescuentoTotal(venta.descuentoTotal);
    setTipoDescuentoTotal(venta.tipoDescuentoTotal);
    const nuevas = ventasEspera.filter(v => v.id !== venta.id);
    localStorage.setItem('relea_ventas_espera', JSON.stringify(nuevas));
    setVentasEspera(nuevas);
  }

  function eliminarEspera(id) {
    const nuevas = ventasEspera.filter(v => v.id !== id);
    localStorage.setItem('relea_ventas_espera', JSON.stringify(nuevas));
    setVentasEspera(nuevas);
  }

  function quitarDelCarrito(lote_id) { setCarrito(carrito.filter(i => i.lote_id !== lote_id)); }
  function cambiarCantidad(lote_id, cantidad) {
    if (cantidad < 1) return;
    setCarrito(carrito.map(i => i.lote_id === lote_id ? { ...i, cantidad: Number(cantidad) } : i));
  }

  // Tocar el precio del ítem para fijarlo a mano — sube o baja según lo que se
  // escriba. Por debajo sigue siendo el mismo campo "descuento" de siempre
  // (negativo = recargo), así que el campo Desc. y el precio tocado quedan
  // siempre sincronizados sin lógica aparte.
  function confirmarPrecioManual(lote_id, valorTexto) {
    const item = carrito.find(i => i.lote_id === lote_id);
    if (!item) return;
    const nuevoPrecio = Math.max(0, Math.round(Number(valorTexto)));
    if (!Number.isFinite(nuevoPrecio)) return;
    const nuevoDescuento = item.precio_unitario - nuevoPrecio; // negativo = recargo
    setCarrito(carrito.map(i => i.lote_id === lote_id
      ? { ...i, descuento: nuevoDescuento, descuentoVisual: nuevoDescuento, tipoDescuento: 'pesos' }
      : i
    ));
  }

  // Reparte el descuento total entre las líneas de la venta, proporcional a lo
  // que aporta cada una, para que el precio guardado por libro (venta_detalle)
  // refleje lo que realmente se cobró — y no solo el total de la boleta.
  // Sin esto, el ticket de cambio y el reporte de libros más vendidos siguen
  // mostrando el precio de lista aunque se haya aplicado descuento total.
  // Reparto por "mayor resto": todos los pesos del descuento quedan asignados,
  // ninguno se pierde ni se duplica por redondeo.
  function repartirDescuentoTotal(items, descuentoMonto) {
    if (!descuentoMonto) return items.map(() => 0);
    const subtotales = items.map(i => (i.precio_unitario - (i.descuento || 0)) * i.cantidad);
    const sumaSubtotales = subtotales.reduce((s, x) => s + x, 0);
    if (sumaSubtotales <= 0) return items.map(() => 0);

    const crudos = subtotales.map(s => descuentoMonto * s / sumaSubtotales);
    const piso = crudos.map(Math.floor);
    const restante = descuentoMonto - piso.reduce((s, x) => s + x, 0);
    const ordenPorResto = crudos
      .map((c, idx) => ({ idx, resto: c - Math.floor(c) }))
      .sort((a, b) => b.resto - a.resto);
    const reparto = [...piso];
    for (let k = 0; k < restante; k++) reparto[ordenPorResto[k % ordenPorResto.length].idx] += 1;
    return reparto;
  }

  const subtotal   = carrito.filter(i => !i.devuelto).reduce((sum, i) => sum + (i.precio_unitario - (i.descuento || 0)) * i.cantidad, 0);
  const devCredito = carrito.filter(i => i.devuelto).reduce((sum, i) => sum + i.precio_unitario, 0);
  const descuentoTotalMonto = descuentoTotal
    ? tipoDescuentoTotal === 'pesos'
      ? Number(descuentoTotal)
      : Math.round(subtotal * Number(descuentoTotal) / 100)
    : 0;
  const total = Math.max(0, subtotal - descuentoTotalMonto);

  const tcCredito = tcAplicados.reduce((sum, tc) =>
    sum + tc.itemsSeleccionados.reduce((s, i) => s + i.precio_original, 0), 0);
  // Opción A: gift card logic — usa totalConCredito para gift card
  const totalConCredito = Math.max(0, total - devCredito - tcCredito);
  const esGift       = metodoPago === 'giftcard';
  const giftNum      = esGift ? Number(valorGift || 0) : 0;
  const giftCubre    = Math.min(giftNum, totalConCredito);
  const restanteGift = Math.max(0, totalConCredito - giftNum);
  const saldoGift    = Math.max(0, giftNum - totalConCredito);

  const soloDevueltos = carrito.length > 0 && carrito.every(i => i.devuelto);
  // Opción A: botón bloqueado hasta elegir método (si totalConCredito cubre todo o todo es devolución, no se necesita método)
  const puedeCobrar = carrito.length === 0 ? false
    : soloDevueltos          ? true
    : totalConCredito === 0  ? true
    : !metodoPago            ? false
    : esGift                 ? (giftNum > 0 && (restanteGift === 0 || !!metodoPago2))
    : pagoMixto              ? (!!metodoPago && !!metodoPago2)
    : true;

  // Atajos 1–5 para método de pago (no roba foco si el cursor está en un input)
  useEffect(() => {
    const onKey = (e) => {
      if (e.target && (e.target.tagName === 'INPUT' || e.target.isContentEditable)) return;
      const idx = ['1','2','3','4','5'].indexOf(e.key);
      if (idx >= 0) setMetodoPago(POS_METODOS_A[idx].key);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  async function buscarTC() {
    if (!tcInput.trim()) return;
    setTcCargando(true);
    try {
      const r = await api.get(`/tickets-cambio/${tcInput.trim().toUpperCase()}`);
      const ticket = r.data;
      const itemsDisponibles = ticket.items.filter(i => !i.canjeado);
      setTcPanel({
        ...ticket,
        itemsPanel: itemsDisponibles.map(i => ({ ...i, selected: ticket.tipo === 'individual' })),
      });
    } catch (err) {
      setMensaje(err.response?.data?.error || 'Ticket no encontrado o ya canjeado');
    }
    setTcCargando(false);
  }

  function aplicarTC() {
    if (!tcPanel) return;
    const selected = tcPanel.itemsPanel.filter(i => i.selected);
    if (selected.length === 0) return;
    setTcAplicados(prev => [...prev, {
      codigo: tcPanel.codigo,
      tipo: tcPanel.tipo,
      ticket_id: tcPanel.id,
      itemsSeleccionados: selected,
    }]);
    setTcPanel(null);
    setTcInput('');
  }

  async function registrarVenta() {
  if (carrito.length === 0 || !puedeCobrar) return;
  setCargando(true);
  try {
    // gift card parcial: monto1=monto cubierto por giftcard, monto2=restante en otro método
    const monto1 = pagoMixto ? Number(montoPago1) : (esGift ? giftCubre : totalConCredito);
    const monto2 = pagoMixto ? Number(montoPago2) : (esGift && restanteGift > 0 ? restanteGift : null);
    if (pagoMixto && monto1 + monto2 < totalConCredito) {
      setMensaje('Los montos no suman el total de la venta');
      setCargando(false);
      return;
    }
    const itemsDevueltos = carrito.filter(i => i.devuelto);
    const itemsVenta     = carrito.filter(i => !i.devuelto);

    // Primero registrar las devoluciones
    await Promise.all(itemsDevueltos.map(i =>
      api.post('/ventas/devolucion-cliente', {
        lote_id: i.lote_id,
        cantidad: i.cantidad,
        precio_unitario: i.precio_unitario,
        motivo: 'Devolución con cambio POS'
      })
    ));

    // Luego registrar la venta (solo ítems no devueltos)
    let ventaId    = null;
    let ventaItems = [];
    if (itemsVenta.length > 0) {
      const prorrateoDescuentoTotal = repartirDescuentoTotal(itemsVenta, descuentoTotalMonto);
      const r = await api.post('/ventas', {
        items: itemsVenta.map((i, idx) => ({
          ...i,
          precio_efectivo: Math.round((i.precio_unitario - (i.descuento || 0)) * i.cantidad - prorrateoDescuentoTotal[idx]),
          oferta_id: i.oferta_id || null,
        })),
        total: totalConCredito,
        descuento_total: descuentoTotalMonto + devCredito + tcCredito,
        metodo_pago: metodoPago,
        metodo_pago_2: pagoMixto ? metodoPago2 : (esGift && restanteGift > 0 ? metodoPago2 : null),
        monto_pago_1: monto1,
        monto_pago_2: monto2,
        con_devolucion: itemsDevueltos.length > 0,
      });
      ventaId    = r.data.venta_id;
      ventaItems = r.data.items || [];
    }

    // Marcar TCs aplicados como canjeados
    if (tcAplicados.length > 0 && ventaId) {
      await Promise.all(tcAplicados.map(tc =>
        api.post(`/tickets-cambio/${tc.codigo}/canjear`, {
          item_ids: tc.itemsSeleccionados.map(i => i.id),
          venta_id: ventaId,
        }).catch(e => console.warn('[TC canjeo]', e.message))
      ));
    }

    setVentaConfirmada({
      fecha: new Date(),
      carrito:             [...carrito],
      subtotal,
      descuentoTotalMonto,
      descuentoTotal,
      tipoDescuentoTotal,
      total: totalConCredito,
      pagoMixto,
      metodoPago,
      metodoPago2:  pagoMixto ? metodoPago2 : null,
      montoPago1:   monto1,
      montoPago2:   pagoMixto ? monto2 : null,
      ventaId,
      ventaItems,
      tcCredito,
    });

    setCarrito([]);
    setMensaje('');
    setPagoMixto(false);
    setMontoPago1('');
    setMontoPago2('');
    setMetodoPago(null);
    setMetodoPago2('');
    setValorGift('');
    setDescuentoTotal('');
    setTcAplicados([]);
    setTcPanel(null);
    setTcInput('');
    await cargarLotes();
    cargarUltimasVentas();
  } catch (error) {
    setMensaje('Error al registrar la venta');
  }
  setCargando(false);
}

  async function guardarMetodoPago(ventaId) {
    if (!nuevoMetodo1) return;
    setAccionando(true);
    try {
      await api.patch(`/ventas/${ventaId}/metodo-pago`, { metodo_pago: nuevoMetodo1, metodo_pago_2: nuevoMetodo2 || null });
      await cargarUltimasVentas();
      setEditandoMetodo(false);
      setVentaDetalle(null);
      setNuevoMetodo1('');
      setNuevoMetodo2('');
    } catch { setMensaje('Error al actualizar el método de pago'); }
    setAccionando(false);
  }

  async function anularVenta(ventaId, forzar = false) {
    setAccionando(true);
    try {
      const r = await api.patch(`/ventas/${ventaId}/anular`, { forzar });
      if (r.data?.requiere_confirmacion) {
        setConfirmAnulacion({ id: ventaId, mensaje: r.data.mensaje });
        setAccionando(false);
        return;
      }
      setConfirmAnulacion(null);
      setVentaDetalle(null);
      if (r.data?.tickets_revertidos > 0) {
        setMensaje(`Venta anulada. Se devolvió el crédito de ${r.data.tickets_revertidos} ticket${r.data.tickets_revertidos !== 1 ? 's' : ''} de cambio.`);
      }
      await cargarUltimasVentas();
      await cargarLotes();
    } catch (err) { setMensaje(err.response?.data?.error || 'Error al anular la venta'); }
    setAccionando(false);
  }

  function toggleDevueltoEnCarrito(lote_id) {
    setCarrito(carrito.map(i => i.lote_id === lote_id ? { ...i, devuelto: !i.devuelto } : i));
  }

  return (
    <div style={{ background: 'var(--canvas)', minHeight: '100%', padding: 'var(--content-inset)' }}>
      <div>
      {/* ── Page head ─────────────────────────────────── */}
      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 16, marginBottom: '1.5rem', flexWrap: 'wrap' }}>
        <div>
          <h2 style={{ margin: 0, fontFamily: 'var(--font-display)', fontSize: 28, fontWeight: 700, letterSpacing: 'var(--tracking-tight)', color: 'var(--ink-900)' }}>
            Registrar venta
          </h2>
          <span style={{ fontFamily: 'var(--font-ui)', fontSize: 14, color: 'var(--ink-500)', marginTop: 4, display: 'block' }}>
            {new Date().toLocaleTimeString('es-CL', { hour: '2-digit', minute: '2-digit' })} · POS terminal
          </span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
          {ventasEspera.length > 0 && (
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5, padding: '6px 13px', background: 'var(--warn-bg)', color: 'var(--warn-ink)', borderRadius: 'var(--r-pill)', fontSize: 12, fontWeight: 600, fontFamily: 'var(--font-ui)' }}>
              <Pause size={11} strokeWidth={2} /> {ventasEspera.length} en espera
            </span>
          )}
        </div>
      </div>

      {/* ── Toast ─────────────────────────────────────── */}
      {mensaje && (
        <div style={{ background: 'var(--ok-bg)', color: 'var(--ok-ink)', border: '1px solid var(--line)', borderRadius: 12, padding: '10px 16px', marginBottom: '1rem', fontSize: 14, fontFamily: 'var(--font-ui)' }}>
          {mensaje}
        </div>
      )}

      {/* ── Alerta: libro reservado ────────────────────── */}
      {alertaPedido && (
        <div style={{ background: 'var(--warn-bg)', border: '1px solid var(--line)', borderRadius: 14, padding: '12px 16px', marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
          <ClipboardList size={16} strokeWidth={1.75} style={{ color: 'var(--warn-ink)', flexShrink: 0 }} />
          <span style={{ flex: 1, fontSize: 14, color: 'var(--ink-700)', fontFamily: 'var(--font-ui)' }}>
            <strong>{alertaPedido.lote.titulo}</strong> está reservado para <strong>{alertaPedido.pedido.cliente_nombre}</strong>. ¿Esta venta es para él?
          </span>
          <button onClick={confirmarPedidoCliente}
            style={{ padding: '6px 14px', background: 'var(--ink-900)', color: '#fff', border: 'none', cursor: 'pointer', borderRadius: 'var(--r-pill)', fontSize: 12, fontWeight: 600, fontFamily: 'var(--font-ui)' }}>
            Confirmar
          </button>
          <button onClick={() => setAlertaPedido(null)}
            style={{ padding: '6px 14px', background: 'transparent', border: '1px solid var(--line)', cursor: 'pointer', borderRadius: 'var(--r-pill)', fontSize: 12, color: 'var(--ink-600)', fontFamily: 'var(--font-ui)' }}>
            No
          </button>
        </div>
      )}

      {/* ── Grid principal ─────────────────────────────── */}
      <div style={{ display: 'grid', gridTemplateColumns: mob ? '1fr' : '1fr 0.9fr', gap: 20, alignItems: 'start' }}>

        {/* ── Izquierda: búsqueda + en espera ─── */}
        <div style={{ border: '1px solid var(--line)', borderRadius: 'var(--r-3xl)', background: 'var(--paper)', overflow: 'hidden', boxShadow: 'var(--shadow-card)', padding: '20px 24px' }}>
          {/* Barra de búsqueda pill */}
          <div style={{ position: 'relative', marginBottom: (busquedaGrupos.totalItems > 0 || busqueda || grupoExpandido) ? 0 : 14 }}>
            <span style={{ position: 'absolute', left: 14, top: '50%', transform: 'translateY(-50%)', color: 'var(--ink-400)', display: 'flex', pointerEvents: 'none' }}>
              <Search size={16} strokeWidth={1.75} />
            </span>
            <input
              id="pos-busqueda"
              autoFocus
              value={busqueda}
              onChange={e => { setBusqueda(e.target.value); if (grupoExpandido) setGrupoExpandido(null); }}
              placeholder="Título o ISBN — escanea o escribe..."
              style={{
                width: '100%', boxSizing: 'border-box',
                padding: '11px 48px 11px 42px',
                border: '1px solid var(--line)', borderRadius: 'var(--r-pill)',
                background: 'var(--paper)', color: 'var(--ink-900)',
                fontFamily: 'var(--font-ui)', fontSize: 14, outline: 'none',
                transition: `border-color var(--t-fast)`,
              }}
              onFocus={e => e.target.style.borderColor = 'var(--ink-400)'}
              onBlur={e => e.target.style.borderColor = 'var(--line)'}
            />
            <span style={{ position: 'absolute', right: 14, top: '50%', transform: 'translateY(-50%)', fontSize: 11, color: 'var(--ink-400)', fontFamily: 'var(--font-mono)', pointerEvents: 'none' }}>
              {scannedFlash ? '✓' : 'F1'}
            </span>
          </div>

          {/* ── B3Strip: chip strip de últimas ventas del día ─── */}
          {!busqueda && !grupoExpandido && ultimasVentas.length > 0 && (() => {
            const validas = ultimasVentas.filter(v => v.estado !== 'anulada');
            const totalDia = validas.reduce((s, v) => {
              if (v.metodo_pago === 'giftcard') {
                // solo contar la parte pagada en otro método (monto_pago_2), no la giftcard
                return s + (v.metodo_pago_2 ? Number(v.monto_pago_2 || 0) : 0);
              }
              return s + Number(v.total);
            }, 0);
            const MCFG = { efectivo:{ tone:'mint' }, debito:{ tone:'blue' }, credito:{ tone:'violet' }, transferencia:{ tone:'peach' }, giftcard:{ tone:'rose' } };
            const ordenadas = [...ultimasVentas].reverse();
            const detalleV = ventaDetalle ? ultimasVentas.find(v => v.id === ventaDetalle) : null;
            return (
              <div style={{ marginTop: 10 }}>
                <div style={{ display: 'flex', gap: 7, alignItems: 'stretch', overflowX: 'auto', paddingBottom: 2, scrollbarWidth: 'none' }}>
                  <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: 1, padding: '8px 12px', borderRadius: 13, background: 'var(--ink-900)', color: '#fff', flexShrink: 0 }}>
                    <span style={{ fontSize: 10, opacity: .55, whiteSpace: 'nowrap', fontFamily: 'var(--font-ui)' }}>Hoy</span>
                    <span style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 15, letterSpacing: '-0.01em', whiteSpace: 'nowrap' }}>{validas.length} ventas</span>
                    <span style={{ fontSize: 10, opacity: .55, fontFamily: 'var(--font-mono)', whiteSpace: 'nowrap' }}>${totalDia.toLocaleString('es-CL')}</span>
                  </div>
                  {ordenadas.map(v => {
                    const anulada = v.estado === 'anulada';
                    const abierto = ventaDetalle === v.id;
                    const c1 = MCFG[v.metodo_pago] || { tone: 'sand' };
                    const c2 = v.metodo_pago_2 ? (MCFG[v.metodo_pago_2] || { tone: 'sand' }) : null;
                    const titulos = (v.items || []).map(i => i.titulo + (i.cantidad > 1 ? ` ×${i.cantidad}` : '')).join(', ');
                    return (
                      <button key={v.id} onClick={() => setVentaDetalle(abierto ? null : v.id)}
                        style={{ display: 'flex', flexDirection: 'column', gap: 3, padding: '8px 12px', borderRadius: 13, flexShrink: 0, background: abierto ? 'var(--ink-900)' : anulada ? 'var(--paper-soft)' : 'var(--paper)', border: `1.5px solid ${abierto ? 'var(--ink-900)' : anulada ? 'var(--line-soft)' : 'var(--line)'}`, minWidth: 130, maxWidth: 180, opacity: anulada ? 0.6 : 1, cursor: 'pointer', textAlign: 'left', transition: 'background var(--t-fast), border-color var(--t-fast)' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 8 }}>
                          <span style={{ fontSize: 10.5, color: abierto ? 'rgba(255,255,255,0.55)' : 'var(--ink-400)', fontFamily: 'var(--font-mono)', whiteSpace: 'nowrap' }}>
                            {new Date(v.fecha).toLocaleTimeString('es-CL', { hour: '2-digit', minute: '2-digit' })}
                          </span>
                          <span style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 14, letterSpacing: '-0.01em', whiteSpace: 'nowrap', color: abierto ? '#fff' : 'var(--ink-900)', textDecoration: anulada ? 'line-through' : 'none' }}>${Number(v.total).toLocaleString('es-CL')}</span>
                        </div>
                        <div style={{ fontSize: 11, color: abierto ? 'rgba(255,255,255,0.7)' : 'var(--ink-500)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', textDecoration: anulada ? 'line-through' : 'none' }}>{titulos}</div>
                        <div style={{ marginTop: 2, display: 'flex', gap: 4, flexWrap: 'wrap' }}>
                          {anulada
                            ? <span style={{ fontSize: 10, background: 'var(--bad-bg)', color: 'var(--bad-ink)', padding: '2px 7px', borderRadius: 999, fontWeight: 600, fontFamily: 'var(--font-ui)' }}>anulada</span>
                            : <><span style={{ display: 'inline-flex', alignItems: 'center', padding: '2px 8px', borderRadius: 999, fontSize: 10.5, fontWeight: 600, background: abierto ? 'rgba(255,255,255,0.15)' : `var(--past-${c1.tone})`, color: abierto ? '#fff' : `var(--past-${c1.tone}-ink)`, whiteSpace: 'nowrap', fontFamily: 'var(--font-ui)' }}>{v.metodo_pago}</span>
                              {c2 && <span style={{ display: 'inline-flex', alignItems: 'center', padding: '2px 8px', borderRadius: 999, fontSize: 10.5, fontWeight: 600, background: abierto ? 'rgba(255,255,255,0.15)' : `var(--past-${c2.tone})`, color: abierto ? '#fff' : `var(--past-${c2.tone}-ink)`, whiteSpace: 'nowrap', fontFamily: 'var(--font-ui)' }}>{v.metodo_pago_2}</span>}
                              {v.con_devolucion && <span style={{ display: 'inline-flex', alignItems: 'center', padding: '2px 7px', borderRadius: 999, fontSize: 10, fontWeight: 600, background: 'var(--ok-bg)', color: 'var(--ok-ink)', whiteSpace: 'nowrap', fontFamily: 'var(--font-ui)' }}>↩ dev.</span>}
                            </>
                          }
                        </div>
                      </button>
                    );
                  })}
                </div>

                {/* Panel de detalle de venta */}
                {detalleV && (() => {
                  const anulada = detalleV.estado === 'anulada';
                  const MCFG2 = { efectivo:{ tone:'mint' }, debito:{ tone:'blue' }, credito:{ tone:'violet' }, transferencia:{ tone:'peach' }, giftcard:{ tone:'rose' } };
                  const c1 = MCFG2[detalleV.metodo_pago] || { tone:'sand' };
                  const c2 = detalleV.metodo_pago_2 ? (MCFG2[detalleV.metodo_pago_2] || { tone:'sand' }) : null;
                  return (
                    <div style={{ marginTop: 8, border: '1px solid var(--line)', borderRadius: 14, background: 'var(--paper)', overflow: 'hidden' }}>
                      {/* Cabecera */}
                      <div style={{ padding: '10px 14px', background: 'var(--paper-stripe)', borderBottom: '1px solid var(--line-soft)', display: 'flex', alignItems: 'center', gap: 8 }}>
                        <span style={{ fontSize: 12, fontWeight: 600, color: 'var(--ink-700)', fontFamily: 'var(--font-ui)', flex: 1 }}>
                          Venta · {new Date(detalleV.fecha).toLocaleTimeString('es-CL', { hour: '2-digit', minute: '2-digit' })}
                          {anulada && <span style={{ marginLeft: 8, fontSize: 10, background: 'var(--bad-bg)', color: 'var(--bad-ink)', padding: '2px 7px', borderRadius: 999, fontWeight: 600 }}>anulada</span>}
                        </span>
                        <button onClick={() => { setVentaDetalle(null); setEditandoMetodo(false); setConfirmAnulacion(null); }} style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--ink-400)', display: 'inline-flex', padding: 2 }}>
                          <X size={14} strokeWidth={1.75} />
                        </button>
                      </div>

                      {/* Ítems */}
                      {(detalleV.items || []).map((item, i) => (
                        <div key={i} style={{ padding: '8px 14px', borderBottom: i < detalleV.items.length - 1 ? '1px solid var(--line-soft)' : 'none', display: 'flex', alignItems: 'center', gap: 10 }}>
                          <span style={{ width: 28, height: 28, borderRadius: '50%', flexShrink: 0, background: 'var(--past-peach)', color: 'var(--past-peach-ink)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                            <BookOpen size={12} strokeWidth={1.75} />
                          </span>
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--ink-900)', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>{item.titulo}</div>
                            {item.autor && <div style={{ fontSize: 11, color: 'var(--ink-500)', fontFamily: 'var(--font-ui)' }}>{item.autor}</div>}
                          </div>
                          <div style={{ textAlign: 'right', flexShrink: 0 }}>
                            {item.cantidad > 1 && <div style={{ fontSize: 10, color: 'var(--ink-400)', fontFamily: 'var(--font-ui)' }}>×{item.cantidad}</div>}
                            <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--ink-900)', fontFamily: 'var(--font-display)', letterSpacing: '-0.01em' }}>${Number(item.precio_unitario || 0).toLocaleString('es-CL')}</div>
                          </div>
                        </div>
                      ))}

                      {/* Descuento global (si suma de subtotales > total) */}
                      {(() => {
                        const sumaItems = (detalleV.items || []).reduce((s, it) => s + Number(it.subtotal || 0), 0);
                        const dcto = sumaItems - Number(detalleV.total);
                        if (dcto <= 0) return null;
                        return (
                          <div style={{ padding: '6px 14px', borderTop: '1px solid var(--line-soft)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <span style={{ fontSize: 12, color: 'var(--bad-ink)', fontFamily: 'var(--font-ui)' }}>Descuento</span>
                            <span style={{ fontSize: 12, fontWeight: 600, color: 'var(--bad-ink)', fontFamily: 'var(--font-display)' }}>−${dcto.toLocaleString('es-CL')}</span>
                          </div>
                        );
                      })()}

                      {/* Footer: método + total + acciones */}
                      <div style={{ padding: '10px 14px', borderTop: '1px solid var(--line-soft)' }}>
                        {/* Modo vista: método actual + botones */}
                        {!editandoMetodo && !confirmAnulacion && (
                          <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
                            <span style={{ padding: '2px 9px', borderRadius: 999, fontSize: 11, fontWeight: 600, background: `var(--past-${c1.tone})`, color: `var(--past-${c1.tone}-ink)`, fontFamily: 'var(--font-ui)' }}>{detalleV.metodo_pago}</span>
                            {c2 && <span style={{ padding: '2px 9px', borderRadius: 999, fontSize: 11, fontWeight: 600, background: `var(--past-${c2.tone})`, color: `var(--past-${c2.tone}-ink)`, fontFamily: 'var(--font-ui)' }}>{detalleV.metodo_pago_2}</span>}
                            {!anulada && (<>
                              <button onClick={() => { setNuevoMetodo1(detalleV.metodo_pago); setNuevoMetodo2(detalleV.metodo_pago_2 || ''); setEditandoMetodo(true); }}
                                style={{ display: 'inline-flex', alignItems: 'center', gap: 4, padding: '4px 10px', background: 'transparent', border: '1px solid var(--line)', borderRadius: 'var(--r-pill)', cursor: 'pointer', fontSize: 11, color: 'var(--ink-600)', fontFamily: 'var(--font-ui)' }}>
                                <Pencil size={11} strokeWidth={1.75} /> Editar pago
                              </button>
                              <button onClick={() => setConfirmAnulacion({ id: detalleV.id, mensaje: null })}
                                style={{ display: 'inline-flex', alignItems: 'center', gap: 4, padding: '4px 10px', background: 'transparent', border: '1px solid var(--bad-line)', borderRadius: 'var(--r-pill)', cursor: 'pointer', fontSize: 11, color: 'var(--bad-ink)', fontFamily: 'var(--font-ui)' }}>
                                <X size={11} strokeWidth={2} /> Anular
                              </button>
                              <button onClick={async () => {
                                  if (tcHistorial?.ventaId === detalleV.id) { setTcHistorial(null); return; }
                                  setTcHistorial({ ventaId: detalleV.id, tickets: null });
                                  try {
                                    const r = await api.get(`/tickets-cambio?venta_id=${detalleV.id}`);
                                    setTcHistorial({ ventaId: detalleV.id, tickets: r.data });
                                  } catch { setTcHistorial({ ventaId: detalleV.id, tickets: [] }); }
                                }}
                                style={{ display: 'inline-flex', alignItems: 'center', gap: 4, padding: '4px 10px', background: tcHistorial?.ventaId === detalleV.id ? '#F5F3FF' : 'transparent', border: `1px solid ${tcHistorial?.ventaId === detalleV.id ? 'rgba(109,40,217,0.4)' : 'rgba(109,40,217,0.3)'}`, borderRadius: 'var(--r-pill)', cursor: 'pointer', fontSize: 11, color: '#7C3AED', fontFamily: 'var(--font-ui)' }}>
                                <Tag size={11} strokeWidth={1.75} /> Imprimir TC
                              </button>
                            </>)}
                            <span style={{ marginLeft: 'auto', fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 18, letterSpacing: '-0.02em', color: 'var(--ink-900)' }}>${Number(detalleV.total).toLocaleString('es-CL')}</span>
                          </div>
                        )}

                        {/* Modo edición de método */}
                        {editandoMetodo && (
                          <div>
                            <div style={{ fontSize: 11, fontWeight: 600, color: 'var(--ink-700)', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 8, fontFamily: 'var(--font-ui)' }}>Cambiar método de pago</div>
                            <div style={{ display: 'flex', gap: 5, flexWrap: 'wrap', marginBottom: 8 }}>
                              {POS_METODOS_A.map(m => {
                                const on = nuevoMetodo1 === m.key;
                                return (
                                  <button key={m.key} onClick={() => setNuevoMetodo1(m.key)}
                                    style={{ display: 'inline-flex', alignItems: 'center', gap: 5, padding: '5px 10px', borderRadius: 'var(--r-pill)', fontSize: 12, border: `1.5px solid ${on ? 'var(--ink-900)' : 'var(--line)'}`, background: on ? 'var(--ink-900)' : 'var(--paper)', color: on ? '#fff' : 'var(--ink-700)', cursor: 'pointer', fontFamily: 'var(--font-ui)', fontWeight: on ? 600 : 400 }}>
                                    <m.Icon size={11} strokeWidth={1.75} /> {m.label}
                                  </button>
                                );
                              })}
                            </div>
                            <div style={{ fontSize: 11, fontWeight: 600, color: 'var(--ink-500)', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 6, fontFamily: 'var(--font-ui)' }}>2º método (opcional)</div>
                            <div style={{ display: 'flex', gap: 5, flexWrap: 'wrap', marginBottom: 10 }}>
                              <button onClick={() => setNuevoMetodo2('')}
                                style={{ padding: '4px 10px', borderRadius: 'var(--r-pill)', fontSize: 11, border: `1.5px solid ${!nuevoMetodo2 ? 'var(--ink-900)' : 'var(--line)'}`, background: !nuevoMetodo2 ? 'var(--ink-900)' : 'var(--paper)', color: !nuevoMetodo2 ? '#fff' : 'var(--ink-600)', cursor: 'pointer', fontFamily: 'var(--font-ui)' }}>
                                Ninguno
                              </button>
                              {POS_METODOS_A.filter(m => m.key !== nuevoMetodo1).map(m => {
                                const on = nuevoMetodo2 === m.key;
                                return (
                                  <button key={m.key} onClick={() => setNuevoMetodo2(m.key)}
                                    style={{ display: 'inline-flex', alignItems: 'center', gap: 4, padding: '4px 10px', borderRadius: 'var(--r-pill)', fontSize: 11, border: `1.5px solid ${on ? 'var(--ink-900)' : 'var(--line)'}`, background: on ? 'var(--ink-900)' : 'var(--paper)', color: on ? '#fff' : 'var(--ink-600)', cursor: 'pointer', fontFamily: 'var(--font-ui)' }}>
                                    <m.Icon size={10} strokeWidth={1.75} /> {m.label}
                                  </button>
                                );
                              })}
                            </div>
                            <div style={{ display: 'flex', gap: 6 }}>
                              <button onClick={() => guardarMetodoPago(detalleV.id)} disabled={!nuevoMetodo1 || accionando}
                                style={{ flex: 1, padding: '7px', background: 'var(--ink-900)', color: '#fff', border: 'none', borderRadius: 'var(--r-pill)', cursor: 'pointer', fontSize: 12, fontWeight: 600, fontFamily: 'var(--font-ui)', opacity: accionando ? 0.6 : 1 }}>
                                {accionando ? 'Guardando…' : 'Guardar'}
                              </button>
                              <button onClick={() => setEditandoMetodo(false)}
                                style={{ padding: '7px 14px', background: 'transparent', border: '1px solid var(--line)', borderRadius: 'var(--r-pill)', cursor: 'pointer', fontSize: 12, color: 'var(--ink-600)', fontFamily: 'var(--font-ui)' }}>
                                Cancelar
                              </button>
                            </div>
                          </div>
                        )}

                        {/* Confirmación de anulación */}
                        {confirmAnulacion && (
                          <div style={{ background: 'var(--bad-bg)', border: '1px solid var(--bad-line)', borderRadius: 10, padding: '10px 12px' }}>
                            <p style={{ margin: '0 0 10px', fontSize: 12, color: 'var(--bad-ink)', fontFamily: 'var(--font-ui)', lineHeight: 1.5 }}>
                              {confirmAnulacion.mensaje || '¿Confirmar anulación? El stock de los libros se devolverá al inventario.'}
                            </p>
                            <div style={{ display: 'flex', gap: 6 }}>
                              <button onClick={() => anularVenta(confirmAnulacion.id, true)} disabled={accionando}
                                style={{ flex: 1, padding: '7px', background: 'var(--bad-ink)', color: '#fff', border: 'none', borderRadius: 'var(--r-pill)', cursor: 'pointer', fontSize: 12, fontWeight: 600, fontFamily: 'var(--font-ui)', opacity: accionando ? 0.6 : 1 }}>
                                {accionando ? 'Anulando…' : 'Sí, anular'}
                              </button>
                              <button onClick={() => setConfirmAnulacion(null)}
                                style={{ padding: '7px 14px', background: 'transparent', border: '1px solid var(--bad-line)', borderRadius: 'var(--r-pill)', cursor: 'pointer', fontSize: 12, color: 'var(--bad-ink)', fontFamily: 'var(--font-ui)' }}>
                                Cancelar
                              </button>
                            </div>
                          </div>
                        )}
                      </div>

                      {/* Panel tickets de cambio de la venta */}
                      {tcHistorial?.ventaId === detalleV.id && (
                        <div style={{ borderTop: '1px solid rgba(109,40,217,0.12)', padding: '10px 14px', background: '#FAFAFA' }}>
                          {!tcHistorial.tickets ? (
                            <div style={{ fontSize: 12, color: '#A78BFA', fontFamily: 'var(--font-ui)' }}>Buscando tickets…</div>
                          ) : tcHistorial.tickets.length === 0 ? (
                            <div style={{ fontSize: 12, color: 'var(--ink-400)', fontFamily: 'var(--font-ui)' }}>Esta venta no tiene tickets de cambio generados.</div>
                          ) : (
                            <div>
                              <div style={{ fontSize: 10, fontWeight: 600, color: '#A78BFA', textTransform: 'uppercase', letterSpacing: '0.07em', marginBottom: 8, fontFamily: 'var(--font-ui)' }}>Tickets de cambio</div>
                              {tcHistorial.tickets.map(tc => {
                                const esTotal = tc.tipo === 'total';
                                const titulo  = esTotal ? null : tc.items?.[0]?.titulo_snapshot;
                                const nLibros = tc.items?.length || 0;
                                return (
                                  <div key={tc.id} style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6 }}>
                                    <div style={{ flex: 1, minWidth: 0 }}>
                                      <div style={{ fontFamily: 'var(--font-mono)', fontSize: 13, fontWeight: 700, color: '#7C3AED', letterSpacing: '0.08em' }}>{tc.codigo}</div>
                                      <div style={{ fontSize: 11, color: 'var(--ink-500)', fontFamily: 'var(--font-ui)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                        {esTotal ? `Compra completa · ${nLibros} libro${nLibros !== 1 ? 's' : ''}` : titulo}
                                      </div>
                                    </div>
                                    <button onClick={() => imprimirTicketCambio(tc.codigo, titulo, nLibros)}
                                      style={{ display: 'inline-flex', alignItems: 'center', gap: 4, padding: '5px 11px', background: '#7C3AED', color: '#fff', border: 'none', borderRadius: 'var(--r-pill)', fontSize: 11, fontWeight: 600, cursor: 'pointer', fontFamily: 'var(--font-ui)', whiteSpace: 'nowrap', flexShrink: 0 }}>
                                      <Printer size={11} strokeWidth={2} /> Imprimir
                                    </button>
                                  </div>
                                );
                              })}
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  );
                })()}
              </div>
            );
          })()}

          {/* ── Lista expandida de grupo (autor / editorial) ─── */}
          {grupoExpandido ? (
            <div style={{ marginTop: 8 }}>
              {/* Cabecera con botón volver */}
              <div style={{ display: 'flex', alignItems: 'center', padding: '10px 16px', background: 'var(--paper-stripe)', border: '1px solid var(--line)', borderRadius: '12px 12px 0 0', borderBottom: '1px solid var(--line-soft)' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6, flex: 1, fontSize: 12, fontWeight: 600, color: 'var(--ink-700)', fontFamily: 'var(--font-ui)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                  {grupoExpandido.iconKey === 'user' ? <User size={13} strokeWidth={1.75} /> : <Building2 size={13} strokeWidth={1.75} />}
                  {grupoExpandido.header}
                  <span style={{ fontWeight: 400, color: 'var(--ink-400)', textTransform: 'none', letterSpacing: 0, fontSize: 11 }}>— {grupoExpandido.items.length} {grupoExpandido.items.length === 1 ? 'título' : 'títulos'}</span>
                </div>
                <button onClick={() => setGrupoExpandido(null)}
                  style={{ display: 'inline-flex', alignItems: 'center', gap: 4, padding: '4px 10px', background: 'transparent', border: '1px solid var(--line)', borderRadius: 'var(--r-pill)', cursor: 'pointer', fontSize: 12, color: 'var(--ink-500)', fontFamily: 'var(--font-ui)', transition: `border-color var(--t-fast)` }}
                  onMouseEnter={e => e.currentTarget.style.borderColor = 'var(--ink-400)'}
                  onMouseLeave={e => e.currentTarget.style.borderColor = 'var(--line)'}
                >
                  <X size={11} strokeWidth={2} /> Volver
                </button>
              </div>
              {/* Items */}
              <div style={{ border: '1px solid var(--line)', borderTop: 'none', borderRadius: '0 0 12px 12px', maxHeight: 480, overflowY: 'auto', overflowX: 'hidden' }}>
                {grupoExpandido.items.map((l, i) => {
                  const sinStock    = (l.stock ?? 0) <= 0;
                  const tone        = TONE_STYLES[POS_TONES[i % POS_TONES.length]] || TONE_STYLES['peach'];
                  const circuloBg   = sinStock ? 'var(--bad-bg)'  : tone.bg;
                  const circuloInk  = sinStock ? 'var(--bad-ink)' : tone.ink;
                  const tituloColor = sinStock ? 'var(--ink-400)' : 'var(--ink-900)';
                  const precioColor = sinStock ? 'var(--ink-400)' : 'var(--ink-900)';
                  return (
                    <div key={l.id} onClick={() => agregarAlCarrito(l)}
                      style={{ padding: '12px 16px', borderBottom: i < grupoExpandido.items.length - 1 ? '1px solid var(--line-soft)' : 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 12, transition: `background var(--t-fast)` }}
                      onMouseEnter={e => e.currentTarget.style.background = 'var(--brand-softer)'}
                      onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                    >
                      <span style={{ width: 40, height: 40, borderRadius: '50%', flexShrink: 0, background: circuloBg, color: circuloInk, display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                        {sinStock ? <BookX size={17} strokeWidth={1.75} />
                         : grupoExpandido.iconKey === 'user'     ? <User      size={17} strokeWidth={1.75} />
                         : grupoExpandido.iconKey === 'building' ? <Building2 size={17} strokeWidth={1.75} />
                         : <BookOpen size={17} strokeWidth={1.75} />}
                      </span>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ fontSize: 14, fontWeight: 600, color: tituloColor, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{l.titulo}</div>
                        {(l.isbn || l.autor || l.editorial) && (
                          <div style={{ fontSize: 11, color: 'var(--ink-400)', marginTop: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontFamily: 'var(--font-ui)' }}>
                            {[l.isbn, l.autor, l.editorial].filter(Boolean).join(' · ')}
                          </div>
                        )}
                        <div style={{ fontSize: 12, color: 'var(--ink-400)', marginTop: 2, display: 'flex', alignItems: 'center', gap: 6 }}>
                          <span>{l.distribuidor}</span>
                          {sinStock
                            ? <span style={{ padding: '1px 7px', borderRadius: 'var(--r-pill)', background: 'var(--bad-bg)', color: 'var(--bad-ink)', fontSize: 10, fontWeight: 700, fontFamily: 'var(--font-ui)', letterSpacing: '0.03em' }}>Sin stock</span>
                            : <span style={{ color: 'var(--ink-300)' }}>· Stock: {l.stock}</span>
                          }
                        </div>
                      </div>
                      <span style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 18, letterSpacing: '-0.01em', color: precioColor, whiteSpace: 'nowrap' }}>
                        ${Number(l.pvp).toLocaleString('es-CL')}
                      </span>
                    </div>
                  );
                })}
              </div>
            </div>
          ) : (<>

          {/* Resultados de búsqueda */}
          {busqueda && (
            <div style={{ border: '1px solid var(--line)', borderRadius: 14, background: 'var(--paper)', marginBottom: 16, overflow: 'hidden', boxShadow: 'var(--shadow-card)', maxHeight: 420, overflowY: 'auto' }}>
              {busquedaGrupos.totalItems === 0 ? (
                <p style={{ padding: '12px 16px', color: 'var(--ink-400)', fontSize: 13, margin: 0, fontStyle: 'italic', fontFamily: 'var(--font-ui)' }}>Sin resultados</p>
              ) : busquedaGrupos.grupos.map((grupo, gi) => (
                <React.Fragment key={gi}>
                  {grupo.header && (
                    <div
                      onClick={() => expandirGrupo(grupo, busquedaTrim)}
                      style={{ padding: '8px 16px', fontSize: 11, fontWeight: 600, color: 'var(--ink-600)', textTransform: 'uppercase', letterSpacing: '0.06em', fontFamily: 'var(--font-ui)', background: 'var(--paper-stripe)', borderBottom: '1px solid var(--line-soft)', display: 'flex', alignItems: 'center', gap: 5, cursor: 'pointer', transition: `background var(--t-fast)` }}
                      onMouseEnter={e => e.currentTarget.style.background = 'var(--brand-softer)'}
                      onMouseLeave={e => e.currentTarget.style.background = 'var(--paper-stripe)'}
                    >
                      {grupo.iconKey === 'user' ? <User size={11} strokeWidth={2} /> : <Building2 size={11} strokeWidth={2} />}
                      <span style={{ flex: 1 }}>{grupo.header}</span>
                      <span style={{ fontSize: 10, color: 'var(--ink-400)', fontWeight: 400, textTransform: 'none', letterSpacing: 0 }}>Ver todos →</span>
                    </div>
                  )}
                  {grupo.items.map((l, i) => {
                    const sinStock    = (l.stock ?? 0) <= 0;
                    const tone        = TONE_STYLES[POS_TONES[i % POS_TONES.length]] || TONE_STYLES['peach'];
                    const circuloBg   = sinStock ? 'var(--bad-bg)'  : tone.bg;
                    const circuloInk  = sinStock ? 'var(--bad-ink)' : tone.ink;
                    const tituloColor = sinStock ? 'var(--ink-400)' : 'var(--ink-900)';
                    const precioColor = sinStock ? 'var(--ink-400)' : 'var(--ink-900)';
                    const isLast      = gi === busquedaGrupos.grupos.length - 1 && i === grupo.items.length - 1;
                    return (
                      <div key={l.id} onClick={() => agregarAlCarrito(l)}
                        style={{ padding: '12px 16px', borderBottom: isLast ? 'none' : '1px solid var(--line-soft)', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 12, transition: `background var(--t-fast)` }}
                        onMouseEnter={e => e.currentTarget.style.background = 'var(--brand-softer)'}
                        onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                      >
                        <span style={{ width: 40, height: 40, borderRadius: '50%', flexShrink: 0, background: circuloBg, color: circuloInk, display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                          {sinStock            ? <BookX     size={17} strokeWidth={1.75} />
                           : grupo.iconKey === 'user'     ? <User      size={17} strokeWidth={1.75} />
                           : grupo.iconKey === 'building' ? <Building2 size={17} strokeWidth={1.75} />
                           : <BookOpen size={17} strokeWidth={1.75} />}
                        </span>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ fontSize: 14, fontWeight: 600, color: tituloColor, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{l.titulo}</div>
                          {(l.isbn || l.autor || l.editorial) && (
                            <div style={{ fontSize: 11, color: 'var(--ink-400)', marginTop: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontFamily: 'var(--font-ui)' }}>
                              {[l.isbn, l.autor, l.editorial].filter(Boolean).join(' · ')}
                            </div>
                          )}
                          <div style={{ fontSize: 12, color: 'var(--ink-400)', marginTop: 2, display: 'flex', alignItems: 'center', gap: 6 }}>
                            <span>{l.distribuidor}</span>
                            {sinStock
                              ? <span style={{ padding: '1px 7px', borderRadius: 'var(--r-pill)', background: 'var(--bad-bg)', color: 'var(--bad-ink)', fontSize: 10, fontWeight: 700, fontFamily: 'var(--font-ui)', letterSpacing: '0.03em' }}>Sin stock</span>
                              : <span style={{ color: 'var(--ink-300)' }}>· Stock: {l.stock}</span>
                            }
                          </div>
                        </div>
                        <span style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 18, letterSpacing: '-0.01em', color: precioColor, whiteSpace: 'nowrap' }}>
                          ${Number(l.pvp).toLocaleString('es-CL')}
                        </span>
                      </div>
                    );
                  })}
                </React.Fragment>
              ))}
            </div>
          )}

          {/* Ventas en espera */}
          {ventasEspera.length > 0 && (
            <div style={{ marginTop: busqueda ? 0 : '1.5rem' }}>
              <div style={{ fontSize: 11, fontWeight: 600, color: 'var(--ink-500)', textTransform: 'uppercase', letterSpacing: '0.07em', fontFamily: 'var(--font-ui)', marginBottom: 10 }}>
                En espera ({ventasEspera.length})
              </div>
              {ventasEspera.map(v => {
                const subtotalEspera = v.carrito.reduce((sum, i) => sum + (i.precio_unitario - (i.descuento || 0)) * i.cantidad, 0);
                const descMonto = v.descuentoTotal
                  ? v.tipoDescuentoTotal === 'pesos' ? Number(v.descuentoTotal) : Math.round(subtotalEspera * Number(v.descuentoTotal) / 100)
                  : 0;
                const totalEspera = Math.max(0, subtotalEspera - descMonto);
                const esperaTone = TONE_STYLES[itemTone(v.id)] || TONE_STYLES['peach'];
                return (
                  <div key={v.id} style={{ border: '1px solid var(--line)', borderRadius: 14, padding: '12px 14px', marginBottom: 10, display: 'flex', alignItems: 'center', gap: 12, background: 'var(--paper)' }}>
                    <span style={{ width: 36, height: 36, borderRadius: '50%', flexShrink: 0, background: esperaTone.bg, color: esperaTone.ink, display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                      <Pause size={15} strokeWidth={1.75} />
                    </span>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontSize: 12, color: 'var(--ink-500)', fontFamily: 'var(--font-ui)' }}>
                        <strong style={{ color: 'var(--ink-900)' }}>{new Date(v.guardada_en).toLocaleTimeString('es-CL', { hour: '2-digit', minute: '2-digit' })}</strong>
                        <span style={{ marginLeft: 6 }}>{v.carrito.length} {v.carrito.length === 1 ? 'ítem' : 'ítems'}</span>
                      </div>
                      <div style={{ fontSize: 12, color: 'var(--ink-400)', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', marginTop: 2 }}>
                        {(() => { const t = v.carrito.map(i => i.titulo); return t.length <= 3 ? t.join(' · ') : t.slice(0, 2).join(' · ') + ` +${t.length - 2} más`; })()}
                      </div>
                    </div>
                    <span style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 17, letterSpacing: '-0.01em', color: 'var(--ink-900)', whiteSpace: 'nowrap' }}>
                      ${totalEspera.toLocaleString('es-CL')}
                    </span>
                    <button onClick={() => recuperarEspera(v)}
                      style={{ padding: '6px 12px', background: 'var(--brand)', color: '#fff', border: 'none', cursor: 'pointer', borderRadius: 'var(--r-pill)', fontSize: 12, fontWeight: 600, fontFamily: 'var(--font-ui)', flexShrink: 0 }}>
                      Recuperar
                    </button>
                    <button onClick={() => eliminarEspera(v.id)}
                      style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--ink-300)', display: 'inline-flex', alignItems: 'center', padding: 4, flexShrink: 0 }}>
                      <X size={14} strokeWidth={1.75} />
                    </button>
                  </div>
                );
              })}
            </div>
          )}
          </>)} {/* fin grupoExpandido ternary */}
        </div>

        {/* ── Derecha: carrito o comprobante ───────────── */}
        <div style={{ border: '1px solid var(--line)', borderRadius: 'var(--r-3xl)', background: 'var(--paper)', overflow: 'hidden', boxShadow: 'var(--shadow-card)' }}>
          {!ventaConfirmada ? (
          <>
          {/* Header carrito */}
          <div style={{ padding: '16px 20px 12px', display: 'flex', alignItems: 'center', gap: 10, borderBottom: '1px solid var(--line-soft)' }}>
            <ShoppingCart size={18} strokeWidth={1.75} color="var(--ink-900)" />
            <span style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 20, letterSpacing: '-0.015em', color: 'var(--ink-900)', flex: 1 }}>Carrito</span>
            <span style={{ display: 'inline-flex', alignItems: 'center', padding: '3px 10px', background: 'var(--paper-soft)', color: 'var(--ink-600)', borderRadius: 'var(--r-pill)', fontSize: 12, fontFamily: 'var(--font-ui)' }}>
              {carrito.reduce((s, i) => s + i.cantidad, 0)} ítems
            </span>
            {carrito.length > 0 && (
              <button onClick={guardarEnEspera}
                style={{ display: 'inline-flex', alignItems: 'center', gap: 5, padding: '5px 12px', background: 'transparent', border: '1px solid var(--line)', borderRadius: 'var(--r-pill)', cursor: 'pointer', fontSize: 12, fontFamily: 'var(--font-ui)', color: 'var(--ink-600)', transition: `border-color var(--t-fast)` }}
                onMouseEnter={e => e.currentTarget.style.borderColor = 'var(--ink-400)'}
                onMouseLeave={e => e.currentTarget.style.borderColor = 'var(--line)'}
              >
                <Pause size={11} strokeWidth={2} /> En espera
              </button>
            )}
          </div>

          {carrito.length === 0 ? (
            <p style={{ padding: '20px', color: 'var(--ink-400)', fontSize: 13, fontStyle: 'italic', fontFamily: 'var(--font-ui)', margin: 0 }}>
              Busca un libro para agregarlo al carrito.
            </p>
          ) : (
            <>
              {/* Ítems */}
              {carrito.map(item => {
                const tone = TONE_STYLES[itemTone(item.lote_id)] || TONE_STYLES['peach'];
                const esDevuelto = !!item.devuelto;
                return (
                  <div key={item.lote_id} style={{ padding: '12px 20px', borderTop: '1px solid var(--line-soft)', background: esDevuelto ? 'var(--ok-bg)' : 'transparent', transition: 'background var(--t-fast)' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                      <span style={{ width: 32, height: 32, borderRadius: '50%', flexShrink: 0, background: esDevuelto ? 'var(--ok-line)' : tone.bg, color: esDevuelto ? 'var(--ok-ink)' : tone.ink, display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                        {esDevuelto ? <RotateCcw size={13} strokeWidth={2} /> : <BookOpen size={13} strokeWidth={1.75} />}
                      </span>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ fontSize: 13, fontWeight: 600, color: esDevuelto ? 'var(--ok-ink)' : 'var(--ink-900)', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>{item.titulo}</div>
                        <div style={{ fontSize: 11, color: esDevuelto ? 'var(--ok-ink)' : 'var(--ink-500)', marginTop: 1, opacity: esDevuelto ? 0.8 : 1, display: 'flex', alignItems: 'center' }}>
                          {esDevuelto ? (
                            `Devuelto al stock · crédito $${Number(item.precio_unitario).toLocaleString('es-CL')}`
                          ) : editandoPrecioId === item.lote_id ? (
                            <input
                              type="number" min="0" autoFocus
                              defaultValue={item.precio_unitario - (item.descuento || 0)}
                              onBlur={e => { confirmarPrecioManual(item.lote_id, e.target.value); setEditandoPrecioId(null); }}
                              onKeyDown={e => {
                                if (e.key === 'Enter') { confirmarPrecioManual(item.lote_id, e.target.value); setEditandoPrecioId(null); }
                                if (e.key === 'Escape') setEditandoPrecioId(null);
                              }}
                              style={{ width: 72, padding: '2px 6px', borderRadius: 6, border: '1.5px solid var(--brand)', background: 'var(--paper)', fontSize: 11, textAlign: 'right', outline: 'none', fontFamily: 'var(--font-mono)', color: 'var(--ink-900)' }}
                            />
                          ) : (
                            <span
                              onClick={() => setEditandoPrecioId(item.lote_id)}
                              title="Tocar para cobrar un precio distinto"
                              style={{ cursor: 'pointer', borderBottom: '1px dashed var(--ink-300)' }}
                            >
                              ${Number(item.precio_unitario - (item.descuento || 0)).toLocaleString('es-CL')} c/u
                              {item.descuento > 0 && <span style={{ color: 'var(--bad-ink)', marginLeft: 4 }}>−${Number(item.descuento).toLocaleString('es-CL')}</span>}
                              {item.descuento < 0 && <span style={{ color: 'var(--brand)', marginLeft: 4 }}>+${Number(-item.descuento).toLocaleString('es-CL')}</span>}
                            </span>
                          )}
                        </div>
                        {item.oferta_nombre && !esDevuelto && (
                          <div style={{ display: 'inline-flex', alignItems: 'center', gap: 3, marginTop: 3, padding: '2px 7px', background: 'var(--ok-bg)', color: 'var(--ok-ink)', borderRadius: 'var(--r-pill)', fontSize: 10, fontWeight: 600, fontFamily: 'var(--font-ui)' }}>
                            <Tag size={9} strokeWidth={2} /> {item.oferta_nombre}
                          </div>
                        )}
                      </div>
                      {!esDevuelto && <>
                        <input type="number" min="1" value={item.cantidad} onChange={e => cambiarCantidad(item.lote_id, e.target.value)}
                          style={{ width: 48, height: 32, borderRadius: 'var(--r-pill)', textAlign: 'center', background: item.cantidad > 1 ? 'var(--warn-bg)' : 'var(--paper)', border: '1px solid var(--line)', color: 'var(--ink-900)', fontWeight: 600, outline: 'none', fontFamily: 'var(--font-mono)', fontSize: 13 }} />
                        <span style={{ minWidth: 80, textAlign: 'right', fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 17, letterSpacing: '-0.01em', color: 'var(--ink-900)' }}>
                          ${((item.precio_unitario - (item.descuento || 0)) * item.cantidad).toLocaleString('es-CL')}
                        </span>
                      </>}
                      {/* Botón devolver / desmarcar */}
                      <button onClick={() => toggleDevueltoEnCarrito(item.lote_id)}
                        title={esDevuelto ? 'Desmarcar devolución' : 'Marcar como devuelto'}
                        style={{ background: esDevuelto ? 'var(--ok-bg)' : 'none', border: `1px solid ${esDevuelto ? 'var(--ok-line)' : 'var(--line)'}`, borderRadius: 8, cursor: 'pointer', color: esDevuelto ? 'var(--ok-ink)' : 'var(--ink-400)', display: 'inline-flex', alignItems: 'center', padding: 5, flexShrink: 0, transition: `border-color var(--t-fast), color var(--t-fast), background var(--t-fast)` }}
                        onMouseEnter={e => { if (!esDevuelto) { e.currentTarget.style.borderColor = 'var(--ok-ink)'; e.currentTarget.style.color = 'var(--ok-ink)'; e.currentTarget.style.background = 'var(--ok-bg)'; } }}
                        onMouseLeave={e => { if (!esDevuelto) { e.currentTarget.style.borderColor = 'var(--line)'; e.currentTarget.style.color = 'var(--ink-400)'; e.currentTarget.style.background = 'none'; } }}
                      >
                        <RotateCcw size={12} strokeWidth={1.75} />
                      </button>
                      <button onClick={() => quitarDelCarrito(item.lote_id)}
                        style={{ background: 'none', border: '1px solid var(--line)', borderRadius: 8, cursor: 'pointer', color: 'var(--ink-400)', display: 'inline-flex', alignItems: 'center', padding: 5, flexShrink: 0, transition: `border-color var(--t-fast), color var(--t-fast)` }}
                        onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--bad-line, var(--line))'; e.currentTarget.style.color = 'var(--bad-ink)'; }}
                        onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--line)'; e.currentTarget.style.color = 'var(--ink-400)'; }}
                      >
                        <X size={12} strokeWidth={1.75} />
                      </button>
                    </div>
                    {/* Descuento por ítem */}
                    <div style={{ display: 'flex', gap: 8, marginTop: 8, alignItems: 'center', paddingLeft: 44 }}>
                      <span style={{ fontSize: 11, color: 'var(--ink-400)', fontFamily: 'var(--font-ui)' }}>Desc.</span>
                      <input type="number" placeholder="0" title="Negativo para cobrar más que el precio de lista"
                        value={item.descuentoVisual !== undefined ? item.descuentoVisual : (item.descuento || '')}
                        onChange={e => {
                          const valor = e.target.value === '' ? '' : Number(e.target.value);
                          const tipo = item.tipoDescuento || 'pesos';
                          const descuentoMonto = valor === '' ? 0 : tipo === 'porcentaje' ? Math.round(item.precio_unitario * valor / 100) : valor;
                          setCarrito(carrito.map(i => i.lote_id === item.lote_id ? { ...i, descuento: descuentoMonto, descuentoVisual: valor } : i));
                        }}
                        style={{ width: 60, padding: '4px 8px', borderRadius: 'var(--r-pill)', border: '1px solid var(--line)', background: 'var(--paper)', fontSize: 12, textAlign: 'right', outline: 'none', fontFamily: 'var(--font-mono)' }} />
                      {/* Pill $ / % */}
                      <div style={{ display: 'inline-flex', border: '1px solid var(--line)', borderRadius: 'var(--r-pill)', overflow: 'hidden', flexShrink: 0 }}>
                        {['pesos', 'porcentaje'].map(t => {
                          const activo = (item.tipoDescuento || 'pesos') === t;
                          return (
                            <button key={t}
                              onClick={() => {
                              if (!activo) setCarrito(carrito.map(i => {
                                if (i.lote_id !== item.lote_id) return i;
                                const visual = i.descuentoVisual !== undefined && i.descuentoVisual !== '' ? Number(i.descuentoVisual) : (i.descuento || 0);
                                const monto  = t === 'porcentaje' ? Math.round(i.precio_unitario * visual / 100) : visual;
                                return { ...i, tipoDescuento: t, descuento: monto, descuentoVisual: visual || '' };
                              }));
                            }}
                              style={{ padding: '4px 10px', border: 'none', borderRight: t === 'pesos' ? '1px solid var(--line)' : 'none', background: activo ? 'var(--ink-900)' : 'var(--paper)', color: activo ? '#fff' : 'var(--ink-600)', cursor: activo ? 'default' : 'pointer', fontSize: 12, fontFamily: 'var(--font-ui)', fontWeight: activo ? 600 : 400, transition: `background var(--t-fast)` }}>
                              {t === 'pesos' ? '$' : '%'}
                            </button>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                );
              })}

              {/* Totales */}
              <div style={{ padding: '14px 20px 10px', borderTop: '1px solid var(--line-soft)', background: 'var(--paper)' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
                  <span style={{ fontSize: 12, color: 'var(--ink-500)', fontFamily: 'var(--font-ui)', flex: 1 }}>Descuento total</span>
                  <input type="number" min="0" placeholder="0" value={descuentoTotal}
                    onChange={e => {
                      const v = Number(e.target.value);
                      setDescuentoTotal(tipoDescuentoTotal === 'porcentaje' ? Math.min(v, 100) : v);
                    }}
                    style={{ width: 80, padding: '6px 10px', borderRadius: 'var(--r-pill)', border: '1px solid var(--line)', background: 'var(--paper)', textAlign: 'right', outline: 'none', fontFamily: 'var(--font-mono)', fontSize: 13 }} />
                  {/* Pill $ / % */}
                  <div style={{ display: 'inline-flex', border: '1px solid var(--line)', borderRadius: 'var(--r-pill)', overflow: 'hidden', flexShrink: 0 }}>
                    {['pesos', 'porcentaje'].map(t => {
                      const activo = tipoDescuentoTotal === t;
                      return (
                        <button key={t}
                          onClick={() => { if (!activo) setTipoDescuentoTotal(t); }}
                          style={{ padding: '6px 12px', border: 'none', borderRight: t === 'pesos' ? '1px solid var(--line)' : 'none', background: activo ? 'var(--ink-900)' : 'var(--paper)', color: activo ? '#fff' : 'var(--ink-600)', cursor: activo ? 'default' : 'pointer', fontSize: 12, fontFamily: 'var(--font-ui)', fontWeight: activo ? 600 : 400, transition: `background var(--t-fast)` }}>
                          {t === 'pesos' ? '$' : '%'}
                        </button>
                      );
                    })}
                  </div>
                </div>
                {subtotal !== total && (
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, color: 'var(--ink-500)', marginBottom: 4, fontFamily: 'var(--font-ui)' }}>
                    <span>Subtotal</span>
                    <span style={{ fontFamily: 'var(--font-mono)' }}>${subtotal.toLocaleString('es-CL')}</span>
                  </div>
                )}
                {descuentoTotalMonto > 0 && (
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, color: 'var(--bad-ink)', marginBottom: 4, fontFamily: 'var(--font-ui)' }}>
                    <span>Descuento</span>
                    <span style={{ fontFamily: 'var(--font-mono)' }}>−${descuentoTotalMonto.toLocaleString('es-CL')}</span>
                  </div>
                )}
                {devCredito > 0 && (
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: 12, color: 'var(--ok-ink)', marginBottom: 4, fontFamily: 'var(--font-ui)', background: 'var(--ok-bg)', borderRadius: 8, padding: '4px 8px', margin: '0 -8px 4px' }}>
                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5 }}><RotateCcw size={11} strokeWidth={2} /> Crédito devolución</span>
                    <span style={{ fontFamily: 'var(--font-mono)' }}>−${devCredito.toLocaleString('es-CL')}</span>
                  </div>
                )}
                {tcCredito > 0 && (
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: 12, color: '#7C3AED', marginBottom: 4, fontFamily: 'var(--font-ui)', background: '#F5F3FF', borderRadius: 8, padding: '4px 8px', margin: '0 -8px 4px' }}>
                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5 }}><Tag size={11} strokeWidth={2} /> Ticket de cambio</span>
                    <span style={{ fontFamily: 'var(--font-mono)' }}>−${tcCredito.toLocaleString('es-CL')}</span>
                  </div>
                )}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginTop: 6 }}>
                  <span style={{ fontSize: 12, fontWeight: 600, color: 'var(--ink-700)', textTransform: 'uppercase', letterSpacing: '0.06em', fontFamily: 'var(--font-ui)' }}>Total</span>
                  <span style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 34, letterSpacing: '-0.02em', color: 'var(--ink-900)' }}>
                    ${totalConCredito.toLocaleString('es-CL')}
                  </span>
                </div>
                {devCredito > total && (
                  <div style={{ fontSize: 12, color: 'var(--ok-ink)', fontFamily: 'var(--font-ui)', marginTop: 4, background: 'var(--ok-bg)', borderRadius: 8, padding: '5px 8px' }}>
                    Reembolso en efectivo al cliente: <strong style={{ fontFamily: 'var(--font-mono)' }}>${(devCredito - total).toLocaleString('es-CL')}</strong>
                  </div>
                )}
              </div>

              {/* Ticket de cambio — canjear */}
              <div style={{ padding: '0 20px 12px' }}>
                {tcPanel ? (
                  <div style={{ background: '#F5F3FF', border: '1px solid rgba(109,40,217,0.2)', borderRadius: 12, padding: 12 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
                      <span style={{ fontFamily: 'var(--font-mono)', fontSize: 15, fontWeight: 700, color: '#7C3AED', letterSpacing: '0.08em' }}>{tcPanel.codigo}</span>
                      <span style={{ fontSize: 11, color: '#A78BFA', fontFamily: 'var(--font-ui)' }}>{tcPanel.tipo === 'total' ? 'Compra completa' : 'Individual'}</span>
                    </div>
                    <div style={{ fontSize: 10, fontWeight: 600, letterSpacing: '0.06em', color: '#A78BFA', textTransform: 'uppercase', marginBottom: 6, fontFamily: 'var(--font-ui)' }}>
                      {tcPanel.tipo === 'total' ? 'Marcar libros que devuelve' : 'Libro a devolver'}
                    </div>
                    {tcPanel.itemsPanel.map((item, idx) => (
                      <div key={item.id}
                        onClick={() => {
                          if (tcPanel.tipo === 'individual') return;
                          setTcPanel({ ...tcPanel, itemsPanel: tcPanel.itemsPanel.map((i, j) => j === idx ? { ...i, selected: !i.selected } : i) });
                        }}
                        style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '7px 10px', background: item.selected ? 'rgba(109,40,217,0.08)' : 'rgba(255,255,255,0.6)', borderRadius: 8, marginBottom: 4, cursor: tcPanel.tipo === 'total' ? 'pointer' : 'default', border: '1px solid rgba(109,40,217,0.1)' }}>
                        <div style={{ width: 16, height: 16, borderRadius: 4, border: `1.5px solid ${item.selected ? '#7C3AED' : 'rgba(109,40,217,0.3)'}`, background: item.selected ? '#7C3AED' : 'transparent', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          {item.selected && <span style={{ color: 'white', fontSize: 9, fontWeight: 700, lineHeight: 1 }}>✓</span>}
                        </div>
                        <span style={{ fontSize: 11, fontWeight: 500, color: '#1A1612', flex: 1, fontFamily: 'var(--font-ui)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item.titulo_snapshot}</span>
                      </div>
                    ))}
                    {tcPanel.itemsPanel.some(i => i.selected) && (() => {
                      const credPrev = tcPanel.itemsPanel.filter(i => i.selected).reduce((s, i) => s + i.precio_original, 0);
                      return (
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 8, padding: '6px 10px', background: 'rgba(109,40,217,0.08)', borderRadius: 8 }}>
                          <span style={{ fontSize: 11, color: '#7C3AED', fontWeight: 500, fontFamily: 'var(--font-ui)' }}>Crédito a aplicar</span>
                          <span style={{ fontFamily: 'var(--font-mono)', fontWeight: 700, color: '#7C3AED', fontSize: 12 }}>${credPrev.toLocaleString('es-CL')}</span>
                        </div>
                      );
                    })()}
                    <div style={{ display: 'flex', gap: 8, marginTop: 10 }}>
                      <button onClick={aplicarTC} disabled={!tcPanel.itemsPanel.some(i => i.selected)}
                        style={{ flex: 1, padding: '7px 0', background: '#7C3AED', color: 'white', border: 'none', borderRadius: 'var(--r-pill)', fontSize: 12, fontWeight: 600, cursor: tcPanel.itemsPanel.some(i => i.selected) ? 'pointer' : 'default', fontFamily: 'var(--font-ui)', opacity: tcPanel.itemsPanel.some(i => i.selected) ? 1 : 0.5 }}>
                        Aplicar crédito
                      </button>
                      <button onClick={() => setTcPanel(null)}
                        style={{ padding: '7px 14px', background: 'transparent', border: '1px solid rgba(109,40,217,0.3)', borderRadius: 'var(--r-pill)', fontSize: 12, color: '#7C3AED', cursor: 'pointer', fontFamily: 'var(--font-ui)' }}>
                        Cancelar
                      </button>
                    </div>
                  </div>
                ) : (
                  <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                    <input
                      value={tcInput}
                      onChange={e => setTcInput(e.target.value.toUpperCase())}
                      onKeyDown={e => e.key === 'Enter' && buscarTC()}
                      placeholder="Canjear ticket TC-XXXX"
                      style={{ flex: 1, padding: '8px 12px', borderRadius: 'var(--r-pill)', border: '1px solid rgba(109,40,217,0.25)', background: tcInput ? '#F5F3FF' : 'var(--paper)', outline: 'none', fontSize: 12, fontFamily: tcInput ? 'var(--font-mono)' : 'var(--font-ui)', letterSpacing: tcInput ? '0.05em' : 'normal', color: '#7C3AED', fontWeight: tcInput ? 600 : 400 }}
                    />
                    {tcInput && (
                      <button onClick={buscarTC} disabled={tcCargando}
                        style={{ padding: '8px 14px', background: '#7C3AED', color: 'white', border: 'none', borderRadius: 'var(--r-pill)', fontSize: 12, fontWeight: 600, cursor: 'pointer', fontFamily: 'var(--font-ui)', whiteSpace: 'nowrap', opacity: tcCargando ? 0.5 : 1 }}>
                        {tcCargando ? '...' : 'Buscar'}
                      </button>
                    )}
                  </div>
                )}
                {tcAplicados.map((tc, i) => (
                  <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 6, padding: '6px 10px', background: '#F5F3FF', borderRadius: 8, border: '1px solid rgba(109,40,217,0.15)' }}>
                    <div>
                      <span style={{ fontFamily: 'var(--font-mono)', fontSize: 12, fontWeight: 600, color: '#7C3AED' }}>{tc.codigo}</span>
                      <span style={{ fontSize: 10, color: '#A78BFA', marginLeft: 6, fontFamily: 'var(--font-ui)' }}>{tc.itemsSeleccionados.length} libro{tc.itemsSeleccionados.length !== 1 ? 's' : ''}</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <span style={{ fontFamily: 'var(--font-mono)', fontWeight: 700, color: '#7C3AED', fontSize: 12 }}>−${tc.itemsSeleccionados.reduce((s, x) => s + x.precio_original, 0).toLocaleString('es-CL')}</span>
                      <button onClick={() => setTcAplicados(tcAplicados.filter((_, j) => j !== i))}
                        style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#A78BFA', fontSize: 16, lineHeight: 1, padding: '0 2px' }}>×</button>
                    </div>
                  </div>
                ))}
              </div>

              {/* Pago — Opción A */}
              <div style={{ padding: '6px 20px 18px' }}>
                {/* Label + pill "requerido" */}
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, margin: '6px 0 9px' }}>
                  <span style={{ fontSize: 11, fontWeight: 600, color: 'var(--ink-700)', textTransform: 'uppercase', letterSpacing: '0.06em', fontFamily: 'var(--font-ui)' }}>Método de pago</span>
                  {!metodoPago && (
                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, padding: '2px 9px', borderRadius: 'var(--r-pill)', fontSize: 11, fontWeight: 600, background: 'var(--warn-bg)', color: 'var(--warn-ink)', fontFamily: 'var(--font-ui)' }}>
                      <CircleAlert size={11} strokeWidth={2} /> requerido
                    </span>
                  )}
                </div>

                {/* Grid de botones de método — 2 columnas */}
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                  {POS_METODOS_A.map(m => {
                    const on = metodoPago === m.key;
                    const isGiftCard = m.key === 'giftcard';
                    return (
                      <div key={m.key} style={isGiftCard ? { gridColumn: '1 / -1' } : {}}>
                        <button onClick={() => { setMetodoPago(m.key); setValorGift(''); setMetodoPago2(''); }}
                          style={{ width: '100%', display: 'flex', alignItems: 'center', gap: 10, textAlign: 'left', padding: '10px 13px', borderRadius: 14, cursor: 'pointer', background: on ? 'var(--ink-900)' : 'var(--paper)', border: `1.5px solid ${on ? 'var(--ink-900)' : 'var(--line)'}`, color: on ? '#fff' : 'var(--ink-800)', fontFamily: 'var(--font-ui)', fontSize: 13, fontWeight: 600, transition: `background var(--t-fast), border-color var(--t-fast)` }}>
                          <span style={{ width: 32, height: 32, borderRadius: '50%', flexShrink: 0, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', background: on ? 'rgba(255,255,255,0.16)' : `var(--past-${m.tone})`, color: on ? '#fff' : `var(--past-${m.tone}-ink)` }}>
                            <m.Icon size={15} strokeWidth={1.75} />
                          </span>
                          <span style={{ flex: 1 }}>{m.label}</span>
                          <span style={{ fontFamily: 'var(--font-mono)', fontSize: 10, opacity: on ? 0.65 : 0.4, border: `1px solid ${on ? 'rgba(255,255,255,0.3)' : 'var(--line)'}`, borderRadius: 5, padding: '1px 5px', lineHeight: 1.4 }}>{m.atajo}</span>
                        </button>
                      </div>
                    );
                  })}
                </div>

                {/* Gift card: valor + restante */}
                {esGift && (
                  <div style={{ background: 'var(--paper-soft)', border: '1px solid var(--line)', borderRadius: 14, padding: '12px 14px', marginTop: 10 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                      <span style={{ fontSize: 12, color: 'var(--ink-700)', fontWeight: 600, flex: 1 }}>Valor de la gift card</span>
                      <input type="number" placeholder="0" value={valorGift} onChange={e => setValorGift(e.target.value)} autoFocus
                        style={{ width: 120, padding: '7px 12px', borderRadius: 'var(--r-pill)', border: '1px solid var(--line)', background: 'var(--paper)', outline: 'none', textAlign: 'right', fontFamily: 'var(--font-mono)', fontSize: 13 }} />
                    </div>
                    {giftNum > 0 && (
                      <div style={{ marginTop: 10 }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, color: 'var(--ink-600)', padding: '2px 0', fontFamily: 'var(--font-ui)' }}>
                          <span>Gift card cubre</span>
                          <span style={{ fontFamily: 'var(--font-mono)', color: 'var(--ok-ink)' }}>−${giftCubre.toLocaleString('es-CL')}</span>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', padding: '5px 0 2px', borderTop: '1px solid var(--line-soft)', marginTop: 4 }}>
                          <span style={{ fontSize: 12, fontWeight: 700, color: 'var(--ink-800)', fontFamily: 'var(--font-ui)' }}>Restante a cobrar</span>
                          <span style={{ fontFamily: 'var(--font-display)', fontSize: 19, fontWeight: 700, letterSpacing: '-0.01em' }}>${restanteGift.toLocaleString('es-CL')}</span>
                        </div>
                        {saldoGift > 0 && (
                          <div style={{ fontSize: 11, color: 'var(--ink-500)', marginTop: 3, fontFamily: 'var(--font-ui)' }}>Queda ${saldoGift.toLocaleString('es-CL')} de saldo en la tarjeta.</div>
                        )}
                      </div>
                    )}
                    {giftNum > 0 && restanteGift > 0 && (
                      <div style={{ marginTop: 10 }}>
                        <div style={{ fontSize: 11, fontWeight: 600, color: 'var(--ink-700)', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 7, fontFamily: 'var(--font-ui)' }}>Resto con</div>
                        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                          {POS_METODOS_A.filter(m => m.key !== 'giftcard').map(m => {
                            const on = metodoPago2 === m.key;
                            return (
                              <button key={m.key} onClick={() => setMetodoPago2(m.key)}
                                style={{ display: 'inline-flex', alignItems: 'center', gap: 5, padding: '6px 11px', borderRadius: 'var(--r-pill)', fontSize: 12, border: `1.5px solid ${on ? 'var(--ink-900)' : 'var(--line)'}`, background: on ? 'var(--ink-900)' : 'var(--paper)', color: on ? '#fff' : 'var(--ink-700)', cursor: 'pointer', fontFamily: 'var(--font-ui)', fontWeight: on ? 600 : 500 }}>
                                <m.Icon size={12} strokeWidth={1.75} /> {m.label}
                              </button>
                            );
                          })}
                        </div>
                      </div>
                    )}
                  </div>
                )}

                {/* Pago mixto toggle — oculto con gift card */}
                {!esGift && (
                  <label style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 12, cursor: 'pointer', color: 'var(--ink-600)', fontFamily: 'var(--font-ui)', marginTop: 11 }}>
                    <input type="checkbox" checked={pagoMixto} onChange={e => { setPagoMixto(e.target.checked); setMetodoPago2(''); }} />
                    Pago mixto (2 métodos)
                  </label>
                )}

                {/* Segundo método pago mixto */}
                {!esGift && pagoMixto && (
                  <div style={{ background: 'var(--paper-soft)', border: '1px solid var(--line)', borderRadius: 14, padding: '11px 13px', marginTop: 10 }}>
                    <div style={{ fontSize: 11, fontWeight: 600, color: 'var(--ink-700)', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 8, fontFamily: 'var(--font-ui)' }}>Segundo método</div>
                    <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                      {POS_METODOS_A.filter(m => m.key !== metodoPago).map(m => {
                        const on = metodoPago2 === m.key;
                        return (
                          <button key={m.key} onClick={() => setMetodoPago2(m.key)}
                            style={{ display: 'inline-flex', alignItems: 'center', gap: 5, padding: '6px 11px', borderRadius: 'var(--r-pill)', fontSize: 12, border: `1.5px solid ${on ? 'var(--ink-900)' : 'var(--line)'}`, background: on ? 'var(--ink-900)' : 'var(--paper)', color: on ? '#fff' : 'var(--ink-700)', cursor: 'pointer', fontFamily: 'var(--font-ui)', fontWeight: on ? 600 : 500 }}>
                            <m.Icon size={12} strokeWidth={1.75} /> {m.label}
                          </button>
                        );
                      })}
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginTop: 10 }}>
                      <input type="number" placeholder="Monto 1" value={montoPago1}
                        onChange={e => { setMontoPago1(e.target.value); setMontoPago2(Math.max(0, total - Number(e.target.value))); }}
                        style={{ padding: '7px 10px', borderRadius: 'var(--r-pill)', border: '1px solid var(--line)', background: 'var(--paper)', fontSize: 12, outline: 'none', fontFamily: 'var(--font-mono)' }} />
                      <input type="number" placeholder="Monto 2" value={montoPago2} onChange={e => setMontoPago2(e.target.value)}
                        style={{ padding: '7px 10px', borderRadius: 'var(--r-pill)', border: '1px solid var(--line)', background: 'var(--paper)', fontSize: 12, outline: 'none', fontFamily: 'var(--font-mono)' }} />
                    </div>
                    {metodoPago === 'efectivo' && montoPago1 && (
                      <div style={{ fontSize: 12, color: 'var(--ink-600)', fontFamily: 'var(--font-ui)', marginTop: 6 }}>
                        Vuelto: <strong style={{ fontFamily: 'var(--font-mono)', color: 'var(--ink-900)' }}>${Math.max(0, Number(montoPago1) - (total - Number(montoPago2 || 0))).toLocaleString('es-CL')}</strong>
                      </div>
                    )}
                    {metodoPago2 === 'efectivo' && montoPago2 && (
                      <div style={{ fontSize: 12, color: 'var(--ink-600)', fontFamily: 'var(--font-ui)', marginTop: 6 }}>
                        Vuelto: <strong style={{ fontFamily: 'var(--font-mono)', color: 'var(--ink-900)' }}>${Math.max(0, Number(montoPago2) - (total - Number(montoPago1 || 0))).toLocaleString('es-CL')}</strong>
                      </div>
                    )}
                  </div>
                )}

                {/* Efectivo simple: monto recibido + vuelto */}
                {!pagoMixto && !esGift && metodoPago === 'efectivo' && (
                  <div style={{ background: 'var(--paper)', border: '1px solid var(--line)', borderRadius: 14, padding: '12px 14px', marginTop: 10 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                      <span style={{ fontSize: 12, color: 'var(--ink-600)', fontFamily: 'var(--font-ui)', flex: 1 }}>Monto recibido</span>
                      <input type="number" placeholder={total.toString()} value={montoPago1} onChange={e => setMontoPago1(e.target.value)}
                        style={{ width: 110, padding: '7px 12px', borderRadius: 'var(--r-pill)', border: '1px solid var(--line)', background: 'var(--paper)', outline: 'none', textAlign: 'right', fontFamily: 'var(--font-mono)', fontSize: 13 }} />
                    </div>
                    {montoPago1 && Number(montoPago1) >= totalConCredito && (
                      <div style={{ marginTop: 8, fontSize: 13, color: 'var(--ink-700)', fontFamily: 'var(--font-ui)' }}>
                        Vuelto: <strong style={{ fontFamily: 'var(--font-display)', fontSize: 17, letterSpacing: '-0.01em', color: 'var(--ink-900)' }}>${(Number(montoPago1) - totalConCredito).toLocaleString('es-CL')}</strong>
                      </div>
                    )}
                  </div>
                )}

                {/* Botón Cobrar — bloqueado si no hay método */}
                <button onClick={registrarVenta} disabled={cargando || !puedeCobrar}
                  style={{ width: '100%', padding: '13px', marginTop: 14, background: (cargando || !puedeCobrar) ? 'var(--ink-200)' : 'var(--brand)', color: (cargando || !puedeCobrar) ? 'var(--ink-500)' : '#fff', border: 'none', cursor: (cargando || !puedeCobrar) ? 'not-allowed' : 'pointer', fontSize: 15, borderRadius: 'var(--r-pill)', fontFamily: 'var(--font-ui)', fontWeight: 700, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 8, transition: `background var(--t-fast), color var(--t-fast)` }}
                  onMouseEnter={e => { if (puedeCobrar && !cargando) e.currentTarget.style.opacity = '0.9'; }}
                  onMouseLeave={e => { e.currentTarget.style.opacity = '1'; }}
                >
                  {puedeCobrar
                    ? <><Check size={16} strokeWidth={2.5} />{cargando ? 'Registrando...' : soloDevueltos ? 'Confirmar devolución' : totalConCredito === 0 ? 'Confirmar cambio sin cobro' : `Cobrar $${(esGift ? restanteGift : totalConCredito).toLocaleString('es-CL')}`}</>
                    : <><Lock size={15} strokeWidth={2} /> Elige cómo pagó para cobrar</>
                  }
                </button>
                {!puedeCobrar && !cargando && carrito.length > 0 && (
                  <p style={{ margin: '8px 2px 0', fontSize: 11.5, color: 'var(--ink-500)', textAlign: 'center', lineHeight: 1.45, fontFamily: 'var(--font-ui)' }}>
                    {esGift
                      ? (giftNum > 0 ? 'Falta elegir con qué se paga el resto.' : 'Ingresa el valor de la gift card para continuar.')
                      : pagoMixto && metodoPago
                        ? 'Falta elegir el segundo método del pago mixto.'
                        : 'Sin método elegido la venta no se cierra — así nunca queda registrada en efectivo por error.'}
                  </p>
                )}
              </div>
            </>
          )}
          </> /* fin !ventaConfirmada */
          ) : (
          /* ── Comprobante post-venta (reemplaza carrito) ── */
          <>
            <div style={{ padding: '16px 20px 12px', display: 'flex', alignItems: 'center', gap: 10, borderBottom: '1px solid var(--line-soft)' }}>
              <Printer size={18} strokeWidth={1.75} color="var(--ink-900)" />
              <span style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 20, letterSpacing: '-0.015em', color: 'var(--ink-900)', flex: 1 }}>Comprobante</span>
            </div>
            <ComprobanteVenta venta={ventaConfirmada} />
            <PosTicketGenerador ventaId={ventaConfirmada.ventaId} ventaItems={ventaConfirmada.ventaItems || []} />
            <div className="no-print" style={{ display: 'flex', gap: 10, padding: '14px 20px', borderTop: '1px solid var(--line-soft)' }}>
              <button onClick={() => window.print()}
                style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '8px 18px', background: 'var(--ink-900)', color: '#fff', border: 'none', borderRadius: 'var(--r-pill)', cursor: 'pointer', fontSize: 13, fontFamily: 'var(--font-ui)', fontWeight: 600 }}>
                <Printer size={13} strokeWidth={1.75} /> Imprimir comprobante
              </button>
              <button onClick={() => { setVentaConfirmada(null); setTimeout(() => document.getElementById('pos-busqueda')?.focus(), 50); }}
                style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '8px 18px', background: 'var(--paper)', border: '1px solid var(--line)', borderRadius: 'var(--r-pill)', cursor: 'pointer', fontSize: 13, fontFamily: 'var(--font-ui)', color: 'var(--ink-700)' }}>
                Nueva venta
              </button>
            </div>
          </>
          )}
        </div>
      </div>
      </div>
    </div>
  );
}


// ---------------------------------------------------------------------------
// FilaReposicion — definida FUERA de Reposicion para que React mantenga una
// referencia de tipo estable entre renders y no destruya/monte las filas en
// cada actualización de estado del padre.
// ---------------------------------------------------------------------------
function FilaReposicion({
  item, mostrarDistDropdown,
  distribuidores, distSel, setDistSel,
  enviando, confirmados, repPendiente,
  onRepuesto, onAgregarAPedido, onAsignarYAgregar, onAbrirFicha,
}) {
  const yaEnPedido   = item.en_pedido;
  const procesando   = !!enviando[item.libro_id];
  const confirmacion = confirmados[item.libro_id];
  const selActual    = distSel[item.libro_id] || '';
  const pendiente    = !!repPendiente[item.id];

  const tone = TONE_STYLES[itemTone(item.libro_id)] || TONE_STYLES['peach'];
  const sinStock = item.stock_actual <= 0;

  return (
    <tr style={{ borderBottom: '1px solid var(--line-soft)' }}
      onMouseEnter={e => { e.currentTarget.style.background = 'var(--brand-softer)'; }}
      onMouseLeave={e => { e.currentTarget.style.background = ''; }}
    >
      {/* Círculo pastel */}
      <td style={{ padding: '10px 0 10px 14px', verticalAlign: 'middle', width: 52 }}>
        <span style={{ width: 36, height: 36, borderRadius: '50%', flexShrink: 0, background: tone.bg, color: tone.ink, display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
          <BookOpen size={15} strokeWidth={1.75} />
        </span>
      </td>

      {/* Título + autor/editorial/isbn */}
      <td style={{ padding: '10px 12px', verticalAlign: 'middle', minWidth: 200 }}>
        <button
          onClick={() => onAbrirFicha({ id: item.libro_id, titulo: item.titulo, autor: item.autor, isbn: item.isbn, editorial: item.editorial, categoria: item.categoria, activo: true, etiquetas: [] })}
          style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', textAlign: 'left', display: 'block', width: '100%' }}
        >
          <div style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 14, color: 'var(--ink-900)', letterSpacing: '-0.01em', lineHeight: 1.25 }}>{item.titulo}</div>
          <div style={{ marginTop: 2, fontSize: 12, color: 'var(--ink-500)', fontFamily: 'var(--font-ui)', lineHeight: 1.3 }}>
            {item.autor || '—'}
            {item.editorial && <span style={{ color: 'var(--ink-700)' }}> · {item.editorial}</span>}
          </div>
          {(item.isbn || item.codigo_relea || item.distribuidor_nombre) && (
            <div style={{ marginTop: 1, fontSize: 11, color: 'var(--ink-400)', fontFamily: 'var(--font-ui)', lineHeight: 1.3 }}>
              {(item.isbn || item.codigo_relea) && <span style={{ fontFamily: 'var(--font-mono)' }}>{item.isbn || item.codigo_relea}</span>}
              {item.distribuidor_nombre && <span>{(item.isbn || item.codigo_relea) ? ' · ' : ''}{item.distribuidor_nombre}</span>}
            </div>
          )}
        </button>
      </td>

      {/* Stock */}
      <td style={{ padding: '10px 12px', verticalAlign: 'middle', textAlign: 'right', whiteSpace: 'nowrap' }}>
        <span style={{
          display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
          padding: '2px 10px', borderRadius: 'var(--r-pill)',
          background: sinStock ? 'var(--bad-bg)' : 'var(--ok-bg)',
          color: sinStock ? 'var(--bad-ink)' : 'var(--ok-ink)',
          fontSize: 12, fontWeight: 600, fontFamily: 'var(--font-ui)',
        }}>
          {item.stock_actual}
        </span>
      </td>

      {/* Vendidos */}
      <td style={{ padding: '10px 12px', verticalAlign: 'middle', textAlign: 'right', whiteSpace: 'nowrap' }}>
        <span style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 15, color: 'var(--ink-900)', letterSpacing: '-0.01em' }}>
          {item.cantidad}
        </span>
      </td>

      {/* Acciones */}
      <td style={{ padding: '10px 14px 10px 8px', verticalAlign: 'middle' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 4, alignItems: 'flex-start' }}>
          <div style={{ display: 'flex', gap: 6, alignItems: 'center', flexWrap: 'wrap' }}>

            {/* Repuesto ✓ — doble tap */}
            <button
              onClick={() => onRepuesto(item.id)}
              style={{ padding: '4px 12px', cursor: 'pointer', borderRadius: 'var(--r-pill)', fontSize: 12, fontFamily: 'var(--font-ui)', fontWeight: 600, whiteSpace: 'nowrap', lineHeight: 1.4, transition: 'all var(--t-fast)',
                background: pendiente ? 'var(--brand)' : 'var(--ok-bg)',
                color:      pendiente ? '#fff'         : 'var(--ok-ink)',
                border:     pendiente ? '1px solid var(--brand-strong)' : '1px solid var(--ok-line)',
              }}
            >
              {pendiente ? '¿Confirmar?' : 'Repuesto ✓'}
            </button>

            {mostrarDistDropdown ? (
              <>
                <select
                  value={selActual}
                  onChange={e => setDistSel(prev => ({ ...prev, [item.libro_id]: e.target.value }))}
                  style={{ padding: '4px 8px', border: '1px solid var(--line-strong)', borderRadius: 'var(--r-pill)', fontSize: 12, fontFamily: 'var(--font-ui)', background: 'var(--paper)', color: 'var(--ink-700)', maxWidth: 160, cursor: 'pointer' }}
                >
                  <option value="">— distribuidor —</option>
                  {distribuidores.map(d => <option key={d.id} value={d.id}>{d.nombre}</option>)}
                </select>
                <button
                  onClick={() => onAsignarYAgregar(item)}
                  disabled={procesando || !selActual}
                  style={{ padding: '4px 12px', background: selActual ? 'var(--ink-900)' : 'var(--paper)', color: selActual ? '#fff' : 'var(--ink-300)', border: `1px solid ${selActual ? 'var(--ink-900)' : 'var(--line)'}`, borderRadius: 'var(--r-pill)', fontSize: 12, fontFamily: 'var(--font-ui)', fontWeight: 600, cursor: selActual ? 'pointer' : 'default', whiteSpace: 'nowrap', lineHeight: 1.4 }}
                >
                  {procesando ? '…' : 'Asignar + Pedir'}
                </button>
              </>
            ) : (
              <button
                onClick={() => onAgregarAPedido(item)}
                disabled={yaEnPedido || procesando}
                title={yaEnPedido ? 'Ya está en la bandeja de pedidos' : `Agregar a bandeja de ${item.distribuidor_nombre}`}
                style={{
                  padding: '4px 12px', borderRadius: 'var(--r-pill)', fontSize: 12, fontFamily: 'var(--font-ui)', fontWeight: 600, whiteSpace: 'nowrap', lineHeight: 1.4, cursor: yaEnPedido ? 'default' : 'pointer',
                  background: yaEnPedido ? 'transparent' : 'transparent',
                  color: yaEnPedido ? 'var(--ink-400)' : 'var(--ink-700)',
                  border: `1px solid ${yaEnPedido ? 'var(--line)' : 'var(--line-strong)'}`,
                }}
              >
                {procesando ? '…' : yaEnPedido ? 'En pedidos' : '+ Pedido'}
              </button>
            )}
          </div>

          {confirmacion && (
            <span style={{ fontSize: 11, color: 'var(--ok-ink)', fontFamily: 'var(--font-ui)', fontWeight: 500 }}>
              ✓ Agregado a {confirmacion}
            </span>
          )}
        </div>
      </td>
    </tr>
  );
}

// FilaReposicionMobile — versión compacta expandible para pantallas pequeñas
function FilaReposicionMobile({
  item, mostrarDistDropdown,
  distribuidores, distSel, setDistSel,
  enviando, confirmados, repPendiente,
  onRepuesto, onAgregarAPedido, onAsignarYAgregar,
  expandido, onToggle,
}) {
  const yaEnPedido   = item.en_pedido;
  const procesando   = !!enviando[item.libro_id];
  const confirmacion = confirmados[item.libro_id];
  const selActual    = distSel[item.libro_id] || '';
  const sinStock     = item.stock_actual <= 0;
  const pendiente    = !!repPendiente[item.id];
  const tone         = TONE_STYLES[itemTone(item.libro_id)] || TONE_STYLES['peach'];

  return (
    <div style={{ borderBottom: '1px solid var(--line-soft)' }}>
      {/* Fila compacta — siempre visible */}
      <button
        onClick={onToggle}
        style={{ width: '100%', background: 'none', border: 'none', padding: '10px 12px', display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', textAlign: 'left' }}
      >
        <span style={{ width: 28, height: 28, borderRadius: '50%', background: tone.bg, color: tone.ink, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
          <BookOpen size={12} strokeWidth={1.75} />
        </span>
        <span style={{ flex: 1, minWidth: 0 }}>
          <span style={{ display: 'block', fontFamily: 'var(--font-display)', fontWeight: 600, fontSize: 13, lineHeight: 1.25, color: 'var(--ink-900)', letterSpacing: '-0.01em', overflowWrap: 'anywhere' }}>{item.titulo}</span>
          <span style={{ display: 'block', marginTop: 2, fontSize: 11.5, lineHeight: 1.3, color: 'var(--ink-500)', fontFamily: 'var(--font-ui)', overflowWrap: 'anywhere' }}>{item.autor || '—'}</span>
          {item.editorial && <span style={{ display: 'block', fontSize: 11.5, lineHeight: 1.3, color: 'var(--ink-700)', fontFamily: 'var(--font-ui)', overflowWrap: 'anywhere' }}>{item.editorial}</span>}
          {(item.isbn || item.codigo_relea) && <span style={{ display: 'block', marginTop: 1, fontFamily: 'var(--font-mono)', fontSize: 10.5, color: 'var(--ink-400)' }}>{item.isbn || item.codigo_relea}</span>}
        </span>
        <span style={{ padding: '1px 7px', borderRadius: 'var(--r-pill)', background: sinStock ? 'var(--bad-bg)' : 'var(--ok-bg)', color: sinStock ? 'var(--bad-ink)' : 'var(--ok-ink)', fontSize: 10, fontWeight: 700, flexShrink: 0, fontFamily: 'var(--font-ui)' }}>
          {item.stock_actual}
        </span>
        <span style={{ fontSize: 12, fontWeight: 700, color: 'var(--ink-700)', fontFamily: 'var(--font-ui)', flexShrink: 0 }}>×{item.cantidad}</span>
        <span style={{ color: 'var(--ink-300)', fontSize: 16, flexShrink: 0, display: 'inline-block', transition: 'transform var(--t-fast)', transform: expandido ? 'rotate(90deg)' : 'none' }}>›</span>
      </button>

      {/* Contenido expandido */}
      {expandido && (
        <div style={{ padding: '0 12px 12px 48px' }}>
          {item.distribuidor_nombre && (
            <div style={{ fontSize: 11.5, color: 'var(--ink-500)', fontFamily: 'var(--font-ui)', marginBottom: 8 }}>{item.distribuidor_nombre}</div>
          )}
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
            <span style={{ padding: '2px 9px', borderRadius: 'var(--r-pill)', background: sinStock ? 'var(--bad-bg)' : 'var(--ok-bg)', color: sinStock ? 'var(--bad-ink)' : 'var(--ok-ink)', fontSize: 11, fontWeight: 600, fontFamily: 'var(--font-ui)' }}>
              {sinStock ? 'Sin stock' : `Stock: ${item.stock_actual}`}
            </span>
            <span style={{ fontSize: 12, color: 'var(--ink-500)', fontFamily: 'var(--font-ui)' }}>
              ×<strong style={{ color: 'var(--ink-900)', fontFamily: 'var(--font-display)' }}>{item.cantidad}</strong> vendidos
            </span>
          </div>
          {mostrarDistDropdown ? (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 7 }}>
              <select
                value={selActual}
                onChange={e => setDistSel(prev => ({ ...prev, [item.libro_id]: e.target.value }))}
                style={{ padding: '8px 10px', border: '1px solid var(--line-strong)', borderRadius: 'var(--r-md)', fontSize: 13, fontFamily: 'var(--font-ui)', background: 'var(--paper)', color: 'var(--ink-700)', width: '100%' }}
              >
                <option value="">— Elegir distribuidor —</option>
                {distribuidores.map(d => <option key={d.id} value={d.id}>{d.nombre}</option>)}
              </select>
              <button
                onClick={() => onAsignarYAgregar(item)}
                disabled={procesando || !selActual}
                style={{ padding: '9px', background: selActual ? 'var(--ink-900)' : 'var(--canvas-deep)', color: selActual ? '#fff' : 'var(--ink-300)', border: 'none', borderRadius: 'var(--r-md)', fontSize: 13, fontFamily: 'var(--font-ui)', fontWeight: 600, cursor: selActual ? 'pointer' : 'default', width: '100%' }}
              >
                {procesando ? '…' : 'Asignar + Pedir'}
              </button>
              <button
                onClick={() => onRepuesto(item.id)}
                style={{ padding: '8px', border: 'none', borderRadius: 'var(--r-md)', fontSize: 13, fontFamily: 'var(--font-ui)', fontWeight: 600, cursor: 'pointer', width: '100%', transition: 'all var(--t-fast)',
                  background: pendiente ? 'var(--brand)'   : 'var(--canvas-deep)',
                  color:      pendiente ? '#fff'            : 'var(--ink-600)',
                }}
              >
                {pendiente ? '¿Confirmar?' : 'Repuesto ✓'}
              </button>
            </div>
          ) : (
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 7 }}>
              <button
                onClick={() => onAgregarAPedido(item)}
                disabled={yaEnPedido || procesando}
                style={{ padding: '9px', background: yaEnPedido ? 'var(--canvas-deep)' : 'var(--ink-900)', color: yaEnPedido ? 'var(--ink-400)' : '#fff', border: 'none', borderRadius: 'var(--r-md)', fontSize: 13, fontFamily: 'var(--font-ui)', fontWeight: 600, cursor: yaEnPedido ? 'default' : 'pointer' }}
              >
                {procesando ? '…' : yaEnPedido ? 'En pedidos' : '+ Pedido'}
              </button>
              <button
                onClick={() => onRepuesto(item.id)}
                style={{ padding: '9px', border: 'none', borderRadius: 'var(--r-md)', fontSize: 13, fontFamily: 'var(--font-ui)', fontWeight: 600, cursor: 'pointer', transition: 'all var(--t-fast)',
                  background: pendiente ? 'var(--brand-strong)' : 'var(--brand)',
                  color: '#fff',
                }}
              >
                {pendiente ? '¿Confirmar?' : 'Repuesto'}
              </button>
            </div>
          )}
          {confirmacion && (
            <div style={{ marginTop: 7, fontSize: 11, color: 'var(--ok-ink)', fontFamily: 'var(--font-ui)', fontWeight: 500 }}>
              ✓ Agregado a {confirmacion}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

// ── Orden de Reposición: por última venta (lo más reciente primero, agrupado por día) o A–Z ──
const REPOSICION_ORDEN_KEY = 'relea_reposicion_orden';

function diaLocalReposicion(iso) {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

function etiquetaDiaReposicion(dia) {
  if (!dia) return 'Sin fecha de venta';
  const hoy = new Date();
  const ayer = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate() - 1);
  const f = d => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  if (dia === f(hoy)) return 'Hoy';
  if (dia === f(ayer)) return 'Ayer';
  const d = new Date(`${dia}T12:00:00`);
  const txt = d.toLocaleDateString('es-CL', { weekday: 'short', day: 'numeric', month: 'short' }).replace(/[.,]/g, '');
  const t = txt.charAt(0).toUpperCase() + txt.slice(1);
  return d.getFullYear() === hoy.getFullYear() ? t : `${t} ${d.getFullYear()}`;
}

// Devuelve [{ clave, etiqueta, items }]. En 'venta' hay un grupo por día; en 'az' un solo grupo sin etiqueta.
function agruparReposicion(items, orden) {
  if (orden === 'az') {
    return [{ clave: 'az', etiqueta: null, items: [...items].sort((a, b) => String(a.titulo).localeCompare(String(b.titulo), 'es')) }];
  }
  const ordenados = [...items].sort((a, b) => {
    const ta = a.ultima_venta ? new Date(a.ultima_venta).getTime() : -Infinity;
    const tb = b.ultima_venta ? new Date(b.ultima_venta).getTime() : -Infinity;
    return tb - ta || String(a.titulo).localeCompare(String(b.titulo), 'es');
  });
  const grupos = [];
  for (const it of ordenados) {
    const dia = it.ultima_venta ? diaLocalReposicion(it.ultima_venta) : null;
    const g = grupos[grupos.length - 1];
    if (g && g.clave === (dia || 'sin-fecha')) g.items.push(it);
    else grupos.push({ clave: dia || 'sin-fecha', etiqueta: etiquetaDiaReposicion(dia), items: [it] });
  }
  return grupos;
}

// Banda con el día: fila de tabla en escritorio (colSpan) o bloque en celular
function BandaDiaReposicion({ etiqueta, colSpan }) {
  const estilo = { padding: '6px 14px', background: 'var(--paper-stripe)', fontSize: 12, fontWeight: 600, color: 'var(--ink-600)', fontFamily: 'var(--font-ui)', borderBottom: '1px solid var(--line-soft)' };
  if (colSpan) return <tr><td colSpan={colSpan} style={estilo}>{etiqueta}</td></tr>;
  return <div style={{ ...estilo, padding: '5px 12px' }}>{etiqueta}</div>;
}

// Encabezado de tabla — también fuera del render para evitar re-creación de elemento JSX
function EncabezadoReposicion() {
  const thSt = { padding: '9px 12px', fontSize: 11, fontWeight: 600, color: 'var(--ink-500)', fontFamily: 'var(--font-ui)', textTransform: 'uppercase', letterSpacing: '0.06em', whiteSpace: 'nowrap' };
  return (
    <tr style={{ textAlign: 'left', borderBottom: `1px solid var(--line)`, background: 'var(--paper-stripe)' }}>
      <th style={{ width: 52, padding: '9px 0 9px 14px' }} />
      <th style={thSt}>Título</th>
      <th style={{ ...thSt, textAlign: 'right' }}>Stock</th>
      <th style={{ ...thSt, textAlign: 'right' }}>Vendidos</th>
      <th style={{ padding: '9px 12px' }}></th>
    </tr>
  );
}

function Reposicion() {
  const [items,          setItems]          = useState([]);
  const [distribuidores, setDistribuidores] = useState([]);
  // confirmados: { [libro_id]: 'Nombre Distribuidor' } — feedback inline 3 seg
  const [confirmados,    setConfirmados]    = useState({});
  // enviando: { [libro_id]: true } — spinner mientras procesa
  const [enviando,       setEnviando]       = useState({});
  // distSel: { [libro_id]: uuid } — distribuidor seleccionado en el dropdown inline
  const [distSel,        setDistSel]        = useState({});
  // sinDistAbierto — sección colapsable "Sin distribuidor asignado"
  const [sinDistAbierto, setSinDistAbierto] = useState(false);
  // ficha lateral del libro
  const [fichaLibro,    setFichaLibro]    = useState(null);
  const [fichaAbierta,  setFichaAbierta]  = useState(false);
  const esMobile = useMobile();
  const [expandidoId,   setExpandidoId]   = useState(null);
  const [orden, setOrden] = useState(() => { try { return localStorage.getItem(REPOSICION_ORDEN_KEY) === 'az' ? 'az' : 'venta'; } catch { return 'venta'; } });
  const cambiarOrden = o => { setOrden(o); try { localStorage.setItem(REPOSICION_ORDEN_KEY, o); } catch {} };
  const [repPendiente,  setRepPendiente]  = useState({});
  const repTimers = useRef({});

  useEffect(() => {
    cargarTodo();
    // Si llegamos desde la notificación del catálogo, auto-expandir la sección
    if (sessionStorage.getItem('reposicion_abrir_sin_dist')) {
      sessionStorage.removeItem('reposicion_abrir_sin_dist');
      setSinDistAbierto(true);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  async function cargarTodo() {
    try {
      const [repRes, distRes] = await Promise.all([
        api.get('/reposicion'),
        api.get('/distribuidores'),
      ]);
      setItems(repRes.data);
      setDistribuidores(distRes.data);
    } catch (e) {
      console.error('Error al cargar reposición:', e.message);
    }
  }

  // ── Repuesto ✓ — doble tap ───────────────────────────────────────────────
  async function marcarRepuesto(id) {
    await api.delete(`/reposicion/${id}`);
    await cargarTodo();
  }

  function onRepuestoTap(id) {
    if (repPendiente[id]) {
      clearTimeout(repTimers.current[id]);
      delete repTimers.current[id];
      setRepPendiente(prev => { const n = { ...prev }; delete n[id]; return n; });
      marcarRepuesto(id);
    } else {
      setRepPendiente(prev => ({ ...prev, [id]: true }));
      repTimers.current[id] = setTimeout(() => {
        setRepPendiente(prev => { const n = { ...prev }; delete n[id]; return n; });
        delete repTimers.current[id];
      }, 3000);
    }
  }

  // ── Feedback inline positivo ────────────────────────────────────────────
  function mostrarConfirmacion(libro_id, distNombre) {
    setConfirmados(prev => ({ ...prev, [libro_id]: distNombre }));
    setTimeout(() => {
      setConfirmados(prev => { const n = { ...prev }; delete n[libro_id]; return n; });
    }, 3000);
  }

  // ── + Pedido (libro CON distribuidor ya asignado) ────────────────────────
  async function agregarAPedido(item) {
    if (item.en_pedido) return;
    setEnviando(prev => ({ ...prev, [item.libro_id]: true }));
    try {
      await api.post('/pedido-marcado', {
        libro_id:         item.libro_id,
        distribuidor_id:  item.distribuidor_id,
        desde_reposicion: true,
        cantidad:         item.cantidad,
      });
      setItems(prev => prev.map(i =>
        i.libro_id === item.libro_id ? { ...i, en_pedido: true } : i
      ));
      mostrarConfirmacion(item.libro_id, item.distribuidor_nombre);
    } catch (e) {
      alert('Error al agregar a pedido: ' + (e.response?.data?.error || e.message));
    }
    setEnviando(prev => { const n = { ...prev }; delete n[item.libro_id]; return n; });
  }

  // ── Asignar distribuidor + agregar a bandeja (libro SIN distribuidor) ────
  async function asignarYAgregar(item) {
    const distribuidorId = distSel[item.libro_id];
    if (!distribuidorId) return alert('Seleccioná un distribuidor primero');
    setEnviando(prev => ({ ...prev, [item.libro_id]: true }));
    try {
      // 1. Persistir en el lote permanentemente
      await api.patch(`/lotes/libro/${item.libro_id}/distribuidor`, { distribuidor_id: distribuidorId });
      // 2. Agregar a la bandeja de pedidos
      await api.post('/pedido-marcado', {
        libro_id:         item.libro_id,
        distribuidor_id:  distribuidorId,
        desde_reposicion: true,
        cantidad:         item.cantidad,
      });
      // 3. Actualizar el item localmente: ahora tiene distribuidor + en_pedido
      const dist = distribuidores.find(d => d.id === distribuidorId);
      setItems(prev => prev.map(i =>
        i.libro_id === item.libro_id
          ? { ...i, distribuidor_id: distribuidorId, distribuidor_nombre: dist?.nombre, en_pedido: true }
          : i
      ));
      mostrarConfirmacion(item.libro_id, dist?.nombre || 'distribuidor');
    } catch (e) {
      alert('Error al asignar distribuidor: ' + (e.response?.data?.error || e.message));
    }
    setEnviando(prev => { const n = { ...prev }; delete n[item.libro_id]; return n; });
  }

  function abrirFicha(libro) {
    setFichaLibro(libro);
    requestAnimationFrame(() => setFichaAbierta(true));
  }
  function cerrarFicha() {
    setFichaAbierta(false);
    setTimeout(() => setFichaLibro(null), 310);
  }

  // ── Separar items ────────────────────────────────────────────────────────
  const conDistribuidor = items.filter(i => !!i.distribuidor_id);
  const sinDistribuidor = items.filter(i => !i.distribuidor_id);

  // Props comunes que FilaReposicion necesita (estables entre renders)
  const filaProps = { distribuidores, distSel, setDistSel, enviando, confirmados, repPendiente,
    onRepuesto: onRepuestoTap, onAgregarAPedido: agregarAPedido, onAsignarYAgregar: asignarYAgregar,
    onAbrirFicha: abrirFicha };

  const gruposCon = agruparReposicion(conDistribuidor, orden);
  const gruposSin = agruparReposicion(sinDistribuidor, orden);

  const totalPendientes    = items.length;
  const sinStockCount      = items.filter(i => i.stock_actual <= 0).length;
  const totalUnidades      = items.reduce((s, i) => s + (i.cantidad || 0), 0);

  return (
    <div style={{ background: 'var(--canvas)', minHeight: '100%', padding: 'var(--content-inset)' }}>
      {/* ── Card principal ── */}
      <div style={{ background: 'var(--paper)', border: '1px solid var(--line)', borderRadius: 20, boxShadow: 'var(--shadow-card)', overflow: 'hidden', height: esMobile ? 'auto' : 'calc(100vh - 32px)', display: 'flex', flexDirection: 'column' }}>

        {/* Header */}
        <div style={{ padding: esMobile ? '12px 14px 10px' : '18px 24px 14px', borderBottom: '1px solid var(--line-soft)', flexShrink: 0 }}>
          <div style={{ display: 'flex', alignItems: 'baseline', gap: 10 }}>
            <h2 style={{ margin: 0, fontFamily: 'var(--font-display)', fontSize: 20, fontWeight: 700, color: 'var(--ink-900)', letterSpacing: '-0.015em' }}>Reposición</h2>
            {totalPendientes > 0 && (
              <span style={{ background: 'var(--brand-soft)', color: 'var(--brand)', fontSize: 12, fontWeight: 600, padding: '2px 10px', borderRadius: 'var(--r-pill)', fontFamily: 'var(--font-ui)' }}>
                {totalPendientes}
              </span>
            )}
          </div>
          <p style={{ margin: '4px 0 0', color: 'var(--ink-500)', fontSize: 13, fontFamily: 'var(--font-ui)', maxWidth: 560 }}>
            Libros vendidos que necesitan reponerse. Usá <strong style={{ color: 'var(--ink-700)' }}>+ Pedido</strong> para enviarlos
            a la bandeja del distribuidor correspondiente.
          </p>
          <div role="group" aria-label="Orden de la lista" style={{ display: 'inline-flex', gap: 2, marginTop: 10, padding: 3, background: 'var(--paper-stripe)', border: '1px solid var(--line-soft)', borderRadius: 'var(--r-pill)' }}>
            {[{ id: 'venta', label: 'Última venta' }, { id: 'az', label: 'A–Z' }].map(o => (
              <button key={o.id} type="button" onClick={() => cambiarOrden(o.id)} aria-pressed={orden === o.id}
                style={{ padding: '4px 14px', borderRadius: 'var(--r-pill)', border: orden === o.id ? '1px solid var(--line)' : '1px solid transparent', background: orden === o.id ? 'var(--paper)' : 'transparent', color: orden === o.id ? 'var(--ink-900)' : 'var(--ink-500)', fontSize: 12, fontWeight: orden === o.id ? 600 : 500, fontFamily: 'var(--font-ui)', cursor: 'pointer' }}>
                {o.label}
              </button>
            ))}
          </div>
        </div>

        {/* KPI strip */}
        {totalPendientes > 0 && (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 1, borderBottom: '1px solid var(--line-soft)', flexShrink: 0, background: 'var(--line-soft)' }}>
            {[
              { label: 'Pendientes', value: totalPendientes, font: 'var(--font-display)' },
              { label: 'Sin stock', value: sinStockCount, font: 'var(--font-display)', warn: sinStockCount > 0 },
              { label: 'Unidades vendidas', value: totalUnidades, font: 'var(--font-display)' },
            ].map(({ label, value, font, warn }) => (
              <div key={label} style={{ background: 'var(--paper)', padding: esMobile ? '10px 12px' : '14px 20px' }}>
                <div style={{ fontSize: 11, fontWeight: 600, color: 'var(--ink-400)', fontFamily: 'var(--font-ui)', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 4 }}>{label}</div>
                <div style={{ fontFamily: font, fontSize: esMobile ? 22 : 28, fontWeight: 700, color: warn ? 'var(--bad-ink)' : 'var(--ink-900)', letterSpacing: '-0.02em', lineHeight: 1 }}>{value}</div>
              </div>
            ))}
          </div>
        )}

        {/* Body — scrollable en desktop, fluido en mobile */}
        <div style={{ flex: esMobile ? 'none' : 1, height: esMobile ? 'auto' : 0, overflowY: esMobile ? 'visible' : 'auto', padding: esMobile ? '10px 10px' : '20px 24px' }}>
          {items.length === 0 && (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', gap: 12 }}>
              <span style={{ width: 48, height: 48, borderRadius: '50%', background: 'var(--past-mint)', color: 'var(--past-mint-ink)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                <BookOpen size={22} strokeWidth={1.5} />
              </span>
              <p style={{ color: 'var(--ink-400)', fontSize: 14, fontFamily: 'var(--font-ui)', margin: 0, textAlign: 'center' }}>No hay libros pendientes de reposición.</p>
            </div>
          )}

          {/* ── Con distribuidor ── */}
          {conDistribuidor.length > 0 && (
            <>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
                <span style={{ fontSize: 12, fontWeight: 600, color: 'var(--ink-600)', fontFamily: 'var(--font-ui)', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Con distribuidor</span>
                <span style={{ background: 'var(--canvas-deep)', color: 'var(--ink-500)', fontSize: 11, fontWeight: 600, padding: '1px 8px', borderRadius: 'var(--r-pill)', fontFamily: 'var(--font-ui)' }}>{conDistribuidor.length}</span>
              </div>
              {esMobile ? (
                <div style={{ border: '1px solid var(--line)', borderRadius: 12, overflow: 'hidden', marginBottom: 16, background: 'var(--paper)' }}>
                  {gruposCon.map(g => (
                    <React.Fragment key={g.clave}>
                      {g.etiqueta && <BandaDiaReposicion etiqueta={g.etiqueta} />}
                      {g.items.map(item => (
                        <FilaReposicionMobile key={item.id} item={item} mostrarDistDropdown={false} {...filaProps}
                          expandido={expandidoId === item.libro_id}
                          onToggle={() => setExpandidoId(expandidoId === item.libro_id ? null : item.libro_id)}
                        />
                      ))}
                    </React.Fragment>
                  ))}
                </div>
              ) : (
                <div style={{ overflowX: 'auto', marginBottom: 24, border: '1px solid var(--line)', borderRadius: 12 }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead><EncabezadoReposicion /></thead>
                    <tbody>
                      {gruposCon.map(g => (
                        <React.Fragment key={g.clave}>
                          {g.etiqueta && <BandaDiaReposicion etiqueta={g.etiqueta} colSpan={5} />}
                          {g.items.map(item => (
                            <FilaReposicion key={item.id} item={item} mostrarDistDropdown={false} {...filaProps} />
                          ))}
                        </React.Fragment>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </>
          )}

          {/* ── Sección colapsable: libros SIN distribuidor ── */}
          {sinDistribuidor.length > 0 && (
            <div>
              <button
                onClick={() => setSinDistAbierto(v => !v)}
                style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '6px 0', display: 'flex', alignItems: 'center', gap: 8, fontFamily: 'var(--font-ui)', fontSize: 13, color: 'var(--bad-ink)', fontWeight: 700 }}
              >
                <span style={{ width: 28, height: 28, borderRadius: '50%', background: 'var(--past-rose)', color: 'var(--past-rose-ink)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  <ChevronRight size={13} strokeWidth={2.5} style={{ transform: sinDistAbierto ? 'rotate(90deg)' : 'none', transition: 'transform var(--t-fast)' }} />
                </span>
                <span style={{ fontFamily: 'var(--font-display)', fontSize: 14, letterSpacing: '-0.01em' }}>Sin distribuidor asignado</span>
                <span style={{ background: 'var(--bad-bg)', color: 'var(--bad-ink)', fontSize: 11, fontWeight: 600, padding: '2px 8px', borderRadius: 'var(--r-pill)' }}>{sinDistribuidor.length}</span>
              </button>

              {sinDistAbierto && (
                esMobile ? (
                  <div style={{ marginTop: 8, border: '1px solid var(--bad-line)', borderRadius: 12, overflow: 'hidden', background: 'var(--paper)' }}>
                    {gruposSin.map(g => (
                      <React.Fragment key={g.clave}>
                        {g.etiqueta && <BandaDiaReposicion etiqueta={g.etiqueta} />}
                        {g.items.map(item => (
                          <FilaReposicionMobile key={item.id} item={item} mostrarDistDropdown={true} {...filaProps}
                            expandido={expandidoId === item.libro_id}
                            onToggle={() => setExpandidoId(expandidoId === item.libro_id ? null : item.libro_id)}
                          />
                        ))}
                      </React.Fragment>
                    ))}
                  </div>
                ) : (
                  <div style={{ overflowX: 'auto', marginTop: 8, border: '1px solid var(--bad-line)', borderRadius: 12, background: 'var(--bad-bg)' }}>
                    <div style={{ background: 'var(--paper)', borderRadius: 10, overflow: 'hidden', margin: 1 }}>
                      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead><EncabezadoReposicion /></thead>
                        <tbody>
                          {gruposSin.map(g => (
                            <React.Fragment key={g.clave}>
                              {g.etiqueta && <BandaDiaReposicion etiqueta={g.etiqueta} colSpan={5} />}
                              {g.items.map(item => (
                                <FilaReposicion key={item.id} item={item} mostrarDistDropdown={true} {...filaProps} />
                              ))}
                            </React.Fragment>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )
              )}
            </div>
          )}
        </div>
      </div>

      {/* Ficha lateral del libro — reutiliza el mismo panel que Inventario */}
      {fichaLibro && (
        <InvFichaLibro
          libro={fichaLibro}
          abierto={fichaAbierta}
          onClose={cerrarFicha}
          onLibroActualizado={() => {}}
        />
      )}
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════
// MÓDULO INVENTARIO — reemplaza Libros + Lotes
// ═══════════════════════════════════════════════════════════════════════════

const INV_COLS_KEY     = 'relea_inv_cols_v2';
const INV_PERIODOS_KEY = 'relea_inv_periodos';

const COLUMNAS_DEF = [
  { id: 'isbn',               label: 'ISBN',             defaultOn: true  },
  { id: 'titulo',             label: 'Título',           defaultOn: true  },
  { id: 'autor',              label: 'Autor',            defaultOn: true  },
  { id: 'editorial',          label: 'Editorial',        defaultOn: true  },
  { id: 'distribuidor',       label: 'Distribuidor',     defaultOn: true  },
  { id: 'categoria',          label: 'Categoría',        defaultOn: true  },
  { id: 'costo',              label: 'Precio Costo',     defaultOn: true  },
  { id: 'pvp',                label: 'PVP',              defaultOn: true  },
  { id: 'precio_neto',        label: 'Precio Neto',      defaultOn: true  },
  { id: 'stock_total',        label: 'Stock',            defaultOn: true  },
  { id: 'modalidad',          label: 'Modalidad',        defaultOn: true  },
  { id: 'stock_consignacion', label: 'Stock consig.',    defaultOn: true  },
  { id: 'stock_firme',        label: 'Stock firme',      defaultOn: true  },
];

function invColsDefault() { return COLUMNAS_DEF.filter(c => c.defaultOn).map(c => c.id); }
function invLeerCols()     { try { const r = localStorage.getItem(INV_COLS_KEY);     if (r) return JSON.parse(r); } catch {} return invColsDefault(); }
function invLeerPeriodos() { try { const r = localStorage.getItem(INV_PERIODOS_KEY); if (r) return JSON.parse(r); } catch {} return []; }
function invGuardarCols(c)  { localStorage.setItem(INV_COLS_KEY,     JSON.stringify(c)); }
function invGuardarPer(p)   { localStorage.setItem(INV_PERIODOS_KEY, JSON.stringify(p)); }

function invFmt(n)  { return n != null ? `$${Number(n).toLocaleString('es-CL', { maximumFractionDigits: 0 })}` : '—'; }
function invFecha(iso) { if (!iso) return '—'; const d = new Date(iso); return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`; }

// Devuelve el valor primitivo ordenable de un libro para una columna dada
function invSortVal(colId, l) {
  switch (colId) {
    case 'isbn':               return l.isbn || null;
    case 'titulo':             return l.titulo || null;
    case 'autor':              return l.autor || null;
    case 'editorial':          return l.editorial || null;
    case 'categoria':          return l.categoria || null;
    case 'pvp':                return l.pvp != null ? Number(l.pvp) : null;
    case 'costo':              return l.costo != null ? Number(l.costo) : null;
    case 'stock_total':        return l.stock_total ?? null;
    case 'stock_firme':        return l.stock_firme ?? null;
    case 'stock_consignacion': return l.stock_consignacion ?? null;
    case 'distribuidor':       return l.distribuidores || null;
    case 'modalidad':          return l.modalidades || null;
    case 'fecha_ultima_venta': return l.fecha_ultima_venta || null;
    case 'fecha_ingreso':      return l.fecha_ingreso || null;
    case 'en_ultimo_pedido':   return l.en_ultimo_pedido ? 1 : 0;
    case 'etiquetas':          return (l.etiquetas || []).length;
    case 'estado':             return l.activo ? 1 : 0;
    case 'devuelto':           return l.devuelto ?? 0;
    default:
      if (colId.startsWith('ventas_')) return l[colId] ?? 0;
      return null;
  }
}

// Devuelve los valores de un libro para un colId como array de strings (para filtrado)
function colMatchValues(colId, l) {
  switch (colId) {
    case 'distribuidor':     return Array.isArray(l.distribuidor_ids) ? l.distribuidor_ids : [];
    case 'modalidad':        return (l.modalidades || '').split(', ').map(s => s.replace(/^-?\d+ /, '')).filter(Boolean);
    case 'etiquetas':        return (l.etiquetas || []).map(e => e.nombre);
    case 'en_ultimo_pedido': return [l.en_ultimo_pedido ? 'si' : 'no'];
    case 'estado':           return [l.activo ? 'true' : 'false'];
    case 'isbn':             return l.isbn     != null ? [String(l.isbn)]     : [];
    case 'titulo':           return l.titulo   != null ? [String(l.titulo)]   : [];
    case 'autor':            return l.autor    != null ? [String(l.autor)]    : [];
    case 'editorial':        return l.editorial != null ? [String(l.editorial)] : [];
    case 'categoria':        return l.categoria != null ? [String(l.categoria)] : [];
    case 'pvp':              return l.pvp   != null ? [String(Number(l.pvp))]   : [];
    case 'costo':            return l.costo != null ? [String(Number(l.costo))] : [];
    case 'stock_total':        return [String(l.stock_total ?? '')];
    case 'stock_firme':        return [String(l.stock_firme ?? '')];
    case 'stock_consignacion': return [String(l.stock_consignacion ?? '')];
    case 'devuelto':           return [String(l.devuelto ?? 0)];
    case 'fecha_ultima_venta': return l.fecha_ultima_venta ? [l.fecha_ultima_venta] : [];
    case 'fecha_ingreso':      return l.fecha_ingreso      ? [l.fecha_ingreso]      : [];
    default:
      if (colId.startsWith('ventas_')) return [String(l[colId] ?? '')];
      return [];
  }
}

// --- InvVentasPanel --- stats + tendencia + tabla mensual + historial de ingresos ---
function InvVentasPanel({ detalle, libro, onDocSaved }) {
  const ventas_meses = detalle?.ventas_meses || [];
  const lotes        = detalle?.lotes        || [];
  const [editDoc, setEditDoc] = React.useState(null); // { id, tipo_doc, num_doc } | null
  const [savingDoc, setSavingDoc] = React.useState(false);

  const unidadesAll  = ventas_meses.reduce((s, m) => s + Number(m.unidades || 0), 0);
  const stockTotal   = libro?.stock_total        ?? 0;
  const stockConsig  = libro?.stock_consignacion  ?? 0;
  const stockFirme   = libro?.stock_firme         ?? 0;
  const devoluciones = libro?.devuelto            ?? 0;

  const ahora = new Date();

  const ultimoLote = lotes.length
    ? [...lotes].sort((a, b) => new Date(b.creado_en) - new Date(a.creado_en))[0]
    : null;
  const fechaUltimoIngreso = ultimoLote ? invFecha(ultimoLote.doc_fecha || ultimoLote.creado_en) : 'sin datos';

  const sorted = [...ventas_meses].sort((a, b) => a.mes.localeCompare(b.mes));
  const last3 = sorted.slice(-3).reduce((s, m) => s + Number(m.unidades || 0), 0);
  const prev3 = sorted.slice(-6, -3).reduce((s, m) => s + Number(m.unidades || 0), 0);
  let trend = null;
  if (sorted.length >= 3) {
    if (prev3 === 0 && last3 > 0) {
      trend = { dir: 'up', label: 'Subiendo', suffix: '' };
    } else if (prev3 > 0) {
      const pct = Math.round((last3 - prev3) / prev3 * 100);
      if      (pct >=  10) trend = { dir: 'up',   label: 'Subiendo', suffix: ' +' + pct + '% vs 3m anteriores' };
      else if (pct <= -10) trend = { dir: 'down',  label: 'Bajando',  suffix: ' ' + pct + '% vs 3m anteriores' };
      else                 trend = { dir: 'flat',  label: 'Estable',  suffix: ' ' + (pct > 0 ? '+' : '') + pct + '% vs 3m anteriores' };
    }
  }

  const hace12 = new Date(ahora.getFullYear(), ahora.getMonth() - 11, 1);
  const corte12 = `${hace12.getFullYear()}-${String(hace12.getMonth() + 1).padStart(2,'0')}`;
  const meses12 = [...ventas_meses].filter(m => m.mes >= corte12).sort((a, b) => b.mes.localeCompare(a.mes));

  const MNAMES = ['ene','feb','mar','abr','may','jun','jul','ago','sep','oct','nov','dic'];
  const fmtMes = iso => { const [y, m] = iso.split('-'); return MNAMES[parseInt(m,10)-1] + ' ' + y; };
  const fmt = n => Math.round(n).toLocaleString('es-CL');

  const thS = { padding: '0.3rem 0.45rem', fontSize: '0.72rem', color: 'var(--ink-400)', fontWeight: 500, textAlign: 'left', borderBottom: '1px solid var(--line)', textTransform: 'uppercase', letterSpacing: '0.05em', whiteSpace: 'nowrap' };
  const tdS = { padding: '0.33rem 0.45rem', fontSize: '0.83rem', borderBottom: '1px solid var(--line-soft)', color: 'var(--ink-700)' };

  const trendStyle = {
    up:   { background: 'var(--ok-bg,#eaf6f1)',  color: 'var(--ok-ink,#14633a)' },
    down: { background: '#fef2f2',                color: '#b91c1c'                },
    flat: { background: 'var(--paper-soft)',       color: 'var(--ink-500)'         },
  };

  if (unidadesAll === 0 && lotes.length === 0) {
    return <p style={{ color: '#bbb', fontSize: '0.83rem', margin: 0 }}>Sin ventas ni ingresos registrados</p>;
  }

  return (
    <>
      {/* 6 stats */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '0.4rem', marginBottom: '0.75rem' }}>
        {[['Stock total', stockTotal], ['Consignado', stockConsig], ['Firme', stockFirme],
          ['Ventas totales', unidadesAll], ['Últ. ingreso', fechaUltimoIngreso], ['Devoluciones', devoluciones]
        ].map(([lbl, val]) => (
          <div key={lbl} style={{ background: 'var(--paper-soft)', border: '1px solid var(--line-soft)', borderRadius: 'var(--r-md)', padding: '0.45rem 0.5rem' }}>
            <div style={{ fontSize: '0.61rem', color: 'var(--ink-400)', fontFamily: 'var(--font-ui)', marginBottom: '0.12rem', textTransform: 'uppercase', letterSpacing: '0.05em', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{lbl}</div>
            <div style={{ fontSize: '0.85rem', fontWeight: 700, color: 'var(--ink-900)', fontFamily: 'var(--font-ui)', whiteSpace: 'nowrap' }}>{String(val)}</div>
          </div>
        ))}
      </div>

      {/* Tendencia */}
      {trend && (
        <div style={{ marginBottom: '0.75rem' }}>
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, borderRadius: 20, padding: '4px 10px', fontSize: '0.74rem', fontFamily: 'var(--font-ui)', fontWeight: 600, ...trendStyle[trend.dir] }}>
            {trend.dir === 'up' ? 'Subiendo' : trend.dir === 'down' ? 'Bajando' : 'Estable'}{trend.suffix}
          </span>
        </div>
      )}

      {/* Tabla mensual */}
      {meses12.length > 0 && (
        <div style={{ marginBottom: '1rem' }}>
          <div style={{ fontSize: '0.72rem', color: 'var(--ink-400)', fontFamily: 'var(--font-ui)', fontWeight: 500, marginBottom: '0.4rem' }}>Ventas por mes (12 m)</div>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead><tr>
                <th style={thS}>Mes</th>
                <th style={{ ...thS, textAlign: 'center' }}>Uds</th>
                <th style={{ ...thS, textAlign: 'right' }}>Total</th>
              </tr></thead>
              <tbody>
                {meses12.map(m => (
                  <tr key={m.mes}>
                    <td style={{ ...tdS, color: 'var(--ink-500)', whiteSpace: 'nowrap' }}>{fmtMes(m.mes)}</td>
                    <td style={{ ...tdS, textAlign: 'center', fontWeight: Number(m.unidades) > 0 ? 600 : 400 }}>{m.unidades}</td>
                    <td style={{ ...tdS, textAlign: 'right', fontVariantNumeric: 'tabular-nums' }}>${fmt(m.total)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Historial de ingresos */}
      {lotes.length > 0 && (
        <div>
          <div style={{ fontSize: '0.72rem', color: 'var(--ink-400)', fontFamily: 'var(--font-ui)', fontWeight: 500, marginBottom: '0.4rem' }}>Historial de ingresos</div>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead><tr>
                <th style={thS}>Fecha</th>
                <th style={thS}>Distribuidor</th>
                <th style={thS}>Documento</th>
                <th style={{ ...thS, textAlign: 'right' }}>Stock</th>
              </tr></thead>
              <tbody>
                {[...lotes].sort((a, b) => new Date(b.creado_en) - new Date(a.creado_en)).map(lo => (
                  <tr key={lo.id}>
                    <td style={{ ...tdS, whiteSpace: 'nowrap', color: 'var(--ink-500)', fontSize: '0.79rem' }}>{invFecha(lo.doc_fecha || lo.creado_en)}</td>
                    <td style={tdS}>{lo.distribuidor}</td>
                    <td style={{ ...tdS, fontSize: '0.79rem' }}>
                      {lo.doc_id ? (
                        <span style={{ color: 'var(--ink-700)' }}>
                          {(lo.doc_tipo === 'gdd' ? 'GDD' : 'Factura') + ' ' + lo.doc_numero}
                        </span>
                      ) : editDoc?.id === lo.id ? (
                        <span style={{ display: 'inline-flex', gap: 4, alignItems: 'center' }}>
                          <select value={editDoc.tipo_doc}
                            onChange={e => setEditDoc(p => ({ ...p, tipo_doc: e.target.value }))}
                            style={{ padding: '2px 4px', fontSize: '0.77rem', border: '1px solid var(--line)', borderRadius: 4 }}>
                            <option value="">Tipo</option>
                            <option value="GDD">GDD</option>
                            <option value="Factura">Factura</option>
                            <option value="Otro">Otro</option>
                          </select>
                          <input value={editDoc.num_doc}
                            onChange={e => setEditDoc(p => ({ ...p, num_doc: e.target.value }))}
                            placeholder="Nro."
                            style={{ width: 70, padding: '2px 5px', fontSize: '0.77rem', border: '1px solid var(--line)', borderRadius: 4 }} />
                          <button disabled={savingDoc}
                            onClick={async () => {
                              setSavingDoc(true);
                              try { await onDocSaved(lo.id, editDoc.tipo_doc, editDoc.num_doc); setEditDoc(null); }
                              finally { setSavingDoc(false); }
                            }}
                            style={{ padding: '2px 8px', fontSize: '0.74rem', fontWeight: 600, background: 'var(--accent)', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer' }}>
                            {savingDoc ? '…' : 'OK'}
                          </button>
                          <button onClick={() => setEditDoc(null)}
                            style={{ padding: '2px 6px', fontSize: '0.74rem', background: 'none', border: '1px solid var(--line)', borderRadius: 4, cursor: 'pointer', color: 'var(--ink-400)' }}>
                            ✕
                          </button>
                        </span>
                      ) : (
                        <span
                          onClick={() => setEditDoc({ id: lo.id, tipo_doc: lo.tipo_doc || '', num_doc: lo.num_doc || '' })}
                          title="Clic para editar"
                          style={{ color: (lo.tipo_doc || lo.num_doc) ? 'var(--ink-700)' : 'var(--ink-300)', cursor: 'pointer', textDecoration: 'underline dotted' }}>
                          {(lo.tipo_doc || lo.num_doc)
                            ? [lo.tipo_doc, lo.num_doc].filter(Boolean).join(' ')
                            : 'sin doc.'}
                        </span>
                      )}
                    </td>
                    <td style={{ ...tdS, textAlign: 'right', fontWeight: 600 }}>{lo.stock}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </>
  );
}

// --- InvColumnasPicker ---
function InvColumnasPicker({ colsActivas, setColsActivas, periodos, setPeriodos, onClose }) {
  const [nuevoPer, setNuevoPer] = useState('');

  function toggleCol(id) {
    setColsActivas(prev => {
      const next = prev.includes(id) ? prev.filter(c => c !== id) : [...prev, id];
      invGuardarCols(next); return next;
    });
  }
  function agregarPer() {
    const n = parseInt(nuevoPer, 10);
    if (!n || n < 1 || n > 999) return;
    const next = [...new Set([...periodos, n])].sort((a, b) => a - b);
    setPeriodos(next); invGuardarPer(next); setNuevoPer('');
  }
  function quitarPer(d) {
    const next = periodos.filter(p => p !== d);
    setPeriodos(next); invGuardarPer(next);
  }

  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 400, display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-end' }}>
      <div onClick={onClose} style={{ position: 'absolute', inset: 0, background: 'var(--scrim)' }} />
      <div style={{ position: 'relative', background: 'var(--paper)', width: 300, height: '100vh', overflowY: 'auto', padding: '1.5rem 1.25rem', boxShadow: 'var(--shadow-pop)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
          <h3 style={{ margin: 0, fontSize: '1rem', fontFamily: 'var(--font-display)', fontWeight: 700, color: 'var(--ink-900)' }}>Personalizar columnas</h3>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: '1.4rem', cursor: 'pointer', color: 'var(--ink-300)', lineHeight: 1 }}>×</button>
        </div>
        <p style={{ margin: '0 0 1rem', fontSize: '0.8rem', color: 'var(--ink-400)', fontFamily: 'var(--font-ui)' }}>La configuración se guarda automáticamente.</p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.05rem', marginBottom: '1.5rem' }}>
          {COLUMNAS_DEF.map(col => (
            <label key={col.id} style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', padding: '0.4rem 0.5rem', cursor: 'pointer', borderRadius: 'var(--r-md)', background: colsActivas.includes(col.id) ? 'var(--brand-softer)' : 'transparent' }}>
              <input type="checkbox" checked={colsActivas.includes(col.id)} onChange={() => toggleCol(col.id)} style={{ accentColor: 'var(--brand)' }} />
              <span style={{ fontSize: '0.88rem', fontFamily: 'var(--font-ui)', color: 'var(--ink-700)' }}>{col.label}</span>
            </label>
          ))}
        </div>
        <button onClick={() => { const d = invColsDefault(); setColsActivas(d); invGuardarCols(d); }}
          style={{ marginTop: '1.5rem', width: '100%', background: 'none', border: '1px solid var(--line)', color: 'var(--ink-600)', padding: '0.4rem', borderRadius: 'var(--r-pill)', cursor: 'pointer', fontSize: '0.82rem', fontFamily: 'var(--font-ui)' }}>
          Restaurar por defecto
        </button>
      </div>
    </div>
  );
}

// --- InvFichaLibro — panel lateral deslizante ---
function InvFichaLibro({ libro, abierto, onClose, onLibroActualizado }) {
  const [detalle,         setDetalle]         = useState(null);
  const [cargando,        setCargando]        = useState(true);
  const [portadaUrl,      setPortadaUrl]      = useState(null);
  const [descripcionOL,   setDescripcionOL]   = useState('');
  const [editando,          setEditando]          = useState(false);
  const [formLibro,         setFormLibro]         = useState({});
  const [libroLocal,        setLibroLocal]        = useState({});
  const [guardando,         setGuardando]         = useState(false);
  const [libroMsg,          setLibroMsg]          = useState(null);
  const [propuestaPendiente, setPropuestaPendiente] = useState(null);
  const [inputEt,         setInputEt]         = useState('');
  const [etSistema,       setEtSistema]       = useState([]);
  const [etMsg,           setEtMsg]           = useState(null);

  // Edición de lote
  const [editLoteId,    setEditLoteId]    = useState(null);
  const [editForm,      setEditForm]      = useState({});
  const [editOrig,      setEditOrig]      = useState({});
  const [precioDialog,  setPrecioDialog]  = useState(null); // null | { trigger:'pvp'|'costo', pct:string }
  const [guardandoLote,   setGuardandoLote]   = useState(false);
  const [loteMsg,         setLoteMsg]         = useState(null); // { tipo:'ok'|'err', texto }
  // Bajar stock de un lote en consignación: qué pasó (ver backend/lib/bajas.js) y bajas ya registradas del libro
  const [bajaTipo,      setBajaTipo]      = useState('perdida');
  const [bajaDetalle,   setBajaDetalle]   = useState('');
  const [bajas,         setBajas]         = useState([]);
  const [revirtiendoId, setRevirtiendoId] = useState(null);
  const [distribuidores,  setDistribuidores]  = useState([]);
  const [nuevoDistNombre, setNuevoDistNombre] = useState('');
  const [nuevoDistRut,    setNuevoDistRut]    = useState('');
  const [creandoDist,     setCreandoDist]     = useState(false);

  useEffect(() => {
    api.get('/distribuidores').then(r => setDistribuidores(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    if (!libro) return;
    setDetalle(null); setCargando(true); setEditando(false); setPortadaUrl(null);
    setDescripcionOL(''); setInputEt(''); setPropuestaPendiente(null); setLibroMsg(null);
    setEditLoteId(null); setEditForm({}); setEditOrig({}); setPrecioDialog(null); setLoteMsg(null);
    setFormLibro({ titulo: libro.titulo, autor: libro.autor || '', editorial: libro.editorial || '', categoria: libro.categoria || '', isbn: libro.isbn || '' });
    setLibroLocal({ ...libro });

    api.get('/libros/mis-propuestas').then(r => {
      const prop = (r.data || []).find(p => p.libro_id === libro.id);
      if (prop) setPropuestaPendiente(prop);
    }).catch(() => {});

    api.get(`/inventario/${libro.id}/detalle`).then(r => { setDetalle(r.data); setCargando(false); }).catch(() => setCargando(false));
    setBajas([]); cargarBajas();
    api.get('/etiquetas').then(r => setEtSistema(r.data)).catch(() => {});

    if (libro.isbn) {
      const isbn = libro.isbn.replace(/-/g, '');
      const img  = new Image();
      img.onload = () => { if (img.naturalWidth > 10) setPortadaUrl(`https://covers.openlibrary.org/b/isbn/${isbn}-M.jpg`); };
      img.src = `https://covers.openlibrary.org/b/isbn/${isbn}-M.jpg`;
      fetch(`https://openlibrary.org/isbn/${isbn}.json`, { signal: AbortSignal.timeout(4000) })
        .then(r => r.json()).then(data => {
          const desc = data.description;
          if (desc) setDescripcionOL(typeof desc === 'string' ? desc : (desc.value || ''));
        }).catch(() => {});
    }
  }, [libro?.id]); // eslint-disable-line

  const etiquetasActuales = detalle?.etiquetas ?? (libro?.etiquetas || []);
  const etSugs = inputEt.trim()
    ? etSistema.filter(e => e.nombre.toLowerCase().includes(inputEt.toLowerCase()) && !etiquetasActuales.some(a => a.id === e.id)).slice(0, 5)
    : [];

  async function guardarLibro() {
    setGuardando(true);
    setLibroMsg(null);
    try {
      const body = {};
      if (formLibro.titulo    !== (libroLocal.titulo    || '')) body.titulo    = formLibro.titulo;
      if (formLibro.autor     !== (libroLocal.autor     || '')) body.autor     = formLibro.autor;
      if (formLibro.editorial !== (libroLocal.editorial || '')) body.editorial = formLibro.editorial;
      if (formLibro.categoria !== (libroLocal.categoria || '')) body.categoria = formLibro.categoria;
      if (formLibro.isbn      !== (libroLocal.isbn      || '')) body.isbn      = formLibro.isbn || null;
      if (Object.keys(body).length === 0) { setEditando(false); return; }
      const r = await api.patch(`/libros/${libro.id}`, body);
      const datos = r.data;
      if (datos.propuesta_pendiente) {
        setPropuestaPendiente(datos.propuesta_pendiente);
        setLibroLocal(prev => ({ ...prev, categoria: formLibro.categoria }));
        setLibroMsg({ tipo: 'propuesta', texto: 'Cambios enviados a RELEA para revisión.' });
      } else {
        setLibroLocal(prev => ({ ...prev, ...formLibro }));
        onLibroActualizado();
      }
      setEditando(false);
    } catch (e) {
      setLibroMsg(e.response?.data?.error || 'Error al guardar. Intenta de nuevo.');
    }
    setGuardando(false);
  }

  function iniciarEdicion() {
    if (propuestaPendiente?.campos) {
      setFormLibro(prev => ({ ...prev, ...propuestaPendiente.campos }));
    }
    setEditando(true);
  }

  async function agregarEtiqueta(nombre) {
    if (!nombre.trim()) return;
    setEtMsg(null);
    try {
      const et = await api.post('/etiquetas', { nombre: nombre.trim() });
      await api.post('/libro-etiquetas', { libro_id: libro.id, etiqueta_id: et.data.id });
      const r = await api.get(`/inventario/${libro.id}/detalle`);
      setDetalle(r.data); setInputEt(''); onLibroActualizado();
    } catch(e) {
      setEtMsg(e.response?.data?.error || 'Error al agregar la etiqueta');
    }
  }

  async function quitarEtiqueta(etiqueta_id) {
    try {
      await api.delete(`/libro-etiquetas/${libro.id}/${etiqueta_id}`);
      const r = await api.get(`/inventario/${libro.id}/detalle`);
      setDetalle(r.data); onLibroActualizado();
    } catch {}
  }

  async function guardarDocLote(loteId, tipo_doc, num_doc) {
    await api.patch(`/lotes/${loteId}`, { tipo_doc: tipo_doc || null, num_doc: num_doc || null });
    const r = await api.get(`/inventario/${libro.id}/detalle`);
    setDetalle(r.data);
  }

  async function cargarBajas() {
    try {
      const r = await api.get(`/ajustes/bajas/${libro.id}`);
      setBajas(r.data);
    } catch { /* la sección simplemente no aparece */ }
  }

  async function revertirBaja(b) {
    const detalleTxt = b.baja_tipo === 'perdida'
      ? 'El stock vuelve al lote y la pérdida sale de lo que se le pagará al distribuidor.'
      : 'El stock vuelve al lote.';
    if (!window.confirm(`¿Revertir esta baja de ${b.cobro_cantidad} unidad${Number(b.cobro_cantidad) !== 1 ? 'es' : ''}?\n\n${detalleTxt}`)) return;
    setRevirtiendoId(b.id);
    try {
      await api.post(`/ajustes/${b.id}/revertir`);
      const r = await api.get(`/inventario/${libro.id}/detalle`);
      setDetalle(r.data);
      await cargarBajas();
      onLibroActualizado();
    } catch (e) {
      alert(e.response?.data?.error || 'No se pudo revertir la baja.');
      cargarBajas();
    }
    setRevirtiendoId(null);
  }

  function abrirEditLote(lo) {
    setEditLoteId(lo.id);
    const f = { distribuidor_id: lo.distribuidor_id, modalidad: lo.modalidad, pvp: String(lo.pvp || ''), costo_real: String(lo.costo_real || ''), stock: String(lo.stock ?? '') };
    setEditForm(f);
    setEditOrig(f);
    setPrecioDialog(null);
    setLoteMsg(null);
    setBajaTipo('perdida'); setBajaDetalle('');
    setNuevoDistNombre('');
    setNuevoDistRut('');
  }

  async function crearDistribuidor() {
    if (!nuevoDistNombre.trim() || !nuevoDistRut.trim()) return;
    setCreandoDist(true);
    try {
      const r = await api.post('/distribuidores', {
        nombre: nuevoDistNombre.trim(),
        ...(nuevoDistRut.trim() ? { rut: nuevoDistRut.trim() } : {}),
      });
      const nuevo = r.data;
      const yaExistia = nuevo._ya_existia;
      setDistribuidores(prev =>
        prev.some(d => d.id === nuevo.id) ? prev : [...prev, nuevo].sort((a, b) => a.nombre.localeCompare(b.nombre))
      );
      setEditForm(prev => ({ ...prev, distribuidor_id: nuevo.id }));
      setNuevoDistNombre('');
      setNuevoDistRut('');
      if (yaExistia) setLoteMsg({ tipo: 'ok', texto: `Ya existía "${nuevo.nombre}" — seleccionado automáticamente.` });
    } catch (e) {
      setLoteMsg({ tipo: 'err', texto: e.response?.data?.error || 'No se pudo crear el distribuidor.' });
    }
    setCreandoDist(false);
  }

  function editSetField(campo, valor) {
    setEditForm(prev => ({ ...prev, [campo]: valor }));
    if (campo === 'pvp' || campo === 'costo_real') setPrecioDialog(null);
  }

  function onPvpBlur() {
    if (editForm.pvp !== editOrig.pvp && editForm.pvp) {
      const pvp   = Number(editForm.pvp);
      const costo = Number(editForm.costo_real);
      const pct   = pvp > 0 && costo > 0 ? String(Math.round((1 - costo / pvp) * 100)) : '';
      setPrecioDialog({ trigger: 'pvp', pct });
    }
  }

  function onCostoBlur() {
    if (editForm.costo_real !== editOrig.costo_real && editForm.costo_real) {
      const pvp   = Number(editForm.pvp);
      const costo = Number(editForm.costo_real);
      const pct   = pvp > 0 && costo > 0 ? String(Math.round((1 - costo / pvp) * 100)) : '';
      setPrecioDialog({ trigger: 'costo', pct });
    }
  }

  function aplicarDialogoPrecio(solo) {
    if (!precioDialog) return;
    if (!solo) {
      const pct = Number(precioDialog.pct);
      if (precioDialog.trigger === 'pvp') {
        const pvp  = Number(editForm.pvp);
        const costo = pvp > 0 && pct > 0 && pct < 100 ? String(Math.round(pvp * (1 - pct / 100))) : editForm.costo_real;
        setEditForm(prev => ({ ...prev, costo_real: costo }));
      } else {
        const costo = Number(editForm.costo_real);
        const pvp   = costo > 0 && pct > 0 && pct < 100 ? String(Math.round(costo / (1 - pct / 100))) : editForm.pvp;
        setEditForm(prev => ({ ...prev, pvp }));
      }
    }
    setPrecioDialog(null);
  }

  async function guardarLote() {
    if (!editLoteId) return;
    setGuardandoLote(true);
    setLoteMsg(null);
    try {
      const body = {};
      if (editForm.distribuidor_id !== editOrig.distribuidor_id) body.distribuidor_id = editForm.distribuidor_id;
      if (editForm.modalidad       !== editOrig.modalidad)       body.modalidad       = editForm.modalidad;
      if (editForm.pvp             !== editOrig.pvp)             body.pvp             = Number(editForm.pvp);
      if (editForm.costo_real      !== editOrig.costo_real)      body.costo_real      = Number(editForm.costo_real);
      if (editForm.stock           !== editOrig.stock)           body.stock           = Number(editForm.stock);
      // Bajar stock de un libro en consignación: se dice qué pasó, porque el distribuidor puede seguir contándolo
      if (body.stock !== undefined && editOrig.modalidad === 'consignacion' && body.stock < Number(editOrig.stock)) {
        body.baja_tipo = bajaTipo;
        if (bajaDetalle.trim()) body.baja_detalle = bajaDetalle.trim();
      }

      if (Object.keys(body).length === 0) { setEditLoteId(null); return; }
      await api.patch(`/lotes/${editLoteId}`, body);
      const r = await api.get(`/inventario/${libro.id}/detalle`);
      setDetalle(r.data);
      setEditLoteId(null);
      setLoteMsg({ tipo: 'ok', texto: 'Cambios guardados.' });
      cargarBajas();
      onLibroActualizado();
      setTimeout(() => setLoteMsg(null), 3000);
    } catch (e) {
      setLoteMsg({ tipo: 'err', texto: e.response?.data?.error || 'Error al guardar.' });
    }
    setGuardandoLote(false);
  }

  const thS = { padding: '0.35rem 0.5rem', fontSize: '0.76rem', color: 'var(--ink-400)', fontWeight: 500, textAlign: 'left', borderBottom: '1px solid var(--line)', whiteSpace: 'nowrap', textTransform: 'uppercase', letterSpacing: '0.06em' };
  const tdS = { padding: '0.38rem 0.5rem', fontSize: '0.86rem', borderBottom: '1px solid var(--line-soft)', color: 'var(--ink-700)' };

  return (
    <>
      {/* Overlay */}
      <div onClick={onClose} style={{
        position: 'fixed', inset: 0, background: 'var(--scrim)', zIndex: 299,
        opacity: abierto ? 1 : 0, transition: 'opacity var(--t-normal)', pointerEvents: abierto ? 'auto' : 'none',
      }} />
      {/* Panel */}
      <div style={{
        position: 'fixed', top: 0, right: 0, bottom: 0, width: 'min(520px, 100vw)',
        background: 'var(--paper)', zIndex: 300, overflowY: 'auto',
        boxShadow: 'var(--shadow-pop)',
        transform: abierto ? 'translateX(0)' : 'translateX(100%)',
        transition: 'transform var(--t-normal)',
      }}>
        {/* Cabecera sticky */}
        <div style={{ position: 'sticky', top: 0, background: 'var(--paper)', borderBottom: '1px solid var(--line-soft)', padding: '1rem 1.25rem', display: 'flex', alignItems: 'flex-start', gap: '0.9rem', zIndex: 1 }}>
          {portadaUrl && <img src={portadaUrl} alt="Portada" style={{ width: 54, height: 76, objectFit: 'cover', borderRadius: 'var(--r-sm)', flexShrink: 0, border: '1px solid var(--line)' }} />}
          <div style={{ flex: 1, minWidth: 0 }}>
            <p style={{ margin: '0 0 0.1rem', fontSize: '0.73rem', color: 'var(--ink-300)', fontFamily: 'var(--font-mono)' }}>{libroLocal.isbn || 'Sin ISBN'}</p>
            <h3 style={{ margin: '0 0 0.2rem', fontSize: '0.98rem', lineHeight: 1.3, fontFamily: 'var(--font-ui)', color: 'var(--ink-900)' }}>{libroLocal.titulo}</h3>
            {libroLocal.autor && <p style={{ margin: 0, fontSize: '0.83rem', color: 'var(--ink-500)' }}>{libroLocal.autor}</p>}
          </div>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: '1.5rem', cursor: 'pointer', color: 'var(--ink-300)', lineHeight: 1, flexShrink: 0, padding: 0 }}>×</button>
        </div>

        <div style={{ padding: '1.25rem' }}>

          {/* Datos del libro */}
          <div style={{ marginBottom: '1.5rem' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.65rem' }}>
              <h4 style={{ margin: 0, fontSize: '0.78rem', textTransform: 'uppercase', letterSpacing: '0.06em', color: 'var(--ink-400)', fontFamily: 'var(--font-ui)' }}>Datos del libro</h4>
              {!editando
                ? <button onClick={iniciarEdicion} style={{ background: 'none', border: '1px solid var(--line)', padding: '0.22rem 0.6rem', borderRadius: 'var(--r-pill)', cursor: 'pointer', fontSize: '0.79rem', color: 'var(--ink-600)', fontFamily: 'var(--font-ui)' }}>Editar</button>
                : <div style={{ display: 'flex', gap: '0.35rem' }}>
                    <button onClick={guardarLibro} disabled={guardando} style={{ background: 'var(--ink-900)', color: 'white', border: 'none', padding: '0.22rem 0.6rem', borderRadius: 'var(--r-pill)', cursor: 'pointer', fontSize: '0.79rem', fontFamily: 'var(--font-ui)' }}>{guardando ? '…' : 'Guardar'}</button>
                    <button onClick={() => setEditando(false)} style={{ background: 'none', border: '1px solid var(--line)', padding: '0.22rem 0.6rem', borderRadius: 'var(--r-pill)', cursor: 'pointer', fontSize: '0.79rem', color: 'var(--ink-600)', fontFamily: 'var(--font-ui)' }}>Cancelar</button>
                  </div>
              }
            </div>
            {editando ? (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.45rem' }}>
                {[['Título','titulo'],['Autor','autor'],['Editorial','editorial'],['Categoría','categoria'],['ISBN','isbn']].map(([lbl,key]) => (
                  <div key={key}>
                    <label style={{ display: 'block', fontSize: '0.76rem', color: '#999', marginBottom: '0.18rem' }}>{lbl}</label>
                    <input value={formLibro[key] || ''} onChange={e => setFormLibro(p => ({ ...p, [key]: e.target.value }))}
                      style={{ width: '100%', padding: '0.38rem 0.5rem', border: '1px solid #ddd', borderRadius: '4px', fontSize: '0.88rem', boxSizing: 'border-box' }} />
                  </div>
                ))}
                {libroMsg && <p style={{ margin: 0, fontSize: '0.82rem', color: libroMsg?.tipo === 'propuesta' ? '#92400e' : '#b91c1c', background: libroMsg?.tipo === 'propuesta' ? '#fffbeb' : '#fef2f2', border: `1px solid ${libroMsg?.tipo === 'propuesta' ? '#fcd34d' : '#fca5a5'}`, borderRadius: 4, padding: '0.35rem 0.55rem' }}>{libroMsg?.texto || libroMsg}</p>}
              </div>
            ) : (
              <div>
                {propuestaPendiente && (
                  <div style={{ marginBottom: '0.75rem', padding: '0.55rem 0.7rem', background: '#fffbeb', border: '1px solid #fcd34d', borderRadius: 6 }}>
                    <p style={{ margin: '0 0 0.3rem', fontSize: '0.78rem', fontWeight: 600, color: '#92400e', fontFamily: 'var(--font-ui)', textTransform: 'uppercase', letterSpacing: '0.04em' }}>Pendiente de revisión por RELEA</p>
                    {Object.entries(propuestaPendiente.campos || {}).map(([campo, valor]) => (
                      <div key={campo} style={{ fontSize: '0.83rem', color: '#78350f', fontFamily: 'var(--font-ui)' }}>
                        <span style={{ textTransform: 'capitalize' }}>{campo}</span>: <strong>{valor}</strong>
                      </div>
                    ))}
                  </div>
                )}
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.45rem 1rem', fontSize: '0.88rem' }}>
                  {[['Autor', libroLocal.autor], ['Editorial', libroLocal.editorial], ['Categoría', libroLocal.categoria]].map(([lbl, val]) => (
                    <div key={lbl}>
                      <span style={{ color: 'var(--ink-400)', fontSize: '0.75rem', display: 'block', fontFamily: 'var(--font-ui)' }}>{lbl}</span>
                      <span>{val || '—'}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          {/* Etiquetas */}
          <div style={{ marginBottom: '1.5rem' }}>
            <h4 style={{ margin: '0 0 0.55rem', fontSize: '0.78rem', textTransform: 'uppercase', letterSpacing: '0.06em', color: 'var(--ink-400)', fontFamily: 'var(--font-ui)' }}>Etiquetas</h4>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.35rem', marginBottom: '0.5rem' }}>
              {etiquetasActuales.map(et => (
                <span key={et.id} style={{ display: 'inline-flex', alignItems: 'center', gap: '0.25rem', background: 'var(--paper-soft)', border: '1px solid var(--line)', padding: '0.18rem 0.5rem', borderRadius: 'var(--r-pill)', fontSize: '0.8rem', color: 'var(--ink-600)', fontFamily: 'var(--font-ui)' }}>
                  {et.nombre}
                  <button onClick={() => quitarEtiqueta(et.id)} style={{ background: 'none', border: 'none', color: 'var(--ink-300)', cursor: 'pointer', fontSize: '0.95rem', lineHeight: 1, padding: 0 }}>×</button>
                </span>
              ))}
            </div>
            <div style={{ position: 'relative' }}>
              <div style={{ display: 'flex', gap: '0.35rem' }}>
                <input value={inputEt} onChange={e => setInputEt(e.target.value)}
                  onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); etSugs[0] ? agregarEtiqueta(etSugs[0].nombre) : agregarEtiqueta(inputEt); } }}
                  placeholder="Nueva etiqueta…"
                  style={{ flex: 1, padding: '0.33rem 0.5rem', border: '1px solid var(--line)', borderRadius: 'var(--r-md)', fontSize: '0.84rem', fontFamily: 'var(--font-ui)', background: 'var(--paper)', color: 'var(--ink-900)' }} />
                <button onClick={() => etSugs[0] ? agregarEtiqueta(etSugs[0].nombre) : agregarEtiqueta(inputEt)}
                  style={{ padding: '0.33rem 0.65rem', background: 'var(--ink-900)', color: 'white', border: 'none', borderRadius: 'var(--r-md)', cursor: 'pointer', fontSize: '0.82rem', fontFamily: 'var(--font-ui)' }}>+</button>
              </div>
              {etSugs.length > 0 && (
                <div style={{ position: 'absolute', top: '100%', left: 0, right: 42, background: 'var(--paper)', border: '1px solid var(--line)', borderRadius: 'var(--r-md)', boxShadow: 'var(--shadow-pop)', zIndex: 10, marginTop: 2 }}>
                  {etSugs.map(et => (
                    <div key={et.id} onClick={() => agregarEtiqueta(et.nombre)}
                      style={{ padding: '0.38rem 0.6rem', cursor: 'pointer', fontSize: '0.84rem', fontFamily: 'var(--font-ui)', color: 'var(--ink-700)' }}
                      onMouseEnter={e => e.currentTarget.style.background = 'var(--brand-softer)'}
                      onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                      {et.nombre}
                    </div>
                  ))}
                </div>
              )}
            </div>
            {etMsg && <p style={{ margin: '0.35rem 0 0', fontSize: '0.78rem', color: '#b91c1c' }}>{etMsg}</p>}
          </div>

          {/* Lotes */}
          <div style={{ marginBottom: '1.5rem' }}>
            <h4 style={{ margin: '0 0 0.55rem', fontSize: '0.78rem', textTransform: 'uppercase', letterSpacing: '0.06em', color: 'var(--ink-400)', fontFamily: 'var(--font-ui)' }}>Registros de stock</h4>
            {cargando ? <p style={{ color: '#ccc', fontSize: '0.84rem', margin: 0 }}>Cargando…</p>
              : !detalle?.lotes?.length ? <p style={{ color: '#ccc', fontSize: '0.84rem', margin: 0 }}>Sin registros de stock</p>
              : <>
                  <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead><tr>
                      <th style={thS}>Distribuidor</th>
                      <th style={thS}>Modalidad</th>
                      <th style={thS}>PVP</th>
                      <th style={thS}>Costo</th>
                      <th style={{ ...thS, textAlign: 'right' }}>Consig.</th>
                      <th style={{ ...thS, textAlign: 'right' }}>Firme</th>
                      <th style={thS}></th>
                    </tr></thead>
                    <tbody>
                      {detalle.lotes.map(lo => (
                        <tr key={lo.id} style={{ background: editLoteId === lo.id ? 'var(--brand-softer,#f5f3ff)' : 'transparent' }}>
                          <td style={tdS}>
                            {lo.distribuidor}
                            {lo.doc_id && (
                              <span style={{ display: 'block', fontSize: 11, color: 'var(--ink-300)', marginTop: 1, fontFamily: 'var(--font-ui)' }}>
                                {lo.doc_tipo === 'gdd' ? 'GDD' : 'Factura'} N° {lo.doc_numero}
                                {lo.doc_fecha && ` · ${new Date(String(lo.doc_fecha).slice(0,10) + 'T12:00:00').toLocaleDateString('es-CL', { day:'numeric', month:'short', year:'numeric' })}`}
                              </span>
                            )}
                          </td>
                          <td style={tdS}>{lo.modalidad}</td>
                          <td style={tdS}>{invFmt(lo.pvp)}</td>
                          <td style={tdS}>{invFmt(lo.costo_real)}</td>
                          <td style={{ ...tdS, textAlign: 'right', fontWeight: lo.modalidad === 'consignacion' ? 700 : 400, color: lo.modalidad === 'consignacion' ? 'var(--ink-900)' : 'var(--ink-300)' }}>{lo.modalidad === 'consignacion' ? lo.stock : '—'}</td>
                          <td style={{ ...tdS, textAlign: 'right', fontWeight: lo.modalidad === 'firme' ? 700 : 400, color: lo.modalidad === 'firme' ? 'var(--ink-900)' : 'var(--ink-300)' }}>{lo.modalidad === 'firme' ? lo.stock : '—'}</td>
                          <td style={{ ...tdS, textAlign: 'right', paddingRight: 0 }}>
                            {editLoteId === lo.id
                              ? <button onClick={() => setEditLoteId(null)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--ink-400)', fontSize: '0.8rem', fontFamily: 'var(--font-ui)', padding: '0.1rem 0.3rem' }}>✕</button>
                              : <button onClick={() => abrirEditLote(lo)} style={{ background: 'none', border: '1px solid var(--line)', padding: '0.18rem 0.55rem', borderRadius: 'var(--r-pill)', cursor: 'pointer', fontSize: '0.75rem', color: 'var(--ink-500)', fontFamily: 'var(--font-ui)' }}>Editar</button>
                            }
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>

                  {/* Formulario de edición inline */}
                  {editLoteId && (
                    <div style={{ marginTop: '0.75rem', background: 'var(--paper-soft,#fafaf8)', border: '1px solid var(--line)', borderRadius: 'var(--r-md)', padding: '0.85rem' }}>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.55rem' }}>

                        {/* Distribuidor */}
                        <div>
                          <label style={{ display: 'block', fontSize: '0.72rem', color: 'var(--ink-400)', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '0.2rem', fontFamily: 'var(--font-ui)' }}>Distribuidor</label>
                          <select value={editForm.distribuidor_id || ''} onChange={e => editSetField('distribuidor_id', e.target.value)}
                            style={{ width: '100%', padding: '0.38rem 0.5rem', border: '1px solid var(--line)', borderRadius: 'var(--r-md)', fontSize: '0.86rem', fontFamily: 'var(--font-ui)', background: 'var(--paper)', color: 'var(--ink-900)' }}>
                            {distribuidores.map(d => <option key={d.id} value={d.id}>{d.nombre}</option>)}
                          </select>
                          {/* Crear distribuidor inline */}
                          <div style={{ marginTop: '0.3rem', display: 'flex', flexDirection: 'column', gap: '0.25rem' }}>
                            <div style={{ display: 'flex', gap: '0.35rem' }}>
                              <input
                                value={nuevoDistNombre}
                                onChange={e => setNuevoDistNombre(e.target.value)}
                                onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); if (nuevoDistNombre.trim()) crearDistribuidor(); } }}
                                placeholder="＋ Nombre del distribuidor…"
                                style={{ flex: 1, padding: '0.3rem 0.5rem', border: '1px solid var(--line)', borderRadius: 'var(--r-md)', fontSize: '0.82rem', fontFamily: 'var(--font-ui)', background: 'var(--paper)', color: 'var(--ink-900)' }}
                              />
                              <input
                                value={nuevoDistRut}
                                onChange={e => setNuevoDistRut(e.target.value)}
                                onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); if (nuevoDistNombre.trim()) crearDistribuidor(); } }}
                                placeholder="RUT (ej: 76.123.456-7)"
                                style={{ width: 130, padding: '0.3rem 0.5rem', border: '1px solid var(--line)', borderRadius: 'var(--r-md)', fontSize: '0.82rem', fontFamily: 'var(--font-ui)', background: 'var(--paper)', color: 'var(--ink-900)' }}
                              />
                            </div>
                            {nuevoDistNombre.trim() && (
                              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                {!nuevoDistRut.trim() && (
                                  <span style={{ fontSize: '0.72rem', color: 'var(--ink-400)' }}>
                                    El RUT es obligatorio
                                  </span>
                                )}
                                <button onClick={crearDistribuidor} disabled={creandoDist || !nuevoDistRut.trim()}
                                  style={{ marginLeft: 'auto', padding: '0.28rem 0.75rem', background: 'var(--ink-900)', color: 'white', border: 'none', borderRadius: 'var(--r-md)', cursor: nuevoDistRut.trim() ? 'pointer' : 'not-allowed', fontSize: '0.8rem', fontFamily: 'var(--font-ui)', whiteSpace: 'nowrap', opacity: nuevoDistRut.trim() ? 1 : 0.4 }}>
                                  {creandoDist ? '…' : 'Crear'}
                                </button>
                              </div>
                            )}
                          </div>
                        </div>

                        {/* Modalidad */}
                        <div>
                          <label style={{ display: 'block', fontSize: '0.72rem', color: 'var(--ink-400)', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '0.2rem', fontFamily: 'var(--font-ui)' }}>Modalidad</label>
                          <select value={editForm.modalidad || ''} onChange={e => editSetField('modalidad', e.target.value)}
                            style={{ width: '100%', padding: '0.38rem 0.5rem', border: '1px solid var(--line)', borderRadius: 'var(--r-md)', fontSize: '0.86rem', fontFamily: 'var(--font-ui)', background: 'var(--paper)', color: 'var(--ink-900)' }}>
                            <option value="firme">firme</option>
                            <option value="consignacion">consignacion</option>
                            <option value="manual">manual</option>
                            <option value="migracion">migracion</option>
                          </select>
                        </div>

                        {/* PVP + Costo */}
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.55rem' }}>
                          <div>
                            <label style={{ display: 'block', fontSize: '0.72rem', color: 'var(--ink-400)', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '0.2rem', fontFamily: 'var(--font-ui)' }}>PVP ($)</label>
                            <input type="number" min="0" step="1" value={editForm.pvp}
                              onChange={e => editSetField('pvp', e.target.value)}
                              onBlur={onPvpBlur}
                              style={{ width: '100%', padding: '0.38rem 0.5rem', border: '1px solid var(--line)', borderRadius: 'var(--r-md)', fontSize: '0.86rem', fontFamily: 'var(--font-ui)', background: 'var(--paper)', color: 'var(--ink-900)', boxSizing: 'border-box' }} />
                            {editForm.pvp > 0 && <p style={{ margin: '0.18rem 0 0', fontSize: '0.72rem', color: 'var(--ink-400)' }}>Neto: ${Math.round(editForm.pvp / 1.19).toLocaleString('es-CL')}</p>}
                          </div>
                          <div>
                            <label style={{ display: 'block', fontSize: '0.72rem', color: 'var(--ink-400)', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '0.2rem', fontFamily: 'var(--font-ui)' }}>Costo ($)</label>
                            <input type="number" min="0" step="1" value={editForm.costo_real}
                              onChange={e => editSetField('costo_real', e.target.value)}
                              onBlur={onCostoBlur}
                              style={{ width: '100%', padding: '0.38rem 0.5rem', border: '1px solid var(--line)', borderRadius: 'var(--r-md)', fontSize: '0.86rem', fontFamily: 'var(--font-ui)', background: 'var(--paper)', color: 'var(--ink-900)', boxSizing: 'border-box' }} />
                            {editForm.pvp > 0 && editForm.costo_real >= 0 && (
                              <p style={{ margin: '0.18rem 0 0', fontSize: '0.72rem', color: 'var(--ink-400)' }}>
                                Ganancia: {Math.round((1 - editForm.costo_real / editForm.pvp) * 100)}%
                              </p>
                            )}
                          </div>
                        </div>

                        {/* Diálogo recálculo de precios */}
                        {precioDialog && (
                          <div style={{ background: 'var(--paper)', border: '1px solid var(--brand-line,#d4c5f9)', borderRadius: 'var(--r-md)', padding: '0.75rem', display: 'flex', flexDirection: 'column', gap: '0.55rem' }}>
                            <p style={{ margin: 0, fontSize: '0.83rem', color: 'var(--ink-800)', fontWeight: 600 }}>
                              {precioDialog.trigger === 'pvp' ? '¿También actualizar el costo?' : '¿También actualizar el PVP?'}
                            </p>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                              <label style={{ fontSize: '0.78rem', color: 'var(--ink-500)', whiteSpace: 'nowrap' }}>Ganancia %</label>
                              <input type="number" min="0" max="99" step="0.1"
                                value={precioDialog.pct}
                                onChange={e => setPrecioDialog(prev => ({ ...prev, pct: e.target.value }))}
                                style={{ width: 64, padding: '0.28rem 0.4rem', border: '1px solid var(--line)', borderRadius: 'var(--r-md)', fontSize: '0.86rem', textAlign: 'right', fontFamily: 'var(--font-ui)' }} />
                              <span style={{ fontSize: '0.78rem', color: 'var(--ink-400)' }}>%</span>
                              {precioDialog.pct !== '' && Number(precioDialog.pct) > 0 && Number(precioDialog.pct) < 100 && (
                                <span style={{ fontSize: '0.78rem', color: 'var(--ink-600)', marginLeft: 4 }}>
                                  → {precioDialog.trigger === 'pvp'
                                    ? `Costo: $${Math.round(Number(editForm.pvp) * (1 - Number(precioDialog.pct) / 100)).toLocaleString('es-CL')}`
                                    : `PVP: $${Math.round(Number(editForm.costo_real) / (1 - Number(precioDialog.pct) / 100)).toLocaleString('es-CL')}`
                                  }
                                </span>
                              )}
                            </div>
                            <div style={{ display: 'flex', gap: '0.4rem' }}>
                              <button onClick={() => aplicarDialogoPrecio(true)}
                                style={{ flex: 1, padding: '0.3rem 0', background: 'none', border: '1px solid var(--line)', borderRadius: 'var(--r-md)', cursor: 'pointer', fontSize: '0.79rem', color: 'var(--ink-600)', fontFamily: 'var(--font-ui)' }}>
                                Solo {precioDialog.trigger === 'pvp' ? 'PVP' : 'Costo'}
                              </button>
                              <button onClick={() => aplicarDialogoPrecio(false)}
                                style={{ flex: 1, padding: '0.3rem 0', background: 'var(--ink-900)', color: 'white', border: 'none', borderRadius: 'var(--r-md)', cursor: 'pointer', fontSize: '0.79rem', fontWeight: 600, fontFamily: 'var(--font-ui)' }}>
                                Actualizar ambos
                              </button>
                            </div>
                          </div>
                        )}

                        {/* Stock */}
                        <div>
                          <label style={{ display: 'block', fontSize: '0.72rem', color: 'var(--ink-400)', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '0.2rem', fontFamily: 'var(--font-ui)' }}>Stock</label>
                          <input type="number" min="0" step="1" value={editForm.stock}
                            onChange={e => editSetField('stock', e.target.value)}
                            style={{ width: '100%', padding: '0.38rem 0.5rem', border: '1px solid var(--line)', borderRadius: 'var(--r-md)', fontSize: '0.86rem', fontFamily: 'var(--font-ui)', background: 'var(--paper)', color: 'var(--ink-900)', boxSizing: 'border-box' }} />
                          {editForm.stock !== editOrig.stock && <p style={{ margin: '0.18rem 0 0', fontSize: '0.72rem', color: 'var(--warn,#856404)' }}>⚠ El cambio quedará registrado en el historial de ajustes.</p>}
                          {editOrig.modalidad === 'consignacion' && editForm.stock !== '' && Number(editForm.stock) < Number(editOrig.stock) && (() => {
                            const unidades   = Number(editOrig.stock) - Number(editForm.stock);
                            const costoTotal = unidades * Number(editOrig.costo_real || 0);
                            const distNombre = distribuidores.find(d => d.id === editOrig.distribuidor_id)?.nombre || 'el distribuidor';
                            const opciones = [
                              { id: 'perdida',       titulo: 'Pérdida a pagar',            etiqueta: 'Va al reporte', cobra: true, desc: 'Faltante, daño o robo. Se le paga al distribuidor igual.' },
                              { id: 'devolucion',    titulo: 'Devolución al distribuidor', etiqueta: 'No se cobra',                 desc: 'Se lo devolví o se lo voy a devolver.' },
                              { id: 'error_ingreso', titulo: 'Error de ingreso',           etiqueta: 'No se cobra',                 desc: 'Ingresé más de los que llegaron. Queda marcado para reclamar la diferencia.' },
                            ];
                            return (
                              <div style={{ marginTop: '0.6rem' }}>
                                <p style={{ margin: '0 0 0.35rem', fontSize: '0.84rem', fontWeight: 600, color: 'var(--ink-900)', fontFamily: 'var(--font-ui)' }}>¿Qué pasó con {unidades === 1 ? 'este libro' : `estos ${unidades} libros`}?</p>
                                {opciones.map(o => {
                                  const sel = bajaTipo === o.id;
                                  return (
                                    <label key={o.id} style={{ display: 'flex', gap: '0.55rem', alignItems: 'flex-start', padding: '0.5rem 0.65rem', marginBottom: '0.35rem', cursor: 'pointer', border: sel ? '1.5px solid var(--ink-900)' : '1px solid var(--line)', borderRadius: 'var(--r-md)', background: sel ? 'var(--paper)' : 'transparent' }}>
                                      <input type="radio" name="baja-tipo" checked={sel} onChange={() => setBajaTipo(o.id)} style={{ marginTop: 3 }} />
                                      <span style={{ minWidth: 0 }}>
                                        <span style={{ fontSize: '0.84rem', fontWeight: 600, color: 'var(--ink-900)', fontFamily: 'var(--font-ui)' }}>{o.titulo}</span>
                                        <span style={{ marginLeft: 6, fontSize: '0.7rem', padding: '0.05rem 0.4rem', borderRadius: 'var(--r-pill)', background: o.cobra ? 'var(--warn-bg)' : 'var(--paper-stripe,#f2f2ee)', color: o.cobra ? 'var(--warn-ink)' : 'var(--ink-500)' }}>{o.etiqueta}</span>
                                        <span style={{ display: 'block', fontSize: '0.74rem', color: 'var(--ink-500)', marginTop: 1 }}>{o.desc}</span>
                                      </span>
                                    </label>
                                  );
                                })}
                                <input type="text" value={bajaDetalle} onChange={e => setBajaDetalle(e.target.value)} placeholder="Detalle (opcional)"
                                  style={{ width: '100%', marginTop: '0.1rem', padding: '0.38rem 0.5rem', border: '1px solid var(--line)', borderRadius: 'var(--r-md)', fontSize: '0.84rem', fontFamily: 'var(--font-ui)', background: 'var(--paper)', color: 'var(--ink-900)', boxSizing: 'border-box' }} />
                                <p style={{ margin: '0.4rem 0 0', padding: '0.45rem 0.6rem', borderRadius: 'var(--r-md)', fontSize: '0.78rem', lineHeight: 1.45, background: bajaTipo === 'perdida' ? 'var(--warn-bg)' : 'var(--paper-stripe,#f2f2ee)', color: bajaTipo === 'perdida' ? 'var(--warn-ink)' : 'var(--ink-500)' }}>
                                  {bajaTipo === 'perdida'
                                    ? `Se cobrarán ${invFmt(costoTotal)} (costo + IVA) en el próximo reporte de ${distNombre}. Podrás revertirlo mientras no se reporte.`
                                    : bajaTipo === 'devolucion'
                                      ? 'No se cobra ni va al reporte. Queda registrada como devolución en el historial.'
                                      : 'No se cobra ni va al reporte. Queda marcada para reclamar la diferencia al distribuidor.'}
                                </p>
                              </div>
                            );
                          })()}
                        </div>

                        {/* Acciones */}
                        <div style={{ display: 'flex', gap: '0.4rem', justifyContent: 'flex-end', paddingTop: '0.1rem' }}>
                          <button onClick={() => { setEditLoteId(null); setPrecioDialog(null); }}
                            style={{ padding: '0.3rem 0.8rem', background: 'none', border: '1px solid var(--line)', borderRadius: 'var(--r-md)', cursor: 'pointer', fontSize: '0.82rem', color: 'var(--ink-600)', fontFamily: 'var(--font-ui)' }}>
                            Cancelar
                          </button>
                          <button onClick={guardarLote} disabled={guardandoLote}
                            style={{ padding: '0.3rem 0.9rem', background: 'var(--ink-900)', color: 'white', border: 'none', borderRadius: 'var(--r-md)', cursor: 'pointer', fontSize: '0.82rem', fontWeight: 600, fontFamily: 'var(--font-ui)' }}>
                            {guardandoLote ? '…' : 'Guardar'}
                          </button>
                        </div>
                      </div>
                    </div>
                  )}

                  {loteMsg && (
                    <p style={{ margin: '0.45rem 0 0', fontSize: '0.82rem', color: loteMsg.tipo === 'ok' ? 'var(--ok-ink,#1a6b3c)' : '#c0392b' }}>{loteMsg.texto}</p>
                  )}
                </>
            }
          </div>

          {/* Bajas de consignación */}
          {bajas.length > 0 && (
            <div style={{ marginBottom: '1.5rem' }}>
              <h4 style={{ margin: '0 0 0.55rem', fontSize: '0.78rem', textTransform: 'uppercase', letterSpacing: '0.06em', color: 'var(--ink-400)', fontFamily: 'var(--font-ui)' }}>Bajas de consignación</h4>
              <div style={{ border: '1px solid var(--line)', borderRadius: 'var(--r-md)', overflow: 'hidden' }}>
                {bajas.map((b, i) => {
                  const revertida = !!b.revertido_en;
                  const puedeRevertir = !revertida && (b.baja_tipo !== 'perdida' || b.cobro_estado === 'por_pagar');
                  const etiquetaTipo = { perdida: 'Pérdida a pagar', devolucion: 'Devolución al distribuidor', error_ingreso: 'Error de ingreso' }[b.baja_tipo] || b.baja_tipo;
                  const estado = revertida ? { t: 'Revertida', bg: 'var(--paper-stripe,#f2f2ee)', ink: 'var(--ink-500)' }
                    : b.baja_tipo === 'perdida' && b.cobro_estado === 'reportada' ? { t: 'Reportada', bg: 'var(--ok-bg)', ink: 'var(--ok-ink)' }
                    : b.baja_tipo === 'perdida' ? { t: 'Por pagar', bg: 'var(--warn-bg)', ink: 'var(--warn-ink)' }
                    : b.baja_tipo === 'devolucion' ? { t: 'Sin cobro', bg: 'var(--paper-stripe,#f2f2ee)', ink: 'var(--ink-500)' }
                    : { t: 'Por reclamar', bg: 'var(--paper-stripe,#f2f2ee)', ink: 'var(--ink-500)' };
                  const unidades = Number(b.cobro_cantidad);
                  return (
                    <div key={b.id} style={{ padding: '0.55rem 0.75rem', borderTop: i > 0 ? '1px solid var(--line-soft)' : 'none', fontFamily: 'var(--font-ui)' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flexWrap: 'wrap' }}>
                        <span style={{ fontSize: '0.78rem', color: 'var(--ink-400)', whiteSpace: 'nowrap' }}>{new Date(b.creado_en).toLocaleDateString('es-CL', { day: 'numeric', month: 'short' })}</span>
                        <span style={{ fontSize: '0.84rem', fontWeight: 600, color: 'var(--ink-900)' }}>{etiquetaTipo}</span>
                        <span style={{ fontSize: '0.8rem', color: 'var(--ink-500)' }}>{unidades} u.{b.baja_tipo === 'perdida' && b.cobro_costo_unit != null ? ` · ${invFmt(unidades * Number(b.cobro_costo_unit))}` : ''}</span>
                        <span style={{ marginLeft: 'auto', fontSize: '0.72rem', padding: '0.05rem 0.5rem', borderRadius: 'var(--r-pill)', background: estado.bg, color: estado.ink }}>{estado.t}</span>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginTop: 3 }}>
                        <span style={{ fontSize: '0.75rem', color: 'var(--ink-400)', flex: 1, minWidth: 0 }}>
                          {b.distribuidor}{b.notas && b.notas !== etiquetaTipo ? ` · ${b.notas.replace(/^[^:]+: /, '')}` : ''}
                          {b.cobro_estado === 'reportada' && !revertida && b.reporte_nombre ? ` · ${b.reporte_nombre}` : ''}
                        </span>
                        {puedeRevertir && (
                          <button onClick={() => revertirBaja(b)} disabled={revirtiendoId === b.id}
                            style={{ background: 'none', border: '1px solid var(--line)', padding: '0.18rem 0.55rem', borderRadius: 'var(--r-pill)', cursor: 'pointer', fontSize: '0.75rem', color: 'var(--ink-600)', fontFamily: 'var(--font-ui)', whiteSpace: 'nowrap' }}>
                            {revirtiendoId === b.id ? '…' : 'Revertir'}
                          </button>
                        )}
                      </div>
                      {b.baja_tipo === 'perdida' && b.cobro_estado === 'reportada' && !revertida && (
                        <p style={{ margin: '3px 0 0', fontSize: '0.72rem', color: 'var(--ink-400)' }}>Ya fue en un reporte de consignación, no se puede revertir.</p>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {/* Ventas e ingresos */}
          <div style={{ marginBottom: '1.5rem' }}>
            <h4 style={{ margin: '0 0 0.75rem', fontSize: '0.78rem', textTransform: 'uppercase', letterSpacing: '0.06em', color: 'var(--ink-400)', fontFamily: 'var(--font-ui)' }}>Ventas e ingresos</h4>
            {cargando
              ? <p style={{ color: '#ccc', fontSize: '0.84rem', margin: 0 }}>Cargando…</p>
              : <InvVentasPanel detalle={detalle} libro={libroLocal} onDocSaved={guardarDocLote} />
            }
          </div>

          {/* En pedidos */}
          {libro.en_ultimo_pedido && (
            <div style={{ marginBottom: '1.5rem', background: 'var(--ok-bg)', border: '1px solid var(--ok-line)', borderRadius: 'var(--r-md)', padding: '0.6rem 0.85rem', fontSize: '0.84rem', color: 'var(--ok-ink)', fontFamily: 'var(--font-ui)' }}>
              ✓ Incluido en un pedido a distribuidor
            </div>
          )}

          {/* Descripción Open Library */}
          {descripcionOL && (
            <div style={{ marginBottom: '1.5rem' }}>
              <h4 style={{ margin: '0 0 0.55rem', fontSize: '0.78rem', textTransform: 'uppercase', letterSpacing: '0.06em', color: 'var(--ink-400)', fontFamily: 'var(--font-ui)' }}>Descripción (Open Library)</h4>
              <p style={{ margin: 0, fontSize: '0.86rem', color: 'var(--ink-600)', lineHeight: 1.55 }}>{descripcionOL.slice(0, 600)}{descripcionOL.length > 600 ? '…' : ''}</p>
            </div>
          )}

        </div>
      </div>
    </>
  );
}

// ---------------------------------------------------------------------------
// Atajos de búsqueda — definición declarativa
// fn(libro, ahora_ms) → bool  — todos los campos vienen del payload existente
// Los ventas_Nd siempre están disponibles porque cargarLibros incluye días base
// ---------------------------------------------------------------------------
const INV_DIAS_BASE = [1, 7, 30, 60, 90, 180, 270, 365];

const ATAJOS_DEF = [
  // — Stock —
  { id: 'sin_stock',        familia: 'stock',      label: 'Sin stock',        fn: (l) => l.stock_total === 0 },
  { id: 'stock_bajo',       familia: 'stock',      label: 'Stock bajo (1–2)', fn: (l) => l.stock_total >= 1 && l.stock_total <= 2 },
  { id: 'stock_negativo',   familia: 'stock',      label: 'Stock negativo',   fn: (l) => l.stock_total < 0 },

  // — Ventas —
  { id: 'vendidos_hoy',     familia: 'ventas',     label: 'Vendidos hoy',     fn: (l) => (l.ventas_1d   ?? 0) > 0 },
  { id: 'esta_semana',      familia: 'ventas',     label: 'Esta semana',      fn: (l) => (l.ventas_7d   ?? 0) > 0 },
  { id: 'este_mes',         familia: 'ventas',     label: 'Este mes',         fn: (l) => (l.ventas_30d  ?? 0) > 0 },
  { id: 'sin_ventas_30',    familia: 'ventas',     label: 'Sin ventas 30d',   fn: (l) => (l.ventas_30d  ?? 0) === 0 },
  { id: 'sin_ventas_90',    familia: 'ventas',     label: 'Sin ventas 90d',   fn: (l) => (l.ventas_90d  ?? 0) === 0 },
  { id: 'sin_ventas_180',   familia: 'ventas',     label: 'Sin ventas 180d',  fn: (l) => (l.ventas_180d ?? 0) === 0 },
  { id: 'nunca_vendido',    familia: 'ventas',     label: 'Nunca vendido',    fn: (l) => !l.fecha_ultima_venta },
  { id: 'subiendo',         familia: 'ventas',     label: 'Subiendo',         fn: (l) => { const m30 = l.ventas_30d ?? 0; const ant = (l.ventas_60d ?? 0) - m30; return m30 > 0 && m30 > ant; } },

  // — Modalidad / origen —
  { id: 'firme',            familia: 'modalidad',  label: 'Firme',            fn: (l) => (l.stock_firme        ?? 0) > 0 },
  { id: 'consignacion',     familia: 'modalidad',  label: 'Consignación',     fn: (l) => (l.stock_consignacion ?? 0) > 0 },
  { id: 'manual',           familia: 'modalidad',  label: 'Manual',           fn: (l) => (l.modalidades || '').includes('manual') },
  { id: 'recien_ingresados',familia: 'modalidad',  label: 'Recién ingresados', fn: (l, ahora) => l.fecha_ingreso && (ahora - new Date(l.fecha_ingreso).getTime()) < 30 * 864e5 },
  // "Por distribuidor" se maneja aparte con selector — no tiene fn aquí

  // — Consignación operativa (colapsado por default) —
  { id: 'consig_3m',        familia: 'consig_op',  label: 'Sin mov. 3 meses', fn: (l) => (l.stock_consignacion ?? 0) > 0 && (l.ventas_90d  ?? 0) === 0 },
  { id: 'consig_6m',        familia: 'consig_op',  label: 'Sin mov. 6 meses', fn: (l) => (l.stock_consignacion ?? 0) > 0 && (l.ventas_180d ?? 0) === 0 },
  { id: 'consig_9m',        familia: 'consig_op',  label: 'Sin mov. 9 meses', fn: (l) => (l.stock_consignacion ?? 0) > 0 && (l.ventas_270d ?? 0) === 0 },
  { id: 'consig_1a',        familia: 'consig_op',  label: 'Sin mov. 1 año',   fn: (l) => (l.stock_consignacion ?? 0) > 0 && (l.ventas_365d ?? 0) === 0 },

  // — Calidad de datos (colapsado por default) —
  { id: 'sin_autor',        familia: 'calidad',    label: 'Sin autor',        fn: (l) => !l.autor },
  { id: 'sin_editorial',    familia: 'calidad',    label: 'Sin editorial',    fn: (l) => !l.editorial },
  { id: 'sin_categoria',    familia: 'calidad',    label: 'Sin categoría',    fn: (l) => !l.categoria },
  { id: 'sin_costo',        familia: 'calidad',    label: 'Sin costo',        fn: (l) => !l.costo || Number(l.costo) === 0 },
  { id: 'sin_distribuidor', familia: 'calidad',    label: 'Sin distribuidor', fn: (l) => !l.distribuidores },

  // — Inteligentes —
  { id: 'plata_congelada',  familia: 'smart',      label: 'Plata congelada',  fn: (l) => (l.stock_firme ?? 0) > 0 && (l.ventas_90d ?? 0) === 0 },
  { id: 'novedad_pega',     familia: 'smart',      label: 'Novedad que pega', fn: (l, ahora) => l.fecha_ingreso && (ahora - new Date(l.fecha_ingreso).getTime()) < 30 * 864e5 && (l.ventas_30d ?? 0) > 0 },
];

const FAMILIAS_INV = [
  { id: 'stock',     label: 'Stock',               colapsada: false },
  { id: 'ventas',    label: 'Ventas',               colapsada: false },
  { id: 'modalidad', label: 'Modalidad / Origen',   colapsada: false },
  { id: 'smart',     label: 'Inteligentes',         colapsada: false },
  { id: 'consig_op', label: 'Consignación operativa', colapsada: true },
  { id: 'calidad',   label: 'Calidad de datos',     colapsada: true },
];

// ── Ingreso manual: precios a partir de UN valor + ganancia ──────────────────
// El usuario elige con qué precio parte (PVP, Neto, Costo con IVA o Costo sin
// IVA), escribe ese valor y la ganancia %; el resto se deriva.
//   ganancia = (PVP − Costo) / PVP   → Costo (con IVA) = PVP × (1 − ganancia)
//   Neto = PVP / 1,19                → Costo sin IVA = Costo con IVA / 1,19
// Lo que se guarda en el lote es PVP y Costo con IVA (igual que antes).
const IM_IVA = 1.19;
const IM_BASES_PRECIO = [
  { id: 'pvp',        label: 'PVP',           ayuda: 'Precio de venta al público, con IVA.' },
  { id: 'neto',       label: 'Neto',          ayuda: 'PVP ÷ 1,19. El PVP se calcula al tiro.' },
  { id: 'costo_iva',  label: 'Costo con IVA', ayuda: 'Lo que te cobra el distribuidor, IVA incluido.' },
  { id: 'costo_neto', label: 'Costo sin IVA', ayuda: 'Lo que te cobra el distribuidor, antes de IVA.' },
];

function imNumero(s) {
  const n = parseFloat(String(s ?? '').replace(/[^\d.,]/g, '').replace(',', '.'));
  return isNaN(n) ? 0 : n;
}

function imCalcPrecios(base, valor, gananciaPct) {
  const v = imNumero(valor);
  const g = imNumero(gananciaPct) / 100;
  const gananciaOk = g > 0 && g < 1;
  let pvp = null, costoIva = null;
  if (v > 0) {
    if (base === 'pvp')             pvp = v;
    else if (base === 'neto')       pvp = v * IM_IVA;
    else if (base === 'costo_iva')  costoIva = v;
    else                            costoIva = v * IM_IVA;
  }
  if (pvp != null && gananciaOk)                 costoIva = pvp * (1 - g);
  if (costoIva != null && pvp == null && gananciaOk) pvp = costoIva / (1 - g);
  return {
    pvp,
    neto:       pvp      != null ? pvp / IM_IVA      : null,
    costo_iva:  costoIva,
    costo_neto: costoIva != null ? costoIva / IM_IVA : null,
    gananciaOk,
  };
}

// Ganancia % que implica el factor de pago del distribuidor (0,60 → 40 %).
function imGananciaSugerida(dist) {
  const f = Number(dist?.factor_pago);
  return f > 0 && f < 1 ? +((1 - f) * 100).toFixed(1) : null;
}

const imFormInicial = () => ({
  isbn: '', titulo: '', autor: '', editorial: '',
  distribuidor_id: '', modalidad: 'firme',
  precio_base: 'pvp', precio_valor: '', ganancia_pct: '',
  stock: '', notas: '',
  tipo_doc: '', num_doc: '', fecha_doc: new Date().toLocaleDateString('en-CA'),
});

// --- ModuloInventario ---
function ModuloInventario({ preguntaCarga = null }) {
  const [preguntaGuardando, setPreguntaGuardando] = useState(false);
  const [preguntaError,     setPreguntaError]     = useState('');
  const [libros,         setLibros]         = useState([]);
  const [distribuidores, setDistribuidores] = useState([]);
  const [cargando,       setCargando]       = useState(false);
  const [cargandoLibros, setCargandoLibros] = useState(false);
  const [librosListos,   setLibrosListos]   = useState(false);

  const [colsActivas,  setColsActivas]  = useState(() => invLeerCols());
  const [periodos,     setPeriodos]     = useState(() => invLeerPeriodos());
  const [pickerOpen,   setPickerOpen]   = useState(false);

  const [fichaLibro,   setFichaLibro]   = useState(null);
  const [fichaAbierta, setFichaAbierta] = useState(false);

  const [busqueda,      setBusqueda]      = useState('');
  const [filtros,       setFiltros]       = useState({}); // { colId: string[] }
  const [colFilterOpen, setColFilterOpen] = useState(null);
  const [colFilterSearch, setColFilterSearch] = useState('');
  const colFilterRef   = useRef(null);
  const invBusquedaRef = useRef(null);

  const [sortCol, setSortCol] = useState(null);  // id de columna ordenada, o null
  const [sortDir, setSortDir] = useState('asc'); // 'asc' | 'desc'

  const [activos,       setActivos]       = useState(new Set()); // atajos activos (multi-select)
  const [distAtajoSel,  setDistAtajoSel]  = useState('');
  const [filtrosOpen,   setFiltrosOpen]   = useState(false);
  const [ordenarOpen,   setOrdenarOpen]   = useState(false);
  const [masOpen,       setMasOpen]       = useState(false);
  const [masCriterios,  setMasCriterios]  = useState(false);

  const [gestionTab,  setGestionTab]  = useState('libro');  // conservado por si se necesita
  const [gestionOpen, setGestionOpen] = useState(false);   // conservado por compatibilidad interna

  const [imOpen,  setImOpen]  = useState(false); // panel Ingreso manual
  const [devOpen, setDevOpen] = useState(false); // panel Devolución

  const [formLibro,   setFormLibro]   = useState({ isbn: '', titulo: '', autor: '', editorial: '' });
  const [guardandoL,  setGuardandoL]  = useState(false);
  const [formLote,    setFormLote]    = useState({ libro_id: '', distribuidor_id: '', modalidad: 'firme', pvp: '', cantidad: '' });
  const [guardandoLo, setGuardandoLo] = useState(false);

  const [importPreview,  setImportPreview]  = useState(null);
  const [importando,     setImportando]     = useState(false);
  const [importResult,   setImportResult]   = useState(null);
  const [importProgress, setImportProgress] = useState(null);

  // ── estados para pestaña Devolución ──────────────────────────────────────
  const [devDistSel,       setDevDistSel]       = useState(null);   // distribuidor seleccionado
  const [devLibros,        setDevLibros]        = useState([]);     // lotes con stock del distribuidor
  const [devCargando,      setDevCargando]      = useState(false);
  const [devSeleccion,     setDevSeleccion]     = useState({});     // { [lote_id]: cantidad_string }
  const [devNotas,         setDevNotas]         = useState('');
  const [devGuardando,     setDevGuardando]     = useState(false);
  const [devResultado,     setDevResultado]     = useState(null);   // { ok, devolucion_id } | { error }
  const [devHistorial,     setDevHistorial]     = useState([]);
  const [devCargandoHist,  setDevCargandoHist]  = useState(false);
  const [devDetalle,       setDevDetalle]       = useState(new Set()); // ids expandidos en historial

  // ── estados para pestaña Ajuste de stock ──────────────────────────────────
  const [ajusteBusqueda,     setAjusteBusqueda]     = useState('');
  const [ajusteLibroSel,     setAjusteLibroSel]     = useState(null);
  const [ajusteLotes,        setAjusteLotes]        = useState([]);
  const [ajusteCargandoL,    setAjusteCargandoL]    = useState(false);
  const [ajusteForm,         setAjusteForm]         = useState({}); // { [lote_id]: { stock_nuevo, motivo, notas } }
  const [ajusteGuardando,    setAjusteGuardando]    = useState({}); // { [lote_id]: bool }
  const [ajusteResultados,   setAjusteResultados]   = useState({}); // { [lote_id]: respuesta API }
  const [ajusteHistorial,    setAjusteHistorial]    = useState([]);
  const [ajusteCargandoHist, setAjusteCargandoHist] = useState(false);

  // ── estados para Vincular ISBNs ──────────────────────────────────────────
  const [vincularPanel,     setVincularPanel]     = useState(null);   // null | { catalogoId, cargando, data, ... }
  const [mensajeVinc,       setMensajeVinc]       = useState('');
  const [vincularCatalogos, setVincularCatalogos] = useState(null);   // null=cerrado, []=cargado
  const [vincularCatSel,    setVincularCatSel]    = useState('');

  // ── estados para Ingreso manual ──────────────────────────────────────────
  const [imForm,       setImForm]       = useState(imFormInicial);
  const [imGuardando,  setImGuardando]  = useState(false);
  const [imIsbnInfo,   setImIsbnInfo]   = useState(null);  // { encontrado, titulo? }
  const [imMensaje,    setImMensaje]    = useState(null);  // { tipo: 'ok'|'error', texto }
  // Distribuidor nuevo desde el mismo formulario (mismo criterio que el editor de lote: RUT obligatorio)
  const [imNuevoDistOpen,   setImNuevoDistOpen]   = useState(false);
  const [imNuevoDistNombre, setImNuevoDistNombre] = useState('');
  const [imNuevoDistRut,    setImNuevoDistRut]    = useState('');
  const [imCreandoDist,     setImCreandoDist]     = useState(false);
  // Documento enlazado: respuesta de GET /ingreso-manual/documento
  const [imDocInfo,    setImDocInfo]    = useState(null);

  const imPrecios = imCalcPrecios(imForm.precio_base, imForm.precio_valor, imForm.ganancia_pct);
  const imDistSel = distribuidores.find(d => d.id === imForm.distribuidor_id);
  const imGananciaSug = imGananciaSugerida(imDistSel);
  const imValido = imForm.titulo.trim() !== '' && parseInt(imForm.stock, 10) > 0
    && imPrecios.pvp != null && imPrecios.costo_iva != null && !imDocInfo?.conflicto
    && !imNuevoDistOpen; // con el panel de distribuidor nuevo abierto, primero crearlo o cancelar

  function imSetField(campo, valor) {
    setImForm(prev => ({ ...prev, [campo]: valor }));
  }
  // Al cambiar el punto de partida se conserva el valor ya calculado en ese precio
  function imCambiarBasePrecio(nueva) {
    setImForm(prev => {
      if (prev.precio_base === nueva) return prev;
      const c = imCalcPrecios(prev.precio_base, prev.precio_valor, prev.ganancia_pct);
      return { ...prev, precio_base: nueva, precio_valor: c[nueva] != null ? String(Math.round(c[nueva])) : '' };
    });
  }
  function imElegirDistribuidor(id) {
    if (id === '__nuevo') {
      setImNuevoDistOpen(true);
      setImForm(prev => ({ ...prev, distribuidor_id: '' }));
      return;
    }
    setImNuevoDistOpen(false);
    const sug = imGananciaSugerida(distribuidores.find(d => d.id === id));
    setImForm(prev => ({
      ...prev,
      distribuidor_id: id,
      ganancia_pct: sug != null && !String(prev.ganancia_pct).trim() ? String(sug) : prev.ganancia_pct,
    }));
  }
  async function imCrearDistribuidor() {
    if (!imNuevoDistNombre.trim() || !imNuevoDistRut.trim()) return;
    setImCreandoDist(true);
    try {
      const r = await api.post('/distribuidores', { nombre: imNuevoDistNombre.trim(), rut: imNuevoDistRut.trim() });
      const nuevo = r.data;
      setDistribuidores(prev =>
        prev.some(d => d.id === nuevo.id) ? prev : [...prev, nuevo].sort((a, b) => a.nombre.localeCompare(b.nombre))
      );
      const sug = imGananciaSugerida(nuevo);
      setImForm(prev => ({
        ...prev,
        distribuidor_id: nuevo.id,
        ganancia_pct: sug != null && !String(prev.ganancia_pct).trim() ? String(sug) : prev.ganancia_pct,
      }));
      setImNuevoDistNombre('');
      setImNuevoDistRut('');
      setImNuevoDistOpen(false);
      setImMensaje(nuevo._ya_existia ? { tipo: 'ok', texto: `Ya existía "${nuevo.nombre}" — seleccionado automáticamente.` } : null);
    } catch (e) {
      setImMensaje({ tipo: 'error', texto: e.response?.data?.error || 'No se pudo crear el distribuidor.' });
    }
    setImCreandoDist(false);
  }
  async function imBuscarIsbn(isbn) {
    if (!isbn || isbn.trim().length < 10) { setImIsbnInfo(null); return; }
    try {
      const r = await api.get(`/libros?isbn=${encodeURIComponent(isbn.trim())}`);
      const libro = r.data?.find?.(l => l.isbn === isbn.trim());
      if (libro) {
        setImIsbnInfo({ encontrado: true, titulo: libro.titulo, autor: libro.autor, editorial: libro.editorial });
        setImForm(prev => ({ ...prev, titulo: libro.titulo, autor: libro.autor || '', editorial: libro.editorial || '' }));
      } else {
        setImIsbnInfo({ encontrado: false });
      }
    } catch { setImIsbnInfo(null); }
  }
  async function imGuardar(e) {
    e.preventDefault();
    setImMensaje(null);
    setImGuardando(true);
    try {
      const r = await api.post('/ingreso-manual', {
        isbn:           imForm.isbn.trim() || undefined,
        titulo:         imForm.titulo.trim(),
        autor:          imForm.autor.trim() || undefined,
        editorial:      imForm.editorial.trim() || undefined,
        distribuidor_id: imForm.distribuidor_id || undefined,
        modalidad:      imForm.modalidad,
        pvp:            Math.round(imPrecios.pvp),
        costo:          Math.round(imPrecios.costo_iva),
        stock:          parseInt(imForm.stock, 10),
        notas:          imForm.notas.trim() || undefined,
        tipo_doc:       imForm.tipo_doc || undefined,
        num_doc:        imForm.num_doc.trim() || undefined,
        fecha_doc:      imForm.tipo_doc && imForm.num_doc.trim() ? imForm.fecha_doc || undefined : undefined,
      });
      const es_nuevo = r.data.es_libro_nuevo;
      const doc = r.data.documento;
      const textoDoc = !doc ? ''
        : doc.creado ? ` ${imForm.tipo_doc} N° ${imForm.num_doc.trim()} creada en Documentos y enlazada.`
        : ` Enlazado a ${imForm.tipo_doc} N° ${imForm.num_doc.trim()}, que ya estaba en Documentos.`;
      setImMensaje({ tipo: 'ok', texto: `Lote creado. ${es_nuevo ? 'Libro nuevo agregado al catálogo.' : 'Lote agregado a libro existente.'}${textoDoc}` });
      setImForm(imFormInicial());
      setImIsbnInfo(null);
      setImDocInfo(null);
      setImNuevoDistOpen(false);
      await recargarLibros();
    } catch (err) {
      setImMensaje({ tipo: 'error', texto: err.response?.data?.error || err.message });
    }
    setImGuardando(false);
  }

  // Consulta en vivo: ¿el documento (tipo + número) ya existe en Documentos y se puede enlazar?
  useEffect(() => {
    const { tipo_doc, num_doc, distribuidor_id, modalidad } = imForm;
    if (!tipo_doc || !num_doc.trim()) { setImDocInfo(null); return; }
    let cancelado = false;
    const t = setTimeout(async () => {
      try {
        const r = await api.get('/ingreso-manual/documento', {
          params: { tipo: tipo_doc, numero: num_doc.trim(), distribuidor_id: distribuidor_id || undefined, modalidad },
        });
        if (!cancelado) setImDocInfo(r.data);
      } catch { if (!cancelado) setImDocInfo(null); }
    }, 350);
    return () => { cancelado = true; clearTimeout(t); };
  }, [imForm.tipo_doc, imForm.num_doc, imForm.distribuidor_id, imForm.modalidad]); // eslint-disable-line

  // Ref para evitar stale closure en cargarLibros
  const periodosRef = useRef(periodos);
  periodosRef.current = periodos;

  useEffect(() => { cargarTodo(); }, []); // eslint-disable-line

  // Recargar cuando cambian los periodos de ventas (solo si ya se cargaron los libros)
  useEffect(() => {
    if (librosListos) recargarLibros();
  }, [periodos]); // eslint-disable-line

  // Cargar historial de devoluciones la primera vez que se abre el panel
  useEffect(() => {
    if (devOpen && devHistorial.length === 0 && !devCargandoHist)
      cargarHistorialDev();
  }, [devOpen]); // eslint-disable-line

  // Cerrar dropdown de columna al hacer clic fuera; resetear búsqueda interna
  useEffect(() => {
    setColFilterSearch('');
    if (!colFilterOpen) return;
    function handler(e) {
      if (colFilterRef.current && !colFilterRef.current.contains(e.target))
        setColFilterOpen(null);
    }
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [colFilterOpen]);

  async function cargarTodo() {
    setCargando(true);
    try {
      const [d] = await Promise.all([api.get('/distribuidores')]);
      setDistribuidores(d.data);
    } catch (e) { console.error(e); }
    setCargando(false);
  }

  async function cargarLibros() {
    if (librosListos) return; // ya cargados
    setCargandoLibros(true);
    try {
      const diasUnion = [...new Set([...INV_DIAS_BASE, ...periodosRef.current])].sort((a, b) => a - b);
      const r = await api.get(`/inventario?activo=all&dias=${diasUnion.join(',')}`);
      setLibros(r.data);
      setLibrosListos(true);
    } catch (e) { console.error(e); }
    setCargandoLibros(false);
  }

  async function recargarLibros() {
    setCargandoLibros(true);
    try {
      const diasUnion = [...new Set([...INV_DIAS_BASE, ...periodosRef.current])].sort((a, b) => a - b);
      const r = await api.get(`/inventario?activo=all&dias=${diasUnion.join(',')}`);
      setLibros(r.data);
    } catch (e) { console.error(e); }
    setCargandoLibros(false);
  }

  function abrirFicha(libro) {
    setFichaLibro(libro);
    requestAnimationFrame(() => setFichaAbierta(true));
  }
  function cerrarFicha() {
    setFichaAbierta(false);
    setTimeout(() => setFichaLibro(null), 310);
  }

  // ── funciones de Ajuste de stock ─────────────────────────────────────────

  async function cargarHistorialAjuste(libro_id) {
    setAjusteCargandoHist(true);
    try {
      const params = libro_id ? `?libro_id=${libro_id}&limite=30` : '?limite=30';
      const r = await api.get(`/ajustes/historial${params}`);
      setAjusteHistorial(r.data);
    } catch { /* silencioso */ }
    setAjusteCargandoHist(false);
  }

  async function seleccionarLibroAjuste(libro) {
    setAjusteLibroSel(libro);
    setAjusteForm({});
    setAjusteResultados({});
    setAjusteCargandoL(true);
    try {
      const r = await api.get(`/ajustes/libro/${libro.id}`);
      setAjusteLotes(r.data);
      const init = {};
      r.data.forEach(l => { init[l.id] = { stock_nuevo: String(l.stock), motivo: 'conteo_fisico', notas: '' }; });
      setAjusteForm(init);
    } catch { setAjusteLotes([]); }
    setAjusteCargandoL(false);
    cargarHistorialAjuste(libro.id);
  }

  function actualizarAjusteField(lote_id, campo, valor) {
    setAjusteForm(prev => ({ ...prev, [lote_id]: { ...prev[lote_id], [campo]: valor } }));
  }

  async function aplicarAjuste(lote) {
    const f = ajusteForm[lote.id];
    if (!f) return;
    const stock_nuevo = parseInt(f.stock_nuevo);
    if (isNaN(stock_nuevo)) return alert('El stock debe ser un número entero');
    if (f.motivo === 'otro' && !f.notas.trim()) return alert('El motivo "Otro" requiere una nota explicativa');
    const diferencia = stock_nuevo - lote.stock;
    if (diferencia === 0) return alert('El stock ingresado es igual al actual — no hay nada que ajustar');
    const signo = diferencia > 0 ? `+${diferencia}` : String(diferencia);
    const msg = `¿Confirmar ajuste?\n\nStock actual: ${lote.stock}\nStock nuevo:  ${stock_nuevo} (${signo})\nMotivo: ${MOTIVO_LABEL[f.motivo]}${f.notas ? '\nNotas: ' + f.notas : ''}`;
    if (!window.confirm(msg)) return;
    setAjusteGuardando(prev => ({ ...prev, [lote.id]: true }));
    try {
      const r = await api.post('/ajustes', { lote_id: lote.id, stock_nuevo, motivo: f.motivo, notas: f.notas || undefined });
      setAjusteLotes(prev => prev.map(l => l.id === lote.id ? { ...l, stock: stock_nuevo } : l));
      actualizarAjusteField(lote.id, 'stock_nuevo', String(stock_nuevo));
      setAjusteResultados(prev => ({ ...prev, [lote.id]: r.data }));
      cargarHistorialAjuste(ajusteLibroSel?.id);
      cargarLibros();
    } catch (err) {
      alert('Error: ' + (err.response?.data?.error || err.message));
    }
    setAjusteGuardando(prev => ({ ...prev, [lote.id]: false }));
  }

  // ── funciones de Devolución ───────────────────────────────────────────────

  async function cargarStockDev(dist_id) {
    setDevCargando(true);
    setDevLibros([]);
    setDevSeleccion({});
    setDevResultado(null);
    try {
      const r = await api.get(`/devoluciones/distribuidor/${dist_id}/stock`);
      setDevLibros(r.data);
    } catch (err) { setDevLibros([]); }
    setDevCargando(false);
  }

  async function cargarHistorialDev() {
    setDevCargandoHist(true);
    try {
      const r = await api.get('/devoluciones');
      setDevHistorial(r.data);
    } catch { /* silencioso */ }
    setDevCargandoHist(false);
  }

  async function confirmarDevolucion() {
    const items = devLibros
      .filter(l => {
        const c = parseInt(devSeleccion[l.lote_id]);
        return c > 0 && c <= l.stock;
      })
      .map(l => ({ lote_id: l.lote_id, libro_id: l.libro_id, cantidad: parseInt(devSeleccion[l.lote_id]) }));

    if (items.length === 0) return alert('Seleccioná al menos un ítem con cantidad válida');

    const totalUnidades = items.reduce((s, i) => s + i.cantidad, 0);
    const msg = `¿Confirmar devolución de ${totalUnidades} unidad${totalUnidades !== 1 ? 'es' : ''} a ${devDistSel.nombre}?`;
    if (!window.confirm(msg)) return;

    setDevGuardando(true);
    setDevResultado(null);
    try {
      const r = await api.post('/devoluciones', {
        distribuidor_id: devDistSel.id,
        notas: devNotas.trim() || undefined,
        items,
      });
      setDevResultado({ ok: true, devolucion_id: r.data.devolucion_id, totalUnidades });
      setDevSeleccion({});
      setDevNotas('');
      await cargarStockDev(devDistSel.id);
      await cargarHistorialDev();
      cargarLibros();
    } catch (err) {
      setDevResultado({ error: err.response?.data?.error || err.message });
    }
    setDevGuardando(false);
  }

  function toggleDevDetalle(id) {
    setDevDetalle(prev => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  }

  const ajusteDiffColor = d => d > 0 ? 'var(--ok-ink)' : d < 0 ? 'var(--bad-ink)' : 'var(--ink-400)';
  const ajusteDiffLabel = d => d > 0 ? `+${d}` : String(d);

  const ajusteQ = ajusteBusqueda.trim().toLowerCase();
  const ajusteLibrosFiltrados = ajusteQ
    ? libros.filter(l =>
        l.titulo?.toLowerCase().includes(ajusteQ) ||
        l.isbn?.includes(ajusteQ) ||
        l.autor?.toLowerCase().includes(ajusteQ)
      ).slice(0, 20)
    : [];

  const librosFiltrados = useMemo(() => {
    const q     = busqueda.trim().toLowerCase();
    const ahora = Date.now();
    return libros.filter(l => {
      if (q && !['titulo','autor','isbn','editorial'].some(f => l[f]?.toLowerCase?.().includes(q))) return false;
      for (const [colId, seleccion] of Object.entries(filtros)) {
        if (!seleccion || seleccion.length === 0) continue;
        const matchVals = colMatchValues(colId, l);
        if (!seleccion.some(s => matchVals.includes(s))) return false;
      }
      for (const id of activos) {
        if (id === 'por_distribuidor') {
          if (distAtajoSel && (!Array.isArray(l.distribuidor_ids) || !l.distribuidor_ids.includes(distAtajoSel))) return false;
        } else {
          const def = ATAJOS_DEF.find(a => a.id === id);
          if (def && !def.fn(l, ahora)) return false;
        }
      }
      return true;
    });
  }, [libros, busqueda, filtros, activos, distAtajoSel]);

  // Opciones únicas por columna para los dropdowns (calculadas sobre el listado completo)
  const opcionesColumna = useMemo(() => {
    const opts = {};

    // Helpers
    const addUnique = (colId, value, label) => {
      if (!opts[colId]) opts[colId] = new Map();
      if (!opts[colId].has(value)) opts[colId].set(value, label);
    };

    libros.forEach(l => {
      // Texto escalar
      if (l.isbn)       addUnique('isbn',      l.isbn,      l.isbn);
      if (l.titulo)     addUnique('titulo',     l.titulo,    l.titulo);
      if (l.autor)      addUnique('autor',      l.autor,     l.autor);
      if (l.editorial)  addUnique('editorial',  l.editorial, l.editorial);
      if (l.categoria)  addUnique('categoria',  l.categoria, l.categoria);
      // Distribuidores: value = UUID, label = nombre
      if (Array.isArray(l.distribuidor_ids)) {
        const nombres = (l.distribuidores || '').split(', ');
        l.distribuidor_ids.forEach((id, i) => addUnique('distribuidor', id, nombres[i] || id));
      }
      // Modalidad: puede tener múltiples
      if (l.modalidades) l.modalidades.split(', ').forEach(m => { if (m.trim()) addUnique('modalidad', m.trim(), m.trim()); });
      // Etiquetas
      (l.etiquetas || []).forEach(et => addUnique('etiquetas', et.nombre, et.nombre));
      // Numéricos
      if (l.pvp   != null) addUnique('pvp',   String(Number(l.pvp)),   invFmt(l.pvp));
      if (l.costo != null) addUnique('costo',  String(Number(l.costo)), invFmt(l.costo));
      addUnique('stock_total',        String(l.stock_total ?? 0),        String(l.stock_total ?? 0));
      addUnique('stock_firme',        String(l.stock_firme ?? 0),        String(l.stock_firme ?? 0));
      addUnique('stock_consignacion', String(l.stock_consignacion ?? 0), String(l.stock_consignacion ?? 0));
      addUnique('devuelto',           String(l.devuelto ?? 0),           String(l.devuelto ?? 0));
      // Fechas: value = ISO, label = formateado
      if (l.fecha_ultima_venta) addUnique('fecha_ultima_venta', l.fecha_ultima_venta, invFecha(l.fecha_ultima_venta));
      if (l.fecha_ingreso)      addUnique('fecha_ingreso',      l.fecha_ingreso,      invFecha(l.fecha_ingreso));
    });

    // Columnas con opciones fijas
    opts['en_ultimo_pedido'] = new Map([['si', 'Sí'], ['no', 'No']]);
    opts['estado']           = new Map([['true', 'Activo'], ['false', 'Inactivo']]);

    // Ventas por período (dinámicas)
    periodos.forEach(d => {
      const colId = `ventas_${d}d`;
      libros.forEach(l => {
        const v = l[colId] ?? 0;
        addUnique(colId, String(v), String(v));
      });
    });

    // Convertir Maps a arrays ordenados
    const result = {};
    for (const [colId, map] of Object.entries(opts)) {
      let entries = [...map.entries()].map(([value, label]) => ({ value, label }));
      // Orden por tipo
      if (['isbn','titulo','autor','editorial','categoria','modalidad','etiquetas','distribuidor'].includes(colId)) {
        entries.sort((a, b) => a.label.localeCompare(b.label, 'es'));
      } else if (['pvp','costo','stock_total','stock_firme','stock_consignacion','devuelto'].includes(colId) || colId.startsWith('ventas_')) {
        entries.sort((a, b) => Number(a.value) - Number(b.value));
      } else if (['fecha_ultima_venta','fecha_ingreso'].includes(colId)) {
        entries.sort((a, b) => a.value.localeCompare(b.value)); // ISO sort = cronológico
      }
      // en_ultimo_pedido y estado mantienen el orden de inserción
      result[colId] = entries;
    }
    return result;
  }, [libros, periodos]); // eslint-disable-line

  const librosFiltradosOrdenados = useMemo(() => {
    if (!sortCol) return librosFiltrados;
    const arr = [...librosFiltrados];
    arr.sort((a, b) => {
      const va = invSortVal(sortCol, a);
      const vb = invSortVal(sortCol, b);
      if (va == null && vb == null) return 0;
      if (va == null) return 1;
      if (vb == null) return -1;
      const cmp = typeof va === 'number' ? va - vb : String(va).localeCompare(String(vb), 'es');
      return sortDir === 'asc' ? cmp : -cmp;
    });
    return arr;
  }, [librosFiltrados, sortCol, sortDir]);

  const columnasFijas    = COLUMNAS_DEF.filter(c => colsActivas.includes(c.id));
  const columnasPeriodo  = periodos.map(d => ({ id: `ventas_${d}d`, label: `Ventas ${d}d` }));
  const columnasVisibles = [...columnasFijas, ...columnasPeriodo];

  function renderCelda(col, l) {
    switch (col.id) {
      case 'isbn':               return <span style={{ fontFamily: 'var(--font-mono)', fontSize: '0.81rem', color: 'var(--ink-400)' }}>{l.isbn || '—'}</span>;
      case 'titulo':             return (
        <div style={{ minWidth: 0 }}>
          <div style={{ fontSize: 13.5, fontWeight: 600, color: 'var(--ink-900)', lineHeight: 1.25, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{l.titulo}</div>
          <div style={{ fontSize: 11, color: 'var(--ink-400)', fontFamily: 'var(--font-mono)', marginTop: 1 }}>{l.isbn || ''}</div>
        </div>
      );
      case 'autor':              return l.autor || '—';
      case 'editorial':          return l.editorial || '—';
      case 'categoria':          return l.categoria || '—';
      case 'pvp':                return invFmt(l.pvp);
      case 'costo':              return invFmt(l.costo);
      case 'stock_total': {
        const zero = l.stock_total === 0, low = l.stock_total > 0 && l.stock_total <= 2;
        return <span style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 19, letterSpacing: '-0.01em', fontVariantNumeric: 'tabular-nums', color: zero ? 'var(--bad-ink)' : low ? 'var(--warn-ink)' : 'var(--ink-900)' }}>{l.stock_total}</span>;
      }
      case 'precio_neto': {
        const neto = l.pvp ? Math.round(Number(l.pvp) / 1.19) : null;
        return neto != null ? invFmt(neto) : '—';
      }
      case 'stock_firme':        return l.stock_firme;
      case 'stock_consignacion': return l.stock_consignacion;
      case 'devuelto':           return <span style={{ color: (l.devuelto ?? 0) > 0 ? 'var(--bad-ink)' : 'var(--ink-200)', fontVariantNumeric: 'tabular-nums' }}>{l.devuelto ?? 0}</span>;
      case 'distribuidor':       return <span style={{ fontSize: '0.84rem', color: 'var(--ink-600)' }}>{l.distribuidores || '—'}</span>;
      case 'modalidad': {
        const esConsig = l.modalidades?.includes('consignacion');
        return <span style={{ fontSize: '0.8rem', background: esConsig ? 'var(--consig-bg)' : 'var(--hl-yellow)', padding: '0.12rem 0.5rem', borderRadius: 'var(--r-pill)', color: esConsig ? 'var(--consig-ink)' : 'var(--hl-yellow-ink)', fontWeight: 500 }}>{l.modalidades || '—'}</span>;
      }
      case 'fecha_ultima_venta': return <span style={{ fontSize: '0.84rem', color: 'var(--ink-500)' }}>{invFecha(l.fecha_ultima_venta)}</span>;
      case 'fecha_ingreso':      return <span style={{ fontSize: '0.84rem', color: 'var(--ink-500)' }}>{invFecha(l.fecha_ingreso)}</span>;
      case 'en_ultimo_pedido':   return l.en_ultimo_pedido ? <span style={{ color: 'var(--ok-ink)', fontWeight: 600 }}>✓</span> : <span style={{ color: 'var(--ink-200)' }}>—</span>;
      case 'etiquetas':
        return (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.18rem' }}>
            {(l.etiquetas || []).map(et => (
              <span key={et.id} style={{ background: 'var(--paper-soft)', border: '1px solid var(--line)', padding: '0.08rem 0.38rem', borderRadius: 'var(--r-pill)', fontSize: '0.74rem', color: 'var(--ink-600)' }}>{et.nombre}</span>
            ))}
          </div>
        );
      case 'estado':
        return l.activo
          ? <span style={{ fontSize: '0.8rem', color: 'var(--ok-ink)', background: 'var(--ok-bg)', padding: '0.12rem 0.5rem', borderRadius: 'var(--r-pill)', fontWeight: 500 }}>Activo</span>
          : <span style={{ fontSize: '0.8rem', color: 'var(--bad-ink)', background: 'var(--bad-bg)', padding: '0.12rem 0.5rem', borderRadius: 'var(--r-pill)', fontWeight: 500 }}>Inactivo</span>;
      default:
        if (col.id.startsWith('ventas_')) return <span style={{ fontWeight: l[col.id] > 0 ? 600 : 400, color: l[col.id] > 0 ? 'var(--ink-900)' : 'var(--ink-300)', fontVariantNumeric: 'tabular-nums' }}>{l[col.id] ?? '—'}</span>;
        return '—';
    }
  }

  async function agregarLibro(e) {
    e.preventDefault(); setGuardandoL(true);
    try { await api.post('/libros', formLibro); setFormLibro({ isbn: '', titulo: '', autor: '', editorial: '' }); await recargarLibros(); } catch {}
    setGuardandoL(false);
  }

  async function agregarLote(e) {
    e.preventDefault(); setGuardandoLo(true);
    try {
      const dist = distribuidores.find(d => d.id === formLote.distribuidor_id);
      await api.post('/lotes', { ...formLote, factor_pago: dist.factor_pago });
      setFormLote({ libro_id: '', distribuidor_id: '', modalidad: 'firme', pvp: '', cantidad: '' });
      await recargarLibros();
    } catch {}
    setGuardandoLo(false);
  }

  async function subirPreviewImport(e) {
    const file = e.target.files[0]; if (!file) return;
    e.target.value = ''; setImportResult(null); setImportPreview(null); setImportando(true);
    try {
      const fd = new FormData(); fd.append('archivo', file);
      const token = localStorage.getItem('relea_token');
      const res  = await fetch(`${api.defaults.baseURL}/libros/importar/preview`, { method: 'POST', headers: { Authorization: `Bearer ${token}` }, body: fd });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error);
      setImportPreview(data);
    } catch (err) { alert(err.message); }
    setImportando(false);
  }

  async function confirmarImport() {
    if (!importPreview?.archivo) return;
    setImportando(true); setImportProgress({ fase: 'Iniciando…', progreso: 0 });
    try {
      const token = localStorage.getItem('relea_token');
      const response = await fetch(`${api.defaults.baseURL}/libros/importar/confirmar`, {
        method: 'POST', headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ archivo: importPreview.archivo }),
      });
      const reader = response.body.getReader(); const decoder = new TextDecoder(); let buf = '';
      while (true) {
        const { value, done } = await reader.read(); if (done) break;
        buf += decoder.decode(value, { stream: true });
        const lines = buf.split('\n'); buf = lines.pop();
        for (const line of lines) {
          if (!line.startsWith('data: ')) continue;
          const data = JSON.parse(line.slice(6));
          if (data.error) { alert('Error: ' + data.error); break; }
          if (data.done) { setImportResult(data); setImportPreview(null); setImportProgress(null); await recargarLibros(); }
          else setImportProgress(data);
        }
      }
    } catch (err) { alert(err.message); }
    setImportando(false);
  }

  function handleSort(colId) {
    if (sortCol !== colId) { setSortCol(colId); setSortDir('asc'); }
    else if (sortDir === 'asc') { setSortDir('desc'); }
    else { setSortCol(null); setSortDir('asc'); }
  }

  const MAX_FILAS = 200;
  const filasVisibles = busqueda.trim()
    ? librosFiltradosOrdenados.slice(0, MAX_FILAS)
    : [];
  const hayFiltro     = busqueda || Object.values(filtros).some(v => v && v.length > 0) || activos.size > 0 || distAtajoSel;

  // ── funciones para Vincular ISBNs ─────────────────────────────────────────

  async function abrirSelectorVincular() {
    try {
      const res = await api.get('/catalogos/historial');
      setVincularCatalogos(res.data);
      setVincularCatSel(res.data[0]?.id || '');
    } catch (e) {
      alert('Error al cargar catálogos: ' + (e.response?.data?.error || e.message));
    }
  }

  async function abrirVincularInv(catalogoId) {
    setVincularCatalogos(null);
    setVincularPanel({ catalogoId, cargando: true, data: null, confirmando: false, seleccionados: new Set(), conflictoElegido: {}, aceptarTitulo: {}, cambiosAdicionales: {} });
    try {
      const res = await api.get(`/catalogos/${catalogoId}/vincular-preview`);
      const data = res.data;
      const seleccionados = new Set(data.matches.map(m => m.libro_id));
      setVincularPanel(prev => prev ? { ...prev, cargando: false, data, seleccionados, conflictoElegido: {}, aceptarTitulo: {}, cambiosAdicionales: {} } : null);
    } catch (e) {
      setVincularPanel(prev => prev ? { ...prev, cargando: false, errorMsg: e.response?.data?.error || e.message } : null);
    }
  }

  async function confirmarVincularInv() {
    if (!vincularPanel?.data) return;
    const { catalogoId, seleccionados, conflictoElegido, aceptarTitulo, cambiosAdicionales, data } = vincularPanel;
    const vinculos = [];
    for (const m of data.matches) {
      if (seleccionados.has(m.libro_id))
        vinculos.push({ libro_id: m.libro_id, distribuidor_id: m.distribuidor_id, aceptar_titulo: aceptarTitulo?.[m.libro_id] || false, cambios_adicionales: cambiosAdicionales?.[m.libro_id] || [] });
    }
    for (const c of data.conflictos) {
      const distId = conflictoElegido?.[c.libro_id];
      if (distId) vinculos.push({ libro_id: c.libro_id, distribuidor_id: distId, aceptar_titulo: aceptarTitulo?.[c.libro_id] || false, cambios_adicionales: cambiosAdicionales?.[c.libro_id] || [] });
    }
    if (vinculos.length === 0) { setVincularPanel(null); return; }
    setVincularPanel(prev => ({ ...prev, confirmando: true }));
    try {
      const res = await api.post(`/catalogos/${catalogoId}/vincular-confirmar`, { vinculos });
      const { libros_vinculados, campos_actualizados } = res.data;
      setMensajeVinc(`✓ ${libros_vinculados} libro${libros_vinculados !== 1 ? 's' : ''} vinculados · ${campos_actualizados} campo${campos_actualizados !== 1 ? 's' : ''} completados`);
      setTimeout(() => setMensajeVinc(''), 6000);
      setVincularPanel(null);
      await recargarLibros();
    } catch (e) {
      alert('Error al vincular: ' + (e.response?.data?.error || e.message));
      setVincularPanel(prev => ({ ...prev, confirmando: false }));
    }
  }

  function handleCambioAdicionalInv(libro_id, campo, aceptado) {
    setVincularPanel(prev => {
      if (!prev) return prev;
      const prevCA = prev.cambiosAdicionales || {};
      const actual = prevCA[libro_id] || [];
      const next = aceptado ? [...actual, campo] : actual.filter(c => c !== campo);
      return { ...prev, cambiosAdicionales: { ...prevCA, [libro_id]: next } };
    });
  }

  if (cargando) return (
    <div style={{ background: 'var(--canvas)', minHeight: '100%', padding: 'var(--content-inset)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <span style={{ color: 'var(--ink-400)', fontFamily: 'var(--font-ui)', fontSize: 14 }}>Cargando inventario…</span>
    </div>
  );

  return (
    <>
    <div style={{ background: 'var(--canvas)', minHeight: '100%', padding: 'var(--content-inset)' }}>
    <div style={{ background: 'var(--paper)', borderRadius: 20, padding: 24, boxShadow: 'var(--shadow-card)', display: 'flex', flexDirection: 'column',
      // Con el panel Ingreso manual abierto el contenido puede ser más alto que la pantalla.
      // En vez de depender de que el mouse esté sobre esta caja para hacer scroll (poco intuitivo
      // y con varios <select> que capturan la rueda), se deja crecer la tarjeta y es la PÁGINA
      // la que se desplaza — el sidebar es position:fixed, así que no se mueve con ella.
      ...(imOpen ? { minHeight: 'calc(100vh - 32px)', overflow: 'visible' } : { height: 'calc(100vh - 32px)', overflow: 'hidden' }) }}>
      {/* ── Encabezado ─────────────────────────────────── */}
      {(() => {
        const gBtn = { display: 'inline-flex', alignItems: 'center', gap: 6, padding: '9px 14px', border: '1px solid var(--line)', background: 'var(--paper)', color: 'var(--ink-700)', borderRadius: 'var(--r-pill)', cursor: 'pointer', fontFamily: 'var(--font-ui)', fontSize: 12.5, fontWeight: 500, whiteSpace: 'nowrap', transition: 'border-color var(--t-fast)' };

        // Con el panel Ingreso manual abierto, el encabezado se vuelve un breadcrumb fijo
        // ("← Inventario") en vez del título + botones: la página puede ser más alta que la
        // pantalla (ver nota de overflow más abajo) y esta es la forma de volver desde
        // cualquier punto del scroll, sin depender de encontrar una × en algún borde.
        if (imOpen) {
          return (
            <div style={{ position: 'sticky', top: 'var(--content-inset)', zIndex: 5, display: 'flex', alignItems: 'center', gap: 10,
              margin: '-24px -24px 18px', padding: '20px 24px 16px', background: 'var(--paper)', borderRadius: '20px 20px 0 0', borderBottom: '1px solid var(--line)' }}>
              <button onClick={() => setImOpen(false)} title="Volver a Inventario"
                style={{ width: 34, height: 34, borderRadius: '50%', border: '1px solid var(--line)', background: 'var(--paper)', color: 'var(--ink-700)', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, transition: 'border-color var(--t-fast)' }}
                onMouseEnter={e => e.currentTarget.style.borderColor = 'var(--ink-400)'}
                onMouseLeave={e => e.currentTarget.style.borderColor = 'var(--line)'}>
                <ArrowLeft size={16} strokeWidth={1.75} />
              </button>
              <button onClick={() => setImOpen(false)}
                style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', fontFamily: 'var(--font-display)', fontSize: 24, fontWeight: 700, letterSpacing: 'var(--tracking-tight)', color: 'var(--ink-900)' }}>
                Inventario
              </button>
            </div>
          );
        }
        return (
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12, marginBottom: 18 }}>
            <div style={{ flex: 1 }}>
              <h2 style={{ margin: 0, fontFamily: 'var(--font-display)', fontSize: 30, fontWeight: 700, letterSpacing: 'var(--tracking-tight)', color: 'var(--ink-900)', lineHeight: 1 }}>Inventario</h2>
            </div>
            <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
              <button style={gBtn} onClick={() => setPickerOpen(true)}
                onMouseEnter={e => e.currentTarget.style.borderColor = 'var(--ink-400)'}
                onMouseLeave={e => e.currentTarget.style.borderColor = 'var(--line)'}>
                <ChevronRight size={13} style={{ transform: 'rotate(0deg)' }} /> Columnas
              </button>
              <button style={gBtn} onClick={async () => {
                  try {
                    const token = localStorage.getItem('relea_token');
                    const base = (api.defaults.baseURL || '').replace(/\/$/, '');
                    const r = await fetch(`${base}/libros/exportar-inventario`, { headers: { Authorization: `Bearer ${token}` } });
                    if (!r.ok) { const msg = await r.text(); throw new Error(`Error ${r.status}: ${msg}`); }
                    const blob = await r.blob();
                    const url = URL.createObjectURL(blob);
                    const a = document.createElement('a'); a.href = url;
                    a.download = `inventario-relea-${new Date().toISOString().slice(0,10)}.xlsx`;
                    a.click(); URL.revokeObjectURL(url);
                  } catch (err) { alert('No se pudo descargar el inventario: ' + err.message); }
                }}
                onMouseEnter={e => e.currentTarget.style.borderColor = 'var(--ink-400)'}
                onMouseLeave={e => e.currentTarget.style.borderColor = 'var(--line)'}>
                Descargar inventario
              </button>
              <span style={{ display: 'inline-flex' }}>
                <button onClick={() => { setImOpen(o => !o); setDevOpen(false); }}
                  style={{ display: 'inline-flex', alignItems: 'center', gap: 6, background: 'var(--ink-900)', color: '#fff', border: 'none', borderRadius: '999px 0 0 999px', padding: '9px 16px', cursor: 'pointer', fontFamily: 'var(--font-ui)', fontSize: 13, fontWeight: 600, whiteSpace: 'nowrap', transition: 'background var(--t-fast)' }}
                  onMouseEnter={e => e.currentTarget.style.background = 'var(--ink-800)'}
                  onMouseLeave={e => e.currentTarget.style.background = 'var(--ink-900)'}>
                  <Plus size={14} /> Ingresar stock
                </button>
                <button onClick={() => { setImOpen(o => !o); setDevOpen(false); }}
                  style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 32, background: 'var(--ink-800)', color: '#fff', border: 'none', borderLeft: '1px solid rgba(255,255,255,0.15)', borderRadius: '0 999px 999px 0', cursor: 'pointer' }}>
                  <ChevronRight size={12} style={{ transform: 'rotate(90deg)', opacity: 0.7 }} />
                </button>
              </span>
            </div>
          </div>
        );
      })()}

      {/* Mensaje éxito vinculación */}
      {mensajeVinc && (
        <div style={{ background: 'var(--ok-bg)', border: '1px solid var(--ok-line)', padding: '8px 14px', borderRadius: 10, marginBottom: 12, color: 'var(--ok-ink)', fontSize: 13, fontFamily: 'var(--font-ui)' }}>
          {mensajeVinc}
        </div>
      )}

      {/* Librería nueva, sin stock: primera vez en Inventario */}
      {preguntaCarga && !(librosListos && libros.length > 0) && !imOpen && (
        <div style={{ background: 'var(--paper-soft)', border: '1px solid var(--line)', borderRadius: 14, padding: '20px 22px', marginBottom: 18 }}>
          <div style={{ fontFamily: 'var(--font-display)', fontSize: 18, fontWeight: 700, color: 'var(--ink-900)', letterSpacing: '-0.01em', marginBottom: 6 }}>
            ¿Tienes un inventario propio que quieras cargar?
          </div>
          <div style={{ fontSize: 13.5, color: 'var(--ink-500)', fontFamily: 'var(--font-ui)', lineHeight: 1.55, marginBottom: 16, maxWidth: 560 }}>
            Si ya tienes tus libros en un Excel, súbelo y quedan en RELEA. Si no, empieza desde cero y los vas ingresando a medida que los recibes.
          </div>
          <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
            <button onClick={preguntaCarga.cargar} disabled={preguntaGuardando}
              style={{ display: 'inline-flex', alignItems: 'center', gap: 7, padding: '10px 18px', background: 'var(--ink-900)', color: '#fff', border: 'none', borderRadius: 'var(--r-pill)', cursor: 'pointer', fontFamily: 'var(--font-ui)', fontSize: 13, fontWeight: 600 }}>
              <Upload size={14} /> Sí, cargar mi inventario
            </button>
            <button disabled={preguntaGuardando}
              onClick={async () => {
                setPreguntaGuardando(true); setPreguntaError('');
                try { await preguntaCarga.desdeCero(); }
                catch (e) { setPreguntaError(e.response?.data?.error || 'No se pudo guardar. Intenta de nuevo.'); setPreguntaGuardando(false); }
              }}
              style={{ padding: '10px 18px', background: 'var(--paper)', color: 'var(--ink-700)', border: '1px solid var(--line-strong)', borderRadius: 'var(--r-pill)', cursor: preguntaGuardando ? 'default' : 'pointer', fontFamily: 'var(--font-ui)', fontSize: 13, fontWeight: 500, opacity: preguntaGuardando ? 0.7 : 1 }}>
              No, empezar desde cero
            </button>
          </div>
          {preguntaError && <div style={{ marginTop: 10, fontSize: 12.5, color: 'var(--err-ink)', fontFamily: 'var(--font-ui)' }}>{preguntaError}</div>}
        </div>
      )}

      {/* ── Panel Ingreso manual ─────────────────────────── */}
      {imOpen && (
        <div style={{ background: 'var(--paper-soft)', border: '1px solid var(--line)', borderRadius: 14, padding: '18px 20px', marginBottom: 20 }}>
          {/* Sin título ni × propios: el breadcrumb "← Inventario" del encabezado (fijo arriba) ya cierra este panel */}
          <form onSubmit={imGuardar}>
              {(() => {
                const inp   = { width: '100%', padding: '9px 11px', border: '1px solid var(--line-strong)', borderRadius: 8, fontSize: 14, fontFamily: 'var(--font-ui)', background: 'var(--paper)', color: 'var(--ink-900)', boxSizing: 'border-box', outline: 'none' };
                const lbl   = { display: 'block', fontSize: 11.5, color: 'var(--ink-500)', marginBottom: 4, fontFamily: 'var(--font-ui)' };
                const secH  = { display: 'flex', alignItems: 'baseline', gap: 8, fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em', color: 'var(--ink-400)', fontFamily: 'var(--font-ui)', marginBottom: 8 };
                const secHs = { fontWeight: 400, textTransform: 'none', letterSpacing: 0, fontSize: 11 };
                const hint  = { fontSize: 11.5, color: 'var(--ink-500)', marginTop: 5, fontFamily: 'var(--font-ui)' };
                const segWrap = { display: 'flex', background: 'var(--paper)', border: '1px solid var(--line-strong)', borderRadius: 999, padding: 3, gap: 2, width: '100%', boxSizing: 'border-box' };
                const segBtn  = on => ({ flex: 1, border: 0, background: on ? 'var(--ink-900)' : 'transparent', color: on ? '#fff' : 'var(--ink-600)', padding: '7px 10px', borderRadius: 999, fontFamily: 'var(--font-ui)', fontSize: 13, fontWeight: on ? 600 : 500, cursor: 'pointer', whiteSpace: 'nowrap' });
                const btnSm   = { padding: '9px 16px', borderRadius: 999, border: 0, fontFamily: 'var(--font-ui)', fontSize: 13, fontWeight: 600, cursor: 'pointer', whiteSpace: 'nowrap' };
                const clp = n => '$' + Math.round(n).toLocaleString('es-CL');
                const base = IM_BASES_PRECIO.find(b => b.id === imForm.precio_base);
                const stockNum = parseInt(imForm.stock, 10) || 0;
                const celdas = [
                  { id: 'pvp',        t: 'PVP',           sub: 'con IVA' },
                  { id: 'neto',       t: 'Neto',          sub: 'PVP ÷ 1,19' },
                  { id: 'costo_iva',  t: 'Costo con IVA', sub: 'PVP × (1 − ganancia)' },
                  { id: 'costo_neto', t: 'Costo sin IVA', sub: 'Costo con IVA ÷ 1,19' },
                ];
                const docEnlazable = imForm.tipo_doc === 'GDD' || imForm.tipo_doc === 'Factura';
                const docBox = (fondo, borde, tinta) => ({ marginTop: 10, maxWidth: 640, borderRadius: 10, padding: '10px 14px', fontSize: 13, fontFamily: 'var(--font-ui)', background: fondo, border: `1px solid ${borde}`, color: tinta });
                const docSmall = { display: 'block', marginTop: 2, fontSize: 12, opacity: 0.85 };
                const doc = imDocInfo?.documento;
                const distsVisibles = distribuidores.filter(d => d.activo || d.id === imForm.distribuidor_id);

                return (
                  <>
                    {/* Mensaje resultado */}
                    {imMensaje && (
                      <div style={{ marginBottom: 12, padding: '8px 14px', borderRadius: 8, fontSize: 13, fontFamily: 'var(--font-ui)',
                        background: imMensaje.tipo === 'ok' ? 'var(--ok-bg)' : 'var(--bad-bg)',
                        border: `1px solid ${imMensaje.tipo === 'ok' ? 'var(--ok-line)' : 'var(--bad-line)'}`,
                        color: imMensaje.tipo === 'ok' ? 'var(--ok-ink)' : 'var(--bad-ink)' }}>
                        {imMensaje.tipo === 'ok' ? '✓ ' : '✗ '}{imMensaje.texto}
                        <button type="button" onClick={() => setImMensaje(null)} style={{ float: 'right', background: 'none', border: 'none', cursor: 'pointer', color: 'inherit', fontSize: '1rem' }}>×</button>
                      </div>
                    )}

                    {/* Sección: Libro */}
                    <div style={{ marginBottom: 18 }}>
                      <div style={secH}>Libro</div>
                      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(190px, 1fr))', gap: 10, maxWidth: 960 }}>
                        <div style={{ position: 'relative' }}>
                          <label style={lbl}>ISBN <span style={{ color: 'var(--ink-400)' }}>(opcional)</span></label>
                          <input value={imForm.isbn} placeholder="978…"
                            onChange={e => imSetField('isbn', e.target.value)}
                            onBlur={e => imBuscarIsbn(e.target.value)}
                            style={{ ...inp, fontFamily: 'var(--font-mono)', borderColor: imIsbnInfo?.encontrado ? 'var(--ok-line)' : 'var(--line-strong)' }} />
                          {imIsbnInfo?.encontrado && (
                            <span style={{ position: 'absolute', right: 8, bottom: 11, fontSize: 11, color: 'var(--ok-ink)', fontWeight: 700, pointerEvents: 'none' }}>✓ existe</span>
                          )}
                        </div>
                        <div>
                          <label style={lbl}>Título *</label>
                          <input value={imForm.titulo} required onChange={e => imSetField('titulo', e.target.value)} style={inp} />
                        </div>
                        <div>
                          <label style={lbl}>Autor</label>
                          <input value={imForm.autor} onChange={e => imSetField('autor', e.target.value)} style={inp} />
                        </div>
                        <div>
                          <label style={lbl}>Editorial</label>
                          <input value={imForm.editorial} onChange={e => imSetField('editorial', e.target.value)} style={inp} />
                        </div>
                      </div>
                      {imIsbnInfo?.encontrado && (
                        <div style={{ marginTop: 8, padding: '5px 10px', background: 'var(--ok-bg)', border: '1px solid var(--ok-line)', borderRadius: 6, fontSize: 12, color: 'var(--ok-ink)', fontFamily: 'var(--font-ui)', maxWidth: 960, boxSizing: 'border-box' }}>
                          ISBN ya registrado: <strong>{imIsbnInfo.titulo}</strong>. Se creará un nuevo lote para este libro.
                        </div>
                      )}
                    </div>

                    {/* Sección: Lote (sin rótulo: sigue directo después de Libro) */}
                    <div style={{ marginBottom: 18 }}>
                      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(210px, 1fr))', gap: 10, maxWidth: 960 }}>
                        <div>
                          <label style={lbl}>Distribuidor</label>
                          <select value={imNuevoDistOpen ? '__nuevo' : imForm.distribuidor_id}
                            onChange={e => imElegirDistribuidor(e.target.value)} style={inp}>
                            <option value="">Sin distribuidor</option>
                            {distsVisibles.map(d => <option key={d.id} value={d.id}>{d.nombre}</option>)}
                            <option value="__nuevo">＋ Agregar distribuidor nuevo…</option>
                          </select>
                        </div>
                        <div>
                          <label style={lbl}>Modalidad</label>
                          <div style={segWrap}>
                            <button type="button" style={segBtn(imForm.modalidad === 'firme')} onClick={() => imSetField('modalidad', 'firme')}>Firme</button>
                            <button type="button" style={segBtn(imForm.modalidad === 'consignacion')} onClick={() => imSetField('modalidad', 'consignacion')}>Consignación</button>
                          </div>
                        </div>
                        <div>
                          <label style={lbl}>Stock *</label>
                          <input type="number" min="1" step="1" placeholder="0" required value={imForm.stock}
                            onChange={e => imSetField('stock', e.target.value)} style={inp} />
                        </div>

                        {imNuevoDistOpen && (
                          <div className="im-hint-group" style={{ gridColumn: '1 / -1', background: 'var(--paper)', border: '1px dashed var(--brand-line)', borderRadius: 10, padding: '12px 14px' }}>
                            <div style={{ display: 'flex', gap: 8, alignItems: 'flex-end', flexWrap: 'wrap' }}>
                              <div style={{ flex: '1.4 1 200px' }}>
                                <label style={lbl}>Nombre del distribuidor</label>
                                <input autoFocus value={imNuevoDistNombre} placeholder="Ej: Distribuidora Andes"
                                  onChange={e => setImNuevoDistNombre(e.target.value)}
                                  onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); imCrearDistribuidor(); } }}
                                  style={inp} />
                              </div>
                              <div style={{ flex: '1 1 150px' }}>
                                <label style={lbl}>RUT (obligatorio)</label>
                                <input value={imNuevoDistRut} placeholder="76.123.456-7"
                                  onChange={e => setImNuevoDistRut(e.target.value)}
                                  onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); imCrearDistribuidor(); } }}
                                  style={inp} />
                              </div>
                              <button type="button" onClick={imCrearDistribuidor}
                                disabled={imCreandoDist || !imNuevoDistNombre.trim() || !imNuevoDistRut.trim()}
                                style={{ ...btnSm, background: 'var(--ink-900)', color: '#fff', opacity: imNuevoDistNombre.trim() && imNuevoDistRut.trim() ? 1 : 0.35, cursor: imNuevoDistNombre.trim() && imNuevoDistRut.trim() ? 'pointer' : 'not-allowed' }}>
                                {imCreandoDist ? '…' : 'Crear y usar'}
                              </button>
                              <button type="button" onClick={() => setImNuevoDistOpen(false)}
                                style={{ ...btnSm, background: 'transparent', color: 'var(--ink-600)', border: '1px solid var(--line-strong)' }}>
                                Cancelar
                              </button>
                            </div>
                            <div className="im-hint" style={hint}>Si el RUT ya existe, se selecciona el distribuidor que ya tienes en vez de duplicarlo.</div>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Sección: Precios — un solo valor + ganancia (sin rótulo: la tarjeta ya la delimita) */}
                    <div style={{ marginBottom: 18 }}>
                      <div style={{ background: 'var(--paper)', border: '1px solid var(--line)', borderRadius: 12, padding: 16, maxWidth: 960, boxSizing: 'border-box' }}>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16, alignItems: 'flex-start' }}>
                          <div style={{ flex: '2 1 360px', minWidth: 0 }}>
                            <div style={{ fontSize: 12.5, fontWeight: 600, color: 'var(--ink-800)', marginBottom: 8, fontFamily: 'var(--font-ui)' }}>1 · ¿Con qué precio partes?</div>
                            <div style={{ ...segWrap, display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(100px, 1fr))', borderRadius: 22 }}>
                              {IM_BASES_PRECIO.map(b => (
                                <button key={b.id} type="button" style={segBtn(imForm.precio_base === b.id)} onClick={() => imCambiarBasePrecio(b.id)}>{b.label}</button>
                              ))}
                            </div>
                            <div className="im-hint-group">
                              <div style={{ position: 'relative', marginTop: 10 }}>
                                <span style={{ position: 'absolute', left: 11, top: '50%', transform: 'translateY(-50%)', color: 'var(--ink-400)', fontSize: 14 }}>$</span>
                                <input inputMode="numeric" placeholder="0" required value={imForm.precio_valor}
                                  onChange={e => imSetField('precio_valor', e.target.value)}
                                  style={{ ...inp, paddingLeft: 24, fontSize: 16, fontWeight: 600 }} />
                              </div>
                              <div className="im-hint" style={hint}>{base?.ayuda}</div>
                            </div>
                          </div>
                          <div style={{ flex: '1 1 220px', minWidth: 0 }}>
                            <div style={{ fontSize: 12.5, fontWeight: 600, color: 'var(--ink-800)', marginBottom: 8, fontFamily: 'var(--font-ui)' }}>2 · Ganancia</div>
                            <div className="im-hint-group">
                              <div style={{ position: 'relative' }}>
                                <input inputMode="decimal" placeholder="0" required value={imForm.ganancia_pct}
                                  onChange={e => imSetField('ganancia_pct', e.target.value)}
                                  style={{ ...inp, paddingRight: 28, fontSize: 16, fontWeight: 600 }} />
                                <span style={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', color: 'var(--ink-400)', fontSize: 14 }}>%</span>
                              </div>
                              <div className="im-hint" style={hint}>Sobre el PVP: (PVP − Costo) ÷ PVP</div>
                            </div>
                            {imGananciaSug != null && imNumero(imForm.ganancia_pct) !== imGananciaSug && (
                              <button type="button" onClick={() => imSetField('ganancia_pct', String(imGananciaSug))}
                                style={{ marginTop: 8, padding: '4px 10px', border: 0, borderRadius: 999, background: 'var(--hl-yellow)', color: 'var(--ink-800)', fontFamily: 'var(--font-ui)', fontSize: 12, fontWeight: 500, cursor: 'pointer' }}>
                                {imDistSel.nombre}: usar {imGananciaSug} %
                              </button>
                            )}
                          </div>
                        </div>

                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: 10, marginTop: 16, paddingTop: 16, borderTop: '1px solid var(--line-soft)' }}>
                          {celdas.map(c => {
                            const val = imPrecios[c.id];
                            const esBase = c.id === imForm.precio_base;
                            return (
                              <div key={c.id} style={{ border: `1px solid ${esBase ? 'var(--brand-line)' : 'var(--line)'}`, background: esBase ? 'var(--brand-softer)' : 'var(--paper-soft)', borderRadius: 10, padding: '10px 12px', minHeight: 74 }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', gap: 6, fontSize: 11, color: 'var(--ink-500)', fontFamily: 'var(--font-ui)' }}>
                                  {c.t}
                                  <span style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.04em', textTransform: 'uppercase', color: esBase ? 'var(--brand-strong)' : 'var(--ink-400)' }}>{esBase ? 'Ingresado' : 'Calculado'}</span>
                                </div>
                                <div style={{ marginTop: 6, fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 20, letterSpacing: '-0.01em', fontVariantNumeric: 'tabular-nums', color: val != null ? 'var(--ink-900)' : 'var(--ink-300)' }}>
                                  {val != null ? clp(val) : '—'}
                                </div>
                                <div style={{ fontSize: 11, color: 'var(--ink-400)', marginTop: 2, fontFamily: 'var(--font-ui)' }}>
                                  {val != null ? c.sub : (imPrecios.gananciaOk ? '' : 'Falta la ganancia %')}
                                </div>
                              </div>
                            );
                          })}
                        </div>

                        <div style={{ display: 'flex', gap: 18, flexWrap: 'wrap', marginTop: 12, fontSize: 12.5, color: 'var(--ink-600)', fontFamily: 'var(--font-ui)' }}>
                          {imPrecios.pvp != null && imPrecios.costo_iva != null ? (
                            <>
                              <span>Ganancia por libro: <b style={{ color: 'var(--ok-ink)', fontVariantNumeric: 'tabular-nums' }}>{clp(imPrecios.pvp - imPrecios.costo_iva)}</b></span>
                              {stockNum > 0 && (
                                <span>Lote de <b style={{ color: 'var(--ink-900)' }}>{stockNum}</b> u. · costo total <b style={{ color: 'var(--ink-900)', fontVariantNumeric: 'tabular-nums' }}>{clp(imPrecios.costo_iva * stockNum)}</b> · venta potencial <b style={{ color: 'var(--ink-900)', fontVariantNumeric: 'tabular-nums' }}>{clp(imPrecios.pvp * stockNum)}</b></span>
                              )}
                            </>
                          ) : (
                            <span>Completa el precio de partida y la ganancia para ver el resultado.</span>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* Sección: Documento — enlazado con el módulo Documentos */}
                    <div style={{ marginBottom: 18 }}>
                      <div style={secH}>Documento <span style={secHs}>(opcional)</span></div>
                      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', maxWidth: 640 }}>
                        <div style={{ flex: '0 0 150px' }}>
                          <label style={lbl}>Tipo</label>
                          <select value={imForm.tipo_doc} onChange={e => imSetField('tipo_doc', e.target.value)} style={inp}>
                            <option value="">Sin documento</option>
                            <option value="Factura">Factura</option>
                            <option value="GDD">GDD</option>
                            <option value="Otro">Otro</option>
                          </select>
                        </div>
                        <div style={{ flex: '1 1 180px' }}>
                          <label style={lbl}>Número</label>
                          <input value={imForm.num_doc} placeholder="Ej: 4521" disabled={!imForm.tipo_doc}
                            onChange={e => imSetField('num_doc', e.target.value)}
                            style={{ ...inp, fontFamily: 'var(--font-mono)', opacity: imForm.tipo_doc ? 1 : 0.5 }} />
                        </div>
                        {docEnlazable && imForm.num_doc.trim() && imDocInfo && !imDocInfo.existe && (
                          <div style={{ flex: '0 0 170px' }}>
                            <label style={lbl}>Fecha del documento</label>
                            <input type="date" value={imForm.fecha_doc} onChange={e => imSetField('fecha_doc', e.target.value)} style={inp} />
                          </div>
                        )}
                      </div>

                      {imForm.tipo_doc === 'Otro' && imForm.num_doc.trim() && (
                        <div style={docBox('var(--paper-stripe)', 'var(--line)', 'var(--ink-600)')}>
                          Este tipo de documento se guarda solo como referencia en el lote; no se enlaza con Documentos.
                        </div>
                      )}
                      {docEnlazable && imForm.num_doc.trim() && imDocInfo?.enlazable && imDocInfo.conflicto && (
                        <div style={docBox('var(--warn-bg)', 'var(--warn-line)', 'var(--warn-ink)')}>
                          <b>No se puede enlazar.</b> {imDocInfo.conflicto.mensaje}
                        </div>
                      )}
                      {docEnlazable && imForm.num_doc.trim() && imDocInfo?.enlazable && imDocInfo.existe && !imDocInfo.conflicto && (
                        <div style={docBox('var(--ok-bg)', 'var(--ok-line)', 'var(--ok-ink)')}>
                          ✓ Enlazado con Documentos: <b>{imForm.tipo_doc} {doc.numero}</b>
                          {doc.distribuidor_nombre ? ` · ${doc.distribuidor_nombre}` : ''} · {fmtDocFecha(doc.fecha)}
                          {doc.mnt_total != null ? ` · ${clp(Number(doc.mnt_total))}` : ''}
                          <span style={docSmall}>Este ingreso queda como respaldo del documento y no vuelve a sumar stock.</span>
                        </div>
                      )}
                      {docEnlazable && imForm.num_doc.trim() && imDocInfo?.enlazable && !imDocInfo.existe && (
                        <div style={docBox('var(--info-bg)', 'var(--info-line)', 'var(--info-ink)')}>
                          ＋ No existe en Documentos todavía.
                          <span style={docSmall}>
                            Al guardar se crea <b>{imForm.tipo_doc} {imForm.num_doc.trim()}</b>{imDistSel ? ` de ${imDistSel.nombre}` : ''} ya recibida y enlazada a este lote
                            {imForm.tipo_doc === 'Factura' ? '; queda por pagar. Puedes agregar el monto desde Documentos.' : '.'}
                          </span>
                        </div>
                      )}
                    </div>

                    {/* Notas + botón */}
                    <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'flex-end', maxWidth: 960 }}>
                      <div style={{ flex: '1 1 240px' }}>
                        <label style={lbl}>Notas <span style={{ color: 'var(--ink-400)' }}>(opcional)</span></label>
                        <input placeholder="Ej: llegó con caja dañada" value={imForm.notas}
                          onChange={e => imSetField('notas', e.target.value)} style={inp} />
                      </div>
                      <button type="submit" disabled={imGuardando || !imValido}
                        style={{ padding: '10px 22px', background: imValido ? 'var(--ink-900)' : 'var(--ink-200)', color: '#fff', border: 'none', borderRadius: 999, cursor: imGuardando || !imValido ? 'not-allowed' : 'pointer', fontWeight: 600, fontSize: 14, fontFamily: 'var(--font-ui)', whiteSpace: 'nowrap' }}>
                        {imGuardando ? 'Guardando…' : 'Guardar ingreso'}
                      </button>
                    </div>
                  </>
                );
              })()}
            </form>
        </div>
      )}

      {/* ── Panel Devolución ─────────────────────────────── */}
      {devOpen && (
        <div style={{ background: 'var(--paper-soft)', border: '1px solid var(--line)', borderRadius: 14, padding: '18px 20px', marginBottom: 20 }}>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
            <span style={{ fontWeight: 700, fontSize: 14, fontFamily: 'var(--font-ui)', color: 'var(--ink-900)' }}>Devolución al distribuidor</span>
            <button onClick={() => setDevOpen(false)} style={{ marginLeft: 'auto', background: 'none', border: 'none', cursor: 'pointer', color: 'var(--ink-400)', fontSize: 18, lineHeight: 1, padding: '0 2px' }}>×</button>
          </div>
          <div>
              <p style={{ color: '#666', margin: '0 0 1rem', fontSize: '0.88rem' }}>
                Registrá la devolución de libros a un distribuidor. El stock se descuenta de cada lote al confirmar.
              </p>

              {/* Selector de distribuidor */}
              <div style={{ marginBottom: '1rem', maxWidth: 340 }}>
                <label style={{ display: 'block', fontSize: '0.8rem', color: '#555', marginBottom: '0.3rem' }}>Distribuidor</label>
                <select
                  value={devDistSel?.id || ''}
                  onChange={e => {
                    const dist = distribuidores.find(d => d.id === e.target.value) || null;
                    setDevDistSel(dist);
                    setDevResultado(null);
                    if (dist) cargarStockDev(dist.id);
                    else { setDevLibros([]); setDevSeleccion({}); }
                  }}
                  style={{ width: '100%', padding: '0.43rem 0.6rem', border: '1px solid #ccc', borderRadius: '4px', fontSize: '0.9rem' }}
                >
                  <option value=''>Seleccionar distribuidor…</option>
                  {distribuidores.filter(d => d.activo).map(d => (
                    <option key={d.id} value={d.id}>{d.nombre}</option>
                  ))}
                </select>
              </div>

              {/* Resultado éxito / error */}
              {devResultado && (
                <div style={{ marginBottom: '1rem', padding: '0.6rem 1rem', borderRadius: 'var(--r-md)', fontSize: '0.88rem',
                  background: devResultado.ok ? 'var(--ok-bg)' : 'var(--bad-bg)',
                  border: `1px solid ${devResultado.ok ? 'var(--ok-line)' : 'var(--bad-line)'}` }}>
                  {devResultado.ok
                    ? <><strong>✓ Devolución registrada.</strong> {devResultado.totalUnidades} unidad{devResultado.totalUnidades !== 1 ? 'es' : ''} devuelta{devResultado.totalUnidades !== 1 ? 's' : ''} correctamente.</>
                    : <><strong>Error:</strong> {devResultado.error}</>
                  }
                  <button onClick={() => setDevResultado(null)} style={{ float: 'right', background: 'none', border: 'none', cursor: 'pointer', color: '#999', fontSize: '1rem' }}>×</button>
                </div>
              )}

              {/* Tabla de lotes disponibles */}
              {devDistSel && (
                <div style={{ marginBottom: '1rem' }}>
                  {devCargando && <p style={{ color: '#888', fontSize: '0.88rem' }}>Cargando stock…</p>}

                  {!devCargando && devLibros.length === 0 && (
                    <p style={{ color: '#aaa', fontStyle: 'italic', fontSize: '0.88rem' }}>Sin stock disponible para devolver a {devDistSel.nombre}.</p>
                  )}

                  {!devCargando && devLibros.length > 0 && (
                    <>
                      <div style={{ overflowX: 'auto', marginBottom: '0.75rem' }}>
                        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.86rem' }}>
                          <thead>
                            <tr style={{ background: 'var(--paper-stripe)', borderBottom: '1px solid var(--line)' }}>
                              {['Título','ISBN','Modalidad','PVP','Stock disp.','Cant. a devolver'].map(h => (
                                <th key={h} style={{ padding: '0.4rem 0.5rem', textAlign: h === 'PVP' || h === 'Stock disp.' || h === 'Cant. a devolver' ? 'right' : 'left', fontWeight: 500, color: 'var(--ink-500)', fontSize: '0.78rem', whiteSpace: 'nowrap', textTransform: 'uppercase', letterSpacing: '0.06em' }}>{h}</th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {devLibros.map(l => {
                              const cantStr = devSeleccion[l.lote_id] ?? '';
                              const cant    = parseInt(cantStr);
                              const invalido = cantStr !== '' && (isNaN(cant) || cant < 0 || cant > l.stock);
                              return (
                                <tr key={l.lote_id} style={{ borderBottom: '1px solid var(--line-soft)', background: cant > 0 ? 'var(--ok-bg)' : 'transparent' }}>
                                  <td style={{ padding: '0.38rem 0.5rem', fontWeight: cant > 0 ? 600 : 400 }}>{l.titulo}</td>
                                  <td style={{ padding: '0.38rem 0.5rem', color: '#999', fontSize: '0.8rem', fontFamily: 'monospace' }}>{l.isbn || '—'}</td>
                                  <td style={{ padding: '0.38rem 0.5rem', color: '#666' }}>{l.modalidad}</td>
                                  <td style={{ padding: '0.38rem 0.5rem', textAlign: 'right', color: '#555' }}>${Number(l.pvp).toLocaleString('es-CL')}</td>
                                  <td style={{ padding: '0.38rem 0.5rem', textAlign: 'right', fontWeight: 600, color: 'var(--ok-ink)', fontVariantNumeric: 'tabular-nums' }}>{l.stock}</td>
                                  <td style={{ padding: '0.38rem 0.5rem', textAlign: 'right' }}>
                                    <input
                                      type='number'
                                      min={0}
                                      max={l.stock}
                                      placeholder='0'
                                      value={cantStr}
                                      onChange={e => setDevSeleccion(prev => ({ ...prev, [l.lote_id]: e.target.value }))}
                                      style={{ width: '68px', padding: '0.32rem 0.4rem', border: `1px solid ${invalido ? '#e74c3c' : '#ccc'}`, borderRadius: '4px', fontSize: '0.88rem', textAlign: 'right' }}
                                    />
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>

                      {/* Notas y resumen */}
                      {(() => {
                        const itemsValidos = devLibros.filter(l => {
                          const c = parseInt(devSeleccion[l.lote_id]);
                          return c > 0 && c <= l.stock;
                        });
                        const totalUnidades = itemsValidos.reduce((s, l) => s + parseInt(devSeleccion[l.lote_id]), 0);
                        return (
                          <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'flex-end', flexWrap: 'wrap' }}>
                            <div style={{ flex: 1, minWidth: 220 }}>
                              <label style={{ display: 'block', fontSize: '0.8rem', color: '#555', marginBottom: '0.25rem' }}>Notas <span style={{ color: '#aaa' }}>(opcional)</span></label>
                              <input type='text' placeholder='Motivo de la devolución, nº de guía…'
                                value={devNotas} onChange={e => setDevNotas(e.target.value)}
                                style={{ width: '100%', padding: '0.43rem 0.6rem', border: '1px solid #ccc', borderRadius: '4px', fontSize: '0.88rem', boxSizing: 'border-box' }}
                              />
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                              {totalUnidades > 0 && (
                                <span style={{ fontSize: '0.86rem', color: '#555' }}>
                                  <strong>{itemsValidos.length}</strong> título{itemsValidos.length !== 1 ? 's' : ''} · <strong>{totalUnidades}</strong> unidad{totalUnidades !== 1 ? 'es' : ''}
                                </span>
                              )}
                              <button onClick={confirmarDevolucion} disabled={devGuardando || totalUnidades === 0}
                                style={{ padding: '0.43rem 1.1rem', background: totalUnidades === 0 ? 'var(--ink-200)' : 'var(--bad-ink)', color: 'white', border: 'none', borderRadius: 'var(--r-pill)', cursor: devGuardando || totalUnidades === 0 ? 'not-allowed' : 'pointer', fontWeight: 600, fontSize: '0.88rem', whiteSpace: 'nowrap', fontFamily: 'var(--font-ui)' }}>
                                {devGuardando ? 'Registrando…' : 'Confirmar devolución'}
                              </button>
                            </div>
                          </div>
                        );
                      })()}
                    </>
                  )}
                </div>
              )}

              {/* Historial de devoluciones */}
              <div style={{ marginTop: '1.25rem', borderTop: '1px solid #eee', paddingTop: '1rem' }}>
                <h4 style={{ margin: '0 0 0.6rem', fontSize: '0.92rem', color: 'var(--ink-600)', fontFamily: 'var(--font-ui)' }}>Historial de devoluciones</h4>
                {devCargandoHist && <p style={{ color: '#888', fontSize: '0.88rem' }}>Cargando…</p>}
                {!devCargandoHist && devHistorial.length === 0 && (
                  <p style={{ color: '#aaa', fontStyle: 'italic', fontSize: '0.86rem' }}>No hay devoluciones registradas todavía.</p>
                )}
                {devHistorial.length > 0 && (
                  <div style={{ overflowX: 'auto' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.84rem' }}>
                      <thead>
                        <tr style={{ background: 'var(--paper-stripe)', borderBottom: '1px solid var(--line)' }}>
                          <th style={{ padding: '0.4rem 0.5rem', textAlign: 'left', fontWeight: 500, color: 'var(--ink-500)', fontSize: '0.78rem', textTransform: 'uppercase', letterSpacing: '0.06em' }}></th>
                          <th style={{ padding: '0.4rem 0.5rem', textAlign: 'left', fontWeight: 500, color: 'var(--ink-500)', fontSize: '0.78rem', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Fecha</th>
                          <th style={{ padding: '0.4rem 0.5rem', textAlign: 'left', fontWeight: 500, color: 'var(--ink-500)', fontSize: '0.78rem', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Distribuidor</th>
                          <th style={{ padding: '0.4rem 0.5rem', textAlign: 'right', fontWeight: 500, color: 'var(--ink-500)', fontSize: '0.78rem', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Títulos</th>
                          <th style={{ padding: '0.4rem 0.5rem', textAlign: 'right', fontWeight: 500, color: 'var(--ink-500)', fontSize: '0.78rem', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Unidades</th>
                          <th style={{ padding: '0.4rem 0.5rem', textAlign: 'left', fontWeight: 500, color: 'var(--ink-500)', fontSize: '0.78rem', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Notas</th>
                        </tr>
                      </thead>
                      <tbody>
                        {devHistorial.map(dev => (
                          <React.Fragment key={dev.id}>
                            <tr style={{ borderBottom: '1px solid var(--line-soft)', cursor: 'pointer', background: devDetalle.has(dev.id) ? 'var(--paper-soft)' : 'transparent' }}
                              onClick={() => toggleDevDetalle(dev.id)}>
                              <td style={{ padding: '0.38rem 0.5rem', color: 'var(--ink-300)', fontSize: '0.8rem' }}>{devDetalle.has(dev.id) ? '▴' : '▾'}</td>
                              <td style={{ padding: '0.38rem 0.5rem', whiteSpace: 'nowrap', color: 'var(--ink-600)' }}>
                                {new Date(dev.creado_en).toLocaleString('es-CL', { day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit' })}
                              </td>
                              <td style={{ padding: '0.38rem 0.5rem', color: 'var(--ink-700)' }}>{dev.distribuidor}</td>
                              <td style={{ padding: '0.38rem 0.5rem', textAlign: 'right', color: 'var(--ink-700)', fontVariantNumeric: 'tabular-nums' }}>{dev.total_items}</td>
                              <td style={{ padding: '0.38rem 0.5rem', textAlign: 'right', fontWeight: 600, color: 'var(--ink-900)', fontVariantNumeric: 'tabular-nums' }}>{dev.total_unidades}</td>
                              <td style={{ padding: '0.38rem 0.5rem', color: 'var(--ink-500)', fontStyle: dev.notas ? 'normal' : 'italic' }}>{dev.notas || '—'}</td>
                            </tr>
                            {devDetalle.has(dev.id) && dev.detalle.map(d => (
                              <tr key={d.id} style={{ background: 'var(--paper-soft)', borderBottom: '1px solid var(--line-soft)' }}>
                                <td />
                                <td colSpan={2} style={{ padding: '0.3rem 0.5rem 0.3rem 1.5rem', color: 'var(--ink-700)', fontSize: '0.83rem' }}>
                                  {d.titulo}{d.isbn ? <span style={{ color: 'var(--ink-300)', marginLeft: '0.4rem', fontFamily: 'var(--font-mono)' }}>{d.isbn}</span> : ''}
                                  <span style={{ color: 'var(--ink-400)', marginLeft: '0.4rem', fontSize: '0.78rem' }}>{d.modalidad}</span>
                                </td>
                                <td colSpan={3} style={{ padding: '0.3rem 0.5rem', textAlign: 'right', fontWeight: 600, color: 'var(--bad-ink)', fontSize: '0.83rem' }}>
                                  −{d.cantidad} u.
                                </td>
                              </tr>
                            ))}
                          </React.Fragment>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
        </div>
      )}


      {/* ── Búsqueda ─────────────────────────────────────── */}
      {/* Con el panel Ingreso manual abierto se oculta (no se desmonta) la búsqueda y la tabla: el panel usa toda la pantalla */}
      <div style={{ display: imOpen ? 'none' : 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
        <input ref={invBusquedaRef} placeholder="Buscar título, ISBN, autor, editorial…" value={busqueda} onChange={e => { setBusqueda(e.target.value); cargarLibros(); }}
          onKeyDown={e => { if (e.key === 'Enter') invBusquedaRef.current?.select(); }}
          style={{ flex: 1, padding: '9px 16px', border: '1px solid var(--line)', borderRadius: 'var(--r-pill)', fontSize: 13, fontFamily: 'var(--font-ui)', outline: 'none', background: 'var(--paper)', color: 'var(--ink-900)' }} />
        {busqueda.trim() && librosFiltradosOrdenados.length > MAX_FILAS && (
          <span style={{ fontSize: 12, color: 'var(--ink-400)', fontFamily: 'var(--font-ui)', whiteSpace: 'nowrap' }}>
            {MAX_FILAS} de {librosFiltradosOrdenados.length} — afina la búsqueda
          </span>
        )}
      </div>

      {/* ── Tabla ───────────────────────────────────────── */}
      <div style={{ display: imOpen ? 'none' : undefined, flex: 1, height: 0, overflowY: 'auto', overflowX: 'auto', border: '1px solid var(--line)', borderRadius: 12 }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.87rem', fontFamily: 'var(--font-ui)' }}>
          <thead style={{ position: 'sticky', top: 0, zIndex: 1 }}>
            <tr style={{ background: 'var(--paper-stripe)', borderBottom: '1px solid var(--line)' }}>
              <th style={{ width: 56, padding: '10px 0 10px 16px' }} />
              {columnasVisibles.map(col => {
                const ordenActivo = sortCol === col.id;
                return (
                  <th key={col.id}
                    onClick={() => handleSort(col.id)}
                    style={{ padding: '10px 12px', textAlign: 'left', fontWeight: 600, color: ordenActivo ? 'var(--ink-900)' : 'var(--ink-500)', fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.06em', whiteSpace: 'nowrap', cursor: 'pointer', userSelect: 'none' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.3rem' }}>
                      {col.label}
                      {ordenActivo && <span style={{ fontSize: 9, color: 'var(--ink-900)', lineHeight: 1 }}>{sortDir === 'asc' ? '▲' : '▼'}</span>}
                    </div>
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {filasVisibles.length === 0
              ? <tr><td colSpan={columnasVisibles.length + 1} style={{ padding: '3rem', textAlign: 'center', color: 'var(--ink-300)', fontFamily: 'var(--font-ui)', fontSize: 13, fontStyle: 'italic' }}>
                  {cargandoLibros ? 'Cargando…' : !busqueda.trim() ? 'Escribe para buscar en el inventario' : 'Sin resultados para la búsqueda.'}
                </td></tr>
              : filasVisibles.map(l => {
                  const tone = TONE_STYLES[itemTone(l.id)] || TONE_STYLES['peach'];
                  return (
                  <tr key={l.id} onClick={() => abrirFicha(l)}
                    style={{ borderBottom: '1px solid var(--line-soft)', cursor: 'pointer', transition: 'background var(--t-fast)' }}
                    onMouseEnter={e => e.currentTarget.style.background = 'var(--brand-softer)'}
                    onMouseLeave={e => e.currentTarget.style.background = ''}>
                    <td style={{ padding: '8px 0 8px 16px', verticalAlign: 'middle', width: 56 }}>
                      <span style={{ width: 40, height: 40, borderRadius: '50%', flexShrink: 0, background: tone.bg, color: tone.ink, display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                        <BookOpen size={17} strokeWidth={1.75} />
                      </span>
                    </td>
                    {columnasVisibles.map(col => (
                      <td key={col.id} style={{ padding: '12px 12px', verticalAlign: 'middle' }}>
                        {renderCelda(col, l)}
                      </td>
                    ))}
                  </tr>
                  );
                })
            }
          </tbody>
        </table>
      </div>

      {/* ── Picker de columnas ──────────────────────────── */}
      {pickerOpen && (
        <InvColumnasPicker colsActivas={colsActivas} setColsActivas={setColsActivas} periodos={periodos} setPeriodos={setPeriodos} onClose={() => setPickerOpen(false)} />
      )}

      {/* ── Ficha del libro ─────────────────────────────── */}
      {fichaLibro && (
        <InvFichaLibro libro={fichaLibro} abierto={fichaAbierta} onClose={cerrarFicha} onLibroActualizado={() => recargarLibros()} />
      )}
    </div>
    </div>

    {/* ── Modal: selector de catálogo para vincular ─────────────────────── */}
    {vincularCatalogos !== null && (
      <div style={{ position: 'fixed', inset: 0, background: 'var(--scrim)', zIndex: 300, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
        <div style={{ background: 'var(--paper)', borderRadius: 16, padding: 28, minWidth: 420, maxWidth: 520, width: '100%', boxShadow: 'var(--shadow-pop)' }}>
          <h3 style={{ margin: '0 0 8px', fontFamily: 'var(--font-display)', fontSize: 20, fontWeight: 800, color: 'var(--ink-900)', letterSpacing: '-0.02em' }}>Vincular ISBNs</h3>
          <p style={{ margin: '0 0 18px', fontSize: 13, color: 'var(--ink-500)', fontFamily: 'var(--font-ui)', lineHeight: 1.5 }}>
            Seleccioná el catálogo de distribuidor con el que querés vincular el inventario migrado.
          </p>
          {vincularCatalogos.length === 0 ? (
            <p style={{ color: 'var(--ink-400)', fontFamily: 'var(--font-ui)', fontSize: 13, fontStyle: 'italic', marginBottom: 18 }}>
              No hay catálogos cargados. Subí un catálogo desde el módulo Catálogos primero.
            </p>
          ) : (
            <select
              value={vincularCatSel}
              onChange={e => setVincularCatSel(e.target.value)}
              style={{ width: '100%', padding: '8px 10px', border: '1px solid var(--line)', borderRadius: 8, fontSize: 13, fontFamily: 'var(--font-ui)', marginBottom: 18, background: 'var(--paper)', color: 'var(--ink-900)' }}
            >
              {vincularCatalogos.map(c => (
                <option key={c.id} value={c.id}>
                  {c.distribuidor_nombre} — {new Date(c.creado_en).toLocaleDateString('es-CL')} ({c.total_titulos ?? '?'} títulos)
                </option>
              ))}
            </select>
          )}
          <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
            <button
              onClick={() => setVincularCatalogos(null)}
              style={{ padding: '8px 18px', background: 'none', border: '1px solid var(--line)', borderRadius: 'var(--r-pill)', cursor: 'pointer', fontSize: 13, fontFamily: 'var(--font-ui)', color: 'var(--ink-600)' }}
            >Cancelar</button>
            <button
              onClick={() => vincularCatSel && abrirVincularInv(vincularCatSel)}
              disabled={!vincularCatSel || vincularCatalogos.length === 0}
              style={{ padding: '8px 20px', background: 'var(--brand)', color: '#fff', border: 'none', borderRadius: 'var(--r-pill)', cursor: vincularCatSel ? 'pointer' : 'not-allowed', fontSize: 13, fontFamily: 'var(--font-ui)', fontWeight: 700, opacity: vincularCatSel ? 1 : 0.5 }}
            >Ver coincidencias →</button>
          </div>
        </div>
      </div>
    )}

    {/* ── Modal: panel de vinculación ISBN ──────────────────────────────── */}
    {vincularPanel && (
      <div style={{ position: 'fixed', inset: 0, background: 'var(--scrim)', zIndex: 300, display: 'flex', alignItems: 'flex-start', justifyContent: 'center', overflow: 'auto', padding: '32px 16px' }}>
        <div style={{ background: 'var(--paper)', borderRadius: 16, padding: 24, width: '100%', maxWidth: 900, boxShadow: 'var(--shadow-pop)' }}>
          {vincularPanel.cargando ? (
            <div style={{ padding: '2rem', textAlign: 'center' }}>
              <div style={{ fontSize: 14, color: 'var(--ink-500)', fontFamily: 'var(--font-ui)' }}>🔍 Buscando coincidencias de ISBN…</div>
            </div>
          ) : vincularPanel.errorMsg ? (
            <div style={{ padding: '1rem' }}>
              <div style={{ background: 'var(--err-bg)', border: '1px solid var(--err-line)', borderRadius: 8, padding: '12px 16px', color: 'var(--err-ink)', fontSize: 13, fontFamily: 'var(--font-ui)', marginBottom: 12 }}>
                {vincularPanel.errorMsg}
              </div>
              <button onClick={() => setVincularPanel(null)}
                style={{ padding: '7px 18px', background: 'none', border: '1px solid var(--line)', borderRadius: 'var(--r-pill)', cursor: 'pointer', fontSize: 13, fontFamily: 'var(--font-ui)' }}>
                Cerrar
              </button>
            </div>
          ) : vincularPanel.data && (
            <PanelVincular
              data={vincularPanel.data}
              seleccionados={vincularPanel.seleccionados}
              conflictoElegido={vincularPanel.conflictoElegido}
              aceptarTitulo={vincularPanel.aceptarTitulo}
              cambiosAdicionales={vincularPanel.cambiosAdicionales}
              confirmando={vincularPanel.confirmando}
              onToggleMatch={libroId => setVincularPanel(prev => {
                const sel = new Set(prev.seleccionados);
                sel.has(libroId) ? sel.delete(libroId) : sel.add(libroId);
                return { ...prev, seleccionados: sel };
              })}
              onToggleAll={todosOn => setVincularPanel(prev => ({
                ...prev, seleccionados: todosOn ? new Set(prev.data.matches.map(m => m.libro_id)) : new Set(),
              }))}
              onConflictoChange={(libroId, distId) => setVincularPanel(prev => ({
                ...prev, conflictoElegido: { ...prev.conflictoElegido, [libroId]: distId },
              }))}
              onAceptarTitulo={(libroId, val) => setVincularPanel(prev => ({
                ...prev, aceptarTitulo: { ...prev.aceptarTitulo, [libroId]: val },
              }))}
              onCambioAdicional={handleCambioAdicionalInv}
              onConfirmar={confirmarVincularInv}
              onCancelar={() => setVincularPanel(null)}
            />
          )}
        </div>
      </div>
    )}
    </>
  );
}

function Lotes() {
  const [lotes, setLotes] = useState([]);
  const [libros, setLibros] = useState([]);
  const [distribuidores, setDistribuidores] = useState([]);
  const [form, setForm] = useState({ libro_id: '', distribuidor_id: '', modalidad: 'firme', pvp: '', cantidad: '' });
  const [cargando, setCargando] = useState(false);
  const [filtroDistribuidor, setFiltroDistribuidor] = useState('');
  const [filtroModalidad,    setFiltroModalidad]    = useState('');

  useEffect(() => { cargarTodo(); }, []);

  async function cargarTodo() {
    try {
      const [l, d, lo] = await Promise.all([api.get('/libros'), api.get('/distribuidores'), api.get('/lotes')]);
      setLibros(l.data);
      setDistribuidores(d.data);
      setLotes(lo.data);
    } catch (e) { console.error('cargarTodo lotes:', e.message); }
  }

  async function agregarLote(e) {
    e.preventDefault();
    setCargando(true);
    const distribuidor = distribuidores.find(d => d.id === form.distribuidor_id);
    await api.post('/lotes', { ...form, factor_pago: distribuidor.factor_pago });
    setForm({ libro_id: '', distribuidor_id: '', modalidad: 'firme', pvp: '', cantidad: '' });
    await cargarTodo();
    setCargando(false);
  }

  const lotesFiltrados = lotes.filter(l => {
    if (filtroDistribuidor && l.distribuidor_id !== filtroDistribuidor) return false;
    if (filtroModalidad    && l.modalidad       !== filtroModalidad)    return false;
    return true;
  });

  const MODALIDADES = [
    { value: '',              label: 'Todos' },
    { value: 'firme',        label: 'Firme' },
    { value: 'consignacion', label: 'Consignación' },
  ];

  const hayFiltro = filtroDistribuidor || filtroModalidad;

  return (
    <div>
      <h2>Inventario — Ingresar stock</h2>
      <form onSubmit={agregarLote} style={{ marginBottom: '2rem' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', maxWidth: '400px' }}>
          <select value={form.libro_id} onChange={e => setForm({ ...form, libro_id: e.target.value })} required style={{ padding: '0.5rem' }}>
            <option value="">Seleccionar libro *</option>
            {libros.map(l => <option key={l.id} value={l.id}>{l.titulo}</option>)}
          </select>
          <select value={form.distribuidor_id} onChange={e => setForm({ ...form, distribuidor_id: e.target.value })} required style={{ padding: '0.5rem' }}>
            <option value="">Seleccionar distribuidor *</option>
            {distribuidores.map(d => <option key={d.id} value={d.id}>{d.nombre}</option>)}
          </select>
          <select value={form.modalidad} onChange={e => setForm({ ...form, modalidad: e.target.value })} style={{ padding: '0.5rem' }}>
            <option value="firme">Firme</option>
            <option value="consignacion">Consignación</option>
            <option value="migracion">Migración</option>
          </select>
          <input placeholder="PVP *" type="number" step="1" value={form.pvp} onChange={e => setForm({ ...form, pvp: e.target.value })} required style={{ padding: '0.5rem' }} />
          <input placeholder="Cantidad *" type="number" step="1" value={form.cantidad} onChange={e => setForm({ ...form, cantidad: e.target.value })} required style={{ padding: '0.5rem' }} />
          <button type="submit" disabled={cargando} style={{ padding: '0.5rem', background: '#2c2c2a', color: 'white', border: 'none', cursor: 'pointer' }}>
            {cargando ? 'Guardando...' : 'Ingresar stock'}
          </button>
        </div>
      </form>

      {/* ── Filtros ── */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem', flexWrap: 'wrap' }}>
        <h3 style={{ margin: 0 }}>Stock actual</h3>

        {/* Filtro por distribuidor */}
        <select
          value={filtroDistribuidor}
          onChange={e => setFiltroDistribuidor(e.target.value)}
          style={{ padding: '0.4rem 0.7rem', border: '1px solid #ddd', borderRadius: '6px', fontSize: '0.88rem', color: filtroDistribuidor ? '#2c2c2a' : '#888', background: 'white' }}
        >
          <option value="">Todos los distribuidores</option>
          {distribuidores.map(d => <option key={d.id} value={d.id}>{d.nombre}</option>)}
        </select>

        {/* Filtro por modalidad — botones segmentados */}
        <div style={{ display: 'flex', border: '1px solid #ddd', borderRadius: '6px', overflow: 'hidden' }}>
          {MODALIDADES.map(m => (
            <button
              key={m.value}
              onClick={() => setFiltroModalidad(m.value)}
              style={{
                padding: '0.4rem 0.85rem',
                border: 'none',
                borderRight: m.value !== 'consignacion' ? '1px solid #ddd' : 'none',
                background: filtroModalidad === m.value ? '#2c2c2a' : 'white',
                color: filtroModalidad === m.value ? 'white' : '#555',
                cursor: 'pointer',
                fontSize: '0.85rem',
                fontWeight: filtroModalidad === m.value ? 600 : 400,
                transition: 'background 0.15s',
              }}
            >
              {m.label}
            </button>
          ))}
        </div>

        {/* Contador y limpiar */}
        <span style={{ fontSize: '0.84rem', color: '#888', marginLeft: 'auto' }}>
          {lotesFiltrados.length} de {lotes.length} lote{lotes.length !== 1 ? 's' : ''}
          {hayFiltro && (
            <button
              onClick={() => { setFiltroDistribuidor(''); setFiltroModalidad(''); }}
              style={{ marginLeft: '0.6rem', background: 'none', border: 'none', color: '#c0392b', cursor: 'pointer', fontSize: '0.82rem', padding: 0, textDecoration: 'underline' }}
            >
              Limpiar filtros
            </button>
          )}
        </span>
      </div>

      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr style={{ textAlign: 'left', borderBottom: '2px solid #ccc' }}>
            <th style={{ padding: '0.5rem' }}>Título</th>
            <th style={{ padding: '0.5rem' }}>Distribuidor</th>
            <th style={{ padding: '0.5rem' }}>Modalidad</th>
            <th style={{ padding: '0.5rem' }}>PVP</th>
            <th style={{ padding: '0.5rem' }}>Costo real</th>
            <th style={{ padding: '0.5rem' }}>Stock</th>
          </tr>
        </thead>
        <tbody>
          {lotesFiltrados.length === 0
            ? <tr><td colSpan={6} style={{ padding: '1.5rem 0.5rem', color: '#aaa', textAlign: 'center' }}>Sin resultados para los filtros aplicados.</td></tr>
            : lotesFiltrados.map(l => (
              <tr key={l.id} style={{ borderBottom: '1px solid #eee' }}>
                <td style={{ padding: '0.5rem' }}>{l.titulo}</td>
                <td style={{ padding: '0.5rem' }}>{l.distribuidor}</td>
                <td style={{ padding: '0.5rem' }}>{l.modalidad}</td>
                <td style={{ padding: '0.5rem' }}>${Number(l.pvp).toLocaleString('es-CL')}</td>
                <td style={{ padding: '0.5rem' }}>${Number(l.costo_real).toLocaleString('es-CL')}</td>
                <td style={{ padding: '0.5rem' }}>{l.stock}</td>
              </tr>
            ))
          }
        </tbody>
      </table>
    </div>
  );
}

// ── Documentos v2 — visual helpers (no lógica) ───────────────────────────────
const DOC_TIPO_TONE_MAP = { gdd: 'blue', factura: 'peach', nota_credito: 'violet', nota_debito: 'rose' };

// ── Documentos design system — flow / track constants ────────────────────────
// Nota de crédito y nota de débito son opuestas: la primera reduce lo que se
// debe al proveedor (ingreso), la segunda lo aumenta (gasto). Se distinguen
// por color y etiqueta para no confundirlas al revisar el historial.
const DOC_DM_FLOW = {
  gdd:          ['emitida', 'en_recepcion', 'recibida'],
  factura:      ['emitida', 'pagada'],
  nota_credito: ['emitida', 'pagada'],
  nota_debito:  ['emitida', 'pagada'],
};
const DOC_DM_STAGE_LABEL = {
  emitida: 'Emitida', en_recepcion: 'En recepción',
  recibida: 'Recibida', pagada: 'Pagada',
};
const DOC_DM_TIPO_META = {
  gdd:          { label: 'GDD',             sub: 'se recibe', tone: 'blue'   },
  factura:      { label: 'Factura',         sub: 'se paga',   tone: 'peach'  },
  nota_credito: { label: 'Nota de crédito', sub: 'se aplica', tone: 'violet' },
  nota_debito:  { label: 'Nota de débito',  sub: 'se paga',   tone: 'rose'   },
};
const DOC_DM_ADVANCE = {
  gdd:          { emitida: { label: 'Recepcionar',         isGdd: true  }, en_recepcion: { label: 'Continuar recepción', isGdd: true }, parcialmente_recibida: { label: 'Continuar recepción', isGdd: true } },
  factura:      { emitida: { label: 'Marcar pagada',       isGdd: false } },
  nota_credito: { emitida: { label: 'Marcar pagada',       isGdd: false } },
  nota_debito:  { emitida: { label: 'Marcar pagada',       isGdd: false } },
};
const DOC_DM_TERMINAL = { gdd: 'Recibida', factura: 'Pagada', nota_credito: 'Pagada', nota_debito: 'Pagada' };

function docDmNormEstado(tipo, estado) {
  // "recibida" ya no es un paso obligatorio de la factura: las que quedaron así esperan pago igual que una emitida
  if (tipo === 'factura' && (estado === 'recibida' || estado === 'en_recepcion' || estado === 'parcialmente_recibida')) return 'emitida';
  if (tipo === 'gdd' && (estado === 'completa' || estado === 'cerrada_incompleta')) return 'recibida';
  if (tipo === 'gdd' && estado === 'parcialmente_recibida') return 'en_recepcion';
  return estado;
}

function DocDmTrack({ tipo, estado }) {
  const track = DOC_DM_FLOW[tipo] || [];
  const norm  = docDmNormEstado(tipo, estado);
  const idx   = track.indexOf(norm);
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {track.map((st, i) => (
        <React.Fragment key={st}>
          <span style={{
            width: i === idx ? 11 : 9, height: i === idx ? 11 : 9,
            borderRadius: '50%', flexShrink: 0, display: 'inline-block',
            background: i <= idx ? 'var(--brand)' : 'var(--line-strong)',
            boxShadow: i === idx ? '0 0 0 3px var(--brand-softer)' : 'none',
            transition: 'all 180ms ease',
          }} />
          {i < track.length - 1 && (
            <span style={{ width: 22, height: 2, background: i < idx ? 'var(--brand)' : 'var(--line)', borderRadius: 2, display: 'inline-block' }} />
          )}
        </React.Fragment>
      ))}
    </div>
  );
}
const DOC_TONE_BG  = { blue: 'var(--past-blue)', peach: 'var(--past-peach)', violet: 'var(--past-violet)', sand: 'var(--past-sand)' };
const DOC_TONE_INK = { blue: 'var(--past-blue-ink)', peach: 'var(--past-peach-ink)', violet: 'var(--past-violet-ink)', sand: 'var(--past-sand-ink)' };
const DOC_ESTADO_PILL_STYLE = {
  emitida:            { background: 'var(--info-bg)',   color: 'var(--info-ink)' },
  recibida:           { background: 'var(--past-blue)', color: 'var(--past-blue-ink)' },
  pagada:             { background: 'var(--ok-bg)',     color: 'var(--ok-ink)' },
  anulada:            { background: 'var(--bad-bg)',    color: 'var(--bad-ink)' },
  en_recepcion:       { background: 'var(--warn-bg)',   color: 'var(--warn-ink)' },
  completa:           { background: 'var(--ok-bg)',     color: 'var(--ok-ink)' },
  cerrada_incompleta: { background: 'var(--warn-bg)',   color: 'var(--warn-ink)' },
};
const DOC_TH = {
  textAlign: 'left', padding: '12px 16px',
  fontSize: 11, color: 'var(--ink-500)',
  textTransform: 'uppercase', letterSpacing: '0.08em',
  fontWeight: 500, whiteSpace: 'nowrap',
};
const DOC_TD = { padding: '14px 16px', verticalAlign: 'middle' };
// Aviso de una sola línea con ícono (editor de documentos): tono 'warn' | 'bad' | 'ok' | 'neutro'
function AvisoDoc({ tono = 'warn', children }) {
  const t = {
    warn:   ['var(--warn-bg)', 'var(--warn-line)', 'var(--warn-ink)'],
    bad:    ['var(--bad-bg)',  'var(--bad-line)',  'var(--bad-ink)'],
    ok:     ['var(--ok-bg)',   'var(--ok-line)',   'var(--ok-ink)'],
    neutro: ['var(--paper-stripe)', 'var(--line)', 'var(--ink-600)'],
  }[tono];
  const Icono = tono === 'ok' ? CheckCircle : tono === 'warn' ? AlertTriangle : CircleAlert;
  return (
    <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8, background: t[0], border: '1px solid ' + t[1], borderRadius: 8, padding: '6px 10px', marginBottom: 6, fontSize: 12.5, lineHeight: 1.4, color: t[2] }}>
      <Icono size={14} strokeWidth={2} style={{ flexShrink: 0, marginTop: 2 }} />
      <span style={{ minWidth: 0 }}>{children}</span>
    </div>
  );
}
function fmtDocFecha(f) {
  try {
    if (!f) return '—';
    // La DB puede devolver timestamp completo ('2026-05-28T03:00:00.000Z').
    // Tomamos solo los 10 primeros caracteres para evitar concatenar 'T12:00:00'
    // a un string que ya tiene zona horaria, lo que produce Invalid Date.
    const datePart = String(f).slice(0, 10);
    return new Date(datePart + 'T12:00:00').toLocaleDateString('es-CL', { day: '2-digit', month: 'short', year: 'numeric' });
  }
  catch (e) { return f || '—'; }
}
const DOC_ETIQUETA_ESTADO = { emitida: 'emitida', recibida: 'recibida', pagada: 'pagada', anulada: 'anulada', en_recepcion: 'en recepción', parcialmente_recibida: 'parcial', completa: 'completa', cerrada_incompleta: 'incompleta' };
function docDrawerIconCircle(tipo, size = 32) {
  const tone = DOC_TIPO_TONE_MAP[tipo] || 'sand';
  const bg   = DOC_TONE_BG[tone]  || 'var(--past-sand)';
  const ink  = DOC_TONE_INK[tone] || 'var(--past-sand-ink)';
  const Icon = tipo === 'gdd' ? Truck : tipo === 'factura' ? Receipt : FileMinus;
  const iconSize = Math.round(size * 0.44);
  return (
    <div style={{ width: size, height: size, borderRadius: '50%', background: bg, color: ink, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
      <Icon size={iconSize} strokeWidth={1.75} />
    </div>
  );
}
function docDrawerEstadoPill(estado) {
  const s = DOC_ESTADO_PILL_STYLE[estado] || { background: 'var(--paper-stripe)', color: 'var(--ink-600)' };
  return (
    <span style={{ ...s, padding: '3px 11px', borderRadius: 999, fontSize: 12, fontWeight: 500, whiteSpace: 'nowrap', display: 'inline-flex', alignItems: 'center' }}>
      {DOC_ETIQUETA_ESTADO[estado] || estado}
    </span>
  );
}

// ── DocDetalleDrawer — drawer de detalle de documento, reutilizable ─────────
// Usado por el módulo Documentos (lista) y por Finanzas (Facturas impagas).
const ES_CAMPO_DE_TEXTO = /^(INPUT|TEXTAREA|SELECT)$/;
const MEDIOS_PAGO = [['transferencia', 'Transferencia'], ['efectivo', 'Efectivo'], ['cheque', 'Cheque'], ['tarjeta', 'Tarjeta'], ['otro', 'Otro']];
// Propósitos a los que se puede cambiar un documento ya ingresado (entre gasto y libros no se cambia)
const PROPOSITOS_EDITABLES = {
  gdd:          ['ingreso_mercaderia'],
  factura:      ['ingreso_mercaderia', 'cobro_consignacion'],
  nota_credito: ['otro'],
  nota_debito:  ['otro'],
};
const ETIQUETA_PROPOSITO_DOC = { ingreso_mercaderia: 'Ingreso de mercadería', cobro_consignacion: 'Liquidación de consignación', otro: 'Ajuste o corrección', gasto_servicio: 'Gasto o servicio' };

// Resumen corto del stock que ya existe de un libro: "tienes 2 a $ 10.000 de Distribuidora Planeta"
function resumenStockPrevio(tandas) {
  const money = n => `$ ${Math.round(Number(n)).toLocaleString('es-CL')}`;
  const stock = tandas.reduce((n, t) => n + Number(t.stock), 0);
  const precios = [...new Set(tandas.map(t => Number(t.pvp)))];
  if (precios.length > 1) return `tienes ${stock} a precios distintos`;
  const otras = [...new Set(tandas.filter(t => !t.misma_distribuidora).map(t => t.distribuidor))];
  return `tienes ${stock} a ${money(precios[0])}${otras.length === 1 && otras.length === new Set(tandas.map(t => t.distribuidor)).size ? ` de ${otras[0]}` : ''}`;
}

// Se despliega bajo un libro de la recepción cuando llega a un PVP distinto al del stock que ya existe: el librero
// decide con qué precio queda ('separados' = cada tanda con el suyo; 'igualar' = un mismo precio para todo).
function PrecioDistintoCard({ tandas, pvpNuevo, costoNuevo, llegan, distribuidorDoc, decisionActual, onConfirmar, onCerrar }) {
  const money = n => `$ ${Math.round(Number(n)).toLocaleString('es-CL')}`;
  const stock = tandas.reduce((n, t) => n + Number(t.stock), 0);
  const total = stock + llegan;
  const viejos = [...new Set(tandas.map(t => Number(t.pvp)))];
  const maxViejo = Math.max(...viejos), minViejo = Math.min(...viejos);
  const hayOtra = tandas.some(t => !t.misma_distribuidora);
  const pctCambio = Math.round(((pvpNuevo - viejos[0]) / viejos[0]) * 100);
  const margen = pr => (costoNuevo > 0 && pr > 0 ? Math.round(((pr - costoNuevo) / pr) * 100) : null);
  const [sel, setSel] = useState(decisionActual?.opcion || null);
  const [otro, setOtro] = useState(decisionActual?.opcion === 'otro' ? String(decisionActual.precio) : '');
  const [error, setError] = useState('');

  // Efecto de dejar un mismo precio a todo: margen de los nuevos y lo que se deja de ganar
  function efectoIgualar(pr) {
    const avisos = [];
    const perdida = tandas.reduce((n, t) => n + (Number(t.pvp) > pr ? (Number(t.pvp) - pr) * Number(t.stock) : 0), 0);
    if (pr < pvpNuevo) avisos.push(`Ganas ${money(pvpNuevo - pr)} menos por cada libro nuevo.`);
    if (perdida > 0) avisos.push(`Dejas de ganar ${money(perdida)} en lo que ya tenías.`);
    if (tandas.some(t => !t.misma_distribuidora && Number(t.pvp) !== pr)) avisos.push('Modifica stock de otra distribuidora.');
    const m = margen(pr);
    return { margen: m != null ? `Margen de los nuevos: ${m} %` : null, avisos };
  }

  const separados = {
    id: 'separados',
    titulo: tandas.length === 1 && !hayOtra ? `Dejar ${stock} a ${money(viejos[0])} y ${llegan} a ${money(pvpNuevo)}` : 'Dejar cada uno con su precio',
    desc: `Lo que ya tienes no se toca; los ${llegan} nuevos entran a ${money(pvpNuevo)}.`,
    margen: margen(pvpNuevo) != null ? `Margen de los nuevos: ${margen(pvpNuevo)} %` : null,
    avisos: ['Quedan precios distintos del mismo libro, como filas separadas en el POS. Al escanear, el POS toma la tanda más reciente.'],
    decision: { modo: 'separados' }, resumen: 'Cada uno con su precio',
  };
  const nuevo = {
    id: 'nuevo',
    titulo: pvpNuevo > maxViejo ? `Subir todo a ${money(pvpNuevo)}` : pvpNuevo < minViejo ? `Bajar todo a ${money(pvpNuevo)}` : `Poner ${money(pvpNuevo)} a los ${total}`,
    desc: `Los ${stock} que ya tienes y los ${llegan} nuevos quedan a ${money(pvpNuevo)}.`,
    ...(() => { const e = efectoIgualar(pvpNuevo); return { margen: e.margen, avisos: e.avisos }; })(),
    decision: { modo: 'igualar', precio: pvpNuevo }, resumen: `Todo a ${money(pvpNuevo)}`,
  };
  const mantener = viejos.length === 1 ? {
    id: 'mantener',
    titulo: `Mantener ${money(viejos[0])} para los ${total}`,
    desc: `Los ${llegan} nuevos entran a ${money(viejos[0])}.`,
    ...(() => { const e = efectoIgualar(viejos[0]); return { margen: e.margen, avisos: e.avisos }; })(),
    decision: { modo: 'igualar', precio: viejos[0] }, resumen: `Todo a ${money(viejos[0])}`,
  } : null;
  const orden = hayOtra ? [separados, nuevo, mantener]
    : pvpNuevo > maxViejo ? [nuevo, separados, mantener]
    : pvpNuevo < minViejo ? [nuevo, mantener, separados]
    : [separados, nuevo, mantener];
  const opciones = orden.filter(Boolean);
  const otroV = Math.round(Number(otro));
  const otroEfecto = otroV > 0 ? efectoIgualar(otroV) : null;

  function confirmar() {
    if (!sel) { setError('Elige una opción para continuar.'); return; }
    if (sel === 'otro') {
      if (!(otroV > 0)) { setError('Escribe el precio.'); return; }
      onConfirmar({ opcion: 'otro', modo: 'igualar', precio: otroV, resumen: `Todo a ${money(otroV)}` });
      return;
    }
    const op = opciones.find(o => o.id === sel);
    onConfirmar({ opcion: op.id, ...op.decision, resumen: op.resumen });
  }

  const lineaOpcion = (on) => ({ display: 'flex', gap: 10, alignItems: 'flex-start', padding: '9px 11px', marginBottom: 6, borderRadius: 10, cursor: 'pointer', border: on ? '1.5px solid var(--brand)' : '1px solid var(--line)', background: on ? 'var(--brand-softer)' : 'var(--paper)' });
  return (
    <div style={{ border: '1px solid var(--warn-line, var(--line))', borderRadius: 12, padding: '12px 14px', background: 'var(--paper)' }}>
      <div style={{ fontSize: 12.5, fontWeight: 600, color: 'var(--ink-800)', marginBottom: 6 }}>Stock actual de este ISBN</div>
      {tandas.map(t => (
        <div key={t.lote_id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, padding: '6px 10px', marginBottom: 5, borderRadius: 8, background: 'var(--paper-soft)', border: '1px solid var(--line-soft)' }}>
          <span style={{ fontSize: 12.5, color: 'var(--ink-800)' }}>{t.stock} ejemplar{Number(t.stock) !== 1 ? 'es' : ''} a {money(t.pvp)} <span style={{ color: 'var(--ink-500)' }}>· {t.distribuidor}</span></span>
          <span style={{ fontSize: 11, padding: '2px 8px', borderRadius: 999, whiteSpace: 'nowrap', background: t.misma_distribuidora ? 'var(--ok-bg)' : 'var(--paper-stripe)', color: t.misma_distribuidora ? 'var(--ok-ink)' : 'var(--ink-600)' }}>
            {t.misma_distribuidora ? 'Misma distribuidora' : 'Otra distribuidora'}
          </span>
        </div>
      ))}
      <div style={{ fontSize: 12.5, color: 'var(--ink-800)', margin: '8px 0 4px' }}>
        Llegan {llegan} a {money(pvpNuevo)} ({pctCambio > 0 ? '+' : ''}{pctCambio} %){distribuidorDoc ? ` de ${distribuidorDoc}` : ''}{costoNuevo > 0 ? `, con costo ${money(costoNuevo)} cada uno` : ''}.
      </div>
      {hayOtra && (
        <div style={{ fontSize: 12, color: 'var(--ink-500)', marginBottom: 8, lineHeight: 1.45 }}>
          Cada distribuidora puede tener su propio precio para el mismo ISBN. Tú decides si los dejas con precios distintos o los igualas.
        </div>
      )}
      <div style={{ fontSize: 12.5, fontWeight: 600, color: 'var(--ink-800)', margin: '10px 0 6px' }}>¿Con qué precio los dejas?</div>
      {opciones.map(op => (
        <label key={op.id} style={lineaOpcion(sel === op.id)}>
          <input type="radio" name="decision-precio" checked={sel === op.id} onChange={() => { setSel(op.id); setError(''); }} style={{ marginTop: 3 }} />
          <span style={{ flex: 1, minWidth: 0 }}>
            <span style={{ display: 'block', fontSize: 12.5, fontWeight: 600, color: 'var(--ink-900)' }}>{op.titulo}</span>
            <span style={{ display: 'block', fontSize: 12, color: 'var(--ink-500)' }}>{op.desc}</span>
            {op.margen && <span style={{ display: 'block', fontSize: 12, color: 'var(--ink-500)', marginTop: 2 }}>{op.margen}</span>}
            {op.avisos.map((a, i) => <span key={i} style={{ display: 'block', fontSize: 12, color: 'var(--warn-ink)', marginTop: 2 }}>{a}</span>)}
          </span>
        </label>
      ))}
      <label style={lineaOpcion(sel === 'otro')}>
        <input type="radio" name="decision-precio" checked={sel === 'otro'} onChange={() => { setSel('otro'); setError(''); }} style={{ marginTop: 3 }} />
        <span style={{ flex: 1, minWidth: 0 }}>
          <span style={{ display: 'block', fontSize: 12.5, fontWeight: 600, color: 'var(--ink-900)' }}>Otro precio para todos</span>
          <span style={{ display: 'block', fontSize: 12, color: 'var(--ink-500)' }}>Tú decides el precio de los {total}.</span>
          {sel === 'otro' && (
            <span style={{ display: 'block', marginTop: 6 }}>
              <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                <span style={{ fontSize: 13 }}>$</span>
                <input type="number" min="1" step="1" autoFocus value={otro} onChange={e => { setOtro(e.target.value); setError(''); }} placeholder="ej. 11000" aria-label="Precio para todos"
                  style={{ width: 120, height: 32, borderRadius: 8, border: '1px solid var(--line-strong)', padding: '0 10px', fontSize: 13.5, fontFamily: 'inherit' }} />
              </span>
              <span style={{ display: 'block', fontSize: 12, color: 'var(--ink-500)', marginTop: 4 }}>{otroEfecto ? otroEfecto.margen : 'Escribe el precio para ver el margen.'}</span>
              {otroEfecto && otroEfecto.avisos.map((a, i) => <span key={i} style={{ display: 'block', fontSize: 12, color: 'var(--warn-ink)', marginTop: 2 }}>{a}</span>)}
            </span>
          )}
        </span>
      </label>
      {error && <div style={{ fontSize: 12.5, color: 'var(--bad-ink)', marginTop: 2 }}>{error}</div>}
      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 8 }}>
        <button type="button" onClick={onCerrar} style={{ padding: '7px 14px', borderRadius: 999, border: '1px solid var(--line)', background: 'none', color: 'var(--ink-600)', fontSize: 12.5, fontFamily: 'inherit', cursor: 'pointer' }}>Cerrar</button>
        <button type="button" onClick={confirmar} style={{ padding: '7px 16px', borderRadius: 999, border: 'none', background: 'var(--brand)', color: '#fff', fontSize: 12.5, fontWeight: 500, fontFamily: 'inherit', cursor: 'pointer' }}>Confirmar precio</button>
      </div>
    </div>
  );
}

function DocDetalleDrawer({ docId, docsOrden = [], onClose, onNavigate, onChanged, onAbrirCompleto, onMarcarNoLeido, inline = false, refreshTick = 0 }) {
  const [drawerDoc, setDrawerDoc] = useState(null);
  // Edición en el mismo panel, como al ingresar el documento: se trabaja sobre un borrador y se guarda de una vez
  const [editando, setEditando] = useState(false);
  const [borrador, setBorrador] = useState(null);
  const [guardandoEdit, setGuardandoEdit] = useState(false);
  const [errorEdit, setErrorEdit] = useState('');
  const [distribuidoresEdit, setDistribuidoresEdit] = useState([]);
  // "No recepcionar": saca un documento de "Por recepcionar" sin ingresar libros (se puede deshacer)
  const [ocupadoOmitir, setOcupadoOmitir] = useState(false);
  const [errorOmitir, setErrorOmitir] = useState('');
  useEffect(() => { setErrorOmitir(''); }, [docId]);
  // Recibir lo que faltó de un documento ya cerrado (ej. se cerró con 1 de 3 ejemplares y después aparecieron)
  const [recibiendoFalt, setRecibiendoFalt] = useState(false);
  const [cantFalt, setCantFalt] = useState({});
  const [ocupadoFalt, setOcupadoFalt] = useState(false);
  const [errorFalt, setErrorFalt] = useState('');
  const [okFalt, setOkFalt] = useState('');
  // Recepción de la mercadería en el mismo panel (antes era otra página)
  const [recibiendo, setRecibiendo] = useState(false);
  const [recLineas, setRecLineas] = useState([]);
  const [factorPct, setFactorPct] = useState('');
  const [confirmandoRec, setConfirmandoRec] = useState(false);
  const [errorRec, setErrorRec] = useState('');
  const [okRec, setOkRec] = useState('');
  const [ultimoRev, setUltimoRev] = useState(null); // detalle_id de la última casilla marcada: se ve en verde
  const [stockPrevio, setStockPrevio] = useState({}); // { [detalle_id]: tandas con stock que ya existen de ese libro }
  const [precioAbierto, setPrecioAbierto] = useState(null); // detalle_id con la ventana de precio desplegada

  // Al cambiar de documento se sale de la edición
  useEffect(() => {
    setEditando(false); setBorrador(null); setErrorEdit('');
    setRecibiendoFalt(false); setCantFalt({}); setErrorFalt(''); setOkFalt('');
    setRecibiendo(false); setRecLineas([]); setErrorRec(''); setOkRec(''); setUltimoRev(null);
  }, [docId]);

  useEffect(() => {
    setDrawerDoc(null);
    if (!docId) return;
    api.get(`/documentos/${docId}`).then(r => setDrawerDoc(r.data)).catch(() => {});
    // refreshTick: re-trae este mismo documento cuando algo externo lo cambió (ej. una
    // acción en lote que lo incluía) — docId no cambia, así que sin esto quedaría con
    // datos viejos hasta que el usuario haga clic en otra fila y vuelva.
  }, [docId, refreshTick]);

  useEffect(() => {
    if (!docId) return;
    function onKey(e) {
      const escribiendo = !!e.target && ES_CAMPO_DE_TEXTO.test(e.target.tagName || '');
      if (e.key === 'Escape') { if (editando) setEditando(false); else if (recibiendo) setRecibiendo(false); else if (!escribiendo && docsOrden.length > 0) onClose && onClose(); return; }
      if (editando || recibiendo || escribiendo) return;
      const idx = docsOrden.findIndex(d => d.id === docId);
      if (idx < 0) return;
      if ((e.key === 'ArrowUp' || e.key === 'ArrowLeft') && idx > 0)                       onNavigate && onNavigate(docsOrden[idx - 1].id);
      if ((e.key === 'ArrowDown' || e.key === 'ArrowRight') && idx < docsOrden.length - 1) onNavigate && onNavigate(docsOrden[idx + 1].id);
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [docId, docsOrden, onClose, onNavigate, editando, recibiendo]);

  if (!docId) {
    if (!inline) return null;
    return (
      <div style={{ flex: 1, minWidth: 0, background: 'var(--paper)', border: '1px solid var(--line)', borderRadius: 16, display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 320 }}>
        <span style={{ fontSize: 13, color: 'var(--ink-400)' }}>Elige un documento de la lista</span>
      </div>
    );
  }

  const idx   = docsOrden.findIndex(d => d.id === docId);
  const total = docsOrden.length;
  const goPrev = () => { if (idx > 0) onNavigate && onNavigate(docsOrden[idx - 1].id); };
  const goNext = () => { if (idx < total - 1) onNavigate && onNavigate(docsOrden[idx + 1].id); };

  const doc     = drawerDoc;
  const norm    = doc ? docDmNormEstado(doc.tipo, doc.estado) : null;
  const flow    = doc ? (DOC_DM_FLOW[doc.tipo] || []) : [];
  const flowIdx = doc ? flow.indexOf(norm) : -1;
  const isTerminal = !doc || flowIdx < 0 || flowIdx >= flow.length - 1;
  const advDef  = doc && !isTerminal ? DOC_DM_ADVANCE[doc.tipo]?.[norm] : null;
  // Factura de ingreso de mercadería: además de pagarla, se recepciona para que los libros entren al inventario, también
  // si ya está pagada. `sin_recepcionar` lo calcula el servidor mirando los lotes, así no se ingresa dos veces.
  const recepcionFactura = !!doc && doc.tipo === 'factura' && !!doc.sin_recepcionar;
  const recepcionFacturaEnCurso = recepcionFactura && (doc.detalle || []).some(d => d.parcialmente_recibido);

  async function avanzar() {
    if (!doc || !advDef) return;
    if (advDef.isGdd) { abrirRecepcionPanel(); return; }
    try {
      const nextEstado = flow[flowIdx + 1];
      await api.patch(`/documentos/${docId}/estado`, { estado: nextEstado });
      const r = await api.get(`/documentos/${docId}`);
      setDrawerDoc(r.data);
      onChanged && onChanged();
    } catch (e) { console.error(e); }
  }

  async function recargarDoc() {
    const r = await api.get(`/documentos/${docId}`);
    setDrawerDoc(r.data);
    onChanged && onChanged();
  }
  const esGastoDoc = doc?.proposito === 'gasto_servicio';

  async function cambiarOmisionRecepcion(omitir) {
    setOcupadoOmitir(true); setErrorOmitir('');
    try {
      await api.post(`/documentos/${docId}/${omitir ? 'omitir-recepcion' : 'restaurar-recepcion'}`);
      await recargarDoc();
    } catch (e) { setErrorOmitir(e.response?.data?.error || e.message); }
    setOcupadoOmitir(false);
  }

  function abrirEdicion() {
    setBorrador({
      numero: doc.numero || '',
      fecha: doc.fecha ? String(doc.fecha).slice(0, 10) : '',
      distribuidor_id: doc.distribuidor_id || '',
      modalidad: doc.modalidad || 'firme',
      proposito: doc.proposito || 'ingreso_mercaderia',
      notas: doc.notas || '',
      proveedor_nombre: doc.proveedor_nombre || '',
      proveedor_rut: doc.proveedor_rut || '',
      lineas: (doc.detalle || []).map(d => esGastoDoc
        ? { id: d.id, descripcion: d.descripcion || '', cantidad: d.cantidad, precio_neto: d.precio_neto != null ? Number(d.precio_neto) : '', recibida: !!d.parcialmente_recibido }
        : { id: d.id, _isbn: d.isbn || '', _titulo_editado: d.titulo || '', cantidad: d.cantidad, precio_neto: d.precio_neto != null ? Number(d.precio_neto) : '', pvp: d.pvp != null ? Number(d.pvp) : '', recibida: !!d.parcialmente_recibido }),
    });
    setErrorEdit('');
    setEditando(true);
    api.get('/distribuidores').then(r => setDistribuidoresEdit(r.data || [])).catch(() => {});
  }
  const setCampo = (campo, valor) => setBorrador(b => ({ ...b, [campo]: valor }));
  // Cambiar el precio neto recalcula el PVP (neto + IVA), igual que al ingresar el documento
  const setLinea = (i, campo, valor) => setBorrador(b => ({
    ...b,
    lineas: b.lineas.map((l, j) => {
      if (j !== i) return l;
      const nueva = { ...l, [campo]: valor };
      if (campo === 'precio_neto' && !esGastoDoc) { const pn = parseFloat(valor); nueva.pvp = pn > 0 ? Math.round(pn * 1.19) : ''; }
      return nueva;
    }),
  }));
  const agregarLineaBorrador = () => setBorrador(b => ({
    ...b,
    lineas: [...b.lineas, esGastoDoc ? { descripcion: '', cantidad: 1, precio_neto: '' } : { _isbn: '', _titulo_editado: '', cantidad: 1, precio_neto: '', pvp: '' }],
  }));
  const quitarLineaBorrador = i => setBorrador(b => ({ ...b, lineas: b.lineas.filter((_, j) => j !== i) }));

  async function guardarEdicion() {
    setGuardandoEdit(true); setErrorEdit('');
    try {
      await api.put(`/documentos/${docId}`, borrador);
      await recargarDoc();
      setEditando(false);
    } catch (e) { setErrorEdit(e.response?.data?.error || e.message); }
    setGuardandoEdit(false);
  }
  function abrirRecepcionPanel() {
    const fp = Number(doc.distribuidor_factor_pago || 0);
    setFactorPct(fp > 0 ? String(Math.round((1 - fp) * 100)) : '');
    setRecLineas((doc.detalle || []).map(d => ({
      detalle_id: d.id, titulo: d.titulo, autor: d.autor, isbn: d.isbn, pvp: d.pvp, precio_neto: d.precio_neto,
      monto_item: d.monto_item, descuento_pct: d.descuento_pct, cantidad: d.cantidad, esperada: d.cantidad,
      recibida: String(d.cantidad_recibida ?? d.cantidad), ya: !!d.parcialmente_recibido, revisado: false,
    })));
    setErrorRec(''); setOkRec(''); setEditando(false); setUltimoRev(null);
    setStockPrevio({}); setPrecioAbierto(null); cargarStockPrevio();
    setRecibiendo(true);
  }

  function cargarStockPrevio() {
    return api.get(`/documentos/${docId}/stock-previo`).then(r => setStockPrevio(r.data || {})).catch(() => {});
  }
  // PVP con el que llega la línea (el de la GDD o, si no lo trae, neto + IVA) y el stock que ya existe de ese libro.
  // Hay "conflicto" si alguna tanda con stock tiene otro PVP: el librero debe decidir el precio antes de ingresar.
  function infoPrecio(l) {
    const pvpNuevo = Number(l.pvp) > 0 ? Number(l.pvp) : (Number(l.precio_neto) > 0 ? Math.round(Number(l.precio_neto) * 1.19) : null);
    const tandas = stockPrevio[l.detalle_id] || [];
    const conflicto = !l.ya && pvpNuevo != null && tandas.some(t => Number(t.pvp) !== pvpNuevo);
    return { pvpNuevo, tandas, conflicto };
  }
  const lineaSinDecidir = l => infoPrecio(l).conflicto && !l.decision && Number(l.recibida) > 0;

  // tipo: 'parcial' (solo los marcados), 'completa' o 'incompleta' (cerrar definitivo) — igual que la página anterior
  async function confirmarRecepcionPanel(tipo) {
    const esFactura = doc.tipo === 'factura';
    let factor;
    if (!esFactura) {
      const pct = Number(factorPct);
      if (factorPct === '' || isNaN(pct) || pct <= 0 || pct >= 100) { setErrorRec('El descuento editorial debe ser mayor a 0 y menor a 100 %.'); return; }
      factor = parseFloat(((100 - pct) / 100).toFixed(6));
    }
    const aIngresar = tipo === 'parcial' ? recLineas.filter(l => l.revisado && !l.ya) : recLineas.filter(l => !l.ya);
    const lineas = aIngresar.map(l => ({
      detalle_id: l.detalle_id, cantidad_recibida: Number(l.recibida),
      ...(l.decision ? { decision_precio: { modo: l.decision.modo, precio: l.decision.precio } } : {}),
    }));
    if (tipo === 'parcial' && lineas.length === 0) { setErrorRec('Marca al menos un título para ingresar.'); return; }
    const sinDecidir = aIngresar.filter(lineaSinDecidir);
    if (sinDecidir.length > 0) {
      setErrorRec(`Falta decidir el precio de: ${sinDecidir.map(l => l.titulo).join(', ')}.`);
      setPrecioAbierto(sinDecidir[0].detalle_id);
      return;
    }
    setConfirmandoRec(true); setErrorRec('');
    try {
      const body = { tipo, lineas };
      if (factor !== undefined) body.factor = factor;
      const r = await api.post(`/documentos/${docId}/confirmar-recepcion`, body);
      const nLotes = (r.data.lotes || []).length;
      const avisos = (r.data.advertencias || []).map(a => a.motivo);
      const res = await api.get(`/documentos/${docId}`);
      setDrawerDoc(res.data);
      onChanged && onChanged();
      if (tipo === 'parcial' && (r.data.estado === 'parcialmente_recibida' || r.data.quedan_pendientes)) {
        // Quedan títulos por recibir: se sigue en la recepción con las líneas al día
        setRecLineas((res.data.detalle || []).map(d => ({
          detalle_id: d.id, titulo: d.titulo, autor: d.autor, isbn: d.isbn, pvp: d.pvp, precio_neto: d.precio_neto,
          monto_item: d.monto_item, descuento_pct: d.descuento_pct, cantidad: d.cantidad, esperada: d.cantidad,
          recibida: String(d.cantidad_recibida ?? d.cantidad), ya: !!d.parcialmente_recibido, revisado: false,
        })));
        setUltimoRev(null);
        setPrecioAbierto(null);
        cargarStockPrevio();
        setErrorRec(avisos.length ? `Con advertencias: ${avisos.join('; ')}` : '');
      } else {
        setRecibiendo(false);
        const nRe = r.data.lotes_repreciados || 0;
        setOkRec(`Recepción completada — ${nLotes} lote${nLotes !== 1 ? 's' : ''} creado${nLotes !== 1 ? 's' : ''}.${nRe > 0 ? ` Cambió el precio de ${nRe} lote${nRe !== 1 ? 's' : ''} que ya tenías.` : ''}${avisos.length ? ` Advertencias: ${avisos.join('; ')}` : ''}`);
      }
    } catch (e) {
      // Si el servidor pide decidir un precio que la pantalla no mostraba, se recarga el stock para que aparezca el aviso
      if (e.response?.data?.codigo === 'decision_precio_requerida') cargarStockPrevio();
      setErrorRec(e.response?.data?.error === 'descuento_requerido' ? 'Falta el descuento editorial del distribuidor.' : (e.response?.data?.error || e.message));
    }
    setConfirmandoRec(false);
  }

  // La revisión de la recepción: cantidades realmente recibidas, línea por línea
  function renderRecepcion() {
    const esFactura = doc.tipo === 'factura';
    const pct = Number(factorPct);
    const factorValido = factorPct !== '' && !isNaN(pct) && pct > 0 && pct < 100;
    const factorEfectivo = factorValido ? (100 - pct) / 100 : null;
    const sinFactorConfigurado = Number(doc.distribuidor_factor_pago || 0) === 0;
    const hayPreciosNeto = recLineas.some(l => l.precio_neto != null && Number(l.precio_neto) > 0);
    const mostrarCosto = hayPreciosNeto || esFactura;
    const bloqueado = confirmandoRec || (!esFactura && !factorValido);
    const th = { padding: '7px 6px', fontWeight: 600, color: 'var(--ink-600)', fontSize: 11, textAlign: 'right' };
    const haySeleccionados = recLineas.some(l => l.revisado && !l.ya);
    const pendientesPrecio = recLineas.filter(lineaSinDecidir);
    const bloqueadoParcial = bloqueado || pendientesPrecio.some(l => l.revisado);
    const bloqueadoTodo = bloqueado || pendientesPrecio.length > 0;
    const hayPendientes = recLineas.some(l => !l.ya);
    const hayYaIngresados = recLineas.some(l => l.ya);
    const boton = (extra) => ({ padding: '8px 16px', borderRadius: 999, fontSize: 12.5, fontWeight: 500, fontFamily: 'inherit', display: 'inline-flex', alignItems: 'center', gap: 6, ...extra });
    return (
      <div>
        <div style={{ fontSize: 12.5, color: 'var(--ink-500)', marginBottom: 12, lineHeight: 1.45 }}>
          Confirma las cantidades realmente recibidas. Puedes ajustar si llegaron menos ejemplares de los esperados.
        </div>
        {esFactura ? (
          <div style={{ marginBottom: 14, padding: '9px 13px', background: 'var(--paper-soft)', border: '1px solid var(--line)', borderRadius: 10, fontSize: 12.5, color: 'var(--ink-600)' }}>
            <strong style={{ color: 'var(--ink-800)' }}>Factura</strong> — el costo por unidad sale del monto neto de cada línea (monto ÷ cantidad × 1,19).
          </div>
        ) : (
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap', marginBottom: 14, padding: '10px 14px', background: sinFactorConfigurado ? 'var(--warn-bg)' : 'var(--paper-soft)', border: '1px solid ' + (sinFactorConfigurado ? 'var(--warn-line)' : 'var(--line)'), borderRadius: 10 }}>
            <label style={{ fontSize: 12.5, fontWeight: 600, color: 'var(--ink-800)' }}>Descuento editorial (%)</label>
            <input type="number" min="0" max="100" step="1" value={factorPct} onChange={e => setFactorPct(e.target.value)} placeholder="ej. 40"
              style={{ width: 76, height: 32, borderRadius: 8, border: '1px solid ' + (!factorValido && factorPct !== '' ? 'var(--bad-line)' : 'var(--line-strong)'), padding: '0 10px', fontSize: 13.5, fontFamily: 'inherit', textAlign: 'right', background: 'var(--paper)', color: 'var(--ink-900)' }} />
            <span style={{ fontSize: 12, color: factorValido ? 'var(--ink-500)' : 'var(--bad-ink)', flex: '1 1 160px' }}>
              {factorValido
                ? `→ factor ${factorEfectivo.toFixed(4)} · el distribuidor se queda con el ${Math.round(factorEfectivo * 100)} % del precio con IVA`
                : (factorPct === '' ? (sinFactorConfigurado ? 'Este distribuidor no tiene descuento configurado: ingrésalo para continuar.' : 'Requerido para recepcionar') : 'Debe ser mayor a 0 y menor a 100')}
            </span>
          </div>
        )}

        <div style={{ border: '1px solid var(--line)', borderRadius: 12, overflowX: 'auto', overflowY: 'hidden', marginBottom: 12 }}>
          <table style={{ width: '100%', minWidth: 500, borderCollapse: 'collapse', fontSize: 12.5, tableLayout: 'fixed' }}>
            <colgroup>
              <col style={{ width: 34 }} /><col /><col style={{ width: 70 }} />
              {mostrarCosto && <col style={{ width: 78 }} />}
              <col style={{ width: 52 }} /><col style={{ width: 70 }} /><col style={{ width: 56 }} />
            </colgroup>
            <thead>
              <tr style={{ background: 'var(--paper-soft)' }}>
                <th style={th}></th><th style={{ ...th, textAlign: 'left' }}>Libro</th><th style={th}>PVP</th>
                {mostrarCosto && <th style={th}>Costo</th>}
                <th style={th}>Esp.</th><th style={{ ...th, textAlign: 'center' }}>Recib.</th><th style={{ ...th, textAlign: 'center' }}>Dif.</th>
              </tr>
            </thead>
            <tbody>
              {recLineas.map((l, i) => {
                const diff = Number(l.recibida) - l.esperada;
                let costo = null, sinMonto = false;
                if (esFactura) {
                  const mi = l.monto_item != null ? Number(l.monto_item) : null;
                  if (mi && mi > 0) costo = Math.round((mi / (l.cantidad || l.esperada || 1)) * 1.19); else sinMonto = true;
                } else if (l.precio_neto != null && Number(l.precio_neto) > 0 && factorEfectivo !== null) {
                  costo = Math.round(Number(l.precio_neto) * 1.19 * factorEfectivo);
                }
                const actualizar = campo => valor => setRecLineas(ls => ls.map((x, j) => (j === i ? { ...x, [campo]: valor } : x)));
                const ip = infoPrecio(l);
                const abierta = precioAbierto === l.detalle_id && ip.conflicto;
                return (
                  <React.Fragment key={l.detalle_id}>
                  <tr style={{ borderTop: '1px solid var(--line-soft)', background: l.ya ? 'var(--ok-bg)' : (l.revisado && l.detalle_id === ultimoRev) ? 'var(--ok-bg)' : l.revisado ? 'var(--brand-softer)' : 'transparent', boxShadow: (!l.ya && l.revisado && l.detalle_id === ultimoRev) ? 'inset 3px 0 0 var(--ok-ink)' : 'none', opacity: l.ya ? 0.75 : 1 }}>
                    <td style={{ padding: '8px 4px 8px 10px', textAlign: 'center', verticalAlign: 'top' }}>
                      {l.ya
                        ? <span style={{ color: 'var(--ok-ink)', fontSize: 16, lineHeight: 1 }}>✓</span>
                        : <input type="checkbox" checked={l.revisado} onChange={e => { actualizar('revisado')(e.target.checked); setUltimoRev(e.target.checked ? l.detalle_id : null); }} aria-label="Marcar como revisado" style={{ width: 15, height: 15, cursor: 'pointer', accentColor: 'var(--ok-ink)' }} />}
                    </td>
                    <td onClick={l.ya ? undefined : () => { const marcar = !l.revisado; actualizar('revisado')(marcar); setUltimoRev(marcar ? l.detalle_id : null); }}
                      style={{ padding: '8px 6px', verticalAlign: 'top', cursor: l.ya ? 'default' : 'pointer', userSelect: 'none' }}>
                      <div style={{ fontWeight: 600, color: 'var(--ink-900)', lineHeight: 1.25 }}>{l.titulo}</div>
                      {l.isbn && <div style={{ fontFamily: 'var(--font-mono)', fontSize: 11, color: 'var(--ink-500)', marginTop: 2 }}>{l.isbn}</div>}
                      {l.ya && <div style={{ fontSize: 11, color: 'var(--ok-ink)', fontWeight: 500, marginTop: 2 }}>Ya ingresado al sistema</div>}
                      {sinMonto && !l.ya && <div style={{ fontSize: 11, color: 'var(--bad-ink)', marginTop: 2 }}>Sin monto: no se creará el lote</div>}
                      {ip.conflicto && (
                        <button type="button" onClick={e => { e.stopPropagation(); setPrecioAbierto(abierta ? null : l.detalle_id); }}
                          style={{ marginTop: 5, display: 'inline-flex', alignItems: 'center', gap: 5, padding: '3px 10px', borderRadius: 999, fontSize: 11.5, fontWeight: 500, fontFamily: 'inherit', cursor: 'pointer', textAlign: 'left',
                            background: l.decision ? 'var(--ok-bg)' : 'var(--warn-bg)', color: l.decision ? 'var(--ok-ink)' : 'var(--warn-ink)', border: '1px solid ' + (l.decision ? 'var(--ok-line)' : 'var(--warn-line, var(--line))') }}>
                          {l.decision ? <Check size={12} strokeWidth={2.5} /> : <AlertTriangle size={12} strokeWidth={2} />}
                          {l.decision ? `${l.decision.resumen} · Cambiar` : `Precio distinto: ${resumenStockPrevio(ip.tandas)} · Decidir`}
                          {abierta ? <ChevronUp size={12} strokeWidth={2} /> : <ChevronDown size={12} strokeWidth={2} />}
                        </button>
                      )}
                    </td>
                    <td style={{ padding: '8px 6px', textAlign: 'right', verticalAlign: 'top', fontVariantNumeric: 'tabular-nums', color: 'var(--ink-700)', whiteSpace: 'nowrap' }}>
                      {l.pvp ? `$ ${Number(l.pvp).toLocaleString('es-CL')}` : <span style={{ color: 'var(--ink-300)' }}>—</span>}
                    </td>
                    {mostrarCosto && (
                      <td style={{ padding: '8px 6px', textAlign: 'right', verticalAlign: 'top', fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap', color: costo != null ? 'var(--ink-800)' : 'var(--ink-300)' }}>
                        {costo != null ? `$ ${costo.toLocaleString('es-CL')}` : '—'}
                      </td>
                    )}
                    <td style={{ padding: '8px 6px', textAlign: 'right', verticalAlign: 'top', color: 'var(--ink-600)', fontVariantNumeric: 'tabular-nums' }}>{l.esperada}</td>
                    <td style={{ padding: '6px 4px', textAlign: 'center', verticalAlign: 'top' }}>
                      {l.ya
                        ? <span style={{ fontWeight: 600, color: 'var(--ok-ink)' }}>{l.recibida}</span>
                        : <input type="number" min="0" max={l.esperada} value={l.recibida} onChange={e => actualizar('recibida')(e.target.value)} aria-label="Cantidad recibida"
                            style={{ width: 54, height: 30, borderRadius: 999, textAlign: 'center', border: '1px solid ' + (diff < 0 ? 'var(--bad-line)' : 'var(--line-strong)'), background: diff < 0 ? 'var(--bad-bg)' : 'var(--paper)', color: 'var(--ink-900)', fontWeight: 600, fontFamily: 'inherit', fontSize: 13, outline: 'none' }} />}
                    </td>
                    <td style={{ padding: '8px 6px', textAlign: 'center', verticalAlign: 'top' }}>
                      {diff === 0
                        ? <span style={{ color: 'var(--ink-400)' }}>—</span>
                        : <span style={{ padding: '2px 9px', borderRadius: 999, fontSize: 11.5, fontWeight: 500, background: diff < 0 ? 'var(--bad-bg)' : 'var(--ok-bg)', color: diff < 0 ? 'var(--bad-ink)' : 'var(--ok-ink)' }}>{diff > 0 ? `+${diff}` : diff}</span>}
                    </td>
                  </tr>
                  {abierta && (
                    <tr style={{ background: 'var(--paper-soft)' }}>
                      <td colSpan={mostrarCosto ? 7 : 6} style={{ padding: '4px 10px 12px' }}>
                        <PrecioDistintoCard
                          tandas={ip.tandas} pvpNuevo={ip.pvpNuevo} costoNuevo={costo} llegan={Number(l.recibida) || l.esperada}
                          distribuidorDoc={doc.distribuidor_nombre} decisionActual={l.decision}
                          onConfirmar={d => { actualizar('decision')(d); setPrecioAbierto(null); setErrorRec(''); }}
                          onCerrar={() => setPrecioAbierto(null)} />
                      </td>
                    </tr>
                  )}
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>
        </div>
        {errorRec && <div style={{ fontSize: 12.5, color: 'var(--bad-ink)', background: 'var(--bad-bg)', border: '1px solid var(--bad-line)', borderRadius: 8, padding: '6px 10px', marginBottom: 10 }}>{errorRec}</div>}
        {pendientesPrecio.length > 0 && (
          <div style={{ fontSize: 12.5, color: 'var(--warn-ink)', background: 'var(--warn-bg)', border: '1px solid var(--warn-line, var(--line))', borderRadius: 8, padding: '6px 10px', marginBottom: 10 }}>
            Falta decidir el precio de {pendientesPrecio.length} libro{pendientesPrecio.length !== 1 ? 's' : ''}: {pendientesPrecio.map(l => l.titulo).join(', ')}.
          </div>
        )}
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 10 }}>
          <button type="button" onClick={() => confirmarRecepcionPanel('parcial')} disabled={bloqueadoParcial || !haySeleccionados}
            style={boton({ background: 'var(--brand)', color: '#fff', border: 'none', cursor: (bloqueadoParcial || !haySeleccionados) ? 'not-allowed' : 'pointer', opacity: (bloqueadoParcial || !haySeleccionados) ? 0.5 : 1 })}>
            <PackageCheck size={14} strokeWidth={1.75} /> {confirmandoRec ? 'Ingresando…' : 'Ingresar seleccionados'}
          </button>
          {(hayYaIngresados || !hayPendientes) && (
            <button type="button" onClick={() => confirmarRecepcionPanel('completa')} disabled={bloqueadoTodo}
              style={boton({ background: 'var(--ok-bg)', color: 'var(--ok-ink)', border: '1px solid var(--ok-line)', cursor: bloqueadoTodo ? 'not-allowed' : 'pointer', opacity: bloqueadoTodo ? 0.6 : 1 })}>
              <PackageCheck size={14} strokeWidth={1.75} /> {confirmandoRec ? 'Procesando…' : 'Confirmar recepción completa'}
            </button>
          )}
          <button type="button" onClick={() => confirmarRecepcionPanel('incompleta')} disabled={bloqueadoTodo}
            style={boton({ background: 'none', color: 'var(--ink-500)', border: '1px solid var(--line)', cursor: bloqueadoTodo ? 'not-allowed' : 'pointer', opacity: bloqueadoTodo ? 0.6 : 1 })}>
            {confirmandoRec ? 'Procesando…' : 'Cerrar definitivo'}
          </button>
        </div>
      </div>
    );
  }

  async function recibirFaltantes(faltantes) {
    const lineas = faltantes
      .map(d => ({ detalle_id: d.id, cantidad: parseInt(cantFalt[d.id] ?? String(Number(d.cantidad) - Number(d.cantidad_recibida || 0)), 10) || 0 }))
      .filter(l => l.cantidad > 0);
    if (lineas.length === 0) { setErrorFalt('Indica cuántos ejemplares llegaron.'); return; }
    setOcupadoFalt(true); setErrorFalt('');
    try {
      const r = await api.post(`/documentos/${docId}/recibir-faltantes`, { lineas });
      const total = lineas.reduce((n, l) => n + l.cantidad, 0);
      setOkFalt(`Se sumaron ${total} ejemplar${total !== 1 ? 'es' : ''} al stock${r.data.estado === 'completa' ? ' y el documento quedó completo.' : '.'}`);
      setRecibiendoFalt(false); setCantFalt({});
      await recargarDoc();
    } catch (e) { setErrorFalt(e.response?.data?.error || e.message); }
    setOcupadoFalt(false);
  }
  async function cambiarEstadoDoc(estado) {
    setErrorEdit('');
    try { await api.patch(`/documentos/${docId}/estado`, { estado }); await recargarDoc(); }
    catch (e) { setErrorEdit(e.response?.data?.error || e.message); }
  }

  // El editor completo: mismos campos que al ingresar el documento
  function renderEdicion() {
    if (!borrador) return null;
    const campo = { width: '100%', boxSizing: 'border-box', padding: '6px 10px', border: '1px solid var(--line-strong)', borderRadius: 8, fontSize: 13, fontFamily: 'inherit', color: 'var(--ink-900)', background: 'var(--paper)', outline: 'none' };
    const etiqueta = { display: 'block', fontSize: 10, fontWeight: 500, textTransform: 'uppercase', letterSpacing: '0.07em', color: 'var(--ink-500)', marginBottom: 3 };
    const opcionesProp = [...new Set([...(PROPOSITOS_EDITABLES[doc.tipo] || []), doc.proposito])].filter(x => esGastoDoc ? x === 'gasto_servicio' : x !== 'gasto_servicio');
    const modalidadAplica = !esGastoDoc && borrador.proposito !== 'cobro_consignacion';
    const listaDist = distribuidoresEdit.some(d => d.id === doc.distribuidor_id) || !doc.distribuidor_id
      ? distribuidoresEdit
      : [{ id: doc.distribuidor_id, nombre: doc.distribuidor_nombre || 'Distribuidor actual' }, ...distribuidoresEdit];
    const th = { padding: '7px 6px', textAlign: 'left', fontWeight: 600, color: 'var(--ink-600)', fontSize: 11 };
    const celda = { padding: '6px 6px', verticalAlign: 'top' };
    const num = { ...campo, padding: '6px 6px', textAlign: 'right' };
    return (
      <div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '8px 10px', marginBottom: 14 }}>
          <div>
            <label style={etiqueta}>Tipo de documento</label>
            <div style={{ ...campo, background: 'var(--paper-stripe)', color: 'var(--ink-700)' }}>{meta.label}</div>
          </div>
          <div>
            <label style={etiqueta}>Propósito</label>
            <select value={borrador.proposito} onChange={e => setCampo('proposito', e.target.value)} style={campo} disabled={opcionesProp.length < 2}>
              {opcionesProp.map(x => <option key={x} value={x}>{ETIQUETA_PROPOSITO_DOC[x] || x}</option>)}
            </select>
          </div>
          {esGastoDoc ? (
            <>
              <div><label style={etiqueta}>Proveedor</label>
                <input value={borrador.proveedor_nombre} onChange={e => setCampo('proveedor_nombre', e.target.value)} style={campo} /></div>
              <div><label style={etiqueta}>RUT proveedor</label>
                <input value={borrador.proveedor_rut} onChange={e => setCampo('proveedor_rut', e.target.value)} style={{ ...campo, fontFamily: 'var(--font-mono)' }} /></div>
            </>
          ) : (
            <div>
              <label style={etiqueta}>Distribuidor</label>
              <select value={borrador.distribuidor_id} onChange={e => setCampo('distribuidor_id', e.target.value)} style={campo}>
                <option value="">Sin distribuidor</option>
                {listaDist.map(d => <option key={d.id} value={d.id}>{d.nombre}</option>)}
              </select>
            </div>
          )}
          <div><label style={etiqueta}>Número</label>
            <input value={borrador.numero} onChange={e => setCampo('numero', e.target.value)} style={campo} /></div>
          {modalidadAplica && (
            <div style={{ gridColumn: 'span 2' }}>
              <label style={etiqueta}>Modalidad</label>
              <div style={{ display: 'flex', gap: 6 }}>
                {[['firme', 'Firme'], ['consignacion', 'Consignación']].map(([val, et]) => (
                  <button key={val} type="button" onClick={() => setCampo('modalidad', val)}
                    style={{ flex: 1, minWidth: 0, padding: '6px 4px', borderRadius: 8, cursor: 'pointer', fontSize: 12, fontFamily: 'inherit', fontWeight: 600, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
                      border: '1px solid ' + (borrador.modalidad === val ? 'var(--brand)' : 'var(--line)'),
                      background: borrador.modalidad === val ? 'var(--brand-softer)' : 'var(--paper)',
                      color: borrador.modalidad === val ? 'var(--brand)' : 'var(--ink-600)' }}>
                    {et}
                  </button>
                ))}
              </div>
            </div>
          )}
          <div><label style={etiqueta}>Fecha</label>
            <input type="date" value={borrador.fecha} onChange={e => setCampo('fecha', e.target.value)} style={campo} /></div>
          <div style={{ gridColumn: 'span 2' }}><label style={etiqueta}>Notas</label>
            <input value={borrador.notas} onChange={e => setCampo('notas', e.target.value)} style={campo} /></div>
        </div>

        {doc.tipo !== 'gdd' && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 14, flexWrap: 'wrap' }}>
            <span style={{ fontSize: 12, color: 'var(--ink-500)' }}>Cambiar estado:</span>
            {(esGastoDoc ? ['emitida', 'pagada', 'anulada'] : ['emitida', 'recibida', 'pagada', 'anulada']).map(e => {
              const activo = doc.estado === e;
              return (
                <button key={e} type="button" onClick={() => cambiarEstadoDoc(e)} disabled={activo}
                  style={{ padding: '4px 12px', borderRadius: 999, fontSize: 12, fontFamily: 'inherit', cursor: activo ? 'default' : 'pointer', border: '1px solid ' + (activo ? 'transparent' : 'var(--line)'), background: activo ? 'var(--ink-900)' : 'var(--paper)', color: activo ? '#fff' : 'var(--ink-700)', textTransform: 'capitalize' }}>
                  {DOC_ETIQUETA_ESTADO[e] || e}
                </button>
              );
            })}
          </div>
        )}

        <div style={{ fontSize: 10, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.08em', color: 'var(--ink-500)', marginBottom: 8 }}>
          Detalle · {borrador.lineas.length} línea{borrador.lineas.length !== 1 ? 's' : ''}
        </div>
        <div style={{ border: '1px solid var(--line)', borderRadius: 12, overflowX: 'auto', overflowY: 'hidden', marginBottom: 10 }}>
          <table style={{ width: '100%', minWidth: esGastoDoc ? 380 : 520, borderCollapse: 'collapse', fontSize: 12.5, tableLayout: 'fixed' }}>
            <colgroup>
              {esGastoDoc
                ? <><col /><col style={{ width: 62 }} /><col style={{ width: 96 }} /><col style={{ width: 34 }} /></>
                : <><col style={{ width: 128 }} /><col /><col style={{ width: 58 }} /><col style={{ width: 88 }} /><col style={{ width: 88 }} /><col style={{ width: 34 }} /></>}
            </colgroup>
            <thead>
              <tr style={{ background: 'var(--paper-soft)' }}>
                {esGastoDoc
                  ? <><th style={th}>Descripción</th><th style={th}>Cant.</th><th style={th}>Neto</th><th /></>
                  : <><th style={th}>ISBN</th><th style={th}>Libro</th><th style={th}>Cant.</th><th style={th}>P. neto</th><th style={th}>PVP</th><th /></>}
              </tr>
            </thead>
            <tbody>
              {borrador.lineas.map((l, i) => {
                const fija = !!l.recibida;
                const fijaTxt = { fontSize: 12.5, color: 'var(--ink-600)', padding: '7px 2px', wordBreak: 'break-word' };
                const accion = (
                  <td style={{ ...celda, textAlign: 'center', paddingTop: 8 }}>
                    {fija
                      ? <span title="Ya recibida: no se puede cambiar" style={{ color: 'var(--ink-300)', display: 'inline-flex' }}><Lock size={13} strokeWidth={1.75} /></span>
                      : <button type="button" onClick={() => quitarLineaBorrador(i)} aria-label="Quitar línea" title="Quitar línea"
                          style={{ background: 'none', border: 'none', color: 'var(--ink-400)', cursor: 'pointer', padding: 2, display: 'inline-flex' }}><Trash2 size={14} strokeWidth={1.75} /></button>}
                  </td>
                );
                if (esGastoDoc) {
                  return (
                    <tr key={l.id || `n${i}`} style={{ borderTop: '1px solid var(--line-soft)' }}>
                      <td style={celda}>{fija ? <div style={fijaTxt}>{l.descripcion}</div> : <input value={l.descripcion} onChange={e => setLinea(i, 'descripcion', e.target.value)} placeholder="Descripción" style={campo} />}</td>
                      <td style={celda}>{fija ? <div style={{ ...fijaTxt, textAlign: 'right' }}>{l.cantidad}</div> : <input type="number" min="1" value={l.cantidad} onChange={e => setLinea(i, 'cantidad', e.target.value)} style={num} />}</td>
                      <td style={celda}>{fija ? <div style={{ ...fijaTxt, textAlign: 'right' }}>{l.precio_neto}</div> : <input type="number" min="0" step="0.01" value={l.precio_neto} onChange={e => setLinea(i, 'precio_neto', e.target.value)} style={num} />}</td>
                      {accion}
                    </tr>
                  );
                }
                return (
                  <tr key={l.id || `n${i}`} style={{ borderTop: '1px solid var(--line-soft)', background: fija ? 'var(--paper-soft)' : 'transparent' }}>
                    <td style={celda}>
                      {fija
                        ? <div style={{ ...fijaTxt, fontFamily: 'var(--font-mono)', fontSize: 12 }}>{l._isbn}</div>
                        : <input value={l._isbn} onChange={e => setLinea(i, '_isbn', e.target.value)} placeholder="ISBN" title={l._isbn} style={{ ...campo, fontFamily: 'var(--font-mono)', fontSize: 12 }} />}
                    </td>
                    <td style={celda}>
                      {fija
                        ? <div style={fijaTxt}>{l._titulo_editado}</div>
                        : <textarea rows={1} value={l._titulo_editado} onChange={e => setLinea(i, '_titulo_editado', e.target.value)} placeholder={l.id ? 'Título del libro' : 'Título (si el libro es nuevo)'}
                            onKeyDown={e => { if (e.key === 'Enter') e.preventDefault(); }}
                            ref={el => { if (el) { const borde = el.offsetHeight - el.clientHeight; el.style.height = 'auto'; el.style.height = (el.scrollHeight + borde) + 'px'; for (let k = 0; k < 3 && el.scrollHeight > el.clientHeight + 1; k++) el.style.height = (el.scrollHeight + borde) + 'px'; } }}
                            style={{ ...campo, display: 'block', resize: 'none', overflow: 'hidden', lineHeight: 1.35 }} />}
                    </td>
                    <td style={celda}>{fija ? <div style={{ ...fijaTxt, textAlign: 'right' }}>{l.cantidad}</div> : <input type="number" min="1" value={l.cantidad} onChange={e => setLinea(i, 'cantidad', e.target.value)} style={num} />}</td>
                    <td style={celda}>{fija ? <div style={{ ...fijaTxt, textAlign: 'right' }}>{l.precio_neto}</div> : <input type="number" min="0" step="0.01" placeholder="0" value={l.precio_neto} onChange={e => setLinea(i, 'precio_neto', e.target.value)} style={num} />}</td>
                    <td style={celda}>{fija ? <div style={{ ...fijaTxt, textAlign: 'right' }}>{l.pvp}</div> : <input type="number" min="0" step="0.01" placeholder="0" value={l.pvp} onChange={e => setLinea(i, 'pvp', e.target.value)} style={num} />}</td>
                    {accion}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <button type="button" onClick={agregarLineaBorrador}
          style={{ background: 'transparent', border: '1px dashed var(--line-strong)', padding: '6px 14px', cursor: 'pointer', borderRadius: 999, color: 'var(--ink-600)', fontSize: 12.5, fontFamily: 'inherit', display: 'inline-flex', alignItems: 'center', gap: 5, marginBottom: 12 }}>
          <Plus size={13} strokeWidth={2} /> Agregar línea
        </button>
        {doc.tipo === 'gdd' && ['completa', 'cerrada_incompleta'].includes(doc.estado) && (
          <div style={{ fontSize: 11.5, color: 'var(--ink-500)', marginBottom: 8 }}>
            Este documento ya estaba recibido: si agregas libros, volverá a «en recepción» para recibir solo los nuevos. Las líneas ya recibidas (🔒) no se pueden cambiar.
          </div>
        )}
        {errorEdit && (
          <div style={{ fontSize: 12.5, color: 'var(--bad-ink)', background: 'var(--bad-bg)', border: '1px solid var(--bad-line)', borderRadius: 8, padding: '6px 10px', marginBottom: 12 }}>{errorEdit}</div>
        )}
      </div>
    );
  }

  const navBtnStyle = disabled => ({ width: 30, height: 30, borderRadius: 9, border: '1px solid var(--line)', background: 'var(--paper)', color: disabled ? 'var(--ink-300)' : 'var(--ink-700)', cursor: disabled ? 'default' : 'pointer', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' });
  const tileStyle  = { background: 'var(--paper)', border: '1px solid var(--line)', borderRadius: 12, padding: '11px 14px' };
  const tileLbl    = { fontSize: 9.5, textTransform: 'uppercase', letterSpacing: '0.08em', color: 'var(--ink-500)', fontWeight: 600, marginBottom: 4 };

  const etiquetaProposito = { ingreso_mercaderia: 'Ingreso de mercadería', cobro_consignacion: 'Liquidación de consignación', otro: 'Ajuste o corrección', gasto_servicio: 'Gasto o servicio' };
  const meta = doc ? (DOC_DM_TIPO_META[doc.tipo] || {}) : {};

  const mntTotal = doc?.mnt_total ? Number(doc.mnt_total) : null;
  const esExenta = !!doc?.es_exenta;
  const finFilas = mntTotal != null
    ? (esExenta
        ? [{ label: 'Total exento (sin IVA)', value: mntTotal, color: 'var(--brand)' }]
        : [
            { label: 'Monto neto', value: Math.round(mntTotal / 1.19), color: 'var(--ink-900)' },
            { label: 'IVA 19%',    value: mntTotal - Math.round(mntTotal / 1.19), color: 'var(--ink-600)' },
            { label: 'Total',      value: mntTotal, color: 'var(--brand)' },
          ])
    : null;

  // El panel inline no fuerza altura ni scroll propio: crece con su contenido y es la
  // página la que hace scroll, para que el documento se vea completo de una.
  const panelStyle = inline
    ? { flex: 1, minWidth: 0, background: 'var(--paper)', border: '1px solid var(--line)', borderRadius: 16, display: 'flex', flexDirection: 'column', boxSizing: 'border-box' }
    : { position: 'fixed', top: 0, right: 0, height: '100vh', width: 560, maxWidth: '94vw', background: 'var(--paper)', borderLeft: '1px solid var(--line)', boxShadow: '-4px 0 32px rgba(0,0,0,0.10)', zIndex: 61, display: 'flex', flexDirection: 'column', boxSizing: 'border-box' };

  return (
    <React.Fragment>
      {/* scrim — solo en modo overlay; el panel inline vive en el flujo normal de la página */}
      {!inline && <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.18)', zIndex: 60 }} />}
      {/* panel */}
      <div style={panelStyle}
        onKeyDown={e => {
          if (editando || recibiendo || ES_CAMPO_DE_TEXTO.test(e.target.tagName || '')) return;
          if (e.key === 'Escape' && onClose) onClose();
          else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { e.preventDefault(); goPrev(); }
          else if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { e.preventDefault(); goNext(); }
        }}
        tabIndex={-1}
      >
        {/* nav bar — se omite del todo si no hay ni prev/next ni botón de cerrar (tarjetas
            apiladas de la selección múltiple, que no navegan ni se cierran una a una) */}
        {total > 1 && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 9, padding: '12px 18px', borderBottom: '1px solid var(--line-soft)', background: 'var(--paper-soft)', flexShrink: 0, borderRadius: inline ? '16px 16px 0 0' : 0 }}>
            {total > 1 && (
              <>
                <button onClick={goPrev} disabled={idx <= 0} title="Anterior (↑)" style={navBtnStyle(idx <= 0)}>
                  <ChevronUp size={16} strokeWidth={1.75} />
                </button>
                <button onClick={goNext} disabled={idx >= total - 1} title="Siguiente (↓)" style={navBtnStyle(idx >= total - 1)}>
                  <ChevronDown size={16} strokeWidth={1.75} />
                </button>
                <span style={{ fontSize: 12, color: 'var(--ink-500)', fontVariantNumeric: 'tabular-nums', marginLeft: 2 }}>
                  <strong style={{ color: 'var(--ink-800)' }}>{idx + 1}</strong> de {total}
                  <span style={{ marginLeft: 8, color: 'var(--ink-300)' }}>· usa ↑ ↓ para recorrer</span>
                </span>
              </>
            )}
          </div>
        )}

        {!doc && (
          <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--ink-400)', fontSize: 13 }}>Cargando…</div>
        )}

        {doc && (
          <>
            {/* identity — título con fecha y estado debajo; a la derecha, la acción principal, Editar, no leído y cerrar */}
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12, padding: '12px 18px', borderBottom: '1px solid var(--line)', flexShrink: 0 }}>
              {docDrawerIconCircle(doc.tipo, 36)}
              <div style={{ minWidth: 0, flex: 1 }}>
                {(() => {
                  const tituloDoc = `${meta.label} · ${doc.numero || '—'} · ${doc.distribuidor_nombre || doc.proveedor_nombre || (doc.proposito === 'gasto_servicio' ? 'Sin proveedor' : 'Sin distribuidor')}`;
                  return (
                    <div title={tituloDoc} style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 17, letterSpacing: '-0.02em', lineHeight: 1.2, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {tituloDoc}
                    </div>
                  );
                })()}
                <div style={{ display: 'flex', gap: 6, alignItems: 'center', flexWrap: 'wrap', marginTop: 5 }}>
                  {doc.fecha && (
                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5, padding: '2px 10px', borderRadius: 999, fontSize: 12, border: '1px solid var(--line-strong)', color: 'var(--ink-800)', whiteSpace: 'nowrap' }}>
                      <CalendarDays size={12} strokeWidth={1.75} /> {fmtDocFecha(doc.fecha)}
                    </span>
                  )}
                  {docDrawerEstadoPill(doc.estado)}
                  {doc.modalidad === 'consignacion' && (
                    <span style={{ padding: '3px 9px', borderRadius: 999, fontSize: 12, fontWeight: 500, background: 'var(--info-bg)', color: 'var(--info-ink)' }}>consigna</span>
                  )}
                  {esExenta && (
                    <span style={{ padding: '3px 9px', borderRadius: 999, fontSize: 12, fontWeight: 500, background: 'var(--warn-bg)', color: 'var(--warn-ink)', border: '1px solid var(--warn-line)' }}>Exenta</span>
                  )}
                </div>
              </div>
              <div style={{ display: 'flex', gap: 6, alignItems: 'center', flexShrink: 0 }}>
                {editando ? (
                  <>
                    <button type="button" onClick={() => setEditando(false)} disabled={guardandoEdit}
                      style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '7px 13px', border: '1px solid var(--line)', background: 'var(--paper)', color: 'var(--ink-700)', borderRadius: 999, cursor: 'pointer', fontFamily: 'inherit', fontSize: 12.5 }}>
                      <X size={13} strokeWidth={2} /> Cancelar
                    </button>
                    <button type="button" onClick={guardarEdicion} disabled={guardandoEdit}
                      style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '7px 14px', border: 'none', background: 'var(--brand)', color: '#fff', borderRadius: 999, cursor: guardandoEdit ? 'not-allowed' : 'pointer', fontFamily: 'inherit', fontSize: 12.5, fontWeight: 600, opacity: guardandoEdit ? 0.7 : 1 }}>
                      <Check size={13} strokeWidth={2.5} /> {guardandoEdit ? 'Guardando…' : 'Guardar'}
                    </button>
                  </>
                ) : recibiendo ? (
                  <button type="button" onClick={() => setRecibiendo(false)} disabled={confirmandoRec}
                    style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '7px 13px', border: '1px solid var(--line)', background: 'var(--paper)', color: 'var(--ink-700)', borderRadius: 999, cursor: 'pointer', fontFamily: 'inherit', fontSize: 12.5 }}>
                    <X size={13} strokeWidth={2} /> Volver al documento
                  </button>
                ) : (
                  <>
                    {recepcionFactura && (
                      <button type="button" onClick={abrirRecepcionPanel}
                        style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '7px 14px', borderRadius: 999, border: '1px solid var(--brand)', cursor: 'pointer', fontFamily: 'inherit', fontSize: 12.5, fontWeight: 600, background: 'var(--paper)', color: 'var(--brand)', whiteSpace: 'nowrap' }}>
                        <PackageCheck size={13} strokeWidth={1.75} /> {recepcionFacturaEnCurso ? 'Continuar recepción' : 'Recepcionar'}
                      </button>
                    )}
                    {!isTerminal && advDef && (
                      <button type="button" onClick={avanzar}
                        style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '7px 14px', borderRadius: 999, border: 'none', cursor: 'pointer', fontFamily: 'inherit', fontSize: 12.5, fontWeight: 600, background: 'var(--brand)', color: '#fff', whiteSpace: 'nowrap' }}>
                        {advDef.isGdd ? <PackageCheck size={13} strokeWidth={1.75} /> : <Check size={13} strokeWidth={2.25} />} {advDef.label}
                      </button>
                    )}
                    {doc.sin_recepcionar && !doc.tiene_lotes && (
                      <button type="button" onClick={() => cambiarOmisionRecepcion(true)} disabled={ocupadoOmitir}
                        style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '7px 14px', borderRadius: 999, border: '1px solid var(--line-strong)', cursor: ocupadoOmitir ? 'default' : 'pointer', fontFamily: 'inherit', fontSize: 12.5, fontWeight: 500, background: 'var(--paper)', color: 'var(--ink-700)', whiteSpace: 'nowrap', opacity: ocupadoOmitir ? 0.7 : 1 }}>
                        No recepcionar
                      </button>
                    )}
                    <button type="button" onClick={abrirEdicion} aria-label="Editar" title="Editar"
                      style={{ width: 30, height: 30, borderRadius: '50%', border: '1px solid var(--line)', background: 'var(--paper)', color: 'var(--ink-600)', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                      <Pencil size={14} strokeWidth={1.75} />
                    </button>
                    {onMarcarNoLeido && !isTerminal && (
                      <button type="button" onClick={() => onMarcarNoLeido(docId)} aria-label="Marcar como no leído" title="Marcar como no leído"
                        style={{ width: 30, height: 30, borderRadius: '50%', border: '1px solid var(--line)', background: 'var(--paper)', color: 'var(--ink-600)', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                        <Mail size={14} strokeWidth={1.75} />
                      </button>
                    )}
                    {onClose && (
                      <button type="button" onClick={onClose} aria-label="Cerrar documento" title="Cerrar"
                        style={{ width: 30, height: 30, borderRadius: '50%', border: '1px solid var(--line)', background: 'var(--paper)', color: 'var(--ink-600)', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                        <X size={15} strokeWidth={1.75} />
                      </button>
                    )}
                  </>
                )}
              </div>
            </div>

            {/* body — con scroll propio solo en modo cajón (overlay); inline crece completo */}
            <div style={{ flex: 1, overflowY: inline ? 'visible' : 'auto', padding: '18px 18px 8px' }}>
              {/* Track */}
              <div style={{ marginBottom: 18, display: 'flex', alignItems: 'center', gap: 14 }}>
                <DocDmTrack tipo={doc.tipo} estado={doc.estado} />
                <span style={{ fontSize: 12, color: 'var(--ink-500)' }}>{DOC_DM_STAGE_LABEL[norm] || norm}</span>
              </div>

              {editando && renderEdicion()}
              {recibiendo && renderRecepcion()}
              {!editando && !recibiendo && (<>
              {okRec && <div style={{ fontSize: 12.5, color: 'var(--ok-ink)', background: 'var(--ok-bg)', border: '1px solid var(--ok-line)', borderRadius: 10, padding: '7px 12px', marginBottom: 14 }}>{okRec}</div>}
              {/* Meta tiles — distribuidor y fecha ya están en el encabezado */}
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: 8, marginBottom: 14 }}>
                {doc.proposito === 'gasto_servicio' && doc.proveedor_rut && (
                  <div style={tileStyle}>
                    <div style={tileLbl}>RUT proveedor</div>
                    <div style={{ fontSize: 13.5, color: 'var(--ink-900)', fontFamily: 'var(--font-mono)' }}>{doc.proveedor_rut}</div>
                  </div>
                )}
                <div style={tileStyle}>
                  <div style={tileLbl}>Propósito</div>
                  <div style={{ fontSize: 13.5, color: 'var(--ink-900)' }}>{etiquetaProposito[doc.proposito] || '—'}</div>
                </div>
                <div style={tileStyle}>
                  <div style={tileLbl}>Modalidad</div>
                  <div style={{ fontSize: 13.5, color: 'var(--ink-900)' }}>{doc.modalidad === 'consignacion' ? 'Consignación' : 'Firme'}</div>
                </div>
                {doc.estado === 'pagada' && doc.pagado_en && (
                  <div style={tileStyle}>
                    <div style={tileLbl}>Pago</div>
                    <div style={{ fontSize: 13.5, color: 'var(--ink-900)' }}>
                      {fmtDocFecha(doc.pagado_en)}{doc.medio_pago ? ` · ${(MEDIOS_PAGO.find(([v]) => v === doc.medio_pago) || [])[1] || doc.medio_pago}` : ''}
                      {doc.monto_pagado != null && <div style={{ fontSize: 11.5, color: 'var(--ink-500)', marginTop: 2 }}>Pagado $ {Number(doc.monto_pagado).toLocaleString('es-CL')}</div>}
                    </div>
                  </div>
                )}
                {doc.notas && (
                  <div style={{ ...tileStyle, gridColumn: 'span 2' }}>
                    <div style={tileLbl}>Notas</div>
                    <div style={{ fontSize: 13, color: 'var(--ink-700)' }}>{doc.notas}</div>
                  </div>
                )}
              </div>

              {errorOmitir && !doc.recepcion_omitida && (
                <div style={{ fontSize: 12.5, color: 'var(--bad-ink)', marginBottom: 14 }}>{errorOmitir}</div>
              )}
              {doc.recepcion_omitida && (
                <div style={{ borderRadius: 12, padding: '10px 14px', marginBottom: 14, background: 'var(--paper-soft)', border: '1px solid var(--line)', display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                  <span style={{ fontSize: 12.5, color: 'var(--ink-600)', flex: '1 1 220px' }}>
                    Marcado como <strong>no recepcionado</strong>.
                  </span>
                  <button type="button" onClick={() => cambiarOmisionRecepcion(false)} disabled={ocupadoOmitir}
                    style={{ padding: '6px 14px', borderRadius: 999, border: '1px solid var(--line-strong)', background: 'var(--paper)', color: 'var(--ink-700)', fontSize: 12.5, fontFamily: 'inherit', cursor: ocupadoOmitir ? 'default' : 'pointer' }}>
                    {ocupadoOmitir ? 'Guardando…' : 'Deshacer'}
                  </button>
                  {errorOmitir && <span style={{ fontSize: 12.5, color: 'var(--bad-ink)', flexBasis: '100%' }}>{errorOmitir}</span>}
                </div>
              )}

              {/* Faltantes: documento cerrado con menos ejemplares de los que decía */}
              {(() => {
                if (doc.recepcion_omitida || !['completa', 'cerrada_incompleta'].includes(doc.estado) || doc.proposito !== 'ingreso_mercaderia') {
                  return okFalt ? <div style={{ fontSize: 12.5, color: 'var(--ok-ink)', background: 'var(--ok-bg)', border: '1px solid var(--ok-line)', borderRadius: 10, padding: '7px 12px', marginBottom: 14 }}>{okFalt}</div> : null;
                }
                const faltantes = (doc.detalle || []).filter(d => d.libro_id && Number(d.cantidad_recibida || 0) < Number(d.cantidad));
                const totalFalt = faltantes.reduce((n, d) => n + (Number(d.cantidad) - Number(d.cantidad_recibida || 0)), 0);
                const caja = { borderRadius: 12, padding: '10px 14px', marginBottom: 14 };
                return (
                  <>
                    {okFalt && <div style={{ fontSize: 12.5, color: 'var(--ok-ink)', background: 'var(--ok-bg)', border: '1px solid var(--ok-line)', borderRadius: 10, padding: '7px 12px', marginBottom: 14 }}>{okFalt}</div>}
                    {faltantes.length > 0 && !recibiendoFalt && (
                      <div style={{ ...caja, background: 'var(--warn-bg)', border: '1px solid var(--warn-line)', display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                        <AlertTriangle size={15} strokeWidth={2} style={{ color: 'var(--warn-ink)', flexShrink: 0 }} />
                        <span style={{ fontSize: 12.5, color: 'var(--warn-ink)', flex: '1 1 200px' }}>
                          <strong>Faltan {totalFalt} ejemplar{totalFalt !== 1 ? 'es' : ''}</strong> por recibir en {faltantes.length} título{faltantes.length !== 1 ? 's' : ''}.
                        </span>
                        <button type="button" onClick={() => { setRecibiendoFalt(true); setErrorFalt(''); setOkFalt(''); }}
                          style={{ padding: '6px 14px', borderRadius: 999, border: 'none', background: 'var(--brand)', color: '#fff', fontSize: 12.5, fontWeight: 600, fontFamily: 'inherit', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 5 }}>
                          <PackageCheck size={13} strokeWidth={1.75} /> Recibir faltantes
                        </button>
                      </div>
                    )}
                    {faltantes.length > 0 && recibiendoFalt && (
                      <div style={{ ...caja, background: 'var(--paper-soft)', border: '1px solid var(--line-strong)' }}>
                        <div style={{ fontSize: 10, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.08em', color: 'var(--ink-500)', marginBottom: 8 }}>¿Cuántos ejemplares llegaron ahora?</div>
                        {faltantes.map(d => {
                          const faltan = Number(d.cantidad) - Number(d.cantidad_recibida || 0);
                          return (
                            <div key={d.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '6px 0', borderTop: '1px solid var(--line-soft)' }}>
                              <div style={{ flex: 1, minWidth: 0 }}>
                                <div style={{ fontSize: 12.5, fontWeight: 600, color: 'var(--ink-900)', lineHeight: 1.25 }}>{d.titulo || '—'}</div>
                                <div style={{ fontSize: 11, color: 'var(--ink-500)' }}>Decía {d.cantidad} · recibidos {Number(d.cantidad_recibida || 0)} · faltan {faltan}</div>
                              </div>
                              <input type="number" min="0" max={faltan} value={cantFalt[d.id] ?? String(faltan)} aria-label={`Ejemplares que llegaron de ${d.titulo || 'este libro'}`}
                                onChange={e => setCantFalt(c => ({ ...c, [d.id]: e.target.value }))}
                                style={{ width: 70, boxSizing: 'border-box', padding: '5px 8px', border: '1px solid var(--line-strong)', borderRadius: 8, fontSize: 13, fontFamily: 'inherit', textAlign: 'right', background: 'var(--paper)', color: 'var(--ink-900)', outline: 'none' }} />
                            </div>
                          );
                        })}
                        <div style={{ height: 8 }} />
                        {errorFalt && <div style={{ fontSize: 12.5, color: 'var(--bad-ink)', marginBottom: 8 }}>{errorFalt}</div>}
                        <div style={{ display: 'flex', gap: 8 }}>
                          <button type="button" onClick={() => recibirFaltantes(faltantes)} disabled={ocupadoFalt}
                            style={{ padding: '7px 16px', borderRadius: 999, border: 'none', background: 'var(--brand)', color: '#fff', fontSize: 12.5, fontWeight: 600, fontFamily: 'inherit', cursor: ocupadoFalt ? 'not-allowed' : 'pointer', opacity: ocupadoFalt ? 0.7 : 1 }}>
                            {ocupadoFalt ? 'Ingresando…' : 'Ingresar al inventario'}
                          </button>
                          <button type="button" onClick={() => { setRecibiendoFalt(false); setErrorFalt(''); }} disabled={ocupadoFalt}
                            style={{ padding: '7px 14px', borderRadius: 999, border: '1px solid var(--line-strong)', background: 'var(--paper)', color: 'var(--ink-700)', fontSize: 12.5, fontFamily: 'inherit', cursor: 'pointer' }}>
                            Cancelar
                          </button>
                        </div>
                      </div>
                    )}
                  </>
                );
              })()}

              {/* Lines table */}
              {(() => {
                const lineas = doc.detalle || [];
                const esGastoDrawer = doc.proposito === 'gasto_servicio';
                const esGddDrawer   = doc.tipo === 'gdd';
                const esExentaDrawer = !!doc.es_exenta;
                if (lineas.length === 0) return (
                  <div style={{ fontSize: 12, color: 'var(--ink-400)', padding: '8px 0 12px' }}>Sin líneas registradas.</div>
                );
                return (
                  <>
                    <div style={{ fontSize: 10, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.08em', color: 'var(--ink-500)', marginBottom: 8 }}>
                      Líneas · {lineas.length}
                    </div>
                    <div style={{ border: '1px solid var(--line)', borderRadius: 12, overflow: 'hidden', marginBottom: 18 }}>
                      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12.5, tableLayout: esGastoDrawer ? 'auto' : 'fixed' }}>
                        {!esGastoDrawer && (
                          <colgroup>
                            <col />
                            <col style={{ width: 46 }} />
                            {esGddDrawer && <col style={{ width: 52 }} />}
                            <col style={{ width: 80 }} />
                            <col style={{ width: 80 }} />
                            <col style={{ width: 92 }} />
                          </colgroup>
                        )}
                        <thead>
                          <tr style={{ background: 'var(--paper-soft)' }}>
                            {esGastoDrawer ? (
                              <>
                                <th style={{ padding: '8px 12px', textAlign: 'left', fontWeight: 600, color: 'var(--ink-600)', fontSize: 11 }}>Descripción</th>
                                <th style={{ padding: '8px 8px', textAlign: 'right', fontWeight: 600, color: 'var(--ink-600)', fontSize: 11 }}>Cant.</th>
                                {!esExentaDrawer && <th style={{ padding: '8px 8px', textAlign: 'right', fontWeight: 600, color: 'var(--ink-600)', fontSize: 11 }}>Neto</th>}
                                <th style={{ padding: '8px 12px', textAlign: 'right', fontWeight: 600, color: 'var(--ink-600)', fontSize: 11 }}>Total</th>
                              </>
                            ) : (
                              <>
                                <th style={{ padding: '8px 12px', textAlign: 'left', fontWeight: 600, color: 'var(--ink-600)', fontSize: 11 }}>Libro</th>
                                <th style={{ padding: '8px 8px', textAlign: 'right', fontWeight: 600, color: 'var(--ink-600)', fontSize: 11 }}>Cant.</th>
                                {esGddDrawer && <th style={{ padding: '8px 8px', textAlign: 'right', fontWeight: 600, color: 'var(--ink-600)', fontSize: 11 }}>Recib.</th>}
                                <th style={{ padding: '8px 8px', textAlign: 'right', fontWeight: 600, color: 'var(--ink-600)', fontSize: 11 }}>Neto</th>
                                <th style={{ padding: '8px 8px', textAlign: 'right', fontWeight: 600, color: 'var(--ink-600)', fontSize: 11 }}>PVP</th>
                                <th style={{ padding: '8px 12px', textAlign: 'right', fontWeight: 600, color: 'var(--ink-600)', fontSize: 11 }}>Subtotal</th>
                              </>
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          {lineas.map((d, i) => {
                            if (esGastoDrawer) {
                              const valorNeto  = d.precio_neto != null ? Number(d.precio_neto) : (d.monto_item != null ? Number(d.monto_item) : null);
                              const valorTotal = valorNeto != null ? (esExentaDrawer ? valorNeto : Math.round(valorNeto * 1.19)) : null;
                              return (
                                <tr key={i} style={{ borderTop: '1px solid var(--line-soft)' }}>
                                  <td style={{ padding: '8px 12px', color: 'var(--ink-800)' }}>{d.descripcion || '—'}</td>
                                  <td style={{ padding: '8px 8px', textAlign: 'right', fontVariantNumeric: 'tabular-nums' }}>{d.cantidad}</td>
                                  {!esExentaDrawer && <td style={{ padding: '8px 8px', textAlign: 'right', fontVariantNumeric: 'tabular-nums', color: 'var(--ink-600)' }}>{valorNeto != null ? `$ ${valorNeto.toLocaleString('es-CL')}` : '—'}</td>}
                                  <td style={{ padding: '8px 12px', textAlign: 'right', fontVariantNumeric: 'tabular-nums', fontWeight: 600 }}>{valorTotal != null ? `$ ${valorTotal.toLocaleString('es-CL')}` : '—'}</td>
                                </tr>
                              );
                            }
                            const falta    = d.cantidad_recibida != null && d.cantidad_recibida < d.cantidad;
                            const subtotal = d.monto_item != null ? Number(d.monto_item) : (d.precio_neto ? d.cantidad * Number(d.precio_neto) : null);
                            return (
                              <tr key={i} style={{ borderTop: '1px solid var(--line-soft)' }}>
                                <td style={{ padding: '8px 12px' }}>
                                  <div style={{ fontWeight: 600, color: 'var(--ink-900)', lineHeight: 1.2 }}>{d.titulo || '—'}</div>
                                  {d.isbn && <div style={{ fontFamily: 'var(--font-mono)', fontSize: 11, color: 'var(--ink-500)', marginTop: 2 }}>{d.isbn}</div>}
                                  {d.autor && <div style={{ fontSize: 11, color: 'var(--ink-500)', marginTop: 2 }}>{d.autor}</div>}
                                </td>
                                <td style={{ padding: '8px 8px', textAlign: 'right', fontVariantNumeric: 'tabular-nums' }}>{d.cantidad}</td>
                                {esGddDrawer && (
                                  <td style={{ padding: '8px 8px', textAlign: 'right', fontVariantNumeric: 'tabular-nums' }}>
                                    {d.cantidad_recibida != null
                                      ? <span style={{ color: falta ? 'var(--bad-ink)' : 'var(--ink-700)', fontWeight: falta ? 600 : 400 }}>{d.cantidad_recibida}</span>
                                      : <span style={{ color: 'var(--ink-300)' }}>—</span>}
                                  </td>
                                )}
                                <td style={{ padding: '8px 8px', textAlign: 'right', fontVariantNumeric: 'tabular-nums', color: 'var(--ink-700)' }}>
                                  {d.precio_neto ? `$ ${Number(d.precio_neto).toLocaleString('es-CL')}` : '—'}
                                </td>
                                <td style={{ padding: '8px 8px', textAlign: 'right', fontVariantNumeric: 'tabular-nums', color: 'var(--ink-700)' }}>
                                  {d.pvp ? `$ ${Number(d.pvp).toLocaleString('es-CL')}` : '—'}
                                </td>
                                <td style={{ padding: '8px 12px', textAlign: 'right', fontVariantNumeric: 'tabular-nums', fontWeight: 600 }}>
                                  {subtotal != null ? `$ ${subtotal.toLocaleString('es-CL')}` : '—'}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </>
                );
              })()}
              </>)}
            </div>

            {/* Totales: cierran el documento, al estilo del pie de una factura */}
            {!editando && !recibiendo && finFilas && (
              <div style={{ padding: '10px 18px', borderTop: '1px solid var(--line)', background: 'var(--paper-soft)', flexShrink: 0, display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 2 }}>
                {finFilas.map((f, i) => {
                  const ultimo = i === finFilas.length - 1;
                  return (
                    <div key={f.label} style={{ display: 'flex', gap: 28, alignItems: 'baseline', ...(ultimo ? { marginTop: 4, paddingTop: 6, borderTop: '1px solid var(--line-strong)' } : {}) }}>
                      <span style={{ fontSize: ultimo ? 13 : 12, color: 'var(--ink-500)' }}>{f.label}</span>
                      <span style={{ minWidth: 96, textAlign: 'right', fontFamily: ultimo ? 'var(--font-display)' : 'inherit', fontWeight: ultimo ? 700 : 500, fontSize: ultimo ? 18 : 13, letterSpacing: ultimo ? '-0.02em' : 0, color: ultimo ? 'var(--brand)' : 'var(--ink-800)', fontVariantNumeric: 'tabular-nums' }}>
                        $ {f.value.toLocaleString('es-CL')}
                      </span>
                    </div>
                  );
                })}
              </div>
            )}

          </>
        )}
      </div>
    </React.Fragment>
  );
}
// ─────────────────────────────────────────────────────────────────────────────

// =============================================================================
// FINANZAS — Libro de caja
// =============================================================================

const FIN2_CATS = {
  ventas:         { label: 'Ventas mostrador',     tono: 'mint',   icono: ScanLine,     tipo: 'ingreso' },
  eventos:        { label: 'Eventos / talleres',   tono: 'violet', icono: GraduationCap, tipo: 'ingreso' },
  cafeteria:      { label: 'Cafetería',            tono: 'sand',   icono: Coffee,       tipo: 'ingreso' },
  capital:        { label: 'Aporte de capital',    tono: 'blue',   icono: PiggyBank,    tipo: 'ingreso' },
  otros_ing:      { label: 'Otros ingresos',       tono: 'olive',  icono: CirclePlus,   tipo: 'ingreso' },
  distribuidores: { label: 'Distribuidores',       tono: 'yellow', icono: Truck,        tipo: 'gasto'   },
  arriendo:       { label: 'Arriendo / local',     tono: 'peach',  icono: Building2,    tipo: 'gasto'   },
  sueldos:        { label: 'Sueldos',              tono: 'violet', icono: Users,        tipo: 'gasto'   },
  servicios:      { label: 'Servicios',            tono: 'blue',   icono: Zap,          tipo: 'gasto'   },
  insumos:        { label: 'Insumos',              tono: 'sand',   icono: Coffee,       tipo: 'gasto'   },
  marketing:      { label: 'Marketing',            tono: 'rose',   icono: Megaphone,    tipo: 'gasto'   },
  impuestos:      { label: 'Impuestos',             tono: 'yellow', icono: Receipt,      tipo: 'gasto'   },
  otros_gas:      { label: 'Otros gastos',         tono: 'olive',  icono: CirclePlus,   tipo: 'gasto'   },
};

const FIN2_TONO_VARS = {
  mint:   { bg: 'var(--past-mint)',   ink: 'var(--past-mint-ink)'   },
  peach:  { bg: 'var(--past-peach)',  ink: 'var(--past-peach-ink)'  },
  rose:   { bg: 'var(--past-rose)',   ink: 'var(--past-rose-ink)'   },
  yellow: { bg: 'var(--past-yellow)', ink: 'var(--past-yellow-ink)' },
  blue:   { bg: 'var(--past-blue)',   ink: 'var(--past-blue-ink)'   },
  violet: { bg: 'var(--past-violet)', ink: 'var(--past-violet-ink)' },
  olive:  { bg: 'var(--past-olive)',  ink: 'var(--past-olive-ink)'  },
  sand:   { bg: 'var(--past-sand)',   ink: 'var(--past-sand-ink)'   },
};

function fin2Clp(n) {
  return '$ ' + Number(Math.abs(n) || 0).toLocaleString('es-CL', { maximumFractionDigits: 0 });
}

function fin2IcoCircle(cat, size = 34) {
  const meta = FIN2_CATS[cat];
  if (!meta) return <span style={{ width: size, height: size, borderRadius: '50%', background: 'var(--line)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }} />;
  const tono = FIN2_TONO_VARS[meta.tono] || FIN2_TONO_VARS.sand;
  const Ico  = meta.icono;
  return (
    <span style={{ width: size, height: size, borderRadius: '50%', background: tono.bg, color: tono.ink, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
      <Ico size={Math.round(size * 0.46)} strokeWidth={1.75} />
    </span>
  );
}

// Mini sparkline SVG (area + line + dots)
function Fin2Trend({ serie }) {
  if (!serie || serie.length < 2) return null;
  const vals = serie.map(s => s.bal);
  const min  = Math.min(...vals);
  const max  = Math.max(...vals);
  const range = max - min || 1;
  const W = 220, H = 64, pad = 8;
  const iw = W - pad * 2, ih = H - pad * 2;
  const pts = vals.map((v, i) => [
    pad + (i / (vals.length - 1)) * iw,
    pad + ih - ((v - min) / range) * ih,
  ]);
  const linePath  = pts.map((p, i) => `${i === 0 ? 'M' : 'L'}${p[0].toFixed(1)},${p[1].toFixed(1)}`).join(' ');
  const areaPath  = `${linePath} L${pts[pts.length - 1][0].toFixed(1)},${H} L${pts[0][0].toFixed(1)},${H} Z`;
  return (
    <svg viewBox={`0 0 ${W} ${H}`} style={{ width: '100%', maxWidth: W, overflow: 'visible' }}>
      <defs>
        <linearGradient id="fin2grad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%"   stopColor="rgba(199,227,197,0.55)" />
          <stop offset="100%" stopColor="rgba(199,227,197,0)" />
        </linearGradient>
      </defs>
      <path d={areaPath} fill="url(#fin2grad)" />
      <path d={linePath} fill="none" stroke="var(--past-mint)" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
      {pts.map((p, i) => (
        <circle key={i} cx={p[0]} cy={p[1]} r={i === pts.length - 1 ? 4 : 3}
          fill={i === pts.length - 1 ? 'var(--past-mint-ink)' : 'var(--past-mint)'}
          stroke="rgba(255,255,255,0.3)" strokeWidth={1.5} />
      ))}
      {serie.map((s, i) => (
        <text key={i} x={pts[i][0]} y={H} fontSize={9} fill="rgba(255,255,255,0.45)" textAnchor="middle" fontFamily="var(--font-mono)">{s.mes}</text>
      ))}
    </svg>
  );
}

// Modal agregar movimiento
function Fin2Modal({ onClose, onGuardar, mesLabel, initialData }) {
  const editando = !!initialData;
  // La fecha de hoy es la local (toISOString daba la de UTC: de noche en Chile salía el día siguiente)
  const hoyLocal = () => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`; };
  const [tipo, setTipo]       = useState(initialData?.tipo || 'ingreso');
  const [monto, setMonto]     = useState(initialData ? String(Math.round(Number(initialData.monto))) : '');
  const [concepto, setConcepto] = useState(initialData?.concepto || '');
  const [cat, setCat]         = useState(initialData?.cat || '');
  const [detalle, setDetalle] = useState(initialData?.detalle || '');
  const [fecha, setFecha]     = useState(() => (initialData?.fecha ? String(initialData.fecha).slice(0, 10) : hoyLocal()));
  const [guardando, setGuardando] = useState(false);
  const [errorGuardar, setErrorGuardar] = useState('');

  const catsFiltradas = Object.entries(FIN2_CATS).filter(([, m]) => m.tipo === tipo);

  async function handleGuardar() {
    if (!monto || !concepto || !cat) return;
    setGuardando(true);
    setErrorGuardar('');
    try {
      await onGuardar({ tipo, monto: Number(monto), concepto, detalle, cat, fecha });
      onClose();
    } catch (e) {
      // Antes, si el servidor fallaba, el botón se quedaba en "Guardando…" para siempre
      setErrorGuardar(e?.response?.data?.error || e?.message || 'No se pudo guardar');
      setGuardando(false);
    }
  }

  const btnTipoStyle = (t) => ({
    flex: 1, padding: '10px 0', border: '1px solid ' + (tipo === t ? 'transparent' : 'var(--line)'),
    borderRadius: 999, cursor: 'pointer', fontFamily: 'inherit', fontSize: 13, fontWeight: 600,
    background: tipo === t ? (t === 'ingreso' ? 'var(--ok-bg)' : 'var(--bad-bg)') : 'var(--paper)',
    color: tipo === t ? (t === 'ingreso' ? 'var(--ok-ink)' : 'var(--bad-ink)') : 'var(--ink-500)',
    transition: 'all 140ms ease',
  });

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'var(--scrim)', zIndex: 'var(--z-modal)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}
      onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div style={{ background: 'var(--paper)', borderRadius: 24, padding: 28, width: '100%', maxWidth: 460, boxShadow: 'var(--shadow-pop)', display: 'flex', flexDirection: 'column', gap: 20 }}>
        {/* Header */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <span style={{ width: 38, height: 38, borderRadius: '50%', background: 'var(--brand-soft)', color: 'var(--brand)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            <Plus size={18} strokeWidth={2} />
          </span>
          <div>
            <div style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 18, letterSpacing: '-0.015em' }}>{editando ? 'Editar movimiento' : 'Agregar movimiento'}</div>
            <div style={{ fontSize: 12, color: 'var(--ink-500)', marginTop: 1 }}>{mesLabel}</div>
          </div>
          <button onClick={onClose} style={{ marginLeft: 'auto', width: 32, height: 32, borderRadius: '50%', border: '1px solid var(--line)', background: 'var(--paper)', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
            <X size={15} strokeWidth={2} />
          </button>
        </div>

        {/* Tipo toggle */}
        <div style={{ display: 'flex', gap: 8 }}>
          <button style={btnTipoStyle('ingreso')} onClick={() => { setTipo('ingreso'); setCat(''); }}>Ingreso</button>
          <button style={btnTipoStyle('gasto')}   onClick={() => { setTipo('gasto');   setCat(''); }}>Gasto</button>
        </div>

        {/* Monto */}
        <div>
          <div style={{ fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.08em', color: 'var(--ink-500)', marginBottom: 6 }}>Monto</div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 0, border: '1px solid var(--line)', borderRadius: 12, overflow: 'hidden', background: 'var(--paper)' }}>
            <span style={{ padding: '10px 14px', color: 'var(--ink-400)', fontFamily: 'var(--font-mono)', fontSize: 15, borderRight: '1px solid var(--line)', background: 'var(--paper-soft)' }}>$</span>
            <input type="number" min="0" value={monto} onChange={e => setMonto(e.target.value)} placeholder="0"
              style={{ flex: 1, border: 'none', outline: 'none', padding: '10px 14px', fontSize: 15, fontFamily: 'var(--font-mono)', fontVariantNumeric: 'tabular-nums', background: 'transparent', color: 'var(--ink-900)' }} />
          </div>
        </div>

        {/* Concepto */}
        <div>
          <div style={{ fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.08em', color: 'var(--ink-500)', marginBottom: 6 }}>Concepto</div>
          <input value={concepto} onChange={e => setConcepto(e.target.value)} placeholder="Ej: Ventas del fin de semana"
            style={{ width: '100%', boxSizing: 'border-box', border: '1px solid var(--line)', borderRadius: 12, padding: '10px 14px', fontSize: 14, fontFamily: 'inherit', outline: 'none', color: 'var(--ink-900)', background: 'var(--paper)' }} />
        </div>

        {/* Categoría */}
        <div>
          <div style={{ fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.08em', color: 'var(--ink-500)', marginBottom: 8 }}>Categoría</div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
            {catsFiltradas.map(([key, meta]) => {
              const tono  = FIN2_TONO_VARS[meta.tono] || FIN2_TONO_VARS.sand;
              const activo = cat === key;
              const Ico   = meta.icono;
              return (
                <button key={key} onClick={() => setCat(key)}
                  style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '6px 12px', borderRadius: 999, border: '1px solid ' + (activo ? tono.ink : 'var(--line)'), background: activo ? tono.bg : 'var(--paper)', color: activo ? tono.ink : 'var(--ink-700)', cursor: 'pointer', fontFamily: 'inherit', fontSize: 12.5, fontWeight: activo ? 600 : 400, transition: 'all 120ms ease' }}>
                  <Ico size={13} strokeWidth={1.75} />
                  {meta.label}
                </button>
              );
            })}
          </div>
        </div>

        {/* Detalle + Fecha */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
          <div>
            <div style={{ fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.08em', color: 'var(--ink-500)', marginBottom: 6 }}>Detalle (opcional)</div>
            <input value={detalle} onChange={e => setDetalle(e.target.value)} placeholder="Notas adicionales"
              style={{ width: '100%', boxSizing: 'border-box', border: '1px solid var(--line)', borderRadius: 12, padding: '10px 14px', fontSize: 13, fontFamily: 'inherit', outline: 'none', color: 'var(--ink-900)', background: 'var(--paper)' }} />
          </div>
          <div>
            <div style={{ fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.08em', color: 'var(--ink-500)', marginBottom: 6 }}>Fecha</div>
            <input type="date" value={fecha} onChange={e => setFecha(e.target.value)}
              style={{ width: '100%', boxSizing: 'border-box', border: '1px solid var(--line)', borderRadius: 12, padding: '10px 14px', fontSize: 13, fontFamily: 'inherit', outline: 'none', color: 'var(--ink-900)', background: 'var(--paper)' }} />
          </div>
        </div>

        {/* Footer */}
        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
          <button onClick={onClose} style={{ padding: '9px 18px', border: '1px solid var(--line-strong)', background: 'var(--paper)', color: 'var(--ink-800)', borderRadius: 999, cursor: 'pointer', fontFamily: 'inherit', fontSize: 13, fontWeight: 500 }}>
            Cancelar
          </button>
          <button onClick={handleGuardar} disabled={!monto || !concepto || !cat || guardando}
            style={{ padding: '9px 20px', border: 'none', background: 'var(--brand)', color: '#fff', borderRadius: 999, cursor: (!monto || !concepto || !cat) ? 'not-allowed' : 'pointer', fontFamily: 'inherit', fontSize: 13, fontWeight: 600, opacity: (!monto || !concepto || !cat) ? 0.6 : 1, display: 'inline-flex', alignItems: 'center', gap: 6 }}>
            <Check size={14} strokeWidth={2.5} /> {guardando ? 'Guardando…' : (editando ? 'Guardar cambios' : 'Guardar movimiento')}
          </button>
        </div>
        {errorGuardar && <div style={{ fontSize: 12.5, color: 'var(--bad-ink)', background: 'var(--bad-bg)', border: '1px solid var(--bad-line)', borderRadius: 10, padding: '8px 12px', marginTop: -8 }}>{errorGuardar}</div>}
      </div>
    </div>
  );
}

// Columna del ledger (Entradas o Salidas)
function Fin2LedgerCol({ titulo, tono, icono: Ico, total, signo, movs, onEdit, onDelete }) {
  const tonoVars = FIN2_TONO_VARS[tono] || FIN2_TONO_VARS.sand;
  const esIngreso = signo === '+';
  return (
    <div>
      {/* Col header */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 14 }}>
        <span style={{ width: 36, height: 36, borderRadius: '50%', background: tonoVars.bg, color: tonoVars.ink, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
          <Ico size={17} strokeWidth={1.75} />
        </span>
        <div>
          <div style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 16, letterSpacing: '-0.01em', lineHeight: 1.1 }}>{titulo}</div>
          <div style={{ fontSize: 11.5, color: 'var(--ink-500)', marginTop: 1 }}>{movs.length} movimiento{movs.length !== 1 ? 's' : ''}</div>
        </div>
        <div style={{ marginLeft: 'auto', fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: 20, letterSpacing: '-0.02em', fontVariantNumeric: 'tabular-nums', color: esIngreso ? 'var(--ok-ink)' : 'var(--bad-ink)' }}>
          {signo} {fin2Clp(total)}
        </div>
      </div>

      {/* Rows */}
      <div style={{ background: 'var(--paper)', border: '1px solid var(--line)', borderRadius: 16, overflow: 'hidden' }}>
        {movs.length === 0 && (
          <div style={{ padding: '24px 18px', color: 'var(--ink-400)', fontSize: 13, textAlign: 'center' }}>Sin movimientos este mes</div>
        )}
        {movs.map((mov, i) => {
          const meta = FIN2_CATS[mov.cat];
          const esSistema = mov.origen === 'sistema';
          return (
            <div key={mov.id} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '13px 16px', borderTop: i === 0 ? 'none' : '1px solid var(--line-soft)' }}>
              {fin2IcoCircle(mov.cat, 34)}
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
                  <span style={{ fontSize: 13.5, fontWeight: 500, color: 'var(--ink-900)' }}>{mov.concepto}</span>
                  <span style={{ padding: '2px 8px', borderRadius: 999, fontSize: 11, fontWeight: 500, background: esSistema ? 'var(--info-bg)' : 'var(--paper-stripe)', color: esSistema ? 'var(--info-ink)' : 'var(--ink-500)', border: '1px solid ' + (esSistema ? 'var(--info-line)' : 'var(--line)') }}>
                    {esSistema ? 'Sistema' : 'Manual'}
                  </span>
                </div>
                <div style={{ fontSize: 11.5, color: 'var(--ink-400)', marginTop: 2 }}>
                  {new Date(String(mov.fecha).slice(0, 10) + 'T12:00:00').toLocaleDateString('es-CL', { day: '2-digit', month: 'short' })}
                  {mov.detalle ? ` · ${mov.detalle}` : ''}
                </div>
              </div>
              <div style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 14.5, fontVariantNumeric: 'tabular-nums', color: esIngreso ? 'var(--ok-ink)' : 'var(--bad-ink)', flexShrink: 0 }}>
                {signo} {fin2Clp(mov.monto)}
              </div>
              {esSistema ? (
                <div style={{ width: 28, height: 28, borderRadius: 8, border: '1px solid var(--line)', background: 'var(--paper)', color: 'var(--ink-300)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }} title="Movimiento automático">
                  <Lock size={12} strokeWidth={1.75} />
                </div>
              ) : (
                <div style={{ display: 'flex', gap: 4, flexShrink: 0 }}>
                  <button onClick={() => onEdit(mov)}
                    style={{ width: 28, height: 28, borderRadius: 8, border: '1px solid var(--line)', background: 'var(--paper)', color: 'var(--ink-500)', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}
                    title="Editar">
                    <PencilLine size={12} strokeWidth={1.75} />
                  </button>
                  <button onClick={() => onDelete(mov)}
                    style={{ width: 28, height: 28, borderRadius: 8, border: '1px solid var(--bad-line)', background: 'var(--bad-bg)', color: 'var(--bad-ink)', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}
                    title="Eliminar">
                    <Trash2 size={12} strokeWidth={1.75} />
                  </button>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

function Finanzas({ setPagina }) {
  const mob = useMobile();
  const hoy   = new Date();
  const [tab, setTab] = useState('resumen'); // 'resumen' | 'caja' | 'impagas'
  const [resultado, setResultado] = useState(null); // resultado del mes (utilidad), distinto de la caja
  const [mesAno, setMesAno]   = useState({ y: hoy.getFullYear(), m: hoy.getMonth() + 1 });
  const [movs, setMovs]       = useState([]);
  const [tendencia, setTendencia] = useState([]);
  const [iva, setIva]             = useState(null);
  const [ivaAnt, setIvaAnt]       = useState(null);  // IVA mes anterior (a pagar)
  const [ivaModal, setIvaModal]   = useState(false); // modal confirmar pago
  const [ivaMonto, setIvaMonto]   = useState('');    // monto real a pagar
  const [ivaNotas, setIvaNotas]   = useState('');
  const [saldoBanco, setSaldoBanco]     = useState(null);  // saldo banco guardado
  const [saldoBancoInput, setSaldoBancoInput] = useState('');
  const [editandoBanco, setEditandoBanco]     = useState(false);
  const [guardandoBanco, setGuardandoBanco]   = useState(false);
  const [cargando, setCargando]   = useState(true);
  const [errorApi, setErrorApi]   = useState(null);
  const [modal, setModal]         = useState(false);
  const [editMov, setEditMov]     = useState(null);

  const mesKey   = `${mesAno.y}-${String(mesAno.m).padStart(2, '0')}`;
  const mesLabel = new Date(mesAno.y, mesAno.m - 1, 1).toLocaleDateString('es-CL', { month: 'long', year: 'numeric' });
  // Mes anterior (IVA a pagar)
  const mesAntAno = mesAno.m === 1 ? { y: mesAno.y - 1, m: 12 } : { y: mesAno.y, m: mesAno.m - 1 };
  const mesAntKey = `${mesAntAno.y}-${String(mesAntAno.m).padStart(2, '0')}`;
  const mesAntLabel = new Date(mesAntAno.y, mesAntAno.m - 1, 1).toLocaleDateString('es-CL', { month: 'long', year: 'numeric' });
  const diasEnMes = new Date(mesAno.y, mesAno.m, 0).getDate();
  const diaHoy    = mesAno.y === hoy.getFullYear() && mesAno.m === hoy.getMonth() + 1 ? hoy.getDate() : null;

  useEffect(() => { cargar(); }, [mesKey, mesAntKey]); // eslint-disable-line react-hooks/exhaustive-deps

  async function cargar() {
    setCargando(true);
    setErrorApi(null);
    try {
      const [mRes, tRes] = await Promise.all([
        api.get(`/movimientos?mes=${mesKey}`),
        api.get('/movimientos/tendencia?meses=6'),
      ]);
      const normalize = rows => (rows || []).map(r => ({ ...r, monto: Number(r.monto) || 0 }));
      setMovs(normalize(mRes.data));
      setTendencia(tRes.data || []);
    } catch (e) {
      console.error('[Finanzas] error cargando:', e);
      setErrorApi(e?.response?.data?.error || e?.message || 'Error al cargar datos');
    } finally { setCargando(false); }
    // IVA mes actual y mes anterior: fetches independientes
    try {
      const ivaRes = await api.get(`/movimientos/iva?mes=${mesKey}`);
      setIva(ivaRes.data || null);
    } catch (e) {
      console.error('[Finanzas] IVA no disponible:', e.message);
      setIva(null);
    }
    try {
      const r = await api.get(`/movimientos/iva-estado?mes=${mesAntKey}`);
      setIvaAnt(r.data || null);
    } catch (e) {
      console.error('[Finanzas] IVA anterior no disponible:', e.message);
      setIvaAnt(null);
    }
    try {
      const r = await api.get(`/movimientos/saldo-banco?mes=${mesKey}`);
      setSaldoBanco(r.data || null);
      if (r.data) setSaldoBancoInput(String(r.data.monto));
    } catch (e) {
      setSaldoBanco(null);
    }
    try {
      const r = await api.get(`/movimientos/resultado?mes=${mesKey}`);
      setResultado(r.data || null);
    } catch (e) {
      console.error('[Finanzas] resultado no disponible:', e.message);
      setResultado(null);
    }
  }

  async function guardarSaldoBanco() {
    const monto = parseInt(saldoBancoInput.replace(/\D/g, ''), 10);
    if (isNaN(monto)) return;
    setGuardandoBanco(true);
    try {
      const r = await api.post('/movimientos/saldo-banco', { mes: mesKey, monto, snapshot_ing: totIng, snapshot_gas: totGas });
      setSaldoBanco(r.data);
      setEditandoBanco(false);
      await cargar();
    } catch (e) {
      console.error(e);
    } finally {
      setGuardandoBanco(false);
    }
  }

  async function marcarIvaPagado() {
    try {
      const r = await api.post('/movimientos/iva-pagar', {
        mes: mesAntKey,
        monto_estimado: ivaAnt?.saldo > 0 ? ivaAnt.saldo : 0,
        monto_real: ivaMonto ? parseInt(ivaMonto.replace(/\D/g, ''), 10) : null,
        notas: ivaNotas || null,
      });
      setIvaAnt(prev => ({ ...prev, pago: r.data }));
      setIvaModal(false);
      setIvaMonto('');
      setIvaNotas('');
    } catch (e) {
      alert(e.response?.data?.error || 'Error al registrar pago');
    }
  }

  async function handleGuardar(data) {
    if (editMov) {
      await api.put(`/movimientos/${editMov.id}`, data);
    } else {
      await api.post('/movimientos', data);
    }
    setEditMov(null);
    await cargar();
  }

  async function handleEliminar(mov) {
    if (!window.confirm(`¿Eliminar "${mov.concepto}"?`)) return;
    await api.delete(`/movimientos/${mov.id}`);
    await cargar();
  }

  function cambiarMes(delta) {
    setMesAno(prev => {
      let m = prev.m + delta, y = prev.y;
      if (m < 1)  { m = 12; y--; }
      if (m > 12) { m = 1;  y++; }
      return { y, m };
    });
  }

  // Derived
  const ingresos = movs.filter(m => m.tipo === 'ingreso');
  const gastos   = movs.filter(m => m.tipo === 'gasto');
  const totIng   = ingresos.reduce((s, m) => s + Number(m.monto), 0);
  const totGas   = gastos.reduce((s, m) => s + Number(m.monto), 0);
  const balance  = totIng - totGas;
  const esPos    = balance >= 0;

  // Desglose de gastos por categoría para la barra
  const desgloseGas = Object.entries(FIN2_CATS)
    .filter(([, m]) => m.tipo === 'gasto')
    .map(([key, meta]) => ({
      key, meta,
      total: gastos.filter(m => m.cat === key).reduce((s, m) => s + Number(m.monto), 0),
    }))
    .filter(d => d.total > 0)
    .sort((a, b) => b.total - a.total);

  const selectorMes = (
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 24 }}>
        <button onClick={() => cambiarMes(-1)} style={{ width: 32, height: 32, borderRadius: '50%', border: '1px solid var(--line)', background: 'var(--paper)', color: 'var(--ink-700)', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
          <ChevronLeft size={16} strokeWidth={1.75} />
        </button>
        <div style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 18, letterSpacing: '-0.01em', textTransform: 'capitalize', minWidth: 150, textAlign: 'center' }}>{mesLabel}</div>
        <button onClick={() => cambiarMes(+1)} style={{ width: 32, height: 32, borderRadius: '50%', border: '1px solid var(--line)', background: 'var(--paper)', color: 'var(--ink-700)', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', opacity: (mesAno.y > hoy.getFullYear() || (mesAno.y === hoy.getFullYear() && mesAno.m >= hoy.getMonth() + 1)) ? 0.35 : 1 }}>
          <ChevronRight size={16} strokeWidth={1.75} />
        </button>
        <span style={{ fontSize: 12.5, color: 'var(--ink-400)', marginLeft: 4 }}>
          {movs.length} movimiento{movs.length !== 1 ? 's' : ''}
          {diaHoy && <span style={{ marginLeft: 6 }}>· cierra en {diasEnMes - diaHoy} días</span>}
        </span>
      </div>
  );

  return (
    <div style={{ maxWidth: 900, margin: '0 auto' }}>
      {/* ── Page head ── */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 20, flexWrap: 'wrap' }}>
        <div>
          <h1 style={{ fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: 30, letterSpacing: '-0.025em', margin: 0 }}>Finanzas</h1>
          <div style={{ fontSize: 13, color: 'var(--ink-500)', marginTop: 3 }}>Resultado, caja y cuentas por pagar</div>
        </div>
        {tab === 'caja' && (
          <div style={{ marginLeft: 'auto', display: 'flex', gap: 8 }}>
            <button onClick={() => { setEditMov(null); setModal(true); }}
              style={{ display: 'inline-flex', alignItems: 'center', gap: 7, padding: '9px 18px', background: 'var(--brand)', color: '#fff', border: 'none', borderRadius: 999, cursor: 'pointer', fontFamily: 'inherit', fontSize: 13, fontWeight: 600 }}>
              <Plus size={15} strokeWidth={2.5} /> Agregar movimiento
            </button>
          </div>
        )}
      </div>

      {/* ── Tabs ── */}
      <div style={{ display: 'flex', gap: 6, marginBottom: 24, borderBottom: '1px solid var(--line-soft)' }}>
        {[['resumen', 'Resumen'], ['caja', 'Libro de caja'], ['proyeccion', 'Proyección'], ['impagas', 'Por pagar']].map(([id, label]) => (
          <button key={id} onClick={() => setTab(id)}
            style={{
              padding: '9px 16px', border: 'none', borderBottom: tab === id ? '2px solid var(--brand)' : '2px solid transparent',
              background: 'none', cursor: 'pointer', fontFamily: 'var(--font-ui)', fontSize: 13.5,
              fontWeight: tab === id ? 700 : 500, color: tab === id ? 'var(--ink-900)' : 'var(--ink-400)', marginBottom: -1,
            }}>
            {label}
          </button>
        ))}
      </div>

      {tab === 'proyeccion' && <FinProyeccion irA={setTab} />}

      {tab === 'impagas' && <FinFacturasImpagas setPagina={setPagina} />}

      {tab === 'resumen' && (
      <>
      {selectorMes}
      {cargando && <div style={{ textAlign: 'center', padding: '60px 0', color: 'var(--ink-400)', fontSize: 14 }}>Cargando…</div>}
      {!cargando && !resultado && (
        <div style={{ background: 'var(--warn-bg)', border: '1px solid var(--warn-line)', borderRadius: 14, padding: '14px 18px', color: 'var(--warn-ink)', fontSize: 13 }}>
          No se pudo calcular el resultado del mes. <button onClick={cargar} style={{ marginLeft: 8, padding: '3px 12px', borderRadius: 999, border: '1px solid var(--warn-line)', background: 'var(--paper)', color: 'var(--warn-ink)', cursor: 'pointer', fontSize: 12, fontFamily: 'inherit' }}>Reintentar</button>
        </div>
      )}
      {!cargando && resultado && (() => {
        const r = resultado;
        // Resultado: todo sin IVA
        const ventasNeto = Math.round(r.ventas_total / 1.19);
        const costoNeto  = r.costo_desconocido ? null : Math.round(r.costo_total / 1.19);
        const margen     = costoNeto == null ? null : ventasNeto - costoNeto;
        const gastosMap  = {};
        (r.gastos || []).forEach(g => { gastosMap[g.cat] = (gastosMap[g.cat] || 0) + g.total; });
        if (r.gastos_servicios_doc) gastosMap.servicios = (gastosMap.servicios || 0) + r.gastos_servicios_doc;
        const gastosOp   = Object.entries(gastosMap).filter(([, t]) => t !== 0).sort((x, y) => y[1] - x[1]);
        const totGastosOp = gastosOp.reduce((n, [, t]) => n + t, 0);
        const utilidad   = margen == null ? null : margen + r.otros_ingresos - totGastosOp;
        const estimado   = !r.costo_desconocido && r.ventas_total > 0 && r.cobertura < 0.999;
        // Caja: lo que realmente entró y salió (con IVA), del libro de caja
        const pagosDist  = gastos.filter(m => m.cat === 'distribuidores').reduce((n, m) => n + m.monto, 0);
        const ivaPagado  = gastos.filter(m => m.origen === 'sistema' && m.cat === 'impuestos').reduce((n, m) => n + m.monto, 0);
        const gastosFijos = totGas - pagosDist - ivaPagado;
        const celda = { padding: '7px 0', borderTop: '1px solid var(--line-soft)', fontVariantNumeric: 'tabular-nums' };
        const fila = (label, valor, opts = {}) => (
          <div style={{ display: 'flex', alignItems: 'baseline', gap: 12, ...celda, ...(opts.fuerte ? { fontWeight: 600, fontSize: 14 } : { fontSize: 13 }), ...(opts.primera ? { borderTop: 'none' } : {}) }}>
            <span style={{ flex: 1, paddingLeft: opts.sangria ? 14 : 0, color: opts.sangria ? 'var(--ink-500)' : 'var(--ink-900)' }}>{label}</span>
            <span style={{ color: opts.color || (opts.sangria ? 'var(--ink-600)' : 'var(--ink-900)'), whiteSpace: 'nowrap' }}>{valor}</span>
          </div>
        );
        const tarjeta = { background: 'var(--paper)', border: '1px solid var(--line)', borderRadius: 18, padding: '18px 22px' };
        const titulo = { fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.08em', color: 'var(--ink-500)', marginBottom: 10 };
        return (
          <>
            <div style={{ display: 'grid', gridTemplateColumns: mob ? '1fr' : '1fr 1fr', gap: 16, marginBottom: 16 }}>
              <div style={tarjeta}>
                <div style={titulo}>Resultado del mes · lo ganado</div>
                {fila('Ventas netas (sin IVA)', fin2Clp(ventasNeto), { primera: true })}
                {fila(`− Costo de lo vendido${estimado ? ' (estimado)' : ''}`, costoNeto == null ? 'sin costos' : '− ' + fin2Clp(costoNeto), { sangria: true })}
                {fila('Margen bruto', margen == null ? '—' : fin2Clp(margen) + (ventasNeto > 0 ? `  ${Math.round((margen / ventasNeto) * 100)}%` : ''), { fuerte: true })}
                {r.otros_ingresos > 0 && fila('+ Otros ingresos', '+ ' + fin2Clp(r.otros_ingresos), { sangria: true })}
                {gastosOp.map(([cat, t]) => fila(`− ${(FIN2_CATS[cat] || {}).label || cat}`, '− ' + fin2Clp(t), { sangria: true }))}
                {gastosOp.length === 0 && fila('− Gastos del mes', '$ 0', { sangria: true })}
                {fila('Utilidad del mes', utilidad == null ? '—' : (utilidad >= 0 ? '' : '− ') + fin2Clp(utilidad), { fuerte: true, color: utilidad == null ? undefined : utilidad >= 0 ? 'var(--ok-ink)' : 'var(--bad-ink)' })}
                {r.costo_desconocido && (
                  <div style={{ fontSize: 11.5, color: 'var(--warn-ink)', background: 'var(--warn-bg)', borderRadius: 8, padding: '6px 10px', marginTop: 10 }}>
                    Las ventas de este mes no tienen costo registrado, así que no se puede calcular el margen ni la utilidad.
                  </div>
                )}
                {estimado && (
                  <div style={{ fontSize: 11.5, color: 'var(--warn-ink)', background: 'var(--warn-bg)', borderRadius: 8, padding: '6px 10px', marginTop: 10 }}>
                    Estimado: el {Math.round((1 - r.cobertura) * 100)}% de las ventas no tiene costo registrado; se les aplicó el costo promedio del resto.
                  </div>
                )}
              </div>
              <div style={tarjeta}>
                <div style={titulo}>Caja del mes · lo que entró y salió</div>
                {fila('Entró (con IVA)', '+ ' + fin2Clp(totIng), { primera: true })}
                {fila('Pagos a distribuidores', '− ' + fin2Clp(pagosDist), { sangria: true })}
                {fila('Gastos', '− ' + fin2Clp(gastosFijos), { sangria: true })}
                {ivaPagado > 0 && fila('IVA pagado', '− ' + fin2Clp(ivaPagado), { sangria: true })}
                {fila('Caja del mes', (balance >= 0 ? '+ ' : '− ') + fin2Clp(balance), { fuerte: true, color: balance >= 0 ? 'var(--ok-ink)' : 'var(--bad-ink)' })}
                <div style={{ fontSize: 11.5, color: 'var(--ink-500)', marginTop: 12, lineHeight: 1.5 }}>
                  {utilidad != null
                    ? `La caja ${balance >= utilidad ? 'supera' : 'queda bajo'} a la utilidad en ${fin2Clp(balance - utilidad)}. Se explica por el IVA que cobraste y pagaste, por cuánto compraste de mercadería frente a lo que vendiste, y por aportes de capital.`
                    : 'La caja cuenta lo que se cobró y pagó, con IVA; la utilidad cuenta solo lo ganado.'}
                </div>
              </div>
            </div>
            <div style={{ fontSize: 11.5, color: 'var(--ink-400)', lineHeight: 1.5, padding: '0 4px' }}>
              El resultado deja fuera los pagos a distribuidores (ya están en el costo de lo vendido), el IVA pagado y los aportes de capital.
            </div>
          </>
        );
      })()}
      </>
      )}

      {tab === 'caja' && (
      <>
      {selectorMes}

      {cargando && (
        <div style={{ textAlign: 'center', padding: '60px 0', color: 'var(--ink-400)', fontSize: 14 }}>Cargando…</div>
      )}

      {errorApi && !cargando && (
        <div style={{ background: 'var(--bad-bg)', border: '1px solid var(--bad-line)', borderRadius: 14, padding: '14px 18px', marginBottom: 20, color: 'var(--bad-ink)', fontSize: 13 }}>
          <strong>Error al cargar datos:</strong> {errorApi}
          <button onClick={cargar} style={{ marginLeft: 14, padding: '4px 12px', borderRadius: 999, border: '1px solid var(--bad-line)', background: 'var(--paper)', color: 'var(--bad-ink)', cursor: 'pointer', fontSize: 12, fontFamily: 'inherit' }}>Reintentar</button>
        </div>
      )}

      {!cargando && (
        <>
          {/* ── Hero balance (fondo oscuro) ── */}
          <div style={{ background: 'var(--ink-900)', borderRadius: 24, padding: '28px 32px', marginBottom: 20, display: 'flex', alignItems: 'center', gap: 32, flexWrap: 'wrap' }}>
            <div style={{ flex: 1, minWidth: 200 }}>
              <div style={{ fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.1em', color: 'var(--ink-400)', fontWeight: 500, marginBottom: 8 }}>Resultado del mes</div>
              <div style={{ fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: 48, letterSpacing: '-0.03em', fontVariantNumeric: 'tabular-nums', color: esPos ? 'var(--past-mint)' : '#F8A0A0', lineHeight: 1.0 }}>
                {esPos ? '+ ' : '− '}{fin2Clp(balance)}
              </div>
              {tendencia.length >= 2 && (() => {
                const prev = tendencia[tendencia.length - 2]?.bal || 0;
                const curr = tendencia[tendencia.length - 1]?.bal || balance;
                const pct  = prev !== 0 ? Math.round(((curr - prev) / Math.abs(prev)) * 100) : null;
                if (pct === null) return null;
                return (
                  <div style={{ display: 'inline-flex', alignItems: 'center', gap: 5, marginTop: 10, padding: '4px 12px', borderRadius: 999, background: 'rgba(199,227,197,0.15)', color: 'var(--past-mint)' }}>
                    <TrendingUp size={13} strokeWidth={2} />
                    <span style={{ fontSize: 13, fontWeight: 500 }}>{pct >= 0 ? '+' : ''}{pct}% vs. mes anterior</span>
                  </div>
                );
              })()}
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginTop: 18 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  <span style={{ width: 10, height: 10, borderRadius: 3, background: 'var(--past-mint)', flexShrink: 0 }} />
                  <span style={{ fontSize: 12, color: 'var(--ink-400)' }}>Entró</span>
                  <span style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 21, letterSpacing: '-0.015em', fontVariantNumeric: 'tabular-nums', color: 'var(--past-mint)', marginLeft: 'auto' }}>+ {fin2Clp(totIng)}</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  <span style={{ width: 10, height: 10, borderRadius: 3, background: 'var(--past-peach)', flexShrink: 0 }} />
                  <span style={{ fontSize: 12, color: 'var(--ink-400)' }}>Salió</span>
                  <span style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 21, letterSpacing: '-0.015em', fontVariantNumeric: 'tabular-nums', color: 'var(--past-peach)', marginLeft: 'auto' }}>− {fin2Clp(totGas)}</span>
                </div>
              </div>
            </div>
            {tendencia.length > 0 && (
              <div style={{ minWidth: 200, flex: '0 0 220px' }}>
                <div style={{ fontSize: 11.5, color: 'var(--ink-300)', marginBottom: 10 }}>Balance · últimos 6 meses</div>
                <Fin2Trend serie={tendencia} />
              </div>
            )}

            {/* ── IVA mes anterior ── */}
            {ivaAnt && (() => {
              const pagado  = !!ivaAnt.pago;
              const aFavor  = ivaAnt.saldo < 0;
              const hoyD    = new Date();
              const vence   = new Date(hoyD.getFullYear(), hoyD.getMonth(), 19);
              const diff    = Math.ceil((vence - hoyD) / (1000 * 60 * 60 * 24));
              const urgente = !pagado && !aFavor && diff <= 5 && diff >= 0;
              const vencido = !pagado && !aFavor && diff < 0;
              const saldoMostrar = pagado
                ? (ivaAnt.pago.monto_real ?? ivaAnt.pago.monto_estimado ?? Math.abs(ivaAnt.saldo))
                : Math.abs(ivaAnt.saldo);
              return (
                <div style={{ flex: '0 0 220px', minWidth: 200, display: 'flex', flexDirection: 'column', gap: 6 }}>
                  <div style={{ fontSize: 10, textTransform: 'uppercase', letterSpacing: '0.08em', color: 'var(--ink-400)', fontWeight: 600 }}>
                    IVA {mesAntLabel}
                  </div>
                  {/* débito */}
                  <div style={{ background: 'rgba(248,215,192,0.18)', borderRadius: 10, padding: '10px 12px' }}>
                    <div style={{ fontSize: 10, color: 'var(--past-peach)', fontWeight: 500, marginBottom: 3 }}>Débito fiscal</div>
                    <div style={{ fontSize: 17, fontWeight: 700, color: '#fff', fontFamily: 'var(--font-display)', letterSpacing: '-0.02em' }}>{fin2Clp(ivaAnt.debito)}</div>
                    <div style={{ fontSize: 10, color: 'var(--ink-400)', marginTop: 2 }}>ventas {fin2Clp(ivaAnt.totalVentas)}</div>
                  </div>
                  {/* crédito */}
                  <div style={{ background: 'rgba(199,227,197,0.18)', borderRadius: 10, padding: '10px 12px' }}>
                    <div style={{ fontSize: 10, color: 'var(--past-mint)', fontWeight: 500, marginBottom: 3 }}>Crédito fiscal</div>
                    <div style={{ fontSize: 17, fontWeight: 700, color: '#fff', fontFamily: 'var(--font-display)', letterSpacing: '-0.02em' }}>{fin2Clp(ivaAnt.credito)}</div>
                    <div style={{ fontSize: 10, color: 'var(--ink-400)', marginTop: 2 }}>facturas y notas {fin2Clp(ivaAnt.totalFacturas)}</div>
                  </div>
                  {/* saldo */}
                  <div style={{ background: pagado ? 'rgba(46,92,61,0.35)' : aFavor ? 'rgba(200,220,239,0.18)' : urgente || vencido ? 'rgba(220,60,30,0.18)' : 'rgba(255,255,255,0.06)', border: `1px solid ${pagado ? 'rgba(46,92,61,0.5)' : aFavor ? 'rgba(200,220,239,0.3)' : urgente || vencido ? 'rgba(220,60,30,0.4)' : 'rgba(255,255,255,0.10)'}`, borderRadius: 10, padding: '10px 12px' }}>
                    <div style={{ fontSize: 10, color: pagado ? 'var(--past-mint)' : aFavor ? 'var(--past-blue)' : 'var(--ink-400)', fontWeight: 500, marginBottom: 3 }}>
                      {pagado ? '✓ Pagado' : aFavor ? 'Remanente a favor' : 'IVA a pagar'}
                    </div>
                    <div style={{ fontSize: 17, fontWeight: 700, fontFamily: 'var(--font-display)', letterSpacing: '-0.02em', color: pagado ? 'var(--past-mint)' : aFavor ? 'var(--past-blue)' : urgente || vencido ? '#FCA5A5' : '#fff' }}>
                      {fin2Clp(saldoMostrar)}
                    </div>
                    {pagado ? (
                      <>
                        <div style={{ fontSize: 10, color: 'var(--past-mint)', opacity: 0.75, marginTop: 2 }}>
                          {new Date(String(ivaAnt.pago.pagado_en).slice(0,10)+'T12:00:00').toLocaleDateString('es-CL',{day:'numeric',month:'short'})}
                        </div>
                        <button onClick={() => { setIvaMonto(String(ivaAnt.pago.monto_real ?? '')); setIvaNotas(ivaAnt.pago.notas||''); setIvaModal(true); }}
                          style={{ marginTop: 6, fontSize: 10, color: 'var(--ink-400)', background: 'none', border: 'none', cursor: 'pointer', padding: 0, textDecoration: 'underline', textDecorationStyle: 'dotted' }}>
                          Corregir monto
                        </button>
                      </>
                    ) : aFavor ? (
                      <div style={{ fontSize: 10, color: 'var(--ink-400)', marginTop: 2 }}>crédito &gt; débito</div>
                    ) : (
                      <>
                        <div style={{ fontSize: 10, marginTop: 2, color: urgente || vencido ? '#FCA5A5' : 'var(--ink-400)' }}>
                          {vencido ? '⚠ Venció el 19' : diff === 0 ? '⚠ Vence hoy' : `Vence el 19 · ${diff}d`}
                        </div>
                        <button onClick={() => { setIvaMonto(String(Math.abs(ivaAnt.saldo))); setIvaNotas(''); setIvaModal(true); }}
                          style={{ marginTop: 8, width: '100%', padding: '6px 0', background: urgente || vencido ? '#ef4444' : 'var(--brand)', color: '#fff', border: 'none', borderRadius: 7, cursor: 'pointer', fontSize: 11, fontWeight: 600, fontFamily: 'var(--font-ui)' }}>
                          Marcar como pagado
                        </button>
                      </>
                    )}
                  </div>
                </div>
              );
            })()}
          </div>

          {/* ── Modal confirmar pago IVA ── */}
          {ivaModal && (
            <div style={{ position: 'fixed', inset: 0, background: 'var(--scrim)', zIndex: 200, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
              onClick={e => { if (e.target === e.currentTarget) setIvaModal(false); }}>
              <div style={{ background: 'var(--paper)', borderRadius: 20, padding: 28, width: 340, boxShadow: 'var(--shadow-pop)' }}>
                <div style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 18, marginBottom: 6 }}>Registrar pago IVA</div>
                <div style={{ fontSize: 13, color: 'var(--ink-500)', marginBottom: 20 }}>IVA {mesAntLabel} · estimado {fin2Clp(ivaAnt?.saldo > 0 ? ivaAnt.saldo : 0)}</div>
                <div style={{ fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.07em', color: 'var(--ink-500)', marginBottom: 6 }}>Monto real pagado en SII</div>
                <input
                  type="number" value={ivaMonto} onChange={e => setIvaMonto(e.target.value)}
                  placeholder="Monto en pesos"
                  style={{ width: '100%', boxSizing: 'border-box', border: '1px solid var(--line)', borderRadius: 10, padding: '10px 14px', fontSize: 14, fontFamily: 'inherit', marginBottom: 14 }}
                />
                <div style={{ fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.07em', color: 'var(--ink-500)', marginBottom: 6 }}>Notas (opcional)</div>
                <input
                  type="text" value={ivaNotas} onChange={e => setIvaNotas(e.target.value)}
                  placeholder="Ej: pagado con factura 1234"
                  style={{ width: '100%', boxSizing: 'border-box', border: '1px solid var(--line)', borderRadius: 10, padding: '10px 14px', fontSize: 13, fontFamily: 'inherit', marginBottom: 20 }}
                />
                <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
                  <button onClick={() => setIvaModal(false)}
                    style={{ padding: '8px 18px', border: '1px solid var(--line)', background: 'var(--paper)', borderRadius: 999, cursor: 'pointer', fontSize: 13, fontFamily: 'inherit' }}>
                    Cancelar
                  </button>
                  <button onClick={marcarIvaPagado} disabled={!ivaMonto}
                    style={{ padding: '8px 20px', background: 'var(--brand)', color: '#fff', border: 'none', borderRadius: 999, cursor: ivaMonto ? 'pointer' : 'not-allowed', opacity: ivaMonto ? 1 : 0.5, fontSize: 13, fontWeight: 600, fontFamily: 'inherit' }}>
                    Confirmar pago
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* ── Barra desglose gastos ── */}
          {desgloseGas.length > 0 && (
            <div style={{ background: 'var(--paper)', border: '1px solid var(--line)', borderRadius: 20, padding: '20px 22px', marginBottom: 20 }}>
              <div style={{ display: 'flex', alignItems: 'baseline', gap: 10, marginBottom: 14 }}>
                <h4 style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 15, letterSpacing: '-0.01em', margin: 0 }}>En qué se va la plata</h4>
                <span style={{ fontSize: 13, color: 'var(--ink-500)', fontFamily: 'var(--font-mono)' }}>total gastos {fin2Clp(totGas)}</span>
              </div>
              {/* Barra */}
              <div style={{ display: 'flex', height: 26, borderRadius: 999, overflow: 'hidden', marginBottom: 14 }}>
                {desgloseGas.map(({ key, meta, total }) => {
                  const tono = FIN2_TONO_VARS[meta.tono] || FIN2_TONO_VARS.sand;
                  const pct  = totGas > 0 ? (total / totGas) * 100 : 0;
                  return (
                    <div key={key} title={`${meta.label}: ${fin2Clp(total)}`}
                      style={{ width: pct + '%', background: tono.bg, transition: 'width 400ms ease', minWidth: pct > 1 ? 4 : 0 }} />
                  );
                })}
              </div>
              {/* Leyenda */}
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px 18px' }}>
                {desgloseGas.map(({ key, meta, total }) => {
                  const tono = FIN2_TONO_VARS[meta.tono] || FIN2_TONO_VARS.sand;
                  const pct  = totGas > 0 ? Math.round((total / totGas) * 100) : 0;
                  return (
                    <div key={key} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                      <span style={{ width: 10, height: 10, borderRadius: 3, background: tono.bg, border: '1px solid ' + tono.ink, flexShrink: 0 }} />
                      <span style={{ fontSize: 12.5, color: 'var(--ink-700)' }}>{meta.label}</span>
                      <span style={{ fontSize: 12, color: 'var(--ink-400)', fontFamily: 'var(--font-mono)' }}>{pct}%</span>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {/* ── Ledger: dos columnas ── */}
          <div style={{ display: 'grid', gridTemplateColumns: mob ? '1fr' : '1fr 1fr', gap: 20, marginBottom: 28 }}>
            <Fin2LedgerCol
              titulo="Entradas" tono="mint" icono={ArrowDownLeft}
              total={totIng} signo="+"
              movs={ingresos}
              onEdit={m => { setEditMov(m); setModal(true); }}
              onDelete={handleEliminar}
            />
            <Fin2LedgerCol
              titulo="Salidas" tono="peach" icono={ArrowUpRight}
              total={totGas} signo="−"
              movs={gastos}
              onEdit={m => { setEditMov(m); setModal(true); }}
              onDelete={handleEliminar}
            />
          </div>

          {/* ── Saldo banco ── */}
          {(() => {
            // Movimientos desde la fecha en que se ingresó el saldo banco
            const fechaLabel = saldoBanco
              ? new Date(String(saldoBanco.actualizado_en).slice(0, 10) + 'T12:00:00').toLocaleDateString('es-CL', { day: 'numeric', month: 'short' })
              : null;
            const ingDesde   = saldoBanco ? totIng - Number(saldoBanco.snapshot_ing || 0) : 0;
            const gasDesde   = saldoBanco ? totGas - Number(saldoBanco.snapshot_gas || 0) : 0;
            const proyectado = saldoBanco ? Number(saldoBanco.monto) + ingDesde - gasDesde : null;

            return (
              <div style={{ background: 'var(--paper)', border: '1px solid var(--line)', borderRadius: 16, padding: '18px 20px', marginBottom: 20 }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14 }}>
                  <div style={{ fontSize: 11, fontWeight: 600, color: 'var(--ink-400)', textTransform: 'uppercase', letterSpacing: '0.08em' }}>
                    Saldo banco · {mesLabel}
                  </div>
                  {saldoBanco && !editandoBanco && (
                    <button onClick={() => { setEditandoBanco(true); setSaldoBancoInput(String(saldoBanco.monto)); }}
                      style={{ fontSize: 11, color: 'var(--ink-400)', background: 'none', border: 'none', cursor: 'pointer', textDecoration: 'underline', textDecorationStyle: 'dotted' }}>
                      Actualizar
                    </button>
                  )}
                </div>
                {editandoBanco || !saldoBanco ? (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 8, maxWidth: 280 }}>
                    <input
                      type="number"
                      value={saldoBancoInput}
                      onChange={e => setSaldoBancoInput(e.target.value)}
                      placeholder="Monto en pesos"
                      style={{ width: '100%', padding: '8px 12px', borderRadius: 10, border: '1px solid var(--line)', fontSize: 15, fontFamily: 'var(--font-ui)', boxSizing: 'border-box' }}
                      onKeyDown={e => e.key === 'Enter' && guardarSaldoBanco()}
                      autoFocus
                    />
                    <div style={{ display: 'flex', gap: 8 }}>
                      <button onClick={guardarSaldoBanco} disabled={guardandoBanco}
                        style={{ flex: 1, padding: '7px 0', background: 'var(--brand)', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 13, fontWeight: 600, fontFamily: 'var(--font-ui)' }}>
                        {guardandoBanco ? 'Guardando…' : 'Guardar'}
                      </button>
                      {editandoBanco && (
                        <button onClick={() => setEditandoBanco(false)}
                          style={{ padding: '7px 14px', background: 'none', border: '1px solid var(--line)', borderRadius: 8, cursor: 'pointer', fontSize: 13, color: 'var(--ink-500)', fontFamily: 'var(--font-ui)' }}>
                          Cancelar
                        </button>
                      )}
                    </div>
                  </div>
                ) : (
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12 }}>
                    {/* Saldo ingresado */}
                    <div style={{ background: 'var(--past-blue)', borderRadius: 12, padding: '14px 16px' }}>
                      <div style={{ fontSize: 11, color: 'var(--past-blue-ink)', fontWeight: 500, marginBottom: 6 }}>Saldo al {fechaLabel}</div>
                      <div style={{ fontSize: 20, fontWeight: 700, color: 'var(--past-blue-ink)', fontFamily: 'var(--font-display)', letterSpacing: '-0.02em' }}>{fin2Clp(Number(saldoBanco.monto))}</div>
                      <div style={{ fontSize: 10.5, color: 'var(--past-blue-ink)', opacity: 0.6, marginTop: 4 }}>ingresado manualmente</div>
                    </div>
                    {/* Saldo estimado */}
                    <div style={{ background: 'var(--paper-stripe)', borderRadius: 12, padding: '14px 16px', border: '1px solid var(--line)' }}>
                      <div style={{ fontSize: 11, color: 'var(--ink-500)', fontWeight: 500, marginBottom: 6 }}>Saldo estimado hoy</div>
                      <div style={{ fontSize: 20, fontWeight: 700, color: proyectado >= 0 ? 'var(--ink-900)' : 'var(--bad-ink)', fontFamily: 'var(--font-display)', letterSpacing: '-0.02em' }}>{fin2Clp(proyectado)}</div>
                      <div style={{ fontSize: 10.5, color: 'var(--ink-400)', marginTop: 4, lineHeight: 1.4 }}>
                        {ingDesde > 0 && <span style={{ color: 'var(--ok-ink)' }}>+{fin2Clp(ingDesde)}</span>}
                        {ingDesde > 0 && gasDesde > 0 && ' '}
                        {gasDesde > 0 && <span style={{ color: 'var(--bad-ink)' }}>−{fin2Clp(gasDesde)}</span>}
                        {ingDesde === 0 && gasDesde === 0 && 'sin movimientos nuevos'}
                        {(ingDesde > 0 || gasDesde > 0) && ` desde el ${fechaLabel}`}
                      </div>
                    </div>
                    {/* Diferencia */}
                    {(() => {
                      const diff = proyectado - (totIng - totGas);
                      const ok   = Math.abs(diff) < 1000;
                      return (
                        <div style={{ background: ok ? 'var(--ok-bg)' : 'var(--bad-bg)', borderRadius: 12, padding: '14px 16px', border: `1px solid ${ok ? 'var(--ok-line)' : 'var(--bad-line)'}` }}>
                          <div style={{ fontSize: 11, color: ok ? 'var(--ok-ink)' : 'var(--bad-ink)', fontWeight: 500, marginBottom: 6 }}>Diferencia</div>
                          <div style={{ fontSize: 20, fontWeight: 700, color: ok ? 'var(--ok-ink)' : 'var(--bad-ink)', fontFamily: 'var(--font-display)', letterSpacing: '-0.02em' }}>
                            {diff >= 0 ? '+' : ''}{fin2Clp(diff)}
                          </div>
                          <div style={{ fontSize: 10.5, color: ok ? 'var(--ok-ink)' : 'var(--bad-ink)', opacity: 0.85, marginTop: 4 }}>
                            {ok ? '✓ Cuadra' : diff > 0 ? 'ingresos sin registrar' : 'gastos sin registrar'}
                          </div>
                        </div>
                      );
                    })()}
                  </div>
                )}
              </div>
            );
          })()}

          {/* ── Bloque IVA estimado ── */}
          {iva && (
            <div style={{ background: 'var(--paper)', border: '1px solid var(--line)', borderRadius: 16, padding: '18px 20px', marginBottom: 20 }}>
              <div style={{ fontSize: 11, fontWeight: 600, color: 'var(--ink-400)', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 14 }}>
                IVA estimado · {mesLabel}
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: mob ? '1fr' : 'repeat(3, 1fr)', gap: 12 }}>
                <div style={{ background: 'var(--past-peach)', borderRadius: 12, padding: '14px 16px' }}>
                  <div style={{ fontSize: 11, color: 'var(--past-peach-ink)', fontWeight: 500, marginBottom: 6 }}>Débito fiscal</div>
                  <div style={{ fontSize: 20, fontWeight: 700, color: 'var(--past-peach-ink)', fontFamily: 'var(--font-display)', letterSpacing: '-0.02em' }}>{fin2Clp(iva.debito)}</div>
                  <div style={{ fontSize: 10.5, color: 'var(--past-peach-ink)', opacity: 0.7, marginTop: 4 }}>sobre {fin2Clp(iva.totalVentas)} en ventas</div>
                </div>
                <div style={{ background: 'var(--past-mint)', borderRadius: 12, padding: '14px 16px' }}>
                  <div style={{ fontSize: 11, color: 'var(--past-mint-ink)', fontWeight: 500, marginBottom: 6 }}>Crédito fiscal</div>
                  <div style={{ fontSize: 20, fontWeight: 700, color: 'var(--past-mint-ink)', fontFamily: 'var(--font-display)', letterSpacing: '-0.02em' }}>{fin2Clp(iva.credito)}</div>
                  <div style={{ fontSize: 10.5, color: 'var(--past-mint-ink)', opacity: 0.7, marginTop: 4 }}>sobre {fin2Clp(iva.totalFacturas)} en facturas y notas</div>
                </div>
                {(() => {
                  const aFavor = iva.saldo < 0;
                  return (
                    <div style={{ background: aFavor ? 'var(--past-blue)' : 'var(--paper-stripe)', borderRadius: 12, padding: '14px 16px', border: aFavor ? 'none' : '1px solid var(--line)' }}>
                      <div style={{ fontSize: 11, color: aFavor ? 'var(--past-blue-ink)' : 'var(--ink-500)', fontWeight: 500, marginBottom: 6 }}>{aFavor ? 'Remanente a favor' : 'IVA a pagar'}</div>
                      <div style={{ fontSize: 20, fontWeight: 700, color: aFavor ? 'var(--past-blue-ink)' : 'var(--ink-900)', fontFamily: 'var(--font-display)', letterSpacing: '-0.02em' }}>{fin2Clp(Math.abs(iva.saldo))}</div>
                      <div style={{ fontSize: 10.5, color: aFavor ? 'var(--past-blue-ink)' : 'var(--ink-400)', opacity: 0.7, marginTop: 4 }}>{aFavor ? 'débito < crédito' : 'débito − crédito'}</div>
                    </div>
                  );
                })()}
              </div>
            </div>
          )}

          {/* ── Nota al pie ── */}
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8, padding: '12px 16px', background: 'var(--info-bg)', border: '1px solid var(--info-line)', borderRadius: 14 }}>
            <CheckCircle size={14} strokeWidth={1.75} style={{ color: 'var(--info-ink)', flexShrink: 0, marginTop: 1 }} />
            <span style={{ fontSize: 12.5, color: 'var(--info-ink)', lineHeight: 1.5 }}>
              Los movimientos marcados como <strong>Sistema</strong> se generan automáticamente desde ventas y documentos. Solo los movimientos <strong>Manuales</strong> pueden editarse o eliminarse.
            </span>
          </div>
        </>
      )}

      {/* Modal */}
      {modal && (
        <Fin2Modal
          mesLabel={mesLabel}
          onClose={() => { setModal(false); setEditMov(null); }}
          onGuardar={handleGuardar}
          initialData={editMov}
        />
      )}
      </>
      )}
    </div>
  );
}

// =============================================================================
// FINANZAS — Flujo proyectado: ¿alcanza la plata en los próximos días?
// =============================================================================

function FinProyeccion({ irA }) {
  const [dias, setDias] = useState(30);
  const [data, setData] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState(null);
  const [minimo, setMinimo] = useState(() => {
    try { return localStorage.getItem('relea_fin_minimo') || ''; } catch (e) { return ''; }
  });

  useEffect(() => { cargar(); }, [dias]); // eslint-disable-line react-hooks/exhaustive-deps

  function cargar() {
    setCargando(true);
    setError(null);
    api.get(`/movimientos/proyeccion?dias=${dias}`)
      .then(r => setData(r.data))
      .catch(e => setError(e?.response?.data?.error || e.message || 'Error al cargar'))
      .finally(() => setCargando(false));
  }
  function cambiarMinimo(v) {
    const limpio = v.replace(/\D/g, '');
    setMinimo(limpio);
    try { localStorage.setItem('relea_fin_minimo', limpio); } catch (e) { /* solo dura esta sesión */ }
  }

  if (cargando && !data) return <div style={{ textAlign: 'center', padding: '60px 0', color: 'var(--ink-400)', fontSize: 14 }}>Cargando…</div>;
  if (error) {
    return (
      <div style={{ background: 'var(--bad-bg)', border: '1px solid var(--bad-line)', borderRadius: 14, padding: '14px 18px', color: 'var(--bad-ink)', fontSize: 13 }}>
        <strong>Error al cargar datos:</strong> {error}
        <button onClick={cargar} style={{ marginLeft: 14, padding: '4px 12px', borderRadius: 999, border: '1px solid var(--bad-line)', background: 'var(--paper)', color: 'var(--bad-ink)', cursor: 'pointer', fontSize: 12, fontFamily: 'inherit' }}>Reintentar</button>
      </div>
    );
  }
  if (!data) return null;

  const umbral = Number(minimo) || 0;
  const sinSaldo = data.saldo_hoy == null;
  const serie = data.serie || [];
  const bajo = !sinSaldo && data.minimo && data.minimo.saldo < umbral;
  const negativo = !sinSaldo && data.minimo && data.minimo.saldo < 0;
  const etiquetaEvento = e => (e.tipo === 'gasto' ? ((FIN2_CATS[e.concepto] || {}).label || e.concepto) : e.concepto);
  const fechaCorta = f => new Date(f + 'T12:00:00').toLocaleDateString('es-CL', { day: 'numeric', month: 'short' }).replace('.', '');

  // Gráfico: saldo día a día, con el mínimo de seguridad como línea punteada
  const W = 640, H = 170, pl = 10, pr = 10, pt = 16, pb = 26;
  const valores = serie.map(x => x.saldo).concat(umbral > 0 ? [umbral] : [], [0]);
  const vmin = Math.min(...valores), vmax = Math.max(...valores);
  const rango = vmax - vmin || 1;
  const X = d => pl + (d / (serie.length - 1 || 1)) * (W - pl - pr);
  const Y = v => pt + (1 - (v - vmin) / rango) * (H - pt - pb);
  const linea = serie.map((x, k) => `${k === 0 ? 'M' : 'L'}${X(x.dia).toFixed(1)},${Y(x.saldo).toFixed(1)}`).join(' ');
  const diasConEvento = new Set((data.eventos || []).map(e => e.dia));

  const tarjeta = (titulo, valor, color, sub) => (
    <div style={{ background: 'var(--paper)', border: '1px solid var(--line)', borderRadius: 14, padding: '12px 16px' }}>
      <div style={{ fontSize: 10.5, textTransform: 'uppercase', letterSpacing: '0.08em', color: 'var(--ink-500)', fontWeight: 500 }}>{titulo}</div>
      <div style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 21, letterSpacing: '-0.02em', fontVariantNumeric: 'tabular-nums', color: color || 'var(--ink-900)', marginTop: 3 }}>{valor}</div>
      {sub && <div style={{ fontSize: 11.5, color: 'var(--ink-400)', marginTop: 2 }}>{sub}</div>}
    </div>
  );
  const chipDia = e => {
    const base = { fontSize: 11, fontWeight: 600, padding: '2px 9px', borderRadius: 999, whiteSpace: 'nowrap', minWidth: 54, textAlign: 'center' };
    if (e.vencido) return <span style={{ ...base, background: 'var(--bad-bg)', color: 'var(--bad-ink)' }}>vencida</span>;
    if (e.dia === 0) return <span style={{ ...base, background: 'var(--warn-bg)', color: 'var(--warn-ink)' }}>hoy</span>;
    if (e.dia <= 7) return <span style={{ ...base, background: 'var(--warn-bg)', color: 'var(--warn-ink)' }}>día {e.dia}</span>;
    return <span style={{ ...base, background: 'var(--paper-stripe)', color: 'var(--ink-600)' }}>día {e.dia}</span>;
  };

  return (
    <div>
      {/* Horizonte */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap', marginBottom: 16 }}>
        <div style={{ display: 'inline-flex', gap: 4, background: 'var(--paper-soft)', border: '1px solid var(--line)', borderRadius: 10, padding: 3 }}>
          {[30, 60].map(n => (
            <button key={n} onClick={() => setDias(n)}
              style={{ padding: '6px 14px', borderRadius: 8, border: 'none', cursor: 'pointer', fontFamily: 'inherit', fontSize: 12.5, fontWeight: dias === n ? 600 : 500, background: dias === n ? 'var(--ink-900)' : 'transparent', color: dias === n ? '#fff' : 'var(--ink-600)' }}>
              Próximos {n} días
            </button>
          ))}
        </div>
        <label style={{ marginLeft: 'auto', display: 'inline-flex', alignItems: 'center', gap: 8, fontSize: 12.5, color: 'var(--ink-600)' }}>
          Avisarme si el saldo baja de
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, border: '1px solid var(--line-strong)', borderRadius: 8, padding: '4px 8px', background: 'var(--paper)' }}>
            $ <input value={minimo ? Number(minimo).toLocaleString('es-CL') : ''} onChange={e => cambiarMinimo(e.target.value)} placeholder="0" aria-label="Saldo mínimo de seguridad"
              style={{ width: 92, border: 'none', outline: 'none', fontSize: 13, fontFamily: 'inherit', textAlign: 'right', background: 'transparent', color: 'var(--ink-900)' }} />
          </span>
        </label>
      </div>

      {sinSaldo && (
        <div style={{ background: 'var(--warn-bg)', border: '1px solid var(--warn-line)', borderRadius: 14, padding: '14px 18px', marginBottom: 16, display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
          <AlertTriangle size={16} strokeWidth={2} style={{ color: 'var(--warn-ink)', flexShrink: 0 }} />
          <span style={{ fontSize: 13, color: 'var(--warn-ink)', flex: '1 1 260px' }}>
            Para proyectar el saldo hace falta partir de cuánto hay hoy en el banco. Ingrésalo una vez este mes y la proyección lo va ajustando con lo que entra y sale.
          </span>
          <button onClick={() => irA('caja')} style={{ padding: '7px 16px', borderRadius: 999, border: 'none', background: 'var(--brand)', color: '#fff', fontSize: 12.5, fontWeight: 600, fontFamily: 'inherit', cursor: 'pointer' }}>Ingresar el saldo del banco</button>
        </div>
      )}

      {/* Resumen */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: 10, marginBottom: 16 }}>
        {tarjeta('Saldo hoy', sinSaldo ? 'Sin dato' : fin2Clp(data.saldo_hoy), sinSaldo ? 'var(--ink-400)' : (data.saldo_hoy < 0 ? 'var(--bad-ink)' : 'var(--ink-900)'), sinSaldo ? null : 'estimado desde el saldo del banco')}
        {tarjeta(`Vence en ${data.dias} días`, '− ' + fin2Clp(data.egresos_total), data.egresos_total > 0 ? 'var(--bad-ink)' : 'var(--ink-900)', `${(data.eventos || []).length} pago${(data.eventos || []).length !== 1 ? 's' : ''}`)}
        {tarjeta('Ventas esperadas', '+ ' + fin2Clp(data.ventas_esperadas), 'var(--ok-ink)', 'según las últimas 8 semanas')}
        {tarjeta(`Saldo al día ${data.dias}`, sinSaldo ? '—' : fin2Clp(data.saldo_final), sinSaldo ? 'var(--ink-400)' : (data.saldo_final < umbral ? 'var(--bad-ink)' : 'var(--ink-900)'), sinSaldo ? null : fechaCorta(serie[serie.length - 1].fecha))}
      </div>

      {/* Aviso */}
      {!sinSaldo && (
        <div style={{ borderRadius: 12, padding: '10px 16px', marginBottom: 14, fontSize: 13, display: 'flex', alignItems: 'flex-start', gap: 8,
          background: bajo ? (negativo ? 'var(--bad-bg)' : 'var(--warn-bg)') : 'var(--ok-bg)',
          border: '1px solid ' + (bajo ? (negativo ? 'var(--bad-line)' : 'var(--warn-line)') : 'var(--ok-line)'),
          color: bajo ? (negativo ? 'var(--bad-ink)' : 'var(--warn-ink)') : 'var(--ok-ink)' }}>
          {bajo ? <AlertTriangle size={15} strokeWidth={2} style={{ flexShrink: 0, marginTop: 1 }} /> : <CheckCircle size={15} strokeWidth={1.75} style={{ flexShrink: 0, marginTop: 1 }} />}
          <span>
            {bajo
              ? <><strong>El saldo baja {negativo ? 'de $ 0' : `de ${fin2Clp(umbral)}`} el {fechaCorta(data.minimo.fecha)}</strong> y queda en {data.minimo.saldo < 0 ? '− ' : ''}{fin2Clp(data.minimo.saldo)}.{(data.eventos || []).filter(e => e.dia === data.minimo.dia).length > 0 && ` Ese día vence: ${(data.eventos || []).filter(e => e.dia === data.minimo.dia).map(etiquetaEvento).join(', ')}.`}</>
              : <>El saldo se mantiene sobre {fin2Clp(umbral)} los próximos {data.dias} días (su punto más bajo: {fin2Clp(data.minimo.saldo)} el {fechaCorta(data.minimo.fecha)}).</>}
          </span>
        </div>
      )}

      {/* Gráfico */}
      {!sinSaldo && serie.length > 1 && (
        <div style={{ background: 'var(--paper)', border: '1px solid var(--line)', borderRadius: 16, padding: '14px 16px', marginBottom: 16 }}>
          <svg viewBox={`0 0 ${W} ${H}`} style={{ width: '100%', height: 'auto', overflow: 'visible' }} role="img" aria-label="Saldo proyectado día a día">
            {vmin < 0 && vmax > 0 && <line x1={pl} x2={W - pr} y1={Y(0)} y2={Y(0)} stroke="var(--line-strong)" strokeWidth="1" />}
            {umbral > 0 && (
              <>
                <line x1={pl} x2={W - pr} y1={Y(umbral)} y2={Y(umbral)} stroke="var(--bad-ink)" strokeWidth="1" strokeDasharray="4 4" opacity="0.7" />
                <text x={pl + 2} y={Y(umbral) - 4} fontSize="10" fill="var(--bad-ink)">mínimo {fin2Clp(umbral)}</text>
              </>
            )}
            <path d={linea} fill="none" stroke="var(--brand)" strokeWidth="2" strokeLinejoin="round" strokeLinecap="round" />
            {serie.filter(x => diasConEvento.has(x.dia)).map(x => <circle key={x.dia} cx={X(x.dia)} cy={Y(x.saldo)} r="3" fill="var(--paper)" stroke="var(--brand)" strokeWidth="1.5" />)}
            <circle cx={X(data.minimo.dia)} cy={Y(data.minimo.saldo)} r="4.5" fill={bajo ? 'var(--bad-ink)' : 'var(--brand)'} />
            <text x={Math.min(Math.max(X(data.minimo.dia), 70), W - 70)} y={Y(data.minimo.saldo) + 17} textAnchor="middle" fontSize="10.5" fill="var(--ink-700)">mínimo {fin2Clp(data.minimo.saldo)}</text>
            {[0, 0.25, 0.5, 0.75, 1].map(f => {
              const d = Math.round(f * (serie.length - 1));
              return <text key={f} x={X(d)} y={H - 6} textAnchor={f === 0 ? 'start' : f === 1 ? 'end' : 'middle'} fontSize="10" fill="var(--ink-500)">{d === 0 ? 'hoy' : fechaCorta(serie[d].fecha)}</text>;
            })}
          </svg>
          <div style={{ fontSize: 11, color: 'var(--ink-400)', marginTop: 4 }}>Los círculos marcan los días en que vence algún pago.</div>
        </div>
      )}

      {/* Qué vence */}
      <div style={{ background: 'var(--paper)', border: '1px solid var(--line)', borderRadius: 16, overflow: 'hidden', marginBottom: 14 }}>
        <div style={{ padding: '10px 18px', background: 'var(--paper-stripe)', fontSize: 12, fontWeight: 600, color: 'var(--ink-600)' }}>Qué vence en los próximos {data.dias} días</div>
        {(data.eventos || []).length === 0 && <div style={{ padding: '16px 18px', fontSize: 13, color: 'var(--ink-500)' }}>No hay pagos programados en este período.</div>}
        {(data.eventos || []).map((e, k) => (
          <div key={k} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '10px 18px', borderTop: '1px solid var(--line-soft)', fontSize: 13 }}>
            {chipDia(e)}
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ color: 'var(--ink-900)', fontWeight: 500, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{etiquetaEvento(e)}</div>
              <div style={{ fontSize: 11.5, color: 'var(--ink-500)' }}>{fechaCorta(e.fecha)}{e.detalle ? ` · ${e.detalle}` : ''}</div>
            </div>
            <span style={{ fontWeight: 600, fontVariantNumeric: 'tabular-nums', color: 'var(--bad-ink)' }}>− {fin2Clp(e.monto)}</span>
          </div>
        ))}
      </div>

      <div style={{ fontSize: 11.5, color: 'var(--ink-400)', lineHeight: 1.55, padding: '0 4px' }}>
        Es una estimación. Suma los pagos que ya conoce el sistema (facturas por pagar en su vencimiento, el IVA y los gastos que anotas todos los meses) y resta las ventas esperadas según tu promedio de cada día de la semana. No incluye compras que aún no se han facturado ni gastos que no se repiten.
      </div>
    </div>
  );
}

// FINANZAS — Facturas impagas por distribuidor
// =============================================================================

function FinFacturasImpagas({ setPagina }) {
  const [data,     setData]     = useState(null);
  const [cargando, setCargando] = useState(true);
  const [error,    setError]    = useState(null);
  const [modo,     setModo]     = useState('vencimiento'); // 'vencimiento' | 'distribuidor'
  const [abiertos, setAbiertos] = useState(new Set());
  const [selDoc,   setSelDoc]   = useState(null); // id de la factura abierta en el panel
  const [pagando,  setPagando]  = useState(null); // factura cuyo pago se está registrando
  const [formPago, setFormPago] = useState({ fecha: '', medio: 'transferencia', monto: '' });
  const [guardandoPago, setGuardandoPago] = useState(false);
  const [errorPago, setErrorPago] = useState('');
  const [aviso,    setAviso]    = useState('');

  useEffect(() => { cargar(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  function cargar() {
    setCargando(true);
    setError(null);
    return api.get('/documentos/impagas')
      .then(r => setData(r.data))
      .catch(e => setError(e?.response?.data?.error || e.message || 'Error al cargar'))
      .finally(() => setCargando(false));
  }

  function toggle(key) {
    setAbiertos(prev => {
      const next = new Set(prev);
      if (next.has(key)) next.delete(key); else next.add(key);
      return next;
    });
  }

  const hoyLocalISO = () => {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  };
  function abrirPago(f) {
    setFormPago({ fecha: hoyLocalISO(), medio: 'transferencia', monto: String(f.mnt_total) });
    setErrorPago('');
    setPagando(f);
  }
  async function confirmarPago() {
    setGuardandoPago(true);
    setErrorPago('');
    try {
      await api.post(`/documentos/${pagando.id}/pagar`, { fecha_pago: formPago.fecha, medio_pago: formPago.medio, monto: Number(formPago.monto) });
      setAviso(`Pago de la factura N° ${pagando.numero} registrado.`);
      setPagando(null);
      await cargar();
    } catch (e) {
      setErrorPago(e?.response?.data?.error || e.message);
    }
    setGuardandoPago(false);
  }
  async function guardarPlazo(g, valor, actual) {
    if (!g.distribuidor_id) return;
    const nuevoPlazo = valor === '' ? null : parseInt(valor, 10);
    if (nuevoPlazo === actual || (valor !== '' && isNaN(nuevoPlazo))) return;
    try {
      await api.patch(`/distribuidores/${g.distribuidor_id}`, { plazo_pago_dias: nuevoPlazo });
      await cargar();
    } catch (e) {
      alert(e?.response?.data?.error || e.message);
    }
  }

  if (cargando && !data) {
    return <div style={{ textAlign: 'center', padding: '60px 0', color: 'var(--ink-400)', fontSize: 14 }}>Cargando…</div>;
  }

  if (error) {
    return (
      <div style={{ background: 'var(--bad-bg)', border: '1px solid var(--bad-line)', borderRadius: 14, padding: '14px 18px', color: 'var(--bad-ink)', fontSize: 13 }}>
        <strong>Error al cargar datos:</strong> {error}
        <button onClick={cargar} style={{ marginLeft: 14, padding: '4px 12px', borderRadius: 999, border: '1px solid var(--bad-line)', background: 'var(--paper)', color: 'var(--bad-ink)', cursor: 'pointer', fontSize: 12, fontFamily: 'inherit' }}>Reintentar</button>
      </div>
    );
  }

  const { total_general = 0, count_general = 0, distribuidores = [] } = data || {};
  const facturasFlat = distribuidores.flatMap(g => g.facturas);

  // Días que faltan para vencer (negativo = atrasada)
  const hoy12 = new Date(); hoy12.setHours(12, 0, 0, 0);
  const diasPara = f => (f.vence ? Math.round((new Date(String(f.vence).slice(0, 10) + 'T12:00:00') - hoy12) / 86400000) : null);
  const todas = distribuidores.flatMap(g => g.facturas.map(f => ({ ...f, dist_id: g.distribuidor_id, dist_nombre: g.distribuidor_nombre, dias: diasPara(f) })));
  const TRAMOS = [
    { key: 'vencidas', label: 'Vencidas',          color: 'var(--bad-ink)',  test: d => d !== null && d < 0 },
    { key: 'semana',   label: 'Esta semana',       color: 'var(--warn-ink)', test: d => d !== null && d >= 0 && d <= 7 },
    { key: 'mes',      label: 'Próximos 30 días',  color: 'var(--ok-ink)',   test: d => d !== null && d > 7 && d <= 30 },
    { key: 'despues',  label: 'Más adelante',      color: 'var(--ink-500)',  test: d => d === null || d > 30 },
  ].map(t => {
    const facturas = todas.filter(f => t.test(f.dias)).sort((a, b) => String(a.vence || '9999').localeCompare(String(b.vence || '9999')));
    return { ...t, facturas, total: facturas.reduce((n, f) => n + f.mnt_total, 0) };
  });

  const chipDias = d => {
    const base = { display: 'inline-flex', alignItems: 'center', padding: '2px 9px', borderRadius: 999, fontSize: 11, fontWeight: 600, whiteSpace: 'nowrap', flexShrink: 0 };
    if (d === null) return null;
    if (d < 0) return <span style={{ ...base, background: 'var(--bad-bg)', color: 'var(--bad-ink)' }}>{Math.abs(d) === 1 ? '1 día' : `${Math.abs(d)} días`} de atraso</span>;
    if (d === 0) return <span style={{ ...base, background: 'var(--warn-bg)', color: 'var(--warn-ink)' }}>vence hoy</span>;
    if (d <= 7) return <span style={{ ...base, background: 'var(--warn-bg)', color: 'var(--warn-ink)' }}>vence en {d} día{d !== 1 ? 's' : ''}</span>;
    return <span style={{ ...base, background: 'var(--ok-bg)', color: 'var(--ok-ink)' }}>vence en {d} días</span>;
  };

  // Una factura: número, distribuidor (opcional), plazo y vencimiento, chip, monto y "Registrar pago"
  const filaFactura = (f, conDistribuidor) => (
    <div key={f.id} onClick={() => setSelDoc(f.id)}
      style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '10px 18px', borderTop: '1px solid var(--line-soft)', fontSize: 13, cursor: 'pointer' }}
      onMouseEnter={e => { e.currentTarget.style.background = 'var(--paper-soft)'; }}
      onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; }}>
      <span style={{ color: 'var(--ink-700)', fontFamily: 'var(--font-mono)', minWidth: 74 }}>N° {f.numero || '—'}</span>
      <div style={{ flex: 1, minWidth: 0 }}>
        {conDistribuidor && <div style={{ fontWeight: 600, color: 'var(--ink-900)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{f.dist_nombre}</div>}
        <div style={{ fontSize: 11.5, color: 'var(--ink-500)' }}>
          Plazo {f.plazo_dias} días{f.vence ? ` · ${f.dias < 0 ? 'venció' : 'vence'} el ${fmtDocFecha(f.vence)}` : ''}{f.estado === 'recibida' ? ' · recibida' : ''}
        </div>
      </div>
      {chipDias(f.dias)}
      <span style={{ fontWeight: 600, fontVariantNumeric: 'tabular-nums', minWidth: 84, textAlign: 'right' }}>{fin2Clp(f.mnt_total)}</span>
      <button onClick={e => { e.stopPropagation(); abrirPago(f); }}
        style={{ padding: '5px 13px', borderRadius: 999, fontSize: 12, fontWeight: 500, fontFamily: 'inherit', cursor: 'pointer', whiteSpace: 'nowrap',
          border: f.dias !== null && f.dias <= 7 ? 'none' : '1px solid var(--line-strong)',
          background: f.dias !== null && f.dias <= 7 ? 'var(--brand)' : 'var(--paper)',
          color: f.dias !== null && f.dias <= 7 ? '#fff' : 'var(--ink-700)' }}>
        Registrar pago
      </button>
    </div>
  );

  if (distribuidores.length === 0) {
    return (
      <div>
        {aviso && <div style={{ marginBottom: 14, padding: '10px 16px', background: 'var(--ok-bg)', border: '1px solid var(--ok-line)', borderRadius: 12, fontSize: 13, color: 'var(--ok-ink)' }}>{aviso}</div>}
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8, padding: '14px 18px', background: 'var(--ok-bg)', border: '1px solid var(--ok-line)', borderRadius: 14 }}>
          <CheckCircle size={15} strokeWidth={1.75} style={{ color: 'var(--ok-ink)', flexShrink: 0, marginTop: 1 }} />
          <span style={{ fontSize: 13.5, color: 'var(--ok-ink)' }}>No hay facturas por pagar. Todo al día.</span>
        </div>
      </div>
    );
  }

  const [tVenc, tSem, tMes] = TRAMOS;
  const kpi = (titulo, t, color) => (
    <div style={{ background: 'var(--paper)', border: '1px solid var(--line)', borderRadius: 14, padding: '12px 16px' }}>
      <div style={{ fontSize: 10.5, textTransform: 'uppercase', letterSpacing: '0.08em', color: 'var(--ink-500)', fontWeight: 500 }}>{titulo}</div>
      <div style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 22, letterSpacing: '-0.02em', fontVariantNumeric: 'tabular-nums', color, marginTop: 3 }}>{fin2Clp(t.total)}</div>
      <div style={{ fontSize: 11.5, color: 'var(--ink-400)', marginTop: 2 }}>{t.facturas.length} factura{t.facturas.length !== 1 ? 's' : ''}</div>
    </div>
  );
  const campo = { width: '100%', boxSizing: 'border-box', border: '1px solid var(--line-strong)', borderRadius: 10, padding: '9px 12px', fontSize: 14, fontFamily: 'inherit', background: 'var(--paper)', color: 'var(--ink-900)' };
  const etiqueta = { display: 'block', fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.07em', color: 'var(--ink-500)', marginBottom: 5 };

  return (
    <div>
      {aviso && (
        <div style={{ marginBottom: 14, padding: '10px 16px', background: 'var(--ok-bg)', border: '1px solid var(--ok-line)', borderRadius: 12, fontSize: 13, color: 'var(--ok-ink)', display: 'flex', alignItems: 'center', gap: 10 }}>
          <CheckCircle size={15} strokeWidth={1.75} style={{ flexShrink: 0 }} />
          <span style={{ flex: 1 }}>{aviso}</span>
          <button onClick={() => setAviso('')} aria-label="Cerrar aviso" style={{ background: 'none', border: 'none', color: 'var(--ok-ink)', cursor: 'pointer', fontSize: 18, lineHeight: 1, padding: 0 }}>×</button>
        </div>
      )}

      {/* ── Resumen por vencimiento ── */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: 10, marginBottom: 12 }}>
        {kpi('Vencido', tVenc, tVenc.total > 0 ? 'var(--bad-ink)' : 'var(--ink-900)')}
        {kpi('Esta semana', tSem, tSem.total > 0 ? 'var(--warn-ink)' : 'var(--ink-900)')}
        {kpi('Próximos 30 días', tMes, 'var(--ink-900)')}
        <div style={{ background: 'var(--ink-900)', borderRadius: 14, padding: '12px 16px' }}>
          <div style={{ fontSize: 10.5, textTransform: 'uppercase', letterSpacing: '0.08em', color: 'var(--ink-300)', fontWeight: 500 }}>Total adeudado</div>
          <div style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 22, letterSpacing: '-0.02em', fontVariantNumeric: 'tabular-nums', color: '#F8A0A0', marginTop: 3 }}>{fin2Clp(total_general)}</div>
          <div style={{ fontSize: 11.5, color: 'var(--ink-300)', marginTop: 2 }}>{count_general} factura{count_general !== 1 ? 's' : ''} · {distribuidores.length} distribuidor{distribuidores.length !== 1 ? 'es' : ''}</div>
        </div>
      </div>
      <div style={{ display: 'flex', height: 10, borderRadius: 999, overflow: 'hidden', background: 'var(--paper-stripe)', marginBottom: 18 }}>
        {TRAMOS.filter(t => t.total > 0).map(t => (
          <div key={t.key} title={`${t.label}: ${fin2Clp(t.total)}`} style={{ width: (t.total / (total_general || 1)) * 100 + '%', background: t.color, opacity: t.key === 'despues' ? 0.35 : 0.75 }} />
        ))}
      </div>

      {/* ── Cómo verlas ── */}
      <div style={{ display: 'inline-flex', gap: 4, background: 'var(--paper-soft)', border: '1px solid var(--line)', borderRadius: 10, padding: 3, marginBottom: 14 }}>
        {[['vencimiento', 'Por vencimiento'], ['distribuidor', 'Por distribuidor']].map(([k, label]) => (
          <button key={k} onClick={() => setModo(k)}
            style={{ padding: '6px 14px', borderRadius: 8, border: 'none', cursor: 'pointer', fontFamily: 'inherit', fontSize: 12.5, fontWeight: modo === k ? 600 : 500, background: modo === k ? 'var(--ink-900)' : 'transparent', color: modo === k ? '#fff' : 'var(--ink-600)' }}>
            {label}
          </button>
        ))}
      </div>

      {modo === 'vencimiento' && (
        <div style={{ background: 'var(--paper)', border: '1px solid var(--line)', borderRadius: 16, overflow: 'hidden' }}>
          {TRAMOS.filter(t => t.facturas.length > 0).map((t, i) => (
            <div key={t.key}>
              <div style={{ display: 'flex', alignItems: 'center', padding: '8px 18px', background: 'var(--paper-stripe)', borderTop: i ? '1px solid var(--line-soft)' : 'none' }}>
                <span style={{ fontSize: 12, fontWeight: 600, color: t.color }}>{t.label}</span>
                <span style={{ fontSize: 11.5, color: 'var(--ink-400)', marginLeft: 8 }}>{t.facturas.length} factura{t.facturas.length !== 1 ? 's' : ''}</span>
                <span style={{ marginLeft: 'auto', fontSize: 12, fontWeight: 700, fontVariantNumeric: 'tabular-nums', color: 'var(--ink-700)' }}>{fin2Clp(t.total)}</span>
              </div>
              {t.facturas.map(f => filaFactura(f, true))}
            </div>
          ))}
        </div>
      )}

      {modo === 'distribuidor' && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {distribuidores.map(g => {
            const key = g.distribuidor_id || 'sin_distribuidor';
            const abierto = abiertos.has(key);
            const plazoActual = g.distribuidor_id ? (g.facturas[0]?.plazo_dias ?? 30) : null;
            const facturasG = todas.filter(f => (f.dist_id || null) === (g.distribuidor_id || null)).sort((a, b) => String(a.vence || '9999').localeCompare(String(b.vence || '9999')));
            return (
              <div key={key} style={{ background: 'var(--paper)', border: '1px solid var(--line)', borderRadius: 16, overflow: 'hidden' }}>
                <button onClick={() => toggle(key)}
                  style={{ width: '100%', display: 'flex', alignItems: 'center', gap: 12, padding: '16px 20px', background: 'none', border: 'none', cursor: 'pointer', textAlign: 'left', fontFamily: 'inherit' }}>
                  <span style={{ width: 34, height: 34, borderRadius: '50%', background: 'var(--past-peach)', color: 'var(--past-peach-ink)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                    <Truck size={16} strokeWidth={1.75} />
                  </span>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontWeight: 600, fontSize: 14.5 }}>{g.distribuidor_nombre}</div>
                    <div style={{ fontSize: 12, color: 'var(--ink-400)' }}>{g.facturas.length} factura{g.facturas.length !== 1 ? 's' : ''}</div>
                  </div>
                  <div style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 18, letterSpacing: '-0.015em', fontVariantNumeric: 'tabular-nums', color: 'var(--ink-900)' }}>
                    {fin2Clp(g.total)}
                  </div>
                  <ChevronDown size={16} strokeWidth={1.75} style={{ color: 'var(--ink-400)', transform: abierto ? 'rotate(180deg)' : 'none', transition: 'transform 150ms ease', flexShrink: 0 }} />
                </button>
                {abierto && (
                  <div style={{ borderTop: '1px solid var(--line-soft)' }}>
                    {g.distribuidor_id && (
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '9px 18px', background: 'var(--paper-stripe)', fontSize: 12.5, color: 'var(--ink-600)' }}>
                        Plazo de pago de {g.distribuidor_nombre}:
                        <input key={`plazo-${key}-${plazoActual}`} type="number" min="0" max="365" defaultValue={plazoActual} aria-label="Plazo de pago en días"
                          onBlur={e => guardarPlazo(g, e.target.value, plazoActual)} onKeyDown={e => { if (e.key === 'Enter') e.target.blur(); }}
                          style={{ width: 64, padding: '4px 8px', border: '1px solid var(--line-strong)', borderRadius: 8, fontSize: 13, textAlign: 'right', fontFamily: 'inherit', background: 'var(--paper)', color: 'var(--ink-900)' }} />
                        días desde la emisión
                      </div>
                    )}
                    {facturasG.map(f => filaFactura(f, false))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}

      {/* ── Registrar pago ── */}
      {pagando && (
        <div style={{ position: 'fixed', inset: 0, background: 'var(--scrim)', zIndex: 200, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          onClick={e => { if (e.target === e.currentTarget && !guardandoPago) setPagando(null); }}>
          <div style={{ background: 'var(--paper)', borderRadius: 20, padding: 26, width: 380, maxWidth: '92vw', boxShadow: 'var(--shadow-pop)' }}>
            <div style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 18, marginBottom: 4 }}>Registrar pago</div>
            <div style={{ fontSize: 13, color: 'var(--ink-500)', marginBottom: 18 }}>Factura N° {pagando.numero} · {pagando.dist_nombre} · {fin2Clp(pagando.mnt_total)}</div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 }}>
              <div>
                <label style={etiqueta}>Fecha de pago</label>
                <input type="date" value={formPago.fecha} max={hoyLocalISO()} onChange={e => setFormPago(f => ({ ...f, fecha: e.target.value }))} style={campo} />
              </div>
              <div>
                <label style={etiqueta}>Medio</label>
                <select value={formPago.medio} onChange={e => setFormPago(f => ({ ...f, medio: e.target.value }))} style={campo}>
                  {MEDIOS_PAGO.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
                </select>
              </div>
            </div>
            <div style={{ marginBottom: 6 }}>
              <label style={etiqueta}>Monto pagado</label>
              <input type="number" min="0" value={formPago.monto} onChange={e => setFormPago(f => ({ ...f, monto: e.target.value }))} style={campo} />
            </div>
            <div style={{ fontSize: 11.5, color: 'var(--ink-500)', marginBottom: 16 }}>
              La salida queda en el libro de caja en la fecha de pago{Number(formPago.monto) !== Number(pagando.mnt_total) && Number(formPago.monto) > 0 ? ' y por el monto que indicas' : ''}.
            </div>
            {errorPago && <div style={{ fontSize: 12.5, color: 'var(--bad-ink)', background: 'var(--bad-bg)', border: '1px solid var(--bad-line)', borderRadius: 8, padding: '6px 10px', marginBottom: 12 }}>{errorPago}</div>}
            <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
              <button onClick={() => setPagando(null)} disabled={guardandoPago}
                style={{ padding: '8px 18px', border: '1px solid var(--line)', background: 'var(--paper)', borderRadius: 999, cursor: 'pointer', fontSize: 13, fontFamily: 'inherit' }}>Cancelar</button>
              <button onClick={confirmarPago} disabled={guardandoPago || !formPago.fecha || !(Number(formPago.monto) > 0)}
                style={{ padding: '8px 20px', background: 'var(--brand)', color: '#fff', border: 'none', borderRadius: 999, cursor: 'pointer', fontSize: 13, fontWeight: 600, fontFamily: 'inherit', opacity: (guardandoPago || !formPago.fecha || !(Number(formPago.monto) > 0)) ? 0.5 : 1 }}>
                {guardandoPago ? 'Registrando…' : 'Confirmar pago'}
              </button>
            </div>
          </div>
        </div>
      )}

      <DocDetalleDrawer
        docId={selDoc}
        docsOrden={facturasFlat}
        onClose={() => setSelDoc(null)}
        onNavigate={id => setSelDoc(id)}
        onChanged={cargar}
        onAbrirCompleto={setPagina ? () => { setSelDoc(null); setPagina('documentos'); } : undefined}
      />
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────

// Para no perder el trabajo si se corta internet o el usuario se cambia de
// módulo antes de guardar — ver abajo el autoguardado local en ModuloCotizacion.
const COTIZACION_LOCAL_KEY = 'relea_cotizacion_borrador_local';

function ModuloCotizacion() {
  const [vista, setVista] = useState('lista'); // 'lista' (con panel de detalle a la derecha) | 'nueva'
  const [cotizaciones, setCotizaciones] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [errorLista, setErrorLista] = useState('');
  const [seleccionada, setSeleccionada] = useState(null);
  const [config, setConfig] = useState(null);
  const [mostrarConfig, setMostrarConfig] = useState(false);
  const [busca, setBusca] = useState('');

  // ── Estado de "nueva cotización" ────────────────────────────────────────
  const [clienteForm, setClienteForm] = useState({ nombre: '', rut: '', giro: '', direccion: '', comuna: '', correo: '' });
  const [sugerenciasCliente, setSugerenciasCliente] = useState([]);
  const debounceClienteRef = useRef(null);
  const [notas, setNotas] = useState('');
  const [datosDeposito, setDatosDeposito] = useState('');
  const [lotes, setLotes] = useState([]);
  const lotesRef = useRef([]);
  const [busquedaLibro, setBusquedaLibro] = useState('');
  const [lineas, setLineas] = useState([]);
  const [ajustePct, setAjustePct] = useState(''); // % general sobre el precio base de todas las líneas
  const ajusteRef = useRef('');
  ajusteRef.current = ajustePct;
  const [ajusteAbierto, setAjusteAbierto] = useState(false);
  const ajustePopRef = useRef(null);
  useEffect(() => {
    if (!ajusteAbierto) return;
    const fuera = e => { if (ajustePopRef.current && !ajustePopRef.current.contains(e.target)) setAjusteAbierto(false); };
    const esc = e => { if (e.key === 'Escape') setAjusteAbierto(false); };
    document.addEventListener('mousedown', fuera);
    document.addEventListener('keydown', esc);
    return () => { document.removeEventListener('mousedown', fuera); document.removeEventListener('keydown', esc); };
  }, [ajusteAbierto]);
  const [incluirAutor, setIncluirAutor] = useState(true);
  const [incluirEditorial, setIncluirEditorial] = useState(true);
  const [incluirDescuento, setIncluirDescuento] = useState(true);
  const [guardando, setGuardando] = useState(false);
  const [guardandoBorrador, setGuardandoBorrador] = useState(false);
  const [errorGuardar, setErrorGuardar] = useState('');
  // id del borrador que se sigue editando — si existe, guardar actualiza esa
  // misma fila; si es null, guardar siempre crea una fila nueva (cotización
  // nueva, o una copia editable de una ya emitida).
  const [borradorId, setBorradorId] = useState(null);
  const [origenCopia, setOrigenCopia] = useState(false);
  const [mensajeBorrador, setMensajeBorrador] = useState('');
  // Snapshot guardado en este navegador (no en el servidor) de una cotización
  // que se estaba editando y no se guardó — sobrevive a que se corte internet
  // o a que el usuario se cambie de módulo sin querer.
  const [avisoLocal, setAvisoLocal] = useState(null);

  useEffect(() => {
    cargarCotizaciones();
    cargarConfig();
    try {
      const guardado = localStorage.getItem(COTIZACION_LOCAL_KEY);
      if (guardado) setAvisoLocal(JSON.parse(guardado));
    } catch { localStorage.removeItem(COTIZACION_LOCAL_KEY); }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Autoguardado local: mientras se está armando/editando una cotización,
  // cada cambio se refleja en localStorage (con un pequeño debounce) — no
  // depende de la red ni del servidor, así que protege incluso sin internet.
  useEffect(() => {
    if (vista !== 'nueva') return;
    const hayContenido = clienteForm.nombre.trim() || lineas.some(l => l.titulo?.trim() || l.isbn?.trim());
    const t = setTimeout(() => {
      if (!hayContenido) { localStorage.removeItem(COTIZACION_LOCAL_KEY); return; }
      try {
        localStorage.setItem(COTIZACION_LOCAL_KEY, JSON.stringify({
          guardadoEn: Date.now(), borradorId, origenCopia,
          clienteForm, notas, datosDeposito, lineas, ajustePct,
          incluirAutor, incluirEditorial, incluirDescuento,
        }));
      } catch {}
    }, 500);
    return () => clearTimeout(t);
  }, [vista, clienteForm, notas, datosDeposito, lineas, ajustePct, incluirAutor, incluirEditorial, incluirDescuento, borradorId, origenCopia]);

  function continuarLocal() {
    if (!avisoLocal) return;
    setClienteForm(avisoLocal.clienteForm || { nombre: '', rut: '', giro: '', direccion: '', comuna: '', correo: '' });
    setSugerenciasCliente([]);
    setNotas(avisoLocal.notas || '');
    setDatosDeposito(avisoLocal.datosDeposito || '');
    setLineas((avisoLocal.lineas || []).map(l => ({ precio_base: l.precio_neto, _manual: false, ...l })));
    setAjustePct(avisoLocal.ajustePct || '');
    setIncluirAutor(avisoLocal.incluirAutor !== false);
    setIncluirEditorial(avisoLocal.incluirEditorial !== false);
    setIncluirDescuento(avisoLocal.incluirDescuento !== false);
    setBorradorId(avisoLocal.borradorId || null);
    setOrigenCopia(!!avisoLocal.origenCopia);
    setBusquedaLibro('');
    setMensajeBorrador('');
    setErrorGuardar('');
    if (!lotesRef.current.length) cargarLotes();
    setAvisoLocal(null);
    setVista('nueva');
  }
  function descartarLocal() {
    localStorage.removeItem(COTIZACION_LOCAL_KEY);
    setAvisoLocal(null);
  }

  async function cargarCotizaciones() {
    setCargando(true);
    setErrorLista('');
    try {
      const r = await api.get('/cotizaciones');
      if (!Array.isArray(r.data)) throw new Error('Respuesta inesperada del servidor');
      setCotizaciones(r.data);
    } catch (e) {
      console.error(e);
      setCotizaciones([]);
      setErrorLista('No se pudieron cargar las cotizaciones. Puede que el servidor todavía esté desplegando — probá de nuevo en un momento.');
    }
    setCargando(false);
  }
  async function cargarConfig() {
    try { const r = await api.get('/cotizaciones/config'); setConfig(r.data && typeof r.data === 'object' ? r.data : null); }
    catch (e) { console.error(e); }
  }
  async function cargarLotes() {
    try {
      const r = await api.get('/lotes');
      const arr = Array.isArray(r.data) ? r.data : [];
      lotesRef.current = arr;
      setLotes(arr);
    } catch (e) { console.error(e); setLotes([]); }
  }

  // Autocompletado de cliente a partir del historial propio de cotizaciones
  // (no del módulo Clientes): busca coincidencias por nombre o RUT.
  function buscarCliente(texto) {
    clearTimeout(debounceClienteRef.current);
    const q = texto.trim();
    if (q.length < 2) { setSugerenciasCliente([]); return; }
    debounceClienteRef.current = setTimeout(async () => {
      try {
        const r = await api.get('/cotizaciones/clientes', { params: { q } });
        setSugerenciasCliente(Array.isArray(r.data) ? r.data : []);
      } catch { setSugerenciasCliente([]); }
    }, 300);
  }
  function elegirSugerenciaCliente(s) {
    setClienteForm({
      nombre: s.nombre || '', rut: s.rut || '', giro: s.giro || '',
      direccion: s.direccion || '', comuna: s.comuna || '', correo: s.correo || '',
    });
    setSugerenciasCliente([]);
  }

  function abrirNueva() {
    setClienteForm({ nombre: '', rut: '', giro: '', direccion: '', comuna: '', correo: '' });
    setSugerenciasCliente([]);
    setNotas('');
    setDatosDeposito(config?.datos_deposito_default || '');
    setLineas([]);
    setAjustePct('');
    setBusquedaLibro('');
    setIncluirAutor(true);
    setIncluirEditorial(true);
    setIncluirDescuento(true);
    setBorradorId(null);
    setOrigenCopia(false);
    setMensajeBorrador('');
    setErrorGuardar('');
    if (!lotesRef.current.length) cargarLotes();
    setVista('nueva');
  }

  // Precarga el formulario de "nueva" con los datos de una cotización ya
  // guardada — usado tanto para seguir un borrador como para partir de una
  // copia editable de una ya emitida.
  function cargarFormularioDesde(cot) {
    setClienteForm({
      nombre: cot.cliente_nombre || '', rut: cot.cliente_rut || '', giro: cot.cliente_giro || '',
      direccion: cot.cliente_direccion || '', comuna: cot.cliente_comuna || '', correo: cot.cliente_correo || '',
    });
    setSugerenciasCliente([]);
    setNotas(cot.notas || '');
    setDatosDeposito(cot.datos_deposito || config?.datos_deposito_default || '');
    setLineas((cot.lineas || []).map(l => ({
      libro_id: l.libro_id || null, isbn: l.isbn || '', titulo: l.titulo || '',
      autor: l.autor || '', editorial: l.editorial || '', cantidad: l.cantidad,
      precio_base: l.precio_neto, precio_neto: l.precio_neto, _manual: false,
      descuento_pct: Number(l.descuento_pct) > 0 ? l.descuento_pct : '',
    })));
    setAjustePct(''); // los precios guardados pasan a ser el nuevo precio base
    setBusquedaLibro('');
    setIncluirAutor(cot.incluye_autor !== false);
    setIncluirEditorial(cot.incluye_editorial !== false);
    setIncluirDescuento(cot.incluye_descuento !== false);
    setMensajeBorrador('');
    setErrorGuardar('');
    if (!lotesRef.current.length) cargarLotes();
  }

  async function abrirBorrador(cotResumen) {
    try {
      const r = await api.get(`/cotizaciones/${cotResumen.id}`);
      cargarFormularioDesde(r.data);
      setBorradorId(r.data.id);
      setOrigenCopia(false);
      setVista('nueva');
    } catch (e) { console.error(e); }
  }

  function editarCotizacion(cotCompleta) {
    cargarFormularioDesde(cotCompleta);
    setBorradorId(null);
    setOrigenCopia(true);
    setVista('nueva');
  }

  // Enfoca una cotización en el panel derecho (no cambia de vista — la lista
  // y el detalle conviven lado a lado, como en Documentos).
  async function verDetalle(cot) {
    if (cot.estado === 'borrador') return abrirBorrador(cot);
    try {
      const r = await api.get(`/cotizaciones/${cot.id}`);
      setSeleccionada(r.data);
    } catch (e) { console.error(e); }
  }

  // ── Búsqueda de libros, como en el POS: filtra el inventario ya cargado ──
  function resultadosBusqueda() {
    const qTrim = busquedaLibro.trim();
    if (!qTrim || esIsbnEscaneado(qTrim)) return []; // 10+ dígitos: se trata como escaneo, no como búsqueda de texto
    const q = qTrim.toLowerCase();
    return lotes
      .filter(l => l.titulo?.toLowerCase().includes(q) || l.isbn?.includes(qTrim)
        || l.autor?.toLowerCase().includes(q) || l.editorial?.toLowerCase().includes(q))
      .sort((a, b) => (b.stock ?? 0) - (a.stock ?? 0))
      .slice(0, 20);
  }

  // Pistola escáner: escribe el ISBN completo y dispara Enter rápido — se
  // detecta por el largo (10+ dígitos) y agrega el libro de inmediato,
  // igual que en el POS.
  const normIsbn = s => String(s || '').replace(/[-\s]/g, '');
  const esIsbnEscaneado = s => /^\d{10,}$/.test(normIsbn(s));

  useEffect(() => {
    if (!esIsbnEscaneado(busquedaLibro)) return;
    const isbn = normIsbn(busquedaLibro);
    const t = setTimeout(async () => {
      setBusquedaLibro('');
      const datos = await datosPorIsbn(isbn);
      sumarLinea(datos || { isbn });
    }, 250);
    return () => clearTimeout(t);
  }, [busquedaLibro]); // eslint-disable-line react-hooks/exhaustive-deps

  // Datos de un ISBN: primero el inventario de la librería (con su precio) y,
  // si ahí no está, el catálogo general de RELEA (título, autor, editorial —
  // sin precio, porque el precio depende del lote de cada librería).
  async function datosPorIsbn(isbn) {
    const lote = lotesRef.current.find(l => normIsbn(l.isbn) === isbn);
    if (lote) return datosDesdeLote(lote);
    try {
      const r = await api.get('/libros/buscar-uno', { params: { isbn }, _skipRetry: true });
      const li = r.data;
      return { libro_id: li.id, isbn: li.isbn || isbn, titulo: li.titulo || '', autor: li.autor || '', editorial: li.editorial || '' };
    } catch { return null; } // 404 = no está en el catálogo; cualquier otro error: se sigue a mano
  }

  // ── Precios: cada línea tiene un precio base (el del inventario, o el que se
  // escribe) y un precio cotizado. El % general del encabezado de "Cotizado"
  // mueve todas las filas desde su base; una fila editada a mano (_manual)
  // queda fuera del ajuste general hasta que se vuelve a él con ↺.
  const parsePct = s => { const n = Number(String(s ?? '').replace(',', '.')); return Number.isFinite(n) ? n : 0; };
  const precioConAjuste = (base, pct) => {
    if (base === '' || base == null) return '';
    const factor = 1 + parsePct(pct) / 100;
    return Math.round(Number(base) * (factor > 0 ? factor : 1));
  };
  const lineaVacia = { libro_id: null, isbn: '', titulo: '', autor: '', editorial: '', cantidad: 1, precio_base: '', precio_neto: '', _manual: false, descuento_pct: '' };

  function datosDesdeLote(lote) {
    const pvp = Number(lote.pvp) || 0;
    return {
      libro_id: lote.libro_id || lote.id, isbn: lote.isbn || '', titulo: lote.titulo || '',
      autor: lote.autor || '', editorial: lote.editorial || '',
      precio_base: pvp > 0 ? Math.round(pvp / 1.19) : '',
    };
  }

  // Suma un libro a la cotización (o +1 si el ISBN ya está). Forma funcional de
  // setLineas: la búsqueda en el catálogo es asíncrona y no debe pisar cambios
  // hechos mientras tanto.
  function sumarLinea(datos) {
    setLineas(prev => {
      const isbn = normIsbn(datos.isbn);
      if (isbn && prev.some(l => normIsbn(l.isbn) === isbn)) {
        return prev.map(l => normIsbn(l.isbn) === isbn ? { ...l, cantidad: Number(l.cantidad) + 1 } : l);
      }
      const base = datos.precio_base ?? '';
      return [...prev, { ...lineaVacia, ...datos, precio_base: base, precio_neto: precioConAjuste(base, ajusteRef.current) }];
    });
  }

  function agregarLibro(lote) {
    sumarLinea(datosDesdeLote(lote));
    setBusquedaLibro('');
  }
  function agregarLineaManual(titulo = '') {
    setLineas(prev => [...prev, { ...lineaVacia, titulo }]);
    setBusquedaLibro('');
  }
  function actualizarLinea(i, campo, valor) {
    setLineas(lineas.map((l, j) => j === i ? { ...l, [campo]: valor } : l));
  }
  function editarCotizado(i, valor) {
    setLineas(lineas.map((l, j) => {
      if (j !== i) return l;
      const esperado = precioConAjuste(l.precio_base, ajustePct);
      if (esperado === '') {
        // Sin precio base (libro fuera de inventario): si no hay un ajuste activo, lo que se escribe
        // pasa a ser también su base, así un ajuste general posterior lo mueve como al resto.
        const sinAjuste = parsePct(ajustePct) === 0 || 1 + parsePct(ajustePct) / 100 <= 0;
        return sinAjuste ? { ...l, precio_base: valor, precio_neto: valor, _manual: false } : { ...l, precio_neto: valor, _manual: true };
      }
      return { ...l, precio_neto: valor, _manual: Number(valor) !== esperado };
    }));
  }
  function volverAlAjuste(i) {
    setLineas(lineas.map((l, j) => j !== i ? l : { ...l, _manual: false, precio_neto: precioConAjuste(l.precio_base, ajustePct) }));
  }
  function cambiarAjuste(valor) {
    setAjustePct(valor);
    if (1 + parsePct(valor) / 100 <= 0) return; // −100 % o menos: no se aplica
    setLineas(prev => prev.map(l => (l._manual || l.precio_base === '' || l.precio_base == null)
      ? l : { ...l, precio_neto: precioConAjuste(l.precio_base, valor) }));
  }
  function difPct(l) {
    const b = Number(l.precio_base), n = Number(l.precio_neto);
    if (!(b > 0) || l.precio_neto === '' || l.precio_neto == null) return null;
    return Math.round((n / b - 1) * 1000) / 10;
  }

  // Al salir del campo ISBN de una línea a mano: si el título está vacío y el
  // ISBN existe en el inventario o en el catálogo general, completa el resto.
  async function completarLineaDesdeIsbn(i) {
    const l = lineas[i];
    const isbn = normIsbn(l?.isbn);
    if (!l || l.titulo?.trim() || !esIsbnEscaneado(isbn)) return;
    const datos = await datosPorIsbn(isbn);
    if (!datos) return;
    setLineas(prev => prev.map((x, j) => {
      if (j !== i || x.titulo?.trim()) return x; // si mientras tanto escribió un título, se respeta
      const sinPrecio = (x.precio_base === '' || x.precio_base == null) && (x.precio_neto === '' || x.precio_neto == null);
      const base = sinPrecio ? (datos.precio_base ?? '') : x.precio_base;
      return { ...x, ...datos, precio_base: base, precio_neto: sinPrecio ? precioConAjuste(base, ajusteRef.current) : x.precio_neto };
    }));
  }

  function quitarLinea(i) {
    setLineas(lineas.filter((_, j) => j !== i));
  }

  function totalLineaCalc(l) {
    const cant = Number(l.cantidad) || 0, precio = Number(l.precio_neto) || 0, desc = Number(l.descuento_pct) || 0;
    return Math.round(cant * precio * (1 - desc / 100));
  }
  const mntNeto = lineas.reduce((s, l) => s + totalLineaCalc(l), 0);
  const mntIva = Math.round(mntNeto * 0.19);
  const mntTotal = mntNeto + mntIva;

  async function guardarCotizacion(estadoDestino) {
    setErrorGuardar('');
    setMensajeBorrador('');
    if (lineas.length === 0) { setErrorGuardar('Agrega al menos un libro.'); return; }
    if (lineas.some(l => !l.titulo?.trim() || !(Number(l.cantidad) > 0))) {
      setErrorGuardar('Cada línea necesita título y una cantidad mayor a 0.');
      return;
    }
    if (!clienteForm.nombre?.trim()) { setErrorGuardar('Falta el nombre del cliente.'); return; }

    const esBorrador = estadoDestino === 'borrador';
    (esBorrador ? setGuardandoBorrador : setGuardando)(true);
    try {
      const payload = {
        cliente_id: null, cliente_nombre: clienteForm.nombre, cliente_rut: clienteForm.rut,
        cliente_giro: clienteForm.giro, cliente_direccion: clienteForm.direccion,
        cliente_comuna: clienteForm.comuna, cliente_correo: clienteForm.correo,
        notas, datos_deposito: datosDeposito, estado: estadoDestino,
        incluye_autor: incluirAutor, incluye_editorial: incluirEditorial, incluye_descuento: incluirDescuento,
        lineas: lineas.map(({ precio_base, _manual, ...l }) => ({
          ...l, cantidad: Number(l.cantidad) || 0, precio_neto: Number(l.precio_neto) || 0,
          descuento_pct: Number(l.descuento_pct) || 0,
        })),
      };
      // Con borradorId seguimos editando la misma fila; si no, siempre se
      // crea una nueva (cotización nueva, o una copia editable de una ya
      // emitida — nunca se modifica una cotización ya emitida en el lugar).
      const res = borradorId
        ? await api.put(`/cotizaciones/${borradorId}`, payload)
        : await api.post('/cotizaciones', payload);

      if (esBorrador) {
        setBorradorId(res.data.id);
        setOrigenCopia(false);
        setMensajeBorrador('Borrador guardado.');
        cargarCotizaciones();
      } else {
        localStorage.removeItem(COTIZACION_LOCAL_KEY);
        await cargarCotizaciones();
        cargarConfig(); // por si el depósito default quedó actualizado
        setSeleccionada(res.data);
        setVista('lista');
      }
    } catch (e) {
      setErrorGuardar(e.response?.data?.error || e.message || 'Error al guardar');
    }
    (esBorrador ? setGuardandoBorrador : setGuardando)(false);
  }

  function generarPdf(cot) {
    generarPdfCotizacion(cot, config || {});
  }

  function generarExcel(cot) {
    generarExcelCotizacion(cot, config || {});
  }

  // ── Ajustes de la librería (logo, datos de empresa, depósito) ──────────
  const [configForm, setConfigForm] = useState({ nombre_empresa: '', rut: '', giro: '', direccion: '', comuna: '', telefono: '', correo: '', datos_deposito_default: '', siguiente_numero: '' });
  const [guardandoConfig, setGuardandoConfig] = useState(false);
  const [errorConfig, setErrorConfig] = useState('');
  const [subiendoLogo, setSubiendoLogo] = useState(false);

  function abrirConfig() {
    setConfigForm({
      nombre_empresa: config?.nombre_empresa || '', rut: config?.rut || '', giro: config?.giro || '',
      direccion: config?.direccion || '', comuna: config?.comuna || '', telefono: config?.telefono || '',
      correo: config?.correo || '', datos_deposito_default: config?.datos_deposito_default || '',
      siguiente_numero: config?.siguiente_numero || '',
    });
    setErrorConfig('');
    setMostrarConfig(true);
  }
  async function guardarConfigForm() {
    setGuardandoConfig(true);
    setErrorConfig('');
    try {
      const res = await api.post('/cotizaciones/config', configForm);
      setConfig(c => ({ ...(c || {}), ...res.data }));
      setMostrarConfig(false);
    } catch (e) { setErrorConfig(e.response?.data?.error || e.message || 'No se pudo guardar'); }
    setGuardandoConfig(false);
  }

  // Los logos que suben las librerías pueden pesar varios MB (foto de
  // celular, captura de pantalla). Se redimensionan y convierten a PNG acá
  // mismo, en el navegador, antes de subirlos — así el PDF no carga un
  // archivo enorme para mostrar un logo que ocupa unos pocos centímetros.
  function redimensionarLogo(file, maxDim = 600) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      const url = URL.createObjectURL(file);
      img.onload = () => {
        URL.revokeObjectURL(url);
        let { width, height } = img;
        if (width > maxDim || height > maxDim) {
          const ratio = Math.min(maxDim / width, maxDim / height);
          width = Math.round(width * ratio);
          height = Math.round(height * ratio);
        }
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        canvas.getContext('2d').drawImage(img, 0, 0, width, height);
        canvas.toBlob(blob => {
          if (!blob) return reject(new Error('No se pudo procesar la imagen'));
          resolve(new File([blob], 'logo.png', { type: 'image/png' }));
        }, 'image/png');
      };
      img.onerror = () => { URL.revokeObjectURL(url); reject(new Error('No se pudo leer la imagen')); };
      img.src = url;
    });
  }
  async function subirLogo(e) {
    const file = e.target.files[0];
    if (!file) return;
    setSubiendoLogo(true);
    try {
      const archivoFinal = await redimensionarLogo(file);
      const formData = new FormData();
      formData.append('archivo', archivoFinal);
      const token = localStorage.getItem('relea_token');
      const res = await fetch(`${api.defaults.baseURL}/cotizaciones/config/logo`, {
        method: 'POST', headers: { Authorization: `Bearer ${token}` }, body: formData,
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Error al subir el logo');
      await cargarConfig();
    } catch (e) { alert(e.message); }
    setSubiendoLogo(false);
    e.target.value = '';
  }

  const inputStyle = { padding: '8px 12px', width: '100%', boxSizing: 'border-box', border: '1px solid var(--line)', borderRadius: 8, fontSize: 13, fontFamily: 'inherit', color: 'var(--ink-900)', background: 'var(--paper)', outline: 'none' };
  const labelStyle = { display: 'block', fontSize: 11, fontWeight: 500, textTransform: 'uppercase', letterSpacing: '0.07em', color: 'var(--ink-500)', marginBottom: 5 };
  const volverBtn = (onClick) => (
    <button onClick={onClick}
      style={{ width: 36, height: 36, borderRadius: '50%', border: '1px solid var(--line)', background: 'var(--paper)', color: 'var(--ink-700)', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
      <ArrowLeft size={15} strokeWidth={1.75} />
    </button>
  );

  const ConfigModal = !mostrarConfig ? null : (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100 }} onClick={() => setMostrarConfig(false)}>
      <div style={{ background: 'var(--paper)', borderRadius: 16, padding: 24, width: 480, maxWidth: '90vw', maxHeight: '85vh', overflowY: 'auto' }} onClick={e => e.stopPropagation()}>
        <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 20, fontWeight: 700, margin: '0 0 16px' }}>Datos para las cotizaciones</h2>
        <div style={{ marginBottom: 16 }}>
          <label style={labelStyle}>Logo</label>
          {config?.logo_base64 && (
            <img src={`data:${config.logo_mime};base64,${config.logo_base64}`} alt="Logo actual" style={{ maxHeight: 60, maxWidth: 200, display: 'block', marginBottom: 8, borderRadius: 8, border: '1px solid var(--line)', padding: 6 }} />
          )}
          <input type="file" accept="image/png,image/jpeg,image/webp" onChange={subirLogo} disabled={subiendoLogo} />
          {subiendoLogo && <span style={{ fontSize: 12, color: 'var(--ink-400)', marginLeft: 8 }}>Subiendo…</span>}
          <div style={{ fontSize: 11, color: 'var(--ink-400)', marginTop: 4 }}>Se ajusta automáticamente al tamaño que necesita el PDF, sin importar cuánto pese la imagen original.</div>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 }}>
          <div>
            <label style={labelStyle}>Nombre de la empresa</label>
            <input value={configForm.nombre_empresa} onChange={e => setConfigForm({ ...configForm, nombre_empresa: e.target.value })} style={inputStyle} />
          </div>
          <div>
            <label style={labelStyle}>RUT</label>
            <input value={configForm.rut} onChange={e => setConfigForm({ ...configForm, rut: e.target.value })} style={inputStyle} />
          </div>
          <div style={{ gridColumn: '1 / -1' }}>
            <label style={labelStyle}>Giro</label>
            <input value={configForm.giro} onChange={e => setConfigForm({ ...configForm, giro: e.target.value })} style={inputStyle} />
          </div>
          <div>
            <label style={labelStyle}>Dirección</label>
            <input value={configForm.direccion} onChange={e => setConfigForm({ ...configForm, direccion: e.target.value })} style={inputStyle} />
          </div>
          <div>
            <label style={labelStyle}>Comuna</label>
            <input value={configForm.comuna} onChange={e => setConfigForm({ ...configForm, comuna: e.target.value })} style={inputStyle} />
          </div>
          <div>
            <label style={labelStyle}>Teléfono</label>
            <input value={configForm.telefono} onChange={e => setConfigForm({ ...configForm, telefono: e.target.value })} style={inputStyle} />
          </div>
          <div>
            <label style={labelStyle}>Correo</label>
            <input value={configForm.correo} onChange={e => setConfigForm({ ...configForm, correo: e.target.value })} style={inputStyle} />
          </div>
          <div style={{ gridColumn: '1 / -1' }}>
            <label style={labelStyle}>Datos de depósito (valor por defecto)</label>
            <textarea value={configForm.datos_deposito_default} onChange={e => setConfigForm({ ...configForm, datos_deposito_default: e.target.value })}
              rows={4} style={{ ...inputStyle, resize: 'vertical', fontFamily: 'inherit' }} placeholder="Banco, cuenta, titular..." />
          </div>
          <div style={{ gridColumn: '1 / -1' }}>
            <label style={labelStyle}>Próximo número de cotización</label>
            <input type="number" min="1" value={configForm.siguiente_numero}
              onChange={e => setConfigForm({ ...configForm, siguiente_numero: e.target.value })}
              placeholder={config?.siguiente_numero ? String(config.siguiente_numero) : '1'} style={inputStyle} />
            <div style={{ fontSize: 11, color: 'var(--ink-400)', marginTop: 4 }}>
              Si vienes de otro sistema y ya tenías cotizaciones hechas, pon acá el número siguiente al último que usaste — por ejemplo, si tu última cotización fue la #1393, pon 1394. Déjalo en blanco si no necesitas cambiarlo.
            </div>
          </div>
        </div>
        {errorConfig && (
          <div style={{ background: 'var(--bad-bg)', border: '1px solid var(--bad-line)', borderRadius: 10, padding: '10px 14px', marginBottom: 14, fontSize: 13, color: 'var(--bad-ink)' }}>
            {errorConfig}
          </div>
        )}
        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
          <button type="button" onClick={() => setMostrarConfig(false)} style={{ padding: '9px 18px', background: 'transparent', border: '1px solid var(--line)', cursor: 'pointer', borderRadius: 999, fontSize: 13, fontFamily: 'inherit', color: 'var(--ink-700)' }}>Cerrar</button>
          <button type="button" onClick={guardarConfigForm} disabled={guardandoConfig}
            style={{ padding: '9px 20px', background: 'var(--brand)', color: '#fff', border: 'none', cursor: 'pointer', borderRadius: 999, fontSize: 13, fontWeight: 500, fontFamily: 'inherit' }}>
            {guardandoConfig ? 'Guardando...' : 'Guardar'}
          </button>
        </div>
      </div>
    </div>
  );

  if (cargando) return <p style={{ padding: '2rem', color: 'var(--ink-500)', fontFamily: 'var(--font-ui)' }}>Cargando...</p>;

  // ── Lista ────────────────────────────────────────────────────────────
  if (vista === 'lista') {
    return (
      <div>
        {ConfigModal}
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 24 }}>
          <h1 style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 28, letterSpacing: '-0.02em', margin: 0, flex: 1 }}>Cotizaciones</h1>
          <button onClick={abrirConfig}
            style={{ padding: '9px 16px', background: 'transparent', border: '1px solid var(--line)', borderRadius: 999, cursor: 'pointer', fontSize: 13, fontFamily: 'inherit', color: 'var(--ink-700)' }}>
            Ajustes
          </button>
          <button onClick={abrirNueva}
            style={{ padding: '9px 20px', background: 'var(--brand)', color: '#fff', border: 'none', borderRadius: 999, cursor: 'pointer', fontSize: 13, fontWeight: 600, fontFamily: 'inherit', display: 'inline-flex', alignItems: 'center', gap: 6 }}>
            <Plus size={14} strokeWidth={2} /> Nueva cotización
          </button>
        </div>
        {errorLista && (
          <div style={{ background: 'var(--bad-bg)', border: '1px solid var(--bad-line)', borderRadius: 10, padding: '10px 14px', marginBottom: 16, fontSize: 13, display: 'flex', alignItems: 'center', gap: 12 }}>
            <span style={{ color: 'var(--bad-ink)', flex: 1 }}>{errorLista}</span>
            <button type="button" onClick={cargarCotizaciones} style={{ padding: '6px 14px', background: 'transparent', border: '1px solid var(--bad-line)', borderRadius: 999, cursor: 'pointer', fontSize: 12.5, fontFamily: 'inherit', color: 'var(--bad-ink)', flexShrink: 0 }}>
              Reintentar
            </button>
          </div>
        )}
        {avisoLocal && (
          <div style={{ background: 'var(--warn-bg)', border: '1px solid var(--warn-line)', borderRadius: 10, padding: '10px 14px', marginBottom: 16, fontSize: 13, display: 'flex', alignItems: 'center', gap: 12 }}>
            <span style={{ color: 'var(--warn-ink)', flex: 1 }}>
              Tenés una cotización sin guardar{avisoLocal.clienteForm?.nombre ? ` para "${avisoLocal.clienteForm.nombre}"` : ''} — quedó guardada en este navegador para que no se perdiera.
            </span>
            <button type="button" onClick={continuarLocal}
              style={{ padding: '6px 14px', background: 'var(--brand)', color: '#fff', border: 'none', borderRadius: 999, cursor: 'pointer', fontSize: 12.5, fontFamily: 'inherit', fontWeight: 600, flexShrink: 0 }}>
              Continuar
            </button>
            <button type="button" onClick={descartarLocal}
              style={{ padding: '6px 14px', background: 'transparent', border: '1px solid var(--warn-line)', borderRadius: 999, cursor: 'pointer', fontSize: 12.5, fontFamily: 'inherit', color: 'var(--warn-ink)', flexShrink: 0 }}>
              Descartar
            </button>
          </div>
        )}
        {cotizaciones.length > 0 && (
          <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 20 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, background: 'var(--paper)', border: '1px solid var(--line)', borderRadius: 999, padding: '8px 16px', flex: 1, maxWidth: 360 }}>
              <Search size={15} strokeWidth={1.75} style={{ color: 'var(--ink-400)', flexShrink: 0 }} />
              <input
                value={busca}
                onChange={e => setBusca(e.target.value)}
                placeholder="Buscar por número, cliente o RUT…"
                style={{ border: 'none', outline: 'none', background: 'transparent', flex: 1, fontSize: 13.5, fontFamily: 'inherit', color: 'var(--ink-900)' }}
              />
              {busca && <button onClick={() => setBusca('')} style={{ background: 'none', border: 'none', color: 'var(--ink-400)', cursor: 'pointer', fontSize: 17, lineHeight: 1, padding: 0 }}>×</button>}
            </div>
          </div>
        )}
        {(() => {
          const buscaTrim = busca.trim().toLowerCase();
          const matchCot = c => !buscaTrim || [c.numero, c.cliente_nombre, c.cliente_rut].some(v => String(v || '').toLowerCase().includes(buscaTrim));
          const cotizacionesFiltradas = cotizaciones.filter(matchCot);
          if (cotizaciones.length === 0) {
            return !errorLista && <p style={{ color: 'var(--ink-500)', fontSize: 14 }}>Todavía no hay cotizaciones. Creá la primera con "Nueva cotización".</p>;
          }
          if (cotizacionesFiltradas.length === 0) {
            return <p style={{ color: 'var(--ink-500)', fontSize: 14 }}>Ninguna cotización coincide con la búsqueda.</p>;
          }
          return (
          <div style={{ display: 'flex', gap: 16, alignItems: 'flex-start' }}>

            {/* Panel izquierdo — lista */}
            <div style={{ width: 340, flexShrink: 0, border: '1px solid var(--line)', background: 'var(--paper)', borderRadius: 14, overflow: 'hidden' }}>
              {cotizacionesFiltradas.map((c, i) => (
                <div key={c.id} onClick={() => verDetalle(c)}
                  style={{ padding: '9px 12px', borderTop: i ? '1px solid var(--line-soft)' : 'none', cursor: 'pointer', background: seleccionada?.id === c.id ? 'var(--paper-stripe)' : 'transparent' }}>
                  <div style={{ display: 'flex', alignItems: 'baseline', gap: 6 }}>
                    {c.estado === 'borrador'
                      ? <span style={{ background: 'var(--warn-bg)', color: 'var(--warn-ink)', border: '1px solid var(--warn-line)', borderRadius: 999, fontSize: 10.5, fontWeight: 600, padding: '1px 8px', flexShrink: 0 }}>Borrador</span>
                      : <span style={{ fontSize: 12.5, fontWeight: 700, fontFamily: 'var(--font-mono)', color: 'var(--ink-900)', flexShrink: 0 }}>{c.numero}</span>}
                    <span style={{ fontSize: 11.5, color: 'var(--ink-600)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: 1 }}>{c.cliente_nombre || '—'}</span>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginTop: 2 }}>
                    <span style={{ fontSize: 11, color: 'var(--ink-400)' }}>{fmtDocFecha(c.fecha || c.creado_en)}</span>
                    <span style={{ fontSize: 12, fontWeight: 700, color: 'var(--ink-900)' }}>$ {Number(c.mnt_total).toLocaleString('es-CL')}</span>
                  </div>
                </div>
              ))}
            </div>

            {/* Panel derecho — detalle de la cotización enfocada */}
            {!seleccionada ? (
              <div style={{ flex: 1, minWidth: 0, background: 'var(--paper)', border: '1px solid var(--line)', borderRadius: 16, display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 320 }}>
                <span style={{ fontSize: 13, color: 'var(--ink-400)' }}>Elige una cotización de la lista</span>
              </div>
            ) : (
              <div style={{ flex: 1, minWidth: 0, background: 'var(--paper)', border: '1px solid var(--line)', borderRadius: 16, padding: 20, boxSizing: 'border-box' }}>
                <h2 style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 22, letterSpacing: '-0.01em', margin: '0 0 14px' }}>
                  {seleccionada.estado === 'borrador' ? 'Borrador' : `Cotización N° ${seleccionada.numero}`}
                </h2>
                <div style={{ background: 'var(--paper-stripe)', border: '1px solid var(--line)', borderRadius: 12, padding: '12px 16px', marginBottom: 16, fontSize: 13, lineHeight: 1.8 }}>
                  <b>Cliente:</b> {seleccionada.cliente_nombre || '—'} {seleccionada.cliente_rut ? `· ${seleccionada.cliente_rut}` : ''}<br />
                  {seleccionada.cliente_giro && <>{seleccionada.cliente_giro}<br /></>}
                  {seleccionada.cliente_direccion && <>{seleccionada.cliente_direccion}{seleccionada.cliente_comuna ? `, ${seleccionada.cliente_comuna}` : ''}<br /></>}
                  {seleccionada.cliente_correo && <>{seleccionada.cliente_correo}<br /></>}
                  <b>Fecha:</b> {fmtDocFecha(seleccionada.fecha || seleccionada.creado_en)}
                </div>
                <div style={{ border: '1px solid var(--line)', borderRadius: 12, overflow: 'hidden', marginBottom: 16 }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                    <thead>
                      <tr style={{ background: 'var(--paper-stripe)' }}>
                        <th style={{ ...DOC_TH, paddingLeft: 14 }}>ISBN</th>
                        <th style={DOC_TH}>Libro</th>
                        <th style={{ ...DOC_TH, width: 70, textAlign: 'right' }}>Cant.</th>
                        <th style={{ ...DOC_TH, width: 100, textAlign: 'right' }}>Neto unit.</th>
                        <th style={{ ...DOC_TH, width: 80, textAlign: 'right' }}>Dcto.</th>
                        <th style={{ ...DOC_TH, width: 110, textAlign: 'right', paddingRight: 14 }}>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(seleccionada.lineas || []).map((l, i) => (
                        <tr key={i} style={{ borderTop: '1px solid var(--line-soft)' }}>
                          <td style={{ ...DOC_TD, paddingLeft: 14, fontFamily: 'var(--font-mono)', fontSize: 12 }}>{l.isbn || '—'}</td>
                          <td style={DOC_TD}>{l.titulo}{seleccionada.incluye_autor !== false && l.autor ? <div style={{ fontSize: 11, color: 'var(--ink-500)' }}>{l.autor}</div> : null}</td>
                          <td style={{ ...DOC_TD, textAlign: 'right' }}>{l.cantidad}</td>
                          <td style={{ ...DOC_TD, textAlign: 'right' }}>$ {Number(l.precio_neto).toLocaleString('es-CL')}</td>
                          <td style={{ ...DOC_TD, textAlign: 'right' }}>{Number(l.descuento_pct) > 0 ? `${Number(l.descuento_pct)}%` : '—'}</td>
                          <td style={{ ...DOC_TD, textAlign: 'right', paddingRight: 14 }}>$ {Number(l.total_linea).toLocaleString('es-CL')}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 20 }}>
                  <table style={{ fontSize: 13, borderCollapse: 'collapse', minWidth: 220 }}>
                    <tbody>
                      <tr><td style={{ padding: '3px 10px', color: 'var(--ink-500)' }}>Monto Neto</td><td style={{ textAlign: 'right', padding: '3px 10px' }}>$ {Number(seleccionada.mnt_neto).toLocaleString('es-CL')}</td></tr>
                      <tr><td style={{ padding: '3px 10px', color: 'var(--ink-500)' }}>IVA 19%</td><td style={{ textAlign: 'right', padding: '3px 10px' }}>$ {Number(seleccionada.mnt_iva).toLocaleString('es-CL')}</td></tr>
                      <tr style={{ fontWeight: 700, borderTop: '1px solid var(--ink-900)' }}><td style={{ padding: '5px 10px' }}>Total</td><td style={{ textAlign: 'right', padding: '5px 10px' }}>$ {Number(seleccionada.mnt_total).toLocaleString('es-CL')}</td></tr>
                    </tbody>
                  </table>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                  {seleccionada.estado === 'borrador' ? (
                    <button onClick={() => abrirBorrador(seleccionada)}
                      style={{ padding: '10px 22px', background: 'var(--brand)', color: '#fff', border: 'none', borderRadius: 999, cursor: 'pointer', fontSize: 14, fontWeight: 600, fontFamily: 'inherit', display: 'inline-flex', alignItems: 'center', gap: 7 }}>
                      <Pencil size={14} strokeWidth={1.75} /> Seguir editando
                    </button>
                  ) : (
                    <>
                      <button onClick={() => generarPdf(seleccionada)}
                        style={{ padding: '10px 22px', background: 'var(--brand)', color: '#fff', border: 'none', borderRadius: 999, cursor: 'pointer', fontSize: 14, fontWeight: 600, fontFamily: 'inherit', display: 'inline-flex', alignItems: 'center', gap: 7 }}>
                        <Download size={14} strokeWidth={2} /> Generar PDF
                      </button>
                      <button onClick={() => generarExcel(seleccionada)}
                        style={{ padding: '10px 20px', background: 'transparent', border: '1px solid var(--line)', borderRadius: 999, cursor: 'pointer', fontSize: 14, fontWeight: 500, fontFamily: 'inherit', color: 'var(--ink-700)', display: 'inline-flex', alignItems: 'center', gap: 7 }}>
                        <FileSpreadsheet size={14} strokeWidth={1.75} /> Descargar Excel
                      </button>
                      <button onClick={() => editarCotizacion(seleccionada)}
                        style={{ padding: '10px 20px', background: 'transparent', border: '1px solid var(--line)', borderRadius: 999, cursor: 'pointer', fontSize: 14, fontWeight: 500, fontFamily: 'inherit', color: 'var(--ink-700)', display: 'inline-flex', alignItems: 'center', gap: 7 }}>
                        <Pencil size={14} strokeWidth={1.75} /> Editar
                      </button>
                      <span style={{ fontSize: 12, color: 'var(--ink-400)' }}>Editar crea una cotización nueva, con otro número — ésta queda igual.</span>
                    </>
                  )}
                </div>
              </div>
            )}
          </div>
          );
        })()}
      </div>
    );
  }

  // ── Nueva cotización ─────────────────────────────────────────────────
  const resultados = resultadosBusqueda();
  const cardS = { background: 'var(--paper)', border: '1px solid var(--line)', borderRadius: 16, padding: '16px 18px' };
  const eyebrow = { fontSize: 11, fontWeight: 500, textTransform: 'uppercase', letterSpacing: '0.08em', color: 'var(--ink-500)', margin: 0 };
  const chipBtn = (activo, onClick, texto) => (
    <button type="button" aria-pressed={activo} onClick={onClick}
      style={{ padding: '4px 12px', borderRadius: 999, fontSize: 12, fontFamily: 'inherit', cursor: 'pointer', border: '1px solid ' + (activo ? 'var(--ink-900)' : 'var(--line-strong)'), background: activo ? 'var(--ink-900)' : 'var(--paper)', color: activo ? '#fff' : 'var(--ink-700)' }}>
      {texto}
    </button>
  );
  const numInput = { ...inputStyle, padding: '7px 9px', textAlign: 'right', fontSize: 13 };
  const ghostBase = { boxSizing: 'border-box', minWidth: 0, padding: '4px 7px', borderRadius: 7, outline: 'none', fontFamily: 'inherit' };
  const colsLinea = `minmax(0, 1fr) 54px 110px ${incluirDescuento ? '54px ' : ''}96px 18px`;
  const ajusteNum = parsePct(ajustePct);
  const hayAjuste = ajusteNum !== 0 && 1 + ajusteNum / 100 > 0;
  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 22, flexWrap: 'wrap' }}>
        {volverBtn(() => setVista('lista'))}
        <h1 style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 28, letterSpacing: '-0.02em', margin: 0 }}>
          {borradorId ? 'Editar borrador' : origenCopia ? 'Copiar cotización' : 'Nueva cotización'}
        </h1>
        {borradorId && (
          <span style={{ padding: '3px 12px', borderRadius: 999, background: 'var(--brand-softer)', border: '1px solid var(--brand-line)', color: 'var(--brand-strong)', fontSize: 12, fontWeight: 500 }}>Borrador</span>
        )}
      </div>
      {origenCopia && (
        <div style={{ background: 'var(--warn-bg)', border: '1px solid var(--warn-line)', borderRadius: 10, padding: '10px 14px', marginBottom: 16, fontSize: 13, color: 'var(--warn-ink)', maxWidth: 760 }}>
          Estás editando una copia — al guardar se creará una cotización nueva, con otro número. La original no cambia.
        </div>
      )}

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16, alignItems: 'flex-start' }}>

        {/* ══ Columna izquierda: cliente + libros ═════════════════════════ */}
        <div style={{ flex: '1 1 600px', minWidth: 0, display: 'flex', flexDirection: 'column', gap: 16 }}>

          <div style={{ ...cardS, position: 'relative' }}>
            <p style={{ ...eyebrow, marginBottom: 10 }}>Cliente</p>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
              <input value={clienteForm.nombre}
                onChange={e => { setClienteForm({ ...clienteForm, nombre: e.target.value }); buscarCliente(e.target.value); }}
                placeholder="Nombre / Razón social" style={inputStyle} />
              <input value={clienteForm.rut}
                onChange={e => { setClienteForm({ ...clienteForm, rut: e.target.value }); buscarCliente(e.target.value); }}
                placeholder="RUT" style={inputStyle} />
              {sugerenciasCliente.length > 0 && (
                <div style={{ gridColumn: '1 / -1', position: 'relative' }}>
                  <div style={{ position: 'absolute', top: 2, left: 0, right: 0, zIndex: 10, background: 'var(--paper)', border: '1px solid var(--line)', borderRadius: 12, overflow: 'hidden', boxShadow: '0 8px 24px rgba(0,0,0,0.08)' }}>
                    <div style={{ padding: '6px 14px', fontSize: 10.5, textTransform: 'uppercase', letterSpacing: '0.06em', color: 'var(--ink-400)', background: 'var(--paper-stripe)' }}>Ya cotizado antes</div>
                    {sugerenciasCliente.map((s, i) => (
                      <div key={i} onClick={() => elegirSugerenciaCliente(s)}
                        style={{ padding: '9px 14px', cursor: 'pointer', borderTop: '1px solid var(--line-soft)' }}>
                        <div style={{ fontSize: 13.5, fontWeight: 500 }}>{s.nombre}</div>
                        <div style={{ fontSize: 11.5, color: 'var(--ink-500)' }}>{s.rut}{s.giro ? ` · ${s.giro}` : ''}</div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              <input value={clienteForm.giro} onChange={e => setClienteForm({ ...clienteForm, giro: e.target.value })} placeholder="Giro" style={{ ...inputStyle, gridColumn: '1 / -1' }} />
              <input value={clienteForm.direccion} onChange={e => setClienteForm({ ...clienteForm, direccion: e.target.value })} placeholder="Dirección" style={inputStyle} />
              <input value={clienteForm.comuna} onChange={e => setClienteForm({ ...clienteForm, comuna: e.target.value })} placeholder="Comuna" style={inputStyle} />
              <input value={clienteForm.correo} onChange={e => setClienteForm({ ...clienteForm, correo: e.target.value })} placeholder="Correo" style={{ ...inputStyle, gridColumn: '1 / -1' }} />
            </div>
            <div style={{ fontSize: 11.5, color: 'var(--ink-400)', marginTop: 8 }}>Al escribir un nombre o RUT ya cotizado antes, se completan los demás datos.</div>
          </div>

          <div style={cardS}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 10, flexWrap: 'wrap', marginBottom: 12 }}>
              <p style={eyebrow}>Libros</p>
              <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
                <span style={{ fontSize: 11.5, color: 'var(--ink-500)' }}>En el PDF:</span>
                {chipBtn(incluirAutor, () => setIncluirAutor(!incluirAutor), 'Autor')}
                {chipBtn(incluirEditorial, () => setIncluirEditorial(!incluirEditorial), 'Editorial')}
                {chipBtn(incluirDescuento, () => setIncluirDescuento(!incluirDescuento), 'Dcto.')}
              </div>
            </div>

            <div style={{ position: 'relative' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, background: 'var(--paper-soft)', border: '1px solid var(--line)', borderRadius: 999, padding: '9px 16px' }}>
                <Search size={15} strokeWidth={1.75} style={{ color: 'var(--ink-400)', flexShrink: 0 }} />
                <input
                  value={busquedaLibro}
                  onChange={e => setBusquedaLibro(e.target.value)}
                  placeholder="Título o ISBN — escanea o escribe..."
                  style={{ border: 'none', outline: 'none', background: 'transparent', flex: 1, fontSize: 14, fontFamily: 'inherit', color: 'var(--ink-900)' }}
                />
              </div>
              {busquedaLibro.trim() && !esIsbnEscaneado(busquedaLibro) && (
                <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 10, background: 'var(--paper)', border: '1px solid var(--line)', borderRadius: 12, marginTop: 6, maxHeight: 320, overflowY: 'auto', boxShadow: '0 8px 24px rgba(0,0,0,0.08)' }}>
                  {resultados.map(l => (
                    <div key={l.id} onClick={() => agregarLibro(l)}
                      style={{ padding: '10px 14px', cursor: 'pointer', borderBottom: '1px solid var(--line-soft)', display: 'flex', justifyContent: 'space-between', gap: 10, alignItems: 'center' }}>
                      <div>
                        <div style={{ fontSize: 13.5, fontWeight: 500 }}>{l.titulo}</div>
                        <div style={{ fontSize: 11.5, color: 'var(--ink-500)' }}>{l.autor}{l.isbn ? ` · ${l.isbn}` : ''}</div>
                      </div>
                      <div style={{ fontSize: 12, color: 'var(--ink-400)', flexShrink: 0 }}>stock {l.stock ?? 0}</div>
                    </div>
                  ))}
                  <div onClick={() => agregarLineaManual(busquedaLibro.trim())}
                    style={{ padding: '10px 14px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, color: 'var(--ink-700)' }}>
                    <Plus size={13} strokeWidth={2} /> Agregar «{busquedaLibro.trim()}» a mano (no está en mi inventario)
                  </div>
                </div>
              )}
            </div>
            <div style={{ margin: '8px 6px 10px' }}>
              <span style={{ fontSize: 11.5, color: 'var(--ink-400)' }}>
                Si el libro no está en tu inventario, escribe o escanea su ISBN: si está en el catálogo general de RELEA se completan título, autor y editorial.
              </span>
            </div>

            <style>{`
              .cot-gh { border: 1px solid transparent; background: transparent; }
              .cot-fila:hover .cot-gh, .cot-gh:focus { border-color: var(--line); background: var(--paper); }
              .cot-fila:hover { background: var(--paper-soft); }
              .cot-tip { position: relative; display: inline-flex; align-items: center; }
              .cot-tip:hover::after { content: attr(data-tip); position: absolute; bottom: calc(100% + 6px); left: 50%; transform: translateX(-50%); background: var(--ink-900); color: #fff; font-size: 11.5px; line-height: 1.3; padding: 4px 10px; border-radius: 8px; white-space: nowrap; z-index: 30; pointer-events: none; text-transform: none; letter-spacing: 0; font-weight: 400; }
              .cot-tip.abajo:hover::after { bottom: auto; top: calc(100% + 6px); }
            `}</style>
            <div style={{ overflowX: 'auto' }}>
              <div style={{ minWidth: 640 }}>
                <div style={{ display: 'grid', gridTemplateColumns: colsLinea, gap: 12, alignItems: 'end', padding: '6px 0 8px', borderBottom: '1px solid var(--line-soft)', fontSize: 10.5, textTransform: 'uppercase', letterSpacing: '0.06em', color: 'var(--ink-400)' }}>
                  <span>Libro</span>
                  <span style={{ textAlign: 'right' }}>Cant.</span>
                  <span ref={ajustePopRef} style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 6 }}>
                    Cotizado
                    <span className={ajusteAbierto ? 'cot-tip' : 'cot-tip abajo'} data-tip="Ajuste general de precios">
                      <button type="button" onClick={() => setAjusteAbierto(v => !v)} aria-label="Ajuste general de precios" aria-expanded={ajusteAbierto}
                        style={{ position: 'relative', width: 24, height: 24, padding: 0, borderRadius: '50%', border: '1px solid var(--brand-line)', background: 'var(--brand-softer)', color: 'var(--brand-strong)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
                        <Percent size={12} strokeWidth={2.25} />
                        {hayAjuste && <span style={{ position: 'absolute', top: -2, right: -2, width: 8, height: 8, borderRadius: '50%', background: 'var(--brand)', border: '1.5px solid var(--paper)' }} />}
                      </button>
                    </span>
                    {ajusteAbierto && (
                      <div style={{ position: 'absolute', top: 'calc(100% + 8px)', right: 0, zIndex: 20, background: 'var(--paper)', border: '1px solid var(--line)', borderRadius: 12, boxShadow: '0 8px 24px rgba(20,15,8,0.10)', padding: '10px 12px', display: 'flex', flexDirection: 'column', gap: 6, whiteSpace: 'nowrap', textTransform: 'none', letterSpacing: 0, fontSize: 12.5, color: 'var(--ink-700)', fontWeight: 400 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                          <span>Ajuste</span>
                          <input autoFocus value={ajustePct} onChange={e => cambiarAjuste(e.target.value)} onKeyDown={e => { if (e.key === 'Enter') setAjusteAbierto(false); }}
                            placeholder="+10" aria-label="Ajuste general de precios en porcentaje (por ejemplo +10 o -5)"
                            style={{ ...numInput, width: 72, padding: '5px 8px', fontSize: 13 }} />
                          <span>%</span>
                          {hayAjuste && (
                            <button type="button" onClick={() => cambiarAjuste('')}
                              style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--ink-500)', textDecoration: 'underline', fontSize: 12, fontFamily: 'inherit', padding: '0 2px' }}>Quitar</button>
                          )}
                        </div>
                        <span style={{ fontSize: 11, color: 'var(--ink-400)' }}>Sube (+10) o baja (−5) todos los precios cotizados.</span>
                      </div>
                    )}
                  </span>
                  {incluirDescuento && <span style={{ textAlign: 'right' }}>Dcto.</span>}
                  <span style={{ textAlign: 'right' }}>Total</span>
                  <span />
                </div>

                {lineas.length === 0 && (
                  <div style={{ textAlign: 'center', color: 'var(--ink-400)', fontSize: 13, padding: '28px 14px' }}>Todavía no agregaste libros.</div>
                )}

                {lineas.map((l, i) => {
                  const dif = difPct(l);
                  // Solo ayuda visual para quien arma la cotización: no se guarda ni sale en el PDF.
                  const fueraInventario = lotes.length > 0 && (l.isbn?.trim() || l.titulo?.trim())
                    && !lotes.some(x => normIsbn(x.isbn) && normIsbn(x.isbn) === normIsbn(l.isbn));
                  const colorDif = dif == null || dif === 0 ? 'var(--ink-400)' : dif > 0 ? 'var(--ok-ink)' : 'var(--bad-ink)';
                  const sep = <span style={{ color: 'var(--ink-300)', flexShrink: 0 }}>·</span>;
                  return (
                    <div key={i} className="cot-fila" style={{ display: 'grid', gridTemplateColumns: colsLinea, gap: 12, alignItems: 'center', padding: '12px 0', borderBottom: '1px solid var(--line-soft)' }}>
                      <div style={{ minWidth: 0 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                          <input className="cot-gh" value={l.titulo} onChange={e => actualizarLinea(i, 'titulo', e.target.value)} placeholder="Título del libro"
                            style={{ ...ghostBase, flex: '1 1 0', fontSize: 14, fontWeight: 500, color: 'var(--ink-900)' }} />
                          {fueraInventario && (
                            <span className="cot-tip" data-tip="Fuera de inventario" style={{ flexShrink: 0 }}>
                              <span style={{ width: 20, height: 20, borderRadius: '50%', background: 'var(--past-peach)', color: 'var(--past-peach-ink)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                                <PackageX size={12} strokeWidth={2} />
                              </span>
                            </span>
                          )}
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 2, marginTop: 2, overflow: 'hidden' }}>
                          <input className="cot-gh" value={l.isbn} onChange={e => actualizarLinea(i, 'isbn', e.target.value)} onBlur={() => completarLineaDesdeIsbn(i)} placeholder="Sin ISBN"
                            style={{ ...ghostBase, flex: '0 1 124px', fontFamily: 'var(--font-mono)', fontSize: 11, color: 'var(--ink-500)' }} />
                          {incluirAutor && <>{sep}<input className="cot-gh" value={l.autor} onChange={e => actualizarLinea(i, 'autor', e.target.value)} placeholder="Autor"
                            style={{ ...ghostBase, flex: '1 1 0', fontSize: 11.5, color: 'var(--ink-500)' }} /></>}
                          {incluirEditorial && <>{sep}<input className="cot-gh" value={l.editorial} onChange={e => actualizarLinea(i, 'editorial', e.target.value)} placeholder="Editorial"
                            style={{ ...ghostBase, flex: '1 1 0', fontSize: 11.5, color: 'var(--ink-500)' }} /></>}
                        </div>
                      </div>
                      <input className="cot-gh" type="number" min="1" value={l.cantidad} onChange={e => actualizarLinea(i, 'cantidad', e.target.value)} aria-label="Cantidad" style={numInput} />
                      <div>
                        <input type="number" min="0" value={l.precio_neto} onChange={e => editarCotizado(i, e.target.value)} aria-label="Precio cotizado neto"
                          style={{ ...numInput, borderColor: l._manual ? 'var(--brand-line)' : 'var(--line)', background: l._manual ? 'var(--brand-softer)' : 'var(--paper)' }} />
                        <div style={{ marginTop: 3, fontSize: 10.5, minHeight: 14, textAlign: 'right', whiteSpace: 'nowrap', color: l._manual ? 'var(--brand-strong)' : colorDif, fontVariantNumeric: 'tabular-nums' }}>
                          {l._manual
                            ? 'a mano'
                            : dif == null ? ' ' : `${dif > 0 ? '+' : dif < 0 ? '−' : ''}${Math.abs(dif).toLocaleString('es-CL')} %`}
                          {l._manual && hayAjuste && (
                            <button type="button" onClick={() => volverAlAjuste(i)} title="Volver al ajuste general"
                              style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--brand-strong)', padding: '0 0 0 5px', fontSize: 11, lineHeight: 1 }}>↺</button>
                          )}
                        </div>
                      </div>
                      {incluirDescuento && (
                        <input className="cot-gh" type="number" min="0" max="100" placeholder="0" value={l.descuento_pct} onChange={e => actualizarLinea(i, 'descuento_pct', e.target.value)} aria-label="Descuento en porcentaje" style={numInput} />
                      )}
                      <div style={{ textAlign: 'right', fontSize: 14, fontWeight: 600, fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap' }}>$ {totalLineaCalc(l).toLocaleString('es-CL')}</div>
                      <button type="button" onClick={() => quitarLinea(i)} aria-label="Quitar libro" title="Quitar libro"
                        style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--ink-400)', fontSize: 18, lineHeight: 1, padding: 0 }}>×</button>
                    </div>
                  );
                })}

                <span className="cot-tip" data-tip="Agregar línea en blanco" style={{ display: 'flex', marginTop: 12 }}>
                  <button type="button" aria-label="Agregar línea en blanco"
                    onClick={() => {
                      agregarLineaManual();
                      setTimeout(() => {
                        const t = document.querySelectorAll('.cot-fila input[placeholder="Título del libro"]');
                        t[t.length - 1]?.focus();
                      }, 60);
                    }}
                    style={{ width: '100%', height: 40, border: '1.5px dashed var(--line-strong)', borderRadius: 10, background: 'transparent', color: 'var(--ink-500)', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Plus size={18} strokeWidth={2} />
                  </button>
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* ══ Columna derecha: resumen + notas ════════════════════════════ */}
        <div style={{ flex: '1 1 260px', maxWidth: 300, minWidth: 250, position: 'sticky', top: 16, display: 'flex', flexDirection: 'column', gap: 16 }}>
          <div style={cardS}>
            <p style={{ ...eyebrow, marginBottom: 10 }}>Resumen</p>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, marginBottom: 4 }}>
              <span style={{ color: 'var(--ink-500)' }}>Monto neto</span><span style={{ fontVariantNumeric: 'tabular-nums' }}>$ {mntNeto.toLocaleString('es-CL')}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, marginBottom: 8 }}>
              <span style={{ color: 'var(--ink-500)' }}>IVA 19%</span><span style={{ fontVariantNumeric: 'tabular-nums' }}>$ {mntIva.toLocaleString('es-CL')}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', borderTop: '1px solid var(--ink-900)', paddingTop: 8 }}>
              <span style={{ fontWeight: 500, fontSize: 13.5 }}>Total</span>
              <span style={{ fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: 24, letterSpacing: '-0.02em', fontVariantNumeric: 'tabular-nums' }}>$ {mntTotal.toLocaleString('es-CL')}</span>
            </div>

            {hayAjuste && (
              <div style={{ borderTop: '1px solid var(--line-soft)', marginTop: 14, paddingTop: 12, display: 'flex', alignItems: 'center', gap: 8, fontSize: 12.5 }}>
                <span style={{ width: 8, height: 8, borderRadius: '50%', background: 'var(--brand)', flexShrink: 0 }} />
                <span style={{ color: 'var(--ink-600)' }}>Ajuste de precios <b style={{ color: 'var(--ink-900)', fontWeight: 500 }}>{ajusteNum > 0 ? '+' : '−'}{Math.abs(ajusteNum).toLocaleString('es-CL')} %</b></span>
                <button type="button" onClick={() => cambiarAjuste('')}
                  style={{ marginLeft: 'auto', background: 'none', border: 'none', cursor: 'pointer', color: 'var(--ink-500)', textDecoration: 'underline', fontSize: 12, fontFamily: 'inherit', padding: 0 }}>Quitar</button>
              </div>
            )}

            {errorGuardar && (
              <div style={{ background: 'var(--bad-bg)', border: '1px solid var(--bad-line)', borderRadius: 10, padding: '10px 12px', marginTop: 14, fontSize: 12.5 }}>
                <strong style={{ color: 'var(--bad-ink)' }}>No se puede guardar.</strong> <span style={{ color: 'var(--bad-ink)' }}>{errorGuardar}</span>
              </div>
            )}
            <div style={{ borderTop: '1px solid var(--line-soft)', marginTop: 14, paddingTop: 14, display: 'flex', flexDirection: 'column', gap: 8 }}>
              <button type="button" onClick={() => guardarCotizacion('emitida')} disabled={guardando || guardandoBorrador}
                style={{ padding: '10px 20px', background: 'var(--brand)', color: '#fff', border: 'none', cursor: guardando ? 'not-allowed' : 'pointer', borderRadius: 999, fontSize: 13.5, fontWeight: 500, fontFamily: 'inherit', opacity: guardando ? 0.6 : 1 }}>
                {guardando ? 'Guardando...' : 'Guardar cotización'}
              </button>
              <button type="button" onClick={() => guardarCotizacion('borrador')} disabled={guardando || guardandoBorrador}
                style={{ padding: '9px 18px', background: 'transparent', border: '1px solid var(--line)', cursor: 'pointer', borderRadius: 999, fontSize: 13, fontFamily: 'inherit', color: 'var(--ink-700)', opacity: guardandoBorrador ? 0.6 : 1 }}>
                {guardandoBorrador ? 'Guardando...' : 'Guardar borrador'}
              </button>
              <button type="button" onClick={() => { localStorage.removeItem(COTIZACION_LOCAL_KEY); setVista('lista'); }}
                style={{ padding: '6px 18px', background: 'transparent', border: 'none', cursor: 'pointer', borderRadius: 999, fontSize: 13, fontFamily: 'inherit', color: 'var(--ink-500)' }}>
                Cancelar
              </button>
              {mensajeBorrador && <span style={{ fontSize: 12.5, color: 'var(--ok-ink)', textAlign: 'center' }}>{mensajeBorrador}</span>}
            </div>
          </div>

          <div style={cardS}>
            <p style={{ ...eyebrow, marginBottom: 8 }}>Notas y depósito</p>
            <label style={labelStyle}>Notas</label>
            <textarea value={notas} onChange={e => setNotas(e.target.value)} rows={3} style={{ ...inputStyle, resize: 'vertical', fontFamily: 'inherit', marginBottom: 10 }} />
            <label style={labelStyle}>Datos de depósito</label>
            <textarea value={datosDeposito} onChange={e => setDatosDeposito(e.target.value)} rows={3} style={{ ...inputStyle, resize: 'vertical', fontFamily: 'inherit' }} />
          </div>
        </div>
      </div>
    </div>
  );
}

function Documentos({ activo = true }) {
  const [vista, setVista] = useState('lista');
  const [documentos, setDocumentos] = useState([]);
  const [distribuidores, setDistribuidores] = useState([]);
  const [libros, setLibros] = useState([]);
  const [seleccionado, setSeleccionado] = useState(null);
  const [filtroTipo, setFiltroTipo] = useState('');
  const [filtroEstado, setFiltroEstado] = useState('');
  const [form, setForm] = useState({ tipo: 'gdd', numero: '', distribuidor_id: '', modalidad: '', fecha: new Date().toISOString().split('T')[0], notas: '', proposito: '', mnt_total: null, proveedor_rut: '', proveedor_nombre: '' });
  const [detalle, setDetalle] = useState([{ libro_id: '', cantidad: 1, precio_neto: '', pvp: '' }]);
  const [guardando, setGuardando] = useState(false);
  const [cargando, setCargando] = useState(true);
  const [errorGuardar, setErrorGuardar] = useState('');
  const [recepcionLineas, setRecepcionLineas] = useState([]);
  const [confirmando, setConfirmando] = useState(false);
  const [lotesCreados, setLotesCreados] = useState([]);
  const [archivoInfo, setArchivoInfo] = useState(null);
  const [xmlInfo, setXmlInfo] = useState(null);
  const [editando, setEditando] = useState(false);
  const [editForm, setEditForm] = useState({ modalidad: '', notas: '', proposito: '' });
  const [guardandoEdit, setGuardandoEdit] = useState(false);
  const [listDragDepth, setListDragDepth] = useState(0);
  const [loteDocs, setLoteDocs] = useState([]); // ítems del lote de "Nuevo documento" (archivos leídos o documentos a mano)
  const [loteDocActivoId, setLoteDocActivoId] = useState(null); // ítem que se está editando en el panel derecho
  const [confirmandoCierre, setConfirmandoCierre] = useState(false); // aviso "hay documentos sin guardar" al cerrar el lote
  const [loteSel, setLoteSel] = useState(() => new Set()); // ids del lote marcados con la casilla, para quitarlos
  const [confirmandoQuitar, setConfirmandoQuitar] = useState(false); // confirmación de quitar documentos aún sin guardar
  const [confirmandoRecepcionLote, setConfirmandoRecepcionLote] = useState(false); // confirmación de "Recibir todo lo esperado"
  const [recibiendoLote, setRecibiendoLote] = useState(null); // { hecho, total } mientras se reciben varias GDD
  const [resultadoRecepcionLote, setResultadoRecepcionLote] = useState(null); // { ok: [...], fallo: [...] } al terminar
  const [confirmandoAnulacion, setConfirmandoAnulacion] = useState(false); // confirmación de "Anular seleccionados"
  const [anulandoLote, setAnulandoLote] = useState(false);
  const [resultadoAnulacionLote, setResultadoAnulacionLote] = useState(null); // { ok: [...], fallo: [...] } al terminar
  const [factorDescuento, setFactorDescuento] = useState(''); // % descuento editorial, ej "40"
  const [busca, setBusca] = useState('');
  const [docFoco, setDocFoco] = useState(null); // doc id mostrado en el panel derecho de la lista
  const [seleccionados, setSeleccionados] = useState(() => new Set()); // ids marcados con el casillero, para avanzar de a varios
  const [panelTab, setPanelTab] = useState('pendientes'); // 'pendientes' | 'recepcionar' | 'completados' — qué lista muestra el panel izquierdo
  const [soloTipo, setSoloTipo] = useState(null); // null | 'gdd' | 'factura' | … — muestra solo ese tipo en la lista del panel izquierdo
  const [loteAvanzando, setLoteAvanzando] = useState(false);
  const [docRefreshTick, setDocRefreshTick] = useState(0); // fuerza al panel derecho a re-traer el doc enfocado tras una acción en lote

  // Documentos que ya se abrieron en la lista: los que no, se ven en negrita en Pendientes. Se guarda en este
  // navegador, por usuario (no viaja al servidor), así que otro equipo u otro usuario ve sus propias novedades.
  const claveVistos = 'relea_docs_vistos:' + (localStorage.getItem('relea_nombre') || '');
  const [docsVistos, setDocsVistos] = useState(() => {
    try { return new Set(JSON.parse(localStorage.getItem(claveVistos) || '[]')); } catch (e) { return new Set(); }
  });
  function marcarVistos(ids) {
    const nuevos = ids.filter(id => id && !docsVistos.has(id));
    if (nuevos.length === 0) return;
    const next = new Set([...docsVistos, ...nuevos]);
    setDocsVistos(next);
    try { localStorage.setItem(claveVistos, JSON.stringify([...next].slice(-3000))); } catch (e) { /* sin almacenamiento: solo dura esta sesión */ }
  }
  function desmarcarVistos(ids) {
    const next = new Set([...docsVistos].filter(id => !ids.includes(id)));
    setDocsVistos(next);
    try { localStorage.setItem(claveVistos, JSON.stringify([...next].slice(-3000))); } catch (e) { /* solo dura esta sesión */ }
  }
  // Abrir un documento (panel derecho) o marcarlo con la casilla —que muestra su detalle— lo da por visto
  useEffect(() => { marcarVistos([docFoco, ...seleccionados]); }, [docFoco, seleccionados]); // eslint-disable-line react-hooks/exhaustive-deps


  // Búsqueda por libro: además de número y distribuidor, el buscador encuentra los documentos que traen un
  // libro (título, autor o ISBN). Se consulta al servidor con una pequeña espera mientras se escribe.
  const [coincidenciasLibro, setCoincidenciasLibro] = useState({ q: '', mapa: {} });
  useEffect(() => {
    const q = busca.trim();
    if (q.length < 3) { setCoincidenciasLibro({ q: '', mapa: {} }); return undefined; }
    let vigente = true;
    const t = setTimeout(async () => {
      try {
        const r = await api.get('/documentos/buscar-libro', { params: { q } });
        if (vigente) setCoincidenciasLibro({ q: q.toLowerCase(), mapa: r.data || {} });
      } catch (e) { if (vigente) setCoincidenciasLibro({ q: '', mapa: {} }); }
    }, 300);
    return () => { vigente = false; clearTimeout(t); };
  }, [busca]);

  const enBusquedaTop = busca.trim() !== '';
  useEffect(() => { setSeleccionados(new Set()); setSoloTipo(null); }, [enBusquedaTop]);

  useEffect(() => { cargarTodo(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Al volver a Documentos desde otro módulo (la pantalla quedó montada, oculta) se refresca la lista, sin tocar el lote en curso
  const primeraActivacion = useRef(true);
  useEffect(() => {
    if (primeraActivacion.current) { primeraActivacion.current = false; return; }
    if (activo) cargarDocumentos();
  }, [activo]); // eslint-disable-line react-hooks/exhaustive-deps

  // ── "Nuevo documento" — pantalla única ──────────────────────────────────────
  // Constantes y estado derivado del formulario. Declarados aquí (no dentro del
  // render condicional de vista === 'nuevo') porque alimentan los useEffect de
  // abajo, y los hooks no pueden llamarse condicionalmente.
  const etiquetaPropositoLocal = { ingreso_mercaderia: 'Ingreso de mercadería', cobro_consignacion: 'Liquidación de consignación', otro: 'Ajuste o corrección', gasto_servicio: 'Gasto o servicio' };
  const PROPOSITOS_POR_TIPO = {
    gdd:          ['ingreso_mercaderia', 'gasto_servicio'],
    factura:      ['ingreso_mercaderia', 'cobro_consignacion', 'gasto_servicio'],
    nota_credito: ['otro', 'gasto_servicio'],
    nota_debito:  ['otro', 'gasto_servicio'],
  };
  const detalleBlancoGasto = [{ descripcion: '', cantidad: 1, precio_neto: '', monto_item: null }];
  const detalleBlancoLibro = [{ libro_id: '', cantidad: 1, precio_neto: '', pvp: '' }];
  const esGasto = form.proposito === 'gasto_servicio';
  const modalidadAplica = form.proposito !== 'gasto_servicio' && form.proposito !== 'cobro_consignacion';

  // Número / fecha / monto / exención: se autocompletan apenas se lee un archivo,
  // sin depender del propósito (que el usuario todavía no eligió).
  useEffect(() => {
    const fuente = (xmlInfo && !xmlInfo.error) ? xmlInfo : (archivoInfo && !archivoInfo.error ? archivoInfo : null);
    if (!fuente) return;
    setForm(f => ({
      ...f,
      numero:    fuente.folio || fuente.numero || f.numero,
      fecha:     fuente.fechaEmision || f.fecha,
      mnt_total: fuente.mntTotal != null ? fuente.mntTotal : f.mnt_total,
      es_exenta: fuente.esExenta || false,
    }));
  }, [xmlInfo, archivoInfo]); // eslint-disable-line react-hooks/exhaustive-deps

  // Detalle: se (re)construye desde el archivo leído cuando cambia el archivo, o
  // cuando cambia si el propósito elegido es "Gasto o servicio" (cambia la forma
  // de las líneas: descripción libre vs. libro con ISBN). No depende de cuál
  // propósito puntual se eligió entre los que no son gasto, para no perder
  // ediciones manuales al cambiar entre ellos.
  useEffect(() => {
    const fuente = (xmlInfo && !xmlInfo.error) ? xmlInfo : (archivoInfo && !archivoInfo.error ? archivoInfo : null);
    if (!fuente || !fuente.lineas?.length) {
      setDetalle(esGasto ? detalleBlancoGasto : detalleBlancoLibro);
    } else if (esGasto) {
      const esExenta = fuente.esExenta || false;
      setDetalle(fuente.lineas.map(l => {
        const precioNeto = l.precio_neto || (l.monto_item && l.cantidad === 1 ? l.monto_item : null) || '';
        return { descripcion: l.titulo || l.isbn || '', cantidad: l.cantidad || 1, precio_neto: precioNeto, monto_item: l.monto_item || null, _exenta: esExenta };
      }));
    } else {
      setDetalle(fuente.lineas.map(l => {
        const pn = parseFloat(l.precio_neto) || 0;
        const encontrado = !!l.libro_id || !!l.isbn_encontrado;
        const tituloMostrar = l.titulo_bd || l.titulo || '';
        return {
          libro_id: l.libro_id || '', cantidad: l.cantidad || 1, precio_neto: l.precio_neto || '',
          pvp: pn > 0 ? Math.round(pn * 1.19) : (l.pvp || ''),
          descuento_pct: l.descuento_pct || null, monto_item: l.monto_item || null,
          _isbn: l.isbn, _isbn_encontrado: encontrado, _libro_nuevo: !encontrado,
          _titulo: tituloMostrar, _titulo_editado: tituloMostrar.includes('?') ? tituloMostrar : '',
        };
      }));
    }
    if (esGasto && fuente) {
      setForm(f => ({ ...f, proveedor_rut: fuente.rutEmisor || f.proveedor_rut, proveedor_nombre: fuente.razonSocial || f.proveedor_nombre }));
    }
  }, [xmlInfo, archivoInfo, esGasto]); // eslint-disable-line react-hooks/exhaustive-deps

  // Tipo: filtra las opciones de propósito válidas; si la elegida deja de calzar, se limpia.
  function onTipoChange(tipo) {
    setForm(f => {
      const validas = PROPOSITOS_POR_TIPO[tipo] || [];
      const sigueValido = validas.includes(f.proposito);
      return { ...f, tipo, proposito: sigueValido ? f.proposito : '', modalidad: sigueValido ? f.modalidad : '' };
    });
  }

  // Propósito: nunca se preselecciona. "Liquidación de consignación" fija la modalidad
  // internamente —son libros consignados que ya se vendieron— sin mostrar el selector.
  function onPropositoChange(p) {
    setForm(f => ({ ...f, proposito: p, modalidad: p === 'cobro_consignacion' ? 'consignacion' : '', proveedor_rut: '', proveedor_nombre: '' }));
  }

  async function cargarTodo() {
    setCargando(true);
    try {
      const [dists, libs] = await Promise.all([
        api.get('/distribuidores'),
        api.get('/libros')
      ]);
      setDistribuidores(dists.data);
      setLibros(libs.data);
    } catch (e) { console.error('cargarTodo docs (dists/libs):', e.message); }
    try {
      const docs = await api.get('/documentos');
      setDocumentos(docs.data);
    } catch (e) { console.error(e); }
    setCargando(false);
  }

  async function cargarDocumentos(sobreTipo, sobreEstado) {
    const tipo   = sobreTipo   !== undefined ? sobreTipo   : filtroTipo;
    const estado = sobreEstado !== undefined ? sobreEstado : filtroEstado;
    const params = new URLSearchParams();
    if (tipo)   params.append('tipo', tipo);
    if (estado) params.append('estado', estado);
    try {
      const res = await api.get(`/documentos?${params}`);
      setDocumentos(res.data);
    } catch (e) { console.error(e); }
  }

  // "Recepcionar" desde la lista salta directo a la revisión de la recepción; lo demás abre el detalle.
  async function abrirDesdeLista(doc, accion) {
    if (accion === 'recepcionar') await abrirRecepcion(doc.id);
    else await verDetalle(doc);
  }

  async function verDetalle(doc) {
    marcarVistos([doc.id]);
    const res = await api.get(`/documentos/${doc.id}`);
    setSeleccionado(res.data);
    setVista('detalle');
  }

  async function guardarDocumento(e) {
    if (e && e.preventDefault) e.preventDefault();
    setGuardando(true);
    setErrorGuardar('');
    try {
      const esGasto = form.proposito === 'gasto_servicio';
      const lineas = esGasto
        ? detalle.filter(d => d.descripcion?.trim())
        : detalle.filter(d => (d.libro_id || d._isbn || (d._titulo_editado || '').trim() || (d._titulo || '').trim()) && d.cantidad > 0);
      // Pasar RUT y nombre del emisor (del XML o del PDF leído) siempre que se conozcan —
      // no solo para el find-or-create de distribuidor, también permite al backend
      // detectar duplicados por RUT emisor aunque el distribuidor ya esté resuelto.
      const emisorInfo = xmlInfo?.rutEmisor ? xmlInfo : (archivoInfo?.tipo_archivo === 'pdf' ? archivoInfo : null);
      const distribPayload = emisorInfo?.rutEmisor
        ? { distribuidor_rut: emisorInfo.rutEmisor, distribuidor_nombre: emisorInfo.razonSocial }
        : {};
      await api.post('/documentos', {
        ...form,
        detalle: lineas,
        archivo_original: archivoInfo?.archivo || xmlInfo?.archivo || null,
        ...distribPayload,
      });
      await cargarDocumentos();
      const idActual = loteActivoRef.current;
      if (idActual) {
        marcarItem(idActual, 'guardado');
        avanzarDocumentoLote(idActual);
      } else {
        cerrarNuevo(true);
      }
    } catch (err) {
      console.error(err);
      const data = err.response?.data;
      const idActual = loteActivoRef.current;
      if (err.response?.status === 409 && data?.tipo === 'exacto') {
        // En un lote, un duplicado exacto se marca y se pasa al siguiente; si es el único documento,
        // se queda en pantalla con el aviso (como antes).
        if (loteRef.current.length > 1 && idActual) {
          marcarItem(idActual, 'duplicado', { dup: data.duplicado || null, dupMsg: data.error });
          if (!avanzarDocumentoLote(idActual)) setErrorGuardar(data.error);
        } else {
          setErrorGuardar(data.error);
        }
      } else {
        setErrorGuardar(data?.error || err.message || 'Error al guardar');
      }
    }
    setGuardando(false);
  }

  async function cambiarEstado(id, estado) {
    await api.patch(`/documentos/${id}/estado`, { estado });
    const res = await api.get(`/documentos/${id}`);
    setSeleccionado(res.data);
    await cargarDocumentos();
  }

  function abrirEdicion() {
    setEditForm({
      modalidad: seleccionado.modalidad || 'firme',
      notas:     seleccionado.notas     || '',
      proposito: seleccionado.proposito || 'ingreso_mercaderia',
    });
    setErrorLineas('');
    setQuitandoLineaId(null);
    setLineaNueva(lineaNuevaVacia);
    setEditando(true);
  }

  function cancelarEdicion() {
    setEditando(false);
  }

  async function guardarEdicion() {
    setGuardandoEdit(true);
    try {
      await api.patch(`/documentos/${seleccionado.id}`, editForm);
      const res = await api.get(`/documentos/${seleccionado.id}`);
      setSeleccionado(res.data);
      setEditando(false);
      await cargarDocumentos();
    } catch (e) {
      alert(e.response?.data?.error || e.message);
    }
    setGuardandoEdit(false);
  }

  // ── Corregir las líneas de un documento ya ingresado (modo "Editar" del detalle) ──
  // Cada cambio se guarda al instante. Las líneas ya recibidas no se pueden tocar (tienen stock detrás).
  const lineaNuevaVacia = { _isbn: '', _titulo_editado: '', cantidad: '1', precio_neto: '', pvp: '' };
  const [lineaNueva, setLineaNueva] = useState(lineaNuevaVacia);
  const [ocupadoLineas, setOcupadoLineas] = useState(false);
  const [errorLineas, setErrorLineas] = useState('');
  const [quitandoLineaId, setQuitandoLineaId] = useState(null);

  async function recargarSeleccionado() {
    const res = await api.get(`/documentos/${seleccionado.id}`);
    setSeleccionado(res.data);
    await cargarDocumentos();
  }

  async function agregarLineaDoc() {
    setErrorLineas('');
    setOcupadoLineas(true);
    try {
      await api.post(`/documentos/${seleccionado.id}/lineas`, { lineas: [lineaNueva] });
      setLineaNueva(lineaNuevaVacia);
      await recargarSeleccionado();
    } catch (e) {
      setErrorLineas(e.response?.data?.error || e.message);
    }
    setOcupadoLineas(false);
  }

  async function guardarCampoLinea(d, campo, valor) {
    const igual = valor === '' ? d[campo] == null : (d[campo] != null && Number(d[campo]) === Number(valor));
    if (igual) return;
    setErrorLineas('');
    try {
      await api.patch(`/documentos/${seleccionado.id}/lineas/${d.id}`, { [campo]: valor });
    } catch (e) {
      setErrorLineas(e.response?.data?.error || e.message);
    }
    await recargarSeleccionado().catch(() => {});
  }

  async function quitarLineaDoc(d) {
    setErrorLineas('');
    try {
      await api.delete(`/documentos/${seleccionado.id}/lineas/${d.id}`);
    } catch (e) {
      setErrorLineas(e.response?.data?.error || e.message);
    }
    setQuitandoLineaId(null);
    await recargarSeleccionado().catch(() => {});
  }

  function initFactorDescuento(doc) {
    const fp = Number(doc.distribuidor_factor_pago || 0);
    setFactorDescuento(fp > 0 ? String(Math.round((1 - fp) * 100)) : '');
  }

  // Abre la revisión de la recepción. Desde "emitida" no hace falta un paso previo: el documento sigue
  // emitido hasta que se confirma, y ahí pasa a recibida (o queda parcial si faltan títulos).
  async function abrirRecepcion(id = seleccionado.id) {
    const res = await api.get(`/documentos/${id}`);
    const doc = res.data;
    setSeleccionado(doc);
    setRecepcionLineas((doc.detalle || []).map(d => ({
      detalle_id: d.id,
      libro_id: d.libro_id,
      titulo: d.titulo,
      autor: d.autor,
      pvp: d.pvp,
      precio_neto: d.precio_neto,
      monto_item: d.monto_item,
      descuento_pct: d.descuento_pct,
      cantidad: d.cantidad,
      cantidad_esperada: d.cantidad,
      cantidad_recibida: d.cantidad_recibida ?? d.cantidad,
      parcialmente_recibido: d.parcialmente_recibido || false,
      revisado: false,
    })));
    initFactorDescuento(doc);
    setLotesCreados([]);
    setVista('recepcion');
  }

  function _buildLineasParaEnvio(tipo) {
    if (tipo === 'parcial') {
      return recepcionLineas
        .filter(l => l.revisado && !l.parcialmente_recibido)
        .map(l => ({ detalle_id: l.detalle_id, cantidad_recibida: Number(l.cantidad_recibida) }));
    }
    return recepcionLineas
      .filter(l => !l.parcialmente_recibido)
      .map(l => ({ detalle_id: l.detalle_id, cantidad_recibida: Number(l.cantidad_recibida) }));
  }

  async function confirmarRecepcion(tipo) {
    const esFactura = seleccionado.tipo === 'factura';
    let factor = undefined;
    if (!esFactura) {
      const pctNum = Number(factorDescuento);
      if (factorDescuento === '' || isNaN(pctNum) || pctNum <= 0 || pctNum >= 100) {
        alert('El descuento editorial debe ser mayor a 0 y menor a 100 %.');
        return;
      }
      factor = parseFloat(((100 - pctNum) / 100).toFixed(6));
    }
    const lineas = _buildLineasParaEnvio(tipo);
    if (tipo === 'parcial' && lineas.length === 0) {
      alert('Marca al menos un título para ingresar.');
      return;
    }
    setConfirmando(true);
    try {
      const body = { tipo, lineas };
      if (factor !== undefined) body.factor = factor;
      const res = await api.post(`/documentos/${seleccionado.id}/confirmar-recepcion`, body);
      if (res.data.advertencias?.length > 0) {
        alert(`Recepción confirmada con advertencias:\n${res.data.advertencias.map(a => `• ${a.motivo}`).join('\n')}`);
      }
      setLotesCreados(res.data.lotes);
      const docRes = await api.get(`/documentos/${seleccionado.id}`);
      setSeleccionado(docRes.data);
      await cargarDocumentos();
      if (tipo === 'parcial' && res.data.estado !== 'completa') {
        // Recargar líneas y quedarse en vista recepción
        setRecepcionLineas((docRes.data.detalle || []).map(d => ({
          detalle_id: d.id, libro_id: d.libro_id, titulo: d.titulo, autor: d.autor,
          pvp: d.pvp, precio_neto: d.precio_neto, monto_item: d.monto_item,
          descuento_pct: d.descuento_pct, cantidad: d.cantidad,
          cantidad_esperada: d.cantidad, cantidad_recibida: d.cantidad_recibida ?? d.cantidad,
          parcialmente_recibido: d.parcialmente_recibido || false, revisado: false,
        })));
      } else {
        setVista('detalle');
      }
    } catch (e) {
      alert(e.response?.data?.error || e.message);
    }
    setConfirmando(false);
  }

  // ── Lote de documentos (panel izquierdo de "Nuevo documento") ─────────────
  // Cada archivo soltado/elegido es un ítem del lote: se lee al tiro (y el backend avisa si el
  // documento ya estaba ingresado) y se revisa/guarda en el editor del panel derecho. Un documento
  // a mano es un ítem más, sin archivo. form/detalle/xmlInfo/archivoInfo siguen siendo el estado
  // del ítem que se está editando; al cambiar de ítem se guardan sus ediciones para poder volver.
  const formVacio = () => ({ tipo: 'gdd', numero: '', distribuidor_id: '', modalidad: '', fecha: new Date().toISOString().split('T')[0], notas: '', proposito: '', mnt_total: null, proveedor_rut: '', proveedor_nombre: '' });
  const detalleVacio = () => [{ libro_id: '', cantidad: 1, precio_neto: '', pvp: '' }];
  const loteRef = useRef([]);
  loteRef.current = loteDocs;
  const loteSeq = useRef(0);
  const loteActivoRef = useRef(null);

  // Va después de los efectos que derivan form/detalle del archivo leído: así, al volver a un
  // ítem ya editado, sus ediciones pisan lo derivado y no al revés.
  useEffect(() => {
    const it = loteRef.current.find(x => x.id === loteDocActivoId);
    if (it?.edits) { setForm(it.edits.form); setDetalle(it.edits.detalle); }
  }, [loteDocActivoId]); // eslint-disable-line react-hooks/exhaustive-deps

  // Al cambiar el ancho de la ventana, los títulos largos (cuadros que se ajustan a su texto) se reajustan.
  const [, setTickAncho] = useState(0);
  useEffect(() => {
    const f = () => setTickAncho(t => t + 1);
    window.addEventListener('resize', f);
    return () => window.removeEventListener('resize', f);
  }, []);

  const itemLote = extra => ({ id: 'd' + (++loteSeq.current), nombre: '', manual: false, tipoArchivo: null, info: null, resumen: null, dup: null, dupMsg: '', error: '', edits: null, estado: 'pendiente', ...extra });
  const resumenDe = d => ({ tipo: d.tipoDoc || null, numero: d.folio || d.numero || null, proveedor: d.razonSocial || d.rutEmisor || null, monto: d.mntTotal != null ? d.mntTotal : null });
  const esManualVirgen = it => !!it && it.manual && it.id === loteActivoRef.current && !form.numero && !form.proposito && !detalle.some(d => d.libro_id || d._isbn || d._titulo_editado);
  const marcarItem = (id, estado, extra = {}) => setLoteDocs(prev => prev.map(x => x.id === id ? { ...x, estado, ...extra } : x));

  async function leerDocumento(file) {
    const esXml = file.name.split('.').pop().toLowerCase() === 'xml';
    const formData = new FormData();
    formData.append('archivo', file);
    const token = localStorage.getItem('relea_token');
    const res = await fetch(`${api.defaults.baseURL}/documentos/${esXml ? 'subir-xml' : 'subir-archivo'}`, {
      method: 'POST', headers: { Authorization: `Bearer ${token}` }, body: formData,
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || (esXml ? 'Error al procesar el XML' : 'Error al subir el archivo'));
    return { tipoArchivo: esXml ? 'xml' : 'archivo', data };
  }

  // Deja un ítem cargado en el editor. Número, fecha, monto y líneas se derivan del archivo en los
  // efectos de más arriba; acá solo se fija lo que antes fijaba la subida (tipo y distribuidor).
  function cargarEnEditor(it) {
    loteActivoRef.current = it.id;
    setLoteDocActivoId(it.id);
    setErrorGuardar('');
    const d = it.info;
    const f = formVacio();
    if (d) {
      if (d.tipoDoc && (it.tipoArchivo === 'xml' || d.tipo_archivo === 'pdf')) f.tipo = d.tipoDoc;
      if (d.distribuidor_existente) f.distribuidor_id = d.distribuidor_existente.id;
    }
    setForm(f);
    setDetalle(detalleVacio());
    setXmlInfo(it.tipoArchivo === 'xml' ? d : null);
    setArchivoInfo(it.tipoArchivo === 'archivo' ? d : null);
  }

  function abrirNuevo(conManual = true) {
    setLoteSel(new Set());
    setConfirmandoQuitar(false);
    loteActivoRef.current = null;
    setLoteDocActivoId(null);
    setXmlInfo(null);
    setArchivoInfo(null);
    setForm(formVacio());
    setDetalle(detalleVacio());
    setErrorGuardar('');
    if (conManual) {
      const it = itemLote({ nombre: 'Documento a mano', manual: true });
      setLoteDocs([it]);
      cargarEnEditor(it);
    } else {
      setLoteDocs([]);
    }
    setVista('nuevo');
  }

  function agregarManual() {
    const it = itemLote({ nombre: 'Documento a mano', manual: true });
    const idPrevio = loteActivoRef.current, snap = { form, detalle };
    setLoteDocs(prev => [...prev.map(x => x.id === idPrevio ? { ...x, edits: snap } : x), it]);
    cargarEnEditor(it);
  }

  async function agregarArchivosAlLote(fileList) {
    const files = Array.from(fileList || []);
    if (!files.length) return;
    const nuevos = files.map(f => itemLote({ nombre: f.name, file: f, estado: 'leyendo' }));
    // Un documento a mano que nadie tocó se descarta cuando llegan archivos.
    const idPrevio = loteActivoRef.current;
    const descartar = esManualVirgen(loteRef.current.find(x => x.id === idPrevio));
    if (descartar) { loteActivoRef.current = null; setLoteDocActivoId(null); }
    setLoteDocs(prev => [...prev.filter(x => !(descartar && x.id === idPrevio)), ...nuevos]);
    for (const it of nuevos) {
      try {
        const { tipoArchivo, data } = await leerDocumento(it.file);
        const dup = data.duplicado || null;
        const listo = { ...it, tipoArchivo, info: data, resumen: resumenDe(data), dup, estado: dup ? 'duplicado' : 'pendiente' };
        setLoteDocs(prev => prev.map(x => x.id === it.id ? listo : x));
        if (!dup && !loteActivoRef.current && loteRef.current.some(x => x.id === it.id)) cargarEnEditor(listo);
      } catch (err) {
        setLoteDocs(prev => prev.map(x => x.id === it.id ? { ...x, estado: 'error', error: err.message } : x));
      }
    }
  }

  function seleccionarItem(id) {
    const destino = loteRef.current.find(x => x.id === id);
    if (!destino || id === loteActivoRef.current || destino.estado === 'guardado' || destino.estado === 'leyendo') return;
    const idPrevio = loteActivoRef.current, snap = { form, detalle };
    if (idPrevio) setLoteDocs(prev => prev.map(x => x.id === idPrevio ? { ...x, edits: snap } : x));
    cargarEnEditor(destino);
  }

  // Pasa al siguiente ítem por revisar (primero hacia abajo, luego desde el principio). Devuelve
  // false si no queda ninguno; si aún se están leyendo archivos, el siguiente que termine de leerse
  // queda cargado solo.
  function avanzarDocumentoLote(idActual) {
    const lista = loteRef.current;
    const i = lista.findIndex(x => x.id === idActual);
    const sig = [...lista.slice(i + 1), ...lista.slice(0, Math.max(i, 0))].find(x => x.estado === 'pendiente');
    if (sig) { cargarEnEditor(sig); return true; }
    loteActivoRef.current = null;
    setLoteDocActivoId(null);
    return false;
  }

  function saltarDocumentoActual() {
    const id = loteActivoRef.current;
    if (!id) return;
    marcarItem(id, 'saltado');
    avanzarDocumentoLote(id);
  }

  function toggleSelLote(id) {
    setConfirmandoQuitar(false);
    setLoteSel(prev => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id); else next.add(id);
      return next;
    });
  }

  // Saca del lote los documentos marcados (no toca la base de datos: solo deja de mostrarlos acá).
  // Los ya guardados no se pueden quitar. Si se quita el que se estaba editando, pasa al siguiente.
  function quitarDelLote() {
    const quitar = new Set(loteRef.current.filter(x => loteSel.has(x.id) && x.estado !== 'guardado').map(x => x.id));
    if (quitar.size === 0) return;
    const idActivo = loteActivoRef.current;
    const restantes = loteRef.current.filter(x => !quitar.has(x.id));
    setLoteDocs(restantes);
    setLoteSel(new Set());
    setConfirmandoQuitar(false);
    setConfirmandoCierre(false);
    if (idActivo && quitar.has(idActivo)) {
      const sig = restantes.find(x => x.estado === 'pendiente');
      if (sig) cargarEnEditor(sig);
      else { loteActivoRef.current = null; setLoteDocActivoId(null); }
    }
  }

  function cerrarNuevo(forzar = false) {
    const sinGuardar = loteRef.current.filter(x => (x.estado === 'pendiente' || x.estado === 'leyendo') && !esManualVirgen(x)).length;
    // Marcaste algunos y quedan otros: lo más probable es que quieras quitar solo los marcados, no todo el lote
    const marcadosQuitables = loteRef.current.filter(x => loteSel.has(x.id) && x.estado !== 'guardado').length;
    const marcablesTotal = loteRef.current.filter(x => x.estado !== 'guardado').length;
    const hayParcial = marcadosQuitables > 0 && marcablesTotal > marcadosQuitables;
    // Aviso dentro de la pantalla (no window.confirm: algunos navegadores lo bloquean y el botón parecería no responder)
    if (!forzar && (sinGuardar > 0 || hayParcial)) { setConfirmandoCierre(true); window.scrollTo({ top: 0, behavior: 'smooth' }); return; }
    setConfirmandoCierre(false);
    setLoteSel(new Set());
    setConfirmandoQuitar(false);
    setVista('lista');
    setLoteDocs([]);
    loteActivoRef.current = null;
    setLoteDocActivoId(null);
    setXmlInfo(null);
    setArchivoInfo(null);
    setErrorGuardar('');
    setForm(formVacio());
    setDetalle(detalleVacio());
    cargarDocumentos();
  }

  function agregarLinea() {
    if (form.proposito === 'gasto_servicio') {
      setDetalle([...detalle, { descripcion: '', cantidad: 1, precio_neto: '', monto_item: null }]);
    } else {
      setDetalle([...detalle, { libro_id: '', cantidad: 1, precio_neto: '', pvp: '', _isbn: '', _titulo_editado: '' }]);
    }
  }

  function actualizarLinea(i, campo, valor) {
    setDetalle(detalle.map((d, j) => {
      if (j !== i) return d;
      const updated = { ...d, [campo]: valor };
      if (campo === 'precio_neto') {
        const pn = parseFloat(valor);
        updated.pvp = pn > 0 ? Math.round(pn * 1.19) : '';
      }
      return updated;
    }));
  }

  function quitarLinea(i) {
    if (detalle.length === 1) return;
    setDetalle(detalle.filter((_, j) => j !== i));
  }

  const coloresEstado = { emitida: '#4a90d9', recibida: '#7b68ee', pagada: '#5cb85c', anulada: '#d9534f', en_recepcion: '#f39c12', parcialmente_recibida: '#f39c12', completa: '#27ae60', cerrada_incompleta: '#e67e22' };
  const etiquetaEstado = { emitida: 'emitida', recibida: 'recibida', pagada: 'pagada', anulada: 'anulada', en_recepcion: 'en recepción', parcialmente_recibida: 'parcial', completa: 'completa', cerrada_incompleta: 'incompleta' };
  const etiquetaTipo = { gdd: 'GDD', factura: 'Factura', nota_credito: 'Nota de crédito', nota_debito: 'Nota de débito' };

  // Render helpers (no hooks — llamados como funciones, no como <Componentes />)
  const docIconCircle = (tipo, size = 32) => {
    const tone = DOC_TIPO_TONE_MAP[tipo] || 'sand';
    const bg   = DOC_TONE_BG[tone]  || 'var(--past-sand)';
    const ink  = DOC_TONE_INK[tone] || 'var(--past-sand-ink)';
    const Icon = tipo === 'gdd' ? Truck : tipo === 'factura' ? Receipt : FileMinus;
    const iconSize = Math.round(size * 0.44);
    return (
      <div style={{ width: size, height: size, borderRadius: '50%', background: bg, color: ink, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
        <Icon size={iconSize} strokeWidth={1.75} />
      </div>
    );
  };
  const docEstadoPill = (estado) => {
    const s = DOC_ESTADO_PILL_STYLE[estado] || { background: 'var(--paper-stripe)', color: 'var(--ink-600)' };
    return (
      <span style={{ ...s, padding: '3px 11px', borderRadius: 999, fontSize: 12, fontWeight: 500, whiteSpace: 'nowrap', display: 'inline-flex', alignItems: 'center' }}>
        {etiquetaEstado[estado] || estado}
      </span>
    );
  };
  const docBackBtn = (onClick) => (
    <button onClick={onClick}
      style={{ width: 36, height: 36, borderRadius: '50%', border: '1px solid var(--line)', background: 'var(--paper)', color: 'var(--ink-700)', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
      <ArrowLeft size={15} strokeWidth={1.75} />
    </button>
  );

  if (cargando) return <p style={{ padding: '2rem', color: 'var(--ink-500)', fontFamily: 'var(--font-ui)' }}>Cargando...</p>;

  if (vista === 'nuevo') {
    const inputStyle = { padding: '8px 12px', width: '100%', boxSizing: 'border-box', border: '1px solid var(--line)', borderRadius: 8, fontSize: 13, fontFamily: 'inherit', color: 'var(--ink-900)', background: 'var(--paper)', outline: 'none' };
    const labelStyle = { display: 'block', fontSize: 11, fontWeight: 500, textTransform: 'uppercase', letterSpacing: '0.07em', color: 'var(--ink-500)', marginBottom: 5 };
    const etiquetaTipoLocal = { gdd: 'GDD', factura: 'Factura', nota_credito: 'Nota de crédito', nota_debito: 'Nota de débito' };
    const tipoDesdeXml = xmlInfo && !xmlInfo.error && xmlInfo.tipoDoc ? xmlInfo.tipoDoc : null;
    const opcionesProposito = PROPOSITOS_POR_TIPO[form.tipo] || [];
    const isbnsSinMatch = detalle.filter(d => d._isbn && !d._isbn_encontrado);
    const titulosConInterrogante = detalle.filter(d => d._titulo?.includes('?'));
    const fuenteDistribuidor = xmlInfo && !xmlInfo.error ? xmlInfo : (archivoInfo?.tipo_archivo === 'pdf' && !archivoInfo.error ? archivoInfo : null);
    const distribuidorDesdeXml = fuenteDistribuidor && !form.distribuidor_id
      ? (fuenteDistribuidor.distribuidor_existente
          ? null   // ya pre-poblado en form.distribuidor_id
          : fuenteDistribuidor.razonSocial || fuenteDistribuidor.rutEmisor)
      : null;
    const faltaProposito = !form.proposito;
    const faltaModalidad = !faltaProposito && modalidadAplica && !form.modalidad;
    const validacionPendiente = faltaProposito ? 'Elige un propósito.' : faltaModalidad ? 'Elige firme o consignación.' : '';

    const itemActivo = loteDocs.find(x => x.id === loteDocActivoId) || null;
    const idxActivo = itemActivo ? loteDocs.indexOf(itemActivo) : -1;
    const hayOtrosPendientes = loteDocs.some(x => x.id !== loteDocActivoId && (x.estado === 'pendiente' || x.estado === 'leyendo'));
    const cuenta = est => loteDocs.filter(x => x.estado === est).length;
    const loteTerminado = loteDocs.length > 0 && !loteDocActivoId && loteDocs.every(x => x.estado !== 'leyendo' && x.estado !== 'pendiente');
    const leyendoAlgo = loteDocs.some(x => x.estado === 'leyendo');
    const quitables = loteDocs.filter(x => loteSel.has(x.id) && x.estado !== 'guardado');
    const quitablesSinGuardar = quitables.filter(x => x.estado === 'pendiente' || x.estado === 'leyendo');
    const marcables = loteDocs.filter(x => x.estado !== 'guardado');
    const duplicados = loteDocs.filter(x => x.estado === 'duplicado');
    const hayParcial = quitables.length > 0 && marcables.length > quitables.length;
    const sinGuardarAhora = loteDocs.filter(x => (x.estado === 'pendiente' || x.estado === 'leyendo') && !esManualVirgen(x)).length;
    const estadoFila = (it, activo) => {
      if (activo) return { texto: 'Revisando…', color: 'var(--brand)' };
      if (it.estado === 'guardado') return { texto: 'Guardado', color: 'var(--ok-ink)' };
      if (it.estado === 'duplicado') return { texto: 'Ya existe · se salta', color: 'var(--warn-ink)' };
      if (it.estado === 'saltado') return { texto: 'Saltado', color: 'var(--ink-400)' };
      if (it.estado === 'error') return { texto: 'No se pudo leer', color: 'var(--bad-ink)' };
      if (it.estado === 'leyendo') return { texto: 'Leyendo…', color: 'var(--ink-500)' };
      return { texto: 'Por revisar', color: 'var(--ink-500)' };
    };
    const marcaFila = (it, activo) => {
      const base = { width: 15, height: 15, borderRadius: 4, flexShrink: 0, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: 10, fontWeight: 700 };
      if (it.estado === 'guardado') return <span style={{ ...base, background: 'var(--ok-ink)', border: '1px solid var(--ok-ink)' }}><Check size={10} strokeWidth={3} color="#fff" /></span>;
      if (activo) return <span style={{ ...base, border: '1px solid var(--brand)', background: 'var(--paper)' }}><span style={{ width: 7, height: 7, borderRadius: '50%', background: 'var(--brand)' }} /></span>;
      if (it.estado === 'duplicado') return <span style={{ ...base, background: 'var(--warn-bg)', border: '1px solid var(--warn-line)', color: 'var(--warn-ink)' }}>!</span>;
      if (it.estado === 'error') return <span style={{ ...base, background: 'var(--bad-bg)', border: '1px solid var(--bad-line)', color: 'var(--bad-ink)' }}>×</span>;
      if (it.estado === 'saltado') return <span style={{ ...base, border: '1px solid var(--line-strong)', background: 'var(--paper)', color: 'var(--ink-400)' }}>–</span>;
      if (it.estado === 'leyendo') return <span style={{ ...base, border: '1px dashed var(--line-strong)', background: 'var(--paper)' }} />;
      return <span style={{ ...base, border: '1px solid var(--line-strong)', background: 'var(--paper)' }} />;
    };
    const cardDoc = { background: 'var(--paper)', border: '1px solid var(--line)', borderRadius: 16 };
    const campoStyle = { ...inputStyle, padding: '6px 10px' };
    const etiquetaCampo = { ...labelStyle, fontSize: 10, marginBottom: 3 };

    return (
    <div
      style={{ position: 'relative' }}
      onDragEnter={e => { e.preventDefault(); setListDragDepth(d => d + 1); }}
      onDragOver={e => e.preventDefault()}
      onDragLeave={() => setListDragDepth(d => Math.max(0, d - 1))}
      onDrop={e => { e.preventDefault(); setListDragDepth(0); agregarArchivosAlLote(e.dataTransfer.files); }}
    >
      {listDragDepth > 0 && (
        <div style={{ position: 'absolute', inset: 0, zIndex: 50, background: 'rgba(250,245,228,0.88)', border: '2px dashed var(--brand)', borderRadius: 20, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 12, pointerEvents: 'none' }}>
          <div style={{ width: 56, height: 56, borderRadius: '50%', background: 'var(--brand-soft)', color: 'var(--brand)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Upload size={24} strokeWidth={1.75} />
          </div>
          <div style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 20, letterSpacing: '-0.02em', color: 'var(--brand)' }}>Suelta aquí para agregar al lote</div>
          <div style={{ fontSize: 13, color: 'var(--ink-500)' }}>XML DTE · Excel · PDF</div>
        </div>
      )}

      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 14, marginBottom: 18 }}>
        <div style={{ flex: 1 }}>
          <h1 style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 30, letterSpacing: '-0.02em', margin: 0 }}>Documentos</h1>
        </div>
        <button onClick={() => cerrarNuevo()}
          style={{ padding: '9px 18px', background: 'var(--paper)', color: 'var(--ink-700)', border: '1px solid var(--line-strong)', borderRadius: 999, cursor: 'pointer', fontSize: 13, fontWeight: 500, fontFamily: 'inherit', display: 'inline-flex', alignItems: 'center', gap: 6 }}>
          <X size={14} strokeWidth={2} /> Cerrar nuevo
        </button>
      </div>

      {confirmandoCierre && (sinGuardarAhora > 0 || hayParcial) && (
        <div style={{ background: 'var(--warn-bg)', border: '1px solid var(--warn-line)', borderRadius: 12, padding: '12px 16px', marginBottom: 16, display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
          <span style={{ fontSize: 13.5, color: 'var(--warn-ink)', flex: '1 1 260px' }}>
            {hayParcial
              ? <><strong>Marcaste {quitables.length} de {marcables.length} documentos.</strong> ¿Quitas solo los marcados o cierras todo el lote?</>
              : <><strong>Hay {sinGuardarAhora} documento{sinGuardarAhora !== 1 ? 's' : ''} sin guardar.</strong> Si cierras ahora, se descartan.</>}
          </span>
          {hayParcial && (
            <button type="button" onClick={quitarDelLote}
              style={{ padding: '8px 18px', background: 'var(--brand)', color: '#fff', border: 'none', cursor: 'pointer', borderRadius: 999, fontSize: 13, fontWeight: 500, fontFamily: 'inherit' }}>
              Quitar solo los marcados ({quitables.length})
            </button>
          )}
          <button type="button" onClick={() => cerrarNuevo(true)}
            style={hayParcial
              ? { padding: '8px 16px', background: 'var(--paper)', border: '1px solid var(--line-strong)', cursor: 'pointer', borderRadius: 999, fontSize: 13, fontFamily: 'inherit', color: 'var(--ink-700)' }
              : { padding: '8px 18px', background: 'var(--brand)', color: '#fff', border: 'none', cursor: 'pointer', borderRadius: 999, fontSize: 13, fontWeight: 500, fontFamily: 'inherit' }}>
            {hayParcial ? 'Cerrar todo el lote' : 'Descartar y cerrar'}
          </button>
          <button type="button" onClick={() => setConfirmandoCierre(false)}
            style={{ padding: '8px 16px', background: 'var(--paper)', border: '1px solid var(--line-strong)', cursor: 'pointer', borderRadius: 999, fontSize: 13, fontFamily: 'inherit', color: 'var(--ink-700)' }}>
            Seguir editando
          </button>
        </div>
      )}

      <div style={{ display: 'flex', gap: 16, alignItems: 'flex-start' }}>

        {/* ══ Panel izquierdo: el lote ═══════════════════════════════════ */}
        <div style={{ width: 340, flexShrink: 0, display: 'flex', flexDirection: 'column', gap: 10 }}>
          <div style={{ border: '1.5px dashed var(--brand-line)', background: 'var(--brand-softer)', borderRadius: 14, padding: '14px 14px', textAlign: 'center' }}>
            <input id="doc-lote-input" type="file" accept=".xml,.pdf,.xlsx,.xls" multiple style={{ display: 'none' }}
              onChange={e => { agregarArchivosAlLote(e.target.files); e.target.value = ''; }} />
            <label htmlFor="doc-lote-input" style={{ cursor: 'pointer', fontSize: 13, fontWeight: 600, color: 'var(--brand-strong)', display: 'inline-flex', alignItems: 'center', gap: 6 }}>
              <Upload size={14} strokeWidth={1.75} /> Suelta o elige archivos
            </label>
            <div style={{ fontSize: 11, color: 'var(--ink-500)', marginTop: 2 }}>XML DTE · PDF · Excel — varios a la vez</div>
            <button type="button" onClick={agregarManual}
              style={{ marginTop: 8, background: 'none', border: 'none', cursor: 'pointer', fontFamily: 'inherit', fontSize: 12, color: 'var(--ink-600)', textDecoration: 'underline', padding: 0 }}>
              o crea un documento a mano
            </button>
          </div>

          <div style={{ fontSize: 10, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.08em', color: 'var(--ink-500)', margin: '2px 2px 0' }}>
            Lote · {loteDocs.length} documento{loteDocs.length !== 1 ? 's' : ''}
          </div>
          {marcables.length > 1 && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 11.5, color: 'var(--ink-500)', padding: '0 2px' }}>
              <span>Marcar:</span>
              <button onClick={() => { setConfirmandoQuitar(false); setLoteSel(new Set(marcables.map(x => x.id))); }}
                style={{ background: 'none', border: 'none', cursor: 'pointer', fontFamily: 'inherit', fontSize: 11.5, color: 'var(--ink-700)', textDecoration: 'underline', padding: 0 }}>todos ({marcables.length})</button>
              {duplicados.length > 0 && (
                <button onClick={() => { setConfirmandoQuitar(false); setLoteSel(new Set(duplicados.map(x => x.id))); }}
                  style={{ background: 'none', border: 'none', cursor: 'pointer', fontFamily: 'inherit', fontSize: 11.5, color: 'var(--ink-700)', textDecoration: 'underline', padding: 0 }}>ya existentes ({duplicados.length})</button>
              )}
              {loteSel.size > 0 && (
                <button onClick={() => { setConfirmandoQuitar(false); setLoteSel(new Set()); }}
                  style={{ background: 'none', border: 'none', cursor: 'pointer', fontFamily: 'inherit', fontSize: 11.5, color: 'var(--ink-500)', textDecoration: 'underline', padding: 0 }}>ninguno</button>
              )}
            </div>
          )}
          <div style={{ border: '1px solid var(--line)', background: 'var(--paper)', borderRadius: 14, overflow: 'hidden' }}>
            {loteDocs.map((it, i) => {
              const activo = it.id === loteDocActivoId;
              const est = estadoFila(it, activo);
              const r = it.resumen || {};
              const numero = activo ? (form.numero || r.numero) : r.numero;
              const tipoFila = (activo ? form.tipo : r.tipo) || 'gdd';
              const clic = it.estado !== 'guardado' && it.estado !== 'leyendo';
              const marcado = loteSel.has(it.id);
              return (
                <div key={it.id} onClick={() => seleccionarItem(it.id)} title={it.dupMsg || (it.dup ? `Ya existe el documento N° ${it.dup.numero} (estado: ${it.dup.estado})` : it.error || it.nombre)}
                  style={{ display: 'flex', gap: 8, alignItems: 'center', padding: '9px 12px', borderTop: i ? '1px solid var(--line-soft)' : 'none', cursor: clic ? 'pointer' : 'default', background: activo ? 'var(--brand-softer)' : 'transparent', boxShadow: activo ? 'inset 3px 0 0 var(--brand)' : 'none' }}>
                  {it.estado !== 'guardado' ? (
                    <span onClick={e => { e.stopPropagation(); toggleSelLote(it.id); }} title="Marcar para quitar del lote"
                      style={{ width: 15, height: 15, borderRadius: 4, border: '1px solid ' + (marcado ? 'var(--brand)' : 'var(--line-strong)'), background: marcado ? 'var(--brand)' : 'var(--paper)', flexShrink: 0, cursor: 'pointer', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                      {marcado && <Check size={10} strokeWidth={3} color="#fff" />}
                    </span>
                  ) : <span style={{ width: 15, flexShrink: 0 }} />}
                  {marcaFila(it, activo)}
                  {docIconCircle(tipoFila, 26)}
                  <div style={{ minWidth: 0, flex: 1 }}>
                    <div style={{ display: 'flex', alignItems: 'baseline', gap: 6 }}>
                      <span style={{ fontSize: 12.5, fontWeight: 700, fontFamily: 'var(--font-mono)', color: 'var(--ink-900)', flexShrink: 0 }}>{numero || '—'}</span>
                      <span style={{ fontSize: 11.5, color: 'var(--ink-600)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{it.manual ? 'Documento a mano' : (r.proveedor || it.nombre)}</span>
                    </div>
                    <div style={{ fontSize: 11, color: est.color, fontWeight: 500 }}>{est.texto}</div>
                  </div>
                  <span style={{ fontSize: 12, fontWeight: 700, color: 'var(--ink-900)', flexShrink: 0 }}>{r.monto ? `$ ${Number(r.monto).toLocaleString('es-CL')}` : '—'}</span>
                </div>
              );
            })}
          </div>
          {quitables.length > 0 && (
            confirmandoQuitar ? (
              <div style={{ background: 'var(--warn-bg)', border: '1px solid var(--warn-line)', borderRadius: 10, padding: '10px 12px', display: 'flex', flexDirection: 'column', gap: 8 }}>
                <span style={{ fontSize: 12.5, color: 'var(--warn-ink)' }}>
                  {quitablesSinGuardar.length} de los marcados {quitablesSinGuardar.length !== 1 ? 'no están guardados' : 'no está guardado'}: se pierde lo que hayas editado en {quitablesSinGuardar.length !== 1 ? 'ellos' : 'él'}.
                </span>
                <div style={{ display: 'flex', gap: 8 }}>
                  <button onClick={quitarDelLote}
                    style={{ padding: '7px 14px', borderRadius: 999, border: 'none', cursor: 'pointer', fontFamily: 'inherit', fontSize: 12.5, fontWeight: 600, background: 'var(--brand)', color: '#fff' }}>
                    Sí, quitar {quitables.length}
                  </button>
                  <button onClick={() => setConfirmandoQuitar(false)}
                    style={{ padding: '7px 14px', borderRadius: 999, border: '1px solid var(--line-strong)', cursor: 'pointer', fontFamily: 'inherit', fontSize: 12.5, background: 'var(--paper)', color: 'var(--ink-700)' }}>
                    Cancelar
                  </button>
                </div>
              </div>
            ) : (
              <button onClick={() => (quitablesSinGuardar.length > 0 ? setConfirmandoQuitar(true) : quitarDelLote())}
                style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 6, padding: '9px 0', borderRadius: 10, border: '1px solid var(--bad-line)', cursor: 'pointer', fontFamily: 'inherit', fontSize: 13, fontWeight: 600, background: 'var(--paper)', color: 'var(--bad-ink)' }}>
                <X size={14} strokeWidth={2} /> Quitar del lote ({quitables.length})
              </button>
            )
          )}
          <div style={{ fontSize: 12, color: 'var(--ink-600)', padding: '0 4px' }}>
            {[
              cuenta('guardado') > 0 && `${cuenta('guardado')} guardado${cuenta('guardado') !== 1 ? 's' : ''}`,
              cuenta('duplicado') > 0 && `${cuenta('duplicado')} duplicado${cuenta('duplicado') !== 1 ? 's' : ''}`,
              cuenta('saltado') > 0 && `${cuenta('saltado')} saltado${cuenta('saltado') !== 1 ? 's' : ''}`,
              cuenta('error') > 0 && `${cuenta('error')} con error`,
              (cuenta('pendiente') + cuenta('leyendo')) > 0 && `${cuenta('pendiente') + cuenta('leyendo')} por revisar`,
            ].filter(Boolean).join(' · ')}
          </div>
        </div>

        {/* ══ Panel derecho: el editor del documento en curso ═════════════ */}
        <div style={{ flex: 1, minWidth: 0 }}>
          {itemActivo ? (
            <div style={cardDoc}>
              {(() => {
                const nombreDist = esGasto
                  ? (form.proveedor_nombre || '')
                  : (distribuidores.find(d => d.id === form.distribuidor_id)?.nombre || distribuidorDesdeXml || '');
                const titulo = `${etiquetaTipoLocal[form.tipo] || 'Documento'} · ${form.numero || 'sin número'} · ${nombreDist || (esGasto ? 'Sin proveedor' : 'Sin distribuidor')}`;
                const chipLeido = { padding: '2px 10px', borderRadius: 999, fontSize: 12, fontWeight: 500, background: 'var(--ok-bg)', color: 'var(--ok-ink)', whiteSpace: 'nowrap' };
                return (
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '12px 18px', borderBottom: '1px solid var(--line)' }}>
                {docIconCircle(form.tipo, 36)}
                <div style={{ minWidth: 0, flex: 1 }}>
                  <div title={titulo} style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 17, letterSpacing: '-0.02em', lineHeight: 1.15, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {titulo}
                  </div>
                  <div style={{ fontSize: 11, color: 'var(--ink-400)', marginTop: 3, fontFamily: 'var(--font-mono)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {loteDocs.length > 1 ? `Documento ${idxActivo + 1} de ${loteDocs.length}` : 'Documento nuevo'}
                    {!itemActivo.manual && ` · ${itemActivo.nombre}`}
                  </div>
                </div>
                <div style={{ display: 'flex', gap: 6, alignItems: 'center', flexShrink: 0 }}>
                  {form.fecha && (
                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5, padding: '2px 10px', borderRadius: 999, fontSize: 12, border: '1px solid var(--line-strong)', color: 'var(--ink-800)', whiteSpace: 'nowrap' }}>
                      <CalendarDays size={12} strokeWidth={1.75} /> {fmtDocFecha(form.fecha)}
                    </span>
                  )}
                  {xmlInfo && !xmlInfo.error && <span style={chipLeido}>XML procesado</span>}
                  {archivoInfo?.tipo_archivo === 'pdf' && !archivoInfo.error && <span style={chipLeido}>PDF leído</span>}
                  {archivoInfo?.tipo_archivo === 'excel' && !archivoInfo.error && <span style={chipLeido}>Excel leído</span>}
                  {xmlInfo?.esExenta && <span style={{ padding: '2px 10px', borderRadius: 999, fontSize: 12, fontWeight: 600, background: 'var(--warn-bg)', color: 'var(--warn-ink)', border: '1px solid var(--warn-line)', whiteSpace: 'nowrap' }}>Exenta de IVA</span>}
                  {(xmlInfo?.mntTotal || archivoInfo?.mntTotal) && <span style={{ fontWeight: 700, color: 'var(--ink-800)', fontSize: 14, whiteSpace: 'nowrap' }}>$ {Number(xmlInfo?.mntTotal || archivoInfo?.mntTotal).toLocaleString('es-CL')}</span>}
                </div>
              </div>
                );
              })()}

              <div style={{ padding: '12px 18px 18px' }}>
                {itemActivo.estado === 'duplicado' && (
                  <AvisoDoc tono="warn">
                    <strong>Ya está ingresado.</strong>{' '}
                    {itemActivo.dup
                      ? `N° ${itemActivo.dup.numero}${itemActivo.dup.distribuidor_nombre ? `, ${itemActivo.dup.distribuidor_nombre}` : ''} (estado: ${itemActivo.dup.estado}).`
                      : (itemActivo.dupMsg || '')}{' '}
                    Se salta salvo que cambies el número o el distribuidor.
                  </AvisoDoc>
                )}
                {itemActivo.estado === 'error' && (
                  <AvisoDoc tono="bad">
                    <strong>No se pudo leer «{itemActivo.nombre}».</strong> {itemActivo.error} Completa los datos a mano o sáltalo.
                  </AvisoDoc>
                )}
                {archivoInfo?.tipo_archivo === 'excel' && (
                  archivoInfo.lineas?.length > 0
                    ? <AvisoDoc tono="ok"><strong>Excel</strong> · {archivoInfo.lineas.length} línea{archivoInfo.lineas.length !== 1 ? 's' : ''}{archivoInfo.numero ? ` · N° ${archivoInfo.numero}` : ''}</AvisoDoc>
                    : <AvisoDoc tono="warn">No se pudieron extraer líneas — revisa los encabezados o carga los datos manualmente.</AvisoDoc>
                )}
                {archivoInfo?.tipo_archivo === 'pdf' && !(archivoInfo.lineas?.length > 0) && (
                  <AvisoDoc tono="neutro">No se reconocieron líneas en el PDF — completa los datos manualmente.</AvisoDoc>
                )}
                {titulosConInterrogante.length > 0 && (
                  <AvisoDoc tono="warn">Títulos con caracteres dudosos (?) — revísalos y corrígelos antes de guardar.</AvisoDoc>
                )}
                {isbnsSinMatch.length > 0 && !esGasto && (
                  <AvisoDoc tono="warn">
                    <strong>{isbnsSinMatch.length} libro{isbnsSinMatch.length !== 1 ? 's' : ''} nuevo{isbnsSinMatch.length !== 1 ? 's' : ''}</strong> — se crearán al guardar (ISBN {isbnsSinMatch.map(d => d._isbn).join(', ')}). Edita el título si hace falta.
                  </AvisoDoc>
                )}

                <form onSubmit={guardarDocumento}>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(170px, 1fr))', gap: '10px 12px', marginBottom: 16 }}>
                    <div>
                      <label style={etiquetaCampo}>Tipo de documento</label>
                      {tipoDesdeXml ? (
                        <div style={{ ...campoStyle, background: 'var(--paper-stripe)', color: 'var(--ink-700)', display: 'flex', alignItems: 'center', gap: 6, whiteSpace: 'nowrap' }}>
                          <Check size={12} strokeWidth={2.5} style={{ color: 'var(--ok-ink)', flexShrink: 0 }} />
                          {etiquetaTipoLocal[tipoDesdeXml] || tipoDesdeXml}
                          <span style={{ fontSize: 10, color: 'var(--ink-400)', marginLeft: 2 }}>del XML</span>
                        </div>
                      ) : (
                        <select value={form.tipo} onChange={e => onTipoChange(e.target.value)} style={campoStyle}>
                          <option value="gdd">GDD</option>
                          <option value="factura">Factura</option>
                          <option value="nota_credito">Nota de crédito</option>
                          <option value="nota_debito">Nota de débito</option>
                        </select>
                      )}
                    </div>
                    <div>
                      <label style={etiquetaCampo}>Propósito *</label>
                      <select value={form.proposito} onChange={e => onPropositoChange(e.target.value)}
                        style={{ ...campoStyle, color: form.proposito ? 'var(--ink-900)' : 'var(--ink-400)' }}>
                        <option value="" disabled>Elige un propósito</option>
                        {opcionesProposito.map(p => <option key={p} value={p}>{etiquetaPropositoLocal[p]}</option>)}
                      </select>
                    </div>
                    {!esGasto && (
                      <div>
                        <label style={etiquetaCampo}>Distribuidor</label>
                        <select value={form.distribuidor_id} onChange={e => { setForm({ ...form, distribuidor_id: e.target.value }); setErrorGuardar(''); }} style={campoStyle}
                          title={distribuidorDesdeXml && !form.distribuidor_id ? `Se creará «${distribuidorDesdeXml}» al guardar` : undefined}>
                          <option value="">{distribuidorDesdeXml ? `Nuevo: ${distribuidorDesdeXml}` : 'Sin distribuidor'}</option>
                          {distribuidores.map(d => <option key={d.id} value={d.id}>{d.nombre}</option>)}
                        </select>
                      </div>
                    )}
                    {esGasto && (
                      <div>
                        <label style={etiquetaCampo}>Proveedor</label>
                        <input value={form.proveedor_nombre} onChange={e => setForm({ ...form, proveedor_nombre: e.target.value })} placeholder="Nombre del proveedor" style={campoStyle} />
                      </div>
                    )}
                    {esGasto && (
                      <div>
                        <label style={etiquetaCampo}>RUT proveedor</label>
                        <input value={form.proveedor_rut} onChange={e => setForm({ ...form, proveedor_rut: e.target.value })} placeholder="Ej. 96625000K" style={{ ...campoStyle, fontFamily: 'var(--font-mono)' }} />
                      </div>
                    )}
                    <div>
                      <label style={etiquetaCampo}>Número</label>
                      <input value={form.numero} onChange={e => { setForm({ ...form, numero: e.target.value }); setErrorGuardar(''); }} style={campoStyle} />
                    </div>
                    {modalidadAplica && (
                      <div>
                        <label style={etiquetaCampo}>Modalidad *</label>
                        <div style={{ display: 'flex', gap: 6 }}>
                          {[['firme', 'Firme'], ['consignacion', 'Consignación']].map(([val, etiqueta]) => (
                            <button key={val} type="button" onClick={() => setForm({ ...form, modalidad: val })}
                              style={{ flex: 1, minWidth: 0, padding: '6px 4px', borderRadius: 8, cursor: 'pointer', fontSize: 12, fontFamily: 'inherit', fontWeight: 600, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
                                border: '1px solid ' + (form.modalidad === val ? 'var(--brand)' : 'var(--line)'),
                                background: form.modalidad === val ? 'var(--brand-softer)' : 'var(--paper)',
                                color: form.modalidad === val ? 'var(--brand)' : 'var(--ink-600)' }}>
                              {etiqueta}
                            </button>
                          ))}
                        </div>
                      </div>
                    )}
                    <div>
                      <label style={etiquetaCampo}>Fecha</label>
                      <input type="date" value={form.fecha} onChange={e => setForm({ ...form, fecha: e.target.value })} style={campoStyle} />
                    </div>
                    <div style={{ gridColumn: 'span 2' }}>
                      <label style={etiquetaCampo}>Notas</label>
                      <input value={form.notas} onChange={e => setForm({ ...form, notas: e.target.value })} style={campoStyle} />
                    </div>
                  </div>

                  <div style={{ fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.08em', color: 'var(--ink-500)', marginBottom: 10 }}>Detalle · {detalle.length} línea{detalle.length !== 1 ? 's' : ''}</div>
                  <div style={{ border: '1px solid var(--line)', borderRadius: 12, overflowX: 'auto', overflowY: 'hidden', marginBottom: 12 }}>
                    <style>{`
                      .doc-tip:hover::after { content: attr(data-tip); position: absolute; bottom: calc(100% + 6px); right: -4px; background: var(--ink-900); color: #fff; font-size: 11.5px; line-height: 1.3; padding: 4px 10px; border-radius: 8px; white-space: nowrap; z-index: 30; pointer-events: none; font-weight: 400; }
                    `}</style>
                    <table style={{ width: '100%', minWidth: form.proposito === 'gasto_servicio' ? 0 : 640, borderCollapse: 'collapse', fontSize: 13, tableLayout: form.proposito === 'gasto_servicio' ? 'auto' : 'fixed' }}>
                      {form.proposito !== 'gasto_servicio' && (
                        <colgroup>
                          <col style={{ width: 164 }} />
                          <col />
                          <col style={{ width: 76 }} />
                          <col style={{ width: 104 }} />
                          <col style={{ width: 104 }} />
                          <col style={{ width: 36 }} />
                        </colgroup>
                      )}
                      <thead>
                        <tr style={{ background: 'var(--paper-stripe)' }}>
                          {form.proposito === 'gasto_servicio' ? (() => {
                            const esExenta = detalle[0]?._exenta || false;
                            return (
                            <>
                              <th style={{ ...DOC_TH, paddingLeft: 14 }}>Descripción</th>
                              <th style={{ ...DOC_TH, width: 80, textAlign: 'right' }}>Cant.</th>
                              {!esExenta && <th style={{ ...DOC_TH, width: 130, textAlign: 'right' }}>Valor neto</th>}
                              <th style={{ ...DOC_TH, width: 150, textAlign: 'right', paddingRight: 14 }}>{esExenta ? 'Valor total (exento)' : 'Total c/IVA'}</th>
                            </>
                            );
                          })() : (
                            <>
                              <th style={{ ...DOC_TH, padding: '10px 8px 10px 14px' }}>ISBN</th>
                              <th style={{ ...DOC_TH, padding: '10px 8px' }}>Libro</th>
                              <th style={{ ...DOC_TH, padding: '10px 8px' }}>Cant.</th>
                              <th style={{ ...DOC_TH, padding: '10px 8px' }}>Precio neto</th>
                              <th style={{ ...DOC_TH, padding: '10px 8px' }}>PVP</th>
                              <th></th>
                            </>
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {detalle.map((linea, i) => (
                          form.proposito === 'gasto_servicio' ? (
                            (() => {
                              const esExenta = linea._exenta || false;
                              const pn = linea.precio_neto !== '' && linea.precio_neto != null ? Number(linea.precio_neto) : (linea.monto_item != null ? Number(linea.monto_item) : null);
                              const total = pn != null ? (esExenta ? pn : Math.round(pn * 1.19)) : null;
                              return (
                            <tr key={i} style={{ borderTop: '1px solid var(--line-soft)' }}>
                              <td style={{ ...DOC_TD, paddingLeft: 14, color: 'var(--ink-800)' }}>{linea.descripcion || '—'}</td>
                              <td style={{ ...DOC_TD, textAlign: 'right', fontVariantNumeric: 'tabular-nums' }}>{linea.cantidad}</td>
                              {!esExenta && (
                                <td style={{ ...DOC_TD, textAlign: 'right', fontVariantNumeric: 'tabular-nums' }}>{pn != null ? `$ ${pn.toLocaleString('es-CL')}` : '—'}</td>
                              )}
                              <td style={{ ...DOC_TD, textAlign: 'right', paddingRight: 14 }}>
                                <span style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 15, letterSpacing: '-0.01em', fontVariantNumeric: 'tabular-nums' }}>
                                  {total != null ? `$ ${total.toLocaleString('es-CL')}` : '—'}
                                </span>
                              </td>
                            </tr>
                              );
                            })()
                          ) : (
                            <tr key={i} style={{ borderTop: '1px solid var(--line-soft)', background: linea._libro_nuevo ? 'var(--warn-bg)' : 'transparent' }}>
                              <td style={{ ...DOC_TD, padding: '10px 8px 10px 14px', verticalAlign: 'top' }}>
                                <input value={linea._isbn || ''} placeholder="ISBN" title={linea._isbn || ''} onChange={e => actualizarLinea(i, '_isbn', e.target.value)}
                                  style={{ ...inputStyle, fontFamily: 'var(--font-mono)', fontSize: 12.5, width: '100%', padding: '8px 8px' }} />
                              </td>
                              <td style={{ ...DOC_TD, padding: '10px 8px', verticalAlign: 'top' }}>
                                <div style={{ position: 'relative' }}>
                                {(linea._libro_nuevo || linea._titulo) && (
                                  <span className="doc-tip" data-tip={linea._libro_nuevo ? 'Libro nuevo — se creará al guardar' : 'En inventario'}
                                    role="img" aria-label={linea._libro_nuevo ? 'Libro nuevo, se creará al guardar' : 'En inventario'}
                                    style={{ position: 'absolute', top: 7, right: 8, zIndex: 1, width: 20, height: 20, borderRadius: '50%', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', background: linea._libro_nuevo ? 'var(--warn-ink)' : 'var(--ok-bg)', color: linea._libro_nuevo ? '#fff' : 'var(--ok-ink)' }}>
                                    {linea._libro_nuevo ? <Sparkles size={12} strokeWidth={2} /> : <Check size={12} strokeWidth={2.5} />}
                                  </span>
                                )}
                                <textarea rows={1} value={linea._titulo_editado || linea._titulo || ''} placeholder="Título del libro"
                                  onChange={e => actualizarLinea(i, '_titulo_editado', e.target.value)}
                                  onKeyDown={e => { if (e.key === 'Enter') e.preventDefault(); }}
                                  ref={el => { if (el) { const borde = el.offsetHeight - el.clientHeight; el.style.height = 'auto'; el.style.height = (el.scrollHeight + borde) + 'px'; for (let k = 0; k < 3 && el.scrollHeight > el.clientHeight + 1; k++) el.style.height = (el.scrollHeight + borde) + 'px'; } }}
                                  style={{ ...inputStyle, display: 'block', width: '100%', resize: 'none', overflow: 'hidden', lineHeight: 1.35, paddingRight: (linea._libro_nuevo || linea._titulo) ? 36 : undefined }} />
                                </div>
                              </td>
                              <td style={{ ...DOC_TD, padding: '10px 8px', verticalAlign: 'top' }}>
                                <input type="number" min="1" value={linea.cantidad} onChange={e => actualizarLinea(i, 'cantidad', e.target.value)} style={{ ...inputStyle, width: '100%', padding: '8px 8px' }} />
                              </td>
                              <td style={{ ...DOC_TD, padding: '10px 8px', verticalAlign: 'top' }}>
                                <input type="number" min="0" step="0.01" placeholder="0" value={linea.precio_neto} onChange={e => actualizarLinea(i, 'precio_neto', e.target.value)} style={{ ...inputStyle, width: '100%', padding: '8px 8px' }} />
                              </td>
                              <td style={{ ...DOC_TD, padding: '10px 8px', verticalAlign: 'top' }}>
                                <input type="number" min="0" step="0.01" placeholder="0" value={linea.pvp} onChange={e => actualizarLinea(i, 'pvp', e.target.value)} style={{ ...inputStyle, width: '100%', padding: '8px 8px' }} />
                              </td>
                              <td style={{ ...DOC_TD, padding: '10px 4px', textAlign: 'center', verticalAlign: 'top' }}>
                                <button type="button" onClick={() => quitarLinea(i)} disabled={detalle.length === 1} style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--ink-400)', fontSize: 18, lineHeight: 1, padding: '6px 2px' }}>×</button>
                              </td>
                            </tr>
                          )
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <button type="button" onClick={agregarLinea}
                    style={{ background: 'transparent', border: '1px dashed var(--line-strong)', padding: '7px 16px', cursor: 'pointer', borderRadius: 999, color: 'var(--ink-600)', fontSize: 13, fontFamily: 'inherit', margin: '10px 0 18px', display: 'inline-flex', alignItems: 'center', gap: 5 }}>
                    <Plus size={13} strokeWidth={2} /> Agregar línea
                  </button>
                  {errorGuardar && (
                    <div style={{ background: 'var(--bad-bg)', border: '1px solid var(--bad-line)', borderRadius: 10, padding: '10px 14px', marginBottom: 14, fontSize: 13 }}>
                      <strong style={{ color: 'var(--bad-ink)' }}>No se puede guardar.</strong> <span style={{ color: 'var(--bad-ink)' }}>{errorGuardar}</span>
                    </div>
                  )}
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                    <button type="submit" disabled={guardando || !!errorGuardar || !!validacionPendiente}
                      style={{ padding: '9px 20px', background: 'var(--brand)', color: '#fff', border: 'none', cursor: (guardando || errorGuardar || validacionPendiente) ? 'not-allowed' : 'pointer', borderRadius: 999, fontSize: 13, fontWeight: 500, fontFamily: 'inherit', opacity: (errorGuardar || validacionPendiente) ? 0.5 : 1 }}>
                      {guardando ? 'Guardando...' : (hayOtrosPendientes ? 'Guardar y siguiente' : 'Guardar documento')}
                    </button>
                    {loteDocs.length > 1 && (
                      <button type="button" onClick={saltarDocumentoActual} disabled={guardando}
                        style={{ padding: '9px 18px', background: 'transparent', border: '1px solid var(--line)', cursor: guardando ? 'not-allowed' : 'pointer', borderRadius: 999, fontSize: 13, fontFamily: 'inherit', color: 'var(--ink-700)' }}>
                        Saltar
                      </button>
                    )}
                    {validacionPendiente && <span style={{ fontSize: 12, color: 'var(--warn-ink)' }}>{validacionPendiente}</span>}
                    {loteDocs.length > 1 && <span style={{ marginLeft: 'auto', fontSize: 12, color: 'var(--ink-400)' }}>Toca otro documento de la lista para cambiar</span>}
                  </div>
                </form>
              </div>
            </div>
          ) : loteTerminado ? (
            <div style={{ ...cardDoc, padding: '24px 22px' }}>
              <div style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 20, letterSpacing: '-0.02em', marginBottom: 6 }}>{cuenta('guardado') > 0 ? 'Documentos ingresados con éxito' : 'Lote terminado'}</div>
              <div style={{ fontSize: 13.5, color: 'var(--ink-600)', marginBottom: 14 }}>
                {cuenta('guardado')} documento{cuenta('guardado') !== 1 ? 's' : ''} guardado{cuenta('guardado') !== 1 ? 's' : ''}
                {cuenta('duplicado') > 0 && ` · ${cuenta('duplicado')} ya existía${cuenta('duplicado') !== 1 ? 'n' : ''}`}
                {cuenta('saltado') > 0 && ` · ${cuenta('saltado')} saltado${cuenta('saltado') !== 1 ? 's' : ''}`}
                {cuenta('error') > 0 && ` · ${cuenta('error')} con error`}.
              </div>
              {loteDocs.filter(x => x.estado === 'duplicado' || x.estado === 'error').map(x => (
                <div key={x.id} style={{ fontSize: 12.5, color: x.estado === 'error' ? 'var(--bad-ink)' : 'var(--warn-ink)', marginBottom: 6 }}>
                  <strong>{x.resumen?.numero || x.nombre}</strong> — {x.estado === 'error' ? x.error : (x.dupMsg || (x.dup ? `ya existe el N° ${x.dup.numero} (estado: ${x.dup.estado})` : 'ya existía'))}
                </div>
              ))}
              <div style={{ display: 'flex', gap: 10, marginTop: 16 }}>
                <label htmlFor="doc-lote-input"
                  style={{ padding: '9px 20px', background: 'var(--brand)', color: '#fff', cursor: 'pointer', borderRadius: 999, fontSize: 13, fontWeight: 500, fontFamily: 'inherit', display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                  <Plus size={14} strokeWidth={2} /> Agregar otros documentos
                </label>
                <button type="button" onClick={() => cerrarNuevo(true)}
                  style={{ padding: '9px 18px', background: 'transparent', border: '1px solid var(--line)', cursor: 'pointer', borderRadius: 999, fontSize: 13, fontFamily: 'inherit', color: 'var(--ink-700)' }}>
                  Volver
                </button>
              </div>
            </div>
          ) : (
            <div style={{ ...cardDoc, padding: '40px 22px', textAlign: 'center', color: 'var(--ink-500)', fontSize: 13.5 }}>
              {leyendoAlgo ? 'Leyendo los archivos…' : loteDocs.length === 0 ? 'El lote está vacío. Suelta archivos o crea un documento a mano.' : 'Elige un documento de la lista para revisarlo.'}
            </div>
          )}
        </div>
      </div>
    </div>
    );
  }

  if (vista === 'recepcion' && seleccionado) {
    const esFactura = seleccionado.tipo === 'factura';
    // GDD: validar factor descuento editorial
    const pctNum = Number(factorDescuento);
    const factorValido = factorDescuento !== '' && !isNaN(pctNum) && pctNum > 0 && pctNum < 100;
    const factorEfectivo = factorValido ? (100 - pctNum) / 100 : null;
    const factorPagoOriginal = Number(seleccionado.distribuidor_factor_pago || 0);
    const sinFactorConfigurado = factorPagoOriginal === 0;
    const hayPreciosNeto = recepcionLineas.some(l => l.precio_neto != null && Number(l.precio_neto) > 0);
    const btnDisabled = confirmando || (!esFactura && !factorValido);

    return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16, flexWrap: 'wrap' }}>
        {docBackBtn(() => setVista('detalle'))}
        {docIconCircle('gdd', 40)}
        <h1 style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 28, letterSpacing: '-0.02em', margin: 0 }}>
          Recepción · {etiquetaTipo[seleccionado.tipo] || seleccionado.tipo}{seleccionado.numero ? ` ${seleccionado.numero}` : ''}
        </h1>
      </div>
      <p style={{ color: 'var(--ink-500)', fontSize: 13, margin: '0 0 18px', maxWidth: 620, lineHeight: 1.5 }}>
        Confirmá las cantidades realmente recibidas. Podés ajustar si llegaron menos ejemplares de los esperados.
      </p>

      {/* Descuento: editable para GDD, solo informativo para facturas */}
      {esFactura ? (
        <div style={{ marginBottom: 18, padding: '12px 16px', background: 'var(--paper-soft)', border: '1px solid var(--line)', borderRadius: 12, fontSize: 13, color: 'var(--ink-600)' }}>
          <strong style={{ color: 'var(--ink-800)' }}>Factura SII</strong> — el costo por unidad se calcula a partir del monto neto facturado por línea (monto_item ÷ cantidad × 1,19).
        </div>
      ) : (
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20, padding: '14px 18px', background: sinFactorConfigurado ? 'var(--warn-bg)' : 'var(--paper-soft)', border: '1px solid ' + (sinFactorConfigurado ? 'var(--warn-line)' : 'var(--line)'), borderRadius: 12 }}>
          <div style={{ flex: '0 0 auto' }}>
            <label style={{ fontSize: 13, fontWeight: 600, color: 'var(--ink-800)', display: 'block', marginBottom: 4 }}>
              Descuento editorial (%)
            </label>
            {sinFactorConfigurado && (
              <div style={{ fontSize: 11, color: 'var(--warn-ink)', marginBottom: 6 }}>
                ⚠ Este distribuidor no tiene descuento configurado — ingresalo para continuar.
              </div>
            )}
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <input
                type="number" min="0" max="100" step="1"
                value={factorDescuento}
                onChange={e => setFactorDescuento(e.target.value)}
                placeholder="ej. 40"
                style={{ width: 80, height: 36, borderRadius: 8, border: '1px solid ' + (!factorValido && factorDescuento !== '' ? 'var(--bad-line)' : 'var(--line)'), padding: '0 10px', fontSize: 14, fontFamily: 'inherit', textAlign: 'right', background: 'var(--paper)', color: 'var(--ink-900)' }}
              />
              <span style={{ fontSize: 13, color: 'var(--ink-600)' }}>%</span>
              {factorEfectivo !== null && (
                <span style={{ fontSize: 12, color: 'var(--ink-500)', marginLeft: 4 }}>
                  → factor {factorEfectivo.toFixed(4)} &nbsp;·&nbsp; el distribuidor se queda con el {Math.round(factorEfectivo * 100)} % del precio con IVA
                </span>
              )}
            </div>
          </div>
          {!factorValido && (
            <span style={{ fontSize: 12, color: 'var(--bad-ink)', marginLeft: 4 }}>
              {factorDescuento === '' ? 'Requerido para recepcionar' : 'Debe ser mayor a 0 y menor a 100'}
            </span>
          )}
        </div>
      )}

      <div style={{ border: '1px solid var(--line)', borderRadius: 16, overflow: 'hidden', marginBottom: 24 }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
          <thead>
            <tr style={{ background: 'var(--paper-stripe)' }}>
              <th style={{ ...DOC_TH, width: 36, paddingLeft: 18, paddingRight: 0 }}></th>
              <th style={{ ...DOC_TH, paddingLeft: 12 }}>Libro</th>
              <th style={{ ...DOC_TH, textAlign: 'right' }}>PVP</th>
              {(hayPreciosNeto || esFactura) && <th style={{ ...DOC_TH, textAlign: 'right' }}>Costo unitario</th>}
              <th style={{ ...DOC_TH, textAlign: 'center' }}>Esperados</th>
              <th style={{ ...DOC_TH, textAlign: 'center' }}>Recibidos</th>
              <th style={{ ...DOC_TH, textAlign: 'center', paddingRight: 18 }}>Diferencia</th>
            </tr>
          </thead>
          <tbody>
            {recepcionLineas.map((linea, i) => {
              const yaIngresado = linea.parcialmente_recibido;
              const diff = Number(linea.cantidad_recibida) - linea.cantidad_esperada;
              let costoUnitario = null;
              let sinMonto = false;
              if (esFactura) {
                const mi = linea.monto_item != null ? Number(linea.monto_item) : null;
                const cant = linea.cantidad || linea.cantidad_esperada || 1;
                if (mi && mi > 0) costoUnitario = Math.round((mi / cant) * 1.19);
                else sinMonto = true;
              } else if (linea.precio_neto != null && Number(linea.precio_neto) > 0 && factorEfectivo !== null) {
                costoUnitario = Math.round(Number(linea.precio_neto) * 1.19 * factorEfectivo);
              }
              return (
                <tr key={linea.detalle_id} style={{ borderTop: '1px solid var(--line-soft)', background: yaIngresado ? 'var(--ok-bg)' : linea.revisado ? 'var(--brand-softer,#f5f3ff)' : 'transparent', transition: 'background var(--t-fast)', opacity: yaIngresado ? 0.7 : 1 }}>
                  <td style={{ ...DOC_TD, paddingLeft: 18, paddingRight: 0, textAlign: 'center', width: 36 }}>
                    {yaIngresado
                      ? <span style={{ color: 'var(--ok-ink)', fontSize: 18, lineHeight: 1 }}>✓</span>
                      : <input
                          type="checkbox"
                          checked={linea.revisado}
                          onChange={e => setRecepcionLineas(recepcionLineas.map((l, j) => j === i ? { ...l, revisado: e.target.checked } : l))}
                          style={{ width: 16, height: 16, cursor: 'pointer', accentColor: 'var(--ok-ink)' }}
                        />
                    }
                  </td>
                  <td style={{ ...DOC_TD, paddingLeft: 12 }}>
                    <div style={{ fontSize: 13.5, fontWeight: 600 }}>{linea.titulo}</div>
                    <div style={{ fontSize: 11, color: 'var(--ink-500)' }}>{linea.autor}</div>
                    {yaIngresado && <div style={{ fontSize: 11, color: 'var(--ok-ink)', fontWeight: 500, marginTop: 2 }}>Ya ingresado al sistema</div>}
                    {sinMonto && !yaIngresado && <div style={{ fontSize: 11, color: 'var(--bad-ink)', marginTop: 3 }}>⚠ Sin monto_item — lote no se creará</div>}
                  </td>
                  <td style={{ ...DOC_TD, textAlign: 'right', color: 'var(--ink-700)', fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap' }}>
                    {linea.pvp ? `$ ${Number(linea.pvp).toLocaleString('es-CL')}` : <span style={{ color: 'var(--ink-300)' }}>—</span>}
                  </td>
                  {(hayPreciosNeto || esFactura) && (
                    <td style={{ ...DOC_TD, textAlign: 'right', fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap', color: costoUnitario != null ? 'var(--ink-800)' : 'var(--ink-300)', fontFamily: 'var(--font-mono)', fontSize: 12 }}>
                      {costoUnitario != null ? `$ ${costoUnitario.toLocaleString('es-CL')}` : sinMonto ? <span style={{ color: 'var(--bad-ink)', fontSize: 11 }}>sin monto</span> : '—'}
                      {esFactura && linea.descuento_pct != null && costoUnitario != null && (
                        <div style={{ fontSize: 10, color: 'var(--ink-400)', marginTop: 2 }}>Dcto {linea.descuento_pct}%</div>
                      )}
                    </td>
                  )}
                  <td style={{ ...DOC_TD, textAlign: 'center', color: 'var(--ink-600)', fontVariantNumeric: 'tabular-nums' }}>{linea.cantidad_esperada}</td>
                  <td style={{ ...DOC_TD, textAlign: 'center' }}>
                    {yaIngresado
                      ? <span style={{ fontWeight: 600, color: 'var(--ok-ink)', fontVariantNumeric: 'tabular-nums' }}>{linea.cantidad_recibida}</span>
                      : <input
                          type="number" min="0" max={linea.cantidad_esperada}
                          value={linea.cantidad_recibida}
                          onChange={e => setRecepcionLineas(recepcionLineas.map((l, j) => j === i ? { ...l, cantidad_recibida: e.target.value } : l))}
                          style={{
                            width: 64, height: 34, borderRadius: 999, textAlign: 'center',
                            border: '1px solid ' + (diff < 0 ? 'var(--bad-line)' : 'var(--line)'),
                            background: diff < 0 ? 'var(--bad-bg)' : 'var(--paper)',
                            color: 'var(--ink-900)', fontWeight: 600, fontVariantNumeric: 'tabular-nums',
                            outline: 'none', fontFamily: 'inherit', fontSize: 14,
                          }}
                        />
                    }
                  </td>
                  <td style={{ ...DOC_TD, textAlign: 'center', paddingRight: 18 }}>
                    {diff === 0
                      ? <span style={{ color: 'var(--ink-400)' }}>—</span>
                      : <span style={{ padding: '3px 11px', borderRadius: 999, fontSize: 12, fontWeight: 500, background: diff < 0 ? 'var(--bad-bg)' : 'var(--ok-bg)', color: diff < 0 ? 'var(--bad-ink)' : 'var(--ok-ink)' }}>
                          {diff > 0 ? `+${diff}` : diff}
                        </span>}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {(() => {
        const haySeleccionados = recepcionLineas.some(l => l.revisado && !l.parcialmente_recibido);
        const hayPendientes    = recepcionLineas.some(l => !l.parcialmente_recibido);
        const hayYaIngresados  = recepcionLineas.some(l => l.parcialmente_recibido);
        return (
          <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
            <button onClick={() => confirmarRecepcion('parcial')}
              disabled={btnDisabled || !haySeleccionados}
              style={{ padding: '10px 20px', background: 'var(--brand)', color: '#fff', border: 'none', borderRadius: 999, cursor: (btnDisabled || !haySeleccionados) ? 'not-allowed' : 'pointer', opacity: (btnDisabled || !haySeleccionados) ? 0.5 : 1, fontSize: 13, fontWeight: 500, fontFamily: 'inherit', display: 'inline-flex', alignItems: 'center', gap: 6 }}>
              <PackageCheck size={14} strokeWidth={1.75} />
              {confirmando ? 'Ingresando...' : 'Ingresar seleccionados'}
            </button>
            {(hayYaIngresados || !hayPendientes) && (
              <button onClick={() => confirmarRecepcion('completa')} disabled={btnDisabled}
                style={{ padding: '10px 20px', background: 'var(--ok-bg)', color: 'var(--ok-ink)', border: '1px solid var(--ok-line)', borderRadius: 999, cursor: btnDisabled ? 'not-allowed' : 'pointer', opacity: btnDisabled ? 0.6 : 1, fontSize: 13, fontWeight: 500, fontFamily: 'inherit', display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                <PackageCheck size={14} strokeWidth={1.75} />
                {confirmando ? 'Procesando...' : 'Confirmar recepción completa'}
              </button>
            )}
            <button onClick={() => confirmarRecepcion('incompleta')} disabled={btnDisabled}
              style={{ padding: '10px 20px', background: 'none', color: 'var(--ink-500)', border: '1px solid var(--line)', borderRadius: 999, cursor: btnDisabled ? 'not-allowed' : 'pointer', opacity: btnDisabled ? 0.6 : 1, fontSize: 13, fontWeight: 500, fontFamily: 'inherit' }}>
              {confirmando ? 'Procesando...' : 'Cerrar definitivo'}
            </button>
          </div>
        );
      })()}
    </div>
    );
  }

  if (vista === 'detalle' && seleccionado) {
    const total = (seleccionado.detalle || []).reduce((sum, d) => {
      const subtotal = d.monto_item != null
        ? Number(d.monto_item)
        : d.cantidad * Number(d.precio_neto || 0);
      return sum + subtotal;
    }, 0);
    const esGdd = seleccionado.tipo === 'gdd';
    const esIngreso = seleccionado.proposito === 'ingreso_mercaderia';
    const esGastoDoc = seleccionado.proposito === 'gasto_servicio';
    const soloRegistro = seleccionado.proposito === 'cobro_consignacion' || seleccionado.proposito === 'otro' || esGastoDoc;
    const etiquetaProposito = { ingreso_mercaderia: 'Ingreso de mercadería', cobro_consignacion: 'Liquidación de consignación', otro: 'Ajuste o corrección', gasto_servicio: 'Gasto o servicio' };
    return (
      <div>
        {/* Header */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16, flexWrap: 'wrap' }}>
          {docBackBtn(() => { setVista('lista'); setLotesCreados([]); })}
          {docIconCircle(seleccionado.tipo, 36)}
          {(() => {
            const nombreDoc = seleccionado.distribuidor_nombre || seleccionado.proveedor_nombre || (esGastoDoc ? 'Sin proveedor' : 'Sin distribuidor');
            const tituloDoc = `${etiquetaTipo[seleccionado.tipo] || seleccionado.tipo}${seleccionado.numero ? ` · ${seleccionado.numero}` : ''} · ${nombreDoc}`;
            return (
              <div style={{ minWidth: 0, maxWidth: '100%' }}>
                <h1 title={tituloDoc} style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 21, letterSpacing: '-0.02em', margin: 0, lineHeight: 1.15, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {tituloDoc}
                </h1>
                {esGastoDoc && seleccionado.proveedor_rut && (
                  <div style={{ fontSize: 11.5, color: 'var(--ink-400)', marginTop: 3, fontFamily: 'var(--font-mono)' }}>{seleccionado.proveedor_rut}</div>
                )}
              </div>
            );
          })()}
          <DocDmTrack tipo={seleccionado.tipo} estado={seleccionado.estado} />
          {seleccionado.fecha && (
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5, padding: '2px 10px', borderRadius: 999, fontSize: 12, border: '1px solid var(--line-strong)', color: 'var(--ink-800)', whiteSpace: 'nowrap' }}>
              <CalendarDays size={12} strokeWidth={1.75} /> {fmtDocFecha(seleccionado.fecha)}
            </span>
          )}
          {docEstadoPill(seleccionado.estado)}
          {soloRegistro && (
            <span style={{ padding: '3px 11px', borderRadius: 999, fontSize: 12, fontWeight: 500, background: 'var(--past-sand)', color: 'var(--past-sand-ink)', whiteSpace: 'nowrap', display: 'inline-flex', alignItems: 'center' }}>
              Solo registro
            </span>
          )}
          <div style={{ marginLeft: 'auto', display: 'flex', gap: 8, alignItems: 'center' }}>
            {!editando && esIngreso && seleccionado.estado === 'emitida' && (
              <button onClick={() => abrirRecepcion()}
                style={{ padding: '9px 18px', background: 'var(--brand)', color: '#fff', border: 'none', borderRadius: 999, cursor: 'pointer', fontSize: 13, fontWeight: 500, fontFamily: 'inherit', display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                <PackageCheck size={14} strokeWidth={1.75} /> Recepcionar
              </button>
            )}
            {!editando && !esGdd && ['emitida', 'recibida'].includes(seleccionado.estado) && (
              <button onClick={() => cambiarEstado(seleccionado.id, 'pagada')}
                style={{ padding: '9px 18px', background: 'var(--brand)', color: '#fff', border: 'none', borderRadius: 999, cursor: 'pointer', fontSize: 13, fontWeight: 500, fontFamily: 'inherit', display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                <Check size={14} strokeWidth={2} /> Marcar pagada
              </button>
            )}
            {!editando && esIngreso && ['en_recepcion', 'parcialmente_recibida'].includes(seleccionado.estado) && (
              <button onClick={abrirRecepcion}
                style={{ padding: '9px 18px', background: 'var(--brand)', color: '#fff', border: 'none', borderRadius: 999, cursor: 'pointer', fontSize: 13, fontWeight: 500, fontFamily: 'inherit', display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                <PackageCheck size={14} strokeWidth={1.75} /> Continuar recepción
              </button>
            )}
            {!editando && (
              <button onClick={abrirEdicion}
                style={{ padding: '9px 16px', background: 'var(--paper)', color: 'var(--ink-800)', border: '1px solid var(--line-strong)', borderRadius: 999, cursor: 'pointer', fontSize: 13, fontWeight: 500, fontFamily: 'inherit', display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                <Pencil size={13} strokeWidth={1.75} /> Editar
              </button>
            )}
            {editando && (
              <>
                <button onClick={cancelarEdicion} disabled={guardandoEdit}
                  style={{ padding: '9px 16px', background: 'var(--paper)', color: 'var(--ink-700)', border: '1px solid var(--line)', borderRadius: 999, cursor: 'pointer', fontSize: 13, fontFamily: 'inherit', display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                  <X size={13} strokeWidth={2} /> Cancelar
                </button>
                <button onClick={guardarEdicion} disabled={guardandoEdit}
                  style={{ padding: '9px 18px', background: 'var(--brand)', color: '#fff', border: 'none', borderRadius: 999, cursor: guardandoEdit ? 'not-allowed' : 'pointer', fontSize: 13, fontWeight: 500, fontFamily: 'inherit', display: 'inline-flex', alignItems: 'center', gap: 6, opacity: guardandoEdit ? 0.7 : 1 }}>
                  <Check size={13} strokeWidth={2.5} /> {guardandoEdit ? 'Guardando…' : 'Guardar'}
                </button>
              </>
            )}
          </div>
        </div>

        {/* Banner lotes creados */}
        {lotesCreados.length > 0 && (
          <div style={{ background: 'var(--ok-bg)', border: '1px solid var(--ok-line)', borderRadius: 12, padding: '12px 16px', marginBottom: 20, display: 'flex', alignItems: 'center', gap: 8 }}>
            <Check size={14} strokeWidth={2.5} style={{ color: 'var(--ok-ink)', flexShrink: 0 }} />
            <span style={{ color: 'var(--ok-ink)', fontWeight: 500, fontSize: 13 }}>
              Recepción completada — {lotesCreados.length} lote{lotesCreados.length > 1 ? 's' : ''} creado{lotesCreados.length > 1 ? 's' : ''}
            </span>
          </div>
        )}

        {/* ReceptionBar — GDD con recepción iniciada */}
        {esGdd && (() => {
          const lineas = seleccionado.detalle || [];
          const tieneRecep = lineas.some(l => l.cantidad_recibida != null);
          if (!tieneRecep) {
            const esp = lineas.reduce((s, l) => s + Number(l.cantidad || 0), 0);
            if (!esp) return null;
            return (
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, background: 'var(--info-bg)', border: '1px solid var(--info-line)', borderRadius: 14, padding: '12px 16px', marginBottom: 20 }}>
                <span style={{ width: 30, height: 30, borderRadius: '50%', background: 'rgba(255,255,255,0.55)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  <Package size={15} strokeWidth={1.75} style={{ color: 'var(--info-ink)' }} />
                </span>
                <span style={{ fontSize: 13, color: 'var(--info-ink)', flex: 1 }}>
                  <strong>{esp} ejemplares</strong> por recepcionar en {lineas.length} título{lineas.length !== 1 ? 's' : ''}.
                </span>
              </div>
            );
          }
          const esp    = lineas.reduce((s, l) => s + Number(l.cantidad || 0), 0);
          const rec    = lineas.reduce((s, l) => s + Number(l.cantidad_recibida || 0), 0);
          const faltan = esp - rec;
          const pct    = esp > 0 ? Math.round((rec / esp) * 100) : 0;
          const ok     = faltan === 0;
          return (
            <div style={{ background: ok ? 'var(--ok-bg)' : 'var(--warn-bg)', border: '1px solid ' + (ok ? 'var(--ok-line)' : 'var(--warn-line)'), borderRadius: 14, padding: '12px 16px', marginBottom: 20 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 9 }}>
                <span style={{ width: 30, height: 30, borderRadius: '50%', background: 'rgba(255,255,255,0.55)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  {ok
                    ? <CheckCircle size={15} strokeWidth={1.75} style={{ color: 'var(--ok-ink)' }} />
                    : <AlertTriangle size={15} strokeWidth={1.75} style={{ color: 'var(--warn-ink)' }} />}
                </span>
                <span style={{ fontSize: 13, color: ok ? 'var(--ok-ink)' : 'var(--warn-ink)', flex: 1 }}>
                  <strong>{rec} de {esp}</strong> recibidos{ok ? ' — recepción completa' : ` · faltan ${faltan}`}
                </span>
                <span style={{ fontSize: 13, fontWeight: 700, color: ok ? 'var(--ok-ink)' : 'var(--warn-ink)', fontVariantNumeric: 'tabular-nums' }}>{pct}%</span>
              </div>
              <div style={{ height: 6, borderRadius: 999, background: 'rgba(0,0,0,0.06)', overflow: 'hidden' }}>
                <div style={{ width: pct + '%', height: '100%', borderRadius: 999, background: ok ? 'var(--ok-ink)' : 'var(--warn-ink)', transition: 'width 400ms ease' }} />
              </div>
            </div>
          );
        })()}

        {/* Datos — distribuidor y fecha ya están en el encabezado (y no se editan aquí) */}
        {(() => {
          const tileStyle = { background: editando ? 'var(--paper-soft)' : 'var(--paper)', border: '1px solid ' + (editando ? 'var(--line-strong)' : 'var(--line)'), borderRadius: 10, padding: '8px 12px' };
          const labelStyle = { fontSize: 10, textTransform: 'uppercase', letterSpacing: '0.08em', color: 'var(--ink-500)', fontWeight: 500, marginBottom: 3 };
          const inputStyle = { width: '100%', boxSizing: 'border-box', padding: '5px 10px', border: '1px solid var(--line)', borderRadius: 8, fontSize: 13, fontFamily: 'inherit', color: 'var(--ink-900)', background: 'var(--paper)', outline: 'none' };
          return (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(170px, 1fr))', gap: '8px 12px', marginBottom: 16 }}>
              <div style={tileStyle}>
                <div style={labelStyle}>Propósito</div>
                {editando
                  ? <select value={editForm.proposito} onChange={e => setEditForm(f => ({ ...f, proposito: e.target.value }))} style={inputStyle} disabled={esGastoDoc}>
                      <option value="ingreso_mercaderia">Ingreso de mercadería</option>
                      <option value="cobro_consignacion">Liquidación de consignación</option>
                      <option value="otro">Ajuste o corrección</option>
                      <option value="gasto_servicio">Gasto o servicio</option>
                    </select>
                  : <div style={{ fontSize: 13, color: 'var(--ink-900)' }}>{etiquetaProposito[seleccionado.proposito] || seleccionado.proposito || 'Ingreso de mercadería'}</div>
                }
              </div>
              <div style={tileStyle}>
                <div style={labelStyle}>Modalidad</div>
                {editando
                  ? <select value={editForm.modalidad} onChange={e => setEditForm(f => ({ ...f, modalidad: e.target.value }))} style={inputStyle}>
                      <option value="firme">Firme</option>
                      <option value="consignacion">Consignación</option>
                    </select>
                  : <div style={{ fontSize: 13, color: 'var(--ink-900)' }}>{seleccionado.modalidad === 'consignacion' ? 'Consignación' : (seleccionado.modalidad || '—')}</div>
                }
              </div>
              <div style={{ ...tileStyle, gridColumn: 'span 2' }}>
                <div style={labelStyle}>Notas</div>
                {editando
                  ? <input value={editForm.notas} onChange={e => setEditForm(f => ({ ...f, notas: e.target.value }))} placeholder="Sin notas" style={inputStyle} />
                  : <div style={{ fontSize: 13, color: seleccionado.notas ? 'var(--ink-900)' : 'var(--ink-400)' }}>{seleccionado.notas || '—'}</div>
                }
              </div>
            </div>
          );
        })()}

        {/* Estado buttons (no-GDD only) */}
        {!esGdd && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16, flexWrap: 'wrap' }}>
            <span style={{ fontSize: 12, color: 'var(--ink-500)' }}>Cambiar estado:</span>
            {(esGastoDoc ? ['emitida', 'pagada', 'anulada'] : ['emitida', 'recibida', 'pagada', 'anulada']).map(e => {
              const activo = seleccionado.estado === e;
              return (
                <button key={e} onClick={() => cambiarEstado(seleccionado.id, e)} disabled={activo}
                  style={{ padding: '6px 14px', borderRadius: 999, fontSize: 12, fontFamily: 'inherit', cursor: activo ? 'default' : 'pointer', border: '1px solid ' + (activo ? 'transparent' : 'var(--line)'), background: activo ? 'var(--ink-900)' : 'var(--paper)', color: activo ? '#fff' : 'var(--ink-700)', textTransform: 'capitalize' }}>
                  {etiquetaEstado[e] || e}
                </button>
              );
            })}
          </div>
        )}

        {/* Resumen financiero — solo cuando hay mnt_total del XML */}
        {seleccionado.mnt_total && (() => {
          const mntTotal    = Number(seleccionado.mnt_total);
          const esExentaDoc = !!seleccionado.es_exenta;
          const montoNeto   = Math.round(mntTotal / 1.19);
          const iva         = mntTotal - montoNeto;
          const filas = esExentaDoc
            ? [{ label: 'Total exento (sin IVA)', value: mntTotal, color: 'var(--brand)' }]
            : [
                { label: 'Monto neto', value: montoNeto, color: 'var(--ink-900)' },
                { label: 'IVA 19%',    value: iva,       color: 'var(--ink-600)' },
                { label: 'Total',      value: mntTotal,  color: 'var(--brand)'   },
              ];
          return (
            <div style={{ display: 'grid', gridTemplateColumns: `repeat(${filas.length}, 1fr)`, gap: 12, marginBottom: 16 }}>
              {filas.map(({ label, value, color }) => (
                <div key={label} style={{ background: 'var(--paper)', border: '1px solid var(--line)', borderRadius: 12, padding: '9px 16px' }}>
                  <div style={{ fontSize: 10, fontWeight: 500, textTransform: 'uppercase', letterSpacing: '0.08em', color: 'var(--ink-500)', marginBottom: 3 }}>{label}</div>
                  <span style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 20, letterSpacing: '-0.02em', fontVariantNumeric: 'tabular-nums', color }}>
                    $ {value.toLocaleString('es-CL')}
                  </span>
                </div>
              ))}
            </div>
          );
        })()}

        {/* Detalle table */}
        <div style={{ fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.08em', color: 'var(--ink-500)', marginBottom: 10 }}>Detalle</div>
        <div style={{ border: '1px solid var(--line)', borderRadius: 16, overflow: 'hidden' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
            <thead>
              <tr style={{ background: 'var(--paper-stripe)' }}>
                {esGastoDoc ? (
                  <>
                    <th style={{ ...DOC_TH, paddingLeft: 18 }}>Descripción</th>
                    <th style={{ ...DOC_TH, textAlign: 'right' }}>Cant.</th>
                    {!seleccionado.es_exenta && <th style={{ ...DOC_TH, textAlign: 'right' }}>Valor neto</th>}
                    <th style={{ ...DOC_TH, textAlign: 'right', paddingRight: 18 }}>{seleccionado.es_exenta ? 'Valor total (exento)' : 'Total c/IVA'}</th>
                  </>
                ) : (
                  <>
                    <th style={{ ...DOC_TH, paddingLeft: 18 }}>Libro</th>
                    <th style={DOC_TH}>ISBN</th>
                    <th style={{ ...DOC_TH, textAlign: 'right' }}>Cant.</th>
                    {esGdd && <th style={{ ...DOC_TH, textAlign: 'right' }}>Recibidos</th>}
                    <th style={{ ...DOC_TH, textAlign: 'right' }}>P. neto</th>
                    <th style={{ ...DOC_TH, textAlign: 'right' }}>Desc.</th>
                    <th style={{ ...DOC_TH, textAlign: 'right', paddingRight: editando ? 8 : 18 }}>Subtotal</th>
                    {editando && <th style={{ ...DOC_TH, width: 84, paddingLeft: 4, paddingRight: 14 }}></th>}
                  </>
                )}
              </tr>
            </thead>
            <tbody>
              {(seleccionado.detalle || []).map((d, i) => {
                if (esGastoDoc) {
                  const esExenta = !!seleccionado.es_exenta;
                  const valorNeto = d.precio_neto != null ? Number(d.precio_neto) : (d.monto_item != null ? Number(d.monto_item) : null);
                  const valorTotal = valorNeto != null ? (esExenta ? valorNeto : Math.round(valorNeto * 1.19)) : null;
                  return (
                    <tr key={i} style={{ borderTop: '1px solid var(--line-soft)' }}>
                      <td style={{ ...DOC_TD, paddingLeft: 18 }}>
                        <div style={{ fontSize: 13.5 }}>{d.descripcion || '—'}</div>
                      </td>
                      <td style={{ ...DOC_TD, textAlign: 'right', fontVariantNumeric: 'tabular-nums' }}>{d.cantidad}</td>
                      {!esExenta && (
                        <td style={{ ...DOC_TD, textAlign: 'right', fontVariantNumeric: 'tabular-nums', color: 'var(--ink-700)' }}>
                          {valorNeto != null ? `$ ${valorNeto.toLocaleString('es-CL')}` : '—'}
                        </td>
                      )}
                      <td style={{ ...DOC_TD, textAlign: 'right', paddingRight: 18 }}>
                        <span style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 15, letterSpacing: '-0.01em', fontVariantNumeric: 'tabular-nums' }}>
                          {valorTotal != null ? `$ ${valorTotal.toLocaleString('es-CL')}` : '—'}
                        </span>
                      </td>
                    </tr>
                  );
                }
                const falta = d.cantidad_recibida != null && d.cantidad_recibida < d.cantidad;
                const subtotal = d.monto_item != null
                  ? Number(d.monto_item)
                  : d.precio_neto ? d.cantidad * Number(d.precio_neto) : null;
                const lineaEditable = editando && !d.parcialmente_recibido;
                const inputLinea = { width: '100%', boxSizing: 'border-box', padding: '4px 8px', border: '1px solid var(--line-strong)', borderRadius: 8, fontSize: 13, fontFamily: 'inherit', textAlign: 'right', background: 'var(--paper)', color: 'var(--ink-900)', outline: 'none' };
                return (
                  <tr key={i} style={{ borderTop: '1px solid var(--line-soft)' }}>
                    <td style={{ ...DOC_TD, paddingLeft: 18 }}>
                      <div style={{ fontSize: 13.5, fontWeight: 600 }}>{d.titulo}</div>
                      <div style={{ fontSize: 11, color: 'var(--ink-500)' }}>{d.autor}</div>
                    </td>
                    <td style={{ ...DOC_TD, fontFamily: 'var(--font-mono)', fontSize: 12, color: 'var(--ink-500)' }}>{d.isbn || '—'}</td>
                    <td style={{ ...DOC_TD, textAlign: 'right', fontVariantNumeric: 'tabular-nums', width: lineaEditable ? 84 : undefined }}>
                      {lineaEditable
                        ? <input key={`c-${d.id}-${d.cantidad}`} type="number" min="1" defaultValue={d.cantidad} aria-label="Cantidad" style={inputLinea}
                            onBlur={e => { if (e.target.value !== '' && Number(e.target.value) > 0) guardarCampoLinea(d, 'cantidad', e.target.value); else e.target.value = d.cantidad; }}
                            onKeyDown={e => { if (e.key === 'Enter') e.target.blur(); }} />
                        : d.cantidad}
                    </td>
                    {esGdd && (
                      <td style={{ ...DOC_TD, textAlign: 'right', fontVariantNumeric: 'tabular-nums' }}>
                        {d.cantidad_recibida != null
                          ? <span style={{ color: falta ? 'var(--bad-ink)' : 'var(--ink-700)', fontWeight: falta ? 600 : 400 }}>{d.cantidad_recibida}</span>
                          : <span style={{ color: 'var(--ink-300)' }}>—</span>}
                      </td>
                    )}
                    <td style={{ ...DOC_TD, textAlign: 'right', fontVariantNumeric: 'tabular-nums', color: 'var(--ink-700)', width: lineaEditable ? 110 : undefined }}>
                      {lineaEditable
                        ? <input key={`p-${d.id}-${d.precio_neto}`} type="number" min="0" step="0.01" defaultValue={d.precio_neto != null ? Number(d.precio_neto) : ''} aria-label="Precio neto" style={inputLinea}
                            onBlur={e => guardarCampoLinea(d, 'precio_neto', e.target.value)}
                            onKeyDown={e => { if (e.key === 'Enter') e.target.blur(); }} />
                        : (d.precio_neto ? `$ ${Number(d.precio_neto).toLocaleString('es-CL')}` : '—')}
                    </td>
                    <td style={{ ...DOC_TD, textAlign: 'right' }}>
                      {d.descuento_pct
                        ? <span style={{ padding: '2px 8px', borderRadius: 999, fontSize: 12, fontWeight: 600, background: 'var(--warn-bg)', color: 'var(--warn-ink)', whiteSpace: 'nowrap' }}>−{Number(d.descuento_pct)}%</span>
                        : <span style={{ color: 'var(--ink-300)' }}>—</span>}
                    </td>
                    <td style={{ ...DOC_TD, textAlign: 'right', paddingRight: editando ? 8 : 18 }}>
                      <span style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 15, letterSpacing: '-0.01em', fontVariantNumeric: 'tabular-nums' }}>
                        {subtotal != null ? `$ ${subtotal.toLocaleString('es-CL')}` : '—'}
                      </span>
                    </td>
                    {editando && (
                      <td style={{ ...DOC_TD, paddingLeft: 4, paddingRight: 14, textAlign: 'right', whiteSpace: 'nowrap' }}>
                        {d.parcialmente_recibido
                          ? <span style={{ fontSize: 11, color: 'var(--ink-400)' }}>recibida</span>
                          : quitandoLineaId === d.id
                            ? (
                              <span style={{ display: 'inline-flex', gap: 6, alignItems: 'center' }}>
                                <button type="button" onClick={() => quitarLineaDoc(d)} style={{ background: 'var(--bad-ink)', color: '#fff', border: 'none', borderRadius: 999, padding: '3px 10px', fontSize: 12, fontFamily: 'inherit', cursor: 'pointer' }}>Quitar</button>
                                <button type="button" onClick={() => setQuitandoLineaId(null)} aria-label="Cancelar" style={{ background: 'none', border: 'none', color: 'var(--ink-500)', cursor: 'pointer', fontSize: 16, lineHeight: 1, padding: 0 }}>×</button>
                              </span>
                            )
                            : <button type="button" onClick={() => setQuitandoLineaId(d.id)} aria-label="Quitar línea" title="Quitar línea" style={{ background: 'none', border: 'none', color: 'var(--ink-400)', cursor: 'pointer', padding: 4, display: 'inline-flex' }}><Trash2 size={14} strokeWidth={1.75} /></button>}
                      </td>
                    )}
                  </tr>
                );
              })}
            </tbody>
          </table>
          {editando && !esGastoDoc && (() => {
            const campo = { width: '100%', boxSizing: 'border-box', padding: '6px 10px', border: '1px solid var(--line-strong)', borderRadius: 8, fontSize: 13, fontFamily: 'inherit', background: 'var(--paper)', color: 'var(--ink-900)', outline: 'none' };
            const etiqueta = { display: 'block', fontSize: 10, textTransform: 'uppercase', letterSpacing: '0.07em', color: 'var(--ink-500)', fontWeight: 500, marginBottom: 3 };
            const puede = (lineaNueva._isbn.trim() || lineaNueva._titulo_editado.trim()) && Number(lineaNueva.cantidad) > 0 && !ocupadoLineas;
            const yaCerrada = esGdd && ['completa', 'cerrada_incompleta'].includes(seleccionado.estado);
            return (
              <div style={{ padding: '12px 18px 14px', borderTop: '1px solid var(--line-soft)', background: 'var(--paper-soft)' }}>
                <div style={{ fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.08em', color: 'var(--ink-500)', marginBottom: 8 }}>Agregar un libro que faltó</div>
                <form onSubmit={e => { e.preventDefault(); if (puede) agregarLineaDoc(); }}
                  style={{ display: 'grid', gridTemplateColumns: '150px minmax(0, 1fr) 72px 104px 104px auto', gap: 8, alignItems: 'end' }}>
                  <div><label style={etiqueta}>ISBN</label>
                    <input value={lineaNueva._isbn} onChange={e => setLineaNueva(l => ({ ...l, _isbn: e.target.value }))} placeholder="ISBN" style={{ ...campo, fontFamily: 'var(--font-mono)', fontSize: 12.5 }} /></div>
                  <div><label style={etiqueta}>Título (solo si el libro es nuevo)</label>
                    <input value={lineaNueva._titulo_editado} onChange={e => setLineaNueva(l => ({ ...l, _titulo_editado: e.target.value }))} placeholder="Título del libro" style={campo} /></div>
                  <div><label style={etiqueta}>Cant.</label>
                    <input type="number" min="1" value={lineaNueva.cantidad} onChange={e => setLineaNueva(l => ({ ...l, cantidad: e.target.value }))} style={campo} /></div>
                  <div><label style={etiqueta}>Precio neto</label>
                    <input type="number" min="0" step="0.01" placeholder="0" value={lineaNueva.precio_neto} onChange={e => setLineaNueva(l => ({ ...l, precio_neto: e.target.value }))} style={campo} /></div>
                  <div><label style={etiqueta}>PVP</label>
                    <input type="number" min="0" step="0.01" placeholder="0" value={lineaNueva.pvp} onChange={e => setLineaNueva(l => ({ ...l, pvp: e.target.value }))} style={campo} /></div>
                  <button type="submit" disabled={!puede}
                    style={{ padding: '7px 16px', borderRadius: 999, border: 'none', background: 'var(--brand)', color: '#fff', fontSize: 13, fontWeight: 500, fontFamily: 'inherit', cursor: puede ? 'pointer' : 'not-allowed', opacity: puede ? 1 : 0.5, display: 'inline-flex', alignItems: 'center', gap: 5 }}>
                    <Plus size={13} strokeWidth={2} /> {ocupadoLineas ? 'Agregando…' : 'Agregar'}
                  </button>
                </form>
                <div style={{ fontSize: 11.5, color: 'var(--ink-500)', marginTop: 8 }}>
                  Los cambios en las líneas se guardan al instante. Las líneas ya recibidas no se pueden cambiar.
                  {yaCerrada && ' Este documento ya estaba recibido: al agregar libros volverá a «en recepción» para que recibas solo los nuevos.'}
                </div>
                {errorLineas && <div style={{ fontSize: 12.5, color: 'var(--bad-ink)', marginTop: 6 }}>{errorLineas}</div>}
              </div>
            );
          })()}
          {!seleccionado.mnt_total && total > 0 && (
            <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'baseline', gap: 14, padding: '14px 18px', borderTop: '1px solid var(--line-soft)', background: 'var(--paper-soft)' }}>
              <span style={{ fontSize: 12, fontWeight: 600, color: 'var(--ink-500)', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Total neto</span>
              <span style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 24, letterSpacing: '-0.02em', fontVariantNumeric: 'tabular-nums' }}>
                $ {total.toLocaleString('es-CL')}
              </span>
            </div>
          )}
        </div>
      </div>
    );
  }

  // ── list-view helpers ─────────────────────────────────────────────────────
  const buscaTrim = busca.trim().toLowerCase();
  // Libros de ese documento que coinciden con lo buscado (solo vale si la respuesta es de la búsqueda actual)
  const librosQueCoinciden = doc => (buscaTrim && coincidenciasLibro.q === buscaTrim ? coincidenciasLibro.mapa[doc.id] : null) || null;
  const matchDoc  = doc => !buscaTrim || [doc.numero, doc.distribuidor_nombre, doc.proveedor_nombre, etiquetaTipo[doc.tipo]].some(v => (v || '').toLowerCase().includes(buscaTrim)) || !!librosQueCoinciden(doc);

  // Texto de urgencia por fila — se aproxima con la fecha del documento (no guardamos
  // marcas de tiempo por etapa, así que "hace N días" es desde que se emitió/creó).
  function docDmUrgenciaTexto(doc, norm) {
    const dias = Math.max(0, Math.floor((Date.now() - new Date(doc.fecha).getTime()) / 86400000));
    const txtDias = `${dias} día${dias !== 1 ? 's' : ''}`;
    if (doc.tipo === 'factura' && doc.estado === 'recibida') return `recibida hace ${txtDias}, por pagar`;
    if (norm === 'emitida')      return dias === 0 ? 'recién emitida' : `emitida hace ${txtDias}`;
    if (norm === 'en_recepcion') return `en bodega hace ${txtDias}`;
    return `${DOC_DM_STAGE_LABEL[norm] || norm} · hace ${txtDias}`;
  }
  // Bajo la fila: el libro por el que apareció el documento en la búsqueda (con «+N» si trae más)
  function lineaLibroCoincide(doc) {
    const l = librosQueCoinciden(doc);
    if (!l || l.length === 0) return null;
    return (
      <div title={l.map(x => x.titulo).join(' · ')} style={{ fontSize: 11, color: 'var(--brand)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'flex', alignItems: 'center', gap: 4 }}>
        <BookOpen size={11} strokeWidth={2} style={{ flexShrink: 0 }} />
        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{l[0].titulo}{l.length > 1 ? ` +${l.length - 1}` : ''}</span>
      </div>
    );
  }
  function docDmEsPendiente(doc) {
    const norm = docDmNormEstado(doc.tipo, doc.estado);
    const flow = DOC_DM_FLOW[doc.tipo] || [];
    const idx  = flow.indexOf(norm);
    return idx >= 0 && idx < flow.length - 1;
  }

  // Lista dividida: lo que espera una acción tuya, ordenado por más antiguo primero
  // (más urgente), y lo ya cerrado, colapsado por defecto.
  const pendientes  = documentos.filter(matchDoc).filter(docDmEsPendiente)
    .sort((a, b) => new Date(a.fecha) - new Date(b.fecha));
  const completados = documentos.filter(matchDoc).filter(d => !docDmEsPendiente(d))
    .sort((a, b) => new Date(b.fecha) - new Date(a.fecha));
  // Orden plano para prev/next del panel de detalle — el de la pestaña activa, para
  // no saltar a filas que no se ven.
  // El filtro por tipo solo vale mientras queden documentos de ese tipo en la lista (si no, se ignora).
  const filtroDe = lista => (soloTipo && lista.some(d => d.tipo === soloTipo) ? soloTipo : null);
  const filtroPend = filtroDe(pendientes);
  const filtroComp = filtroDe(completados);
  const pendientesVis  = filtroPend ? pendientes.filter(d => d.tipo === filtroPend) : pendientes;
  const completadosVis = filtroComp ? completados.filter(d => d.tipo === filtroComp) : completados;
  // Documentos de ingreso cuyos libros aún no entran al inventario, estén pagados o no (los más antiguos primero)
  const porRecepcionar = documentos.filter(matchDoc).filter(d => d.sin_recepcionar)
    .sort((a, b) => new Date(a.fecha) - new Date(b.fecha));
  const filtroRec = filtroDe(porRecepcionar);
  const porRecepcionarVis = filtroRec ? porRecepcionar.filter(d => d.tipo === filtroRec) : porRecepcionar;
  function textoPorRecepcionar(doc) {
    if (doc.tipo === 'factura' && doc.estado === 'pagada') return `Pagada · sin recepcionar · ${fmtDocFecha(doc.fecha)}`;
    if (doc.tipo === 'factura' && doc.estado === 'recibida') return `Marcada recibida · sin ingreso al inventario · ${fmtDocFecha(doc.fecha)}`;
    return docDmUrgenciaTexto(doc, docDmNormEstado(doc.tipo, doc.estado));
  }
  // Con una búsqueda activa no se divide en pestañas: una sola lista con todos los resultados (más recientes primero)
  const enBusqueda = buscaTrim !== '';
  const resultados = documentos.filter(matchDoc).sort((a, b) => new Date(b.fecha) - new Date(a.fecha));
  const filtroRes = filtroDe(resultados);
  const resultadosVis = filtroRes ? resultados.filter(d => d.tipo === filtroRes) : resultados;
  const docsOrden = enBusqueda ? resultadosVis : (panelTab === 'completados' ? completadosVis : panelTab === 'recepcionar' ? porRecepcionarVis : pendientesVis);

  // Cerrar un documento de la selección múltiple; si queda uno solo, pasa a verse como panel único
  function cerrarDeLaSeleccion(id) {
    const next = new Set(seleccionados);
    next.delete(id);
    setSeleccionados(next);
    if (next.size === 1) setDocFoco([...next][0]);
    else setDocFoco(f => (f === id ? null : f));
  }
  // Marcar como no leído: vuelve a verse en negrita y se cierra (como en el correo)
  function marcarNoLeido(ids) {
    desmarcarVistos(ids);
    setSeleccionados(prev => new Set([...prev].filter(x => !ids.includes(x))));
    setDocFoco(f => (ids.includes(f) ? null : f));
  }

  function toggleSeleccion(id) {
    setConfirmandoRecepcionLote(false); setConfirmandoAnulacion(false);
    setSeleccionados(prev => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id); else next.add(id);
      return next;
    });
  }

  // Acción en lote: solo tiene sentido cuando todo lo marcado comparte tipo y etapa
  // (el mismo botón de avance sirve para todos). GDD queda afuera porque su avance
  // abre el flujo de recepción, no es un simple cambio de estado.
  const seleccionArr = documentos.filter(d => seleccionados.has(d.id));
  let loteInfo = null;
  if (seleccionArr.length >= 2) {
    const tipos = new Set(seleccionArr.map(d => d.tipo));
    const norms = new Set(seleccionArr.map(d => docDmNormEstado(d.tipo, d.estado)));
    if (tipos.size === 1 && norms.size === 1) {
      const tipo = seleccionArr[0].tipo;
      const norm = [...norms][0];
      const flow = DOC_DM_FLOW[tipo] || [];
      const adv  = DOC_DM_ADVANCE[tipo]?.[norm];
      if (adv && !adv.isGdd) {
        loteInfo = { docs: seleccionArr, adv, nextEstado: flow[flow.indexOf(norm) + 1],
          total: seleccionArr.reduce((s, d) => s + Number(d.mnt_total || 0), 0) };
      }
    }
  }

  // Recibir varias GDD de una vez: solo si todo lo marcado son GDD que esperan recepción. Cada una se
  // recibe "completa", con todas las cantidades esperadas, usando el descuento ya configurado del
  // distribuidor (igual que la recepción individual cuando no se cambia nada). Las que no se pueden
  // (sin descuento configurado, u otro error) quedan como estaban y se informan al final.
  const recepcionLoteInfo = seleccionArr.length >= 2 && seleccionArr.every(d => d.tipo === 'gdd' && ['emitida', 'en_recepcion'].includes(docDmNormEstado(d.tipo, d.estado)))
    ? { docs: seleccionArr, total: seleccionArr.reduce((sum, d) => sum + Number(d.mnt_total || 0), 0) }
    : null;

  async function recibirLoteGdd() {
    if (!recepcionLoteInfo) return;
    const docs = recepcionLoteInfo.docs;
    setConfirmandoRecepcionLote(false); setConfirmandoAnulacion(false);
    setResultadoRecepcionLote(null);
    setRecibiendoLote({ hecho: 0, total: docs.length });
    const ok = [], fallo = [];
    for (let i = 0; i < docs.length; i++) {
      const d = docs[i];
      try {
        const det = (await api.get(`/documentos/${d.id}`)).data;
        const factor = Number(det.distribuidor_factor_pago || 0);
        if (!(factor > 0 && factor < 1)) throw new Error('su distribuidor no tiene el descuento configurado: recíbela una vez a mano y queda guardado');
        const lineas = (det.detalle || []).filter(x => !x.parcialmente_recibido).map(x => ({ detalle_id: x.id, cantidad_recibida: Number(x.cantidad) }));
        const r = await api.post(`/documentos/${d.id}/confirmar-recepcion`, { tipo: 'completa', lineas });
        ok.push({ numero: d.numero, lotes: r.data.lotes?.length || 0, avisos: r.data.advertencias?.length || 0 });
      } catch (e) {
        fallo.push({ numero: d.numero, motivo: e.response?.data?.error || e.message });
      }
      setRecibiendoLote({ hecho: i + 1, total: docs.length });
    }
    setRecibiendoLote(null);
    setResultadoRecepcionLote({ ok, fallo });
    setSeleccionados(new Set());
    setDocRefreshTick(t => t + 1);
    await cargarDocumentos();
  }

  // Anular varios a la vez: solo los que siguen "emitida" (aún sin recibir); el backend lo vuelve a
  // comprobar y rechaza los que ya tienen stock ingresado. Un documento anulado deja de contar como
  // duplicado, así que se puede volver a ingresar.
  const anulables = seleccionArr.filter(d => d.estado === 'emitida');

  async function anularSeleccionados() {
    if (!anulables.length) return;
    setConfirmandoAnulacion(false);
    setResultadoAnulacionLote(null);
    setAnulandoLote(true);
    try {
      const r = await api.post('/documentos/anular-lote', { ids: anulables.map(d => d.id) });
      setResultadoAnulacionLote({ ok: r.data.ok || [], fallo: r.data.fallo || [] });
    } catch (e) {
      setResultadoAnulacionLote({ ok: [], fallo: [{ numero: null, motivo: e.response?.data?.error || e.message }] });
    }
    setAnulandoLote(false);
    setSeleccionados(new Set());
    setDocRefreshTick(t => t + 1);
    await cargarDocumentos();
  }

  // Barra de una lista (Pendientes o Completados): casilla maestra como en el correo, que marca lo que se ve,
  // y chips con ícono que filtran la lista por tipo. `lista` es todo; `visibles` lo que deja pasar el filtro.
  function barraSeleccion(lista, visibles, filtro) {
    const nSel = visibles.filter(d => seleccionados.has(d.id)).length;
    const todos = nSel === visibles.length;
    const cambiarSel = ids => { setConfirmandoRecepcionLote(false); setConfirmandoAnulacion(false); setSeleccionados(new Set(ids)); };
    // Gmail: sin nada → marca todo; con algo marcado (parcial o todo) → limpia
    const clicMaestra = () => cambiarSel(nSel === 0 ? visibles.map(d => d.id) : []);
    // Cambiar el filtro limpia la selección: no deben quedar marcados documentos que ya no se ven
    const cambiarFiltro = tipo => { cambiarSel([]); setSoloTipo(tipo); };
    const tipos = ['gdd', 'factura', 'nota_credito', 'nota_debito']
      .map(t => ({ tipo: t, docs: lista.filter(d => d.tipo === t) }))
      .filter(x => x.docs.length > 0);
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '8px 12px', borderBottom: '1px solid var(--line-soft)', background: 'var(--paper-soft)' }}>
        <span role="checkbox" aria-checked={todos ? true : nSel > 0 ? 'mixed' : false} aria-label="Seleccionar todos" tabIndex={0}
          onClick={clicMaestra} onKeyDown={e => { if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); clicMaestra(); } }}
          title={nSel === 0 ? 'Seleccionar todos' : 'Quitar la selección'}
          style={{ width: 15, height: 15, borderRadius: 4, border: '1px solid ' + (nSel > 0 ? 'var(--brand)' : 'var(--line-strong)'), background: nSel > 0 ? 'var(--brand)' : 'var(--paper)', flexShrink: 0, cursor: 'pointer', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
          {todos ? <Check size={10} strokeWidth={3} color="#fff" /> : nSel > 0 ? <Minus size={10} strokeWidth={3} color="#fff" /> : null}
        </span>
        <span onClick={clicMaestra} style={{ fontSize: 12, color: 'var(--ink-600)', cursor: 'pointer', userSelect: 'none' }}>
          {nSel > 0 ? `${nSel} seleccionado${nSel !== 1 ? 's' : ''}` : 'Seleccionar todos'}
        </span>
        {(() => {
          const pendMarcados = visibles.filter(d => seleccionados.has(d.id) && docDmEsPendiente(d)).map(d => d.id);
          if (pendMarcados.length === 0) return null;
          return (
            <button type="button" onClick={() => marcarNoLeido(pendMarcados)} aria-label="Marcar como no leído" title="Marcar como no leído"
              style={{ width: 26, height: 26, borderRadius: 8, border: '1px solid var(--line)', background: 'var(--paper)', color: 'var(--ink-600)', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', marginLeft: 2 }}>
              <Mail size={13} strokeWidth={1.75} />
            </button>
          );
        })()}
        <span style={{ flex: 1 }} />
        {tipos.length > 1 && tipos.map(({ tipo, docs }) => {
          const meta = DOC_DM_TIPO_META[tipo] || {};
          const tone = DOC_TIPO_TONE_MAP[tipo] || 'sand';
          const Icono = tipo === 'gdd' ? Truck : tipo === 'factura' ? Receipt : FileMinus;
          const activo = filtro === tipo;
          return (
            <button key={tipo} type="button" onClick={() => cambiarFiltro(activo ? null : tipo)}
              title={activo ? `Quitar el filtro: mostrar todos` : `Mostrar solo ${meta.label} (${docs.length})`}
              aria-pressed={activo}
              style={{ display: 'inline-flex', alignItems: 'center', gap: 5, padding: '3px 9px', borderRadius: 999, cursor: 'pointer', fontFamily: 'inherit', fontSize: 12, fontWeight: 500, border: '1px solid ' + (activo ? DOC_TONE_INK[tone] : 'var(--line-strong)'), background: activo ? DOC_TONE_BG[tone] : 'var(--paper)', color: activo ? DOC_TONE_INK[tone] : 'var(--ink-700)' }}>
              <Icono size={13} strokeWidth={1.75} /> {docs.length}
            </button>
          );
        })}
      </div>
    );
  }

  async function avanzarLote() {
    if (!loteInfo) return;
    setLoteAvanzando(true);
    try {
      await Promise.all(loteInfo.docs.map(d => api.patch(`/documentos/${d.id}/estado`, { estado: loteInfo.nextEstado })));
      setSeleccionados(new Set());
      setDocRefreshTick(t => t + 1);
      await cargarDocumentos();
    } catch (e) {
      console.error(e);
      alert('Error al actualizar los documentos en lote');
    }
    setLoteAvanzando(false);
  }

  return (
    <div
      style={{ position: 'relative' }}
      onDragEnter={e => { e.preventDefault(); setListDragDepth(d => d + 1); }}
      onDragOver={e => e.preventDefault()}
      onDragLeave={() => setListDragDepth(d => Math.max(0, d - 1))}
      onDrop={e => {
        e.preventDefault();
        setListDragDepth(0);
        const files = e.dataTransfer.files;
        if (!files || !files.length) return;
        abrirNuevo(false);
        agregarArchivosAlLote(files);
      }}
    >
      {/* ── DROP OVERLAY ──────────────────────────────────────────────── */}
      {listDragDepth > 0 && (
        <div style={{ position: 'absolute', inset: 0, zIndex: 50, background: 'rgba(250,245,228,0.88)', border: '2px dashed var(--brand)', borderRadius: 20, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 12, pointerEvents: 'none' }}>
          <div style={{ width: 56, height: 56, borderRadius: '50%', background: 'var(--brand-soft)', color: 'var(--brand)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Upload size={24} strokeWidth={1.75} />
          </div>
          <div style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 20, letterSpacing: '-0.02em', color: 'var(--brand)' }}>Suelta aquí para crear nuevo documento</div>
          <div style={{ fontSize: 13, color: 'var(--ink-500)' }}>XML DTE · Excel · PDF</div>
        </div>
      )}

      {/* ── HEADER ────────────────────────────────────────────────────── */}
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 14, marginBottom: 18 }}>
        <div style={{ flex: 1 }}>
          <h1 style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 30, letterSpacing: '-0.02em', margin: 0 }}>Documentos</h1>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 4 }}>
          <button onClick={() => abrirNuevo()}
            style={{ padding: '9px 18px', background: 'var(--brand)', color: '#fff', border: 'none', borderRadius: 999, cursor: 'pointer', fontSize: 13, fontWeight: 600, fontFamily: 'inherit', display: 'inline-flex', alignItems: 'center', gap: 6 }}>
            <Plus size={14} strokeWidth={2} /> Nuevo documento
          </button>
          <span style={{ fontSize: 10.5, color: 'var(--ink-400)' }}>o arrastra un XML, Excel o PDF</span>
        </div>
      </div>

      {/* ── BUSCADOR ──────────────────────────────────────────────────── */}
      <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 20 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, background: 'var(--paper)', border: '1px solid var(--line)', borderRadius: 999, padding: '8px 16px', flex: 1, maxWidth: 360 }}>
          <Search size={15} strokeWidth={1.75} style={{ color: 'var(--ink-400)', flexShrink: 0 }} />
          <input
            value={busca}
            onChange={e => setBusca(e.target.value)}
            placeholder="Buscar número, distribuidor, libro o ISBN…"
            style={{ border: 'none', outline: 'none', background: 'transparent', flex: 1, fontSize: 13.5, fontFamily: 'inherit', color: 'var(--ink-900)' }}
          />
          {busca && <button onClick={() => setBusca('')} style={{ background: 'none', border: 'none', color: 'var(--ink-400)', cursor: 'pointer', fontSize: 17, lineHeight: 1, padding: 0 }}>×</button>}
        </div>
      </div>

      {resultadoAnulacionLote && (
        <div style={{ background: resultadoAnulacionLote.fallo.length ? 'var(--warn-bg)' : 'var(--ok-bg)', border: '1px solid ' + (resultadoAnulacionLote.fallo.length ? 'var(--warn-line)' : 'var(--ok-line)'), borderRadius: 12, padding: '12px 16px', marginBottom: 16 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <span style={{ fontSize: 13.5, fontWeight: 600, color: resultadoAnulacionLote.fallo.length ? 'var(--warn-ink)' : 'var(--ok-ink)' }}>
              {resultadoAnulacionLote.ok.length} documento{resultadoAnulacionLote.ok.length !== 1 ? 's' : ''} anulado{resultadoAnulacionLote.ok.length !== 1 ? 's' : ''}
              {resultadoAnulacionLote.fallo.length > 0 && ` · ${resultadoAnulacionLote.fallo.length} no se pudo${resultadoAnulacionLote.fallo.length !== 1 ? 'ieron' : ''} anular`}
            </span>
            <button onClick={() => setResultadoAnulacionLote(null)} aria-label="Cerrar resumen"
              style={{ marginLeft: 'auto', background: 'none', border: 'none', cursor: 'pointer', color: 'var(--ink-500)', fontSize: 18, lineHeight: 1, padding: 0 }}>×</button>
          </div>
          {resultadoAnulacionLote.ok.length > 0 && (
            <div style={{ fontSize: 12, color: 'var(--ink-600)', marginTop: 6 }}>Quedan en «Completados» marcados como anulados.</div>
          )}
          {resultadoAnulacionLote.fallo.map((f, i) => (
            <div key={i} style={{ fontSize: 12.5, color: 'var(--warn-ink)', marginTop: 6 }}><strong>{f.numero ? `N° ${f.numero}` : 'Documento'}:</strong> {f.motivo}</div>
          ))}
        </div>
      )}

      {resultadoRecepcionLote && (
        <div style={{ background: resultadoRecepcionLote.fallo.length ? 'var(--warn-bg)' : 'var(--ok-bg)', border: '1px solid ' + (resultadoRecepcionLote.fallo.length ? 'var(--warn-line)' : 'var(--ok-line)'), borderRadius: 12, padding: '12px 16px', marginBottom: 16 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <span style={{ fontSize: 13.5, fontWeight: 600, color: resultadoRecepcionLote.fallo.length ? 'var(--warn-ink)' : 'var(--ok-ink)' }}>
              {resultadoRecepcionLote.ok.length} GDD recibida{resultadoRecepcionLote.ok.length !== 1 ? 's' : ''}
              {resultadoRecepcionLote.ok.length > 0 && ` · ${resultadoRecepcionLote.ok.reduce((sum, x) => sum + x.lotes, 0)} lote${resultadoRecepcionLote.ok.reduce((sum, x) => sum + x.lotes, 0) !== 1 ? 's' : ''} de stock ingresados`}
              {resultadoRecepcionLote.fallo.length > 0 && ` · ${resultadoRecepcionLote.fallo.length} no se pudo${resultadoRecepcionLote.fallo.length !== 1 ? 'ieron' : ''} recibir`}
            </span>
            <button onClick={() => setResultadoRecepcionLote(null)} aria-label="Cerrar resumen"
              style={{ marginLeft: 'auto', background: 'none', border: 'none', cursor: 'pointer', color: 'var(--ink-500)', fontSize: 18, lineHeight: 1, padding: 0 }}>×</button>
          </div>
          {resultadoRecepcionLote.fallo.map(f => (
            <div key={f.numero} style={{ fontSize: 12.5, color: 'var(--warn-ink)', marginTop: 6 }}><strong>GDD {f.numero}:</strong> {f.motivo}</div>
          ))}
          {resultadoRecepcionLote.ok.some(x => x.avisos > 0) && (
            <div style={{ fontSize: 12, color: 'var(--ink-600)', marginTop: 6 }}>Algunas líneas se recibieron con advertencias (por ejemplo, sin precio); revisa su detalle.</div>
          )}
        </div>
      )}

      {/* ── LISTA + DETALLE, lado a lado ─────────────────────────────── */}
      {documentos.filter(matchDoc).length === 0 ? (
        <div style={{ border: '1px solid var(--line)', borderRadius: 16, padding: 48, textAlign: 'center' }}>
          <div style={{ width: 56, height: 56, borderRadius: '50%', background: 'var(--past-sand)', color: 'var(--past-sand-ink)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 12px' }}>
            <Folder size={24} strokeWidth={1.5} />
          </div>
          <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 4 }}>{busca ? 'Sin resultados' : 'Sin documentos'}</div>
          <div style={{ fontSize: 12, color: 'var(--ink-500)' }}>{busca ? 'Ningún documento coincide con la búsqueda.' : 'Crea tu primer documento con el botón de arriba.'}</div>
        </div>
      ) : (
        <div style={{ display: 'flex', gap: 16, alignItems: 'flex-start' }}>

          {/* Panel izquierdo — pestañas Pendientes / Completados */}
          <div style={{ width: 340, flexShrink: 0, display: 'flex', flexDirection: 'column', gap: 10 }}>

            {!enBusqueda && (
            <div style={{ display: 'flex', gap: 4, background: 'var(--paper-soft)', border: '1px solid var(--line)', borderRadius: 10, padding: 3 }}>
              {[['pendientes', 'Pendientes', pendientes.length], ['recepcionar', 'Por recepcionar', porRecepcionar.length], ['completados', 'Completados', completados.length]].map(([key, label, n]) => (
                <button key={key} onClick={() => { if (key !== panelTab) { setSeleccionados(new Set()); setSoloTipo(null); setConfirmandoRecepcionLote(false); setConfirmandoAnulacion(false); } setPanelTab(key); }}
                  style={{ flex: 1, textAlign: 'center', padding: '7px 0', borderRadius: 8, border: 'none', cursor: 'pointer', fontFamily: 'inherit', fontSize: 12, whiteSpace: 'nowrap', fontWeight: panelTab === key ? 600 : 500, background: panelTab === key ? 'var(--ink-900)' : 'transparent', color: panelTab === key ? '#fff' : (key === 'recepcionar' && n > 0 ? 'var(--warn-ink)' : 'var(--ink-600)') }}>
                  {label} {n}
                </button>
              ))}
            </div>
            )}

            {!enBusqueda && panelTab === 'pendientes' && (
              pendientes.length === 0 ? (
                <div style={{ fontSize: 12.5, color: 'var(--ink-400)', padding: '10px 2px' }}>Nada esperando acción — al día.</div>
              ) : (
                <div style={{ border: '1px solid var(--line)', background: 'var(--paper)', borderRadius: 14, overflow: 'hidden' }}>
                  {pendientes.length > 1 && barraSeleccion(pendientes, pendientesVis, filtroPend)}
                  {pendientesVis.map((doc, i) => {
                    const norm = docDmNormEstado(doc.tipo, doc.estado);
                    const marcado = seleccionados.has(doc.id);
                    const sinAbrir = !docsVistos.has(doc.id);
                    const colorUrg = norm === 'en_recepcion' ? 'var(--warn-ink)' : (doc.tipo === 'factura' && doc.estado === 'recibida') ? 'var(--bad-ink)' : 'var(--ink-500)';
                    return (
                      <div key={doc.id} onClick={() => setDocFoco(doc.id)}
                        style={{ display: 'flex', gap: 8, alignItems: 'center', padding: '9px 12px', borderTop: i ? '1px solid var(--line-soft)' : 'none', cursor: 'pointer' }}>
                        <span onClick={e => { e.stopPropagation(); toggleSeleccion(doc.id); }} title="Marcar para acción en lote"
                          style={{ width: 15, height: 15, borderRadius: 4, border: '1px solid ' + (marcado ? 'var(--brand)' : 'var(--line-strong)'), background: marcado ? 'var(--brand)' : 'var(--paper)', flexShrink: 0, cursor: 'pointer', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                          {marcado && <Check size={10} strokeWidth={3} color="#fff" />}
                        </span>
                        {docIconCircle(doc.tipo, 26)}
                        <div style={{ minWidth: 0, flex: 1 }}>
                          <div style={{ display: 'flex', alignItems: 'baseline', gap: 6 }}>
                            <span style={{ fontSize: 12.5, fontWeight: sinAbrir ? 700 : 400, fontFamily: 'var(--font-mono)', color: 'var(--ink-900)', flexShrink: 0 }}>{doc.numero || '—'}</span>
                            <span style={{ fontSize: 11.5, fontWeight: sinAbrir ? 700 : 400, color: sinAbrir ? 'var(--ink-900)' : 'var(--ink-600)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{doc.distribuidor_nombre || doc.proveedor_nombre || '—'}</span>
                          </div>
                          <div style={{ fontSize: 11, color: colorUrg, fontWeight: sinAbrir ? 700 : 400, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{docDmUrgenciaTexto(doc, norm)}</div>
                          {lineaLibroCoincide(doc)}
                        </div>
                        <span style={{ fontSize: 12, fontWeight: sinAbrir ? 700 : 400, color: 'var(--ink-900)', flexShrink: 0 }}>
                          {doc.mnt_total ? `$ ${Number(doc.mnt_total).toLocaleString('es-CL')}` : '—'}
                        </span>
                      </div>
                    );
                  })}
                </div>
              )
            )}

            {!enBusqueda && panelTab === 'recepcionar' && (
              porRecepcionar.length === 0 ? (
                <div style={{ fontSize: 12.5, color: 'var(--ink-400)', padding: '10px 2px' }}>Todo lo que ingresaste ya está en el inventario.</div>
              ) : (
                <div style={{ border: '1px solid var(--line)', background: 'var(--paper)', borderRadius: 14, overflow: 'hidden' }}>
                  {porRecepcionar.length > 1 && barraSeleccion(porRecepcionar, porRecepcionarVis, filtroRec)}
                  {porRecepcionarVis.map((doc, i) => {
                    const yaPagada = doc.tipo === 'factura' && (doc.estado === 'pagada' || doc.estado === 'recibida');
                    return (
                      <div key={doc.id} onClick={() => setDocFoco(doc.id)}
                        style={{ display: 'flex', gap: 8, alignItems: 'center', padding: '9px 12px', borderTop: i ? '1px solid var(--line-soft)' : 'none', cursor: 'pointer' }}>
                        <span onClick={e => { e.stopPropagation(); toggleSeleccion(doc.id); }} title="Marcar"
                          style={{ width: 15, height: 15, borderRadius: 4, border: '1px solid ' + (seleccionados.has(doc.id) ? 'var(--brand)' : 'var(--line-strong)'), background: seleccionados.has(doc.id) ? 'var(--brand)' : 'var(--paper)', flexShrink: 0, cursor: 'pointer', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                          {seleccionados.has(doc.id) && <Check size={10} strokeWidth={3} color="#fff" />}
                        </span>
                        {docIconCircle(doc.tipo, 26)}
                        <div style={{ minWidth: 0, flex: 1 }}>
                          <div style={{ display: 'flex', alignItems: 'baseline', gap: 6 }}>
                            <span style={{ fontSize: 12.5, fontFamily: 'var(--font-mono)', color: 'var(--ink-900)', flexShrink: 0 }}>{doc.numero || '—'}</span>
                            <span style={{ fontSize: 11.5, color: 'var(--ink-600)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{doc.distribuidor_nombre || doc.proveedor_nombre || '—'}</span>
                          </div>
                          <div style={{ fontSize: 11, color: yaPagada ? 'var(--warn-ink)' : 'var(--ink-500)', fontWeight: yaPagada ? 600 : 400, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{textoPorRecepcionar(doc)}</div>
                          {lineaLibroCoincide(doc)}
                        </div>
                        <span style={{ fontSize: 12, color: 'var(--ink-900)', flexShrink: 0 }}>
                          {doc.mnt_total ? `$ ${Number(doc.mnt_total).toLocaleString('es-CL')}` : '—'}
                        </span>
                      </div>
                    );
                  })}
                </div>
              )
            )}

            {!enBusqueda && panelTab === 'completados' && (
              completados.length === 0 ? (
                <div style={{ fontSize: 12.5, color: 'var(--ink-400)', padding: '10px 2px' }}>Nada completado todavía.</div>
              ) : (
                <div style={{ border: '1px solid var(--line)', background: 'var(--paper)', borderRadius: 14, overflow: 'hidden' }}>
                  {completados.length > 1 && barraSeleccion(completados, completadosVis, filtroComp)}
                  {completadosVis.map((doc, i) => (
                    <div key={doc.id} onClick={() => setDocFoco(doc.id)}
                      style={{ display: 'flex', gap: 8, alignItems: 'center', padding: '9px 12px', borderTop: i ? '1px solid var(--line-soft)' : 'none', cursor: 'pointer' }}>
                      <span onClick={e => { e.stopPropagation(); toggleSeleccion(doc.id); }} title="Marcar"
                        style={{ width: 15, height: 15, borderRadius: 4, border: '1px solid ' + (seleccionados.has(doc.id) ? 'var(--brand)' : 'var(--line-strong)'), background: seleccionados.has(doc.id) ? 'var(--brand)' : 'var(--paper)', flexShrink: 0, cursor: 'pointer', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                        {seleccionados.has(doc.id) && <Check size={10} strokeWidth={3} color="#fff" />}
                      </span>
                      {docIconCircle(doc.tipo, 24)}
                      <div style={{ minWidth: 0, flex: 1 }}>
                      <div style={{ display: 'flex', alignItems: 'baseline', gap: 6, opacity: doc.estado === 'anulada' ? 0.5 : 1 }}>
                        <span style={{ fontSize: 12, fontWeight: 600, fontFamily: 'var(--font-mono)', color: 'var(--ink-900)', flexShrink: 0, textDecoration: doc.estado === 'anulada' ? 'line-through' : 'none' }}>{doc.numero || '—'}</span>
                        {doc.estado === 'anulada' && <span style={{ fontSize: 10, fontWeight: 600, color: 'var(--bad-ink)', background: 'var(--bad-bg)', borderRadius: 999, padding: '1px 7px', flexShrink: 0 }}>anulada</span>}
                        <span style={{ fontSize: 11.5, color: 'var(--ink-500)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{doc.distribuidor_nombre || doc.proveedor_nombre || '—'}</span>
                      </div>
                      {lineaLibroCoincide(doc)}
                      </div>
                      <span style={{ fontSize: 11.5, fontWeight: 700, color: 'var(--ink-700)', flexShrink: 0 }}>
                        {doc.mnt_total ? `$ ${Number(doc.mnt_total).toLocaleString('es-CL')}` : '—'}
                      </span>
                    </div>
                  ))}
                </div>
              )
            )}

            {/* Resultados de la búsqueda: una sola lista, sin separar pendientes de completados */}
            {enBusqueda && (
              <>
                <div style={{ fontSize: 10, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.08em', color: 'var(--ink-500)', margin: '2px 2px 0' }}>
                  Resultados · {resultadosVis.length} documento{resultadosVis.length !== 1 ? 's' : ''}
                </div>
                <div style={{ border: '1px solid var(--line)', background: 'var(--paper)', borderRadius: 14, overflow: 'hidden' }}>
                  {resultados.length > 1 && barraSeleccion(resultados, resultadosVis, filtroRes)}
                  {resultadosVis.map((doc, i) => {
                    const pend = docDmEsPendiente(doc);
                    const norm = docDmNormEstado(doc.tipo, doc.estado);
                    const marcado = seleccionados.has(doc.id);
                    const sinAbrir = pend && !docsVistos.has(doc.id);
                    const anulada = doc.estado === 'anulada';
                    const colorUrg = pend
                      ? (norm === 'en_recepcion' ? 'var(--warn-ink)' : (doc.tipo === 'factura' && doc.estado === 'recibida') ? 'var(--bad-ink)' : 'var(--ink-500)')
                      : 'var(--ink-500)';
                    const detalleTxt = pend ? docDmUrgenciaTexto(doc, norm) : `${DOC_ETIQUETA_ESTADO[doc.estado] || doc.estado} · ${fmtDocFecha(doc.fecha)}`;
                    return (
                      <div key={doc.id} onClick={() => setDocFoco(doc.id)}
                        style={{ display: 'flex', gap: 8, alignItems: 'center', padding: '9px 12px', borderTop: i ? '1px solid var(--line-soft)' : 'none', cursor: 'pointer' }}>
                        <span onClick={e => { e.stopPropagation(); toggleSeleccion(doc.id); }} title="Marcar"
                          style={{ width: 15, height: 15, borderRadius: 4, border: '1px solid ' + (marcado ? 'var(--brand)' : 'var(--line-strong)'), background: marcado ? 'var(--brand)' : 'var(--paper)', flexShrink: 0, cursor: 'pointer', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                          {marcado && <Check size={10} strokeWidth={3} color="#fff" />}
                        </span>
                        {docIconCircle(doc.tipo, 26)}
                        <div style={{ minWidth: 0, flex: 1, opacity: anulada ? 0.5 : 1 }}>
                          <div style={{ display: 'flex', alignItems: 'baseline', gap: 6 }}>
                            <span style={{ fontSize: 12.5, fontWeight: sinAbrir ? 700 : 400, fontFamily: 'var(--font-mono)', color: 'var(--ink-900)', flexShrink: 0, textDecoration: anulada ? 'line-through' : 'none' }}>{doc.numero || '—'}</span>
                            <span style={{ fontSize: 11.5, fontWeight: sinAbrir ? 700 : 400, color: sinAbrir ? 'var(--ink-900)' : 'var(--ink-600)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{doc.distribuidor_nombre || doc.proveedor_nombre || '—'}</span>
                          </div>
                          <div style={{ fontSize: 11, color: colorUrg, fontWeight: sinAbrir ? 700 : 400, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{detalleTxt}</div>
                          {lineaLibroCoincide(doc)}
                        </div>
                        <span style={{ fontSize: 12, fontWeight: sinAbrir ? 700 : 400, color: 'var(--ink-900)', flexShrink: 0 }}>
                          {doc.mnt_total ? `$ ${Number(doc.mnt_total).toLocaleString('es-CL')}` : '—'}
                        </span>
                      </div>
                    );
                  })}
                </div>
              </>
            )}
          </div>

          {/* Panel derecho — detalle completo de cada seleccionado (2+) o del enfocado */}
          {seleccionArr.length >= 2 ? (
            <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: 14 }}>
              <div style={{ background: 'var(--paper)', border: '1px solid var(--line)', borderRadius: 16, padding: '14px 18px', display: 'flex', flexDirection: 'column', gap: 10 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  <span style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 16, letterSpacing: '-0.01em' }}>{seleccionArr.length} documentos seleccionados</span>
                  <button onClick={() => setSeleccionados(new Set())}
                    style={{ marginLeft: 'auto', background: 'none', border: 'none', color: 'var(--ink-500)', cursor: 'pointer', fontFamily: 'inherit', fontSize: 12.5, textDecoration: 'underline' }}>
                    Quitar selección
                  </button>
                </div>
                {loteInfo ? (
                  <button onClick={avanzarLote} disabled={loteAvanzando}
                    style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 6, padding: '10px 0', borderRadius: 10, border: 'none', cursor: loteAvanzando ? 'default' : 'pointer', fontFamily: 'inherit', fontSize: 13, fontWeight: 600, background: 'var(--brand)', color: '#fff', opacity: loteAvanzando ? 0.7 : 1 }}>
                    <PackageCheck size={14} strokeWidth={1.75} /> {loteAvanzando ? 'Actualizando…' : `${loteInfo.adv.label} (${loteInfo.docs.length}) · $ ${loteInfo.total.toLocaleString('es-CL')}`}
                  </button>
                ) : recepcionLoteInfo ? (
                  recibiendoLote ? (
                    <div style={{ fontSize: 13, color: 'var(--ink-700)' }}>Recibiendo {recibiendoLote.hecho} de {recibiendoLote.total}…</div>
                  ) : confirmandoRecepcionLote ? (
                    <div style={{ background: 'var(--warn-bg)', border: '1px solid var(--warn-line)', borderRadius: 10, padding: '10px 12px', display: 'flex', flexDirection: 'column', gap: 8 }}>
                      <span style={{ fontSize: 12.5, color: 'var(--warn-ink)' }}>
                        Se recibirán <strong>{recepcionLoteInfo.docs.length} GDD completas</strong>, con todas las cantidades esperadas, y el stock entrará al inventario. Si alguna llegó distinta, recíbela por separado.
                      </span>
                      <div style={{ display: 'flex', gap: 8 }}>
                        <button onClick={recibirLoteGdd}
                          style={{ padding: '8px 16px', borderRadius: 999, border: 'none', cursor: 'pointer', fontFamily: 'inherit', fontSize: 13, fontWeight: 600, background: 'var(--brand)', color: '#fff' }}>
                          Sí, recibir {recepcionLoteInfo.docs.length}
                        </button>
                        <button onClick={() => setConfirmandoRecepcionLote(false)}
                          style={{ padding: '8px 16px', borderRadius: 999, border: '1px solid var(--line-strong)', cursor: 'pointer', fontFamily: 'inherit', fontSize: 13, background: 'var(--paper)', color: 'var(--ink-700)' }}>
                          Cancelar
                        </button>
                      </div>
                    </div>
                  ) : (
                    <button onClick={() => setConfirmandoRecepcionLote(true)}
                      style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 6, padding: '10px 0', borderRadius: 10, border: 'none', cursor: 'pointer', fontFamily: 'inherit', fontSize: 13, fontWeight: 600, background: 'var(--brand)', color: '#fff' }}>
                      <PackageCheck size={14} strokeWidth={1.75} /> Recibir todo lo esperado ({recepcionLoteInfo.docs.length}) · $ {recepcionLoteInfo.total.toLocaleString('es-CL')}
                    </button>
                  )
                ) : panelTab === 'pendientes' ? (
                  <div style={{ fontSize: 12, color: 'var(--ink-500)' }}>Selecciona documentos del mismo tipo y etapa para avanzarlos juntos.</div>
                ) : null}
                {anulables.length > 0 && (
                  anulandoLote ? (
                    <div style={{ fontSize: 13, color: 'var(--ink-700)' }}>Anulando…</div>
                  ) : confirmandoAnulacion ? (
                    <div style={{ background: 'var(--bad-bg)', border: '1px solid var(--bad-line)', borderRadius: 10, padding: '10px 12px', display: 'flex', flexDirection: 'column', gap: 8 }}>
                      <span style={{ fontSize: 12.5, color: 'var(--bad-ink)' }}>
                        Se anularán <strong>{anulables.length} documento{anulables.length !== 1 ? 's' : ''}</strong>: salen de Pendientes y dejan de contar como ya ingresados, así que podrás volver a subirlos.
                        {anulables.length < seleccionArr.length && ` Los otros ${seleccionArr.length - anulables.length} (ya en recepción o recibidos) no se tocan.`}
                      </span>
                      <div style={{ display: 'flex', gap: 8 }}>
                        <button onClick={anularSeleccionados}
                          style={{ padding: '8px 16px', borderRadius: 999, border: 'none', cursor: 'pointer', fontFamily: 'inherit', fontSize: 13, fontWeight: 600, background: 'var(--bad-ink)', color: '#fff' }}>
                          Sí, anular {anulables.length}
                        </button>
                        <button onClick={() => setConfirmandoAnulacion(false)}
                          style={{ padding: '8px 16px', borderRadius: 999, border: '1px solid var(--line-strong)', cursor: 'pointer', fontFamily: 'inherit', fontSize: 13, background: 'var(--paper)', color: 'var(--ink-700)' }}>
                          Cancelar
                        </button>
                      </div>
                    </div>
                  ) : (
                    <button onClick={() => setConfirmandoAnulacion(true)}
                      style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 6, padding: '9px 0', borderRadius: 10, border: '1px solid var(--bad-line)', cursor: 'pointer', fontFamily: 'inherit', fontSize: 13, fontWeight: 600, background: 'var(--paper)', color: 'var(--bad-ink)' }}>
                      <X size={14} strokeWidth={2} /> Anular seleccionados ({anulables.length})
                    </button>
                  )
                )}
              </div>

              {/* Detalle completo de cada uno, uno debajo del otro — sin scroll propio */}
              {seleccionArr.length > 30 && (
                <div style={{ fontSize: 12.5, color: 'var(--ink-500)', padding: '6px 4px' }}>
                  Son muchos documentos para mostrar el detalle de cada uno. Marca 30 o menos para verlos aquí.
                </div>
              )}
              {seleccionArr.length <= 30 && seleccionArr.map(doc => (
                <DocDetalleDrawer key={doc.id} inline docId={doc.id} refreshTick={docRefreshTick} onChanged={cargarDocumentos}
                  onClose={() => cerrarDeLaSeleccion(doc.id)}
                  onMarcarNoLeido={id => { desmarcarVistos([id]); cerrarDeLaSeleccion(id); setDocFoco(f => (f === id ? null : f)); }}
                  onAbrirCompleto={(id, accion) => {
                    const d = documentos.find(x => x.id === id);
                    if (d) abrirDesdeLista(d, accion);
                  }}
                />
              ))}
            </div>
          ) : (
            <DocDetalleDrawer
              inline
              docId={docFoco}
              docsOrden={docsOrden}
              refreshTick={docRefreshTick}
              onNavigate={id => setDocFoco(id)}
              onClose={() => setDocFoco(null)}
              onMarcarNoLeido={id => marcarNoLeido([id])}
              onChanged={cargarDocumentos}
              onAbrirCompleto={(id, accion) => {
                const d = documentos.find(x => x.id === id);
                if (d) abrirDesdeLista(d, accion);
              }}
            />
          )}
        </div>
      )}
    </div>
  );
}

// ---------------------------------------------------------------------------
// PEDIDOS A DISTRIBUIDORES — módulo unificado
// Fusiona la bandeja (pedido_marcado) con el catálogo de cada distribuidor.
// Reposición sigue igual y no se toca desde aquí.
// ---------------------------------------------------------------------------

function Pedidos({ setPagina }) {
  const [distribuidores, setDistribuidores] = useState([]); // overview con metadata
  const [bandeja,        setBandeja]        = useState([]); // pedido_marcado completo
  const [pedidos,        setPedidos]        = useState([]); // borrador + enviados
  const [cargando,       setCargando]       = useState(true);
  const [vista,          setVista]          = useState('entrada');
  const [distActivo,     setDistActivo]     = useState(null);

  useEffect(() => { cargarTodo(); }, []);

  // Mantener distActivo sincronizado cuando se recargan los distribuidores
  // (ej. después de editar datos del distribuidor vía PATCH)
  useEffect(() => {
    if (distActivo) {
      const fresh = distribuidores.find(d => d.id === distActivo.id);
      if (fresh) setDistActivo(fresh);
    }
  }, [distribuidores]); // eslint-disable-line react-hooks/exhaustive-deps

  async function cargarTodo() {
    setCargando(true);
    try {
      const [ovRes, bandejaRes, pedidosRes] = await Promise.all([
        api.get('/pedidos-distribuidor/overview'),
        api.get('/pedido-marcado'),
        api.get('/pedidos-distribuidor'),
      ]);
      setDistribuidores(ovRes.data.filter(d => d.nombre?.toLowerCase() !== 'migración'));
      setBandeja(bandejaRes.data);
      setPedidos(pedidosRes.data);
    } catch (e) {
      alert('Error al cargar pedidos: ' + e.message);
    }
    setCargando(false);
  }

  if (cargando) return <p style={{ padding: '1rem', color: '#888' }}>Cargando...</p>;

  if (vista === 'historial') {
    return <HistorialCompleto
      pedidos={pedidos.filter(p => p.estado === 'enviado')}
      onVolver={() => setVista('entrada')}
    />;
  }

  if (vista === 'distribuidor' && distActivo) {
    return <VistaDistribuidor
      dist={distActivo}
      distribuidores={distribuidores}
      bandeja={bandeja}
      setBandeja={setBandeja}
      pedidos={pedidos}
      onCambiarDist={d => setDistActivo(d)}
      onVolver={() => setVista('entrada')}
      onRecargar={cargarTodo}
      onIrADocumentos={() => setPagina && setPagina('documentos')}
    />;
  }

  return <EntradaPedidos
    distribuidores={distribuidores}
    onAbrirDistribuidor={d => { setDistActivo(d); setVista('distribuidor'); }}
    onVerHistorial={() => setVista('historial')}
    onRecargar={cargarTodo}
  />;
}

// ---------------------------------------------------------------------------
// ENTRADA: grilla de tarjetas por distribuidor
// ---------------------------------------------------------------------------
function EntradaPedidos({ distribuidores, onAbrirDistribuidor, onVerHistorial, onRecargar }) {
  const [mostrarForm, setMostrarForm] = useState(false);
  const [formNuevo, setFormNuevo] = useState({ nombre: '', factor_pago: '', rut: '' });
  const [guardandoNuevo, setGuardandoNuevo] = useState(false);

  async function crearDistribuidor(e) {
    e.preventDefault();
    if (!formNuevo.nombre.trim() || !formNuevo.factor_pago) return;
    setGuardandoNuevo(true);
    try {
      await api.post('/distribuidores', {
        nombre: formNuevo.nombre.trim(),
        factor_pago: parseFloat(formNuevo.factor_pago),
        rut: formNuevo.rut.trim() || null,
      });
      setFormNuevo({ nombre: '', factor_pago: '', rut: '' });
      setMostrarForm(false);
      await onRecargar();
    } catch (e) {
      alert('Error al crear distribuidor: ' + (e.response?.data?.error || e.message));
    }
    setGuardandoNuevo(false);
  }

  const totalBandeja = distribuidores.reduce((s, d) => s + (d.libros_en_bandeja || 0), 0);
  const totalCat     = distribuidores.filter(d => d.catalogo_actualizado_en).length;
  const conActividad = distribuidores.filter(d => d.catalogo_actualizado_en || (d.libros_en_bandeja || 0) > 0);
  const sinActividad = distribuidores.filter(d => !d.catalogo_actualizado_en && !((d.libros_en_bandeja || 0) > 0));

  function getInitials(nombre) {
    const words = nombre.trim().split(/\s+/);
    return words.length === 1 ? words[0].slice(0, 2).toUpperCase() : (words[0][0] + words[1][0]).toUpperCase();
  }

  const initStyle = {
    amber: { background: '#FFFBEB', color: '#b07000' },
    green: { background: '#F0FDF4', color: '#16803C' },
    gray:  { background: 'var(--paper-stripe)', color: 'var(--ink-500)' },
  };

  function renderRow(d, isLast) {
    const enBandeja = d.libros_en_bandeja || 0;
    const color = enBandeja > 0 ? 'amber' : d.catalogo_actualizado_en ? 'green' : 'gray';
    const fmtDate = iso => new Date(iso).toLocaleDateString('es-CL', { day: '2-digit', month: 'short' });
    return (
      <div
        key={d.id}
        onClick={() => onAbrirDistribuidor(d)}
        style={{ display: 'flex', alignItems: 'center', gap: 14, padding: '13px 18px', borderBottom: isLast ? 'none' : '1px solid var(--line)', cursor: 'pointer', transition: 'background 0.1s' }}
        onMouseEnter={e => e.currentTarget.style.background = 'var(--paper-stripe)'}
        onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
      >
        {/* Avatar */}
        <div style={{ width: 38, height: 38, borderRadius: 10, flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, fontWeight: 700, letterSpacing: '-0.01em', ...initStyle[color] }}>
          {getInitials(d.nombre)}
        </div>

        {/* Nombre + contacto */}
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontWeight: 600, fontSize: 14, color: 'var(--ink-900)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{d.nombre}</div>
          <div style={{ fontSize: 12, color: 'var(--ink-500)', marginTop: 1 }}>
            ×{d.factor_pago}{d.nombre_vendedor ? ` · ${d.nombre_vendedor}` : ''}{d.email_vendedor ? ` · ${d.email_vendedor}` : ''}
          </div>
        </div>

        {/* Columnas de estado */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 24, flexShrink: 0 }}>
          <div style={{ textAlign: 'right', minWidth: 96 }}>
            <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase', color: 'var(--ink-500)', marginBottom: 2 }}>Catálogo</div>
            {d.catalogo_actualizado_en
              ? <div style={{ fontSize: 13, color: '#16803C', display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 4 }}>
                  <span style={{ width: 6, height: 6, borderRadius: '50%', background: '#16803C', flexShrink: 0, display: 'inline-block' }} />
                  {fmtDate(d.catalogo_actualizado_en)}
                </div>
              : <div style={{ fontSize: 13, color: 'var(--ink-400)', fontStyle: 'italic' }}>—</div>
            }
          </div>
          <div style={{ textAlign: 'right', minWidth: 64 }}>
            <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase', color: 'var(--ink-500)', marginBottom: 2 }}>Bandeja</div>
            {enBandeja > 0
              ? <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', background: '#b07000', color: 'white', borderRadius: 8, padding: '1px 7px', fontSize: 12, fontWeight: 700 }}>{enBandeja}</span>
                </div>
              : <div style={{ fontSize: 13, color: 'var(--ink-400)', fontStyle: 'italic' }}>—</div>
            }
          </div>
          <div style={{ textAlign: 'right', minWidth: 90 }}>
            <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase', color: 'var(--ink-500)', marginBottom: 2 }}>Último pedido</div>
            <div style={{ fontSize: 13, color: d.ultimo_pedido_enviado ? 'var(--ink-700)' : 'var(--ink-400)', fontStyle: d.ultimo_pedido_enviado ? 'normal' : 'italic' }}>
              {d.ultimo_pedido_enviado ? fmtDate(d.ultimo_pedido_enviado) : '—'}
            </div>
          </div>
        </div>

        {/* Botón */}
        <button
          onClick={e => { e.stopPropagation(); onAbrirDistribuidor(d); }}
          style={{ padding: '5px 12px', borderRadius: 7, border: '1.5px solid var(--line)', background: 'transparent', color: 'var(--ink-500)', fontSize: 12, fontWeight: 600, fontFamily: 'var(--font-ui)', cursor: 'pointer', flexShrink: 0 }}
        >
          Abrir →
        </button>
      </div>
    );
  }

  function renderSection(titulo, items) {
    if (!items.length) return null;
    return (
      <div style={{ marginBottom: 20 }}>
        <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', color: 'var(--ink-500)', paddingBottom: 8, borderBottom: '1px solid var(--line)' }}>{titulo}</div>
        <div style={{ border: '1px solid var(--line)', borderTop: 'none', borderRadius: '0 0 12px 12px', overflow: 'hidden', background: 'var(--paper)' }}>
          {items.map((d, i) => renderRow(d, i === items.length - 1))}
        </div>
      </div>
    );
  }

  return (
    <div style={{ fontFamily: 'var(--font-ui)' }}>
      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 20, flexWrap: 'wrap', gap: 12 }}>
        <div>
          <h2 style={{ margin: '0 0 3px', fontSize: 20, fontWeight: 700 }}>Pedidos a distribuidores</h2>
          <p style={{ color: 'var(--ink-500)', margin: 0, fontSize: 13 }}>Seleccioná un distribuidor para armar o revisar un pedido.</p>
        </div>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
          <button onClick={onVerHistorial} style={{ padding: '7px 14px', background: 'transparent', border: '1.5px solid var(--line)', borderRadius: 9, cursor: 'pointer', fontSize: 13, fontWeight: 500, color: 'var(--ink-500)', fontFamily: 'var(--font-ui)' }}>
            Historial
          </button>
          <button onClick={() => setMostrarForm(v => !v)} style={{ padding: '7px 16px', background: 'var(--ink-900)', color: 'var(--paper)', border: 'none', borderRadius: 9, cursor: 'pointer', fontSize: 13, fontWeight: 600, fontFamily: 'var(--font-ui)' }}>
            {mostrarForm ? '✕ Cancelar' : '+ Distribuidor'}
          </button>
        </div>
      </div>

      {/* Stats */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 20, flexWrap: 'wrap' }}>
        {[
          { label: `${distribuidores.length} distribuidor${distribuidores.length !== 1 ? 'es' : ''}` },
          ...(totalBandeja > 0 ? [{ label: `${totalBandeja} en bandeja`, amber: true }] : []),
          { label: `${totalCat} catálogo${totalCat !== 1 ? 's' : ''} activo${totalCat !== 1 ? 's' : ''}` },
        ].map((s, i) => (
          <span key={i} style={{ display: 'inline-flex', alignItems: 'center', padding: '4px 12px', background: 'var(--paper)', border: '1px solid var(--line)', borderRadius: 8, fontSize: 12.5, fontWeight: s.amber ? 600 : 400, color: s.amber ? '#b07000' : 'var(--ink-700)' }}>
            {s.label}
          </span>
        ))}
      </div>

      {/* Formulario nuevo distribuidor */}
      {mostrarForm && (
        <form onSubmit={crearDistribuidor} style={{ background: 'var(--paper)', border: '1px solid var(--line)', borderRadius: 12, padding: '18px 20px', marginBottom: 20 }}>
          <h3 style={{ margin: '0 0 14px', fontSize: 15, fontWeight: 600 }}>Nuevo distribuidor</h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(190px, 1fr))', gap: 12 }}>
            {[
              { key: 'nombre',      label: 'Nombre *',         type: 'text',   req: true,  placeholder: 'Ej: Planeta' },
              { key: 'factor_pago', label: 'Factor de pago *', type: 'number', req: true,  placeholder: 'Ej: 0.6' },
              { key: 'rut',         label: 'RUT',              type: 'text',   req: false, placeholder: 'Ej: 76.123.456-7' },
            ].map(({ key, label, type, req, placeholder }) => (
              <div key={key}>
                <label style={{ fontSize: 12, color: 'var(--ink-500)', display: 'block', marginBottom: 4, fontWeight: 500 }}>{label}</label>
                <input
                  type={type}
                  step={key === 'factor_pago' ? '0.01' : undefined}
                  min={key === 'factor_pago' ? '0' : undefined}
                  max={key === 'factor_pago' ? '1' : undefined}
                  value={formNuevo[key]}
                  onChange={e => setFormNuevo(p => ({ ...p, [key]: e.target.value }))}
                  required={req}
                  placeholder={placeholder}
                  style={{ width: '100%', padding: '8px 10px', border: '1.5px solid var(--line)', borderRadius: 8, fontSize: 13, fontFamily: 'var(--font-ui)', boxSizing: 'border-box', background: 'var(--paper)', color: 'var(--ink-900)' }}
                />
              </div>
            ))}
          </div>
          <div style={{ marginTop: 14 }}>
            <button type="submit" disabled={guardandoNuevo} style={{ padding: '7px 18px', background: 'var(--ink-900)', color: 'var(--paper)', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 13, fontWeight: 600, fontFamily: 'var(--font-ui)' }}>
              {guardandoNuevo ? 'Guardando…' : 'Crear distribuidor'}
            </button>
          </div>
        </form>
      )}

      {renderSection('Con catálogo o actividad', conActividad)}
      {renderSection('Sin catálogo ni actividad', sinActividad)}

      {distribuidores.length === 0 && (
        <div style={{ textAlign: 'center', padding: '48px 24px', color: 'var(--ink-500)', fontSize: 14 }}>
          <div style={{ fontSize: 36, marginBottom: 12 }}>📦</div>
          <p style={{ margin: '0 0 16px' }}>No hay distribuidores cargados todavía.</p>
          <button onClick={() => setMostrarForm(true)} style={{ padding: '8px 18px', background: 'var(--ink-900)', color: 'var(--paper)', border: 'none', borderRadius: 9, cursor: 'pointer', fontSize: 13, fontWeight: 600, fontFamily: 'var(--font-ui)' }}>
            + Agregar primer distribuidor
          </button>
        </div>
      )}
    </div>
  );
}

// ---------------------------------------------------------------------------
// VISTA DISTRIBUIDOR: catálogo + resumen + historial colapsado
// ---------------------------------------------------------------------------
function VistaDistribuidor({ dist, distribuidores, bandeja, setBandeja, pedidos, onCambiarDist, onVolver, onRecargar, onIrADocumentos }) {
  const [catalogo,         setCatalogo]         = useState(null);
  const [cargandoCat,      setCargandoCat]      = useState(false);
  const [cantidades,       setCantidades]       = useState({});   // { [isbnKey]: string }
  const [pmMap,            setPmMap]            = useState({});   // { [isbnKey]: { pm_id, libro_id } }
  const [filtro,           setFiltro]           = useState('');
  const [tabActivo,        setTabActivo]        = useState('catalogo');
  const [expandidos,       setExpandidos]       = useState({});
  const [vistaMode,        setVistaMode]        = useState('prioridad');
  const [sectsAbiertas,    setSectsAbiertas]    = useState({ s1: false, s2: false, s3: false, s4: false });
  const [verCeroStock,     setVerCeroStock]     = useState(false);
  const [guardando,        setGuardando]        = useState(false);
  const [enviando,         setEnviando]         = useState(false);
  const [vincularPanel,    setVincularPanel]    = useState(null);
  const [mensajeVinc,      setMensajeVinc]      = useState('');
  const debounceRef = React.useRef({});

  // ── Datos del distribuidor ─────────────────────────────────────────────────
  const [editandoDatos,  setEditandoDatos]  = useState(false);
  const [formDatos,      setFormDatos]      = useState({});
  const [guardandoDatos, setGuardandoDatos] = useState(false);

  // ── Documentos recientes ───────────────────────────────────────────────────
  const [documentos,    setDocumentos]    = useState(null); // null = no cargado aún
  const [cargandoDocs,  setCargandoDocs]  = useState(false);

  async function guardarDatos() {
    setGuardandoDatos(true);
    try {
      await api.patch(`/distribuidores/${dist.id}`, {
        nombre:           formDatos.nombre,
        factor_pago:      parseFloat(formDatos.factor_pago) || dist.factor_pago,
        rut:              formDatos.rut || null,
        direccion:        formDatos.direccion || null,
        plazo_pago_dias:  formDatos.plazo_pago_dias === '' || formDatos.plazo_pago_dias == null ? null : parseInt(formDatos.plazo_pago_dias, 10),
        nombre_vendedor:  formDatos.nombre_vendedor || null,
        email_vendedor:   formDatos.email_vendedor || null,
        whatsapp_vendedor: formDatos.whatsapp_vendedor || null,
        notas:            formDatos.notas || null,
      });
      setEditandoDatos(false);
      await onRecargar(); // actualiza distribuidores → useEffect en Pedidos sincroniza distActivo
    } catch (e) {
      alert('Error al guardar: ' + (e.response?.data?.error || e.message));
    }
    setGuardandoDatos(false);
  }

  const cleanIsbn = isbn => isbn ? isbn.replace(/-/g, '') : null;

  const bandejaDistribuidor = bandeja.filter(l =>
    l.distribuidor_id === dist.id || l.distribuidor_id_sugerido === dist.id
  );
  const borrador = pedidos.find(p => p.distribuidor_id === dist.id && p.estado === 'borrador');
  const enviados = pedidos.filter(p => p.distribuidor_id === dist.id && p.estado === 'enviado');

  // Inicializar desde bandeja cada vez que cambia el distribuidor activo
  useEffect(() => {
    setCatalogo(null);
    setCantidades({});
    setPmMap({});
    setFiltro('');

    // Pre-llenar cantidades y pmMap con los datos persistidos de la bandeja
    const newPmMap = {};
    const newCantidades = {};
    for (const item of bandeja) {
      if (item.distribuidor_id !== dist.id && item.distribuidor_id_sugerido !== dist.id) continue;
      const key = cleanIsbn(item.isbn) || item.libro_id;
      if (key) {
        newPmMap[key] = { pm_id: item.id, libro_id: item.libro_id };
        if (item.cantidad) newCantidades[key] = String(item.cantidad);
      }
    }
    setPmMap(newPmMap);
    setCantidades(newCantidades);

    cargarCatalogo();

    // Resetear al cambiar de distribuidor
    setTabActivo('catalogo');
    setEditandoDatos(false);
    setFormDatos({});
    setDocumentos(null);
  }, [dist.id]); // eslint-disable-line react-hooks/exhaustive-deps

  // Lazy load de documentos cuando se activa ese tab
  useEffect(() => {
    if (tabActivo === 'documentos' && documentos === null) {
      setCargandoDocs(true);
      api.get(`/distribuidores/${dist.id}/resumen-documentos`)
        .then(r => setDocumentos(r.data))
        .catch(() => setDocumentos([]))
        .finally(() => setCargandoDocs(false));
    }
  }, [tabActivo, dist.id]); // eslint-disable-line react-hooks/exhaustive-deps

  async function cargarCatalogo() {
    setCargandoCat(true);
    try {
      const res = await api.get(`/catalogos/${dist.id}/actual`);
      setCatalogo(res.data);
    } catch (e) {
      if (e.response?.status !== 404) console.error('Error al cargar catálogo:', e.message);
      setCatalogo(null);
    }
    setCargandoCat(false);
  }

  // Cuando el librero tipea una cantidad en cualquier fila
  function onCantidadChange(isbn, libroId, valor) {
    const key = cleanIsbn(isbn) || libroId;
    setCantidades(prev => ({ ...prev, [key]: valor }));
    if (debounceRef.current[key]) clearTimeout(debounceRef.current[key]);
    debounceRef.current[key] = setTimeout(() => persistirCantidad(key, libroId, valor), 700);
  }

  async function persistirCantidad(isbnKey, libroId, valor) {
    const cantNum = valor ? Number(valor) : null;
    let pm = pmMap[isbnKey];
    try {
      if (!pm && libroId) {
        // Crear entrada en pedido_marcado con el distribuidor del catálogo actual
        await api.post('/pedido-marcado', { libro_id: libroId, distribuidor_id: dist.id, desde_reposicion: false });
        const bandejaRes = await api.get('/pedido-marcado');
        setBandeja(bandejaRes.data);
        const item = bandejaRes.data.find(i => i.libro_id === libroId);
        if (item) {
          pm = { pm_id: item.id, libro_id: libroId };
          setPmMap(prev => ({ ...prev, [isbnKey]: pm }));
        }
      }
      if (pm?.pm_id) {
        await api.patch(`/pedido-marcado/${pm.pm_id}`, { cantidad: cantNum });
      }
    } catch (e) {
      console.error('Error al persistir cantidad:', e.response?.data?.error || e.message);
    }
  }

  // ── listas derivadas ───────────────────────────────────────────────────
  const librosCatalogo = (catalogo?.libros || []).map(l => ({
    ...l, isbnKey: cleanIsbn(l.isbn) || l.id,
  }));

  const librosFiltrados = filtro.trim().length < 2
    ? librosCatalogo
    : librosCatalogo.filter(l =>
        [l.titulo, l.autor, l.isbn, l.editorial, l.categoria]
          .some(v => v?.toLowerCase().includes(filtro.toLowerCase()))
      );

  const isbnsCatalogo = new Set(librosCatalogo.map(l => l.isbnKey));
  const soloEnBandeja = bandejaDistribuidor.filter(l => {
    const k = cleanIsbn(l.isbn);
    return !k || !isbnsCatalogo.has(k);
  });

  const soloEnBandejaFiltrados = soloEnBandeja.filter(l =>
    filtro.trim().length < 2 || [l.titulo, l.isbn, l.editorial].some(v => v?.toLowerCase().includes(filtro.toLowerCase()))
  );
  const gruposP = {
    reponer:  librosFiltrados.filter(l => l.en_reposicion),
    precio:   librosFiltrados.filter(l => !l.en_reposicion && l.precio_actualizado).sort((a, b) => (b.stock_propio ?? 0) - (a.stock_propio ?? 0)),
    enStock:  librosFiltrados.filter(l => !l.en_reposicion && !l.precio_actualizado && l.stock_propio > 0).sort((a, b) => (b.stock_propio ?? 0) - (a.stock_propio ?? 0)),
    sinStock: librosFiltrados.filter(l => !l.en_reposicion && !l.precio_actualizado && l.stock_propio === 0),
  };

  // Resumen: todo con cantidad > 0 (catálogo + solo-bandeja)
  const itemsConCantidad = [];
  for (const l of librosCatalogo) {
    const cant = Number(cantidades[l.isbnKey]);
    if (cant > 0) itemsConCantidad.push({ ...l, cantidad: cant });
  }
  for (const l of soloEnBandeja) {
    const k = cleanIsbn(l.isbn) || l.libro_id;
    const cant = Number(cantidades[k] ?? (l.cantidad || 0));
    if (cant > 0) itemsConCantidad.push({
      titulo: l.titulo, autor: l.autor, isbn: l.isbn, editorial: l.editorial,
      precio_neto: null, pvp_sugerido: null, costo_sugerido: null,
      libro_id: l.libro_id, cantidad: cant,
    });
  }

  async function guardarBorrador() {
    const items = itemsConCantidad.filter(l => l.libro_id).map(l => ({ libro_id: l.libro_id, cantidad: l.cantidad }));
    if (items.length === 0) return alert('No hay libros con cantidad asignada (o no están en el inventario)');
    setGuardando(true);
    try {
      await api.post('/pedidos-distribuidor', { distribuidor_id: dist.id, items });
      await onRecargar();
    } catch (e) {
      alert('Error al guardar borrador: ' + (e.response?.data?.error || e.message));
    }
    setGuardando(false);
  }

  async function enviarPedido() {
    if (!window.confirm(`¿Enviar pedido a ${dist.nombre}?\n\nLos libros saldrán de la bandeja. La reposición no se modifica.`)) return;
    setEnviando(true);
    try {
      let pedidoId = borrador?.id;
      if (!pedidoId) {
        const items = itemsConCantidad.filter(l => l.libro_id).map(l => ({ libro_id: l.libro_id, cantidad: l.cantidad }));
        if (items.length === 0) { setEnviando(false); return alert('No hay libros con cantidad asignada'); }
        const r = await api.post('/pedidos-distribuidor', { distribuidor_id: dist.id, items });
        pedidoId = r.data.id;
      }
      await api.post(`/pedidos-distribuidor/${pedidoId}/enviar`);
      setCantidades({});
      setPmMap({});
      await onRecargar();
    } catch (e) {
      alert('Error al enviar: ' + (e.response?.data?.error || e.message));
    }
    setEnviando(false);
  }

  async function abrirVincular(catalogoId) {
    setVincularPanel({ catalogoId, cargando: true, confirmando: false, data: null, seleccionados: new Set(), conflictoElegido: {}, aceptarTitulo: {} });
    try {
      const res = await api.get(`/catalogos/${catalogoId}/vincular-preview`);
      const data = res.data;
      const seleccionados = new Set(data.matches.map(m => m.libro_id));
      const conflictoElegido = {};
      for (const c of data.conflictos) {
        conflictoElegido[c.libro_id] = c.opciones[0]?.distribuidor_id || '';
      }
      setVincularPanel(prev => ({ ...prev, cargando: false, data, seleccionados, conflictoElegido }));
    } catch (e) {
      alert('Error al cargar preview: ' + (e.response?.data?.error || e.message));
      setVincularPanel(null);
    }
  }

  async function confirmarVincular() {
    if (!vincularPanel?.data) return;
    const { catalogoId, seleccionados, conflictoElegido, aceptarTitulo, data } = vincularPanel;

    const vinculos = [];
    for (const m of data.matches) {
      if (seleccionados.has(m.libro_id)) {
        vinculos.push({ libro_id: m.libro_id, distribuidor_id: m.distribuidor_id, aceptar_titulo: aceptarTitulo[m.libro_id] || false });
      }
    }
    for (const c of data.conflictos) {
      const distId = conflictoElegido[c.libro_id];
      if (distId) {
        vinculos.push({ libro_id: c.libro_id, distribuidor_id: distId, aceptar_titulo: aceptarTitulo[c.libro_id] || false });
      }
    }

    if (vinculos.length === 0) { setVincularPanel(null); return; }

    setVincularPanel(prev => ({ ...prev, confirmando: true }));
    try {
      const res = await api.post(`/catalogos/${catalogoId}/vincular-confirmar`, { vinculos });
      const { libros_vinculados, campos_actualizados } = res.data;
      setMensajeVinc(`✓ ${libros_vinculados} libro${libros_vinculados !== 1 ? 's' : ''} vinculados · ${campos_actualizados} campo${campos_actualizados !== 1 ? 's' : ''} completados`);
      setTimeout(() => setMensajeVinc(''), 6000);
      setVincularPanel(null);
      // Refrescar catálogo para reflejar nuevos datos bibliográficos
      cargarCatalogo();
    } catch (e) {
      alert('Error al vincular: ' + (e.response?.data?.error || e.message));
      setVincularPanel(prev => ({ ...prev, confirmando: false }));
    }
  }

  function exportarExcel() {
    if (itemsConCantidad.length === 0) return alert('No hay libros con cantidad mayor a 0');
    const encabezado = ['ISBN', 'Titulo', 'Autor', 'Editorial', 'Categoria', 'Precio neto', 'PVP', 'Costo', 'Cantidad'];
    const filas = itemsConCantidad.map(l => [
      l.isbn || '',
      l.titulo || '',
      l.autor || '',
      l.editorial || '',
      l.categoria || '',
      l.precio_neto ?? '',
      l.pvp_sugerido ?? '',
      l.costo_sugerido ?? '',
      l.cantidad,
    ]);
    const ws = XLSX.utils.aoa_to_sheet([encabezado, ...filas]);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Pedido');
    const fecha = new Date().toISOString().split('T')[0];
    saveAs(
      new Blob([XLSX.write(wb, { bookType: 'xlsx', type: 'array' })], { type: 'application/octet-stream' }),
      `pedido_${dist.nombre.replace(/\s+/g, '_')}_${fecha}.xlsx`
    );
  }

  // ── render ─────────────────────────────────────────────────────────────
  const TABS = [
    { id: 'catalogo',   label: 'Catálogo' },
    { id: 'pedido',     label: 'Pedido',                badge: itemsConCantidad.length > 0 ? itemsConCantidad.length : null },
    { id: 'documentos', label: 'Documentos' },
    { id: 'historial',  label: `Historial (${enviados.length})` },
  ];

  return (
    <div>
      {/* Nav de distribuidores */}
      <div style={{ display: 'flex', alignItems: 'center', borderBottom: '2px solid #e0e0e0', marginBottom: '1rem', overflowX: 'auto' }}>
        <button onClick={onVolver} style={{ padding: '0.5rem 0.75rem', background: 'none', border: 'none', cursor: 'pointer', color: '#888', fontSize: '0.9rem', whiteSpace: 'nowrap', flexShrink: 0 }}>
          ← Inicio
        </button>
        <div style={{ width: '1px', background: '#e0e0e0', height: '1.4rem', margin: '0 0.25rem', flexShrink: 0 }} />
        {distribuidores.map(d => (
          <button key={d.id} onClick={() => onCambiarDist(d)} style={{
            padding: '0.5rem 0.85rem', background: 'none', border: 'none',
            borderBottom: d.id === dist.id ? '2px solid #2c2c2a' : '2px solid transparent',
            marginBottom: '-2px', cursor: 'pointer',
            fontWeight: d.id === dist.id ? 700 : 400,
            color: d.id === dist.id ? '#2c2c2a' : '#666',
            fontSize: '0.88rem', whiteSpace: 'nowrap', flexShrink: 0,
          }}>
            {d.nombre}
            {(d.libros_en_bandeja || 0) > 0 && (
              <span style={{ marginLeft: '0.3rem', background: '#2c2c2a', color: 'white', borderRadius: '10px', padding: '0.05rem 0.4rem', fontSize: '0.7rem' }}>
                {d.libros_en_bandeja}
              </span>
            )}
          </button>
        ))}
      </div>

      {/* Header fijo del distribuidor */}
      <div style={{ marginBottom: 0 }}>

        {/* Fila 1: nombre + factor + estado catálogo + botón Editar */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', flexWrap: 'wrap', marginBottom: '0.4rem' }}>
          <h2 style={{ margin: 0, fontSize: '1.3rem' }}>{dist.nombre}</h2>
          <span style={{ fontSize: '0.8rem', color: '#666', background: '#f0f0f0', borderRadius: '10px', padding: '0.15rem 0.55rem', whiteSpace: 'nowrap' }}>
            ×{dist.factor_pago}
          </span>
          {cargandoCat
            ? <span style={{ fontSize: '0.8rem', color: '#aaa' }}>Cargando catálogo…</span>
            : catalogo
              ? <span style={{ fontSize: '0.8rem', color: '#1a6b3c' }}>Catálogo del {new Date(catalogo.creado_en).toLocaleDateString('es-CL')} · {catalogo.libros.length} títulos</span>
              : <span style={{ fontSize: '0.8rem', color: '#bbb' }}>Sin catálogo</span>
          }
          {!editandoDatos && (
            <button
              onClick={() => {
                setFormDatos({
                  nombre:            dist.nombre            || '',
                  factor_pago:       dist.factor_pago       ?? '',
                  rut:               dist.rut               || '',
                  nombre_vendedor:   dist.nombre_vendedor   || '',
                  email_vendedor:    dist.email_vendedor    || '',
                  whatsapp_vendedor: dist.whatsapp_vendedor || '',
                  direccion:         dist.direccion         || '',
                  plazo_pago_dias:   dist.plazo_pago_dias   ?? '',
                  notas:             dist.notas             || '',
                });
                setEditandoDatos(true);
              }}
              style={{ marginLeft: 'auto', padding: '0.25rem 0.8rem', background: 'none', border: '1px solid #ccc', borderRadius: '6px', cursor: 'pointer', fontSize: '0.8rem', color: '#555', whiteSpace: 'nowrap' }}
            >
              Editar
            </button>
          )}
        </div>

        {/* Fila 2: datos en modo lectura (solo campos no vacíos) */}
        {!editandoDatos && (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.2rem 1.25rem', marginBottom: '0.75rem', fontSize: '0.81rem', color: '#666' }}>
            {dist.rut               && <span>RUT: <strong>{dist.rut}</strong></span>}
            {dist.nombre_vendedor   && <span>Vendedor: <strong>{dist.nombre_vendedor}</strong></span>}
            {dist.email_vendedor    && <span>{dist.email_vendedor}</span>}
            {dist.whatsapp_vendedor && <span>📱 {dist.whatsapp_vendedor}</span>}
            {dist.direccion         && <span>📍 {dist.direccion}</span>}
            {dist.plazo_pago_dias != null && <span>Plazo de pago: <strong>{dist.plazo_pago_dias} días</strong></span>}
            {dist.notas             && <span style={{ color: '#999', fontStyle: 'italic' }}>{dist.notas}</span>}
            {!dist.rut && !dist.nombre_vendedor && !dist.email_vendedor && !dist.whatsapp_vendedor && !dist.direccion && !dist.notas && (
              <span style={{ color: '#ccc' }}>Sin datos de contacto — hacé clic en Editar para completar</span>
            )}
          </div>
        )}

        {/* Formulario de edición inline (reemplaza la fila de datos) */}
        {editandoDatos && (
          <div style={{ background: '#f9f9f9', border: '1px solid #e0e0e0', borderRadius: '10px', padding: '1rem 1.25rem', marginBottom: '0.75rem' }}>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(190px, 1fr))', gap: '0.65rem', marginBottom: '0.75rem' }}>
              {[
                ['nombre',            'Nombre *',         'text'],
                ['factor_pago',       'Factor de pago *', 'number'],
                ['rut',               'RUT',              'text'],
                ['nombre_vendedor',   'Vendedor',         'text'],
                ['email_vendedor',    'Email vendedor',   'email'],
                ['whatsapp_vendedor', 'WhatsApp',         'text'],
                ['direccion',         'Dirección',        'text'],
                ['plazo_pago_dias',   'Plazo de pago (días)', 'number'],
              ].map(([field, label, type]) => (
                <div key={field}>
                  <label style={{ fontSize: '0.75rem', color: '#666', display: 'block', marginBottom: '0.18rem' }}>{label}</label>
                  <input
                    type={type}
                    step={field === 'factor_pago' ? '0.01' : undefined}
                    min={field === 'factor_pago' ? '0' : undefined}
                    max={field === 'factor_pago' ? '1' : undefined}
                    value={formDatos[field] ?? ''}
                    onChange={e => setFormDatos(p => ({ ...p, [field]: e.target.value }))}
                    style={{ width: '100%', padding: '0.35rem 0.55rem', border: '1px solid #ddd', borderRadius: '6px', fontSize: '0.85rem', boxSizing: 'border-box' }}
                  />
                </div>
              ))}
            </div>
            <div style={{ marginBottom: '0.75rem' }}>
              <label style={{ fontSize: '0.75rem', color: '#666', display: 'block', marginBottom: '0.18rem' }}>Notas</label>
              <textarea
                value={formDatos.notas ?? ''}
                onChange={e => setFormDatos(p => ({ ...p, notas: e.target.value }))}
                rows={2}
                style={{ width: '100%', padding: '0.35rem 0.55rem', border: '1px solid #ddd', borderRadius: '6px', fontSize: '0.85rem', boxSizing: 'border-box', resize: 'vertical' }}
              />
            </div>
            <div style={{ display: 'flex', gap: '0.5rem' }}>
              <button onClick={guardarDatos} disabled={guardandoDatos} style={{ padding: '0.35rem 1rem', background: '#2c2c2a', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '0.83rem', fontWeight: 600 }}>
                {guardandoDatos ? 'Guardando…' : 'Guardar'}
              </button>
              <button onClick={() => setEditandoDatos(false)} style={{ padding: '0.35rem 0.85rem', background: 'none', border: '1px solid #ccc', borderRadius: '6px', cursor: 'pointer', fontSize: '0.83rem', color: '#555' }}>
                Cancelar
              </button>
            </div>
          </div>
        )}

        {/* Tab bar de contenidos */}
        <div style={{ display: 'flex', borderBottom: '2px solid #e0e0e0' }}>
          {TABS.map(t => (
            <button key={t.id} onClick={() => setTabActivo(t.id)} style={{
              padding: '0.45rem 1rem',
              background: 'none',
              border: 'none',
              borderBottom: tabActivo === t.id ? '2px solid #2c2c2a' : '2px solid transparent',
              marginBottom: '-2px',
              cursor: 'pointer',
              fontWeight: tabActivo === t.id ? 700 : 400,
              color: tabActivo === t.id ? '#2c2c2a' : '#666',
              fontSize: '0.88rem',
              whiteSpace: 'nowrap',
              display: 'flex',
              alignItems: 'center',
              gap: '0.3rem',
            }}>
              {t.label}
              {t.badge && (
                <span style={{ background: '#2c2c2a', color: 'white', borderRadius: '10px', padding: '0.05rem 0.4rem', fontSize: '0.7rem' }}>
                  {t.badge}
                </span>
              )}
            </button>
          ))}
        </div>
      </div>

      {/* ── TAB: Catálogo ── */}
      {tabActivo === 'catalogo' && (
        <div style={{ paddingTop: '1rem' }}>

          {/* Toolbar: toggle de vista + búsqueda */}
          {(catalogo || soloEnBandeja.length > 0) && (
            <div style={{ display: 'flex', gap: '8px', marginBottom: '0.6rem', alignItems: 'center', flexWrap: 'wrap' }}>
              {catalogo && (
                <div style={{ display: 'flex', border: '1px solid #ddd', borderRadius: '6px', overflow: 'hidden', flexShrink: 0 }}>
                  <button
                    onClick={() => setVistaMode('prioridad')}
                    style={{ padding: '0.35rem 0.85rem', border: 'none', borderRight: '1px solid #ddd', cursor: 'pointer', background: vistaMode === 'prioridad' ? '#2c2c2a' : 'white', color: vistaMode === 'prioridad' ? 'white' : '#555', fontSize: '0.82rem' }}
                  >
                    ⊞ Por prioridad
                  </button>
                  <button
                    onClick={() => setVistaMode('todos')}
                    style={{ padding: '0.35rem 0.85rem', border: 'none', cursor: 'pointer', background: vistaMode === 'todos' ? '#2c2c2a' : 'white', color: vistaMode === 'todos' ? 'white' : '#555', fontSize: '0.82rem' }}
                  >
                    ≡ Todos
                  </button>
                </div>
              )}
              {vistaMode === 'prioridad' && (
                <button
                  onClick={() => setVerCeroStock(v => !v)}
                  style={{ padding: '0.35rem 0.75rem', border: '1px solid #ddd', borderRadius: '6px', cursor: 'pointer', background: verCeroStock ? '#2c2c2a' : 'white', color: verCeroStock ? 'white' : '#888', fontSize: '0.8rem', whiteSpace: 'nowrap', flexShrink: 0 }}
                >
                  {verCeroStock ? '✓ Con sin-stock' : 'Mostrar sin stock'}
                </button>
              )}
              <input
                type="text"
                placeholder="Filtrar por título, autor, ISBN, editorial o categoría…"
                value={filtro}
                onChange={e => setFiltro(e.target.value)}
                style={{ flex: 1, minWidth: '180px', padding: '0.38rem 0.75rem', border: '1px solid #ddd', borderRadius: '6px', fontSize: '0.88rem', boxSizing: 'border-box' }}
              />
            </div>
          )}

          {/* ─── VISTA PRIORIDAD ─── */}
          {vistaMode === 'prioridad' && catalogo && (() => {
            const SECTS = [
              { id: 's1', label: 'Reponer ya',              bg: '#fff3cd', bdr: '#ffc107', col: '#856404', items: [...soloEnBandejaFiltrados, ...gruposP.reponer] },
              { id: 's2', label: 'Precio cambió',           bg: '#e8f4fd', bdr: '#bee5f9', col: '#2980b9', items: verCeroStock ? gruposP.precio : gruposP.precio.filter(l => (l.stock_propio ?? 0) > 0) },
              { id: 's3', label: 'Ya tengo en inventario', bg: '#e8f8ef', bdr: '#a3d9b5', col: '#1a6b3c', items: gruposP.enStock },
              { id: 's4', label: 'Sin stock propio',        bg: '#f5f5f5', bdr: '#e0e0e0', col: '#666',    items: gruposP.sinStock },
            ];
            const totalItems = SECTS.reduce((s, g) => s + g.items.length, 0);
            return (
              <div>
                {SECTS.map(s => {
                  if (s.items.length === 0) return null;
                  const open = sectsAbiertas[s.id] !== false;
                  return (
                    <div key={s.id} style={{ border: `1px solid ${s.bdr}`, borderRadius: '8px', overflow: 'hidden', marginBottom: '8px' }}>
                      {/* Cabecera de sección */}
                      <div
                        onClick={() => setSectsAbiertas(p => ({ ...p, [s.id]: !open }))}
                        style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 14px', background: s.bg, cursor: 'pointer', userSelect: 'none' }}
                      >
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <span style={{ fontWeight: 600, fontSize: '0.88rem', color: '#2c2c2a' }}>{s.label}</span>
                          <span style={{ background: s.col + '22', color: s.col, borderRadius: '20px', padding: '0.05rem 0.45rem', fontSize: '0.75rem', fontWeight: 600 }}>{s.items.length}</span>
                        </div>
                        <span style={{ fontSize: '0.8rem', color: '#888', display: 'inline-block', transform: open ? '' : 'rotate(-90deg)', transition: 'transform 0.15s' }}>▾</span>
                      </div>
                      {/* Filas de la sección */}
                      {open && s.items.map((l, i) => {
                        const isBandejaItem = !l.isbnKey;
                        const key = l.isbnKey ?? (cleanIsbn(l.isbn) || l.libro_id);
                        const cant = l.isbnKey
                          ? (cantidades[l.isbnKey] || '')
                          : (cantidades[key] ?? (l.cantidad ? String(l.cantidad) : ''));
                        const stockNum = l.stock_propio ?? l.stock_actual ?? 0;
                        return (
                          <div
                            key={s.id + '-' + (l.id || i)}
                            style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 14px', borderTop: '1px solid #f0f0f0', background: Number(cant) > 0 ? '#f0f8ff' : 'transparent', fontSize: '0.85rem' }}
                          >
                            <div style={{ flex: 1, minWidth: 0 }}>
                              <div style={{ fontWeight: 500, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                {l.titulo}
                                {isBandejaItem && <span style={{ marginLeft: '0.4rem', fontSize: '0.7rem', background: '#fff3cd', color: '#856404', border: '1px solid #ffc107', borderRadius: '10px', padding: '0.05rem 0.3rem' }}>reposición</span>}
                              </div>
                              <div style={{ fontSize: '0.78rem', color: '#888', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                {[l.autor, l.editorial].filter(Boolean).join(' · ')}
                              </div>
                            </div>
                            {(s.id === 's1' || s.id === 's2') && (
                              <div style={{ textAlign: 'center', flexShrink: 0, minWidth: '52px' }}>
                                <div style={{ fontSize: '0.69rem', color: '#aaa', marginBottom: '1px' }}>bodega</div>
                                <div style={{ fontSize: '0.85rem', fontWeight: stockNum > 0 ? 600 : 400, color: stockNum > 0 ? '#1a6b3c' : '#bbb' }}>{stockNum}</div>
                              </div>
                            )}
                            {!isBandejaItem && (
                              <div style={{ textAlign: 'center', flexShrink: 0, minWidth: '72px' }}>
                                <div style={{ fontSize: '0.69rem', color: '#aaa', marginBottom: '1px' }}>dist.</div>
                                <div style={{ fontSize: '0.78rem', whiteSpace: 'nowrap', color: l.stock_texto === 'Disponible' ? '#1a6b3c' : l.stock_texto === 'Agotado' ? '#c0392b' : '#888' }}>
                                  {l.stock_texto || '—'}
                                </div>
                              </div>
                            )}
                            {s.id === 's2' && l.pvp_inventario != null && (
                              <span style={{ fontSize: '0.75rem', color: '#2980b9', whiteSpace: 'nowrap', flexShrink: 0 }}>
                                inv.&nbsp;${fmt(l.pvp_inventario)} → ${fmt(l.pvp_sugerido)}
                              </span>
                            )}
                            {s.id === 's3' && (
                              <span style={{ fontSize: '0.75rem', background: '#e8f8ef', color: '#1a6b3c', border: '1px solid #a3d9b5', borderRadius: '10px', padding: '0.05rem 0.4rem', whiteSpace: 'nowrap', flexShrink: 0 }}>
                                {stockNum} en bodega
                              </span>
                            )}
                            <span style={{ fontVariantNumeric: 'tabular-nums', color: '#555', whiteSpace: 'nowrap', flexShrink: 0, minWidth: '60px', textAlign: 'right', fontSize: '0.83rem' }}>
                              {l.precio_neto ? `$${fmt(l.precio_neto)}` : '—'}
                            </span>
                            <input
                              type="number" min="0"
                              value={cant} placeholder="0"
                              onChange={e => onCantidadChange(l.isbn, l.libro_id, e.target.value)}
                              style={{ width: '58px', padding: '0.2rem 0.3rem', textAlign: 'right', border: `1px solid ${Number(cant) > 0 ? '#2980b9' : '#ddd'}`, borderRadius: '4px', fontSize: '0.85rem', flexShrink: 0 }}
                            />
                          </div>
                        );
                      })}
                    </div>
                  );
                })}
                {totalItems === 0 && filtro.trim().length >= 2 && (
                  <p style={{ color: '#888', textAlign: 'center', padding: '1.5rem 1rem' }}>Sin resultados para "{filtro}"</p>
                )}
              </div>
            );
          })()}

          {/* ─── VISTA TODOS (tabla completa) ─── */}
          {(vistaMode === 'todos' || !catalogo) && (
            <div style={{ height: '60vh', overflowY: 'auto', overflowX: 'auto', border: '1px solid #e8e8e8', borderRadius: '8px' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.84rem', minWidth: catalogo ? '1350px' : '600px' }}>
                <thead style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                  <tr style={{ textAlign: 'left', borderBottom: '2px solid #ddd', background: '#fafafa' }}>
                    <th style={{ padding: '0.4rem 0.5rem' }}>Título</th>
                    <th style={{ padding: '0.4rem 0.5rem', color: '#888' }}>Autor</th>
                    <th style={{ padding: '0.4rem 0.5rem', color: '#888' }}>Editorial</th>
                    <th style={{ padding: '0.4rem 0.5rem', color: '#888' }}>ISBN</th>
                    {catalogo && <>
                      <th style={{ padding: '0.4rem 0.5rem', color: '#888' }}>Categoría</th>
                      <th style={{ padding: '0.4rem 0.5rem', textAlign: 'right' }}>Neto</th>
                      <th style={{ padding: '0.4rem 0.5rem', textAlign: 'right' }}>PVP</th>
                      <th style={{ padding: '0.4rem 0.5rem', textAlign: 'right' }}>Costo</th>
                      <th style={{ padding: '0.4rem 0.5rem', textAlign: 'right' }}>Stock dist.</th>
                      <th style={{ padding: '0.4rem 0.5rem', color: '#888' }}>Condición</th>
                      <th style={{ padding: '0.4rem 0.5rem', color: '#888' }}>Observaciones</th>
                    </>}
                    <th style={{ padding: '0.4rem 0.5rem', textAlign: 'right' }}>Stock propio</th>
                    <th style={{ padding: '0.4rem 0.5rem', textAlign: 'right', width: '80px' }}>Cantidad</th>
                  </tr>
                </thead>
                <tbody>
                  {soloEnBandejaFiltrados.map(l => {
                    const k = cleanIsbn(l.isbn) || l.libro_id;
                    const cant = cantidades[k] ?? (l.cantidad ? String(l.cantidad) : '');
                    return (
                      <tr key={l.id} style={{ borderBottom: '1px solid #f0f0f0', background: Number(cant) > 0 ? '#f0f8ff' : '#fffef5' }}>
                        <td style={{ padding: '0.4rem 0.5rem', fontWeight: 500 }}>
                          {l.titulo}
                          <span style={{ marginLeft: '0.4rem', fontSize: '0.7rem', background: '#fff3cd', color: '#856404', border: '1px solid #ffc107', borderRadius: '10px', padding: '0.1rem 0.35rem' }}>reposición</span>
                        </td>
                        <td style={{ padding: '0.4rem 0.5rem', color: '#888', fontSize: '0.8rem' }}>{l.autor || '—'}</td>
                        <td style={{ padding: '0.4rem 0.5rem', color: '#888', fontSize: '0.8rem' }}>{l.editorial || '—'}</td>
                        <td style={{ padding: '0.4rem 0.5rem', color: '#888', fontSize: '0.8rem' }}>{l.isbn || '—'}</td>
                        {catalogo && <>
                          <td style={{ padding: '0.4rem 0.5rem', color: '#ccc' }}>—</td>
                          <td style={{ padding: '0.4rem 0.5rem', color: '#ccc', textAlign: 'right' }}>—</td>
                          <td style={{ padding: '0.4rem 0.5rem', color: '#ccc', textAlign: 'right' }}>—</td>
                          <td style={{ padding: '0.4rem 0.5rem', color: '#ccc', textAlign: 'right' }}>—</td>
                          <td style={{ padding: '0.4rem 0.5rem', color: '#ccc', textAlign: 'right' }}>—</td>
                          <td style={{ padding: '0.4rem 0.5rem', color: '#ccc' }}>—</td>
                          <td style={{ padding: '0.4rem 0.5rem', color: '#ccc' }}>—</td>
                        </>}
                        <td style={{ padding: '0.4rem 0.5rem', textAlign: 'right' }}>
                          <span style={{ color: (l.stock_actual || 0) > 0 ? '#1a6b3c' : '#aaa', fontWeight: (l.stock_actual || 0) > 0 ? 600 : 400 }}>{l.stock_actual ?? 0}</span>
                        </td>
                        <td style={{ padding: '0.4rem 0.5rem', textAlign: 'right' }}>
                          <input type="number" min="0" value={cant} placeholder="0"
                            onChange={e => onCantidadChange(l.isbn, l.libro_id, e.target.value)}
                            style={{ width: '60px', padding: '0.25rem 0.3rem', textAlign: 'right', border: `1px solid ${Number(cant) > 0 ? '#2980b9' : '#ddd'}`, borderRadius: '4px', fontSize: '0.85rem' }}
                          />
                        </td>
                      </tr>
                    );
                  })}

                  {librosFiltrados.map(l => {
                    const cant = cantidades[l.isbnKey] || '';
                    return (
                      <tr key={l.id} style={{ borderBottom: '1px solid #f0f0f0', background: Number(cant) > 0 ? '#f0f8ff' : 'transparent' }}>
                        <td style={{ padding: '0.4rem 0.5rem', fontWeight: 500 }}>
                          {l.titulo}
                          {l.en_reposicion && (
                            <span style={{ marginLeft: '0.4rem', fontSize: '0.7rem', background: '#fff3cd', color: '#856404', border: '1px solid #ffc107', borderRadius: '10px', padding: '0.1rem 0.35rem' }}>reposición</span>
                          )}
                          {l.precio_actualizado && (
                            <span title={`PVP catálogo: $${fmt(l.pvp_sugerido)} · PVP inventario: $${fmt(l.pvp_inventario)}`} style={{ marginLeft: '0.4rem', fontSize: '0.7rem', background: '#fff0e6', color: '#c0392b', border: '1px solid #e67e22', borderRadius: '10px', padding: '0.1rem 0.35rem', cursor: 'help' }}>precio actualizado</span>
                          )}
                        </td>
                        <td style={{ padding: '0.4rem 0.5rem', color: '#888', fontSize: '0.8rem' }}>{l.autor || '—'}</td>
                        <td style={{ padding: '0.4rem 0.5rem', color: '#888', fontSize: '0.8rem' }}>{l.editorial || '—'}</td>
                        <td style={{ padding: '0.4rem 0.5rem', color: '#888', fontSize: '0.8rem' }}>{l.isbn || '—'}</td>
                        <td style={{ padding: '0.4rem 0.5rem', color: '#888' }}>{l.categoria || '—'}</td>
                        <td style={{ padding: '0.4rem 0.5rem', textAlign: 'right' }}>{l.precio_neto ? `$${fmt(l.precio_neto)}` : '—'}</td>
                        <td style={{ padding: '0.4rem 0.5rem', textAlign: 'right' }}>{l.pvp_sugerido ? `$${fmt(l.pvp_sugerido)}` : '—'}</td>
                        <td style={{ padding: '0.4rem 0.5rem', textAlign: 'right', color: '#555' }}>{l.costo_sugerido ? `$${fmt(l.costo_sugerido)}` : '—'}</td>
                        <td style={{ padding: '0.4rem 0.5rem', textAlign: 'right', color: '#888' }}>{l.stock_texto || '—'}</td>
                        <td style={{ padding: '0.4rem 0.5rem', color: '#888', fontSize: '0.8rem', whiteSpace: 'nowrap' }}>{l.condicion_venta || '—'}</td>
                        <td style={{ padding: '0.4rem 0.5rem', color: '#888', fontSize: '0.8rem', maxWidth: '180px' }}>{l.observaciones || '—'}</td>
                        <td style={{ padding: '0.4rem 0.5rem', textAlign: 'right' }}>
                          <span style={{ color: l.stock_propio > 0 ? '#1a6b3c' : '#aaa', fontWeight: l.stock_propio > 0 ? 600 : 400 }}>{l.stock_propio}</span>
                        </td>
                        <td style={{ padding: '0.4rem 0.5rem', textAlign: 'right' }}>
                          <input type="number" min="0" value={cant} placeholder="0"
                            onChange={e => onCantidadChange(l.isbn, l.libro_id, e.target.value)}
                            style={{ width: '60px', padding: '0.25rem 0.3rem', textAlign: 'right', border: `1px solid ${Number(cant) > 0 ? '#2980b9' : '#ddd'}`, borderRadius: '4px', fontSize: '0.85rem' }}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>

              {!catalogo && soloEnBandeja.length === 0 && (
                <p style={{ color: '#aaa', fontStyle: 'italic', padding: '1.5rem 1rem' }}>
                  Sin catálogo ni libros marcados. Marcá libros desde <strong>Reposición</strong> con el botón "+ Pedido".
                </p>
              )}
              {catalogo && librosFiltrados.length === 0 && filtro.trim().length >= 2 && (
                <p style={{ color: '#888', textAlign: 'center', padding: '1.5rem 1rem' }}>Sin resultados para "{filtro}"</p>
              )}
            </div>
          )}
        </div>
      )}

      {/* ── TAB: Pedido ── */}
      {tabActivo === 'pedido' && (
        <div style={{ paddingTop: '1rem' }}>
          {/* Pedido en construcción */}
          {itemsConCantidad.length > 0 ? (
            <div style={{ background: '#f9f9f9', border: '1px solid #e0e0e0', borderRadius: '10px', padding: '1.25rem', marginBottom: '1.5rem' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.75rem', flexWrap: 'wrap', gap: '0.5rem' }}>
                <h3 style={{ margin: 0, fontSize: '1rem' }}>
                  Pedido en construcción
                  <span style={{ fontWeight: 400, color: '#888', fontSize: '0.85rem', marginLeft: '0.5rem' }}>
                    {itemsConCantidad.length} título{itemsConCantidad.length !== 1 ? 's' : ''} · {itemsConCantidad.reduce((s, l) => s + l.cantidad, 0)} ejemplares
                  </span>
                </h3>
                {borrador && (
                  <span style={{ fontSize: '0.78rem', background: '#e8f4fd', color: '#2980b9', padding: '0.15rem 0.5rem', borderRadius: '10px' }}>borrador guardado</span>
                )}
              </div>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.84rem', marginBottom: '1rem' }}>
                <thead>
                  <tr style={{ textAlign: 'left', borderBottom: '1px solid #ddd' }}>
                    <th style={{ padding: '0.3rem 0.4rem' }}>Título</th>
                    <th style={{ padding: '0.3rem 0.4rem', color: '#888' }}>ISBN</th>
                    <th style={{ padding: '0.3rem 0.4rem', textAlign: 'right' }}>Neto</th>
                    <th style={{ padding: '0.3rem 0.4rem', textAlign: 'right' }}>PVP</th>
                    <th style={{ padding: '0.3rem 0.4rem', textAlign: 'right', fontWeight: 700 }}>Cant.</th>
                  </tr>
                </thead>
                <tbody>
                  {(() => {
                    // Normalizar condicion_venta a 'Firme', 'Consignación' o null
                    // Acepta 'firme', 'EN FIRME', 'CONSIGNADO', 'Consignación', etc.
                    const norm = cv => {
                      if (!cv) return null;
                      const v = cv.trim().toLowerCase();
                      if (v.includes('firme')) return 'Firme';
                      if (v.includes('cons')) return 'Consignación';
                      return cv.trim();
                    };
                    const grupos = [
                      { key: 'Firme',        label: 'Firme',         items: itemsConCantidad.filter(l => norm(l.condicion_venta) === 'Firme') },
                      { key: 'Consignación', label: 'Consignación',   items: itemsConCantidad.filter(l => norm(l.condicion_venta) === 'Consignación') },
                      { key: 'sin',          label: 'Sin condición',  items: itemsConCantidad.filter(l => !['Firme','Consignación'].includes(norm(l.condicion_venta))) },
                    ].filter(g => g.items.length > 0);
                    const mostrarEncabezados = grupos.length > 1;
                    return grupos.map(g => (
                      <React.Fragment key={g.key}>
                        {mostrarEncabezados && (
                          <tr>
                            <td colSpan={5} style={{ padding: '0.55rem 0.4rem 0.2rem', fontWeight: 700, fontSize: '0.72rem', color: '#555', textTransform: 'uppercase', letterSpacing: '0.07em', borderTop: g.key !== grupos[0].key ? '1px solid #e8e8e8' : undefined }}>
                              {g.label} <span style={{ fontWeight: 400, color: '#aaa', fontSize: '0.7rem' }}>({g.items.length})</span>
                            </td>
                          </tr>
                        )}
                        {g.items.map((l, i) => (
                          <tr key={i} style={{ borderBottom: '1px solid #f0f0f0' }}>
                            <td style={{ padding: '0.3rem 0.4rem' }}>{l.titulo}</td>
                            <td style={{ padding: '0.3rem 0.4rem', color: '#888', fontSize: '0.8rem' }}>{l.isbn || '—'}</td>
                            <td style={{ padding: '0.3rem 0.4rem', textAlign: 'right' }}>{l.precio_neto ? `$${fmt(l.precio_neto)}` : '—'}</td>
                            <td style={{ padding: '0.3rem 0.4rem', textAlign: 'right' }}>{l.pvp_sugerido ? `$${fmt(l.pvp_sugerido)}` : '—'}</td>
                            <td style={{ padding: '0.3rem 0.4rem', textAlign: 'right', fontWeight: 700 }}>{l.cantidad}</td>
                          </tr>
                        ))}
                      </React.Fragment>
                    ));
                  })()}
                </tbody>
              </table>
              <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
                <button onClick={guardarBorrador} disabled={guardando}
                  style={{ padding: '0.5rem 1rem', background: 'none', border: '1px solid #aaa', borderRadius: '6px', cursor: 'pointer', fontSize: '0.88rem', color: '#444' }}>
                  {guardando ? 'Guardando…' : '💾 Guardar borrador'}
                </button>
                <button onClick={exportarExcel}
                  style={{ padding: '0.5rem 1rem', background: 'none', border: '1px solid #1a6b3c', color: '#1a6b3c', borderRadius: '6px', cursor: 'pointer', fontSize: '0.88rem' }}>
                  ↓ Exportar Excel
                </button>
                <button onClick={enviarPedido} disabled={enviando}
                  style={{ padding: '0.5rem 1.25rem', background: '#2c2c2a', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '0.88rem', fontWeight: 600 }}>
                  {enviando ? 'Enviando…' : '✓ Enviar pedido'}
                </button>
              </div>
            </div>
          ) : (
            <div style={{ background: '#fafafa', border: '1px solid #eee', borderRadius: '10px', padding: '1.5rem', marginBottom: '1.5rem', textAlign: 'center' }}>
              <p style={{ color: '#aaa', margin: 0, fontSize: '0.9rem' }}>
                No hay libros con cantidad asignada. Asigná cantidades en el tab <strong>Catálogo</strong> para armar el pedido.
              </p>
            </div>
          )}

        </div>
      )}

      {/* ── TAB: Documentos ── */}
      {tabActivo === 'documentos' && (
        <div style={{ paddingTop: '1rem' }}>
          {cargandoDocs ? (
            <p style={{ color: '#888', fontSize: '0.88rem' }}>Cargando…</p>
          ) : documentos && documentos.length === 0 ? (
            <p style={{ color: '#aaa', fontStyle: 'italic', fontSize: '0.88rem' }}>No hay documentos registrados para este distribuidor.</p>
          ) : documentos ? (
            <>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.88rem', marginBottom: '1rem' }}>
                <thead>
                  <tr style={{ textAlign: 'left', borderBottom: '2px solid #ddd', background: '#fafafa' }}>
                    <th style={{ padding: '0.4rem 0.5rem' }}>Fecha</th>
                    <th style={{ padding: '0.4rem 0.5rem' }}>Tipo</th>
                    <th style={{ padding: '0.4rem 0.5rem' }}>Número</th>
                    <th style={{ padding: '0.4rem 0.5rem' }}>Modalidad</th>
                    <th style={{ padding: '0.4rem 0.5rem' }}>Estado</th>
                  </tr>
                </thead>
                <tbody>
                  {documentos.map(doc => (
                    <tr key={doc.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                      <td style={{ padding: '0.4rem 0.5rem', color: '#555' }}>{doc.fecha ? new Date(doc.fecha).toLocaleDateString('es-CL') : '—'}</td>
                      <td style={{ padding: '0.4rem 0.5rem', textTransform: 'capitalize' }}>{doc.tipo || '—'}</td>
                      <td style={{ padding: '0.4rem 0.5rem', color: '#555' }}>{doc.numero || '—'}</td>
                      <td style={{ padding: '0.4rem 0.5rem', color: '#888' }}>{doc.modalidad || '—'}</td>
                      <td style={{ padding: '0.4rem 0.5rem' }}>
                        <span style={{ fontSize: '0.78rem', padding: '0.1rem 0.45rem', borderRadius: '10px', background: doc.estado === 'pagado' ? '#e8f5e9' : doc.estado === 'pendiente' ? '#fff8e1' : '#f5f5f5', color: doc.estado === 'pagado' ? '#2e7d32' : doc.estado === 'pendiente' ? '#f57f17' : '#666' }}>
                          {doc.estado || '—'}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {onIrADocumentos && (
                <button onClick={onIrADocumentos} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#2980b9', fontSize: '0.85rem', padding: 0, textDecoration: 'underline' }}>
                  Ver todos los documentos →
                </button>
              )}
            </>
          ) : null}
        </div>
      )}

      {/* ── TAB: Historial ── */}
      {tabActivo === 'historial' && (
        <div style={{ paddingTop: '1rem' }}>
          {enviados.length === 0 ? (
            <p style={{ color: '#aaa', fontStyle: 'italic', fontSize: '0.9rem' }}>No hay pedidos enviados a {dist.nombre}.</p>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.88rem' }}>
              <thead>
                <tr style={{ textAlign: 'left', borderBottom: '2px solid #ddd', background: '#fafafa' }}>
                  <th style={{ padding: '0.4rem 0.5rem' }}>Fecha envío</th>
                  <th style={{ padding: '0.4rem 0.5rem', textAlign: 'right' }}>Títulos</th>
                  <th style={{ padding: '0.4rem 0.5rem', textAlign: 'right' }}>Ejemplares</th>
                  <th style={{ padding: '0.4rem 0.5rem' }}>Notas</th>
                  <th style={{ padding: '0.4rem 0.5rem' }}></th>
                </tr>
              </thead>
              <tbody>
                {enviados.map(p => (
                  <React.Fragment key={p.id}>
                    <tr style={{ borderBottom: expandidos[p.id] ? 'none' : '1px solid #eee', cursor: 'pointer' }}
                      onClick={() => setExpandidos(prev => ({ ...prev, [p.id]: !prev[p.id] }))}>
                      <td style={{ padding: '0.4rem 0.5rem', color: '#555' }}>{new Date(p.enviado_en).toLocaleDateString('es-CL')}</td>
                      <td style={{ padding: '0.4rem 0.5rem', textAlign: 'right' }}>{p.total_lineas}</td>
                      <td style={{ padding: '0.4rem 0.5rem', textAlign: 'right' }}>{p.total_ejemplares}</td>
                      <td style={{ padding: '0.4rem 0.5rem', color: '#666', fontSize: '0.82rem' }}>{p.notas || '—'}</td>
                      <td style={{ padding: '0.4rem 0.5rem', color: '#aaa', fontSize: '0.8rem' }}>{expandidos[p.id] ? '▲' : '▼'}</td>
                    </tr>
                    {expandidos[p.id] && (
                      <tr><td colSpan={5} style={{ padding: '0 0.5rem 0.75rem', borderBottom: '1px solid #eee' }}>
                        <DetallePedidoEnviado pedidoId={p.id} />
                      </td></tr>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}
    </div>
  );
}

// ---------------------------------------------------------------------------
// HISTORIAL COMPLETO: todos los pedidos enviados a todos los distribuidores
// ---------------------------------------------------------------------------
function HistorialCompleto({ pedidos, onVolver }) {
  const [expandidos, setExpandidos] = useState({});
  const ordenados = [...pedidos].sort((a, b) => new Date(b.enviado_en) - new Date(a.enviado_en));

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1.5rem' }}>
        <button onClick={onVolver} style={{ background: 'none', border: '1px solid #ccc', padding: '0.3rem 0.7rem', borderRadius: '6px', cursor: 'pointer' }}>← Volver</button>
        <h2 style={{ margin: 0 }}>Historial de pedidos enviados</h2>
      </div>
      {ordenados.length === 0 ? (
        <p style={{ color: '#aaa', fontStyle: 'italic' }}>No hay pedidos enviados todavía.</p>
      ) : (
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.9rem' }}>
          <thead>
            <tr style={{ textAlign: 'left', borderBottom: '2px solid #ccc', background: '#fafafa' }}>
              <th style={{ padding: '0.5rem' }}>Fecha envío</th>
              <th style={{ padding: '0.5rem' }}>Distribuidor</th>
              <th style={{ padding: '0.5rem', textAlign: 'right' }}>Títulos</th>
              <th style={{ padding: '0.5rem', textAlign: 'right' }}>Ejemplares</th>
              <th style={{ padding: '0.5rem' }}>Notas</th>
              <th style={{ padding: '0.5rem' }}></th>
            </tr>
          </thead>
          <tbody>
            {ordenados.map(p => (
              <React.Fragment key={p.id}>
                <tr style={{ borderBottom: expandidos[p.id] ? 'none' : '1px solid #eee', cursor: 'pointer' }}
                  onClick={() => setExpandidos(prev => ({ ...prev, [p.id]: !prev[p.id] }))}>
                  <td style={{ padding: '0.5rem', color: '#555', whiteSpace: 'nowrap' }}>{new Date(p.enviado_en).toLocaleDateString('es-CL')}</td>
                  <td style={{ padding: '0.5rem', fontWeight: 500 }}>{p.distribuidor_nombre}</td>
                  <td style={{ padding: '0.5rem', textAlign: 'right' }}>{p.total_lineas}</td>
                  <td style={{ padding: '0.5rem', textAlign: 'right' }}>{p.total_ejemplares}</td>
                  <td style={{ padding: '0.5rem', color: '#666', fontSize: '0.85rem' }}>{p.notas || '—'}</td>
                  <td style={{ padding: '0.5rem', color: '#aaa', fontSize: '0.8rem' }}>{expandidos[p.id] ? '▲ cerrar' : '▼ detalle'}</td>
                </tr>
                {expandidos[p.id] && (
                  <tr><td colSpan={6} style={{ padding: '0 0.5rem 0.75rem', borderBottom: '1px solid #eee' }}>
                    <DetallePedidoEnviado pedidoId={p.id} />
                  </td></tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

// Carga el detalle de un pedido enviado solo cuando se expande (lazy)
function DetallePedidoEnviado({ pedidoId }) {
  const [lineas, setLineas] = useState(null);
  const [error,  setError]  = useState('');

  useEffect(() => {
    api.get(`/pedidos-distribuidor/${pedidoId}`)
      .then(r => setLineas(r.data.lineas))
      .catch(e => setError(e.response?.data?.error || e.message));
  }, [pedidoId]);

  if (error)   return <p style={{ color: 'red', padding: '0.5rem', fontSize: '0.85rem' }}>Error: {error}</p>;
  if (!lineas) return <p style={{ color: '#888', padding: '0.5rem', fontSize: '0.85rem' }}>Cargando...</p>;

  return (
    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.84rem', background: '#fafafa', marginTop: '0.25rem' }}>
      <thead>
        <tr style={{ textAlign: 'left', borderBottom: '1px solid #ddd' }}>
          <th style={{ padding: '0.35rem 0.5rem' }}>Título</th>
          <th style={{ padding: '0.35rem 0.5rem', color: '#888' }}>ISBN</th>
          <th style={{ padding: '0.35rem 0.5rem', color: '#888' }}>Editorial</th>
          <th style={{ padding: '0.35rem 0.5rem', textAlign: 'right' }}>Cantidad</th>
        </tr>
      </thead>
      <tbody>
        {lineas.map(l => (
          <tr key={l.id} style={{ borderBottom: '1px solid #eee' }}>
            <td style={{ padding: '0.35rem 0.5rem' }}>{l.titulo}</td>
            <td style={{ padding: '0.35rem 0.5rem', color: '#888' }}>{l.isbn || '—'}</td>
            <td style={{ padding: '0.35rem 0.5rem', color: '#888' }}>{l.editorial || '—'}</td>
            <td style={{ padding: '0.35rem 0.5rem', textAlign: 'right', fontWeight: 600 }}>{l.cantidad}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// ---------------------------------------------------------------------------
// Comprobante de venta imprimible
// Recibe un snapshot de la venta (capturado en registrarVenta() antes de
// limpiar el estado del POS). No hace llamadas a la API.
// La clase "comprobante-print" es el ancla del @media print en index.css.
// ---------------------------------------------------------------------------

const METODO_LABEL = {
  efectivo:       'Efectivo',
  debito:         'Débito',
  credito:        'Crédito',
  transferencia:  'Transferencia',
  giftcard:       'Giftcard',
};

function Divisor() {
  return <div style={{ borderTop: '1px dashed #999', margin: '0.5rem 0' }} />;
}

function FilaComprobante({ izq, der, negrita, color }) {
  const s = { display: 'flex', justifyContent: 'space-between', fontSize: '0.82rem', fontWeight: negrita ? 700 : 400, color: color || 'inherit', lineHeight: 1.5 };
  return <div style={s}><span>{izq}</span><span>{der}</span></div>;
}

function ComprobanteVenta({ venta }) {
  const {
    fecha, carrito, subtotal, descuentoTotalMonto, descuentoTotal,
    tipoDescuentoTotal, total, pagoMixto, metodoPago, metodoPago2,
    montoPago1, montoPago2,
  } = venta;

  const fechaStr = new Date(fecha).toLocaleDateString('es-CL', { day: '2-digit', month: '2-digit', year: 'numeric' });
  const horaStr  = new Date(fecha).toLocaleTimeString('es-CL', { hour: '2-digit', minute: '2-digit' });
  const fmt      = n => `$${Number(n).toLocaleString('es-CL')}`;

  // Vuelto: solo cuando el medio es efectivo y el monto recibido supera el total
  function calcVuelto(metodo, monto, totalParcial) {
    if (metodo !== 'efectivo') return null;
    const recibido = Number(monto);
    if (!recibido || recibido <= totalParcial) return null;
    return recibido - totalParcial;
  }

  const vuelto1 = !pagoMixto ? calcVuelto(metodoPago, montoPago1, total) : calcVuelto(metodoPago, montoPago1, total - Number(montoPago2 || 0));
  const vuelto2 = pagoMixto  ? calcVuelto(metodoPago2, montoPago2, total - Number(montoPago1 || 0)) : null;

  const estiloWrapper = {
    width: 'var(--comprobante-ancho)',
    fontFamily: "'Courier New', Courier, monospace",
    fontSize: '0.8rem',
    lineHeight: 1.5,
    background: 'white',
    color: '#111',
    padding: '1rem 0.75rem',
    border: '1px dashed #ccc',
    borderRadius: '4px',
  };

  return (
    <div className="comprobante-print" style={estiloWrapper}>
      {/* Encabezado */}
      <div style={{ textAlign: 'center', marginBottom: '0.5rem' }}>
        <div style={{ fontWeight: 700, fontSize: '1rem', letterSpacing: '0.05em' }}>LIBRERÍA DE FUEGO</div>
        <div style={{ fontSize: '0.78rem', color: '#444' }}>{fechaStr} &nbsp; {horaStr}</div>
      </div>

      <Divisor />

      {/* Ítems */}
      {carrito.map((item, i) => {
        const precioBase  = Number(item.precio_unitario);
        const descItem    = Number(item.descuento) || 0;
        const precioFinal = precioBase - descItem;
        const lineaTotal  = precioFinal * item.cantidad;

        return (
          <div key={i} style={{ marginBottom: '0.35rem' }}>
            {/* Título — puede hacer wrap en papel estrecho */}
            <div style={{ fontWeight: 600, fontSize: '0.8rem', wordBreak: 'break-word' }}>{item.titulo}</div>
            <FilaComprobante
              izq={`  ${item.cantidad} × ${fmt(precioBase)}`}
              der={fmt(lineaTotal)}
            />
            {descItem > 0 && (
              <FilaComprobante
                izq={`  Desc.${item.tipoDescuento === 'porcentaje' ? ` (${item.descuentoVisual}%)` : ''}`}
                der={`-${fmt(descItem)}`}
                color="#c0392b"
              />
            )}
          </div>
        );
      })}

      <Divisor />

      {/* Totales */}
      {subtotal !== total && (
        <FilaComprobante izq="Subtotal" der={fmt(subtotal)} />
      )}
      {descuentoTotalMonto > 0 && (
        <FilaComprobante
          izq={`Descuento${tipoDescuentoTotal === 'porcentaje' ? ` (${descuentoTotal}%)` : ''}`}
          der={`-${fmt(descuentoTotalMonto)}`}
          color="#c0392b"
        />
      )}
      <FilaComprobante izq="TOTAL" der={fmt(total)} negrita />

      <Divisor />

      {/* Medios de pago */}
      {pagoMixto ? (
        <>
          <FilaComprobante izq={METODO_LABEL[metodoPago]  || metodoPago}  der={fmt(montoPago1)} />
          {vuelto1 !== null && <FilaComprobante izq="  Vuelto" der={fmt(vuelto1)} />}
          <FilaComprobante izq={METODO_LABEL[metodoPago2] || metodoPago2} der={fmt(montoPago2)} />
          {vuelto2 !== null && <FilaComprobante izq="  Vuelto" der={fmt(vuelto2)} />}
        </>
      ) : (
        <>
          <FilaComprobante izq={METODO_LABEL[metodoPago] || metodoPago} der={fmt(montoPago1 || total)} />
          {vuelto1 !== null && <FilaComprobante izq="  Vuelto" der={fmt(vuelto1)} />}
        </>
      )}

      <Divisor />

      {/* Pie */}
      <div style={{ textAlign: 'center', fontSize: '0.78rem', color: '#555', marginTop: '0.25rem' }}>
        ¡Gracias por tu compra!
      </div>
    </div>
  );
}

// ---------------------------------------------------------------------------
// Ajuste Manual de Stock
// Permite corregir diferencias entre el stock del sistema y el físico.
// Toda corrección queda registrada en ajustes_stock (audit trail permanente).
// Stock negativo está permitido pero genera alerta visual.
// ---------------------------------------------------------------------------

const MOTIVOS = [
  { value: 'conteo_fisico', label: 'Conteo físico' },
  { value: 'merma',         label: 'Merma / pérdida' },
  { value: 'daño',          label: 'Ejemplar dañado' },
  { value: 'robo',          label: 'Robo o hurto' },
  // devolucion: incluido como ajuste de emergencia.
  // TODO: en el futuro tendrá su propio flujo en el módulo de consignación,
  // con documento asociado y liquidación automática al distribuidor.
  { value: 'devolucion',    label: 'Devolución al distribuidor' },
  { value: 'otro',          label: 'Otro (especificar en notas)' },
];

const MOTIVO_LABEL = Object.fromEntries(MOTIVOS.map(m => [m.value, m.label]));


// =============================================================================
// CATÁLOGOS DE DISTRIBUIDORES
// Panel de administración exclusivo para admin: subir versiones + historial.
// La visualización de catálogos por libro está integrada en el módulo Pedidos.
// =============================================================================

function fmt(n) {
  if (n == null) return '—';
  return Number(n).toLocaleString('es-CL', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
}

// ---------------------------------------------------------------------------
// ErrorBoundary — captura errores de render en AdminCatalogos y los muestra
// en pantalla en lugar de dejar la pantalla en blanco.
// ---------------------------------------------------------------------------
class CatalogoErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, info: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, info) {
    console.error('[CatalogoErrorBoundary] error de render capturado:', error, info);
    this.setState({ info });
  }
  render() {
    if (this.state.hasError) {
      const { error, info } = this.state;
      return (
        <div style={{ margin: '1.5rem', padding: '1.25rem', background: '#fdecea', border: '2px solid #f44336', borderRadius: '8px', fontFamily: 'monospace' }}>
          <h3 style={{ color: '#b71c1c', margin: '0 0 0.75rem' }}>
            ⛔ Error de React en módulo Catálogos
          </h3>
          <p style={{ fontWeight: 600, color: '#c62828', margin: '0 0 0.5rem', fontFamily: 'sans-serif' }}>
            {error?.message || String(error)}
          </p>
          {error?.stack && (
            <pre style={{ fontSize: '0.72rem', color: '#333', background: '#fff3f3', padding: '0.75rem', borderRadius: '4px', overflowX: 'auto', whiteSpace: 'pre-wrap', margin: '0 0 0.75rem' }}>
              {error.stack}
            </pre>
          )}
          {info?.componentStack && (
            <details style={{ marginBottom: '0.75rem' }}>
              <summary style={{ cursor: 'pointer', color: '#555', fontFamily: 'sans-serif', fontSize: '0.85rem' }}>
                Component stack
              </summary>
              <pre style={{ fontSize: '0.72rem', color: '#555', marginTop: '0.4rem', whiteSpace: 'pre-wrap' }}>
                {info.componentStack}
              </pre>
            </details>
          )}
          <button
            onClick={() => this.setState({ hasError: false, error: null, info: null })}
            style={{ background: '#b71c1c', color: 'white', border: 'none', padding: '0.4rem 1rem', borderRadius: '6px', cursor: 'pointer', fontFamily: 'sans-serif', fontSize: '0.88rem' }}
          >
            Reintentar
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

function Catalogos() {
  return (
    <CatalogoErrorBoundary>
      <AdminCatalogos onVolver={null} onSubida={() => {}} distribuidores={[]} />
    </CatalogoErrorBoundary>
  );
}

// ---------------------------------------------------------------------------
// Panel de vinculación masiva ISBN → inventario (sub-componente de AdminCatalogos)
// Se extrae a nivel de módulo para evitar el anti-patrón de componente anidado.
// ---------------------------------------------------------------------------
function PanelVincular({
  data, seleccionados, conflictoElegido, aceptarTitulo, cambiosAdicionales, confirmando,
  onToggleMatch, onToggleAll, onConflictoChange, onAceptarTitulo, onCambioAdicional,
  onConfirmar, onCancelar,
}) {
  const { distribuidor_nombre, catalogo_creado_en, matches, conflictos, sin_match_count } = data;
  const sinMatchCount = sin_match_count ?? 0;
  // Guards: cualquiera de estos puede llegar undefined si el estado está en transición
  const _sel  = seleccionados     || new Set();
  const _ce   = conflictoElegido  || {};
  const _at   = aceptarTitulo     || {};
  const _ca   = cambiosAdicionales || {};
  const totalSeleccionados = _sel.size + Object.keys(_ce).filter(k => _ce[k]).length;
  const todosOn = matches.length > 0 && _sel.size === matches.length;

  const tdBase = { padding: '0.3rem 0.5rem', fontSize: '0.82rem' };
  const thBase = { ...tdBase, fontWeight: 600, background: '#e8f0fe', textAlign: 'left' };

  return (
    <div style={{ marginTop: '0.75rem', border: '1px solid #90caf9', borderRadius: '8px', overflow: 'hidden', background: 'white' }}>
      {/* Cabecera */}
      <div style={{ background: '#1565c0', color: 'white', padding: '0.5rem 1rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span style={{ fontWeight: 700 }}>
          🔗 Vincular ISBN con inventario — {distribuidor_nombre}
          <span style={{ fontWeight: 400, fontSize: '0.85rem', marginLeft: '0.5rem', opacity: 0.85 }}>
            catálogo del {new Date(catalogo_creado_en).toLocaleDateString('es-AR')}
          </span>
        </span>
        <button onClick={onCancelar} style={{ background: 'none', border: 'none', color: 'white', cursor: 'pointer', fontSize: '1.2rem', lineHeight: 1 }}>×</button>
      </div>

      <div style={{ padding: '1rem' }}>

        {/* Resumen */}
        <div style={{ display: 'flex', gap: '1.5rem', marginBottom: '1rem', fontSize: '0.88rem' }}>
          <span>
            ✅ <strong>{matches.length}</strong> coincidencia{matches.length !== 1 ? 's' : ''} directas
          </span>
          {conflictos.length > 0 && <span>⚠️ <strong>{conflictos.length}</strong> con conflicto</span>}
          {sinMatchCount > 0     && <span style={{ color: '#888' }}>❌ <strong>{sinMatchCount}</strong> sin coincidencia</span>}
        </div>

        {/* Sección 1: matches sin conflicto */}
        {matches.length > 0 && (
          <div style={{ marginBottom: '1.25rem' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.5rem' }}>
              <h4 style={{ margin: 0, fontSize: '0.9rem' }}>Coincidencias directas</h4>
              <label style={{ fontSize: '0.82rem', cursor: 'pointer', color: '#555' }}>
                <input type="checkbox" checked={todosOn} onChange={e => onToggleAll(e.target.checked)} style={{ marginRight: '0.3rem' }} />
                {todosOn ? 'Deseleccionar todos' : 'Seleccionar todos'}
              </label>
            </div>
            <div style={{ maxHeight: '260px', overflowY: 'auto', border: '1px solid #ddd', borderRadius: '6px' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr>
                    <th style={{ ...thBase, width: '30px' }}></th>
                    <th style={thBase}>ISBN</th>
                    <th style={thBase}>Título inventario</th>
                    <th style={thBase}>Campos a completar</th>
                    <th style={thBase}>Diferencias (ya tienen valor)</th>
                    <th style={thBase}>Título catálogo</th>
                  </tr>
                </thead>
                <tbody>
                  {matches.map(m => {
                    const difs = m.diferencias || [];
                    const camposAprobados = _ca[m.libro_id] || [];
                    return (
                      <tr key={m.libro_id} style={{ borderBottom: '1px solid #f0f0f0', background: _sel.has(m.libro_id) ? 'white' : '#fafafa' }}>
                        <td style={{ ...tdBase, textAlign: 'center' }}>
                          <input type="checkbox" checked={_sel.has(m.libro_id)} onChange={() => onToggleMatch(m.libro_id)} />
                        </td>
                        <td style={{ ...tdBase, color: '#888', whiteSpace: 'nowrap' }}>{m.libro_isbn || '—'}</td>
                        <td style={tdBase}>{m.libro_titulo}</td>
                        <td style={tdBase}>
                          {m.campos_a_completar.length === 0
                            ? <span style={{ color: '#aaa', fontSize: '0.78rem' }}>ninguno</span>
                            : m.campos_a_completar.map(c => (
                                <span key={c} style={{ fontSize: '0.75rem', background: '#e8f5e9', color: '#2e7d32', padding: '0.1rem 0.35rem', borderRadius: '10px', marginRight: '0.25rem' }}>{c}</span>
                              ))
                          }
                        </td>
                        <td style={{ ...tdBase, minWidth: '220px' }}>
                          {difs.length === 0
                            ? <span style={{ color: '#aaa', fontSize: '0.78rem' }}>—</span>
                            : difs.map(d => (
                                <div key={d.campo} style={{ marginBottom: '0.3rem' }}>
                                  <span style={{ fontSize: '0.72rem', fontWeight: 600, color: '#555', textTransform: 'capitalize' }}>{d.campo}:</span>
                                  <div style={{ display: 'flex', alignItems: 'baseline', gap: '0.3rem', flexWrap: 'wrap', marginTop: '0.1rem' }}>
                                    <span style={{ fontSize: '0.75rem', color: '#999', textDecoration: 'line-through' }}>{d.valor_actual}</span>
                                    <span style={{ fontSize: '0.7rem', color: '#bbb' }}>→</span>
                                    <span style={{ fontSize: '0.75rem', color: '#1565c0', fontWeight: 600 }}>{d.valor_catalogo}</span>
                                    <label style={{ display: 'inline-flex', alignItems: 'center', gap: '0.2rem', cursor: 'pointer', fontSize: '0.72rem', color: '#555', whiteSpace: 'nowrap' }}>
                                      <input
                                        type="checkbox"
                                        checked={camposAprobados.includes(d.campo)}
                                        onChange={e => onCambioAdicional(m.libro_id, d.campo, e.target.checked)}
                                        style={{ accentColor: '#1565c0' }}
                                      />
                                      actualizar
                                    </label>
                                  </div>
                                </div>
                              ))
                          }
                        </td>
                        <td style={tdBase}>
                          {m.titulo_difiere ? (
                            <span style={{ color: '#b45309', fontSize: '0.82rem' }}>
                              {m.cat_titulo}
                              <label style={{ marginLeft: '0.4rem', whiteSpace: 'nowrap', cursor: 'pointer' }}>
                                <input type="checkbox" checked={_at[m.libro_id] || false} onChange={e => onAceptarTitulo(m.libro_id, e.target.checked)} style={{ marginRight: '0.2rem' }} />
                                actualizar título
                              </label>
                            </span>
                          ) : (
                            <span style={{ color: '#aaa', fontSize: '0.78rem' }}>igual</span>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* Sección 2: conflictos */}
        {conflictos.length > 0 && (
          <div style={{ marginBottom: '1.25rem' }}>
            <h4 style={{ margin: '0 0 0.5rem', fontSize: '0.9rem' }}>⚠️ Conflictos — elegí el distribuidor para cada libro</h4>
            <p style={{ margin: '0 0 0.5rem', fontSize: '0.8rem', color: '#666' }}>
              Estos ISBN aparecen en más de un catálogo. Elegí cuál distribuidor asignar como proveedor.
            </p>
            <div style={{ maxHeight: '240px', overflowY: 'auto', border: '1px solid #ffe0b2', borderRadius: '6px' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr>
                    <th style={{ ...thBase, background: '#fff3e0' }}>ISBN</th>
                    <th style={{ ...thBase, background: '#fff3e0' }}>Título inventario</th>
                    <th style={{ ...thBase, background: '#fff3e0' }}>Asignar a distribuidor</th>
                    <th style={{ ...thBase, background: '#fff3e0' }}>Campos a completar</th>
                  </tr>
                </thead>
                <tbody>
                  {conflictos.map(c => (
                    <tr key={c.libro_id} style={{ borderBottom: '1px solid #ffeee0' }}>
                      <td style={{ ...tdBase, color: '#888', whiteSpace: 'nowrap' }}>{c.libro_isbn || '—'}</td>
                      <td style={tdBase}>{c.libro_titulo}</td>
                      <td style={tdBase}>
                        <select
                          value={_ce[c.libro_id] || ''}
                          onChange={e => onConflictoChange(c.libro_id, e.target.value)}
                          style={{ fontSize: '0.82rem', padding: '0.2rem 0.4rem', borderRadius: '4px', border: '1px solid #ccc', maxWidth: '220px' }}
                        >
                          <option value="">— No vincular —</option>
                          {c.opciones.map(op => (
                            <option key={op.distribuidor_id} value={op.distribuidor_id}>{op.distribuidor_nombre}</option>
                          ))}
                        </select>
                      </td>
                      <td style={tdBase}>
                        {c.campos_a_completar.length === 0
                          ? <span style={{ color: '#aaa', fontSize: '0.78rem' }}>ninguno</span>
                          : c.campos_a_completar.map(campo => (
                              <span key={campo} style={{ fontSize: '0.75rem', background: '#e8f5e9', color: '#2e7d32', padding: '0.1rem 0.35rem', borderRadius: '10px', marginRight: '0.25rem' }}>{campo}</span>
                            ))
                        }
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* Sección 3: sin match */}
        {sinMatchCount > 0 && (
          <p style={{ fontSize: '0.83rem', color: '#888', marginBottom: '1rem' }}>
            ❌ {sinMatchCount} libro{sinMatchCount !== 1 ? 's' : ''} en inventario con "Importación inicial"
            no aparecen en este catálogo. Podrán vincularse cuando se suba el catálogo correcto.
          </p>
        )}

        {/* Mensaje si no hay nada para vincular */}
        {matches.length === 0 && conflictos.length === 0 && (
          <p style={{ color: '#888', fontSize: '0.88rem' }}>No hay libros del inventario con "Importación inicial" que coincidan con ISBNs de este catálogo.</p>
        )}

        {/* Botones */}
        <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'center' }}>
          <button
            onClick={onConfirmar}
            disabled={confirmando || totalSeleccionados === 0}
            style={{ padding: '0.5rem 1.25rem', background: totalSeleccionados > 0 ? '#1565c0' : '#ccc', color: 'white', border: 'none', borderRadius: '6px', cursor: totalSeleccionados > 0 ? 'pointer' : 'default', fontWeight: 600 }}
          >
            {confirmando ? 'Vinculando…' : `Vincular ${totalSeleccionados} libro${totalSeleccionados !== 1 ? 's' : ''}`}
          </button>
          <button onClick={onCancelar} style={{ background: 'none', border: '1px solid #ccc', padding: '0.5rem 1rem', borderRadius: '6px', cursor: 'pointer' }}>
            Cancelar
          </button>
        </div>

      </div>
    </div>
  );
}

// ---------------------------------------------------------------------------
// ADMIN: subir nueva versión + historial
// ---------------------------------------------------------------------------
function AdminCatalogos({ onVolver, onSubida, distribuidores }) {
  const [todosLosDistr, setTodosLosDistr] = useState([]);
  const [distSel,     setDistSel]     = useState('');
  const [archivo,     setArchivo]     = useState(null);
  const [preview,     setPreview]     = useState(null);   // { total, preview, archivo }
  const [subiendo,    setSubiendo]    = useState(false);
  const [confirmando, setConfirmando] = useState(false);
  const [historial,   setHistorial]   = useState([]);
  const [expandidos,  setExpandidos]  = useState({});
  const [detalleVer,  setDetalleVer]  = useState({});     // { [catalogo_id]: [] }
  const [mensaje,     setMensaje]     = useState('');
  // notifSinDist: { count, distNombre } — banner post-subida con matches sin distribuidor
  const [notifSinDist, setNotifSinDist] = useState(null);
  // vincularPanel: estado del panel de vinculación masiva ISBN → inventario
  // null | { catalogoId, cargando, confirmando, data, seleccionados (Set), conflictoElegido {}, aceptarTitulo {} }
  const [vincularPanel, setVincularPanel] = useState(null);
  // modal nuevo distribuidor
  const [modalDistAbierto, setModalDistAbierto] = useState(false);
  const [formDist, setFormDist] = useState({ nombre: '', nombre_legal: '', rut: '', giro: '', casa_matriz: '', sucursales: '', telefono: '', email: '' });
  const [guardandoDist, setGuardandoDist] = useState(false);
  const [errorDist, setErrorDist] = useState('');

  useEffect(() => {
    // Cargar TODOS los distribuidores (no solo los que ya tienen catálogo)
    Promise.all([
      api.get('/distribuidores'),
      api.get('/catalogos/historial'),
    ]).then(([dRes, hRes]) => {
      setTodosLosDistr(dRes.data);
      setHistorial(hRes.data);
    }).catch(() => {});
  }, []);

  async function handleArchivo(e) {
    const f = e.target.files[0];
    if (!f) return;
    if (!distSel) return alert('Seleccioná un distribuidor primero');
    setArchivo(f);
    setPreview(null);
    setSubiendo(true);
    try {
      const fd = new FormData();
      fd.append('archivo', f);
      const res = await api.post(`/catalogos/${distSel}/preview`, fd, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      setPreview(res.data);
    } catch (e) {
      alert('Error al leer el archivo: ' + (e.response?.data?.error || e.message));
      setArchivo(null);
    }
    setSubiendo(false);
  }

  async function confirmarSubida() {
    if (!preview) return;
    setConfirmando(true);
    try {
      const distNombre = todosLosDistr.find(d => d.id === distSel)?.nombre || 'este distribuidor';
      const confirmarRes = await api.post(`/catalogos/${distSel}/confirmar`, { archivo: preview.archivo });
      setMensaje(`✓ Catálogo subido: ${preview.total} títulos`);
      setPreview(null);
      setArchivo(null);
      setDistSel('');
      // Refrescar historial
      const [hRes] = await Promise.all([
        api.get('/catalogos/historial'),
        onSubida(),
      ]);
      setHistorial(hRes.data);
      setTimeout(() => setMensaje(''), 5000);
      // Mostrar notificación si hay libros sin distribuidor que coinciden
      const matches = confirmarRes.data.matches_sin_distribuidor || 0;
      if (matches > 0) {
        setNotifSinDist({ count: matches, distNombre });
        sessionStorage.setItem('reposicion_abrir_sin_dist', '1');
      }
    } catch (e) {
      alert('Error al confirmar: ' + (e.response?.data?.error || e.message));
    }
    setConfirmando(false);
  }

  async function verDetalle(catalogoId) {
    if (detalleVer[catalogoId]) {
      setExpandidos(prev => ({ ...prev, [catalogoId]: !prev[catalogoId] }));
      return;
    }
    try {
      const res = await api.get(`/catalogos/${catalogoId}/detalle`);
      setDetalleVer(prev => ({ ...prev, [catalogoId]: res.data }));
      setExpandidos(prev => ({ ...prev, [catalogoId]: true }));
    } catch (e) {
      alert('Error al cargar detalle');
    }
  }

  // -------------------------------------------------------------------------
  // Vincular ISBNs: el backend hace el cruce completo en una sola query SQL
  // -------------------------------------------------------------------------
  async function abrirVincular(catalogoId) {
    setVincularPanel({
      catalogoId,
      cargando:          true,
      data:              null,
      confirmando:       false,
      seleccionados:     new Set(),
      conflictoElegido:  {},
      aceptarTitulo:     {},
      cambiosAdicionales: {},
    });

    try {
      const res = await api.get(`/catalogos/${catalogoId}/vincular-preview`);
      const data = res.data;
      const seleccionados = new Set(data.matches.map(m => m.libro_id));
      setVincularPanel(prev => prev ? {
        ...prev,
        cargando:          false,
        data,
        seleccionados,
        conflictoElegido:  {},
        aceptarTitulo:     {},
        cambiosAdicionales: {},
      } : null);
    } catch (e) {
      const msg = e.response?.data?.error || e.message;
      setVincularPanel(prev => prev ? {
        ...prev,
        cargando: false,
        errorMsg: `Error: ${msg}`,
      } : null);
    }
  }

  function handleCambioAdicional(libro_id, campo, aceptado) {
    setVincularPanel(prev => {
      if (!prev) return prev;
      const prevCA = prev.cambiosAdicionales || {};
      const actual = prevCA[libro_id] || [];
      const next = aceptado ? [...actual, campo] : actual.filter(c => c !== campo);
      return { ...prev, cambiosAdicionales: { ...prevCA, [libro_id]: next } };
    });
  }

  // -------------------------------------------------------------------------
  // Vincular ISBNs: confirmar
  // -------------------------------------------------------------------------
  async function confirmarVincular() {
    if (!vincularPanel?.data) return;
    const { catalogoId, seleccionados, conflictoElegido, aceptarTitulo, cambiosAdicionales, data } = vincularPanel;

    const _sel2 = seleccionados     || new Set();
    const _ce2  = conflictoElegido  || {};
    const _at2  = aceptarTitulo     || {};
    const _ca2  = cambiosAdicionales || {};

    const vinculos = [];
    for (const m of data.matches) {
      if (_sel2.has(m.libro_id)) {
        vinculos.push({
          libro_id:            m.libro_id,
          distribuidor_id:     m.distribuidor_id,
          aceptar_titulo:      _at2[m.libro_id] || false,
          cambios_adicionales: _ca2[m.libro_id] || [],
        });
      }
    }
    for (const c of data.conflictos) {
      const distId = _ce2[c.libro_id];
      if (distId) {
        vinculos.push({
          libro_id:            c.libro_id,
          distribuidor_id:     distId,
          aceptar_titulo:      _at2[c.libro_id] || false,
          cambios_adicionales: _ca2[c.libro_id] || [],
        });
      }
    }

    if (vinculos.length === 0) { setVincularPanel(null); return; }

    setVincularPanel(prev => ({ ...prev, confirmando: true }));
    try {
      const res = await api.post(`/catalogos/${catalogoId}/vincular-confirmar`, { vinculos });
      const { libros_vinculados, campos_actualizados } = res.data;
      setMensaje(`✓ ${libros_vinculados} libro${libros_vinculados !== 1 ? 's' : ''} vinculados · ${campos_actualizados} campo${campos_actualizados !== 1 ? 's' : ''} completados`);
      setTimeout(() => setMensaje(''), 6000);
      setVincularPanel(null);
      const hRes = await api.get('/catalogos/historial');
      setHistorial(hRes.data);
    } catch (e) {
      alert('Error al vincular: ' + (e.response?.data?.error || e.message));
      setVincularPanel(prev => ({ ...prev, confirmando: false }));
    }
  }

  // ── Crear distribuidor ────────────────────────────────────────────────────
  async function crearDistribuidor(e) {
    e.preventDefault();
    if (!formDist.nombre.trim()) { setErrorDist('El nombre es obligatorio'); return; }
    setGuardandoDist(true);
    setErrorDist('');
    try {
      const res = await api.post('/distribuidores', {
        nombre:       formDist.nombre.trim(),
        nombre_legal: formDist.nombre_legal.trim() || null,
        rut:          formDist.rut.trim()          || null,
        giro:         formDist.giro.trim()         || null,
        casa_matriz:  formDist.casa_matriz.trim()  || null,
        sucursales:   formDist.sucursales.trim()   || null,
        telefono:     formDist.telefono.trim()     || null,
        email:        formDist.email.trim()        || null,
      });
      setTodosLosDistr(prev => [...prev, res.data]);
      setModalDistAbierto(false);
      setFormDist({ nombre: '', nombre_legal: '', rut: '', giro: '', casa_matriz: '', sucursales: '', telefono: '', email: '' });
    } catch (err) {
      setErrorDist(err.response?.data?.error || err.message);
    }
    setGuardandoDist(false);
  }

  // Agrupar historial por distribuidor
  const porDistribuidor = historial.reduce((acc, c) => {
    if (!acc[c.distribuidor_id]) acc[c.distribuidor_id] = { nombre: c.distribuidor_nombre, versiones: [] };
    acc[c.distribuidor_id].versiones.push(c);
    return acc;
  }, {});

  return (
    <div>
      {/* ── Header ── */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1.5rem' }}>
        {onVolver && (
          <button onClick={onVolver} style={{ background: 'none', border: '1px solid #ccc', padding: '0.3rem 0.7rem', borderRadius: '6px', cursor: 'pointer' }}>
            ← Volver
          </button>
        )}
        <h2 style={{ margin: 0, flex: 1, fontFamily: 'var(--font-display)', fontSize: 20, fontWeight: 700, color: 'var(--ink-900)', letterSpacing: '-0.015em' }}>Catálogos de distribuidores</h2>
        <button
          onClick={() => { setFormDist({ nombre: '', nombre_legal: '', rut: '', giro: '', casa_matriz: '', sucursales: '', telefono: '', email: '' }); setErrorDist(''); setModalDistAbierto(true); }}
          style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '7px 16px', background: 'var(--ink-900)', color: '#fff', border: 'none', borderRadius: 'var(--r-pill)', cursor: 'pointer', fontSize: 13, fontFamily: 'var(--font-ui)', fontWeight: 600, whiteSpace: 'nowrap' }}
        >
          <Plus size={14} strokeWidth={2.5} />
          Nuevo distribuidor
        </button>
      </div>

      {/* ── Modal: nuevo distribuidor ── */}
      {modalDistAbierto && (
        <div
          onClick={e => { if (e.target === e.currentTarget) setModalDistAbierto(false); }}
          style={{ position: 'fixed', inset: 0, background: 'var(--scrim)', zIndex: 'var(--z-modal)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}
        >
          <div style={{ background: 'var(--paper)', borderRadius: 20, width: '100%', maxWidth: 560, boxShadow: 'var(--shadow-bot)', overflow: 'hidden' }}>
            {/* Modal header */}
            <div style={{ padding: '20px 24px 16px', borderBottom: '1px solid var(--line-soft)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <div>
                <div style={{ fontFamily: 'var(--font-display)', fontSize: 17, fontWeight: 700, color: 'var(--ink-900)', letterSpacing: '-0.01em' }}>Nuevo distribuidor</div>
                <div style={{ fontSize: 12, color: 'var(--ink-500)', fontFamily: 'var(--font-ui)', marginTop: 2 }}>Completá los datos del proveedor</div>
              </div>
              <button
                onClick={() => setModalDistAbierto(false)}
                style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--ink-400)', padding: 4, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
              >
                <X size={18} strokeWidth={2} />
              </button>
            </div>

            {/* Modal body */}
            <form onSubmit={crearDistribuidor} style={{ padding: '4px 24px 24px', display: 'flex', flexDirection: 'column', gap: 0, maxHeight: 'calc(100vh - 200px)', overflowY: 'auto' }}>
              {(() => {
                const lbl = (text, req) => (
                  <label style={{ display: 'block', fontSize: 11, fontWeight: 600, color: 'var(--ink-500)', fontFamily: 'var(--font-ui)', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 5 }}>
                    {text}{req
                      ? <span style={{ color: 'var(--brand)', marginLeft: 3 }}>*</span>
                      : <span style={{ color: 'var(--ink-300)', fontWeight: 400, textTransform: 'none', letterSpacing: 0, fontSize: 10, marginLeft: 5 }}>opcional</span>
                    }
                  </label>
                );
                const inputSt = (err) => ({ width: '100%', padding: '9px 12px', border: `1px solid ${err ? 'var(--bad-line)' : 'var(--line-strong)'}`, borderRadius: 'var(--r-md)', fontSize: 14, fontFamily: 'var(--font-ui)', color: 'var(--ink-900)', background: 'var(--paper)', boxSizing: 'border-box', outline: 'none', resize: 'vertical' });
                const field = (content) => <div style={{ marginTop: 16 }}>{content}</div>;
                return (<>
                  {/* Nombre fantasía */}
                  {field(<>
                    {lbl('Nombre fantasía', true)}
                    <input autoFocus type="text" placeholder="Ej: Planeta"
                      value={formDist.nombre}
                      onChange={e => { setFormDist(p => ({ ...p, nombre: e.target.value })); setErrorDist(''); }}
                      style={inputSt(errorDist && !formDist.nombre.trim())} />
                  </>)}

                  {/* Nombre legal */}
                  {field(<>
                    {lbl('Nombre legal', false)}
                    <input type="text" placeholder="Ej: Editorial Planeta Chilena S.A."
                      value={formDist.nombre_legal}
                      onChange={e => setFormDist(p => ({ ...p, nombre_legal: e.target.value }))}
                      style={inputSt(false)} />
                  </>)}

                  {/* RUT + Giro en fila */}
                  <div style={{ marginTop: 16, display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                    <div>
                      {lbl('RUT', false)}
                      <input type="text" placeholder="76.123.456-7"
                        value={formDist.rut}
                        onChange={e => setFormDist(p => ({ ...p, rut: e.target.value }))}
                        style={inputSt(false)} />
                    </div>
                    <div>
                      {lbl('Giro', false)}
                      <input type="text" placeholder="Ej: Distribución de libros"
                        value={formDist.giro}
                        onChange={e => setFormDist(p => ({ ...p, giro: e.target.value }))}
                        style={inputSt(false)} />
                    </div>
                  </div>

                  {/* Casa matriz */}
                  {field(<>
                    {lbl('Casa matriz', false)}
                    <textarea placeholder="Dirección de la casa central" rows={2}
                      value={formDist.casa_matriz}
                      onChange={e => setFormDist(p => ({ ...p, casa_matriz: e.target.value }))}
                      style={inputSt(false)} />
                  </>)}

                  {/* Sucursales */}
                  {field(<>
                    {lbl('Sucursales', false)}
                    <textarea placeholder={"Una por línea:\nSucursal Santiago\nSucursal Valparaíso"} rows={3}
                      value={formDist.sucursales}
                      onChange={e => setFormDist(p => ({ ...p, sucursales: e.target.value }))}
                      style={inputSt(false)} />
                  </>)}

                  {/* Teléfono + Email en fila */}
                  <div style={{ marginTop: 16, display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                    <div>
                      {lbl('Teléfono', false)}
                      <input type="tel" placeholder="+56 9 1234 5678"
                        value={formDist.telefono}
                        onChange={e => setFormDist(p => ({ ...p, telefono: e.target.value }))}
                        style={inputSt(false)} />
                    </div>
                    <div>
                      {lbl('Email', false)}
                      <input type="email" placeholder="contacto@ejemplo.com"
                        value={formDist.email}
                        onChange={e => setFormDist(p => ({ ...p, email: e.target.value }))}
                        style={inputSt(false)} />
                    </div>
                  </div>

                  {/* Error */}
                  {errorDist && (
                    <div style={{ marginTop: 16, padding: '8px 12px', background: 'var(--bad-bg)', color: 'var(--bad-ink)', borderRadius: 'var(--r-sm)', fontSize: 13, fontFamily: 'var(--font-ui)' }}>
                      {errorDist}
                    </div>
                  )}

                  {/* Acciones */}
                  <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 20, paddingTop: 16, borderTop: '1px solid var(--line-soft)' }}>
                    <button type="button" onClick={() => setModalDistAbierto(false)}
                      style={{ padding: '8px 18px', background: 'transparent', border: '1px solid var(--line-strong)', borderRadius: 'var(--r-pill)', cursor: 'pointer', fontSize: 13, fontFamily: 'var(--font-ui)', fontWeight: 500, color: 'var(--ink-700)' }}>
                      Cancelar
                    </button>
                    <button type="submit" disabled={guardandoDist || !formDist.nombre.trim()}
                      style={{ padding: '8px 20px', background: guardandoDist || !formDist.nombre.trim() ? 'var(--ink-300)' : 'var(--ink-900)', color: '#fff', border: 'none', borderRadius: 'var(--r-pill)', cursor: guardandoDist || !formDist.nombre.trim() ? 'default' : 'pointer', fontSize: 13, fontFamily: 'var(--font-ui)', fontWeight: 600 }}>
                      {guardandoDist ? 'Guardando…' : 'Crear distribuidor'}
                    </button>
                  </div>
                </>);
              })()}
            </form>
          </div>
        </div>
      )}

      {mensaje && (
        <div style={{ background: '#e8f5e9', border: '1px solid #a5d6a7', padding: '0.75rem 1rem', borderRadius: '6px', marginBottom: '1rem', color: '#2e7d32' }}>
          {mensaje}
        </div>
      )}

      {/* Banner: libros sin distribuidor que coinciden con el catálogo recién subido */}
      {notifSinDist && (
        <div style={{ background: '#fff8e1', border: '1px solid #ffe082', padding: '0.75rem 1rem', borderRadius: '6px', marginBottom: '1.5rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '1rem', flexWrap: 'wrap' }}>
          <span style={{ fontSize: '0.9rem', color: '#6d4c00' }}>
            📋 Hay <strong>{notifSinDist.count}</strong> libro{notifSinDist.count !== 1 ? 's' : ''} en Reposición
            sin distribuidor asignado que podrían ser de <strong>{notifSinDist.distNombre}</strong>.
            {' '}Revisalos en el módulo Reposición → sección <em>Sin distribuidor asignado</em>.
          </span>
          <button
            onClick={() => setNotifSinDist(null)}
            style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#aaa', fontSize: '1.1rem', padding: '0', lineHeight: 1 }}
            title="Cerrar notificación"
          >
            ×
          </button>
        </div>
      )}

      {/* Formulario de subida */}
      <div style={{ background: 'var(--paper)', border: '1px solid var(--line)', borderRadius: 16, padding: '20px 24px', marginBottom: '2rem', maxWidth: 660 }}>
        {/* Encabezado con botón plantilla */}
        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 16, marginBottom: 12 }}>
          <div>
            <div style={{ fontFamily: 'var(--font-display)', fontSize: 15, fontWeight: 700, color: 'var(--ink-900)', letterSpacing: '-0.01em', marginBottom: 4 }}>Subir nuevo catálogo</div>
            <p style={{ fontSize: 12, color: 'var(--ink-500)', margin: 0, fontFamily: 'var(--font-ui)', lineHeight: 1.5 }}>
              Columnas A–Q: ISBN · Título · Autor · Editorial · Colección · Categoría · Subcategoría · Idioma · Precio neto · Stock · Condición venta · Observaciones · Cód. distribuidor · Formato · Páginas · Medida · Edad sugerida
            </p>
          </div>
          <button
            onClick={() => {
              const headers = ['ISBN','Título','Autor','Editorial','Colección','Categoría','Subcategoría','Idioma','Precio neto','Stock','Condición venta','Observaciones','Código distribuidor','Formato','Páginas','Medida','Edad sugerida'];
              const ws = XLSX.utils.aoa_to_sheet([headers, [], [], [], [], []]);
              ws['!cols'] = [10,32,24,20,20,16,16,10,12,8,18,24,18,14,8,14,14].map(w => ({ wch: w }));
              const wb = XLSX.utils.book_new();
              XLSX.utils.book_append_sheet(wb, ws, 'Catálogo');
              XLSX.writeFile(wb, 'plantilla_catalogo.xlsx');
            }}
            style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '7px 14px', background: 'var(--canvas-deep)', color: 'var(--ink-700)', border: '1px solid var(--line-strong)', borderRadius: 'var(--r-pill)', cursor: 'pointer', fontSize: 12, fontFamily: 'var(--font-ui)', fontWeight: 600, whiteSpace: 'nowrap', flexShrink: 0 }}
          >
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
            Descargar plantilla
          </button>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
          <select
            value={distSel}
            onChange={e => { setDistSel(e.target.value); setPreview(null); setArchivo(null); }}
            style={{ padding: '0.5rem', borderRadius: '6px', border: '1px solid var(--line-strong)', fontFamily: 'var(--font-ui)', fontSize: 14, color: 'var(--ink-800)', background: 'var(--paper)' }}
          >
            <option value="">— Seleccioná un distribuidor —</option>
            {todosLosDistr.map(d => <option key={d.id} value={d.id}>{d.nombre}</option>)}
          </select>
          <input
            type="file"
            accept=".xlsx,.xls"
            disabled={!distSel || subiendo}
            onChange={handleArchivo}
            style={{ padding: '0.4rem', fontFamily: 'var(--font-ui)', fontSize: 13 }}
          />
          {subiendo && <p style={{ color: 'var(--ink-400)', margin: 0, fontSize: 13, fontFamily: 'var(--font-ui)' }}>Leyendo archivo…</p>}
        </div>

        {/* Preview */}
        {preview && (
          <div style={{ marginTop: '1.25rem' }}>
            <p style={{ margin: '0 0 0.5rem', fontWeight: 600 }}>
              Vista previa — {preview.total} títulos encontrados
            </p>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.82rem', marginBottom: '1rem' }}>
              <thead>
                <tr style={{ background: 'var(--paper-stripe)', textAlign: 'left', borderBottom: '1px solid var(--line)' }}>
                  {['ISBN','Título','Autor','Editorial','Colección','Categoría','Subcat.','Idioma','Precio neto','Stock','Cond. venta','Observaciones','Cód. dist.','Formato','Págs.','Medida','Edad'].map(h => (
                    <th key={h} style={{ padding: '6px 8px', fontWeight: 600, fontSize: 11, color: 'var(--ink-500)', fontFamily: 'var(--font-ui)', textTransform: 'uppercase', letterSpacing: '0.06em', whiteSpace: 'nowrap' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {preview.preview.map((r, i) => (
                  <tr key={i} style={{ borderBottom: '1px solid var(--line-soft)' }}>
                    <td style={{ padding: '5px 8px', color: 'var(--ink-400)', fontFamily: 'var(--font-mono)', fontSize: 12 }}>{r.isbn || '—'}</td>
                    <td style={{ padding: '5px 8px', color: 'var(--ink-900)', fontWeight: 500, maxWidth: 200 }}>{r.titulo}</td>
                    <td style={{ padding: '5px 8px', color: 'var(--ink-600)' }}>{r.autor || '—'}</td>
                    <td style={{ padding: '5px 8px', color: 'var(--ink-600)' }}>{r.editorial || '—'}</td>
                    <td style={{ padding: '5px 8px', color: 'var(--ink-500)' }}>{r.coleccion || '—'}</td>
                    <td style={{ padding: '5px 8px', color: 'var(--ink-500)' }}>{r.categoria || '—'}</td>
                    <td style={{ padding: '5px 8px', color: 'var(--ink-500)' }}>{r.subcategoria || '—'}</td>
                    <td style={{ padding: '5px 8px', color: 'var(--ink-500)' }}>{r.idioma || '—'}</td>
                    <td style={{ padding: '5px 8px', textAlign: 'right', color: 'var(--ink-700)', fontFamily: 'var(--font-mono)', fontSize: 12 }}>{r.precio_neto != null ? `$${fmt(r.precio_neto)}` : '—'}</td>
                    <td style={{ padding: '5px 8px', color: 'var(--ink-400)' }}>{r.stock_texto || '—'}</td>
                    <td style={{ padding: '5px 8px', color: 'var(--ink-500)' }}>{r.condicion_venta || '—'}</td>
                    <td style={{ padding: '5px 8px', color: 'var(--ink-500)', maxWidth: 140 }}>{r.observaciones || '—'}</td>
                    <td style={{ padding: '5px 8px', color: 'var(--ink-500)', fontFamily: 'var(--font-mono)', fontSize: 12 }}>{r.codigo_distribuidor || '—'}</td>
                    <td style={{ padding: '5px 8px', color: 'var(--ink-600)' }}>{r.formato || '—'}</td>
                    <td style={{ padding: '5px 8px', textAlign: 'right', color: 'var(--ink-500)', fontFamily: 'var(--font-mono)', fontSize: 12 }}>{r.paginas || '—'}</td>
                    <td style={{ padding: '5px 8px', color: 'var(--ink-500)' }}>{r.medida || '—'}</td>
                    <td style={{ padding: '5px 8px', color: 'var(--ink-500)' }}>{r.edad_sugerida || '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            {preview.total > 5 && (
              <p style={{ fontSize: '0.8rem', color: '#888', margin: '0 0 0.75rem' }}>
                … y {preview.total - 5} título{preview.total - 5 !== 1 ? 's' : ''} más
              </p>
            )}
            <div style={{ display: 'flex', gap: '0.75rem' }}>
              <button
                onClick={confirmarSubida}
                disabled={confirmando}
                style={{ padding: '0.5rem 1.25rem', background: '#1a6b3c', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: 600 }}
              >
                {confirmando ? 'Guardando…' : `Confirmar subida (${preview.total} títulos)`}
              </button>
              <button onClick={() => { setPreview(null); setArchivo(null); }} style={{ padding: '0.5rem 1rem', background: 'none', border: '1px solid #ccc', borderRadius: '6px', cursor: 'pointer' }}>
                Cancelar
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Historial de versiones */}
      <h3>Historial de catálogos</h3>
      {Object.keys(porDistribuidor).length === 0 ? (
        <p style={{ color: '#888' }}>Aún no hay catálogos cargados.</p>
      ) : (
        Object.entries(porDistribuidor).map(([distId, { nombre, versiones }]) => (
          <div key={distId} style={{ marginBottom: '1.5rem', border: '1px solid #e0e0e0', borderRadius: '8px', overflow: 'hidden' }}>
            <div style={{ background: '#f5f5f5', padding: '0.6rem 1rem', fontWeight: 700, fontSize: '0.95rem' }}>{nombre}</div>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.85rem' }}>
              <thead>
                <tr style={{ textAlign: 'left', borderBottom: '1px solid #e0e0e0', background: '#fafafa' }}>
                  <th style={{ padding: '0.4rem 0.75rem' }}>Fecha subida</th>
                  <th style={{ padding: '0.4rem 0.75rem', textAlign: 'right' }}>Títulos</th>
                  <th style={{ padding: '0.4rem 0.75rem' }}>Estado</th>
                  <th style={{ padding: '0.4rem 0.75rem' }}></th>
                </tr>
              </thead>
              <tbody>
                {versiones.map(v => (
                  <React.Fragment key={v.id}>
                    <tr style={{ borderBottom: '1px solid #f0f0f0' }}>
                      <td style={{ padding: '0.4rem 0.75rem' }}>{new Date(v.creado_en).toLocaleString('es-CL', { dateStyle: 'medium', timeStyle: 'short' })}</td>
                      <td style={{ padding: '0.4rem 0.75rem', textAlign: 'right' }}>{v.total_titulos}</td>
                      <td style={{ padding: '0.4rem 0.75rem' }}>
                        {v.es_ultimo
                          ? <span style={{ fontSize: '0.78rem', background: '#e8f5e9', color: '#2e7d32', padding: '0.15rem 0.5rem', borderRadius: '10px', fontWeight: 600 }}>Versión actual</span>
                          : <span style={{ fontSize: '0.78rem', color: '#999' }}>Versión anterior</span>
                        }
                      </td>
                      <td style={{ padding: '0.4rem 0.75rem', display: 'flex', gap: '0.4rem', flexWrap: 'wrap' }}>
                        <button onClick={() => verDetalle(v.id)} style={{ background: 'none', border: '1px solid #ccc', padding: '0.15rem 0.5rem', borderRadius: '4px', cursor: 'pointer', fontSize: '0.8rem' }}>
                          {expandidos[v.id] ? 'Ocultar' : 'Ver títulos'}
                        </button>
                        {v.es_ultimo && (
                          <button
                            onClick={() => {
                              if (vincularPanel?.catalogoId === v.id) {
                                if (vincularPanel?.cancelRef) vincularPanel.cancelRef.current = true;
                                setVincularPanel(null);
                              } else {
                                abrirVincular(v.id);
                              }
                            }}
                            style={{ background: vincularPanel?.catalogoId === v.id ? '#e3f2fd' : 'none', border: '1px solid #90caf9', padding: '0.15rem 0.5rem', borderRadius: '4px', cursor: 'pointer', fontSize: '0.8rem', color: '#1565c0', fontWeight: 600 }}
                          >
                            🔗 Vincular ISBNs
                          </button>
                        )}
                      </td>
                    </tr>
                    {/* Panel de vinculación masiva */}
                    {vincularPanel?.catalogoId === v.id && (
                      <tr>
                        <td colSpan={4} style={{ padding: '0 0.75rem 1rem', background: '#f0f7ff' }}>
                          {vincularPanel.errorMsg ? (
                            <div style={{ padding: '1rem 0.25rem' }}>
                              <div style={{ background: '#fdecea', border: '1px solid #f44336', borderRadius: '6px', padding: '0.75rem 1rem', color: '#b71c1c', fontSize: '0.88rem', marginBottom: '0.75rem' }}>
                                ❌ <strong>Error al analizar el catálogo:</strong><br />
                                <code style={{ fontSize: '0.82rem', wordBreak: 'break-all' }}>{vincularPanel.errorMsg}</code>
                              </div>
                              <p style={{ fontSize: '0.8rem', color: '#666', margin: '0 0 0.75rem' }}>
                                Revisá la consola del navegador (F12 → Console) para ver el detalle completo.
                              </p>
                              <button
                                onClick={() => setVincularPanel(null)}
                                style={{ background: 'none', border: '1px solid #ccc', padding: '0.3rem 0.85rem', borderRadius: '6px', cursor: 'pointer', fontSize: '0.83rem' }}
                              >
                                Cerrar
                              </button>
                            </div>
                          ) : vincularPanel.cargando ? (
                            <div style={{ padding: '1rem 0.25rem' }}>
                              <div style={{ fontSize: '0.9rem', color: '#1565c0', fontWeight: 600, marginBottom: '0.4rem' }}>
                                🔍 Analizando catálogo…
                              </div>
                              <p style={{ margin: 0, fontSize: '0.83rem', color: '#888' }}>
                                El servidor está cruzando los ISBNs del catálogo con el inventario. Puede tardar unos segundos.
                              </p>
                            </div>
                          ) : vincularPanel.data && (
                            <PanelVincular
                              data={vincularPanel.data}
                              seleccionados={vincularPanel.seleccionados}
                              conflictoElegido={vincularPanel.conflictoElegido}
                              aceptarTitulo={vincularPanel.aceptarTitulo}
                              cambiosAdicionales={vincularPanel.cambiosAdicionales}
                              confirmando={vincularPanel.confirmando}
                              onToggleMatch={libroId => setVincularPanel(prev => {
                                const sel = new Set(prev.seleccionados);
                                sel.has(libroId) ? sel.delete(libroId) : sel.add(libroId);
                                return { ...prev, seleccionados: sel };
                              })}
                              onToggleAll={todosOn => setVincularPanel(prev => ({
                                ...prev,
                                seleccionados: todosOn
                                  ? new Set(prev.data.matches.map(m => m.libro_id))
                                  : new Set(),
                              }))}
                              onConflictoChange={(libroId, distId) => setVincularPanel(prev => ({
                                ...prev, conflictoElegido: { ...prev.conflictoElegido, [libroId]: distId },
                              }))}
                              onAceptarTitulo={(libroId, val) => setVincularPanel(prev => ({
                                ...prev, aceptarTitulo: { ...prev.aceptarTitulo, [libroId]: val },
                              }))}
                              onCambioAdicional={handleCambioAdicional}
                              onConfirmar={confirmarVincular}
                              onCancelar={() => setVincularPanel(null)}
                            />
                          )}
                        </td>
                      </tr>
                    )}
                    {expandidos[v.id] && detalleVer[v.id] && (
                      <tr>
                        <td colSpan={4} style={{ padding: '0 0.75rem 0.75rem' }}>
                          <div style={{ maxHeight: '300px', overflowY: 'auto', border: '1px solid #eee', borderRadius: '6px' }}>
                            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.8rem' }}>
                              <thead style={{ position: 'sticky', top: 0, background: 'var(--paper-stripe)' }}>
                                <tr style={{ borderBottom: '1px solid var(--line)' }}>
                                  {['ISBN','Título','Autor','Editorial','Colección','Categoría','Subcat.','Idioma','Precio neto','Stock','Cond. venta','Observaciones','Cód. dist.','Formato','Págs.','Medida','Edad'].map(h => (
                                    <th key={h} style={{ padding: '6px 8px', textAlign: 'left', fontSize: 10, fontWeight: 600, color: 'var(--ink-500)', fontFamily: 'var(--font-ui)', textTransform: 'uppercase', letterSpacing: '0.06em', whiteSpace: 'nowrap' }}>{h}</th>
                                  ))}
                                </tr>
                              </thead>
                              <tbody>
                                {detalleVer[v.id].map(r => (
                                  <tr key={r.id} style={{ borderBottom: '1px solid var(--line-soft)' }}>
                                    <td style={{ padding: '4px 8px', color: 'var(--ink-400)', fontFamily: 'var(--font-mono)', fontSize: 11 }}>{r.isbn || '—'}</td>
                                    <td style={{ padding: '4px 8px', color: 'var(--ink-900)', fontWeight: 500 }}>{r.titulo}</td>
                                    <td style={{ padding: '4px 8px', color: 'var(--ink-600)' }}>{r.autor || '—'}</td>
                                    <td style={{ padding: '4px 8px', color: 'var(--ink-600)' }}>{r.editorial || '—'}</td>
                                    <td style={{ padding: '4px 8px', color: 'var(--ink-500)' }}>{r.coleccion || '—'}</td>
                                    <td style={{ padding: '4px 8px', color: 'var(--ink-500)' }}>{r.categoria || '—'}</td>
                                    <td style={{ padding: '4px 8px', color: 'var(--ink-500)' }}>{r.subcategoria || '—'}</td>
                                    <td style={{ padding: '4px 8px', color: 'var(--ink-500)' }}>{r.idioma || '—'}</td>
                                    <td style={{ padding: '4px 8px', textAlign: 'right', fontFamily: 'var(--font-mono)', fontSize: 11 }}>{r.precio_neto != null ? `$${fmt(r.precio_neto)}` : '—'}</td>
                                    <td style={{ padding: '4px 8px', color: 'var(--ink-400)' }}>{r.stock_texto || '—'}</td>
                                    <td style={{ padding: '4px 8px', color: 'var(--ink-500)' }}>{r.condicion_venta || '—'}</td>
                                    <td style={{ padding: '4px 8px', color: 'var(--ink-500)' }}>{r.observaciones || '—'}</td>
                                    <td style={{ padding: '4px 8px', color: 'var(--ink-500)', fontFamily: 'var(--font-mono)', fontSize: 11 }}>{r.codigo_distribuidor || '—'}</td>
                                    <td style={{ padding: '4px 8px', color: 'var(--ink-600)' }}>{r.formato || '—'}</td>
                                    <td style={{ padding: '4px 8px', textAlign: 'right', color: 'var(--ink-500)', fontFamily: 'var(--font-mono)', fontSize: 11 }}>{r.paginas || '—'}</td>
                                    <td style={{ padding: '4px 8px', color: 'var(--ink-500)' }}>{r.medida || '—'}</td>
                                    <td style={{ padding: '4px 8px', color: 'var(--ink-500)' }}>{r.edad_sugerida || '—'}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>
        ))
      )}
    </div>
  );
}

// ============================================================================
// AdminMigracion — carga masiva de inventario desde Excel
// ============================================================================
function AdminMigracion({ migracionRealizada, onMigracionCompletada, setPagina }) {
  const [archivo,     setArchivo]     = useState(null);
  const [preview,     setPreview]     = useState(null);   // { total, preview[], archivo }
  const [subiendo,    setSubiendo]    = useState(false);
  const [confirmando, setConfirmando] = useState(false);
  const [resultado,   setResultado]   = useState(null);   // { ok, libros_creados, … }
  const [error,       setError]       = useState('');

  // Plantilla Excel descargable
  function descargarPlantilla() {
    const headers = [
      'ISBN', 'Título', 'Autor', 'Editorial', 'Colección',
      'Categoría', 'Subcategoría', 'Distribuidor', 'Modalidad',
      'Stock', 'Precio neto público', 'PVP', 'Costo real', 'Observación',
    ];
    const ws = XLSX.utils.aoa_to_sheet([headers, [], [], [], [], []]);
    ws['!cols'] = [14, 32, 24, 20, 20, 14, 16, 20, 14, 8, 16, 10, 10, 24].map(w => ({ wch: w }));
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Migración');
    XLSX.writeFile(wb, 'plantilla_migracion.xlsx');
  }

  async function handleArchivo(e) {
    const file = e.target.files?.[0];
    if (!file) return;
    setArchivo(file);
    setPreview(null);
    setResultado(null);
    setError('');
    setSubiendo(true);
    try {
      const fd = new FormData();
      fd.append('archivo', file);
      const res = await api.post('/migracion/preview', fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setPreview(res.data);
    } catch (err) {
      setError(err.response?.data?.error || err.message);
    }
    setSubiendo(false);
  }

  async function confirmarMigracion() {
    if (!preview?.archivo) return;
    setConfirmando(true);
    setError('');
    try {
      const res = await api.post('/migracion/confirmar', { archivo: preview.archivo });
      setResultado(res.data);
      setPreview(null);
      setArchivo(null);
      onMigracionCompletada?.();
    } catch (err) {
      setError(err.response?.data?.error || err.message);
    }
    setConfirmando(false);
  }

  // ── estilos compartidos ──────────────────────────────────────────────────
  const thSt = {
    padding: '6px 10px', fontSize: 10, fontWeight: 600,
    color: 'var(--ink-500)', fontFamily: 'var(--font-ui)',
    textTransform: 'uppercase', letterSpacing: '0.06em', whiteSpace: 'nowrap',
    textAlign: 'left',
  };
  const tdSt  = (extra = {}) => ({
    padding: '5px 10px', fontSize: 12,
    color: 'var(--ink-700)', fontFamily: 'var(--font-ui)',
    borderBottom: '1px solid var(--line-soft)',
    ...extra,
  });

  // Pantalla de migración ya realizada
  if (migracionRealizada) return (
    <div style={{ background: 'var(--canvas)', minHeight: '100%', padding: 'var(--content-inset)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ background: 'var(--paper)', border: '1px solid var(--line)', borderRadius: 20, padding: '40px 48px', textAlign: 'center', boxShadow: 'var(--shadow-card)', maxWidth: 420 }}>
        <div style={{ width: 48, height: 48, borderRadius: '50%', background: 'var(--ok-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
          <Check size={22} color="var(--ok-ink)" />
        </div>
        <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 20, fontWeight: 800, color: 'var(--ink-900)', margin: '0 0 8px', letterSpacing: '-0.02em' }}>
          Migración completada
        </h2>
        <p style={{ fontSize: 14, color: 'var(--ink-500)', fontFamily: 'var(--font-ui)', margin: '0 0 24px', lineHeight: 1.5 }}>
          La migración inicial ya fue completada.
        </p>
        <button
          onClick={() => setPagina('dashboard')}
          style={{ padding: '9px 24px', background: 'var(--ink-900)', color: 'white', border: 'none', borderRadius: 'var(--r-pill)', cursor: 'pointer', fontFamily: 'var(--font-ui)', fontWeight: 700, fontSize: 13 }}
        >
          Volver al Dashboard
        </button>
      </div>
    </div>
  );

  return (
    <div style={{ background: 'var(--canvas)', minHeight: '100%', padding: 'var(--content-inset)' }}>

      {/* ── Encabezado ────────────────────────────────────────────────── */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 16, marginBottom: 20 }}>
        <div>
          <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 22, fontWeight: 800, color: 'var(--ink-900)', margin: 0, letterSpacing: '-0.02em' }}>
            Migración de inventario
          </h2>
          <p style={{ margin: '4px 0 0', fontSize: 13, color: 'var(--ink-400)', fontFamily: 'var(--font-ui)' }}>
            Importá libros y lotes desde un Excel. Los libros nuevos se crean automáticamente.
          </p>
        </div>
        <button
          onClick={descargarPlantilla}
          style={{
            display: 'inline-flex', alignItems: 'center', gap: 6,
            padding: '8px 16px', background: 'var(--canvas-deep)',
            color: 'var(--ink-700)', border: '1px solid var(--line-strong)',
            borderRadius: 'var(--r-pill)', cursor: 'pointer',
            fontSize: 12, fontFamily: 'var(--font-ui)', fontWeight: 600,
            whiteSpace: 'nowrap', flexShrink: 0,
          }}
        >
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
            <polyline points="7 10 12 15 17 10"/>
            <line x1="12" y1="15" x2="12" y2="3"/>
          </svg>
          Descargar plantilla
        </button>
      </div>

      {/* ── Tarjeta de subida ────────────────────────────────────────── */}
      <div style={{
        background: 'var(--paper)', border: '1px solid var(--line)',
        borderRadius: 16, padding: '20px 24px', maxWidth: 900,
        boxShadow: 'var(--shadow-card)', marginBottom: 24,
      }}>
        <div style={{ fontFamily: 'var(--font-display)', fontSize: 14, fontWeight: 700, color: 'var(--ink-900)', marginBottom: 6, letterSpacing: '-0.01em' }}>
          Subir archivo de migración
        </div>
        <p style={{ margin: '0 0 14px', fontSize: 12, color: 'var(--ink-500)', fontFamily: 'var(--font-ui)', lineHeight: 1.6 }}>
          Columnas A–N: ISBN · Título · Autor · Editorial · Colección · Categoría · Subcategoría · <strong>Distribuidor</strong> · <strong>Modalidad</strong> (firme/consignación) · Stock · Precio neto público · PVP · Costo real · Observación
        </p>

        <input
          type="file"
          accept=".xlsx,.xls"
          disabled={subiendo || confirmando}
          onChange={handleArchivo}
          style={{ padding: '0.4rem', fontFamily: 'var(--font-ui)', fontSize: 13, marginBottom: 8 }}
        />
        {subiendo && (
          <p style={{ margin: '8px 0 0', color: 'var(--ink-400)', fontSize: 13, fontFamily: 'var(--font-ui)' }}>
            Leyendo archivo…
          </p>
        )}
        {error && (
          <div style={{ marginTop: 10, padding: '10px 14px', background: 'var(--bad-bg)', border: '1px solid var(--bad-line)', borderRadius: 8, color: 'var(--bad-ink)', fontSize: 13, fontFamily: 'var(--font-ui)' }}>
            {error}
          </div>
        )}

        {/* ── Preview ─────────────────────────────────────────────────── */}
        {preview && (
          <div style={{ marginTop: 18 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 }}>
              <span style={{ fontFamily: 'var(--font-display)', fontSize: 14, fontWeight: 700, color: 'var(--ink-900)' }}>
                Vista previa
              </span>
              <span style={{
                display: 'inline-flex', alignItems: 'center',
                padding: '2px 10px', borderRadius: 'var(--r-pill)',
                background: 'var(--brand-softer)', color: 'var(--brand-ink)',
                fontSize: 11, fontFamily: 'var(--font-ui)', fontWeight: 700,
              }}>
                {preview.total} {preview.total === 1 ? 'libro' : 'libros'}
              </span>
            </div>

            <div style={{ overflowX: 'auto', border: '1px solid var(--line)', borderRadius: 10 }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
                <thead>
                  <tr style={{ background: 'var(--canvas-deep)', borderBottom: '1px solid var(--line)' }}>
                    {['ISBN','Título','Autor','Editorial','Colección','Subcat.','Distribuidor','Modalidad','Stock','P. neto','PVP','Costo','Obs.'].map(h => (
                      <th key={h} style={thSt}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {preview.preview.map((r, i) => (
                    <tr key={i} style={{ background: i % 2 === 0 ? 'var(--paper)' : 'var(--canvas)' }}>
                      <td style={tdSt({ fontFamily: 'var(--font-mono)', color: 'var(--ink-400)', fontSize: 11 })}>{r.isbn || '—'}</td>
                      <td style={tdSt({ fontWeight: 500, color: 'var(--ink-900)', maxWidth: 180 })}>{r.titulo}</td>
                      <td style={tdSt({ color: 'var(--ink-600)' })}>{r.autor || '—'}</td>
                      <td style={tdSt({ color: 'var(--ink-600)' })}>{r.editorial || '—'}</td>
                      <td style={tdSt({ color: 'var(--ink-500)' })}>{r.coleccion || '—'}</td>
                      <td style={tdSt({ color: 'var(--ink-500)' })}>{r.subcategoria || '—'}</td>
                      <td style={tdSt({ color: 'var(--ink-700)', fontWeight: 600 })}>{r.distribuidor_nombre || '—'}</td>
                      <td style={tdSt()}>
                        <span style={{
                          padding: '2px 8px', borderRadius: 'var(--r-pill)', fontSize: 11, fontWeight: 600,
                          background: r.modalidad === 'consignacion' ? 'var(--past-blue)' : 'var(--past-mint)',
                          color:      r.modalidad === 'consignacion' ? 'var(--past-blue-ink)' : 'var(--past-mint-ink)',
                        }}>
                          {r.modalidad}
                        </span>
                      </td>
                      <td style={tdSt({ textAlign: 'right', fontFamily: 'var(--font-mono)' })}>{r.stock}</td>
                      <td style={tdSt({ textAlign: 'right', fontFamily: 'var(--font-mono)', color: 'var(--ink-500)' })}>{r.precio_neto_publico != null ? `$${r.precio_neto_publico}` : '—'}</td>
                      <td style={tdSt({ textAlign: 'right', fontFamily: 'var(--font-mono)', fontWeight: 600 })}>{r.pvp ? `$${r.pvp}` : '—'}</td>
                      <td style={tdSt({ textAlign: 'right', fontFamily: 'var(--font-mono)', color: 'var(--ink-500)' })}>{r.costo_real ? `$${r.costo_real}` : '—'}</td>
                      <td style={tdSt({ color: 'var(--ink-400)', maxWidth: 140 })}>{r.observacion || '—'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {preview.total > 10 && (
              <p style={{ margin: '8px 0 0', fontSize: 12, color: 'var(--ink-400)', fontFamily: 'var(--font-ui)' }}>
                … y {preview.total - 10} {preview.total - 10 === 1 ? 'libro más' : 'libros más'}
              </p>
            )}

            <div style={{ display: 'flex', gap: 10, marginTop: 16 }}>
              <button
                onClick={confirmarMigracion}
                disabled={confirmando}
                style={{
                  padding: '9px 22px', background: 'var(--ink-900)', color: 'white',
                  border: 'none', borderRadius: 'var(--r-pill)', cursor: 'pointer',
                  fontFamily: 'var(--font-ui)', fontWeight: 700, fontSize: 13,
                  opacity: confirmando ? 0.6 : 1,
                }}
              >
                {confirmando ? 'Importando…' : `Confirmar migración (${preview.total} libros)`}
              </button>
              <button
                onClick={() => { setPreview(null); setArchivo(null); setError(''); }}
                style={{
                  padding: '9px 18px', background: 'none',
                  border: '1px solid var(--line-strong)', borderRadius: 'var(--r-pill)',
                  cursor: 'pointer', fontFamily: 'var(--font-ui)', fontSize: 13,
                  color: 'var(--ink-600)',
                }}
              >
                Cancelar
              </button>
            </div>
          </div>
        )}
      </div>

      {/* ── Resultado post-confirmación ──────────────────────────────── */}
      {resultado && (
        <div style={{
          background: 'var(--paper)', border: '1px solid var(--line)',
          borderRadius: 16, padding: '20px 24px', maxWidth: 900,
          boxShadow: 'var(--shadow-card)',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
            <div style={{
              width: 32, height: 32, borderRadius: '50%',
              background: 'var(--ok-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}>
              <Check size={16} color="var(--ok-ink)" />
            </div>
            <span style={{ fontFamily: 'var(--font-display)', fontSize: 16, fontWeight: 700, color: 'var(--ink-900)' }}>
              Migración completada
            </span>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 12, marginBottom: resultado.errores?.length ? 16 : 0 }}>
            {[
              { label: 'Libros nuevos',      value: resultado.libros_creados,    bg: 'var(--past-mint)',   ink: 'var(--past-mint-ink)'   },
              { label: 'Ya existían',         value: resultado.libros_existentes, bg: 'var(--past-blue)',   ink: 'var(--past-blue-ink)'   },
              { label: 'Lotes creados',       value: resultado.lotes_creados,     bg: 'var(--past-peach)',  ink: 'var(--past-peach-ink)'  },
            ].map(({ label, value, bg, ink }) => (
              <div key={label} style={{ background: bg, borderRadius: 12, padding: '14px 16px' }}>
                <div style={{ fontSize: 24, fontWeight: 800, fontFamily: 'var(--font-display)', color: ink, letterSpacing: '-0.03em' }}>{value}</div>
                <div style={{ fontSize: 11, fontFamily: 'var(--font-ui)', color: ink, marginTop: 2, opacity: 0.8 }}>{label}</div>
              </div>
            ))}
          </div>

          {resultado.errores?.length > 0 && (
            <div style={{ marginTop: 14 }}>
              <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--bad-ink)', fontFamily: 'var(--font-ui)', marginBottom: 6 }}>
                {resultado.errores.length} {resultado.errores.length === 1 ? 'fila con error' : 'filas con error'}
              </div>
              <div style={{ maxHeight: 200, overflowY: 'auto', border: '1px solid var(--bad-line)', borderRadius: 8, background: 'var(--bad-bg)' }}>
                {resultado.errores.map((e, i) => (
                  <div key={i} style={{ padding: '6px 12px', borderBottom: i < resultado.errores.length - 1 ? '1px solid var(--bad-line)' : 'none', fontSize: 12, fontFamily: 'var(--font-ui)', color: 'var(--bad-ink)' }}>
                    <strong>Fila {e.fila}:</strong> {e.error}
                  </div>
                ))}
              </div>
            </div>
          )}

          <button
            onClick={() => setResultado(null)}
            style={{
              marginTop: 16, padding: '8px 18px', background: 'none',
              border: '1px solid var(--line-strong)', borderRadius: 'var(--r-pill)',
              cursor: 'pointer', fontFamily: 'var(--font-ui)', fontSize: 12,
              color: 'var(--ink-600)',
            }}
          >
            Nueva migración
          </button>
        </div>
      )}
    </div>
  );
}

// ---------------------------------------------------------------------------
// ModuloDevoluciones — devoluciones al distribuidor
// ---------------------------------------------------------------------------
const DEV_MOTIVOS = [
  'Exceso de stock',
  'Libro dañado',
  'Vencimiento de consignación',
  'Acuerdo comercial',
  'Error de pedido',
  'Otro',
];

function ModuloDevoluciones() {
  // Borrador (en memoria)
  const [items, setItems]         = useState([]);
  const [distribuidorId, setDistribuidorId] = useState('');
  const [motivo, setMotivo]       = useState('');
  const [numeroGuia, setNumeroGuia] = useState('');
  const [notas, setNotas]         = useState('');

  // Búsqueda
  const [busqueda, setBusqueda]   = useState('');
  const [resultados, setResultados] = useState([]);
  const [buscando, setBuscando]   = useState(false);

  // Datos
  const [distribuidores, setDistribuidores] = useState([]);
  const [historial, setHistorial] = useState([]);
  const [cargandoHist, setCargandoHist] = useState(false);

  // UI
  const [tab, setTab]             = useState('manual'); // 'manual' | 'documento'
  const [guardando, setGuardando] = useState(false);
  const [mensaje, setMensaje]     = useState('');
  const [expandido, setExpandido] = useState(null);

  // Documento
  const [archivoPreview, setArchivoPreview] = useState(null); // { tipo, lineas }
  const [subiendoDoc, setSubiendoDoc]       = useState(null);
  const fileRef = useRef();

  useEffect(() => {
    api.get('/distribuidores').then(r => setDistribuidores(r.data || [])).catch(() => {});
    cargarHistorial();
  }, []);

  async function cargarHistorial() {
    setCargandoHist(true);
    try {
      const r = await api.get('/devoluciones?limite=50');
      setHistorial(r.data || []);
    } catch {}
    setCargandoHist(false);
  }

  // Buscar libros por texto
  const esIsbn = (v) => /^\d{10,13}$/.test(v.trim());

  useEffect(() => {
    if (!busqueda.trim()) { setResultados([]); return; }
    const delay = esIsbn(busqueda) ? 0 : 300;
    const timer = setTimeout(async () => {
      setBuscando(true);
      try {
        const url = distribuidorId
          ? `/devoluciones/distribuidor/${distribuidorId}/stock`
          : `/libros/buscar?q=${encodeURIComponent(busqueda)}`;
        const r = await api.get(url);
        const datos = r.data || [];
        const filtrado = distribuidorId
          ? datos.filter(l =>
              l.titulo?.toLowerCase().includes(busqueda.toLowerCase()) ||
              l.isbn?.includes(busqueda)
            )
          : datos;
        const lista = filtrado.slice(0, 15);
        setResultados(lista);
        // Si es ISBN y hay exactamente 1 resultado, agregar automáticamente
        if (esIsbn(busqueda) && lista.length === 1) {
          agregarItem(lista[0]);
        }
      } catch {}
      setBuscando(false);
    }, delay);
    return () => clearTimeout(timer);
  }, [busqueda, distribuidorId]);

  function agregarItem(libro) {
    const key = libro.lote_id ?? (libro.libro_id || libro.id);
    setItems(prev => {
      const existe = prev.find(i => (i.lote_id ?? (i.libro_id || i.id)) === key);
      if (existe) {
        return prev.map(i =>
          (i.lote_id ?? (i.libro_id || i.id)) === key
            ? { ...i, cantidad: Math.min(i.cantidad + 1, i.stock || 999) }
            : i
        );
      }
      return [...prev, {
        lote_id:              libro.lote_id,
        libro_id:             libro.libro_id || libro.id,
        titulo:               libro.titulo,
        isbn:                 libro.isbn,
        pvp:                  libro.pvp,
        stock:                libro.stock || 0,
        distribuidor_id:      libro.distribuidor_id,
        distribuidor_nombre:  libro.distribuidor_nombre,
        cantidad:             1,
      }];
    });
    setBusqueda('');
    setResultados([]);
  }

  function cambiarCantidad(lote_id, val) {
    const n = Math.max(1, parseInt(val, 10) || 1);
    setItems(prev => prev.map(i => i.lote_id === lote_id ? { ...i, cantidad: n } : i));
  }

  function quitarItem(lote_id) {
    setItems(prev => prev.filter(i => i.lote_id !== lote_id));
  }

  async function confirmarDevolucion() {
    if (!distribuidorId) return setMensaje('Selecciona un distribuidor');
    if (!items.length && !archivoPreview?.lineas?.length)
      return setMensaje('Agrega al menos un libro');

    // MODO PRUEBA: no ejecutar cambios reales en el inventario
    setMensaje('⚠️ Módulo en modo prueba — los cambios no se aplicaron al inventario.');
  }

  async function marcarRecibida(id) {
    try {
      await api.patch(`/devoluciones/${id}/recibida`);
      setHistorial(h => h.map(d => d.id === id ? { ...d, estado: 'recibida' } : d));
    } catch (err) {
      alert(err.response?.data?.error || 'Error');
    }
  }

  async function cancelarDevolucion(id) {
    if (!window.confirm('¿Cancelar esta devolución? El stock se restaurará.')) return;
    try {
      await api.delete(`/devoluciones/${id}`);
      setHistorial(h => h.filter(d => d.id !== id));
    } catch (err) {
      alert(err.response?.data?.error || 'Error');
    }
  }

  async function subirDocumento(e) {
    const file = e.target.files?.[0];
    if (!file) return;
    setSubiendoDoc(file.name);
    setArchivoPreview(null);
    const fd = new FormData();
    fd.append('archivo', file);
    try {
      const r = await api.post('/devoluciones/importar-preview', fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      if (r.data.tipo === 'pdf') {
        setMensaje('El PDF se guardó como referencia. Agrega los libros manualmente.');
        setTab('manual');
      } else {
        setArchivoPreview(r.data);
        // Autocompletar distribuidor si todas las líneas tienen el mismo
        const distIds = [...new Set(r.data.lineas.map(l => l.distribuidor_id).filter(Boolean))];
        if (distIds.length === 1 && !distribuidorId) setDistribuidorId(distIds[0]);
      }
    } catch (err) {
      setMensaje('Error al procesar el archivo: ' + (err.response?.data?.error || err.message));
    }
    setSubiendoDoc(null);
    if (fileRef.current) fileRef.current.value = '';
  }

  const totalUnidades = items.reduce((s, i) => s + i.cantidad, 0);
  const distNombre = distribuidores.find(d => d.id === distribuidorId)?.nombre || '';

  const cardStyle = { background: 'var(--paper)', border: '1px solid var(--line)', borderRadius: 16 };
  const estadoChip = (estado) => {
    if (estado === 'recibida')   return { bg: 'var(--ok-bg)',   ink: 'var(--ok-ink)',   label: 'Recibida' };
    return { bg: 'var(--brand-bg,#e8f0fe)', ink: 'var(--brand,#1a56db)', label: 'Confirmada' };
  };

  return (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 320px', gap: 20, alignItems: 'start' }}>

      {/* ── Panel izquierdo: borrador ── */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>

        {/* Header */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12 }}>
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <h2 style={{ margin: 0, fontSize: 20, fontWeight: 700, color: 'var(--ink-900)', fontFamily: 'var(--font-display)' }}>
                Nueva devolución
              </h2>
              <span style={{ padding: '3px 10px', borderRadius: 999, fontSize: 11, fontWeight: 700, background: 'var(--warn-bg)', color: 'var(--warn-ink)', fontFamily: 'var(--font-ui)', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Beta</span>
            </div>
            <p style={{ margin: '2px 0 0', fontSize: 13, color: 'var(--ink-500)' }}>
              Modo prueba — el stock no se modifica
            </p>
          </div>
          {/* Tabs */}
          <div style={{ display: 'flex', gap: 4, background: 'var(--paper-stripe)', borderRadius: 10, padding: 4 }}>
            {[['manual', 'Manual'], ['documento', 'Por documento']].map(([id, label]) => (
              <button key={id} onClick={() => { setTab(id); setArchivoPreview(null); }}
                style={{ padding: '6px 14px', borderRadius: 8, border: 'none', cursor: 'pointer', fontSize: 13, fontWeight: 600, fontFamily: 'var(--font-ui)',
                  background: tab === id ? 'var(--paper)' : 'transparent',
                  color: tab === id ? 'var(--ink-900)' : 'var(--ink-500)',
                  boxShadow: tab === id ? '0 1px 3px rgba(0,0,0,.08)' : 'none' }}>
                {label}
              </button>
            ))}
          </div>
        </div>

        {/* Banner modo prueba */}
        <div style={{ padding: '12px 16px', borderRadius: 10, background: 'var(--warn-bg)', border: '1px solid var(--warn-line,#fde68a)', color: 'var(--warn-ink)', fontSize: 13, fontWeight: 500 }}>
          ⚠️ Módulo en modo prueba — las acciones que se realicen aquí <strong>no afectan el inventario</strong>.
        </div>

        {/* Distribuidor + campos */}
        <div style={{ ...cardStyle, padding: 20, display: 'flex', flexDirection: 'column', gap: 14 }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            <div>
              <label style={{ fontSize: 11, fontWeight: 600, color: 'var(--ink-600)', textTransform: 'uppercase', letterSpacing: '0.06em', display: 'block', marginBottom: 6 }}>
                Distribuidor *
              </label>
              <select value={distribuidorId} onChange={e => setDistribuidorId(e.target.value)}
                style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid var(--line)', fontFamily: 'var(--font-ui)', fontSize: 13, background: 'var(--paper)', color: 'var(--ink-900)' }}>
                <option value="">Seleccionar…</option>
                {distribuidores.map(d => <option key={d.id} value={d.id}>{d.nombre}</option>)}
              </select>
            </div>
            <div>
              <label style={{ fontSize: 11, fontWeight: 600, color: 'var(--ink-600)', textTransform: 'uppercase', letterSpacing: '0.06em', display: 'block', marginBottom: 6 }}>
                Motivo
              </label>
              <select value={motivo} onChange={e => setMotivo(e.target.value)}
                style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid var(--line)', fontFamily: 'var(--font-ui)', fontSize: 13, background: 'var(--paper)', color: 'var(--ink-900)' }}>
                <option value="">Sin especificar</option>
                {DEV_MOTIVOS.map(m => <option key={m} value={m}>{m}</option>)}
              </select>
            </div>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            <div>
              <label style={{ fontSize: 11, fontWeight: 600, color: 'var(--ink-600)', textTransform: 'uppercase', letterSpacing: '0.06em', display: 'block', marginBottom: 6 }}>
                N° de guía
              </label>
              <input value={numeroGuia} onChange={e => setNumeroGuia(e.target.value)} placeholder="Opcional"
                style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid var(--line)', fontFamily: 'var(--font-ui)', fontSize: 13, background: 'var(--paper)', color: 'var(--ink-900)', boxSizing: 'border-box' }} />
            </div>
            <div>
              <label style={{ fontSize: 11, fontWeight: 600, color: 'var(--ink-600)', textTransform: 'uppercase', letterSpacing: '0.06em', display: 'block', marginBottom: 6 }}>
                Notas
              </label>
              <input value={notas} onChange={e => setNotas(e.target.value)} placeholder="Opcional"
                style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid var(--line)', fontFamily: 'var(--font-ui)', fontSize: 13, background: 'var(--paper)', color: 'var(--ink-900)', boxSizing: 'border-box' }} />
            </div>
          </div>
        </div>

        {/* TAB MANUAL */}
        {tab === 'manual' && (
          <>
            {/* Buscador */}
            <div style={{ ...cardStyle, padding: 16, position: 'relative' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <Search size={16} color="var(--ink-400)" strokeWidth={2} />
                <input
                  value={busqueda}
                  onChange={e => setBusqueda(e.target.value)}
                  onKeyDown={e => { if (e.key === 'Enter' && resultados.length > 0) agregarItem(resultados[0]); }}
                  placeholder={distribuidorId ? `Buscar en stock de ${distNombre}…` : 'Buscar libro por título o ISBN…'}
                  style={{ flex: 1, border: 'none', outline: 'none', fontSize: 14, fontFamily: 'var(--font-ui)', background: 'transparent', color: 'var(--ink-900)' }}
                />
                {buscando && <RefreshCw size={14} color="var(--ink-400)" className="spin" />}
              </div>
              {resultados.length > 0 && (
                <div style={{ position: 'absolute', left: 0, right: 0, top: '100%', zIndex: 100, background: 'var(--paper)', border: '1px solid var(--line)', borderRadius: '0 0 12px 12px', boxShadow: '0 8px 24px rgba(0,0,0,.10)', overflow: 'hidden' }}>
                  {resultados.map((l, i) => (
                    <button key={i} onClick={() => agregarItem(l)}
                      style={{ width: '100%', display: 'flex', alignItems: 'center', gap: 12, padding: '10px 16px', background: 'none', border: 'none', cursor: 'pointer', textAlign: 'left', borderBottom: i < resultados.length - 1 ? '1px solid var(--line-soft)' : 'none' }}
                      onMouseEnter={e => e.currentTarget.style.background = 'var(--paper-stripe)'}
                      onMouseLeave={e => e.currentTarget.style.background = 'none'}>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--ink-900)', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>{l.titulo}</div>
                        <div style={{ fontSize: 11, color: 'var(--ink-500)', fontFamily: 'var(--font-ui)' }}>{l.isbn}{l.autor ? ` · ${l.autor}` : ''}</div>
                      </div>
                      <div style={{ textAlign: 'right', flexShrink: 0 }}>
                        {l.stock != null && <div style={{ fontSize: 11, color: 'var(--ink-500)', fontFamily: 'var(--font-ui)' }}>stock: {l.stock}</div>}
                        {l.pvp && <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--ink-700)', fontFamily: 'var(--font-display)' }}>${Number(l.pvp).toLocaleString('es-CL')}</div>}
                      </div>
                    </button>
                  ))}
                </div>
              )}
            </div>

            {/* Lista del borrador */}
            {items.length > 0 ? (
              <div style={{ ...cardStyle, overflow: 'hidden' }}>
                <div style={{ padding: '12px 16px', borderBottom: '1px solid var(--line-soft)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <span style={{ fontSize: 12, fontWeight: 600, color: 'var(--ink-600)', textTransform: 'uppercase', letterSpacing: '0.06em' }}>
                    {items.length} título{items.length !== 1 ? 's' : ''} · {totalUnidades} unidad{totalUnidades !== 1 ? 'es' : ''}
                  </span>
                  <button onClick={() => setItems([])}
                    style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 12, color: 'var(--bad-ink)' }}>
                    Limpiar todo
                  </button>
                </div>
                {items.map((item, i) => (
                  <div key={item.lote_id} style={{ padding: '10px 16px', borderBottom: i < items.length - 1 ? '1px solid var(--line-soft)' : 'none', display: 'flex', alignItems: 'center', gap: 12 }}>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--ink-900)', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>{item.titulo}</div>
                      <div style={{ fontSize: 11, color: 'var(--ink-500)', fontFamily: 'var(--font-ui)' }}>
                        {item.isbn}{item.stock != null ? ` · stock actual: ${item.stock}` : ''}
                      </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexShrink: 0 }}>
                      <button onClick={() => cambiarCantidad(item.lote_id, item.cantidad - 1)}
                        style={{ width: 26, height: 26, borderRadius: '50%', border: '1px solid var(--line)', background: 'var(--paper)', cursor: 'pointer', fontSize: 16, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--ink-700)' }}>−</button>
                      <input type="number" min="1" max={item.stock || 999} value={item.cantidad}
                        onChange={e => cambiarCantidad(item.lote_id, e.target.value)}
                        style={{ width: 48, textAlign: 'center', padding: '4px 6px', border: '1px solid var(--line)', borderRadius: 6, fontFamily: 'var(--font-ui)', fontSize: 13 }} />
                      <button onClick={() => cambiarCantidad(item.lote_id, item.cantidad + 1)}
                        style={{ width: 26, height: 26, borderRadius: '50%', border: '1px solid var(--line)', background: 'var(--paper)', cursor: 'pointer', fontSize: 16, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--ink-700)' }}>+</button>
                      <button onClick={() => quitarItem(item.lote_id)}
                        style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--bad-ink)', padding: '4px', display: 'flex', alignItems: 'center' }}>
                        <X size={14} strokeWidth={2} />
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div style={{ ...cardStyle, padding: '32px 20px', textAlign: 'center', color: 'var(--ink-400)', fontSize: 13 }}>
                Busca un libro para agregar a la devolución
              </div>
            )}
          </>
        )}

        {/* TAB DOCUMENTO */}
        {tab === 'documento' && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            {/* Upload area */}
            <div
              onClick={() => fileRef.current?.click()}
              style={{ ...cardStyle, padding: '40px 20px', textAlign: 'center', cursor: 'pointer', borderStyle: 'dashed', borderColor: 'var(--brand)', background: 'var(--brand-bg,#f0f4ff)' }}>
              <Upload size={28} color="var(--brand)" strokeWidth={1.5} style={{ margin: '0 auto 10px' }} />
              <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--brand)' }}>
                {subiendoDoc ? `Procesando ${subiendoDoc}…` : 'Subir Excel, XML o PDF'}
              </div>
              <div style={{ fontSize: 12, color: 'var(--ink-500)', marginTop: 4 }}>
                Excel: columnas ISBN/EAN y Cantidad · XML: formato estándar de distribuidor
              </div>
              <input ref={fileRef} type="file" accept=".xlsx,.xls,.xml,.pdf" style={{ display: 'none' }} onChange={subirDocumento} />
            </div>

            {/* Preview */}
            {archivoPreview && archivoPreview.lineas.length > 0 && (
              <div style={{ ...cardStyle, overflow: 'hidden' }}>
                <div style={{ padding: '12px 16px', borderBottom: '1px solid var(--line-soft)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <span style={{ fontSize: 12, fontWeight: 600, color: 'var(--ink-600)', textTransform: 'uppercase', letterSpacing: '0.06em' }}>
                    Vista previa · {archivoPreview.lineas.filter(l => l.encontrado).length} encontrados / {archivoPreview.lineas.length} total
                  </span>
                  <button onClick={() => setArchivoPreview(null)}
                    style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--ink-400)' }}>
                    <X size={14} strokeWidth={2} />
                  </button>
                </div>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                  <thead>
                    <tr style={{ background: 'var(--paper-stripe)', borderBottom: '1px solid var(--line-soft)' }}>
                      <th style={{ padding: '8px 12px', textAlign: 'left', fontWeight: 600, color: 'var(--ink-600)', fontSize: 11 }}>ISBN</th>
                      <th style={{ padding: '8px 12px', textAlign: 'left', fontWeight: 600, color: 'var(--ink-600)', fontSize: 11 }}>Título</th>
                      <th style={{ padding: '8px 12px', textAlign: 'center', fontWeight: 600, color: 'var(--ink-600)', fontSize: 11 }}>Cant.</th>
                      <th style={{ padding: '8px 12px', textAlign: 'center', fontWeight: 600, color: 'var(--ink-600)', fontSize: 11 }}>Stock</th>
                      <th style={{ padding: '8px 12px', textAlign: 'center', fontWeight: 600, color: 'var(--ink-600)', fontSize: 11 }}>Estado</th>
                    </tr>
                  </thead>
                  <tbody>
                    {archivoPreview.lineas.map((l, i) => (
                      <tr key={i} style={{ borderBottom: '1px solid var(--line-soft)', opacity: l.encontrado ? 1 : 0.5 }}>
                        <td style={{ padding: '8px 12px', fontFamily: 'var(--font-ui)', fontSize: 12, color: 'var(--ink-600)' }}>{l.isbn || '—'}</td>
                        <td style={{ padding: '8px 12px', color: 'var(--ink-900)', fontWeight: l.encontrado ? 500 : 400 }}>{l.titulo || '—'}</td>
                        <td style={{ padding: '8px 12px', textAlign: 'center', fontFamily: 'var(--font-ui)' }}>
                          <input type="number" min="1" value={l.cantidad}
                            onChange={e => setArchivoPreview(prev => ({
                              ...prev,
                              lineas: prev.lineas.map((ll, j) => j === i ? { ...ll, cantidad: Math.max(1, parseInt(e.target.value,10)||1) } : ll)
                            }))}
                            style={{ width: 52, textAlign: 'center', padding: '3px 6px', border: '1px solid var(--line)', borderRadius: 6, fontFamily: 'var(--font-ui)', fontSize: 12 }} />
                        </td>
                        <td style={{ padding: '8px 12px', textAlign: 'center', fontFamily: 'var(--font-ui)', fontSize: 12, color: 'var(--ink-500)' }}>{l.stock_actual ?? '—'}</td>
                        <td style={{ padding: '8px 12px', textAlign: 'center' }}>
                          {l.encontrado
                            ? <span style={{ fontSize: 11, fontWeight: 600, padding: '2px 8px', borderRadius: 999, background: 'var(--ok-bg)', color: 'var(--ok-ink)' }}>✓ encontrado</span>
                            : <span style={{ fontSize: 11, fontWeight: 600, padding: '2px 8px', borderRadius: 999, background: 'var(--warn-bg)', color: 'var(--warn-ink)' }}>no encontrado</span>
                          }
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            {archivoPreview && archivoPreview.lineas.length === 0 && (
              <div style={{ ...cardStyle, padding: 24, textAlign: 'center', color: 'var(--ink-400)', fontSize: 13 }}>
                No se encontraron líneas válidas en el documento
              </div>
            )}
          </div>
        )}

        {/* Mensaje */}
        {mensaje && (
          <div style={{ padding: '12px 16px', borderRadius: 10, fontSize: 13, fontWeight: 500,
            background: mensaje.startsWith('✓') ? 'var(--ok-bg)' : 'var(--bad-bg)',
            color: mensaje.startsWith('✓') ? 'var(--ok-ink)' : 'var(--bad-ink)',
            border: `1px solid ${mensaje.startsWith('✓') ? 'var(--ok-line,#86efac)' : 'var(--bad-line)'}` }}>
            {mensaje}
          </div>
        )}

        {/* Botón confirmar */}
        {(items.length > 0 || (archivoPreview?.lineas?.some(l => l.encontrado))) && (
          <button
            onClick={confirmarDevolucion}
            disabled={guardando || !distribuidorId}
            style={{ padding: '12px 24px', background: guardando || !distribuidorId ? 'var(--ink-300)' : 'var(--brand)', color: '#fff', border: 'none', borderRadius: 12, cursor: guardando || !distribuidorId ? 'not-allowed' : 'pointer', fontSize: 15, fontWeight: 700, fontFamily: 'var(--font-ui)' }}>
            {guardando ? 'Registrando…' : `Confirmar devolución${totalUnidades > 0 ? ` · ${totalUnidades} ud.` : ''}`}
          </button>
        )}
      </div>

      {/* ── Sidebar: historial ── */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--ink-600)', textTransform: 'uppercase', letterSpacing: '0.08em' }}>
          Historial
        </div>

        {cargandoHist && <div style={{ fontSize: 13, color: 'var(--ink-400)' }}>Cargando…</div>}

        {!cargandoHist && historial.length === 0 && (
          <div style={{ ...cardStyle, padding: '20px 16px', textAlign: 'center', fontSize: 13, color: 'var(--ink-400)' }}>
            Sin devoluciones registradas
          </div>
        )}

        {historial.map(dev => {
          const chip = estadoChip(dev.estado);
          const abierto = expandido === dev.id;
          return (
            <div key={dev.id} style={{ ...cardStyle, overflow: 'hidden' }}>
              <button
                onClick={() => setExpandido(abierto ? null : dev.id)}
                style={{ width: '100%', padding: '12px 14px', background: 'none', border: 'none', cursor: 'pointer', textAlign: 'left', display: 'flex', flexDirection: 'column', gap: 6 }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8 }}>
                  <span style={{ fontSize: 13, fontWeight: 700, color: 'var(--ink-900)', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', flex: 1 }}>
                    {dev.distribuidor}
                  </span>
                  <span style={{ fontSize: 11, fontWeight: 600, padding: '2px 8px', borderRadius: 999, background: chip.bg, color: chip.ink, flexShrink: 0 }}>
                    {chip.label}
                  </span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                  <span style={{ fontSize: 11, color: 'var(--ink-500)', fontFamily: 'var(--font-ui)' }}>
                    {new Date(dev.creado_en).toLocaleDateString('es-CL', { day: 'numeric', month: 'short', year: 'numeric' })}
                  </span>
                  <span style={{ fontSize: 11, color: 'var(--ink-600)', fontFamily: 'var(--font-ui)', fontWeight: 600 }}>
                    {dev.total_unidades} ud. · {dev.total_items} título{dev.total_items !== 1 ? 's' : ''}
                  </span>
                  {dev.motivo && <span style={{ fontSize: 11, color: 'var(--ink-500)', fontFamily: 'var(--font-ui)' }}>{dev.motivo}</span>}
                </div>
                {dev.numero_guia && (
                  <div style={{ fontSize: 11, color: 'var(--ink-500)', fontFamily: 'var(--font-ui)' }}>
                    Guía: {dev.numero_guia}
                  </div>
                )}
              </button>

              {abierto && (
                <div style={{ borderTop: '1px solid var(--line-soft)' }}>
                  {/* Detalle de libros */}
                  {dev.detalle?.map((d, i) => (
                    <div key={i} style={{ padding: '8px 14px', borderBottom: i < dev.detalle.length - 1 ? '1px solid var(--line-soft)' : 'none', display: 'flex', alignItems: 'center', gap: 10 }}>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ fontSize: 12, fontWeight: 500, color: 'var(--ink-900)', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>{d.titulo}</div>
                        <div style={{ fontSize: 11, color: 'var(--ink-500)', fontFamily: 'var(--font-ui)' }}>{d.isbn}</div>
                      </div>
                      <div style={{ textAlign: 'right', flexShrink: 0 }}>
                        <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--ink-800)', fontFamily: 'var(--font-ui)' }}>×{d.cantidad}</div>
                        {d.pvp && <div style={{ fontSize: 11, color: 'var(--ink-500)', fontFamily: 'var(--font-display)' }}>${Number(d.pvp).toLocaleString('es-CL')}</div>}
                      </div>
                    </div>
                  ))}

                  {/* Notas */}
                  {dev.notas && (
                    <div style={{ padding: '8px 14px', fontSize: 12, color: 'var(--ink-500)', fontFamily: 'var(--font-ui)', fontStyle: 'italic', borderTop: '1px solid var(--line-soft)' }}>
                      {dev.notas}
                    </div>
                  )}

                  {/* Acciones */}
                  <div style={{ padding: '10px 14px', borderTop: '1px solid var(--line-soft)', display: 'flex', gap: 8 }}>
                    {dev.estado === 'confirmada' && (
                      <button onClick={() => marcarRecibida(dev.id)}
                        style={{ flex: 1, padding: '6px 10px', background: 'var(--ok-bg)', color: 'var(--ok-ink)', border: '1px solid var(--ok-line,#86efac)', borderRadius: 8, cursor: 'pointer', fontSize: 12, fontWeight: 600, fontFamily: 'var(--font-ui)' }}>
                        ✓ Marcar recibida
                      </button>
                    )}
                    {dev.estado === 'confirmada' && (
                      <button onClick={() => cancelarDevolucion(dev.id)}
                        style={{ padding: '6px 10px', background: 'none', color: 'var(--bad-ink)', border: '1px solid var(--bad-line)', borderRadius: 8, cursor: 'pointer', fontSize: 12, fontFamily: 'var(--font-ui)' }}>
                        Cancelar
                      </button>
                    )}
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

// =============================================================================
// MÓDULO OFERTAS
// =============================================================================
function ModuloOfertas() {
  const [ofertas,       setOfertas]       = useState([]);
  const [distribuidores, setDistribuidores] = useState([]);
  const [lotes,         setLotes]         = useState([]);
  const [cargando,      setCargando]      = useState(true);
  const [guardando,     setGuardando]     = useState(false);
  const [vista,         setVista]         = useState('lista'); // 'lista' | 'form' | 'detalle'
  const [ofertaDetalle, setOfertaDetalle] = useState(null);   // { ...oferta, libros: [] }
  const [busquedaLibro, setBusquedaLibro] = useState('');
  const [error,         setError]         = useState('');
  const [importOfer,    setImportOfer]    = useState(null);   // { items, encontrados: [], pendientes: [], yaEnOferta }
  const excelOferRef = useRef(null);
  const [formOfer, setFormOfer] = useState({
    nombre: '', distribuidor_id: '',
    descuento_cliente_pct: '', pct_libreria: '', pct_distribuidor: '',
    fecha_inicio: '', fecha_fin: '',
  });

  useEffect(() => {
    cargarOfertas();
    Promise.all([
      api.get('/distribuidores'),
      api.get('/lotes'),
    ]).then(([d, l]) => {
      setDistribuidores(d.data || []);
      setLotes(l.data || []);
    }).catch(() => {});
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  async function cargarOfertas() {
    setCargando(true);
    try {
      const r = await api.get('/ofertas');
      setOfertas(r.data || []);
    } catch { setError('Error al cargar ofertas'); }
    setCargando(false);
  }

  async function abrirDetalle(oferta) {
    try {
      const r = await api.get(`/ofertas/${oferta.id}`);
      setOfertaDetalle(r.data);
      setVista('detalle');
    } catch { setError('Error al cargar detalle'); }
  }

  async function toggleActiva(oferta) {
    try {
      await api.patch(`/ofertas/${oferta.id}`, { activa: !oferta.activa });
      setOfertas(prev => prev.map(o => o.id === oferta.id ? { ...o, activa: !o.activa, estado: !o.activa ? 'vigente' : 'inactiva' } : o));
      if (ofertaDetalle?.id === oferta.id) setOfertaDetalle(prev => ({ ...prev, activa: !prev.activa }));
    } catch { setError('Error al actualizar'); }
  }

  async function eliminarOferta(id) {
    if (!window.confirm('¿Eliminar esta oferta? Se perderán sus libros asociados.')) return;
    try {
      await api.delete(`/ofertas/${id}`);
      setOfertas(prev => prev.filter(o => o.id !== id));
      if (vista === 'detalle') setVista('lista');
    } catch { setError('Error al eliminar'); }
  }

  async function crearOferta(e) {
    e.preventDefault();
    setError('');
    setGuardando(true);
    try {
      await api.post('/ofertas', {
        nombre:               formOfer.nombre,
        distribuidor_id:      formOfer.distribuidor_id || null,
        descuento_cliente_pct: Number(formOfer.descuento_cliente_pct) || 0,
        pct_libreria:         Number(formOfer.pct_libreria) || 0,
        pct_distribuidor:     Number(formOfer.pct_distribuidor) || 0,
        fecha_inicio:         formOfer.fecha_inicio,
        fecha_fin:            formOfer.fecha_fin,
      });
      await cargarOfertas();
      setVista('lista');
      setFormOfer({ nombre: '', distribuidor_id: '', descuento_cliente_pct: '', pct_libreria: '', pct_distribuidor: '', fecha_inicio: '', fecha_fin: '' });
    } catch (err) { setError(err.response?.data?.error || 'Error al crear oferta'); }
    setGuardando(false);
  }

  async function quitarPendiente(id) {
    if (!ofertaDetalle) return;
    try {
      await api.delete(`/ofertas/${ofertaDetalle.id}/pendientes/${id}`);
      setOfertaDetalle(prev => ({ ...prev, pendientes: (prev.pendientes || []).filter(x => x.id !== id) }));
    } catch { setError('Error al quitar el ISBN en espera'); }
  }

  async function quitarLibroDeOferta(libro_id) {
    if (!ofertaDetalle) return;
    try {
      await api.delete(`/ofertas/${ofertaDetalle.id}/libros/${libro_id}`);
      setOfertaDetalle(prev => ({ ...prev, libros: prev.libros.filter(l => l.libro_id !== libro_id) }));
    } catch { setError('Error al quitar libro'); }
  }

  function normIsbn(v) {
    return String(v ?? '').replace(/[^0-9Xx]/g, '').toUpperCase();
  }

  async function handleExcelISBN(e) {
    const file = e.target.files[0];
    if (!file) return;
    try {
      const buf = await file.arrayBuffer();
      const wb = XLSX.read(buf, { type: 'array' });
      const ws = wb.Sheets[wb.SheetNames[0]];
      const rows = XLSX.utils.sheet_to_json(ws, { header: 1, defval: '' });

      // Un ISBN por celda (10–13 dígitos normalizados); si la fila trae algo parecido a un título se guarda junto,
      // para mostrarlo mientras el libro todavía no existe en el sistema.
      const items = [];
      const vistos = new Set();
      for (const row of rows) {
        const celdas = row.map(c => String(c ?? '').trim());
        const titulo = celdas.find(c => /[A-Za-zÁÉÍÓÚáéíóúÑñ]{3,}/.test(c)) || '';
        for (const cell of celdas) {
          const n = normIsbn(cell);
          if (n.length >= 10 && n.length <= 13 && !vistos.has(n)) { vistos.add(n); items.push({ isbn: n, titulo }); }
        }
      }

      // El servidor empareja contra todo el catálogo (no solo contra lo que hay en stock): un título sin stock,
      // o que esta librería todavía no recibe, también entra. Lo que no existe aún queda "en espera".
      const r = await api.post(`/ofertas/${ofertaDetalle.id}/isbns/previsualizar`, { items });
      setImportOfer({ items, encontrados: r.data.encontrados || [], pendientes: r.data.pendientes || [], yaEnOferta: r.data.ya_en_oferta || 0 });
    } catch (err) {
      // 404 sin mensaje = el servidor aún no tiene la ruta (se está desplegando una versión nueva): no es culpa del archivo
      setError(err.response?.data?.error || (err.response?.status === 404 ? 'El servidor todavía se está actualizando. Espera unos minutos y vuelve a subir el archivo.' : 'Error al leer el archivo Excel'));
    }
    e.target.value = '';
  }

  async function confirmarImportOfer() {
    if (!importOfer || !ofertaDetalle || (importOfer.encontrados.length === 0 && importOfer.pendientes.length === 0)) return;
    setGuardando(true);
    try {
      await api.post(`/ofertas/${ofertaDetalle.id}/isbns/importar`, { items: importOfer.items });
      const r = await api.get(`/ofertas/${ofertaDetalle.id}`);
      setOfertaDetalle(r.data);
      setImportOfer(null);
    } catch { setError('Error al importar libros'); }
    setGuardando(false);
  }

  async function agregarLibroAOferta(libro_id) {
    if (!ofertaDetalle) return;
    if (ofertaDetalle.libros.some(l => l.libro_id === libro_id)) return;
    try {
      await api.post(`/ofertas/${ofertaDetalle.id}/libros`, { libro_ids: [libro_id] });
      const lote = lotes.find(l => l.libro_id === libro_id || l.libro_id?.toString() === libro_id?.toString());
      setOfertaDetalle(prev => ({
        ...prev,
        libros: [...prev.libros, { libro_id, titulo: lote?.titulo || '', isbn: lote?.isbn || '', autor: lote?.autor || '', pvp: lote?.pvp }],
      }));
      setBusquedaLibro('');
    } catch { setError('Error al agregar libro'); }
  }

  const ESTADO_BADGE = {
    vigente:  { bg: 'var(--ok-bg)',   ink: 'var(--ok-ink)',   label: 'Vigente' },
    proxima:  { bg: 'var(--warn-bg)', ink: 'var(--warn-ink)', label: 'Próxima' },
    vencida:  { bg: 'var(--paper-stripe)', ink: 'var(--ink-400)', label: 'Vencida' },
    inactiva: { bg: 'var(--paper-stripe)', ink: 'var(--ink-400)', label: 'Inactiva' },
  };

  const inpSt = { width: '100%', boxSizing: 'border-box', padding: '9px 12px', border: '1px solid var(--line)', borderRadius: 10, background: 'var(--paper)', color: 'var(--ink-900)', fontSize: 14, fontFamily: 'var(--font-ui)', outline: 'none' };
  const lblSt = { fontSize: 12, fontWeight: 600, color: 'var(--ink-600)', fontFamily: 'var(--font-ui)', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 4, display: 'block' };

  // ── Formulario nueva oferta ────────────────────────────────────────────────
  if (vista === 'form') {
    const pctTot = Number(formOfer.pct_libreria || 0) + Number(formOfer.pct_distribuidor || 0);
    const pctOk = pctTot === Number(formOfer.descuento_cliente_pct || 0);
    return (
      <div style={{ maxWidth: 560 }}>
        <button onClick={() => setVista('lista')} style={{ display: 'inline-flex', alignItems: 'center', gap: 5, padding: '6px 12px', background: 'none', border: '1px solid var(--line)', borderRadius: 'var(--r-pill)', cursor: 'pointer', fontSize: 13, color: 'var(--ink-600)', fontFamily: 'var(--font-ui)', marginBottom: 20 }}>
          <ArrowLeft size={14} strokeWidth={1.75} /> Volver
        </button>
        <h2 style={{ margin: '0 0 20px', fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 22, letterSpacing: 'var(--tracking-tight)', color: 'var(--ink-900)' }}>Nueva oferta</h2>

        {error && <div style={{ background: 'var(--bad-bg)', color: 'var(--bad-ink)', padding: '10px 14px', borderRadius: 10, fontSize: 13, marginBottom: 16, fontFamily: 'var(--font-ui)' }}>{error}</div>}

        <form onSubmit={crearOferta} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <div>
            <label style={lblSt}>Nombre de la oferta *</label>
            <input style={inpSt} required placeholder="Ej: Libros infantiles Planeta julio" value={formOfer.nombre} onChange={e => setFormOfer(p => ({ ...p, nombre: e.target.value }))} />
          </div>

          <div>
            <label style={lblSt}>Distribuidor (opcional)</label>
            <select style={inpSt} value={formOfer.distribuidor_id} onChange={e => setFormOfer(p => ({ ...p, distribuidor_id: e.target.value }))}>
              <option value="">Sin distribuidor específico</option>
              {distribuidores.map(d => <option key={d.id} value={d.id}>{d.nombre}</option>)}
            </select>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            <div>
              <label style={lblSt}>Fecha inicio *</label>
              <input type="date" style={inpSt} required value={formOfer.fecha_inicio} onChange={e => setFormOfer(p => ({ ...p, fecha_inicio: e.target.value }))} />
            </div>
            <div>
              <label style={lblSt}>Fecha fin *</label>
              <input type="date" style={inpSt} required value={formOfer.fecha_fin} onChange={e => setFormOfer(p => ({ ...p, fecha_fin: e.target.value }))} />
            </div>
          </div>

          <div style={{ background: 'var(--paper-stripe)', borderRadius: 12, padding: '14px 16px', border: '1px solid var(--line-soft)' }}>
            <p style={{ margin: '0 0 12px', fontSize: 13, color: 'var(--ink-600)', fontFamily: 'var(--font-ui)', lineHeight: 1.5 }}>
              Define cuánto descuento recibe el cliente y cómo se reparte entre la librería y el distribuidor.
            </p>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12 }}>
              <div>
                <label style={lblSt}><Percent size={10} strokeWidth={2} style={{ marginRight: 3 }} />Descuento cliente</label>
                <input type="number" min="0" max="100" step="0.01" style={inpSt} placeholder="20" value={formOfer.descuento_cliente_pct} onChange={e => setFormOfer(p => ({ ...p, descuento_cliente_pct: e.target.value }))} />
              </div>
              <div>
                <label style={lblSt}>Pone librería</label>
                <input type="number" min="0" max="100" step="0.01" style={inpSt} placeholder="10" value={formOfer.pct_libreria} onChange={e => setFormOfer(p => ({ ...p, pct_libreria: e.target.value }))} />
              </div>
              <div>
                <label style={lblSt}>Pone distribuidor</label>
                <input type="number" min="0" max="100" step="0.01" style={inpSt} placeholder="10" value={formOfer.pct_distribuidor} onChange={e => setFormOfer(p => ({ ...p, pct_distribuidor: e.target.value }))} />
              </div>
            </div>
            {formOfer.descuento_cliente_pct && (
              <div style={{ marginTop: 10, fontSize: 12, fontFamily: 'var(--font-ui)', color: pctOk ? 'var(--ok-ink)' : 'var(--bad-ink)' }}>
                {pctOk ? `✓ Los porcentajes suman ${pctTot}% — correcto.` : `⚠ Librería (${formOfer.pct_libreria||0}%) + Distribuidor (${formOfer.pct_distribuidor||0}%) = ${pctTot}% ≠ ${formOfer.descuento_cliente_pct}% del cliente.`}
              </div>
            )}
          </div>

          <button type="submit" disabled={guardando} style={{ padding: '12px', background: 'var(--ink-900)', color: '#fff', border: 'none', borderRadius: 10, cursor: 'pointer', fontSize: 15, fontWeight: 600, fontFamily: 'var(--font-ui)', opacity: guardando ? 0.6 : 1 }}>
            {guardando ? 'Creando…' : 'Crear oferta'}
          </button>
        </form>
      </div>
    );
  }

  // ── Detalle de oferta (con lista de libros) ────────────────────────────────
  if (vista === 'detalle' && ofertaDetalle) {
    const bq = busquedaLibro.trim().toLowerCase();
    const lotesDisponibles = bq.length >= 2
      ? lotes.filter(l =>
          !ofertaDetalle.libros.some(lb => lb.libro_id === l.libro_id?.toString() || lb.libro_id === l.libro_id)
          && (l.titulo?.toLowerCase().includes(bq) || l.isbn?.toLowerCase().includes(bq) || l.autor?.toLowerCase().includes(bq))
        ).slice(0, 8)
      : [];

    const est = ESTADO_BADGE[ofertaDetalle.activa
      ? (new Date() < new Date(ofertaDetalle.fecha_inicio) ? 'proxima' : new Date() > new Date(ofertaDetalle.fecha_fin) ? 'vencida' : 'vigente')
      : 'inactiva'] || ESTADO_BADGE.inactiva;

    return (
      <div style={{ maxWidth: 680 }}>
        <button onClick={() => setVista('lista')} style={{ display: 'inline-flex', alignItems: 'center', gap: 5, padding: '6px 12px', background: 'none', border: '1px solid var(--line)', borderRadius: 'var(--r-pill)', cursor: 'pointer', fontSize: 13, color: 'var(--ink-600)', fontFamily: 'var(--font-ui)', marginBottom: 20 }}>
          <ArrowLeft size={14} strokeWidth={1.75} /> Volver
        </button>

        {error && <div style={{ background: 'var(--bad-bg)', color: 'var(--bad-ink)', padding: '10px 14px', borderRadius: 10, fontSize: 13, marginBottom: 16, fontFamily: 'var(--font-ui)' }}>{error}</div>}

        {/* Cabecera */}
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12, marginBottom: 20, flexWrap: 'wrap' }}>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4, flexWrap: 'wrap' }}>
              <h2 style={{ margin: 0, fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 22, letterSpacing: 'var(--tracking-tight)', color: 'var(--ink-900)' }}>{ofertaDetalle.nombre}</h2>
              <span style={{ padding: '3px 10px', background: est.bg, color: est.ink, borderRadius: 'var(--r-pill)', fontSize: 11, fontWeight: 700, fontFamily: 'var(--font-ui)' }}>{est.label}</span>
            </div>
            <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
              <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5, fontSize: 13, color: 'var(--ink-500)', fontFamily: 'var(--font-ui)' }}>
                <CalendarDays size={13} strokeWidth={1.75} />
                {new Date(String(ofertaDetalle.fecha_inicio).slice(0, 10) + 'T12:00:00').toLocaleDateString('es-CL', { day: 'numeric', month: 'short' })} — {new Date(String(ofertaDetalle.fecha_fin).slice(0, 10) + 'T12:00:00').toLocaleDateString('es-CL', { day: 'numeric', month: 'short', year: 'numeric' })}
              </span>
              {ofertaDetalle.distribuidor_nombre && (
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5, fontSize: 13, color: 'var(--ink-500)', fontFamily: 'var(--font-ui)' }}>
                  <Truck size={13} strokeWidth={1.75} /> {ofertaDetalle.distribuidor_nombre}
                </span>
              )}
            </div>
          </div>
          <div style={{ display: 'flex', gap: 8, flexShrink: 0 }}>
            <button onClick={() => toggleActiva(ofertaDetalle)}
              style={{ padding: '7px 14px', background: ofertaDetalle.activa ? 'var(--warn-bg)' : 'var(--ok-bg)', color: ofertaDetalle.activa ? 'var(--warn-ink)' : 'var(--ok-ink)', border: 'none', borderRadius: 'var(--r-pill)', cursor: 'pointer', fontSize: 12, fontWeight: 600, fontFamily: 'var(--font-ui)' }}>
              {ofertaDetalle.activa ? 'Desactivar' : 'Activar'}
            </button>
            <button onClick={() => eliminarOferta(ofertaDetalle.id)}
              style={{ padding: '7px 14px', background: 'none', color: 'var(--bad-ink)', border: '1px solid var(--bad-line)', borderRadius: 'var(--r-pill)', cursor: 'pointer', fontSize: 12, fontFamily: 'var(--font-ui)' }}>
              Eliminar
            </button>
          </div>
        </div>

        {/* Chips de descuento */}
        <div style={{ display: 'flex', gap: 10, marginBottom: 20, flexWrap: 'wrap' }}>
          {[
            { label: 'Descuento al cliente', value: `${ofertaDetalle.descuento_cliente_pct}%`, color: 'var(--brand)' },
            { label: 'Absorbe librería',      value: `${ofertaDetalle.pct_libreria}%`,          color: 'var(--ink-500)' },
            { label: 'Absorbe distribuidor',  value: `${ofertaDetalle.pct_distribuidor}%`,       color: 'var(--ink-500)' },
          ].map(chip => (
            <div key={chip.label} style={{ padding: '8px 14px', background: 'var(--paper)', border: '1px solid var(--line)', borderRadius: 10, textAlign: 'center' }}>
              <div style={{ fontSize: 18, fontWeight: 700, fontFamily: 'var(--font-display)', color: chip.color, letterSpacing: '-0.02em' }}>{chip.value}</div>
              <div style={{ fontSize: 11, color: 'var(--ink-400)', fontFamily: 'var(--font-ui)', marginTop: 1 }}>{chip.label}</div>
            </div>
          ))}
        </div>

        {/* Buscador de libros + importar Excel */}
        <div style={{ marginBottom: importOfer ? 0 : 16, position: 'relative' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 6 }}>
            <label style={{ ...lblSt, marginBottom: 0 }}>Agregar libros a la oferta</label>
            <button onClick={() => excelOferRef.current?.click()}
              style={{ display: 'inline-flex', alignItems: 'center', gap: 5, padding: '5px 12px', background: 'var(--ok-bg)', color: 'var(--ok-ink)', border: '1px solid var(--ok-line, var(--line))', borderRadius: 'var(--r-pill)', cursor: 'pointer', fontSize: 12, fontWeight: 600, fontFamily: 'var(--font-ui)' }}>
              <Download size={12} strokeWidth={2} style={{ transform: 'rotate(180deg)' }} /> Importar desde Excel
            </button>
            <input ref={excelOferRef} type="file" accept=".xlsx,.xls,.ods,.csv" style={{ display: 'none' }} onChange={handleExcelISBN} />
          </div>
          <div style={{ position: 'relative' }}>
            <Search size={14} style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', color: 'var(--ink-400)' }} />
            <input
              style={{ ...inpSt, paddingLeft: 36 }}
              placeholder="Buscar por título, ISBN o autor..."
              value={busquedaLibro}
              onChange={e => setBusquedaLibro(e.target.value)}
            />
          </div>
          {lotesDisponibles.length > 0 && (
            <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, background: 'var(--paper)', border: '1px solid var(--line)', borderRadius: 10, marginTop: 4, zIndex: 50, boxShadow: 'var(--shadow-card)', maxHeight: 240, overflowY: 'auto' }}>
              {lotesDisponibles.map(l => (
                <div key={l.id} onClick={() => agregarLibroAOferta(l.libro_id)}
                  style={{ padding: '10px 14px', cursor: 'pointer', borderBottom: '1px solid var(--line-soft)', display: 'flex', alignItems: 'center', gap: 10, transition: 'background var(--t-fast)' }}
                  onMouseEnter={e => e.currentTarget.style.background = 'var(--brand-softer)'}
                  onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                >
                  <Plus size={14} strokeWidth={2} style={{ color: 'var(--ok-ink)', flexShrink: 0 }} />
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--ink-900)', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>{l.titulo}</div>
                    <div style={{ fontSize: 11, color: 'var(--ink-400)', fontFamily: 'var(--font-ui)' }}>{[l.isbn, l.autor].filter(Boolean).join(' · ')}</div>
                  </div>
                  {l.pvp && <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--ink-600)', fontFamily: 'var(--font-display)', flexShrink: 0 }}>${Number(l.pvp).toLocaleString('es-CL')}</span>}
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Preview de importación por Excel */}
        {importOfer && (
          <div style={{ marginBottom: 16, border: '1px solid var(--line)', borderRadius: 12, overflow: 'hidden', background: 'var(--paper)' }}>
            <div style={{ padding: '10px 16px', background: 'var(--paper-stripe)', borderBottom: '1px solid var(--line-soft)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--ink-700)', fontFamily: 'var(--font-ui)' }}>
                Resultado del Excel — {importOfer.encontrados.length} encontrados, {importOfer.pendientes.length} en espera{importOfer.yaEnOferta > 0 ? `, ${importOfer.yaEnOferta} ya estaban en la oferta` : ''}
              </span>
              <button onClick={() => setImportOfer(null)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--ink-400)', display: 'flex', padding: 4 }}>
                <X size={14} strokeWidth={2} />
              </button>
            </div>
            {importOfer.encontrados.length > 0 && (
              <div style={{ maxHeight: 220, overflowY: 'auto' }}>
                {importOfer.encontrados.map((l, i) => (
                  <div key={l.libro_id} style={{ padding: '8px 16px', borderBottom: '1px solid var(--line-soft)', display: 'flex', alignItems: 'center', gap: 10 }}>
                    <Check size={13} strokeWidth={2.5} style={{ color: 'var(--ok-ink)', flexShrink: 0 }} />
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontSize: 13, fontWeight: 500, color: 'var(--ink-900)', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>{l.titulo}</div>
                      <div style={{ fontSize: 11, color: 'var(--ink-400)', fontFamily: 'var(--font-mono)' }}>{l.isbn}</div>
                    </div>
                    {Number(l.stock) <= 0 && <span style={{ fontSize: 10.5, fontWeight: 600, padding: '2px 8px', borderRadius: 999, background: 'var(--paper-stripe)', color: 'var(--ink-500)', fontFamily: 'var(--font-ui)', flexShrink: 0 }}>sin stock</span>}
                  </div>
                ))}
              </div>
            )}
            {importOfer.pendientes.length > 0 && (
              <div style={{ padding: '8px 16px', borderTop: importOfer.encontrados.length > 0 ? '1px solid var(--line)' : 'none' }}>
                <div style={{ fontSize: 11, fontWeight: 600, color: 'var(--warn-ink)', fontFamily: 'var(--font-ui)', marginBottom: 4, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                  Aún no están en el sistema ({importOfer.pendientes.length})
                </div>
                <div style={{ fontSize: 12, color: 'var(--ink-500)', fontFamily: 'var(--font-ui)', lineHeight: 1.5, marginBottom: 4 }}>
                  Quedarán en espera y se agregarán solos a la oferta cuando el libro llegue, por ejemplo al recepcionar una GDD.
                </div>
                <div style={{ fontSize: 11, color: 'var(--ink-400)', fontFamily: 'var(--font-mono)', lineHeight: 1.7 }}>
                  {importOfer.pendientes.slice(0, 10).map(x => x.titulo ? `${x.isbn} (${x.titulo})` : x.isbn).join(' · ')}{importOfer.pendientes.length > 10 ? ` +${importOfer.pendientes.length - 10} más` : ''}
                </div>
              </div>
            )}
            <div style={{ padding: '10px 16px', borderTop: '1px solid var(--line-soft)', display: 'flex', gap: 8 }}>
              <button onClick={confirmarImportOfer} disabled={guardando || importOfer.encontrados.length + importOfer.pendientes.length === 0}
                style={{ flex: 1, padding: '9px', background: 'var(--ink-900)', color: '#fff', border: 'none', borderRadius: 10, cursor: importOfer.encontrados.length + importOfer.pendientes.length === 0 ? 'not-allowed' : 'pointer', fontSize: 13, fontWeight: 600, fontFamily: 'var(--font-ui)', opacity: (guardando || importOfer.encontrados.length + importOfer.pendientes.length === 0) ? 0.5 : 1 }}>
                {guardando ? 'Agregando…' : [
                  importOfer.encontrados.length > 0 && `Agregar ${importOfer.encontrados.length} libro${importOfer.encontrados.length !== 1 ? 's' : ''}`,
                  importOfer.pendientes.length > 0 && `${importOfer.encontrados.length > 0 ? 'dejar' : 'Dejar'} ${importOfer.pendientes.length} en espera`,
                ].filter(Boolean).join(' y ') || 'Nada que agregar'}
              </button>
              <button onClick={() => setImportOfer(null)}
                style={{ padding: '9px 16px', background: 'transparent', border: '1px solid var(--line)', borderRadius: 10, cursor: 'pointer', fontSize: 13, color: 'var(--ink-600)', fontFamily: 'var(--font-ui)' }}>
                Cancelar
              </button>
            </div>
          </div>
        )}

        {/* Lista de libros en la oferta */}
        <div style={{ border: '1px solid var(--line)', borderRadius: 12, overflow: 'hidden' }}>
          <div style={{ padding: '10px 16px', background: 'var(--paper-stripe)', borderBottom: '1px solid var(--line-soft)', fontSize: 12, fontWeight: 600, color: 'var(--ink-600)', fontFamily: 'var(--font-ui)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
            {ofertaDetalle.libros.length} {ofertaDetalle.libros.length === 1 ? 'libro' : 'libros'} en la oferta
          </div>
          {ofertaDetalle.libros.length === 0 ? (
            <div style={{ padding: '24px 16px', textAlign: 'center', color: 'var(--ink-400)', fontSize: 14, fontFamily: 'var(--font-ui)' }}>
              Ningún libro agregado. Usa el buscador de arriba.
            </div>
          ) : (
            ofertaDetalle.libros.map((l, i) => {
              const precioDesc = l.pvp ? Math.round(Number(l.pvp) * (1 - Number(ofertaDetalle.descuento_cliente_pct) / 100)) : null;
              const costoAj = l.pvp && l.costo_real
                ? (Number(l.costo_real) - (Number(l.pvp) * Number(ofertaDetalle.pct_distribuidor) / 100)).toFixed(0)
                : null;
              return (
                <div key={l.libro_id} style={{ padding: '12px 16px', borderBottom: i < ofertaDetalle.libros.length - 1 ? '1px solid var(--line-soft)' : 'none', display: 'flex', alignItems: 'center', gap: 12 }}>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--ink-900)', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>{l.titulo}</div>
                    <div style={{ fontSize: 11, color: 'var(--ink-400)', marginTop: 2, fontFamily: 'var(--font-ui)' }}>{[l.isbn, l.autor].filter(Boolean).join(' · ')}</div>
                  </div>
                  {l.pvp && (
                    <div style={{ textAlign: 'right', flexShrink: 0 }}>
                      <div style={{ fontSize: 13, fontFamily: 'var(--font-display)', color: 'var(--ink-400)', textDecoration: 'line-through' }}>${Number(l.pvp).toLocaleString('es-CL')}</div>
                      {precioDesc && <div style={{ fontSize: 14, fontWeight: 700, fontFamily: 'var(--font-display)', color: 'var(--ok-ink)' }}>${precioDesc.toLocaleString('es-CL')}</div>}
                      {costoAj && <div style={{ fontSize: 10, color: 'var(--ink-400)', fontFamily: 'var(--font-ui)' }}>Costo dist.: ${Number(costoAj).toLocaleString('es-CL')}</div>}
                    </div>
                  )}
                  <button onClick={() => quitarLibroDeOferta(l.libro_id)}
                    style={{ background: 'none', border: '1px solid var(--line)', borderRadius: 8, cursor: 'pointer', color: 'var(--ink-400)', display: 'inline-flex', alignItems: 'center', padding: 5, flexShrink: 0, transition: 'border-color var(--t-fast), color var(--t-fast)' }}
                    onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--bad-line)'; e.currentTarget.style.color = 'var(--bad-ink)'; }}
                    onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--line)'; e.currentTarget.style.color = 'var(--ink-400)'; }}
                  >
                    <X size={12} strokeWidth={1.75} />
                  </button>
                </div>
              );
            })
          )}
        </div>

        {/* ISBN de la oferta que todavía no existen en el sistema */}
        {(ofertaDetalle.pendientes || []).length > 0 && (
          <div style={{ marginTop: 16, border: '1px solid var(--line)', borderRadius: 12, overflow: 'hidden' }}>
            <div style={{ padding: '10px 16px', background: 'var(--warn-bg)', borderBottom: '1px solid var(--line-soft)', fontSize: 12, fontWeight: 600, color: 'var(--warn-ink)', fontFamily: 'var(--font-ui)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
              {ofertaDetalle.pendientes.length} en espera de llegar al sistema
            </div>
            <div style={{ padding: '8px 16px', fontSize: 12, color: 'var(--ink-500)', fontFamily: 'var(--font-ui)', lineHeight: 1.5, borderBottom: '1px solid var(--line-soft)' }}>
              Se agregan solos a la oferta cuando el libro llega, por ejemplo al recepcionar una GDD.
            </div>
            {ofertaDetalle.pendientes.map((x, i) => (
              <div key={x.id} style={{ padding: '9px 16px', borderBottom: i < ofertaDetalle.pendientes.length - 1 ? '1px solid var(--line-soft)' : 'none', display: 'flex', alignItems: 'center', gap: 12 }}>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 13, fontFamily: 'var(--font-mono)', color: 'var(--ink-700)' }}>{x.isbn}</div>
                  {x.titulo && <div style={{ fontSize: 12, color: 'var(--ink-400)', fontFamily: 'var(--font-ui)', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>{x.titulo}</div>}
                </div>
                <button onClick={() => quitarPendiente(x.id)} aria-label="Quitar de la lista de espera"
                  style={{ background: 'none', border: '1px solid var(--line)', borderRadius: 8, cursor: 'pointer', color: 'var(--ink-400)', display: 'inline-flex', alignItems: 'center', padding: 5, flexShrink: 0 }}>
                  <X size={12} strokeWidth={1.75} />
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }

  // ── Lista de ofertas ───────────────────────────────────────────────────────
  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 24, flexWrap: 'wrap', gap: 12 }}>
        <div>
          <h2 style={{ margin: 0, fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 28, letterSpacing: 'var(--tracking-tight)', color: 'var(--ink-900)' }}>Ofertas</h2>
          <span style={{ fontSize: 14, color: 'var(--ink-500)', fontFamily: 'var(--font-ui)' }}>Descuentos automáticos en el POS por fechas</span>
        </div>
        <button onClick={() => { setVista('form'); setError(''); }}
          style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '10px 18px', background: 'var(--ink-900)', color: '#fff', border: 'none', borderRadius: 'var(--r-pill)', cursor: 'pointer', fontSize: 14, fontWeight: 600, fontFamily: 'var(--font-ui)' }}>
          <Plus size={15} strokeWidth={2} /> Nueva oferta
        </button>
      </div>

      {error && <div style={{ background: 'var(--bad-bg)', color: 'var(--bad-ink)', padding: '10px 14px', borderRadius: 10, fontSize: 13, marginBottom: 16, fontFamily: 'var(--font-ui)' }}>{error}</div>}

      {cargando ? (
        <div style={{ textAlign: 'center', padding: '40px 0', color: 'var(--ink-400)', fontFamily: 'var(--font-ui)' }}>Cargando...</div>
      ) : ofertas.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '48px 24px', border: '1px dashed var(--line)', borderRadius: 16, color: 'var(--ink-400)', fontFamily: 'var(--font-ui)' }}>
          <Tag size={32} strokeWidth={1.25} style={{ marginBottom: 12, opacity: 0.4 }} />
          <p style={{ margin: 0, fontSize: 15 }}>No hay ofertas creadas todavía.</p>
          <p style={{ margin: '6px 0 0', fontSize: 13 }}>Las ofertas activas aplican descuento automáticamente en el POS.</p>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {ofertas.map(oferta => {
            const est = ESTADO_BADGE[oferta.estado] || ESTADO_BADGE.inactiva;
            return (
              <div key={oferta.id} style={{ border: '1px solid var(--line)', borderRadius: 14, background: 'var(--paper)', padding: '16px 20px', display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'wrap', boxShadow: 'var(--shadow-card)' }}>
                <div style={{ flex: 1, minWidth: 200 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', marginBottom: 4 }}>
                    <span style={{ fontSize: 15, fontWeight: 700, color: 'var(--ink-900)', fontFamily: 'var(--font-ui)' }}>{oferta.nombre}</span>
                    <span style={{ padding: '2px 9px', background: est.bg, color: est.ink, borderRadius: 'var(--r-pill)', fontSize: 11, fontWeight: 700, fontFamily: 'var(--font-ui)' }}>{est.label}</span>
                  </div>
                  <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap', fontSize: 12, color: 'var(--ink-500)', fontFamily: 'var(--font-ui)' }}>
                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                      <CalendarDays size={11} strokeWidth={1.75} />
                      {new Date(String(oferta.fecha_inicio).slice(0, 10) + 'T12:00:00').toLocaleDateString('es-CL', { day: 'numeric', month: 'short' })} — {new Date(String(oferta.fecha_fin).slice(0, 10) + 'T12:00:00').toLocaleDateString('es-CL', { day: 'numeric', month: 'short', year: 'numeric' })}
                    </span>
                    {oferta.distribuidor_nombre && (
                      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                        <Truck size={11} strokeWidth={1.75} /> {oferta.distribuidor_nombre}
                      </span>
                    )}
                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                      <BookOpen size={11} strokeWidth={1.75} /> {oferta.libros_count} {oferta.libros_count === 1 ? 'libro' : 'libros'}
                    </span>
                  </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexShrink: 0 }}>
                  <div style={{ textAlign: 'center', minWidth: 56 }}>
                    <div style={{ fontSize: 22, fontWeight: 700, fontFamily: 'var(--font-display)', color: 'var(--brand)', letterSpacing: '-0.02em' }}>{Number(oferta.descuento_cliente_pct)}%</div>
                    <div style={{ fontSize: 10, color: 'var(--ink-400)', fontFamily: 'var(--font-ui)' }}>desc. cliente</div>
                  </div>
                  <button onClick={() => abrirDetalle(oferta)}
                    style={{ padding: '7px 14px', background: 'var(--ink-900)', color: '#fff', border: 'none', borderRadius: 'var(--r-pill)', cursor: 'pointer', fontSize: 12, fontWeight: 600, fontFamily: 'var(--font-ui)' }}>
                    Ver
                  </button>
                  <button onClick={() => toggleActiva(oferta)}
                    style={{ padding: '7px 12px', background: 'none', border: '1px solid var(--line)', borderRadius: 'var(--r-pill)', cursor: 'pointer', fontSize: 12, color: 'var(--ink-600)', fontFamily: 'var(--font-ui)' }}>
                    {oferta.activa ? 'Desactivar' : 'Activar'}
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default App;
